var zm = Object.defineProperty;
var Vm = (t, e, r) => e in t ? zm(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var ye = (t, e, r) => (Vm(t, typeof e != "symbol" ? e + "" : e, r), r);
import * as ve from "react";
import K, { useState as ht, useEffect as _t, createContext as pu, useContext as Ma, useLayoutEffect as qm, useRef as _n, useMemo as Hm, useCallback as xl, useDebugValue as Ym, forwardRef as Km, createElement as fi, Fragment as h0 } from "react";
import * as Xm from "react-dom";
import Wt from "react-dom";
const p0 = {
  SyncIntervalTime: 3e3
};
var ds = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : {};
function g0(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      if (this instanceof n) {
        var i = [null];
        i.push.apply(i, arguments);
        var o = Function.bind.apply(e, i);
        return new o();
      }
      return e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var vi = {}, Jm = {
  get exports() {
    return vi;
  },
  set exports(t) {
    vi = t;
  }
}, di = typeof Reflect == "object" ? Reflect : null, Mf = di && typeof di.apply == "function" ? di.apply : function(e, r, n) {
  return Function.prototype.apply.call(e, r, n);
}, Us;
di && typeof di.ownKeys == "function" ? Us = di.ownKeys : Object.getOwnPropertySymbols ? Us = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Us = function(e) {
  return Object.getOwnPropertyNames(e);
};
function Qm(t) {
  console && console.warn && console.warn(t);
}
var m0 = Number.isNaN || function(e) {
  return e !== e;
};
function tt() {
  tt.init.call(this);
}
Jm.exports = tt;
vi.once = ey;
tt.EventEmitter = tt;
tt.prototype._events = void 0;
tt.prototype._eventsCount = 0;
tt.prototype._maxListeners = void 0;
var Nf = 10;
function Na(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(tt, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Nf;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || m0(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    Nf = t;
  }
});
tt.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
tt.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || m0(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function y0(t) {
  return t._maxListeners === void 0 ? tt.defaultMaxListeners : t._maxListeners;
}
tt.prototype.getMaxListeners = function() {
  return y0(this);
};
tt.prototype.emit = function(e) {
  for (var r = [], n = 1; n < arguments.length; n++)
    r.push(arguments[n]);
  var i = e === "error", o = this._events;
  if (o !== void 0)
    i = i && o.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var s;
    if (r.length > 0 && (s = r[0]), s instanceof Error)
      throw s;
    var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
    throw a.context = s, a;
  }
  var l = o[e];
  if (l === void 0)
    return !1;
  if (typeof l == "function")
    Mf(l, this, r);
  else
    for (var c = l.length, u = x0(l, c), n = 0; n < c; ++n)
      Mf(u[n], this, r);
  return !0;
};
function b0(t, e, r, n) {
  var i, o, s;
  if (Na(r), o = t._events, o === void 0 ? (o = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (o.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    r.listener ? r.listener : r
  ), o = t._events), s = o[e]), s === void 0)
    s = o[e] = r, ++t._eventsCount;
  else if (typeof s == "function" ? s = o[e] = n ? [r, s] : [s, r] : n ? s.unshift(r) : s.push(r), i = y0(t), i > 0 && s.length > i && !s.warned) {
    s.warned = !0;
    var a = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    a.name = "MaxListenersExceededWarning", a.emitter = t, a.type = e, a.count = s.length, Qm(a);
  }
  return t;
}
tt.prototype.addListener = function(e, r) {
  return b0(this, e, r, !1);
};
tt.prototype.on = tt.prototype.addListener;
tt.prototype.prependListener = function(e, r) {
  return b0(this, e, r, !0);
};
function Gm() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function v0(t, e, r) {
  var n = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r }, i = Gm.bind(n);
  return i.listener = r, n.wrapFn = i, i;
}
tt.prototype.once = function(e, r) {
  return Na(r), this.on(e, v0(this, e, r)), this;
};
tt.prototype.prependOnceListener = function(e, r) {
  return Na(r), this.prependListener(e, v0(this, e, r)), this;
};
tt.prototype.removeListener = function(e, r) {
  var n, i, o, s, a;
  if (Na(r), i = this._events, i === void 0)
    return this;
  if (n = i[e], n === void 0)
    return this;
  if (n === r || n.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || r));
  else if (typeof n != "function") {
    for (o = -1, s = n.length - 1; s >= 0; s--)
      if (n[s] === r || n[s].listener === r) {
        a = n[s].listener, o = s;
        break;
      }
    if (o < 0)
      return this;
    o === 0 ? n.shift() : Zm(n, o), n.length === 1 && (i[e] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", e, a || r);
  }
  return this;
};
tt.prototype.off = tt.prototype.removeListener;
tt.prototype.removeAllListeners = function(e) {
  var r, n, i;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[e]), this;
  if (arguments.length === 0) {
    var o = Object.keys(n), s;
    for (i = 0; i < o.length; ++i)
      s = o[i], s !== "removeListener" && this.removeAllListeners(s);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = n[e], typeof r == "function")
    this.removeListener(e, r);
  else if (r !== void 0)
    for (i = r.length - 1; i >= 0; i--)
      this.removeListener(e, r[i]);
  return this;
};
function A0(t, e, r) {
  var n = t._events;
  if (n === void 0)
    return [];
  var i = n[e];
  return i === void 0 ? [] : typeof i == "function" ? r ? [i.listener || i] : [i] : r ? $m(i) : x0(i, i.length);
}
tt.prototype.listeners = function(e) {
  return A0(this, e, !0);
};
tt.prototype.rawListeners = function(e) {
  return A0(this, e, !1);
};
tt.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : w0.call(t, e);
};
tt.prototype.listenerCount = w0;
function w0(t) {
  var e = this._events;
  if (e !== void 0) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
tt.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Us(this._events) : [];
};
function x0(t, e) {
  for (var r = new Array(e), n = 0; n < e; ++n)
    r[n] = t[n];
  return r;
}
function Zm(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function $m(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r)
    e[r] = t[r].listener || t[r];
  return e;
}
function ey(t, e) {
  return new Promise(function(r, n) {
    function i(s) {
      t.removeListener(e, o), n(s);
    }
    function o() {
      typeof t.removeListener == "function" && t.removeListener("error", i), r([].slice.call(arguments));
    }
    _0(t, e, o, { once: !0 }), e !== "error" && ty(t, i, { once: !0 });
  });
}
function ty(t, e, r) {
  typeof t.on == "function" && _0(t, "error", e, r);
}
function _0(t, e, r, n) {
  if (typeof t.on == "function")
    n.once ? t.once(e, r) : t.on(e, r);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function i(o) {
      n.once && t.removeEventListener(e, i), r(o);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
class gu extends vi.EventEmitter {
  constructor() {
    super(), this.temporaryListeners = [];
  }
  on(e, r, n) {
    return super.on(e, r), n && this.temporaryListeners.push([e, r]), () => {
      this.off(e, r);
    };
  }
  removeTemporaryListeners() {
    console.log(
      "removeTemporaryListeners CALLED",
      this,
      this.temporaryListeners
    ), this.temporaryListeners.forEach(([e, r]) => {
      this.removeListener(e, r);
    }), this.temporaryListeners = [];
  }
}
var ia = {}, ry = {
  get exports() {
    return ia;
  },
  set exports(t) {
    ia = t;
  }
}, _l, Bf;
function ny() {
  if (Bf)
    return _l;
  Bf = 1;
  var t = 1e3, e = t * 60, r = e * 60, n = r * 24, i = n * 7, o = n * 365.25;
  _l = function(u, f) {
    f = f || {};
    var d = typeof u;
    if (d === "string" && u.length > 0)
      return s(u);
    if (d === "number" && isFinite(u))
      return f.long ? l(u) : a(u);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(u)
    );
  };
  function s(u) {
    if (u = String(u), !(u.length > 100)) {
      var f = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        u
      );
      if (f) {
        var d = parseFloat(f[1]), h = (f[2] || "ms").toLowerCase();
        switch (h) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return d * o;
          case "weeks":
          case "week":
          case "w":
            return d * i;
          case "days":
          case "day":
          case "d":
            return d * n;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return d * r;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return d * e;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return d * t;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return d;
          default:
            return;
        }
      }
    }
  }
  function a(u) {
    var f = Math.abs(u);
    return f >= n ? Math.round(u / n) + "d" : f >= r ? Math.round(u / r) + "h" : f >= e ? Math.round(u / e) + "m" : f >= t ? Math.round(u / t) + "s" : u + "ms";
  }
  function l(u) {
    var f = Math.abs(u);
    return f >= n ? c(u, f, n, "day") : f >= r ? c(u, f, r, "hour") : f >= e ? c(u, f, e, "minute") : f >= t ? c(u, f, t, "second") : u + " ms";
  }
  function c(u, f, d, h) {
    var g = f >= d * 1.5;
    return Math.round(u / d) + " " + h + (g ? "s" : "");
  }
  return _l;
}
function iy(t) {
  r.debug = r, r.default = r, r.coerce = l, r.disable = o, r.enable = i, r.enabled = s, r.humanize = ny(), r.destroy = c, Object.keys(t).forEach((u) => {
    r[u] = t[u];
  }), r.names = [], r.skips = [], r.formatters = {};
  function e(u) {
    let f = 0;
    for (let d = 0; d < u.length; d++)
      f = (f << 5) - f + u.charCodeAt(d), f |= 0;
    return r.colors[Math.abs(f) % r.colors.length];
  }
  r.selectColor = e;
  function r(u) {
    let f, d = null, h, g;
    function p(...y) {
      if (!p.enabled)
        return;
      const b = p, x = Number(/* @__PURE__ */ new Date()), S = x - (f || x);
      b.diff = S, b.prev = f, b.curr = x, f = x, y[0] = r.coerce(y[0]), typeof y[0] != "string" && y.unshift("%O");
      let O = 0;
      y[0] = y[0].replace(/%([a-zA-Z%])/g, (B, N) => {
        if (B === "%%")
          return "%";
        O++;
        const j = r.formatters[N];
        if (typeof j == "function") {
          const W = y[O];
          B = j.call(b, W), y.splice(O, 1), O--;
        }
        return B;
      }), r.formatArgs.call(b, y), (b.log || r.log).apply(b, y);
    }
    return p.namespace = u, p.useColors = r.useColors(), p.color = r.selectColor(u), p.extend = n, p.destroy = r.destroy, Object.defineProperty(p, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => d !== null ? d : (h !== r.namespaces && (h = r.namespaces, g = r.enabled(u)), g),
      set: (y) => {
        d = y;
      }
    }), typeof r.init == "function" && r.init(p), p;
  }
  function n(u, f) {
    const d = r(this.namespace + (typeof f > "u" ? ":" : f) + u);
    return d.log = this.log, d;
  }
  function i(u) {
    r.save(u), r.namespaces = u, r.names = [], r.skips = [];
    let f;
    const d = (typeof u == "string" ? u : "").split(/[\s,]+/), h = d.length;
    for (f = 0; f < h; f++)
      d[f] && (u = d[f].replace(/\*/g, ".*?"), u[0] === "-" ? r.skips.push(new RegExp("^" + u.slice(1) + "$")) : r.names.push(new RegExp("^" + u + "$")));
  }
  function o() {
    const u = [
      ...r.names.map(a),
      ...r.skips.map(a).map((f) => "-" + f)
    ].join(",");
    return r.enable(""), u;
  }
  function s(u) {
    if (u[u.length - 1] === "*")
      return !0;
    let f, d;
    for (f = 0, d = r.skips.length; f < d; f++)
      if (r.skips[f].test(u))
        return !1;
    for (f = 0, d = r.names.length; f < d; f++)
      if (r.names[f].test(u))
        return !0;
    return !1;
  }
  function a(u) {
    return u.toString().substring(2, u.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function l(u) {
    return u instanceof Error ? u.stack || u.message : u;
  }
  function c() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return r.enable(r.load()), r;
}
var oy = iy;
(function(t, e) {
  e.formatArgs = n, e.save = i, e.load = o, e.useColors = r, e.storage = s(), e.destroy = (() => {
    let l = !1;
    return () => {
      l || (l = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), e.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function r() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function n(l) {
    if (l[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + l[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors)
      return;
    const c = "color: " + this.color;
    l.splice(1, 0, c, "color: inherit");
    let u = 0, f = 0;
    l[0].replace(/%[a-zA-Z%]/g, (d) => {
      d !== "%%" && (u++, d === "%c" && (f = u));
    }), l.splice(f, 0, c);
  }
  e.log = console.debug || console.log || (() => {
  });
  function i(l) {
    try {
      l ? e.storage.setItem("debug", l) : e.storage.removeItem("debug");
    } catch {
    }
  }
  function o() {
    let l;
    try {
      l = e.storage.getItem("debug");
    } catch {
    }
    return !l && typeof process < "u" && "env" in process && (l = process.env.DEBUG), l;
  }
  function s() {
    try {
      return localStorage;
    } catch {
    }
  }
  t.exports = oy(e);
  const { formatters: a } = t.exports;
  a.j = function(l) {
    try {
      return JSON.stringify(l);
    } catch (c) {
      return "[UnexpectedJSONParseError]: " + c.message;
    }
  };
})(ry, ia);
var sy = function() {
  if (typeof globalThis > "u")
    return null;
  var e = {
    RTCPeerConnection: globalThis.RTCPeerConnection || globalThis.mozRTCPeerConnection || globalThis.webkitRTCPeerConnection,
    RTCSessionDescription: globalThis.RTCSessionDescription || globalThis.mozRTCSessionDescription || globalThis.webkitRTCSessionDescription,
    RTCIceCandidate: globalThis.RTCIceCandidate || globalThis.mozRTCIceCandidate || globalThis.webkitRTCIceCandidate
  };
  return e.RTCPeerConnection ? e : null;
}, _c = {}, Lf = {
  get exports() {
    return _c;
  },
  set exports(t) {
    _c = t;
  }
}, _o = {}, ay = {
  get exports() {
    return _o;
  },
  set exports(t) {
    _o = t;
  }
}, Yo = {}, Ko = {};
Ko.byteLength = uy;
Ko.toByteArray = dy;
Ko.fromByteArray = gy;
var xr = [], rr = [], ly = typeof Uint8Array < "u" ? Uint8Array : Array, Sl = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Gn = 0, cy = Sl.length; Gn < cy; ++Gn)
  xr[Gn] = Sl[Gn], rr[Sl.charCodeAt(Gn)] = Gn;
rr["-".charCodeAt(0)] = 62;
rr["_".charCodeAt(0)] = 63;
function S0(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var n = r === e ? 0 : 4 - r % 4;
  return [r, n];
}
function uy(t) {
  var e = S0(t), r = e[0], n = e[1];
  return (r + n) * 3 / 4 - n;
}
function fy(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function dy(t) {
  var e, r = S0(t), n = r[0], i = r[1], o = new ly(fy(t, n, i)), s = 0, a = i > 0 ? n - 4 : n, l;
  for (l = 0; l < a; l += 4)
    e = rr[t.charCodeAt(l)] << 18 | rr[t.charCodeAt(l + 1)] << 12 | rr[t.charCodeAt(l + 2)] << 6 | rr[t.charCodeAt(l + 3)], o[s++] = e >> 16 & 255, o[s++] = e >> 8 & 255, o[s++] = e & 255;
  return i === 2 && (e = rr[t.charCodeAt(l)] << 2 | rr[t.charCodeAt(l + 1)] >> 4, o[s++] = e & 255), i === 1 && (e = rr[t.charCodeAt(l)] << 10 | rr[t.charCodeAt(l + 1)] << 4 | rr[t.charCodeAt(l + 2)] >> 2, o[s++] = e >> 8 & 255, o[s++] = e & 255), o;
}
function hy(t) {
  return xr[t >> 18 & 63] + xr[t >> 12 & 63] + xr[t >> 6 & 63] + xr[t & 63];
}
function py(t, e, r) {
  for (var n, i = [], o = e; o < r; o += 3)
    n = (t[o] << 16 & 16711680) + (t[o + 1] << 8 & 65280) + (t[o + 2] & 255), i.push(hy(n));
  return i.join("");
}
function gy(t) {
  for (var e, r = t.length, n = r % 3, i = [], o = 16383, s = 0, a = r - n; s < a; s += o)
    i.push(py(t, s, s + o > a ? a : s + o));
  return n === 1 ? (e = t[r - 1], i.push(
    xr[e >> 2] + xr[e << 4 & 63] + "=="
  )) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(
    xr[e >> 10] + xr[e >> 4 & 63] + xr[e << 2 & 63] + "="
  )), i.join("");
}
var Ba = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Ba.read = function(t, e, r, n, i) {
  var o, s, a = i * 8 - n - 1, l = (1 << a) - 1, c = l >> 1, u = -7, f = r ? i - 1 : 0, d = r ? -1 : 1, h = t[e + f];
  for (f += d, o = h & (1 << -u) - 1, h >>= -u, u += a; u > 0; o = o * 256 + t[e + f], f += d, u -= 8)
    ;
  for (s = o & (1 << -u) - 1, o >>= -u, u += n; u > 0; s = s * 256 + t[e + f], f += d, u -= 8)
    ;
  if (o === 0)
    o = 1 - c;
  else {
    if (o === l)
      return s ? NaN : (h ? -1 : 1) * (1 / 0);
    s = s + Math.pow(2, n), o = o - c;
  }
  return (h ? -1 : 1) * s * Math.pow(2, o - n);
};
Ba.write = function(t, e, r, n, i, o) {
  var s, a, l, c = o * 8 - i - 1, u = (1 << c) - 1, f = u >> 1, d = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = n ? 0 : o - 1, g = n ? 1 : -1, p = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = u) : (s = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), s + f >= 1 ? e += d / l : e += d * Math.pow(2, 1 - f), e * l >= 2 && (s++, l /= 2), s + f >= u ? (a = 0, s = u) : s + f >= 1 ? (a = (e * l - 1) * Math.pow(2, i), s = s + f) : (a = e * Math.pow(2, f - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + h] = a & 255, h += g, a /= 256, i -= 8)
    ;
  for (s = s << i | a, c += i; c > 0; t[r + h] = s & 255, h += g, s /= 256, c -= 8)
    ;
  t[r + h - g] |= p * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  var e = Ko, r = Ba, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = a, t.SlowBuffer = x, t.INSPECT_MAX_BYTES = 50;
  var i = 2147483647;
  t.kMaxLength = i, a.TYPED_ARRAY_SUPPORT = o(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function o() {
    try {
      var C = new Uint8Array(1), v = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(v, Uint8Array.prototype), Object.setPrototypeOf(C, v), C.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(a.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(a.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.byteOffset;
    }
  });
  function s(C) {
    if (C > i)
      throw new RangeError('The value "' + C + '" is invalid for option "size"');
    var v = new Uint8Array(C);
    return Object.setPrototypeOf(v, a.prototype), v;
  }
  function a(C, v, w) {
    if (typeof C == "number") {
      if (typeof v == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return f(C);
    }
    return l(C, v, w);
  }
  a.poolSize = 8192;
  function l(C, v, w) {
    if (typeof C == "string")
      return d(C, v);
    if (ArrayBuffer.isView(C))
      return g(C);
    if (C == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof C
      );
    if (re(C, ArrayBuffer) || C && re(C.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (re(C, SharedArrayBuffer) || C && re(C.buffer, SharedArrayBuffer)))
      return p(C, v, w);
    if (typeof C == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    var D = C.valueOf && C.valueOf();
    if (D != null && D !== C)
      return a.from(D, v, w);
    var J = y(C);
    if (J)
      return J;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof C[Symbol.toPrimitive] == "function")
      return a.from(
        C[Symbol.toPrimitive]("string"),
        v,
        w
      );
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof C
    );
  }
  a.from = function(C, v, w) {
    return l(C, v, w);
  }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
  function c(C) {
    if (typeof C != "number")
      throw new TypeError('"size" argument must be of type number');
    if (C < 0)
      throw new RangeError('The value "' + C + '" is invalid for option "size"');
  }
  function u(C, v, w) {
    return c(C), C <= 0 ? s(C) : v !== void 0 ? typeof w == "string" ? s(C).fill(v, w) : s(C).fill(v) : s(C);
  }
  a.alloc = function(C, v, w) {
    return u(C, v, w);
  };
  function f(C) {
    return c(C), s(C < 0 ? 0 : b(C) | 0);
  }
  a.allocUnsafe = function(C) {
    return f(C);
  }, a.allocUnsafeSlow = function(C) {
    return f(C);
  };
  function d(C, v) {
    if ((typeof v != "string" || v === "") && (v = "utf8"), !a.isEncoding(v))
      throw new TypeError("Unknown encoding: " + v);
    var w = S(C, v) | 0, D = s(w), J = D.write(C, v);
    return J !== w && (D = D.slice(0, J)), D;
  }
  function h(C) {
    for (var v = C.length < 0 ? 0 : b(C.length) | 0, w = s(v), D = 0; D < v; D += 1)
      w[D] = C[D] & 255;
    return w;
  }
  function g(C) {
    if (re(C, Uint8Array)) {
      var v = new Uint8Array(C);
      return p(v.buffer, v.byteOffset, v.byteLength);
    }
    return h(C);
  }
  function p(C, v, w) {
    if (v < 0 || C.byteLength < v)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (C.byteLength < v + (w || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    var D;
    return v === void 0 && w === void 0 ? D = new Uint8Array(C) : w === void 0 ? D = new Uint8Array(C, v) : D = new Uint8Array(C, v, w), Object.setPrototypeOf(D, a.prototype), D;
  }
  function y(C) {
    if (a.isBuffer(C)) {
      var v = b(C.length) | 0, w = s(v);
      return w.length === 0 || C.copy(w, 0, 0, v), w;
    }
    if (C.length !== void 0)
      return typeof C.length != "number" || ne(C.length) ? s(0) : h(C);
    if (C.type === "Buffer" && Array.isArray(C.data))
      return h(C.data);
  }
  function b(C) {
    if (C >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return C | 0;
  }
  function x(C) {
    return +C != C && (C = 0), a.alloc(+C);
  }
  a.isBuffer = function(v) {
    return v != null && v._isBuffer === !0 && v !== a.prototype;
  }, a.compare = function(v, w) {
    if (re(v, Uint8Array) && (v = a.from(v, v.offset, v.byteLength)), re(w, Uint8Array) && (w = a.from(w, w.offset, w.byteLength)), !a.isBuffer(v) || !a.isBuffer(w))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (v === w)
      return 0;
    for (var D = v.length, J = w.length, ae = 0, ue = Math.min(D, J); ae < ue; ++ae)
      if (v[ae] !== w[ae]) {
        D = v[ae], J = w[ae];
        break;
      }
    return D < J ? -1 : J < D ? 1 : 0;
  }, a.isEncoding = function(v) {
    switch (String(v).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, a.concat = function(v, w) {
    if (!Array.isArray(v))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (v.length === 0)
      return a.alloc(0);
    var D;
    if (w === void 0)
      for (w = 0, D = 0; D < v.length; ++D)
        w += v[D].length;
    var J = a.allocUnsafe(w), ae = 0;
    for (D = 0; D < v.length; ++D) {
      var ue = v[D];
      if (re(ue, Uint8Array))
        ae + ue.length > J.length ? a.from(ue).copy(J, ae) : Uint8Array.prototype.set.call(
          J,
          ue,
          ae
        );
      else if (a.isBuffer(ue))
        ue.copy(J, ae);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      ae += ue.length;
    }
    return J;
  };
  function S(C, v) {
    if (a.isBuffer(C))
      return C.length;
    if (ArrayBuffer.isView(C) || re(C, ArrayBuffer))
      return C.byteLength;
    if (typeof C != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof C
      );
    var w = C.length, D = arguments.length > 2 && arguments[2] === !0;
    if (!D && w === 0)
      return 0;
    for (var J = !1; ; )
      switch (v) {
        case "ascii":
        case "latin1":
        case "binary":
          return w;
        case "utf8":
        case "utf-8":
          return Z(C).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return w * 2;
        case "hex":
          return w >>> 1;
        case "base64":
          return R(C).length;
        default:
          if (J)
            return D ? -1 : Z(C).length;
          v = ("" + v).toLowerCase(), J = !0;
      }
  }
  a.byteLength = S;
  function O(C, v, w) {
    var D = !1;
    if ((v === void 0 || v < 0) && (v = 0), v > this.length || ((w === void 0 || w > this.length) && (w = this.length), w <= 0) || (w >>>= 0, v >>>= 0, w <= v))
      return "";
    for (C || (C = "utf8"); ; )
      switch (C) {
        case "hex":
          return X(this, v, w);
        case "utf8":
        case "utf-8":
          return z(this, v, w);
        case "ascii":
          return V(this, v, w);
        case "latin1":
        case "binary":
          return te(this, v, w);
        case "base64":
          return P(this, v, w);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return H(this, v, w);
        default:
          if (D)
            throw new TypeError("Unknown encoding: " + C);
          C = (C + "").toLowerCase(), D = !0;
      }
  }
  a.prototype._isBuffer = !0;
  function _(C, v, w) {
    var D = C[v];
    C[v] = C[w], C[w] = D;
  }
  a.prototype.swap16 = function() {
    var v = this.length;
    if (v % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var w = 0; w < v; w += 2)
      _(this, w, w + 1);
    return this;
  }, a.prototype.swap32 = function() {
    var v = this.length;
    if (v % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var w = 0; w < v; w += 4)
      _(this, w, w + 3), _(this, w + 1, w + 2);
    return this;
  }, a.prototype.swap64 = function() {
    var v = this.length;
    if (v % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var w = 0; w < v; w += 8)
      _(this, w, w + 7), _(this, w + 1, w + 6), _(this, w + 2, w + 5), _(this, w + 3, w + 4);
    return this;
  }, a.prototype.toString = function() {
    var v = this.length;
    return v === 0 ? "" : arguments.length === 0 ? z(this, 0, v) : O.apply(this, arguments);
  }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(v) {
    if (!a.isBuffer(v))
      throw new TypeError("Argument must be a Buffer");
    return this === v ? !0 : a.compare(this, v) === 0;
  }, a.prototype.inspect = function() {
    var v = "", w = t.INSPECT_MAX_BYTES;
    return v = this.toString("hex", 0, w).replace(/(.{2})/g, "$1 ").trim(), this.length > w && (v += " ... "), "<Buffer " + v + ">";
  }, n && (a.prototype[n] = a.prototype.inspect), a.prototype.compare = function(v, w, D, J, ae) {
    if (re(v, Uint8Array) && (v = a.from(v, v.offset, v.byteLength)), !a.isBuffer(v))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof v
      );
    if (w === void 0 && (w = 0), D === void 0 && (D = v ? v.length : 0), J === void 0 && (J = 0), ae === void 0 && (ae = this.length), w < 0 || D > v.length || J < 0 || ae > this.length)
      throw new RangeError("out of range index");
    if (J >= ae && w >= D)
      return 0;
    if (J >= ae)
      return -1;
    if (w >= D)
      return 1;
    if (w >>>= 0, D >>>= 0, J >>>= 0, ae >>>= 0, this === v)
      return 0;
    for (var ue = ae - J, Se = D - w, _e = Math.min(ue, Se), we = this.slice(J, ae), Ne = v.slice(w, D), E = 0; E < _e; ++E)
      if (we[E] !== Ne[E]) {
        ue = we[E], Se = Ne[E];
        break;
      }
    return ue < Se ? -1 : Se < ue ? 1 : 0;
  };
  function B(C, v, w, D, J) {
    if (C.length === 0)
      return -1;
    if (typeof w == "string" ? (D = w, w = 0) : w > 2147483647 ? w = 2147483647 : w < -2147483648 && (w = -2147483648), w = +w, ne(w) && (w = J ? 0 : C.length - 1), w < 0 && (w = C.length + w), w >= C.length) {
      if (J)
        return -1;
      w = C.length - 1;
    } else if (w < 0)
      if (J)
        w = 0;
      else
        return -1;
    if (typeof v == "string" && (v = a.from(v, D)), a.isBuffer(v))
      return v.length === 0 ? -1 : N(C, v, w, D, J);
    if (typeof v == "number")
      return v = v & 255, typeof Uint8Array.prototype.indexOf == "function" ? J ? Uint8Array.prototype.indexOf.call(C, v, w) : Uint8Array.prototype.lastIndexOf.call(C, v, w) : N(C, [v], w, D, J);
    throw new TypeError("val must be string, number or Buffer");
  }
  function N(C, v, w, D, J) {
    var ae = 1, ue = C.length, Se = v.length;
    if (D !== void 0 && (D = String(D).toLowerCase(), D === "ucs2" || D === "ucs-2" || D === "utf16le" || D === "utf-16le")) {
      if (C.length < 2 || v.length < 2)
        return -1;
      ae = 2, ue /= 2, Se /= 2, w /= 2;
    }
    function _e(A, M) {
      return ae === 1 ? A[M] : A.readUInt16BE(M * ae);
    }
    var we;
    if (J) {
      var Ne = -1;
      for (we = w; we < ue; we++)
        if (_e(C, we) === _e(v, Ne === -1 ? 0 : we - Ne)) {
          if (Ne === -1 && (Ne = we), we - Ne + 1 === Se)
            return Ne * ae;
        } else
          Ne !== -1 && (we -= we - Ne), Ne = -1;
    } else
      for (w + Se > ue && (w = ue - Se), we = w; we >= 0; we--) {
        for (var E = !0, m = 0; m < Se; m++)
          if (_e(C, we + m) !== _e(v, m)) {
            E = !1;
            break;
          }
        if (E)
          return we;
      }
    return -1;
  }
  a.prototype.includes = function(v, w, D) {
    return this.indexOf(v, w, D) !== -1;
  }, a.prototype.indexOf = function(v, w, D) {
    return B(this, v, w, D, !0);
  }, a.prototype.lastIndexOf = function(v, w, D) {
    return B(this, v, w, D, !1);
  };
  function j(C, v, w, D) {
    w = Number(w) || 0;
    var J = C.length - w;
    D ? (D = Number(D), D > J && (D = J)) : D = J;
    var ae = v.length;
    D > ae / 2 && (D = ae / 2);
    for (var ue = 0; ue < D; ++ue) {
      var Se = parseInt(v.substr(ue * 2, 2), 16);
      if (ne(Se))
        return ue;
      C[w + ue] = Se;
    }
    return ue;
  }
  function W(C, v, w, D) {
    return k(Z(v, C.length - w), C, w, D);
  }
  function G(C, v, w, D) {
    return k(oe(v), C, w, D);
  }
  function ee(C, v, w, D) {
    return k(R(v), C, w, D);
  }
  function fe(C, v, w, D) {
    return k(de(v, C.length - w), C, w, D);
  }
  a.prototype.write = function(v, w, D, J) {
    if (w === void 0)
      J = "utf8", D = this.length, w = 0;
    else if (D === void 0 && typeof w == "string")
      J = w, D = this.length, w = 0;
    else if (isFinite(w))
      w = w >>> 0, isFinite(D) ? (D = D >>> 0, J === void 0 && (J = "utf8")) : (J = D, D = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    var ae = this.length - w;
    if ((D === void 0 || D > ae) && (D = ae), v.length > 0 && (D < 0 || w < 0) || w > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    J || (J = "utf8");
    for (var ue = !1; ; )
      switch (J) {
        case "hex":
          return j(this, v, w, D);
        case "utf8":
        case "utf-8":
          return W(this, v, w, D);
        case "ascii":
        case "latin1":
        case "binary":
          return G(this, v, w, D);
        case "base64":
          return ee(this, v, w, D);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return fe(this, v, w, D);
        default:
          if (ue)
            throw new TypeError("Unknown encoding: " + J);
          J = ("" + J).toLowerCase(), ue = !0;
      }
  }, a.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function P(C, v, w) {
    return v === 0 && w === C.length ? e.fromByteArray(C) : e.fromByteArray(C.slice(v, w));
  }
  function z(C, v, w) {
    w = Math.min(C.length, w);
    for (var D = [], J = v; J < w; ) {
      var ae = C[J], ue = null, Se = ae > 239 ? 4 : ae > 223 ? 3 : ae > 191 ? 2 : 1;
      if (J + Se <= w) {
        var _e, we, Ne, E;
        switch (Se) {
          case 1:
            ae < 128 && (ue = ae);
            break;
          case 2:
            _e = C[J + 1], (_e & 192) === 128 && (E = (ae & 31) << 6 | _e & 63, E > 127 && (ue = E));
            break;
          case 3:
            _e = C[J + 1], we = C[J + 2], (_e & 192) === 128 && (we & 192) === 128 && (E = (ae & 15) << 12 | (_e & 63) << 6 | we & 63, E > 2047 && (E < 55296 || E > 57343) && (ue = E));
            break;
          case 4:
            _e = C[J + 1], we = C[J + 2], Ne = C[J + 3], (_e & 192) === 128 && (we & 192) === 128 && (Ne & 192) === 128 && (E = (ae & 15) << 18 | (_e & 63) << 12 | (we & 63) << 6 | Ne & 63, E > 65535 && E < 1114112 && (ue = E));
        }
      }
      ue === null ? (ue = 65533, Se = 1) : ue > 65535 && (ue -= 65536, D.push(ue >>> 10 & 1023 | 55296), ue = 56320 | ue & 1023), D.push(ue), J += Se;
    }
    return I(D);
  }
  var U = 4096;
  function I(C) {
    var v = C.length;
    if (v <= U)
      return String.fromCharCode.apply(String, C);
    for (var w = "", D = 0; D < v; )
      w += String.fromCharCode.apply(
        String,
        C.slice(D, D += U)
      );
    return w;
  }
  function V(C, v, w) {
    var D = "";
    w = Math.min(C.length, w);
    for (var J = v; J < w; ++J)
      D += String.fromCharCode(C[J] & 127);
    return D;
  }
  function te(C, v, w) {
    var D = "";
    w = Math.min(C.length, w);
    for (var J = v; J < w; ++J)
      D += String.fromCharCode(C[J]);
    return D;
  }
  function X(C, v, w) {
    var D = C.length;
    (!v || v < 0) && (v = 0), (!w || w < 0 || w > D) && (w = D);
    for (var J = "", ae = v; ae < w; ++ae)
      J += Ae[C[ae]];
    return J;
  }
  function H(C, v, w) {
    for (var D = C.slice(v, w), J = "", ae = 0; ae < D.length - 1; ae += 2)
      J += String.fromCharCode(D[ae] + D[ae + 1] * 256);
    return J;
  }
  a.prototype.slice = function(v, w) {
    var D = this.length;
    v = ~~v, w = w === void 0 ? D : ~~w, v < 0 ? (v += D, v < 0 && (v = 0)) : v > D && (v = D), w < 0 ? (w += D, w < 0 && (w = 0)) : w > D && (w = D), w < v && (w = v);
    var J = this.subarray(v, w);
    return Object.setPrototypeOf(J, a.prototype), J;
  };
  function $(C, v, w) {
    if (C % 1 !== 0 || C < 0)
      throw new RangeError("offset is not uint");
    if (C + v > w)
      throw new RangeError("Trying to access beyond buffer length");
  }
  a.prototype.readUintLE = a.prototype.readUIntLE = function(v, w, D) {
    v = v >>> 0, w = w >>> 0, D || $(v, w, this.length);
    for (var J = this[v], ae = 1, ue = 0; ++ue < w && (ae *= 256); )
      J += this[v + ue] * ae;
    return J;
  }, a.prototype.readUintBE = a.prototype.readUIntBE = function(v, w, D) {
    v = v >>> 0, w = w >>> 0, D || $(v, w, this.length);
    for (var J = this[v + --w], ae = 1; w > 0 && (ae *= 256); )
      J += this[v + --w] * ae;
    return J;
  }, a.prototype.readUint8 = a.prototype.readUInt8 = function(v, w) {
    return v = v >>> 0, w || $(v, 1, this.length), this[v];
  }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(v, w) {
    return v = v >>> 0, w || $(v, 2, this.length), this[v] | this[v + 1] << 8;
  }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(v, w) {
    return v = v >>> 0, w || $(v, 2, this.length), this[v] << 8 | this[v + 1];
  }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(v, w) {
    return v = v >>> 0, w || $(v, 4, this.length), (this[v] | this[v + 1] << 8 | this[v + 2] << 16) + this[v + 3] * 16777216;
  }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(v, w) {
    return v = v >>> 0, w || $(v, 4, this.length), this[v] * 16777216 + (this[v + 1] << 16 | this[v + 2] << 8 | this[v + 3]);
  }, a.prototype.readIntLE = function(v, w, D) {
    v = v >>> 0, w = w >>> 0, D || $(v, w, this.length);
    for (var J = this[v], ae = 1, ue = 0; ++ue < w && (ae *= 256); )
      J += this[v + ue] * ae;
    return ae *= 128, J >= ae && (J -= Math.pow(2, 8 * w)), J;
  }, a.prototype.readIntBE = function(v, w, D) {
    v = v >>> 0, w = w >>> 0, D || $(v, w, this.length);
    for (var J = w, ae = 1, ue = this[v + --J]; J > 0 && (ae *= 256); )
      ue += this[v + --J] * ae;
    return ae *= 128, ue >= ae && (ue -= Math.pow(2, 8 * w)), ue;
  }, a.prototype.readInt8 = function(v, w) {
    return v = v >>> 0, w || $(v, 1, this.length), this[v] & 128 ? (255 - this[v] + 1) * -1 : this[v];
  }, a.prototype.readInt16LE = function(v, w) {
    v = v >>> 0, w || $(v, 2, this.length);
    var D = this[v] | this[v + 1] << 8;
    return D & 32768 ? D | 4294901760 : D;
  }, a.prototype.readInt16BE = function(v, w) {
    v = v >>> 0, w || $(v, 2, this.length);
    var D = this[v + 1] | this[v] << 8;
    return D & 32768 ? D | 4294901760 : D;
  }, a.prototype.readInt32LE = function(v, w) {
    return v = v >>> 0, w || $(v, 4, this.length), this[v] | this[v + 1] << 8 | this[v + 2] << 16 | this[v + 3] << 24;
  }, a.prototype.readInt32BE = function(v, w) {
    return v = v >>> 0, w || $(v, 4, this.length), this[v] << 24 | this[v + 1] << 16 | this[v + 2] << 8 | this[v + 3];
  }, a.prototype.readFloatLE = function(v, w) {
    return v = v >>> 0, w || $(v, 4, this.length), r.read(this, v, !0, 23, 4);
  }, a.prototype.readFloatBE = function(v, w) {
    return v = v >>> 0, w || $(v, 4, this.length), r.read(this, v, !1, 23, 4);
  }, a.prototype.readDoubleLE = function(v, w) {
    return v = v >>> 0, w || $(v, 8, this.length), r.read(this, v, !0, 52, 8);
  }, a.prototype.readDoubleBE = function(v, w) {
    return v = v >>> 0, w || $(v, 8, this.length), r.read(this, v, !1, 52, 8);
  };
  function se(C, v, w, D, J, ae) {
    if (!a.isBuffer(C))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (v > J || v < ae)
      throw new RangeError('"value" argument is out of bounds');
    if (w + D > C.length)
      throw new RangeError("Index out of range");
  }
  a.prototype.writeUintLE = a.prototype.writeUIntLE = function(v, w, D, J) {
    if (v = +v, w = w >>> 0, D = D >>> 0, !J) {
      var ae = Math.pow(2, 8 * D) - 1;
      se(this, v, w, D, ae, 0);
    }
    var ue = 1, Se = 0;
    for (this[w] = v & 255; ++Se < D && (ue *= 256); )
      this[w + Se] = v / ue & 255;
    return w + D;
  }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(v, w, D, J) {
    if (v = +v, w = w >>> 0, D = D >>> 0, !J) {
      var ae = Math.pow(2, 8 * D) - 1;
      se(this, v, w, D, ae, 0);
    }
    var ue = D - 1, Se = 1;
    for (this[w + ue] = v & 255; --ue >= 0 && (Se *= 256); )
      this[w + ue] = v / Se & 255;
    return w + D;
  }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 1, 255, 0), this[w] = v & 255, w + 1;
  }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 2, 65535, 0), this[w] = v & 255, this[w + 1] = v >>> 8, w + 2;
  }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 2, 65535, 0), this[w] = v >>> 8, this[w + 1] = v & 255, w + 2;
  }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 4, 4294967295, 0), this[w + 3] = v >>> 24, this[w + 2] = v >>> 16, this[w + 1] = v >>> 8, this[w] = v & 255, w + 4;
  }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 4, 4294967295, 0), this[w] = v >>> 24, this[w + 1] = v >>> 16, this[w + 2] = v >>> 8, this[w + 3] = v & 255, w + 4;
  }, a.prototype.writeIntLE = function(v, w, D, J) {
    if (v = +v, w = w >>> 0, !J) {
      var ae = Math.pow(2, 8 * D - 1);
      se(this, v, w, D, ae - 1, -ae);
    }
    var ue = 0, Se = 1, _e = 0;
    for (this[w] = v & 255; ++ue < D && (Se *= 256); )
      v < 0 && _e === 0 && this[w + ue - 1] !== 0 && (_e = 1), this[w + ue] = (v / Se >> 0) - _e & 255;
    return w + D;
  }, a.prototype.writeIntBE = function(v, w, D, J) {
    if (v = +v, w = w >>> 0, !J) {
      var ae = Math.pow(2, 8 * D - 1);
      se(this, v, w, D, ae - 1, -ae);
    }
    var ue = D - 1, Se = 1, _e = 0;
    for (this[w + ue] = v & 255; --ue >= 0 && (Se *= 256); )
      v < 0 && _e === 0 && this[w + ue + 1] !== 0 && (_e = 1), this[w + ue] = (v / Se >> 0) - _e & 255;
    return w + D;
  }, a.prototype.writeInt8 = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 1, 127, -128), v < 0 && (v = 255 + v + 1), this[w] = v & 255, w + 1;
  }, a.prototype.writeInt16LE = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 2, 32767, -32768), this[w] = v & 255, this[w + 1] = v >>> 8, w + 2;
  }, a.prototype.writeInt16BE = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 2, 32767, -32768), this[w] = v >>> 8, this[w + 1] = v & 255, w + 2;
  }, a.prototype.writeInt32LE = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 4, 2147483647, -2147483648), this[w] = v & 255, this[w + 1] = v >>> 8, this[w + 2] = v >>> 16, this[w + 3] = v >>> 24, w + 4;
  }, a.prototype.writeInt32BE = function(v, w, D) {
    return v = +v, w = w >>> 0, D || se(this, v, w, 4, 2147483647, -2147483648), v < 0 && (v = 4294967295 + v + 1), this[w] = v >>> 24, this[w + 1] = v >>> 16, this[w + 2] = v >>> 8, this[w + 3] = v & 255, w + 4;
  };
  function he(C, v, w, D, J, ae) {
    if (w + D > C.length)
      throw new RangeError("Index out of range");
    if (w < 0)
      throw new RangeError("Index out of range");
  }
  function pe(C, v, w, D, J) {
    return v = +v, w = w >>> 0, J || he(C, v, w, 4), r.write(C, v, w, D, 23, 4), w + 4;
  }
  a.prototype.writeFloatLE = function(v, w, D) {
    return pe(this, v, w, !0, D);
  }, a.prototype.writeFloatBE = function(v, w, D) {
    return pe(this, v, w, !1, D);
  };
  function me(C, v, w, D, J) {
    return v = +v, w = w >>> 0, J || he(C, v, w, 8), r.write(C, v, w, D, 52, 8), w + 8;
  }
  a.prototype.writeDoubleLE = function(v, w, D) {
    return me(this, v, w, !0, D);
  }, a.prototype.writeDoubleBE = function(v, w, D) {
    return me(this, v, w, !1, D);
  }, a.prototype.copy = function(v, w, D, J) {
    if (!a.isBuffer(v))
      throw new TypeError("argument should be a Buffer");
    if (D || (D = 0), !J && J !== 0 && (J = this.length), w >= v.length && (w = v.length), w || (w = 0), J > 0 && J < D && (J = D), J === D || v.length === 0 || this.length === 0)
      return 0;
    if (w < 0)
      throw new RangeError("targetStart out of bounds");
    if (D < 0 || D >= this.length)
      throw new RangeError("Index out of range");
    if (J < 0)
      throw new RangeError("sourceEnd out of bounds");
    J > this.length && (J = this.length), v.length - w < J - D && (J = v.length - w + D);
    var ae = J - D;
    return this === v && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(w, D, J) : Uint8Array.prototype.set.call(
      v,
      this.subarray(D, J),
      w
    ), ae;
  }, a.prototype.fill = function(v, w, D, J) {
    if (typeof v == "string") {
      if (typeof w == "string" ? (J = w, w = 0, D = this.length) : typeof D == "string" && (J = D, D = this.length), J !== void 0 && typeof J != "string")
        throw new TypeError("encoding must be a string");
      if (typeof J == "string" && !a.isEncoding(J))
        throw new TypeError("Unknown encoding: " + J);
      if (v.length === 1) {
        var ae = v.charCodeAt(0);
        (J === "utf8" && ae < 128 || J === "latin1") && (v = ae);
      }
    } else
      typeof v == "number" ? v = v & 255 : typeof v == "boolean" && (v = Number(v));
    if (w < 0 || this.length < w || this.length < D)
      throw new RangeError("Out of range index");
    if (D <= w)
      return this;
    w = w >>> 0, D = D === void 0 ? this.length : D >>> 0, v || (v = 0);
    var ue;
    if (typeof v == "number")
      for (ue = w; ue < D; ++ue)
        this[ue] = v;
    else {
      var Se = a.isBuffer(v) ? v : a.from(v, J), _e = Se.length;
      if (_e === 0)
        throw new TypeError('The value "' + v + '" is invalid for argument "value"');
      for (ue = 0; ue < D - w; ++ue)
        this[ue + w] = Se[ue % _e];
    }
    return this;
  };
  var L = /[^+/0-9A-Za-z-_]/g;
  function q(C) {
    if (C = C.split("=")[0], C = C.trim().replace(L, ""), C.length < 2)
      return "";
    for (; C.length % 4 !== 0; )
      C = C + "=";
    return C;
  }
  function Z(C, v) {
    v = v || 1 / 0;
    for (var w, D = C.length, J = null, ae = [], ue = 0; ue < D; ++ue) {
      if (w = C.charCodeAt(ue), w > 55295 && w < 57344) {
        if (!J) {
          if (w > 56319) {
            (v -= 3) > -1 && ae.push(239, 191, 189);
            continue;
          } else if (ue + 1 === D) {
            (v -= 3) > -1 && ae.push(239, 191, 189);
            continue;
          }
          J = w;
          continue;
        }
        if (w < 56320) {
          (v -= 3) > -1 && ae.push(239, 191, 189), J = w;
          continue;
        }
        w = (J - 55296 << 10 | w - 56320) + 65536;
      } else
        J && (v -= 3) > -1 && ae.push(239, 191, 189);
      if (J = null, w < 128) {
        if ((v -= 1) < 0)
          break;
        ae.push(w);
      } else if (w < 2048) {
        if ((v -= 2) < 0)
          break;
        ae.push(
          w >> 6 | 192,
          w & 63 | 128
        );
      } else if (w < 65536) {
        if ((v -= 3) < 0)
          break;
        ae.push(
          w >> 12 | 224,
          w >> 6 & 63 | 128,
          w & 63 | 128
        );
      } else if (w < 1114112) {
        if ((v -= 4) < 0)
          break;
        ae.push(
          w >> 18 | 240,
          w >> 12 & 63 | 128,
          w >> 6 & 63 | 128,
          w & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return ae;
  }
  function oe(C) {
    for (var v = [], w = 0; w < C.length; ++w)
      v.push(C.charCodeAt(w) & 255);
    return v;
  }
  function de(C, v) {
    for (var w, D, J, ae = [], ue = 0; ue < C.length && !((v -= 2) < 0); ++ue)
      w = C.charCodeAt(ue), D = w >> 8, J = w % 256, ae.push(J), ae.push(D);
    return ae;
  }
  function R(C) {
    return e.toByteArray(q(C));
  }
  function k(C, v, w, D) {
    for (var J = 0; J < D && !(J + w >= v.length || J >= C.length); ++J)
      v[J + w] = C[J];
    return J;
  }
  function re(C, v) {
    return C instanceof v || C != null && C.constructor != null && C.constructor.name != null && C.constructor.name === v.name;
  }
  function ne(C) {
    return C !== C;
  }
  var Ae = function() {
    for (var C = "0123456789abcdef", v = new Array(256), w = 0; w < 16; ++w)
      for (var D = w * 16, J = 0; J < 16; ++J)
        v[D + J] = C[w] + C[J];
    return v;
  }();
})(Yo);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(t, e) {
  var r = Yo, n = r.Buffer;
  function i(s, a) {
    for (var l in s)
      a[l] = s[l];
  }
  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? t.exports = r : (i(r, e), e.Buffer = o);
  function o(s, a, l) {
    return n(s, a, l);
  }
  o.prototype = Object.create(n.prototype), i(n, o), o.from = function(s, a, l) {
    if (typeof s == "number")
      throw new TypeError("Argument must not be a number");
    return n(s, a, l);
  }, o.alloc = function(s, a, l) {
    if (typeof s != "number")
      throw new TypeError("Argument must be a number");
    var c = n(s);
    return a !== void 0 ? typeof l == "string" ? c.fill(a, l) : c.fill(a) : c.fill(0), c;
  }, o.allocUnsafe = function(s) {
    if (typeof s != "number")
      throw new TypeError("Argument must be a number");
    return n(s);
  }, o.allocUnsafeSlow = function(s) {
    if (typeof s != "number")
      throw new TypeError("Argument must be a number");
    return r.SlowBuffer(s);
  };
})(ay, _o);
var El = 65536, my = 4294967295;
function yy() {
  throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
}
var by = _o.Buffer, oa = globalThis.crypto || globalThis.msCrypto;
oa && oa.getRandomValues ? Lf.exports = vy : Lf.exports = yy;
function vy(t, e) {
  if (t > my)
    throw new RangeError("requested too many random bytes");
  var r = by.allocUnsafe(t);
  if (t > 0)
    if (t > El)
      for (var n = 0; n < t; n += El)
        oa.getRandomValues(r.slice(n, n + El));
    else
      oa.getRandomValues(r);
  return typeof e == "function" ? process.nextTick(function() {
    e(null, r);
  }) : r;
}
var sa = {}, Ay = {
  get exports() {
    return sa;
  },
  set exports(t) {
    sa = t;
  }
}, E0 = vi.EventEmitter;
const wy = {}, xy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wy
}, Symbol.toStringTag, { value: "Module" })), k0 = /* @__PURE__ */ g0(xy);
var kl, Ff;
function _y() {
  if (Ff)
    return kl;
  Ff = 1;
  function t(d, h) {
    var g = Object.keys(d);
    if (Object.getOwnPropertySymbols) {
      var p = Object.getOwnPropertySymbols(d);
      h && (p = p.filter(function(y) {
        return Object.getOwnPropertyDescriptor(d, y).enumerable;
      })), g.push.apply(g, p);
    }
    return g;
  }
  function e(d) {
    for (var h = 1; h < arguments.length; h++) {
      var g = arguments[h] != null ? arguments[h] : {};
      h % 2 ? t(Object(g), !0).forEach(function(p) {
        r(d, p, g[p]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(g)) : t(Object(g)).forEach(function(p) {
        Object.defineProperty(d, p, Object.getOwnPropertyDescriptor(g, p));
      });
    }
    return d;
  }
  function r(d, h, g) {
    return h in d ? Object.defineProperty(d, h, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : d[h] = g, d;
  }
  function n(d, h) {
    if (!(d instanceof h))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(d, h) {
    for (var g = 0; g < h.length; g++) {
      var p = h[g];
      p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(d, p.key, p);
    }
  }
  function o(d, h, g) {
    return h && i(d.prototype, h), g && i(d, g), d;
  }
  var s = Yo, a = s.Buffer, l = k0, c = l.inspect, u = c && c.custom || "inspect";
  function f(d, h, g) {
    a.prototype.copy.call(d, h, g);
  }
  return kl = /* @__PURE__ */ function() {
    function d() {
      n(this, d), this.head = null, this.tail = null, this.length = 0;
    }
    return o(d, [{
      key: "push",
      value: function(g) {
        var p = {
          data: g,
          next: null
        };
        this.length > 0 ? this.tail.next = p : this.head = p, this.tail = p, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(g) {
        var p = {
          data: g,
          next: this.head
        };
        this.length === 0 && (this.tail = p), this.head = p, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var g = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, g;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(g) {
        if (this.length === 0)
          return "";
        for (var p = this.head, y = "" + p.data; p = p.next; )
          y += g + p.data;
        return y;
      }
    }, {
      key: "concat",
      value: function(g) {
        if (this.length === 0)
          return a.alloc(0);
        for (var p = a.allocUnsafe(g >>> 0), y = this.head, b = 0; y; )
          f(y.data, p, b), b += y.data.length, y = y.next;
        return p;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(g, p) {
        var y;
        return g < this.head.data.length ? (y = this.head.data.slice(0, g), this.head.data = this.head.data.slice(g)) : g === this.head.data.length ? y = this.shift() : y = p ? this._getString(g) : this._getBuffer(g), y;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(g) {
        var p = this.head, y = 1, b = p.data;
        for (g -= b.length; p = p.next; ) {
          var x = p.data, S = g > x.length ? x.length : g;
          if (S === x.length ? b += x : b += x.slice(0, g), g -= S, g === 0) {
            S === x.length ? (++y, p.next ? this.head = p.next : this.head = this.tail = null) : (this.head = p, p.data = x.slice(S));
            break;
          }
          ++y;
        }
        return this.length -= y, b;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(g) {
        var p = a.allocUnsafe(g), y = this.head, b = 1;
        for (y.data.copy(p), g -= y.data.length; y = y.next; ) {
          var x = y.data, S = g > x.length ? x.length : g;
          if (x.copy(p, p.length - g, 0, S), g -= S, g === 0) {
            S === x.length ? (++b, y.next ? this.head = y.next : this.head = this.tail = null) : (this.head = y, y.data = x.slice(S));
            break;
          }
          ++b;
        }
        return this.length -= b, p;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: u,
      value: function(g, p) {
        return c(this, e({}, p, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), d;
  }(), kl;
}
function Sy(t, e) {
  var r = this, n = this._readableState && this._readableState.destroyed, i = this._writableState && this._writableState.destroyed;
  return n || i ? (e ? e(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(Sc, this, t)) : process.nextTick(Sc, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(o) {
    !e && o ? r._writableState ? r._writableState.errorEmitted ? process.nextTick(zs, r) : (r._writableState.errorEmitted = !0, process.nextTick(jf, r, o)) : process.nextTick(jf, r, o) : e ? (process.nextTick(zs, r), e(o)) : process.nextTick(zs, r);
  }), this);
}
function jf(t, e) {
  Sc(t, e), zs(t);
}
function zs(t) {
  t._writableState && !t._writableState.emitClose || t._readableState && !t._readableState.emitClose || t.emit("close");
}
function Ey() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function Sc(t, e) {
  t.emit("error", e);
}
function ky(t, e) {
  var r = t._readableState, n = t._writableState;
  r && r.autoDestroy || n && n.autoDestroy ? t.destroy(e) : t.emit("error", e);
}
var C0 = {
  destroy: Sy,
  undestroy: Ey,
  errorOrDestroy: ky
}, Jn = {};
function Cy(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
var T0 = {};
function ar(t, e, r) {
  r || (r = Error);
  function n(o, s, a) {
    return typeof e == "string" ? e : e(o, s, a);
  }
  var i = /* @__PURE__ */ function(o) {
    Cy(s, o);
    function s(a, l, c) {
      return o.call(this, n(a, l, c)) || this;
    }
    return s;
  }(r);
  i.prototype.name = r.name, i.prototype.code = t, T0[t] = i;
}
function Wf(t, e) {
  if (Array.isArray(t)) {
    var r = t.length;
    return t = t.map(function(n) {
      return String(n);
    }), r > 2 ? "one of ".concat(e, " ").concat(t.slice(0, r - 1).join(", "), ", or ") + t[r - 1] : r === 2 ? "one of ".concat(e, " ").concat(t[0], " or ").concat(t[1]) : "of ".concat(e, " ").concat(t[0]);
  } else
    return "of ".concat(e, " ").concat(String(t));
}
function Ty(t, e, r) {
  return t.substr(!r || r < 0 ? 0 : +r, e.length) === e;
}
function Oy(t, e, r) {
  return (r === void 0 || r > t.length) && (r = t.length), t.substring(r - e.length, r) === e;
}
function Iy(t, e, r) {
  return typeof r != "number" && (r = 0), r + e.length > t.length ? !1 : t.indexOf(e, r) !== -1;
}
ar("ERR_INVALID_OPT_VALUE", function(t, e) {
  return 'The value "' + e + '" is invalid for option "' + t + '"';
}, TypeError);
ar("ERR_INVALID_ARG_TYPE", function(t, e, r) {
  var n;
  typeof e == "string" && Ty(e, "not ") ? (n = "must not be", e = e.replace(/^not /, "")) : n = "must be";
  var i;
  if (Oy(t, " argument"))
    i = "The ".concat(t, " ").concat(n, " ").concat(Wf(e, "type"));
  else {
    var o = Iy(t, ".") ? "property" : "argument";
    i = 'The "'.concat(t, '" ').concat(o, " ").concat(n, " ").concat(Wf(e, "type"));
  }
  return i += ". Received type ".concat(typeof r), i;
}, TypeError);
ar("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
ar("ERR_METHOD_NOT_IMPLEMENTED", function(t) {
  return "The " + t + " method is not implemented";
});
ar("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
ar("ERR_STREAM_DESTROYED", function(t) {
  return "Cannot call " + t + " after a stream was destroyed";
});
ar("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
ar("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
ar("ERR_STREAM_WRITE_AFTER_END", "write after end");
ar("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
ar("ERR_UNKNOWN_ENCODING", function(t) {
  return "Unknown encoding: " + t;
}, TypeError);
ar("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
Jn.codes = T0;
var Py = Jn.codes.ERR_INVALID_OPT_VALUE;
function Ry(t, e, r) {
  return t.highWaterMark != null ? t.highWaterMark : e ? t[r] : null;
}
function Dy(t, e, r, n) {
  var i = Ry(e, n, r);
  if (i != null) {
    if (!(isFinite(i) && Math.floor(i) === i) || i < 0) {
      var o = n ? r : "highWaterMark";
      throw new Py(o, i);
    }
    return Math.floor(i);
  }
  return t.objectMode ? 16 : 16 * 1024;
}
var O0 = {
  getHighWaterMark: Dy
}, Wn = {}, Uf = {
  get exports() {
    return Wn;
  },
  set exports(t) {
    Wn = t;
  }
};
typeof Object.create == "function" ? Uf.exports = function(e, r) {
  r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : Uf.exports = function(e, r) {
  if (r) {
    e.super_ = r;
    var n = function() {
    };
    n.prototype = r.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }
};
var My = Ny;
function Ny(t, e) {
  if (Cl("noDeprecation"))
    return t;
  var r = !1;
  function n() {
    if (!r) {
      if (Cl("throwDeprecation"))
        throw new Error(e);
      Cl("traceDeprecation") ? console.trace(e) : console.warn(e), r = !0;
    }
    return t.apply(this, arguments);
  }
  return n;
}
function Cl(t) {
  try {
    if (!globalThis.localStorage)
      return !1;
  } catch {
    return !1;
  }
  var e = globalThis.localStorage[t];
  return e == null ? !1 : String(e).toLowerCase() === "true";
}
var Tl, zf;
function I0() {
  if (zf)
    return Tl;
  zf = 1, Tl = j;
  function t(L) {
    var q = this;
    this.next = null, this.entry = null, this.finish = function() {
      me(q, L);
    };
  }
  var e;
  j.WritableState = B;
  var r = {
    deprecate: My
  }, n = E0, i = Yo.Buffer, o = globalThis.Uint8Array || function() {
  };
  function s(L) {
    return i.from(L);
  }
  function a(L) {
    return i.isBuffer(L) || L instanceof o;
  }
  var l = C0, c = O0, u = c.getHighWaterMark, f = Jn.codes, d = f.ERR_INVALID_ARG_TYPE, h = f.ERR_METHOD_NOT_IMPLEMENTED, g = f.ERR_MULTIPLE_CALLBACK, p = f.ERR_STREAM_CANNOT_PIPE, y = f.ERR_STREAM_DESTROYED, b = f.ERR_STREAM_NULL_VALUES, x = f.ERR_STREAM_WRITE_AFTER_END, S = f.ERR_UNKNOWN_ENCODING, O = l.errorOrDestroy;
  Wn(j, n);
  function _() {
  }
  function B(L, q, Z) {
    e = e || Ai(), L = L || {}, typeof Z != "boolean" && (Z = q instanceof e), this.objectMode = !!L.objectMode, Z && (this.objectMode = this.objectMode || !!L.writableObjectMode), this.highWaterMark = u(this, L, "writableHighWaterMark", Z), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var oe = L.decodeStrings === !1;
    this.decodeStrings = !oe, this.defaultEncoding = L.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(de) {
      I(q, de);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = L.emitClose !== !1, this.autoDestroy = !!L.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  B.prototype.getBuffer = function() {
    for (var q = this.bufferedRequest, Z = []; q; )
      Z.push(q), q = q.next;
    return Z;
  }, function() {
    try {
      Object.defineProperty(B.prototype, "buffer", {
        get: r.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var N;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (N = Function.prototype[Symbol.hasInstance], Object.defineProperty(j, Symbol.hasInstance, {
    value: function(q) {
      return N.call(this, q) ? !0 : this !== j ? !1 : q && q._writableState instanceof B;
    }
  })) : N = function(q) {
    return q instanceof this;
  };
  function j(L) {
    e = e || Ai();
    var q = this instanceof e;
    if (!q && !N.call(j, this))
      return new j(L);
    this._writableState = new B(L, this, q), this.writable = !0, L && (typeof L.write == "function" && (this._write = L.write), typeof L.writev == "function" && (this._writev = L.writev), typeof L.destroy == "function" && (this._destroy = L.destroy), typeof L.final == "function" && (this._final = L.final)), n.call(this);
  }
  j.prototype.pipe = function() {
    O(this, new p());
  };
  function W(L, q) {
    var Z = new x();
    O(L, Z), process.nextTick(q, Z);
  }
  function G(L, q, Z, oe) {
    var de;
    return Z === null ? de = new b() : typeof Z != "string" && !q.objectMode && (de = new d("chunk", ["string", "Buffer"], Z)), de ? (O(L, de), process.nextTick(oe, de), !1) : !0;
  }
  j.prototype.write = function(L, q, Z) {
    var oe = this._writableState, de = !1, R = !oe.objectMode && a(L);
    return R && !i.isBuffer(L) && (L = s(L)), typeof q == "function" && (Z = q, q = null), R ? q = "buffer" : q || (q = oe.defaultEncoding), typeof Z != "function" && (Z = _), oe.ending ? W(this, Z) : (R || G(this, oe, L, Z)) && (oe.pendingcb++, de = fe(this, oe, R, L, q, Z)), de;
  }, j.prototype.cork = function() {
    this._writableState.corked++;
  }, j.prototype.uncork = function() {
    var L = this._writableState;
    L.corked && (L.corked--, !L.writing && !L.corked && !L.bufferProcessing && L.bufferedRequest && X(this, L));
  }, j.prototype.setDefaultEncoding = function(q) {
    if (typeof q == "string" && (q = q.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((q + "").toLowerCase()) > -1))
      throw new S(q);
    return this._writableState.defaultEncoding = q, this;
  }, Object.defineProperty(j.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function ee(L, q, Z) {
    return !L.objectMode && L.decodeStrings !== !1 && typeof q == "string" && (q = i.from(q, Z)), q;
  }
  Object.defineProperty(j.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function fe(L, q, Z, oe, de, R) {
    if (!Z) {
      var k = ee(q, oe, de);
      oe !== k && (Z = !0, de = "buffer", oe = k);
    }
    var re = q.objectMode ? 1 : oe.length;
    q.length += re;
    var ne = q.length < q.highWaterMark;
    if (ne || (q.needDrain = !0), q.writing || q.corked) {
      var Ae = q.lastBufferedRequest;
      q.lastBufferedRequest = {
        chunk: oe,
        encoding: de,
        isBuf: Z,
        callback: R,
        next: null
      }, Ae ? Ae.next = q.lastBufferedRequest : q.bufferedRequest = q.lastBufferedRequest, q.bufferedRequestCount += 1;
    } else
      P(L, q, !1, re, oe, de, R);
    return ne;
  }
  function P(L, q, Z, oe, de, R, k) {
    q.writelen = oe, q.writecb = k, q.writing = !0, q.sync = !0, q.destroyed ? q.onwrite(new y("write")) : Z ? L._writev(de, q.onwrite) : L._write(de, R, q.onwrite), q.sync = !1;
  }
  function z(L, q, Z, oe, de) {
    --q.pendingcb, Z ? (process.nextTick(de, oe), process.nextTick(he, L, q), L._writableState.errorEmitted = !0, O(L, oe)) : (de(oe), L._writableState.errorEmitted = !0, O(L, oe), he(L, q));
  }
  function U(L) {
    L.writing = !1, L.writecb = null, L.length -= L.writelen, L.writelen = 0;
  }
  function I(L, q) {
    var Z = L._writableState, oe = Z.sync, de = Z.writecb;
    if (typeof de != "function")
      throw new g();
    if (U(Z), q)
      z(L, Z, oe, q, de);
    else {
      var R = H(Z) || L.destroyed;
      !R && !Z.corked && !Z.bufferProcessing && Z.bufferedRequest && X(L, Z), oe ? process.nextTick(V, L, Z, R, de) : V(L, Z, R, de);
    }
  }
  function V(L, q, Z, oe) {
    Z || te(L, q), q.pendingcb--, oe(), he(L, q);
  }
  function te(L, q) {
    q.length === 0 && q.needDrain && (q.needDrain = !1, L.emit("drain"));
  }
  function X(L, q) {
    q.bufferProcessing = !0;
    var Z = q.bufferedRequest;
    if (L._writev && Z && Z.next) {
      var oe = q.bufferedRequestCount, de = new Array(oe), R = q.corkedRequestsFree;
      R.entry = Z;
      for (var k = 0, re = !0; Z; )
        de[k] = Z, Z.isBuf || (re = !1), Z = Z.next, k += 1;
      de.allBuffers = re, P(L, q, !0, q.length, de, "", R.finish), q.pendingcb++, q.lastBufferedRequest = null, R.next ? (q.corkedRequestsFree = R.next, R.next = null) : q.corkedRequestsFree = new t(q), q.bufferedRequestCount = 0;
    } else {
      for (; Z; ) {
        var ne = Z.chunk, Ae = Z.encoding, C = Z.callback, v = q.objectMode ? 1 : ne.length;
        if (P(L, q, !1, v, ne, Ae, C), Z = Z.next, q.bufferedRequestCount--, q.writing)
          break;
      }
      Z === null && (q.lastBufferedRequest = null);
    }
    q.bufferedRequest = Z, q.bufferProcessing = !1;
  }
  j.prototype._write = function(L, q, Z) {
    Z(new h("_write()"));
  }, j.prototype._writev = null, j.prototype.end = function(L, q, Z) {
    var oe = this._writableState;
    return typeof L == "function" ? (Z = L, L = null, q = null) : typeof q == "function" && (Z = q, q = null), L != null && this.write(L, q), oe.corked && (oe.corked = 1, this.uncork()), oe.ending || pe(this, oe, Z), this;
  }, Object.defineProperty(j.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function H(L) {
    return L.ending && L.length === 0 && L.bufferedRequest === null && !L.finished && !L.writing;
  }
  function $(L, q) {
    L._final(function(Z) {
      q.pendingcb--, Z && O(L, Z), q.prefinished = !0, L.emit("prefinish"), he(L, q);
    });
  }
  function se(L, q) {
    !q.prefinished && !q.finalCalled && (typeof L._final == "function" && !q.destroyed ? (q.pendingcb++, q.finalCalled = !0, process.nextTick($, L, q)) : (q.prefinished = !0, L.emit("prefinish")));
  }
  function he(L, q) {
    var Z = H(q);
    if (Z && (se(L, q), q.pendingcb === 0 && (q.finished = !0, L.emit("finish"), q.autoDestroy))) {
      var oe = L._readableState;
      (!oe || oe.autoDestroy && oe.endEmitted) && L.destroy();
    }
    return Z;
  }
  function pe(L, q, Z) {
    q.ending = !0, he(L, q), Z && (q.finished ? process.nextTick(Z) : L.once("finish", Z)), q.ended = !0, L.writable = !1;
  }
  function me(L, q, Z) {
    var oe = L.entry;
    for (L.entry = null; oe; ) {
      var de = oe.callback;
      q.pendingcb--, de(Z), oe = oe.next;
    }
    q.corkedRequestsFree.next = L;
  }
  return Object.defineProperty(j.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(q) {
      this._writableState && (this._writableState.destroyed = q);
    }
  }), j.prototype.destroy = l.destroy, j.prototype._undestroy = l.undestroy, j.prototype._destroy = function(L, q) {
    q(L);
  }, Tl;
}
var Ol, Vf;
function Ai() {
  if (Vf)
    return Ol;
  Vf = 1;
  var t = Object.keys || function(c) {
    var u = [];
    for (var f in c)
      u.push(f);
    return u;
  };
  Ol = s;
  var e = R0(), r = I0();
  Wn(s, e);
  for (var n = t(r.prototype), i = 0; i < n.length; i++) {
    var o = n[i];
    s.prototype[o] || (s.prototype[o] = r.prototype[o]);
  }
  function s(c) {
    if (!(this instanceof s))
      return new s(c);
    e.call(this, c), r.call(this, c), this.allowHalfOpen = !0, c && (c.readable === !1 && (this.readable = !1), c.writable === !1 && (this.writable = !1), c.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", a)));
  }
  Object.defineProperty(s.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(s.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(s.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function a() {
    this._writableState.ended || process.nextTick(l, this);
  }
  function l(c) {
    c.end();
  }
  return Object.defineProperty(s.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(u) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = u, this._writableState.destroyed = u);
    }
  }), Ol;
}
var Il = {}, qf;
function Hf() {
  if (qf)
    return Il;
  qf = 1;
  var t = _o.Buffer, e = t.isEncoding || function(b) {
    switch (b = "" + b, b && b.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function r(b) {
    if (!b)
      return "utf8";
    for (var x; ; )
      switch (b) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return b;
        default:
          if (x)
            return;
          b = ("" + b).toLowerCase(), x = !0;
      }
  }
  function n(b) {
    var x = r(b);
    if (typeof x != "string" && (t.isEncoding === e || !e(b)))
      throw new Error("Unknown encoding: " + b);
    return x || b;
  }
  Il.StringDecoder = i;
  function i(b) {
    this.encoding = n(b);
    var x;
    switch (this.encoding) {
      case "utf16le":
        this.text = f, this.end = d, x = 4;
        break;
      case "utf8":
        this.fillLast = l, x = 4;
        break;
      case "base64":
        this.text = h, this.end = g, x = 3;
        break;
      default:
        this.write = p, this.end = y;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = t.allocUnsafe(x);
  }
  i.prototype.write = function(b) {
    if (b.length === 0)
      return "";
    var x, S;
    if (this.lastNeed) {
      if (x = this.fillLast(b), x === void 0)
        return "";
      S = this.lastNeed, this.lastNeed = 0;
    } else
      S = 0;
    return S < b.length ? x ? x + this.text(b, S) : this.text(b, S) : x || "";
  }, i.prototype.end = u, i.prototype.text = c, i.prototype.fillLast = function(b) {
    if (this.lastNeed <= b.length)
      return b.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    b.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, b.length), this.lastNeed -= b.length;
  };
  function o(b) {
    return b <= 127 ? 0 : b >> 5 === 6 ? 2 : b >> 4 === 14 ? 3 : b >> 3 === 30 ? 4 : b >> 6 === 2 ? -1 : -2;
  }
  function s(b, x, S) {
    var O = x.length - 1;
    if (O < S)
      return 0;
    var _ = o(x[O]);
    return _ >= 0 ? (_ > 0 && (b.lastNeed = _ - 1), _) : --O < S || _ === -2 ? 0 : (_ = o(x[O]), _ >= 0 ? (_ > 0 && (b.lastNeed = _ - 2), _) : --O < S || _ === -2 ? 0 : (_ = o(x[O]), _ >= 0 ? (_ > 0 && (_ === 2 ? _ = 0 : b.lastNeed = _ - 3), _) : 0));
  }
  function a(b, x, S) {
    if ((x[0] & 192) !== 128)
      return b.lastNeed = 0, "�";
    if (b.lastNeed > 1 && x.length > 1) {
      if ((x[1] & 192) !== 128)
        return b.lastNeed = 1, "�";
      if (b.lastNeed > 2 && x.length > 2 && (x[2] & 192) !== 128)
        return b.lastNeed = 2, "�";
    }
  }
  function l(b) {
    var x = this.lastTotal - this.lastNeed, S = a(this, b);
    if (S !== void 0)
      return S;
    if (this.lastNeed <= b.length)
      return b.copy(this.lastChar, x, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    b.copy(this.lastChar, x, 0, b.length), this.lastNeed -= b.length;
  }
  function c(b, x) {
    var S = s(this, b, x);
    if (!this.lastNeed)
      return b.toString("utf8", x);
    this.lastTotal = S;
    var O = b.length - (S - this.lastNeed);
    return b.copy(this.lastChar, 0, O), b.toString("utf8", x, O);
  }
  function u(b) {
    var x = b && b.length ? this.write(b) : "";
    return this.lastNeed ? x + "�" : x;
  }
  function f(b, x) {
    if ((b.length - x) % 2 === 0) {
      var S = b.toString("utf16le", x);
      if (S) {
        var O = S.charCodeAt(S.length - 1);
        if (O >= 55296 && O <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = b[b.length - 2], this.lastChar[1] = b[b.length - 1], S.slice(0, -1);
      }
      return S;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = b[b.length - 1], b.toString("utf16le", x, b.length - 1);
  }
  function d(b) {
    var x = b && b.length ? this.write(b) : "";
    if (this.lastNeed) {
      var S = this.lastTotal - this.lastNeed;
      return x + this.lastChar.toString("utf16le", 0, S);
    }
    return x;
  }
  function h(b, x) {
    var S = (b.length - x) % 3;
    return S === 0 ? b.toString("base64", x) : (this.lastNeed = 3 - S, this.lastTotal = 3, S === 1 ? this.lastChar[0] = b[b.length - 1] : (this.lastChar[0] = b[b.length - 2], this.lastChar[1] = b[b.length - 1]), b.toString("base64", x, b.length - S));
  }
  function g(b) {
    var x = b && b.length ? this.write(b) : "";
    return this.lastNeed ? x + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : x;
  }
  function p(b) {
    return b.toString(this.encoding);
  }
  function y(b) {
    return b && b.length ? this.write(b) : "";
  }
  return Il;
}
var Yf = Jn.codes.ERR_STREAM_PREMATURE_CLOSE;
function By(t) {
  var e = !1;
  return function() {
    if (!e) {
      e = !0;
      for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
        n[i] = arguments[i];
      t.apply(this, n);
    }
  };
}
function Ly() {
}
function Fy(t) {
  return t.setHeader && typeof t.abort == "function";
}
function P0(t, e, r) {
  if (typeof e == "function")
    return P0(t, null, e);
  e || (e = {}), r = By(r || Ly);
  var n = e.readable || e.readable !== !1 && t.readable, i = e.writable || e.writable !== !1 && t.writable, o = function() {
    t.writable || a();
  }, s = t._writableState && t._writableState.finished, a = function() {
    i = !1, s = !0, n || r.call(t);
  }, l = t._readableState && t._readableState.endEmitted, c = function() {
    n = !1, l = !0, i || r.call(t);
  }, u = function(g) {
    r.call(t, g);
  }, f = function() {
    var g;
    if (n && !l)
      return (!t._readableState || !t._readableState.ended) && (g = new Yf()), r.call(t, g);
    if (i && !s)
      return (!t._writableState || !t._writableState.ended) && (g = new Yf()), r.call(t, g);
  }, d = function() {
    t.req.on("finish", a);
  };
  return Fy(t) ? (t.on("complete", a), t.on("abort", f), t.req ? d() : t.on("request", d)) : i && !t._writableState && (t.on("end", o), t.on("close", o)), t.on("end", c), t.on("finish", a), e.error !== !1 && t.on("error", u), t.on("close", f), function() {
    t.removeListener("complete", a), t.removeListener("abort", f), t.removeListener("request", d), t.req && t.req.removeListener("finish", a), t.removeListener("end", o), t.removeListener("close", o), t.removeListener("finish", a), t.removeListener("end", c), t.removeListener("error", u), t.removeListener("close", f);
  };
}
var mu = P0, Pl, Kf;
function jy() {
  if (Kf)
    return Pl;
  Kf = 1;
  var t;
  function e(b, x, S) {
    return x in b ? Object.defineProperty(b, x, { value: S, enumerable: !0, configurable: !0, writable: !0 }) : b[x] = S, b;
  }
  var r = mu, n = Symbol("lastResolve"), i = Symbol("lastReject"), o = Symbol("error"), s = Symbol("ended"), a = Symbol("lastPromise"), l = Symbol("handlePromise"), c = Symbol("stream");
  function u(b, x) {
    return {
      value: b,
      done: x
    };
  }
  function f(b) {
    var x = b[n];
    if (x !== null) {
      var S = b[c].read();
      S !== null && (b[a] = null, b[n] = null, b[i] = null, x(u(S, !1)));
    }
  }
  function d(b) {
    process.nextTick(f, b);
  }
  function h(b, x) {
    return function(S, O) {
      b.then(function() {
        if (x[s]) {
          S(u(void 0, !0));
          return;
        }
        x[l](S, O);
      }, O);
    };
  }
  var g = Object.getPrototypeOf(function() {
  }), p = Object.setPrototypeOf((t = {
    get stream() {
      return this[c];
    },
    next: function() {
      var x = this, S = this[o];
      if (S !== null)
        return Promise.reject(S);
      if (this[s])
        return Promise.resolve(u(void 0, !0));
      if (this[c].destroyed)
        return new Promise(function(N, j) {
          process.nextTick(function() {
            x[o] ? j(x[o]) : N(u(void 0, !0));
          });
        });
      var O = this[a], _;
      if (O)
        _ = new Promise(h(O, this));
      else {
        var B = this[c].read();
        if (B !== null)
          return Promise.resolve(u(B, !1));
        _ = new Promise(this[l]);
      }
      return this[a] = _, _;
    }
  }, e(t, Symbol.asyncIterator, function() {
    return this;
  }), e(t, "return", function() {
    var x = this;
    return new Promise(function(S, O) {
      x[c].destroy(null, function(_) {
        if (_) {
          O(_);
          return;
        }
        S(u(void 0, !0));
      });
    });
  }), t), g), y = function(x) {
    var S, O = Object.create(p, (S = {}, e(S, c, {
      value: x,
      writable: !0
    }), e(S, n, {
      value: null,
      writable: !0
    }), e(S, i, {
      value: null,
      writable: !0
    }), e(S, o, {
      value: null,
      writable: !0
    }), e(S, s, {
      value: x._readableState.endEmitted,
      writable: !0
    }), e(S, l, {
      value: function(B, N) {
        var j = O[c].read();
        j ? (O[a] = null, O[n] = null, O[i] = null, B(u(j, !1))) : (O[n] = B, O[i] = N);
      },
      writable: !0
    }), S));
    return O[a] = null, r(x, function(_) {
      if (_ && _.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var B = O[i];
        B !== null && (O[a] = null, O[n] = null, O[i] = null, B(_)), O[o] = _;
        return;
      }
      var N = O[n];
      N !== null && (O[a] = null, O[n] = null, O[i] = null, N(u(void 0, !0))), O[s] = !0;
    }), x.on("readable", d.bind(null, O)), O;
  };
  return Pl = y, Pl;
}
var Rl, Xf;
function Wy() {
  return Xf || (Xf = 1, Rl = function() {
    throw new Error("Readable.from is not available in the browser");
  }), Rl;
}
var Dl, Jf;
function R0() {
  if (Jf)
    return Dl;
  Jf = 1, Dl = W;
  var t;
  W.ReadableState = j, vi.EventEmitter;
  var e = function(k, re) {
    return k.listeners(re).length;
  }, r = E0, n = Yo.Buffer, i = globalThis.Uint8Array || function() {
  };
  function o(R) {
    return n.from(R);
  }
  function s(R) {
    return n.isBuffer(R) || R instanceof i;
  }
  var a = k0, l;
  a && a.debuglog ? l = a.debuglog("stream") : l = function() {
  };
  var c = _y(), u = C0, f = O0, d = f.getHighWaterMark, h = Jn.codes, g = h.ERR_INVALID_ARG_TYPE, p = h.ERR_STREAM_PUSH_AFTER_EOF, y = h.ERR_METHOD_NOT_IMPLEMENTED, b = h.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, x, S, O;
  Wn(W, r);
  var _ = u.errorOrDestroy, B = ["error", "close", "destroy", "pause", "resume"];
  function N(R, k, re) {
    if (typeof R.prependListener == "function")
      return R.prependListener(k, re);
    !R._events || !R._events[k] ? R.on(k, re) : Array.isArray(R._events[k]) ? R._events[k].unshift(re) : R._events[k] = [re, R._events[k]];
  }
  function j(R, k, re) {
    t = t || Ai(), R = R || {}, typeof re != "boolean" && (re = k instanceof t), this.objectMode = !!R.objectMode, re && (this.objectMode = this.objectMode || !!R.readableObjectMode), this.highWaterMark = d(this, R, "readableHighWaterMark", re), this.buffer = new c(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = R.emitClose !== !1, this.autoDestroy = !!R.autoDestroy, this.destroyed = !1, this.defaultEncoding = R.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, R.encoding && (x || (x = Hf().StringDecoder), this.decoder = new x(R.encoding), this.encoding = R.encoding);
  }
  function W(R) {
    if (t = t || Ai(), !(this instanceof W))
      return new W(R);
    var k = this instanceof t;
    this._readableState = new j(R, this, k), this.readable = !0, R && (typeof R.read == "function" && (this._read = R.read), typeof R.destroy == "function" && (this._destroy = R.destroy)), r.call(this);
  }
  Object.defineProperty(W.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(k) {
      this._readableState && (this._readableState.destroyed = k);
    }
  }), W.prototype.destroy = u.destroy, W.prototype._undestroy = u.undestroy, W.prototype._destroy = function(R, k) {
    k(R);
  }, W.prototype.push = function(R, k) {
    var re = this._readableState, ne;
    return re.objectMode ? ne = !0 : typeof R == "string" && (k = k || re.defaultEncoding, k !== re.encoding && (R = n.from(R, k), k = ""), ne = !0), G(this, R, k, !1, ne);
  }, W.prototype.unshift = function(R) {
    return G(this, R, null, !0, !1);
  };
  function G(R, k, re, ne, Ae) {
    l("readableAddChunk", k);
    var C = R._readableState;
    if (k === null)
      C.reading = !1, I(R, C);
    else {
      var v;
      if (Ae || (v = fe(C, k)), v)
        _(R, v);
      else if (C.objectMode || k && k.length > 0)
        if (typeof k != "string" && !C.objectMode && Object.getPrototypeOf(k) !== n.prototype && (k = o(k)), ne)
          C.endEmitted ? _(R, new b()) : ee(R, C, k, !0);
        else if (C.ended)
          _(R, new p());
        else {
          if (C.destroyed)
            return !1;
          C.reading = !1, C.decoder && !re ? (k = C.decoder.write(k), C.objectMode || k.length !== 0 ? ee(R, C, k, !1) : X(R, C)) : ee(R, C, k, !1);
        }
      else
        ne || (C.reading = !1, X(R, C));
    }
    return !C.ended && (C.length < C.highWaterMark || C.length === 0);
  }
  function ee(R, k, re, ne) {
    k.flowing && k.length === 0 && !k.sync ? (k.awaitDrain = 0, R.emit("data", re)) : (k.length += k.objectMode ? 1 : re.length, ne ? k.buffer.unshift(re) : k.buffer.push(re), k.needReadable && V(R)), X(R, k);
  }
  function fe(R, k) {
    var re;
    return !s(k) && typeof k != "string" && k !== void 0 && !R.objectMode && (re = new g("chunk", ["string", "Buffer", "Uint8Array"], k)), re;
  }
  W.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, W.prototype.setEncoding = function(R) {
    x || (x = Hf().StringDecoder);
    var k = new x(R);
    this._readableState.decoder = k, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var re = this._readableState.buffer.head, ne = ""; re !== null; )
      ne += k.write(re.data), re = re.next;
    return this._readableState.buffer.clear(), ne !== "" && this._readableState.buffer.push(ne), this._readableState.length = ne.length, this;
  };
  var P = 1073741824;
  function z(R) {
    return R >= P ? R = P : (R--, R |= R >>> 1, R |= R >>> 2, R |= R >>> 4, R |= R >>> 8, R |= R >>> 16, R++), R;
  }
  function U(R, k) {
    return R <= 0 || k.length === 0 && k.ended ? 0 : k.objectMode ? 1 : R !== R ? k.flowing && k.length ? k.buffer.head.data.length : k.length : (R > k.highWaterMark && (k.highWaterMark = z(R)), R <= k.length ? R : k.ended ? k.length : (k.needReadable = !0, 0));
  }
  W.prototype.read = function(R) {
    l("read", R), R = parseInt(R, 10);
    var k = this._readableState, re = R;
    if (R !== 0 && (k.emittedReadable = !1), R === 0 && k.needReadable && ((k.highWaterMark !== 0 ? k.length >= k.highWaterMark : k.length > 0) || k.ended))
      return l("read: emitReadable", k.length, k.ended), k.length === 0 && k.ended ? Z(this) : V(this), null;
    if (R = U(R, k), R === 0 && k.ended)
      return k.length === 0 && Z(this), null;
    var ne = k.needReadable;
    l("need readable", ne), (k.length === 0 || k.length - R < k.highWaterMark) && (ne = !0, l("length less than watermark", ne)), k.ended || k.reading ? (ne = !1, l("reading or ended", ne)) : ne && (l("do read"), k.reading = !0, k.sync = !0, k.length === 0 && (k.needReadable = !0), this._read(k.highWaterMark), k.sync = !1, k.reading || (R = U(re, k)));
    var Ae;
    return R > 0 ? Ae = q(R, k) : Ae = null, Ae === null ? (k.needReadable = k.length <= k.highWaterMark, R = 0) : (k.length -= R, k.awaitDrain = 0), k.length === 0 && (k.ended || (k.needReadable = !0), re !== R && k.ended && Z(this)), Ae !== null && this.emit("data", Ae), Ae;
  };
  function I(R, k) {
    if (l("onEofChunk"), !k.ended) {
      if (k.decoder) {
        var re = k.decoder.end();
        re && re.length && (k.buffer.push(re), k.length += k.objectMode ? 1 : re.length);
      }
      k.ended = !0, k.sync ? V(R) : (k.needReadable = !1, k.emittedReadable || (k.emittedReadable = !0, te(R)));
    }
  }
  function V(R) {
    var k = R._readableState;
    l("emitReadable", k.needReadable, k.emittedReadable), k.needReadable = !1, k.emittedReadable || (l("emitReadable", k.flowing), k.emittedReadable = !0, process.nextTick(te, R));
  }
  function te(R) {
    var k = R._readableState;
    l("emitReadable_", k.destroyed, k.length, k.ended), !k.destroyed && (k.length || k.ended) && (R.emit("readable"), k.emittedReadable = !1), k.needReadable = !k.flowing && !k.ended && k.length <= k.highWaterMark, L(R);
  }
  function X(R, k) {
    k.readingMore || (k.readingMore = !0, process.nextTick(H, R, k));
  }
  function H(R, k) {
    for (; !k.reading && !k.ended && (k.length < k.highWaterMark || k.flowing && k.length === 0); ) {
      var re = k.length;
      if (l("maybeReadMore read 0"), R.read(0), re === k.length)
        break;
    }
    k.readingMore = !1;
  }
  W.prototype._read = function(R) {
    _(this, new y("_read()"));
  }, W.prototype.pipe = function(R, k) {
    var re = this, ne = this._readableState;
    switch (ne.pipesCount) {
      case 0:
        ne.pipes = R;
        break;
      case 1:
        ne.pipes = [ne.pipes, R];
        break;
      default:
        ne.pipes.push(R);
        break;
    }
    ne.pipesCount += 1, l("pipe count=%d opts=%j", ne.pipesCount, k);
    var Ae = (!k || k.end !== !1) && R !== process.stdout && R !== process.stderr, C = Ae ? w : Ne;
    ne.endEmitted ? process.nextTick(C) : re.once("end", C), R.on("unpipe", v);
    function v(E, m) {
      l("onunpipe"), E === re && m && m.hasUnpiped === !1 && (m.hasUnpiped = !0, ae());
    }
    function w() {
      l("onend"), R.end();
    }
    var D = $(re);
    R.on("drain", D);
    var J = !1;
    function ae() {
      l("cleanup"), R.removeListener("close", _e), R.removeListener("finish", we), R.removeListener("drain", D), R.removeListener("error", Se), R.removeListener("unpipe", v), re.removeListener("end", w), re.removeListener("end", Ne), re.removeListener("data", ue), J = !0, ne.awaitDrain && (!R._writableState || R._writableState.needDrain) && D();
    }
    re.on("data", ue);
    function ue(E) {
      l("ondata");
      var m = R.write(E);
      l("dest.write", m), m === !1 && ((ne.pipesCount === 1 && ne.pipes === R || ne.pipesCount > 1 && de(ne.pipes, R) !== -1) && !J && (l("false write response, pause", ne.awaitDrain), ne.awaitDrain++), re.pause());
    }
    function Se(E) {
      l("onerror", E), Ne(), R.removeListener("error", Se), e(R, "error") === 0 && _(R, E);
    }
    N(R, "error", Se);
    function _e() {
      R.removeListener("finish", we), Ne();
    }
    R.once("close", _e);
    function we() {
      l("onfinish"), R.removeListener("close", _e), Ne();
    }
    R.once("finish", we);
    function Ne() {
      l("unpipe"), re.unpipe(R);
    }
    return R.emit("pipe", re), ne.flowing || (l("pipe resume"), re.resume()), R;
  };
  function $(R) {
    return function() {
      var re = R._readableState;
      l("pipeOnDrain", re.awaitDrain), re.awaitDrain && re.awaitDrain--, re.awaitDrain === 0 && e(R, "data") && (re.flowing = !0, L(R));
    };
  }
  W.prototype.unpipe = function(R) {
    var k = this._readableState, re = {
      hasUnpiped: !1
    };
    if (k.pipesCount === 0)
      return this;
    if (k.pipesCount === 1)
      return R && R !== k.pipes ? this : (R || (R = k.pipes), k.pipes = null, k.pipesCount = 0, k.flowing = !1, R && R.emit("unpipe", this, re), this);
    if (!R) {
      var ne = k.pipes, Ae = k.pipesCount;
      k.pipes = null, k.pipesCount = 0, k.flowing = !1;
      for (var C = 0; C < Ae; C++)
        ne[C].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var v = de(k.pipes, R);
    return v === -1 ? this : (k.pipes.splice(v, 1), k.pipesCount -= 1, k.pipesCount === 1 && (k.pipes = k.pipes[0]), R.emit("unpipe", this, re), this);
  }, W.prototype.on = function(R, k) {
    var re = r.prototype.on.call(this, R, k), ne = this._readableState;
    return R === "data" ? (ne.readableListening = this.listenerCount("readable") > 0, ne.flowing !== !1 && this.resume()) : R === "readable" && !ne.endEmitted && !ne.readableListening && (ne.readableListening = ne.needReadable = !0, ne.flowing = !1, ne.emittedReadable = !1, l("on readable", ne.length, ne.reading), ne.length ? V(this) : ne.reading || process.nextTick(he, this)), re;
  }, W.prototype.addListener = W.prototype.on, W.prototype.removeListener = function(R, k) {
    var re = r.prototype.removeListener.call(this, R, k);
    return R === "readable" && process.nextTick(se, this), re;
  }, W.prototype.removeAllListeners = function(R) {
    var k = r.prototype.removeAllListeners.apply(this, arguments);
    return (R === "readable" || R === void 0) && process.nextTick(se, this), k;
  };
  function se(R) {
    var k = R._readableState;
    k.readableListening = R.listenerCount("readable") > 0, k.resumeScheduled && !k.paused ? k.flowing = !0 : R.listenerCount("data") > 0 && R.resume();
  }
  function he(R) {
    l("readable nexttick read 0"), R.read(0);
  }
  W.prototype.resume = function() {
    var R = this._readableState;
    return R.flowing || (l("resume"), R.flowing = !R.readableListening, pe(this, R)), R.paused = !1, this;
  };
  function pe(R, k) {
    k.resumeScheduled || (k.resumeScheduled = !0, process.nextTick(me, R, k));
  }
  function me(R, k) {
    l("resume", k.reading), k.reading || R.read(0), k.resumeScheduled = !1, R.emit("resume"), L(R), k.flowing && !k.reading && R.read(0);
  }
  W.prototype.pause = function() {
    return l("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (l("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function L(R) {
    var k = R._readableState;
    for (l("flow", k.flowing); k.flowing && R.read() !== null; )
      ;
  }
  W.prototype.wrap = function(R) {
    var k = this, re = this._readableState, ne = !1;
    R.on("end", function() {
      if (l("wrapped end"), re.decoder && !re.ended) {
        var v = re.decoder.end();
        v && v.length && k.push(v);
      }
      k.push(null);
    }), R.on("data", function(v) {
      if (l("wrapped data"), re.decoder && (v = re.decoder.write(v)), !(re.objectMode && v == null) && !(!re.objectMode && (!v || !v.length))) {
        var w = k.push(v);
        w || (ne = !0, R.pause());
      }
    });
    for (var Ae in R)
      this[Ae] === void 0 && typeof R[Ae] == "function" && (this[Ae] = function(w) {
        return function() {
          return R[w].apply(R, arguments);
        };
      }(Ae));
    for (var C = 0; C < B.length; C++)
      R.on(B[C], this.emit.bind(this, B[C]));
    return this._read = function(v) {
      l("wrapped _read", v), ne && (ne = !1, R.resume());
    }, this;
  }, typeof Symbol == "function" && (W.prototype[Symbol.asyncIterator] = function() {
    return S === void 0 && (S = jy()), S(this);
  }), Object.defineProperty(W.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(W.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(W.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(k) {
      this._readableState && (this._readableState.flowing = k);
    }
  }), W._fromList = q, Object.defineProperty(W.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function q(R, k) {
    if (k.length === 0)
      return null;
    var re;
    return k.objectMode ? re = k.buffer.shift() : !R || R >= k.length ? (k.decoder ? re = k.buffer.join("") : k.buffer.length === 1 ? re = k.buffer.first() : re = k.buffer.concat(k.length), k.buffer.clear()) : re = k.buffer.consume(R, k.decoder), re;
  }
  function Z(R) {
    var k = R._readableState;
    l("endReadable", k.endEmitted), k.endEmitted || (k.ended = !0, process.nextTick(oe, k, R));
  }
  function oe(R, k) {
    if (l("endReadableNT", R.endEmitted, R.length), !R.endEmitted && R.length === 0 && (R.endEmitted = !0, k.readable = !1, k.emit("end"), R.autoDestroy)) {
      var re = k._writableState;
      (!re || re.autoDestroy && re.finished) && k.destroy();
    }
  }
  typeof Symbol == "function" && (W.from = function(R, k) {
    return O === void 0 && (O = Wy()), O(W, R, k);
  });
  function de(R, k) {
    for (var re = 0, ne = R.length; re < ne; re++)
      if (R[re] === k)
        return re;
    return -1;
  }
  return Dl;
}
var D0 = qr, La = Jn.codes, Uy = La.ERR_METHOD_NOT_IMPLEMENTED, zy = La.ERR_MULTIPLE_CALLBACK, Vy = La.ERR_TRANSFORM_ALREADY_TRANSFORMING, qy = La.ERR_TRANSFORM_WITH_LENGTH_0, Fa = Ai();
Wn(qr, Fa);
function Hy(t, e) {
  var r = this._transformState;
  r.transforming = !1;
  var n = r.writecb;
  if (n === null)
    return this.emit("error", new zy());
  r.writechunk = null, r.writecb = null, e != null && this.push(e), n(t);
  var i = this._readableState;
  i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
}
function qr(t) {
  if (!(this instanceof qr))
    return new qr(t);
  Fa.call(this, t), this._transformState = {
    afterTransform: Hy.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.on("prefinish", Yy);
}
function Yy() {
  var t = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(e, r) {
    Qf(t, e, r);
  }) : Qf(this, null, null);
}
qr.prototype.push = function(t, e) {
  return this._transformState.needTransform = !1, Fa.prototype.push.call(this, t, e);
};
qr.prototype._transform = function(t, e, r) {
  r(new Uy("_transform()"));
};
qr.prototype._write = function(t, e, r) {
  var n = this._transformState;
  if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
qr.prototype._read = function(t) {
  var e = this._transformState;
  e.writechunk !== null && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
qr.prototype._destroy = function(t, e) {
  Fa.prototype._destroy.call(this, t, function(r) {
    e(r);
  });
};
function Qf(t, e, r) {
  if (e)
    return t.emit("error", e);
  if (r != null && t.push(r), t._writableState.length)
    throw new qy();
  if (t._transformState.transforming)
    throw new Vy();
  return t.push(null);
}
var Ky = So, M0 = D0;
Wn(So, M0);
function So(t) {
  if (!(this instanceof So))
    return new So(t);
  M0.call(this, t);
}
So.prototype._transform = function(t, e, r) {
  r(null, t);
};
var Ml;
function Xy(t) {
  var e = !1;
  return function() {
    e || (e = !0, t.apply(void 0, arguments));
  };
}
var N0 = Jn.codes, Jy = N0.ERR_MISSING_ARGS, Qy = N0.ERR_STREAM_DESTROYED;
function Gf(t) {
  if (t)
    throw t;
}
function Gy(t) {
  return t.setHeader && typeof t.abort == "function";
}
function Zy(t, e, r, n) {
  n = Xy(n);
  var i = !1;
  t.on("close", function() {
    i = !0;
  }), Ml === void 0 && (Ml = mu), Ml(t, {
    readable: e,
    writable: r
  }, function(s) {
    if (s)
      return n(s);
    i = !0, n();
  });
  var o = !1;
  return function(s) {
    if (!i && !o) {
      if (o = !0, Gy(t))
        return t.abort();
      if (typeof t.destroy == "function")
        return t.destroy();
      n(s || new Qy("pipe"));
    }
  };
}
function Zf(t) {
  t();
}
function $y(t, e) {
  return t.pipe(e);
}
function eb(t) {
  return !t.length || typeof t[t.length - 1] != "function" ? Gf : t.pop();
}
function tb() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var n = eb(e);
  if (Array.isArray(e[0]) && (e = e[0]), e.length < 2)
    throw new Jy("streams");
  var i, o = e.map(function(s, a) {
    var l = a < e.length - 1, c = a > 0;
    return Zy(s, l, c, function(u) {
      i || (i = u), u && o.forEach(Zf), !l && (o.forEach(Zf), n(i));
    });
  });
  return e.reduce($y);
}
var rb = tb;
(function(t, e) {
  e = t.exports = R0(), e.Stream = e, e.Readable = e, e.Writable = I0(), e.Duplex = Ai(), e.Transform = D0, e.PassThrough = Ky, e.finished = mu, e.pipeline = rb;
})(Ay, sa);
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
let $f;
var nb = typeof queueMicrotask == "function" ? queueMicrotask.bind(typeof window < "u" ? window : globalThis) : (t) => ($f || ($f = Promise.resolve())).then(t).catch((e) => setTimeout(() => {
  throw e;
}, 0));
function ed(t, e) {
  for (const r in e)
    Object.defineProperty(t, r, {
      value: e[r],
      enumerable: !0,
      configurable: !0
    });
  return t;
}
function ib(t, e, r) {
  if (!t || typeof t == "string")
    throw new TypeError("Please pass an Error to err-code");
  r || (r = {}), typeof e == "object" && (r = e, e = ""), e && (r.code = e);
  try {
    return ed(t, r);
  } catch {
    r.message = t.message, r.stack = t.stack;
    const i = function() {
    };
    return i.prototype = Object.create(Object.getPrototypeOf(t)), ed(new i(), r);
  }
}
var ob = ib, B0 = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  const e = Ko, r = Ba, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = a, t.SlowBuffer = x, t.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  t.kMaxLength = i, a.TYPED_ARRAY_SUPPORT = o(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function o() {
    try {
      const E = new Uint8Array(1), m = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(m, Uint8Array.prototype), Object.setPrototypeOf(E, m), E.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(a.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(a.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.byteOffset;
    }
  });
  function s(E) {
    if (E > i)
      throw new RangeError('The value "' + E + '" is invalid for option "size"');
    const m = new Uint8Array(E);
    return Object.setPrototypeOf(m, a.prototype), m;
  }
  function a(E, m, A) {
    if (typeof E == "number") {
      if (typeof m == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return f(E);
    }
    return l(E, m, A);
  }
  a.poolSize = 8192;
  function l(E, m, A) {
    if (typeof E == "string")
      return d(E, m);
    if (ArrayBuffer.isView(E))
      return g(E);
    if (E == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof E
      );
    if (ue(E, ArrayBuffer) || E && ue(E.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ue(E, SharedArrayBuffer) || E && ue(E.buffer, SharedArrayBuffer)))
      return p(E, m, A);
    if (typeof E == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const M = E.valueOf && E.valueOf();
    if (M != null && M !== E)
      return a.from(M, m, A);
    const Q = y(E);
    if (Q)
      return Q;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof E[Symbol.toPrimitive] == "function")
      return a.from(E[Symbol.toPrimitive]("string"), m, A);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof E
    );
  }
  a.from = function(E, m, A) {
    return l(E, m, A);
  }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
  function c(E) {
    if (typeof E != "number")
      throw new TypeError('"size" argument must be of type number');
    if (E < 0)
      throw new RangeError('The value "' + E + '" is invalid for option "size"');
  }
  function u(E, m, A) {
    return c(E), E <= 0 ? s(E) : m !== void 0 ? typeof A == "string" ? s(E).fill(m, A) : s(E).fill(m) : s(E);
  }
  a.alloc = function(E, m, A) {
    return u(E, m, A);
  };
  function f(E) {
    return c(E), s(E < 0 ? 0 : b(E) | 0);
  }
  a.allocUnsafe = function(E) {
    return f(E);
  }, a.allocUnsafeSlow = function(E) {
    return f(E);
  };
  function d(E, m) {
    if ((typeof m != "string" || m === "") && (m = "utf8"), !a.isEncoding(m))
      throw new TypeError("Unknown encoding: " + m);
    const A = S(E, m) | 0;
    let M = s(A);
    const Q = M.write(E, m);
    return Q !== A && (M = M.slice(0, Q)), M;
  }
  function h(E) {
    const m = E.length < 0 ? 0 : b(E.length) | 0, A = s(m);
    for (let M = 0; M < m; M += 1)
      A[M] = E[M] & 255;
    return A;
  }
  function g(E) {
    if (ue(E, Uint8Array)) {
      const m = new Uint8Array(E);
      return p(m.buffer, m.byteOffset, m.byteLength);
    }
    return h(E);
  }
  function p(E, m, A) {
    if (m < 0 || E.byteLength < m)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (E.byteLength < m + (A || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let M;
    return m === void 0 && A === void 0 ? M = new Uint8Array(E) : A === void 0 ? M = new Uint8Array(E, m) : M = new Uint8Array(E, m, A), Object.setPrototypeOf(M, a.prototype), M;
  }
  function y(E) {
    if (a.isBuffer(E)) {
      const m = b(E.length) | 0, A = s(m);
      return A.length === 0 || E.copy(A, 0, 0, m), A;
    }
    if (E.length !== void 0)
      return typeof E.length != "number" || Se(E.length) ? s(0) : h(E);
    if (E.type === "Buffer" && Array.isArray(E.data))
      return h(E.data);
  }
  function b(E) {
    if (E >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return E | 0;
  }
  function x(E) {
    return +E != E && (E = 0), a.alloc(+E);
  }
  a.isBuffer = function(m) {
    return m != null && m._isBuffer === !0 && m !== a.prototype;
  }, a.compare = function(m, A) {
    if (ue(m, Uint8Array) && (m = a.from(m, m.offset, m.byteLength)), ue(A, Uint8Array) && (A = a.from(A, A.offset, A.byteLength)), !a.isBuffer(m) || !a.isBuffer(A))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (m === A)
      return 0;
    let M = m.length, Q = A.length;
    for (let ie = 0, le = Math.min(M, Q); ie < le; ++ie)
      if (m[ie] !== A[ie]) {
        M = m[ie], Q = A[ie];
        break;
      }
    return M < Q ? -1 : Q < M ? 1 : 0;
  }, a.isEncoding = function(m) {
    switch (String(m).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, a.concat = function(m, A) {
    if (!Array.isArray(m))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (m.length === 0)
      return a.alloc(0);
    let M;
    if (A === void 0)
      for (A = 0, M = 0; M < m.length; ++M)
        A += m[M].length;
    const Q = a.allocUnsafe(A);
    let ie = 0;
    for (M = 0; M < m.length; ++M) {
      let le = m[M];
      if (ue(le, Uint8Array))
        ie + le.length > Q.length ? (a.isBuffer(le) || (le = a.from(le)), le.copy(Q, ie)) : Uint8Array.prototype.set.call(
          Q,
          le,
          ie
        );
      else if (a.isBuffer(le))
        le.copy(Q, ie);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      ie += le.length;
    }
    return Q;
  };
  function S(E, m) {
    if (a.isBuffer(E))
      return E.length;
    if (ArrayBuffer.isView(E) || ue(E, ArrayBuffer))
      return E.byteLength;
    if (typeof E != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof E
      );
    const A = E.length, M = arguments.length > 2 && arguments[2] === !0;
    if (!M && A === 0)
      return 0;
    let Q = !1;
    for (; ; )
      switch (m) {
        case "ascii":
        case "latin1":
        case "binary":
          return A;
        case "utf8":
        case "utf-8":
          return v(E).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return A * 2;
        case "hex":
          return A >>> 1;
        case "base64":
          return J(E).length;
        default:
          if (Q)
            return M ? -1 : v(E).length;
          m = ("" + m).toLowerCase(), Q = !0;
      }
  }
  a.byteLength = S;
  function O(E, m, A) {
    let M = !1;
    if ((m === void 0 || m < 0) && (m = 0), m > this.length || ((A === void 0 || A > this.length) && (A = this.length), A <= 0) || (A >>>= 0, m >>>= 0, A <= m))
      return "";
    for (E || (E = "utf8"); ; )
      switch (E) {
        case "hex":
          return X(this, m, A);
        case "utf8":
        case "utf-8":
          return z(this, m, A);
        case "ascii":
          return V(this, m, A);
        case "latin1":
        case "binary":
          return te(this, m, A);
        case "base64":
          return P(this, m, A);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return H(this, m, A);
        default:
          if (M)
            throw new TypeError("Unknown encoding: " + E);
          E = (E + "").toLowerCase(), M = !0;
      }
  }
  a.prototype._isBuffer = !0;
  function _(E, m, A) {
    const M = E[m];
    E[m] = E[A], E[A] = M;
  }
  a.prototype.swap16 = function() {
    const m = this.length;
    if (m % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let A = 0; A < m; A += 2)
      _(this, A, A + 1);
    return this;
  }, a.prototype.swap32 = function() {
    const m = this.length;
    if (m % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let A = 0; A < m; A += 4)
      _(this, A, A + 3), _(this, A + 1, A + 2);
    return this;
  }, a.prototype.swap64 = function() {
    const m = this.length;
    if (m % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let A = 0; A < m; A += 8)
      _(this, A, A + 7), _(this, A + 1, A + 6), _(this, A + 2, A + 5), _(this, A + 3, A + 4);
    return this;
  }, a.prototype.toString = function() {
    const m = this.length;
    return m === 0 ? "" : arguments.length === 0 ? z(this, 0, m) : O.apply(this, arguments);
  }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(m) {
    if (!a.isBuffer(m))
      throw new TypeError("Argument must be a Buffer");
    return this === m ? !0 : a.compare(this, m) === 0;
  }, a.prototype.inspect = function() {
    let m = "";
    const A = t.INSPECT_MAX_BYTES;
    return m = this.toString("hex", 0, A).replace(/(.{2})/g, "$1 ").trim(), this.length > A && (m += " ... "), "<Buffer " + m + ">";
  }, n && (a.prototype[n] = a.prototype.inspect), a.prototype.compare = function(m, A, M, Q, ie) {
    if (ue(m, Uint8Array) && (m = a.from(m, m.offset, m.byteLength)), !a.isBuffer(m))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof m
      );
    if (A === void 0 && (A = 0), M === void 0 && (M = m ? m.length : 0), Q === void 0 && (Q = 0), ie === void 0 && (ie = this.length), A < 0 || M > m.length || Q < 0 || ie > this.length)
      throw new RangeError("out of range index");
    if (Q >= ie && A >= M)
      return 0;
    if (Q >= ie)
      return -1;
    if (A >= M)
      return 1;
    if (A >>>= 0, M >>>= 0, Q >>>= 0, ie >>>= 0, this === m)
      return 0;
    let le = ie - Q, Ee = M - A;
    const Fe = Math.min(le, Ee), Ve = this.slice(Q, ie), Ge = m.slice(A, M);
    for (let Ue = 0; Ue < Fe; ++Ue)
      if (Ve[Ue] !== Ge[Ue]) {
        le = Ve[Ue], Ee = Ge[Ue];
        break;
      }
    return le < Ee ? -1 : Ee < le ? 1 : 0;
  };
  function B(E, m, A, M, Q) {
    if (E.length === 0)
      return -1;
    if (typeof A == "string" ? (M = A, A = 0) : A > 2147483647 ? A = 2147483647 : A < -2147483648 && (A = -2147483648), A = +A, Se(A) && (A = Q ? 0 : E.length - 1), A < 0 && (A = E.length + A), A >= E.length) {
      if (Q)
        return -1;
      A = E.length - 1;
    } else if (A < 0)
      if (Q)
        A = 0;
      else
        return -1;
    if (typeof m == "string" && (m = a.from(m, M)), a.isBuffer(m))
      return m.length === 0 ? -1 : N(E, m, A, M, Q);
    if (typeof m == "number")
      return m = m & 255, typeof Uint8Array.prototype.indexOf == "function" ? Q ? Uint8Array.prototype.indexOf.call(E, m, A) : Uint8Array.prototype.lastIndexOf.call(E, m, A) : N(E, [m], A, M, Q);
    throw new TypeError("val must be string, number or Buffer");
  }
  function N(E, m, A, M, Q) {
    let ie = 1, le = E.length, Ee = m.length;
    if (M !== void 0 && (M = String(M).toLowerCase(), M === "ucs2" || M === "ucs-2" || M === "utf16le" || M === "utf-16le")) {
      if (E.length < 2 || m.length < 2)
        return -1;
      ie = 2, le /= 2, Ee /= 2, A /= 2;
    }
    function Fe(Ge, Ue) {
      return ie === 1 ? Ge[Ue] : Ge.readUInt16BE(Ue * ie);
    }
    let Ve;
    if (Q) {
      let Ge = -1;
      for (Ve = A; Ve < le; Ve++)
        if (Fe(E, Ve) === Fe(m, Ge === -1 ? 0 : Ve - Ge)) {
          if (Ge === -1 && (Ge = Ve), Ve - Ge + 1 === Ee)
            return Ge * ie;
        } else
          Ge !== -1 && (Ve -= Ve - Ge), Ge = -1;
    } else
      for (A + Ee > le && (A = le - Ee), Ve = A; Ve >= 0; Ve--) {
        let Ge = !0;
        for (let Ue = 0; Ue < Ee; Ue++)
          if (Fe(E, Ve + Ue) !== Fe(m, Ue)) {
            Ge = !1;
            break;
          }
        if (Ge)
          return Ve;
      }
    return -1;
  }
  a.prototype.includes = function(m, A, M) {
    return this.indexOf(m, A, M) !== -1;
  }, a.prototype.indexOf = function(m, A, M) {
    return B(this, m, A, M, !0);
  }, a.prototype.lastIndexOf = function(m, A, M) {
    return B(this, m, A, M, !1);
  };
  function j(E, m, A, M) {
    A = Number(A) || 0;
    const Q = E.length - A;
    M ? (M = Number(M), M > Q && (M = Q)) : M = Q;
    const ie = m.length;
    M > ie / 2 && (M = ie / 2);
    let le;
    for (le = 0; le < M; ++le) {
      const Ee = parseInt(m.substr(le * 2, 2), 16);
      if (Se(Ee))
        return le;
      E[A + le] = Ee;
    }
    return le;
  }
  function W(E, m, A, M) {
    return ae(v(m, E.length - A), E, A, M);
  }
  function G(E, m, A, M) {
    return ae(w(m), E, A, M);
  }
  function ee(E, m, A, M) {
    return ae(J(m), E, A, M);
  }
  function fe(E, m, A, M) {
    return ae(D(m, E.length - A), E, A, M);
  }
  a.prototype.write = function(m, A, M, Q) {
    if (A === void 0)
      Q = "utf8", M = this.length, A = 0;
    else if (M === void 0 && typeof A == "string")
      Q = A, M = this.length, A = 0;
    else if (isFinite(A))
      A = A >>> 0, isFinite(M) ? (M = M >>> 0, Q === void 0 && (Q = "utf8")) : (Q = M, M = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const ie = this.length - A;
    if ((M === void 0 || M > ie) && (M = ie), m.length > 0 && (M < 0 || A < 0) || A > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Q || (Q = "utf8");
    let le = !1;
    for (; ; )
      switch (Q) {
        case "hex":
          return j(this, m, A, M);
        case "utf8":
        case "utf-8":
          return W(this, m, A, M);
        case "ascii":
        case "latin1":
        case "binary":
          return G(this, m, A, M);
        case "base64":
          return ee(this, m, A, M);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return fe(this, m, A, M);
        default:
          if (le)
            throw new TypeError("Unknown encoding: " + Q);
          Q = ("" + Q).toLowerCase(), le = !0;
      }
  }, a.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function P(E, m, A) {
    return m === 0 && A === E.length ? e.fromByteArray(E) : e.fromByteArray(E.slice(m, A));
  }
  function z(E, m, A) {
    A = Math.min(E.length, A);
    const M = [];
    let Q = m;
    for (; Q < A; ) {
      const ie = E[Q];
      let le = null, Ee = ie > 239 ? 4 : ie > 223 ? 3 : ie > 191 ? 2 : 1;
      if (Q + Ee <= A) {
        let Fe, Ve, Ge, Ue;
        switch (Ee) {
          case 1:
            ie < 128 && (le = ie);
            break;
          case 2:
            Fe = E[Q + 1], (Fe & 192) === 128 && (Ue = (ie & 31) << 6 | Fe & 63, Ue > 127 && (le = Ue));
            break;
          case 3:
            Fe = E[Q + 1], Ve = E[Q + 2], (Fe & 192) === 128 && (Ve & 192) === 128 && (Ue = (ie & 15) << 12 | (Fe & 63) << 6 | Ve & 63, Ue > 2047 && (Ue < 55296 || Ue > 57343) && (le = Ue));
            break;
          case 4:
            Fe = E[Q + 1], Ve = E[Q + 2], Ge = E[Q + 3], (Fe & 192) === 128 && (Ve & 192) === 128 && (Ge & 192) === 128 && (Ue = (ie & 15) << 18 | (Fe & 63) << 12 | (Ve & 63) << 6 | Ge & 63, Ue > 65535 && Ue < 1114112 && (le = Ue));
        }
      }
      le === null ? (le = 65533, Ee = 1) : le > 65535 && (le -= 65536, M.push(le >>> 10 & 1023 | 55296), le = 56320 | le & 1023), M.push(le), Q += Ee;
    }
    return I(M);
  }
  const U = 4096;
  function I(E) {
    const m = E.length;
    if (m <= U)
      return String.fromCharCode.apply(String, E);
    let A = "", M = 0;
    for (; M < m; )
      A += String.fromCharCode.apply(
        String,
        E.slice(M, M += U)
      );
    return A;
  }
  function V(E, m, A) {
    let M = "";
    A = Math.min(E.length, A);
    for (let Q = m; Q < A; ++Q)
      M += String.fromCharCode(E[Q] & 127);
    return M;
  }
  function te(E, m, A) {
    let M = "";
    A = Math.min(E.length, A);
    for (let Q = m; Q < A; ++Q)
      M += String.fromCharCode(E[Q]);
    return M;
  }
  function X(E, m, A) {
    const M = E.length;
    (!m || m < 0) && (m = 0), (!A || A < 0 || A > M) && (A = M);
    let Q = "";
    for (let ie = m; ie < A; ++ie)
      Q += _e[E[ie]];
    return Q;
  }
  function H(E, m, A) {
    const M = E.slice(m, A);
    let Q = "";
    for (let ie = 0; ie < M.length - 1; ie += 2)
      Q += String.fromCharCode(M[ie] + M[ie + 1] * 256);
    return Q;
  }
  a.prototype.slice = function(m, A) {
    const M = this.length;
    m = ~~m, A = A === void 0 ? M : ~~A, m < 0 ? (m += M, m < 0 && (m = 0)) : m > M && (m = M), A < 0 ? (A += M, A < 0 && (A = 0)) : A > M && (A = M), A < m && (A = m);
    const Q = this.subarray(m, A);
    return Object.setPrototypeOf(Q, a.prototype), Q;
  };
  function $(E, m, A) {
    if (E % 1 !== 0 || E < 0)
      throw new RangeError("offset is not uint");
    if (E + m > A)
      throw new RangeError("Trying to access beyond buffer length");
  }
  a.prototype.readUintLE = a.prototype.readUIntLE = function(m, A, M) {
    m = m >>> 0, A = A >>> 0, M || $(m, A, this.length);
    let Q = this[m], ie = 1, le = 0;
    for (; ++le < A && (ie *= 256); )
      Q += this[m + le] * ie;
    return Q;
  }, a.prototype.readUintBE = a.prototype.readUIntBE = function(m, A, M) {
    m = m >>> 0, A = A >>> 0, M || $(m, A, this.length);
    let Q = this[m + --A], ie = 1;
    for (; A > 0 && (ie *= 256); )
      Q += this[m + --A] * ie;
    return Q;
  }, a.prototype.readUint8 = a.prototype.readUInt8 = function(m, A) {
    return m = m >>> 0, A || $(m, 1, this.length), this[m];
  }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(m, A) {
    return m = m >>> 0, A || $(m, 2, this.length), this[m] | this[m + 1] << 8;
  }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(m, A) {
    return m = m >>> 0, A || $(m, 2, this.length), this[m] << 8 | this[m + 1];
  }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(m, A) {
    return m = m >>> 0, A || $(m, 4, this.length), (this[m] | this[m + 1] << 8 | this[m + 2] << 16) + this[m + 3] * 16777216;
  }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(m, A) {
    return m = m >>> 0, A || $(m, 4, this.length), this[m] * 16777216 + (this[m + 1] << 16 | this[m + 2] << 8 | this[m + 3]);
  }, a.prototype.readBigUInt64LE = we(function(m) {
    m = m >>> 0, re(m, "offset");
    const A = this[m], M = this[m + 7];
    (A === void 0 || M === void 0) && ne(m, this.length - 8);
    const Q = A + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + this[++m] * 2 ** 24, ie = this[++m] + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + M * 2 ** 24;
    return BigInt(Q) + (BigInt(ie) << BigInt(32));
  }), a.prototype.readBigUInt64BE = we(function(m) {
    m = m >>> 0, re(m, "offset");
    const A = this[m], M = this[m + 7];
    (A === void 0 || M === void 0) && ne(m, this.length - 8);
    const Q = A * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + this[++m], ie = this[++m] * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + M;
    return (BigInt(Q) << BigInt(32)) + BigInt(ie);
  }), a.prototype.readIntLE = function(m, A, M) {
    m = m >>> 0, A = A >>> 0, M || $(m, A, this.length);
    let Q = this[m], ie = 1, le = 0;
    for (; ++le < A && (ie *= 256); )
      Q += this[m + le] * ie;
    return ie *= 128, Q >= ie && (Q -= Math.pow(2, 8 * A)), Q;
  }, a.prototype.readIntBE = function(m, A, M) {
    m = m >>> 0, A = A >>> 0, M || $(m, A, this.length);
    let Q = A, ie = 1, le = this[m + --Q];
    for (; Q > 0 && (ie *= 256); )
      le += this[m + --Q] * ie;
    return ie *= 128, le >= ie && (le -= Math.pow(2, 8 * A)), le;
  }, a.prototype.readInt8 = function(m, A) {
    return m = m >>> 0, A || $(m, 1, this.length), this[m] & 128 ? (255 - this[m] + 1) * -1 : this[m];
  }, a.prototype.readInt16LE = function(m, A) {
    m = m >>> 0, A || $(m, 2, this.length);
    const M = this[m] | this[m + 1] << 8;
    return M & 32768 ? M | 4294901760 : M;
  }, a.prototype.readInt16BE = function(m, A) {
    m = m >>> 0, A || $(m, 2, this.length);
    const M = this[m + 1] | this[m] << 8;
    return M & 32768 ? M | 4294901760 : M;
  }, a.prototype.readInt32LE = function(m, A) {
    return m = m >>> 0, A || $(m, 4, this.length), this[m] | this[m + 1] << 8 | this[m + 2] << 16 | this[m + 3] << 24;
  }, a.prototype.readInt32BE = function(m, A) {
    return m = m >>> 0, A || $(m, 4, this.length), this[m] << 24 | this[m + 1] << 16 | this[m + 2] << 8 | this[m + 3];
  }, a.prototype.readBigInt64LE = we(function(m) {
    m = m >>> 0, re(m, "offset");
    const A = this[m], M = this[m + 7];
    (A === void 0 || M === void 0) && ne(m, this.length - 8);
    const Q = this[m + 4] + this[m + 5] * 2 ** 8 + this[m + 6] * 2 ** 16 + (M << 24);
    return (BigInt(Q) << BigInt(32)) + BigInt(A + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + this[++m] * 2 ** 24);
  }), a.prototype.readBigInt64BE = we(function(m) {
    m = m >>> 0, re(m, "offset");
    const A = this[m], M = this[m + 7];
    (A === void 0 || M === void 0) && ne(m, this.length - 8);
    const Q = (A << 24) + // Overflow
    this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + this[++m];
    return (BigInt(Q) << BigInt(32)) + BigInt(this[++m] * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + M);
  }), a.prototype.readFloatLE = function(m, A) {
    return m = m >>> 0, A || $(m, 4, this.length), r.read(this, m, !0, 23, 4);
  }, a.prototype.readFloatBE = function(m, A) {
    return m = m >>> 0, A || $(m, 4, this.length), r.read(this, m, !1, 23, 4);
  }, a.prototype.readDoubleLE = function(m, A) {
    return m = m >>> 0, A || $(m, 8, this.length), r.read(this, m, !0, 52, 8);
  }, a.prototype.readDoubleBE = function(m, A) {
    return m = m >>> 0, A || $(m, 8, this.length), r.read(this, m, !1, 52, 8);
  };
  function se(E, m, A, M, Q, ie) {
    if (!a.isBuffer(E))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (m > Q || m < ie)
      throw new RangeError('"value" argument is out of bounds');
    if (A + M > E.length)
      throw new RangeError("Index out of range");
  }
  a.prototype.writeUintLE = a.prototype.writeUIntLE = function(m, A, M, Q) {
    if (m = +m, A = A >>> 0, M = M >>> 0, !Q) {
      const Ee = Math.pow(2, 8 * M) - 1;
      se(this, m, A, M, Ee, 0);
    }
    let ie = 1, le = 0;
    for (this[A] = m & 255; ++le < M && (ie *= 256); )
      this[A + le] = m / ie & 255;
    return A + M;
  }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(m, A, M, Q) {
    if (m = +m, A = A >>> 0, M = M >>> 0, !Q) {
      const Ee = Math.pow(2, 8 * M) - 1;
      se(this, m, A, M, Ee, 0);
    }
    let ie = M - 1, le = 1;
    for (this[A + ie] = m & 255; --ie >= 0 && (le *= 256); )
      this[A + ie] = m / le & 255;
    return A + M;
  }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 1, 255, 0), this[A] = m & 255, A + 1;
  }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 2, 65535, 0), this[A] = m & 255, this[A + 1] = m >>> 8, A + 2;
  }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 2, 65535, 0), this[A] = m >>> 8, this[A + 1] = m & 255, A + 2;
  }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 4, 4294967295, 0), this[A + 3] = m >>> 24, this[A + 2] = m >>> 16, this[A + 1] = m >>> 8, this[A] = m & 255, A + 4;
  }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 4, 4294967295, 0), this[A] = m >>> 24, this[A + 1] = m >>> 16, this[A + 2] = m >>> 8, this[A + 3] = m & 255, A + 4;
  };
  function he(E, m, A, M, Q) {
    k(m, M, Q, E, A, 7);
    let ie = Number(m & BigInt(4294967295));
    E[A++] = ie, ie = ie >> 8, E[A++] = ie, ie = ie >> 8, E[A++] = ie, ie = ie >> 8, E[A++] = ie;
    let le = Number(m >> BigInt(32) & BigInt(4294967295));
    return E[A++] = le, le = le >> 8, E[A++] = le, le = le >> 8, E[A++] = le, le = le >> 8, E[A++] = le, A;
  }
  function pe(E, m, A, M, Q) {
    k(m, M, Q, E, A, 7);
    let ie = Number(m & BigInt(4294967295));
    E[A + 7] = ie, ie = ie >> 8, E[A + 6] = ie, ie = ie >> 8, E[A + 5] = ie, ie = ie >> 8, E[A + 4] = ie;
    let le = Number(m >> BigInt(32) & BigInt(4294967295));
    return E[A + 3] = le, le = le >> 8, E[A + 2] = le, le = le >> 8, E[A + 1] = le, le = le >> 8, E[A] = le, A + 8;
  }
  a.prototype.writeBigUInt64LE = we(function(m, A = 0) {
    return he(this, m, A, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeBigUInt64BE = we(function(m, A = 0) {
    return pe(this, m, A, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeIntLE = function(m, A, M, Q) {
    if (m = +m, A = A >>> 0, !Q) {
      const Fe = Math.pow(2, 8 * M - 1);
      se(this, m, A, M, Fe - 1, -Fe);
    }
    let ie = 0, le = 1, Ee = 0;
    for (this[A] = m & 255; ++ie < M && (le *= 256); )
      m < 0 && Ee === 0 && this[A + ie - 1] !== 0 && (Ee = 1), this[A + ie] = (m / le >> 0) - Ee & 255;
    return A + M;
  }, a.prototype.writeIntBE = function(m, A, M, Q) {
    if (m = +m, A = A >>> 0, !Q) {
      const Fe = Math.pow(2, 8 * M - 1);
      se(this, m, A, M, Fe - 1, -Fe);
    }
    let ie = M - 1, le = 1, Ee = 0;
    for (this[A + ie] = m & 255; --ie >= 0 && (le *= 256); )
      m < 0 && Ee === 0 && this[A + ie + 1] !== 0 && (Ee = 1), this[A + ie] = (m / le >> 0) - Ee & 255;
    return A + M;
  }, a.prototype.writeInt8 = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 1, 127, -128), m < 0 && (m = 255 + m + 1), this[A] = m & 255, A + 1;
  }, a.prototype.writeInt16LE = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 2, 32767, -32768), this[A] = m & 255, this[A + 1] = m >>> 8, A + 2;
  }, a.prototype.writeInt16BE = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 2, 32767, -32768), this[A] = m >>> 8, this[A + 1] = m & 255, A + 2;
  }, a.prototype.writeInt32LE = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 4, 2147483647, -2147483648), this[A] = m & 255, this[A + 1] = m >>> 8, this[A + 2] = m >>> 16, this[A + 3] = m >>> 24, A + 4;
  }, a.prototype.writeInt32BE = function(m, A, M) {
    return m = +m, A = A >>> 0, M || se(this, m, A, 4, 2147483647, -2147483648), m < 0 && (m = 4294967295 + m + 1), this[A] = m >>> 24, this[A + 1] = m >>> 16, this[A + 2] = m >>> 8, this[A + 3] = m & 255, A + 4;
  }, a.prototype.writeBigInt64LE = we(function(m, A = 0) {
    return he(this, m, A, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), a.prototype.writeBigInt64BE = we(function(m, A = 0) {
    return pe(this, m, A, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function me(E, m, A, M, Q, ie) {
    if (A + M > E.length)
      throw new RangeError("Index out of range");
    if (A < 0)
      throw new RangeError("Index out of range");
  }
  function L(E, m, A, M, Q) {
    return m = +m, A = A >>> 0, Q || me(E, m, A, 4), r.write(E, m, A, M, 23, 4), A + 4;
  }
  a.prototype.writeFloatLE = function(m, A, M) {
    return L(this, m, A, !0, M);
  }, a.prototype.writeFloatBE = function(m, A, M) {
    return L(this, m, A, !1, M);
  };
  function q(E, m, A, M, Q) {
    return m = +m, A = A >>> 0, Q || me(E, m, A, 8), r.write(E, m, A, M, 52, 8), A + 8;
  }
  a.prototype.writeDoubleLE = function(m, A, M) {
    return q(this, m, A, !0, M);
  }, a.prototype.writeDoubleBE = function(m, A, M) {
    return q(this, m, A, !1, M);
  }, a.prototype.copy = function(m, A, M, Q) {
    if (!a.isBuffer(m))
      throw new TypeError("argument should be a Buffer");
    if (M || (M = 0), !Q && Q !== 0 && (Q = this.length), A >= m.length && (A = m.length), A || (A = 0), Q > 0 && Q < M && (Q = M), Q === M || m.length === 0 || this.length === 0)
      return 0;
    if (A < 0)
      throw new RangeError("targetStart out of bounds");
    if (M < 0 || M >= this.length)
      throw new RangeError("Index out of range");
    if (Q < 0)
      throw new RangeError("sourceEnd out of bounds");
    Q > this.length && (Q = this.length), m.length - A < Q - M && (Q = m.length - A + M);
    const ie = Q - M;
    return this === m && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(A, M, Q) : Uint8Array.prototype.set.call(
      m,
      this.subarray(M, Q),
      A
    ), ie;
  }, a.prototype.fill = function(m, A, M, Q) {
    if (typeof m == "string") {
      if (typeof A == "string" ? (Q = A, A = 0, M = this.length) : typeof M == "string" && (Q = M, M = this.length), Q !== void 0 && typeof Q != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Q == "string" && !a.isEncoding(Q))
        throw new TypeError("Unknown encoding: " + Q);
      if (m.length === 1) {
        const le = m.charCodeAt(0);
        (Q === "utf8" && le < 128 || Q === "latin1") && (m = le);
      }
    } else
      typeof m == "number" ? m = m & 255 : typeof m == "boolean" && (m = Number(m));
    if (A < 0 || this.length < A || this.length < M)
      throw new RangeError("Out of range index");
    if (M <= A)
      return this;
    A = A >>> 0, M = M === void 0 ? this.length : M >>> 0, m || (m = 0);
    let ie;
    if (typeof m == "number")
      for (ie = A; ie < M; ++ie)
        this[ie] = m;
    else {
      const le = a.isBuffer(m) ? m : a.from(m, Q), Ee = le.length;
      if (Ee === 0)
        throw new TypeError('The value "' + m + '" is invalid for argument "value"');
      for (ie = 0; ie < M - A; ++ie)
        this[ie + A] = le[ie % Ee];
    }
    return this;
  };
  const Z = {};
  function oe(E, m, A) {
    Z[E] = class extends A {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: m.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${E}]`, this.stack, delete this.name;
      }
      get code() {
        return E;
      }
      set code(Q) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Q,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${E}]: ${this.message}`;
      }
    };
  }
  oe(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(E) {
      return E ? `${E} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), oe(
    "ERR_INVALID_ARG_TYPE",
    function(E, m) {
      return `The "${E}" argument must be of type number. Received type ${typeof m}`;
    },
    TypeError
  ), oe(
    "ERR_OUT_OF_RANGE",
    function(E, m, A) {
      let M = `The value of "${E}" is out of range.`, Q = A;
      return Number.isInteger(A) && Math.abs(A) > 2 ** 32 ? Q = de(String(A)) : typeof A == "bigint" && (Q = String(A), (A > BigInt(2) ** BigInt(32) || A < -(BigInt(2) ** BigInt(32))) && (Q = de(Q)), Q += "n"), M += ` It must be ${m}. Received ${Q}`, M;
    },
    RangeError
  );
  function de(E) {
    let m = "", A = E.length;
    const M = E[0] === "-" ? 1 : 0;
    for (; A >= M + 4; A -= 3)
      m = `_${E.slice(A - 3, A)}${m}`;
    return `${E.slice(0, A)}${m}`;
  }
  function R(E, m, A) {
    re(m, "offset"), (E[m] === void 0 || E[m + A] === void 0) && ne(m, E.length - (A + 1));
  }
  function k(E, m, A, M, Q, ie) {
    if (E > A || E < m) {
      const le = typeof m == "bigint" ? "n" : "";
      let Ee;
      throw ie > 3 ? m === 0 || m === BigInt(0) ? Ee = `>= 0${le} and < 2${le} ** ${(ie + 1) * 8}${le}` : Ee = `>= -(2${le} ** ${(ie + 1) * 8 - 1}${le}) and < 2 ** ${(ie + 1) * 8 - 1}${le}` : Ee = `>= ${m}${le} and <= ${A}${le}`, new Z.ERR_OUT_OF_RANGE("value", Ee, E);
    }
    R(M, Q, ie);
  }
  function re(E, m) {
    if (typeof E != "number")
      throw new Z.ERR_INVALID_ARG_TYPE(m, "number", E);
  }
  function ne(E, m, A) {
    throw Math.floor(E) !== E ? (re(E, A), new Z.ERR_OUT_OF_RANGE(A || "offset", "an integer", E)) : m < 0 ? new Z.ERR_BUFFER_OUT_OF_BOUNDS() : new Z.ERR_OUT_OF_RANGE(
      A || "offset",
      `>= ${A ? 1 : 0} and <= ${m}`,
      E
    );
  }
  const Ae = /[^+/0-9A-Za-z-_]/g;
  function C(E) {
    if (E = E.split("=")[0], E = E.trim().replace(Ae, ""), E.length < 2)
      return "";
    for (; E.length % 4 !== 0; )
      E = E + "=";
    return E;
  }
  function v(E, m) {
    m = m || 1 / 0;
    let A;
    const M = E.length;
    let Q = null;
    const ie = [];
    for (let le = 0; le < M; ++le) {
      if (A = E.charCodeAt(le), A > 55295 && A < 57344) {
        if (!Q) {
          if (A > 56319) {
            (m -= 3) > -1 && ie.push(239, 191, 189);
            continue;
          } else if (le + 1 === M) {
            (m -= 3) > -1 && ie.push(239, 191, 189);
            continue;
          }
          Q = A;
          continue;
        }
        if (A < 56320) {
          (m -= 3) > -1 && ie.push(239, 191, 189), Q = A;
          continue;
        }
        A = (Q - 55296 << 10 | A - 56320) + 65536;
      } else
        Q && (m -= 3) > -1 && ie.push(239, 191, 189);
      if (Q = null, A < 128) {
        if ((m -= 1) < 0)
          break;
        ie.push(A);
      } else if (A < 2048) {
        if ((m -= 2) < 0)
          break;
        ie.push(
          A >> 6 | 192,
          A & 63 | 128
        );
      } else if (A < 65536) {
        if ((m -= 3) < 0)
          break;
        ie.push(
          A >> 12 | 224,
          A >> 6 & 63 | 128,
          A & 63 | 128
        );
      } else if (A < 1114112) {
        if ((m -= 4) < 0)
          break;
        ie.push(
          A >> 18 | 240,
          A >> 12 & 63 | 128,
          A >> 6 & 63 | 128,
          A & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return ie;
  }
  function w(E) {
    const m = [];
    for (let A = 0; A < E.length; ++A)
      m.push(E.charCodeAt(A) & 255);
    return m;
  }
  function D(E, m) {
    let A, M, Q;
    const ie = [];
    for (let le = 0; le < E.length && !((m -= 2) < 0); ++le)
      A = E.charCodeAt(le), M = A >> 8, Q = A % 256, ie.push(Q), ie.push(M);
    return ie;
  }
  function J(E) {
    return e.toByteArray(C(E));
  }
  function ae(E, m, A, M) {
    let Q;
    for (Q = 0; Q < M && !(Q + A >= m.length || Q >= E.length); ++Q)
      m[Q + A] = E[Q];
    return Q;
  }
  function ue(E, m) {
    return E instanceof m || E != null && E.constructor != null && E.constructor.name != null && E.constructor.name === m.name;
  }
  function Se(E) {
    return E !== E;
  }
  const _e = function() {
    const E = "0123456789abcdef", m = new Array(256);
    for (let A = 0; A < 16; ++A) {
      const M = A * 16;
      for (let Q = 0; Q < 16; ++Q)
        m[M + Q] = E[A] + E[Q];
    }
    return m;
  }();
  function we(E) {
    return typeof BigInt > "u" ? Ne : E;
  }
  function Ne() {
    throw new Error("BigInt not supported");
  }
})(B0);
/*! simple-peer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
const sb = ia("simple-peer"), L0 = sy, td = _c, ab = sa, Nl = nb, Le = ob, { Buffer: lb } = B0, Bl = 64 * 1024, cb = 5 * 1e3, ub = 5 * 1e3;
function rd(t) {
  return t.replace(/a=ice-options:trickle\s\n/g, "");
}
function fb(t) {
  console.warn(t);
}
class Un extends ab.Duplex {
  constructor(e) {
    if (e = Object.assign({
      allowHalfOpen: !1
    }, e), super(e), this._id = td(4).toString("hex").slice(0, 7), this._debug("new peer %o", e), this.channelName = e.initiator ? e.channelName || td(20).toString("hex") : null, this.initiator = e.initiator || !1, this.channelConfig = e.channelConfig || Un.channelConfig, this.channelNegotiated = this.channelConfig.negotiated, this.config = Object.assign({}, Un.config, e.config), this.offerOptions = e.offerOptions || {}, this.answerOptions = e.answerOptions || {}, this.sdpTransform = e.sdpTransform || ((r) => r), this.streams = e.streams || (e.stream ? [e.stream] : []), this.trickle = e.trickle !== void 0 ? e.trickle : !0, this.allowHalfTrickle = e.allowHalfTrickle !== void 0 ? e.allowHalfTrickle : !1, this.iceCompleteTimeout = e.iceCompleteTimeout || cb, this.destroyed = !1, this.destroying = !1, this._connected = !1, this.remoteAddress = void 0, this.remoteFamily = void 0, this.remotePort = void 0, this.localAddress = void 0, this.localFamily = void 0, this.localPort = void 0, this._wrtc = e.wrtc && typeof e.wrtc == "object" ? e.wrtc : L0(), !this._wrtc)
      throw Le(typeof window > "u" ? new Error("No WebRTC support: Specify `opts.wrtc` option in this environment") : new Error("No WebRTC support: Not a supported browser"), "ERR_WEBRTC_SUPPORT");
    this._pcReady = !1, this._channelReady = !1, this._iceComplete = !1, this._iceCompleteTimer = null, this._channel = null, this._pendingCandidates = [], this._isNegotiating = !1, this._firstNegotiation = !0, this._batchedNegotiation = !1, this._queuedNegotiation = !1, this._sendersAwaitingStable = [], this._senderMap = /* @__PURE__ */ new Map(), this._closingInterval = null, this._remoteTracks = [], this._remoteStreams = [], this._chunk = null, this._cb = null, this._interval = null;
    try {
      this._pc = new this._wrtc.RTCPeerConnection(this.config);
    } catch (r) {
      this.destroy(Le(r, "ERR_PC_CONSTRUCTOR"));
      return;
    }
    this._isReactNativeWebrtc = typeof this._pc._peerConnectionId == "number", this._pc.oniceconnectionstatechange = () => {
      this._onIceStateChange();
    }, this._pc.onicegatheringstatechange = () => {
      this._onIceStateChange();
    }, this._pc.onconnectionstatechange = () => {
      this._onConnectionStateChange();
    }, this._pc.onsignalingstatechange = () => {
      this._onSignalingStateChange();
    }, this._pc.onicecandidate = (r) => {
      this._onIceCandidate(r);
    }, typeof this._pc.peerIdentity == "object" && this._pc.peerIdentity.catch((r) => {
      this.destroy(Le(r, "ERR_PC_PEER_IDENTITY"));
    }), this.initiator || this.channelNegotiated ? this._setupData({
      channel: this._pc.createDataChannel(this.channelName, this.channelConfig)
    }) : this._pc.ondatachannel = (r) => {
      this._setupData(r);
    }, this.streams && this.streams.forEach((r) => {
      this.addStream(r);
    }), this._pc.ontrack = (r) => {
      this._onTrack(r);
    }, this._debug("initial negotiation"), this._needsNegotiation(), this._onFinishBound = () => {
      this._onFinish();
    }, this.once("finish", this._onFinishBound);
  }
  get bufferSize() {
    return this._channel && this._channel.bufferedAmount || 0;
  }
  // HACK: it's possible channel.readyState is "closing" before peer.destroy() fires
  // https://bugs.chromium.org/p/chromium/issues/detail?id=882743
  get connected() {
    return this._connected && this._channel.readyState === "open";
  }
  address() {
    return { port: this.localPort, family: this.localFamily, address: this.localAddress };
  }
  signal(e) {
    if (!this.destroying) {
      if (this.destroyed)
        throw Le(new Error("cannot signal after peer is destroyed"), "ERR_DESTROYED");
      if (typeof e == "string")
        try {
          e = JSON.parse(e);
        } catch {
          e = {};
        }
      this._debug("signal()"), e.renegotiate && this.initiator && (this._debug("got request to renegotiate"), this._needsNegotiation()), e.transceiverRequest && this.initiator && (this._debug("got request for transceiver"), this.addTransceiver(e.transceiverRequest.kind, e.transceiverRequest.init)), e.candidate && (this._pc.remoteDescription && this._pc.remoteDescription.type ? this._addIceCandidate(e.candidate) : this._pendingCandidates.push(e.candidate)), e.sdp && this._pc.setRemoteDescription(new this._wrtc.RTCSessionDescription(e)).then(() => {
        this.destroyed || (this._pendingCandidates.forEach((r) => {
          this._addIceCandidate(r);
        }), this._pendingCandidates = [], this._pc.remoteDescription.type === "offer" && this._createAnswer());
      }).catch((r) => {
        this.destroy(Le(r, "ERR_SET_REMOTE_DESCRIPTION"));
      }), !e.sdp && !e.candidate && !e.renegotiate && !e.transceiverRequest && this.destroy(Le(new Error("signal() called with invalid signal data"), "ERR_SIGNALING"));
    }
  }
  _addIceCandidate(e) {
    const r = new this._wrtc.RTCIceCandidate(e);
    this._pc.addIceCandidate(r).catch((n) => {
      !r.address || r.address.endsWith(".local") ? fb("Ignoring unsupported ICE candidate.") : this.destroy(Le(n, "ERR_ADD_ICE_CANDIDATE"));
    });
  }
  /**
   * Send text/binary data to the remote peer.
   * @param {ArrayBufferView|ArrayBuffer|Buffer|string|Blob} chunk
   */
  send(e) {
    if (!this.destroying) {
      if (this.destroyed)
        throw Le(new Error("cannot send after peer is destroyed"), "ERR_DESTROYED");
      this._channel.send(e);
    }
  }
  /**
   * Add a Transceiver to the connection.
   * @param {String} kind
   * @param {Object} init
   */
  addTransceiver(e, r) {
    if (!this.destroying) {
      if (this.destroyed)
        throw Le(new Error("cannot addTransceiver after peer is destroyed"), "ERR_DESTROYED");
      if (this._debug("addTransceiver()"), this.initiator)
        try {
          this._pc.addTransceiver(e, r), this._needsNegotiation();
        } catch (n) {
          this.destroy(Le(n, "ERR_ADD_TRANSCEIVER"));
        }
      else
        this.emit("signal", {
          // request initiator to renegotiate
          type: "transceiverRequest",
          transceiverRequest: { kind: e, init: r }
        });
    }
  }
  /**
   * Add a MediaStream to the connection.
   * @param {MediaStream} stream
   */
  addStream(e) {
    if (!this.destroying) {
      if (this.destroyed)
        throw Le(new Error("cannot addStream after peer is destroyed"), "ERR_DESTROYED");
      this._debug("addStream()"), e.getTracks().forEach((r) => {
        this.addTrack(r, e);
      });
    }
  }
  /**
   * Add a MediaStreamTrack to the connection.
   * @param {MediaStreamTrack} track
   * @param {MediaStream} stream
   */
  addTrack(e, r) {
    if (this.destroying)
      return;
    if (this.destroyed)
      throw Le(new Error("cannot addTrack after peer is destroyed"), "ERR_DESTROYED");
    this._debug("addTrack()");
    const n = this._senderMap.get(e) || /* @__PURE__ */ new Map();
    let i = n.get(r);
    if (!i)
      i = this._pc.addTrack(e, r), n.set(r, i), this._senderMap.set(e, n), this._needsNegotiation();
    else
      throw i.removed ? Le(new Error("Track has been removed. You should enable/disable tracks that you want to re-add."), "ERR_SENDER_REMOVED") : Le(new Error("Track has already been added to that stream."), "ERR_SENDER_ALREADY_ADDED");
  }
  /**
   * Replace a MediaStreamTrack by another in the connection.
   * @param {MediaStreamTrack} oldTrack
   * @param {MediaStreamTrack} newTrack
   * @param {MediaStream} stream
   */
  replaceTrack(e, r, n) {
    if (this.destroying)
      return;
    if (this.destroyed)
      throw Le(new Error("cannot replaceTrack after peer is destroyed"), "ERR_DESTROYED");
    this._debug("replaceTrack()");
    const i = this._senderMap.get(e), o = i ? i.get(n) : null;
    if (!o)
      throw Le(new Error("Cannot replace track that was never added."), "ERR_TRACK_NOT_ADDED");
    r && this._senderMap.set(r, i), o.replaceTrack != null ? o.replaceTrack(r) : this.destroy(Le(new Error("replaceTrack is not supported in this browser"), "ERR_UNSUPPORTED_REPLACETRACK"));
  }
  /**
   * Remove a MediaStreamTrack from the connection.
   * @param {MediaStreamTrack} track
   * @param {MediaStream} stream
   */
  removeTrack(e, r) {
    if (this.destroying)
      return;
    if (this.destroyed)
      throw Le(new Error("cannot removeTrack after peer is destroyed"), "ERR_DESTROYED");
    this._debug("removeSender()");
    const n = this._senderMap.get(e), i = n ? n.get(r) : null;
    if (!i)
      throw Le(new Error("Cannot remove track that was never added."), "ERR_TRACK_NOT_ADDED");
    try {
      i.removed = !0, this._pc.removeTrack(i);
    } catch (o) {
      o.name === "NS_ERROR_UNEXPECTED" ? this._sendersAwaitingStable.push(i) : this.destroy(Le(o, "ERR_REMOVE_TRACK"));
    }
    this._needsNegotiation();
  }
  /**
   * Remove a MediaStream from the connection.
   * @param {MediaStream} stream
   */
  removeStream(e) {
    if (!this.destroying) {
      if (this.destroyed)
        throw Le(new Error("cannot removeStream after peer is destroyed"), "ERR_DESTROYED");
      this._debug("removeSenders()"), e.getTracks().forEach((r) => {
        this.removeTrack(r, e);
      });
    }
  }
  _needsNegotiation() {
    this._debug("_needsNegotiation"), !this._batchedNegotiation && (this._batchedNegotiation = !0, Nl(() => {
      this._batchedNegotiation = !1, this.initiator || !this._firstNegotiation ? (this._debug("starting batched negotiation"), this.negotiate()) : this._debug("non-initiator initial negotiation request discarded"), this._firstNegotiation = !1;
    }));
  }
  negotiate() {
    if (!this.destroying) {
      if (this.destroyed)
        throw Le(new Error("cannot negotiate after peer is destroyed"), "ERR_DESTROYED");
      this.initiator ? this._isNegotiating ? (this._queuedNegotiation = !0, this._debug("already negotiating, queueing")) : (this._debug("start negotiation"), setTimeout(() => {
        this._createOffer();
      }, 0)) : this._isNegotiating ? (this._queuedNegotiation = !0, this._debug("already negotiating, queueing")) : (this._debug("requesting negotiation from initiator"), this.emit("signal", {
        // request initiator to renegotiate
        type: "renegotiate",
        renegotiate: !0
      })), this._isNegotiating = !0;
    }
  }
  // TODO: Delete this method once readable-stream is updated to contain a default
  // implementation of destroy() that automatically calls _destroy()
  // See: https://github.com/nodejs/readable-stream/issues/283
  destroy(e) {
    this._destroy(e, () => {
    });
  }
  _destroy(e, r) {
    this.destroyed || this.destroying || (this.destroying = !0, this._debug("destroying (error: %s)", e && (e.message || e)), Nl(() => {
      if (this.destroyed = !0, this.destroying = !1, this._debug("destroy (error: %s)", e && (e.message || e)), this.readable = this.writable = !1, this._readableState.ended || this.push(null), this._writableState.finished || this.end(), this._connected = !1, this._pcReady = !1, this._channelReady = !1, this._remoteTracks = null, this._remoteStreams = null, this._senderMap = null, clearInterval(this._closingInterval), this._closingInterval = null, clearInterval(this._interval), this._interval = null, this._chunk = null, this._cb = null, this._onFinishBound && this.removeListener("finish", this._onFinishBound), this._onFinishBound = null, this._channel) {
        try {
          this._channel.close();
        } catch {
        }
        this._channel.onmessage = null, this._channel.onopen = null, this._channel.onclose = null, this._channel.onerror = null;
      }
      if (this._pc) {
        try {
          this._pc.close();
        } catch {
        }
        this._pc.oniceconnectionstatechange = null, this._pc.onicegatheringstatechange = null, this._pc.onsignalingstatechange = null, this._pc.onicecandidate = null, this._pc.ontrack = null, this._pc.ondatachannel = null;
      }
      this._pc = null, this._channel = null, e && this.emit("error", e), this.emit("close"), r();
    }));
  }
  _setupData(e) {
    if (!e.channel)
      return this.destroy(Le(new Error("Data channel event is missing `channel` property"), "ERR_DATA_CHANNEL"));
    this._channel = e.channel, this._channel.binaryType = "arraybuffer", typeof this._channel.bufferedAmountLowThreshold == "number" && (this._channel.bufferedAmountLowThreshold = Bl), this.channelName = this._channel.label, this._channel.onmessage = (n) => {
      this._onChannelMessage(n);
    }, this._channel.onbufferedamountlow = () => {
      this._onChannelBufferedAmountLow();
    }, this._channel.onopen = () => {
      this._onChannelOpen();
    }, this._channel.onclose = () => {
      this._onChannelClose();
    }, this._channel.onerror = (n) => {
      const i = n.error instanceof Error ? n.error : new Error(`Datachannel error: ${n.message} ${n.filename}:${n.lineno}:${n.colno}`);
      this.destroy(Le(i, "ERR_DATA_CHANNEL"));
    };
    let r = !1;
    this._closingInterval = setInterval(() => {
      this._channel && this._channel.readyState === "closing" ? (r && this._onChannelClose(), r = !0) : r = !1;
    }, ub);
  }
  _read() {
  }
  _write(e, r, n) {
    if (this.destroyed)
      return n(Le(new Error("cannot write after peer is destroyed"), "ERR_DATA_CHANNEL"));
    if (this._connected) {
      try {
        this.send(e);
      } catch (i) {
        return this.destroy(Le(i, "ERR_DATA_CHANNEL"));
      }
      this._channel.bufferedAmount > Bl ? (this._debug("start backpressure: bufferedAmount %d", this._channel.bufferedAmount), this._cb = n) : n(null);
    } else
      this._debug("write before connect"), this._chunk = e, this._cb = n;
  }
  // When stream finishes writing, close socket. Half open connections are not
  // supported.
  _onFinish() {
    if (this.destroyed)
      return;
    const e = () => {
      setTimeout(() => this.destroy(), 1e3);
    };
    this._connected ? e() : this.once("connect", e);
  }
  _startIceCompleteTimeout() {
    this.destroyed || this._iceCompleteTimer || (this._debug("started iceComplete timeout"), this._iceCompleteTimer = setTimeout(() => {
      this._iceComplete || (this._iceComplete = !0, this._debug("iceComplete timeout completed"), this.emit("iceTimeout"), this.emit("_iceComplete"));
    }, this.iceCompleteTimeout));
  }
  _createOffer() {
    this.destroyed || this._pc.createOffer(this.offerOptions).then((e) => {
      if (this.destroyed)
        return;
      !this.trickle && !this.allowHalfTrickle && (e.sdp = rd(e.sdp)), e.sdp = this.sdpTransform(e.sdp);
      const r = () => {
        if (this.destroyed)
          return;
        const o = this._pc.localDescription || e;
        this._debug("signal"), this.emit("signal", {
          type: o.type,
          sdp: o.sdp
        });
      }, n = () => {
        this._debug("createOffer success"), !this.destroyed && (this.trickle || this._iceComplete ? r() : this.once("_iceComplete", r));
      }, i = (o) => {
        this.destroy(Le(o, "ERR_SET_LOCAL_DESCRIPTION"));
      };
      this._pc.setLocalDescription(e).then(n).catch(i);
    }).catch((e) => {
      this.destroy(Le(e, "ERR_CREATE_OFFER"));
    });
  }
  _requestMissingTransceivers() {
    this._pc.getTransceivers && this._pc.getTransceivers().forEach((e) => {
      !e.mid && e.sender.track && !e.requested && (e.requested = !0, this.addTransceiver(e.sender.track.kind));
    });
  }
  _createAnswer() {
    this.destroyed || this._pc.createAnswer(this.answerOptions).then((e) => {
      if (this.destroyed)
        return;
      !this.trickle && !this.allowHalfTrickle && (e.sdp = rd(e.sdp)), e.sdp = this.sdpTransform(e.sdp);
      const r = () => {
        if (this.destroyed)
          return;
        const o = this._pc.localDescription || e;
        this._debug("signal"), this.emit("signal", {
          type: o.type,
          sdp: o.sdp
        }), this.initiator || this._requestMissingTransceivers();
      }, n = () => {
        this.destroyed || (this.trickle || this._iceComplete ? r() : this.once("_iceComplete", r));
      }, i = (o) => {
        this.destroy(Le(o, "ERR_SET_LOCAL_DESCRIPTION"));
      };
      this._pc.setLocalDescription(e).then(n).catch(i);
    }).catch((e) => {
      this.destroy(Le(e, "ERR_CREATE_ANSWER"));
    });
  }
  _onConnectionStateChange() {
    this.destroyed || this._pc.connectionState === "failed" && this.destroy(Le(new Error("Connection failed."), "ERR_CONNECTION_FAILURE"));
  }
  _onIceStateChange() {
    if (this.destroyed)
      return;
    const e = this._pc.iceConnectionState, r = this._pc.iceGatheringState;
    this._debug(
      "iceStateChange (connection: %s) (gathering: %s)",
      e,
      r
    ), this.emit("iceStateChange", e, r), (e === "connected" || e === "completed") && (this._pcReady = !0, this._maybeReady()), e === "failed" && this.destroy(Le(new Error("Ice connection failed."), "ERR_ICE_CONNECTION_FAILURE")), e === "closed" && this.destroy(Le(new Error("Ice connection closed."), "ERR_ICE_CONNECTION_CLOSED"));
  }
  getStats(e) {
    const r = (n) => (Object.prototype.toString.call(n.values) === "[object Array]" && n.values.forEach((i) => {
      Object.assign(n, i);
    }), n);
    this._pc.getStats.length === 0 || this._isReactNativeWebrtc ? this._pc.getStats().then((n) => {
      const i = [];
      n.forEach((o) => {
        i.push(r(o));
      }), e(null, i);
    }, (n) => e(n)) : this._pc.getStats.length > 0 ? this._pc.getStats((n) => {
      if (this.destroyed)
        return;
      const i = [];
      n.result().forEach((o) => {
        const s = {};
        o.names().forEach((a) => {
          s[a] = o.stat(a);
        }), s.id = o.id, s.type = o.type, s.timestamp = o.timestamp, i.push(r(s));
      }), e(null, i);
    }, (n) => e(n)) : e(null, []);
  }
  _maybeReady() {
    if (this._debug("maybeReady pc %s channel %s", this._pcReady, this._channelReady), this._connected || this._connecting || !this._pcReady || !this._channelReady)
      return;
    this._connecting = !0;
    const e = () => {
      this.destroyed || this.getStats((r, n) => {
        if (this.destroyed)
          return;
        r && (n = []);
        const i = {}, o = {}, s = {};
        let a = !1;
        n.forEach((c) => {
          (c.type === "remotecandidate" || c.type === "remote-candidate") && (i[c.id] = c), (c.type === "localcandidate" || c.type === "local-candidate") && (o[c.id] = c), (c.type === "candidatepair" || c.type === "candidate-pair") && (s[c.id] = c);
        });
        const l = (c) => {
          a = !0;
          let u = o[c.localCandidateId];
          u && (u.ip || u.address) ? (this.localAddress = u.ip || u.address, this.localPort = Number(u.port)) : u && u.ipAddress ? (this.localAddress = u.ipAddress, this.localPort = Number(u.portNumber)) : typeof c.googLocalAddress == "string" && (u = c.googLocalAddress.split(":"), this.localAddress = u[0], this.localPort = Number(u[1])), this.localAddress && (this.localFamily = this.localAddress.includes(":") ? "IPv6" : "IPv4");
          let f = i[c.remoteCandidateId];
          f && (f.ip || f.address) ? (this.remoteAddress = f.ip || f.address, this.remotePort = Number(f.port)) : f && f.ipAddress ? (this.remoteAddress = f.ipAddress, this.remotePort = Number(f.portNumber)) : typeof c.googRemoteAddress == "string" && (f = c.googRemoteAddress.split(":"), this.remoteAddress = f[0], this.remotePort = Number(f[1])), this.remoteAddress && (this.remoteFamily = this.remoteAddress.includes(":") ? "IPv6" : "IPv4"), this._debug(
            "connect local: %s:%s remote: %s:%s",
            this.localAddress,
            this.localPort,
            this.remoteAddress,
            this.remotePort
          );
        };
        if (n.forEach((c) => {
          c.type === "transport" && c.selectedCandidatePairId && l(s[c.selectedCandidatePairId]), (c.type === "googCandidatePair" && c.googActiveConnection === "true" || (c.type === "candidatepair" || c.type === "candidate-pair") && c.selected) && l(c);
        }), !a && (!Object.keys(s).length || Object.keys(o).length)) {
          setTimeout(e, 100);
          return;
        } else
          this._connecting = !1, this._connected = !0;
        if (this._chunk) {
          try {
            this.send(this._chunk);
          } catch (u) {
            return this.destroy(Le(u, "ERR_DATA_CHANNEL"));
          }
          this._chunk = null, this._debug('sent chunk from "write before connect"');
          const c = this._cb;
          this._cb = null, c(null);
        }
        typeof this._channel.bufferedAmountLowThreshold != "number" && (this._interval = setInterval(() => this._onInterval(), 150), this._interval.unref && this._interval.unref()), this._debug("connect"), this.emit("connect");
      });
    };
    e();
  }
  _onInterval() {
    !this._cb || !this._channel || this._channel.bufferedAmount > Bl || this._onChannelBufferedAmountLow();
  }
  _onSignalingStateChange() {
    this.destroyed || (this._pc.signalingState === "stable" && (this._isNegotiating = !1, this._debug("flushing sender queue", this._sendersAwaitingStable), this._sendersAwaitingStable.forEach((e) => {
      this._pc.removeTrack(e), this._queuedNegotiation = !0;
    }), this._sendersAwaitingStable = [], this._queuedNegotiation ? (this._debug("flushing negotiation queue"), this._queuedNegotiation = !1, this._needsNegotiation()) : (this._debug("negotiated"), this.emit("negotiated"))), this._debug("signalingStateChange %s", this._pc.signalingState), this.emit("signalingStateChange", this._pc.signalingState));
  }
  _onIceCandidate(e) {
    this.destroyed || (e.candidate && this.trickle ? this.emit("signal", {
      type: "candidate",
      candidate: {
        candidate: e.candidate.candidate,
        sdpMLineIndex: e.candidate.sdpMLineIndex,
        sdpMid: e.candidate.sdpMid
      }
    }) : !e.candidate && !this._iceComplete && (this._iceComplete = !0, this.emit("_iceComplete")), e.candidate && this._startIceCompleteTimeout());
  }
  _onChannelMessage(e) {
    if (this.destroyed)
      return;
    let r = e.data;
    r instanceof ArrayBuffer && (r = lb.from(r)), this.push(r);
  }
  _onChannelBufferedAmountLow() {
    if (this.destroyed || !this._cb)
      return;
    this._debug("ending backpressure: bufferedAmount %d", this._channel.bufferedAmount);
    const e = this._cb;
    this._cb = null, e(null);
  }
  _onChannelOpen() {
    this._connected || this.destroyed || (this._debug("on channel open"), this._channelReady = !0, this._maybeReady());
  }
  _onChannelClose() {
    this.destroyed || (this._debug("on channel close"), this.destroy());
  }
  _onTrack(e) {
    this.destroyed || e.streams.forEach((r) => {
      this._debug("on track"), this.emit("track", e.track, r), this._remoteTracks.push({
        track: e.track,
        stream: r
      }), !this._remoteStreams.some((n) => n.id === r.id) && (this._remoteStreams.push(r), Nl(() => {
        this._debug("on stream"), this.emit("stream", r);
      }));
    });
  }
  _debug() {
    const e = [].slice.call(arguments);
    e[0] = "[" + this._id + "] " + e[0], sb.apply(null, e);
  }
}
Un.WEBRTC_SUPPORT = !!L0();
Un.config = {
  iceServers: [
    {
      urls: [
        "stun:stun.l.google.com:19302",
        "stun:globalThis.stun.twilio.com:3478"
      ]
    }
  ],
  sdpSemantics: "unified-plan"
};
Un.channelConfig = {};
var nd = Un;
function Ce() {
  localStorage.getItem("debug") === "true" && console.log(...arguments);
}
typeof window < "u" && (window.process = {
  ...window.process,
  nextTick: function(t, e, r, n) {
    setTimeout(() => {
      t(e, r, n);
    }, 0);
  }
}, window.process.env = window.process.env || {});
function db(t) {
  t = t.replace(/#/g, "");
  var e = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  t = t.replace(e, function(n, i, o, s) {
    return i + i + o + o + s + s;
  });
  var r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
  return r ? {
    r: parseInt(r[1], 16),
    g: parseInt(r[2], 16),
    b: parseInt(r[3], 16),
    hexString: `#${t}`,
    hex: parseInt(r[1], 16) << 16 | parseInt(r[2], 16) << 8 | parseInt(r[3], 16)
  } : null;
}
class hb extends gu {
  constructor({
    websocketSend: e,
    id: r,
    myId: n,
    isRenderServer: i,
    isRenderServerOrHostIfNotCasting: o,
    playerIsSpectator: s,
    playerIsProxy: a,
    broadcastUnreliable: l,
    setPlayerState: c,
    getBootDate: u,
    avatarList: f,
    kickPlayer: d,
    state: h = {},
    defaultPlayerState: g = {}
  }) {
    super(), this.websocketSend = e, this.broadcastUnreliable = l, this.setPlayerState = c, this.myId = n, this._kickPlayerTrigger = d, this.id = r, this.avatarList = f, this.syncIntervalTime = p0.SyncIntervalTime, this.isRenderServer = i, this.isRenderServerOrHostIfNotCasting = o, this.playerIsSpectator = s, this.playerIsProxy = a, this.state = h, this.defaultPlayerState = g, this.iUpdatedStateAt = {}, this.playerIsProxy && (this.state.__proxyBy = n), this.getBootDate = u, this.stateKeyUpdateOrder = {}, this.inputState = {}, this.peer = null, this.webrtcConnected = !1, this.webrtcRetryCount = 0, this.controllerLegacy = !1, this.heartbeatInterval = 0, this.retryWebRtcTimeout = 0, this.isDestroyed = !1, this.timeDiffFromServer = 0, this.bot = void 0, this.on("input_broadcast", (p) => {
      !o() && !s && this.send({ pinput: p });
    });
  }
  send(e, r, n) {
    if (this.webrtcConnected && !r && !this.playerIsProxy)
      try {
        Ce(
          "sending unreliable",
          e,
          r,
          "webrtcConnected",
          this.webrtcConnected
        ), this.peer.send(JSON.stringify(e));
      } catch (i) {
        Ce(i);
      }
    else
      !r && this.isRenderServerOrHostIfNotCasting() && !n ? this.broadcastUnreliable(e) : this.playerIsProxy || (this.isRenderServerOrHostIfNotCasting() && (e.for = this.id), Ce(
        "sending reliable",
        e,
        r,
        "webrtcConnected",
        this.webrtcConnected
      ), this.websocketSend(JSON.stringify(e)));
  }
  startWebrtc() {
    if (this.retryWebRtcTimeout && (clearTimeout(this.retryWebRtcTimeout), this.retryWebRtcTimeout = 0), this.peer && this.peer.destroy(), !this.isRenderServerOrHostIfNotCasting() && this.myId === this.id) {
      Ce("webrtc::connecting", "not render server, isMyId");
      try {
        this.peer = new nd({ initiator: !0, objectMode: !0 });
      } catch (e) {
        Ce(this._idToHuman(), "::webrtc:", "connection error", e), this.webrtcConnected = !1;
        return;
      }
      this.peer.on("signal", (e) => {
        Ce("got signal", e), this.send({ signal: e }, !0);
      }), this.peer.on("connect", () => {
        this.webrtcConnected = !0, this.webrtcRetryCount = 0, this.emit("webrtc_connected"), clearTimeout(this.retryWebRtcTimeout);
      }), this.peer.on("data", (e) => {
        e = JSON.parse(e), Ce("webrtc::host says:", e), e.ping ? (this.timeDiffFromServer = e.ping - Date.now(), this.send({ pong: e.ping })) : e.pstate ? this.setPlayerState(e) : e.gstate && this.emit("global_state_unreliable", e.gstate);
      }), this.peer.on("stream", (e) => {
        this.emit("stream", e);
      }), this.peer.on("close", () => {
        Ce(this._idToHuman(), "::webrtc:", "connection closed"), this.webrtcConnected = !1, this.retryWebRtcTimeout = setTimeout(() => {
          !this.isDestroyed && this.webrtcRetryCount < 5 && (this.startWebrtc(), this.webrtcRetryCount++);
        }, 3e3);
      }), this.peer.on("error", (e) => {
        Ce(this._idToHuman(), "::webrtc:", "connection error", e), this.webrtcConnected = !1;
      });
    } else if (this.isRenderServerOrHostIfNotCasting() && this.myId !== this.id) {
      Ce("webrtc::connecting", "is render server, notMyId"), clearInterval(this.heartbeatInterval), this.heartbeatInterval = setInterval(() => {
        this.send({
          ping: Date.now()
        });
      }, 5e3);
      try {
        this.peer = new nd({ objectMode: !0 });
      } catch (e) {
        Ce(this._idToHuman(), "::webrtc:", "connection error", e), this.webrtcConnected = !1;
        return;
      }
      this.peer.on("signal", (e) => {
        Ce("got signal", e), this.send({ for: this.id, signal: e }, !0);
      }), this.peer.on("connect", () => {
        Ce("connected to player via webrtc"), this.webrtcConnected = !0, this.send({ ping: Date.now() }), this.emit("webrtc_connected");
      }), this.peer.on("data", (e) => {
        Ce(this._idToHuman(), "::webrtc:", e), e = JSON.parse(e), e.pinput ? this.handleInput(e.pinput) : e.pstate ? this.setState(e.d[0], e.d[1]) : e.pong && this.handlePingResponse(e);
      }), this.peer.on("close", () => {
        this.webrtcConnected = !1, Ce(this._idToHuman(), "::webrtc:", "connection closed");
      }), this.peer.on("error", (e) => {
        this.webrtcConnected = !1, Ce(this._idToHuman(), "::webrtc:", "connection error", e);
      });
    }
  }
  _idToHuman() {
    return `${this.playerIsSpectator ? "spectator" : "player"}(${this.id})`;
  }
  signal(e) {
    this.peer.destroyed && this.isRenderServerOrHostIfNotCasting() && this.startWebrtc();
    try {
      Ce("signaling", e), this.peer.signal(e);
    } catch (r) {
      Ce(r);
    }
  }
  handlePingResponse(e) {
    var r = Date.now() - e.pong;
    this.emit("ping", r);
  }
  // used for local players
  attachControllerLegacy(e) {
    this.detachControllerLegacy(), this.controllerLegacy = e, this.controllerLegacy.on("keydown", this.handleKeyDown.bind(this)), this.controllerLegacy.on("keyup", this.handleKeyUp.bind(this)), this.controllerLegacy.on("dpad", this.handleDpad.bind(this)), this.controllerLegacy.on("gyro", this.handleGyro.bind(this));
  }
  detachControllerLegacy() {
    if (this.controllerLegacy) {
      const e = this.controllerLegacy;
      return this.controllerLegacy.off("keydown", this.handleKeyDown), this.controllerLegacy.off("keyup", this.handleKeyUp), this.controllerLegacy.off("dpad", this.handleDpad), this.controllerLegacy.off("gyro", this.handleGyro), delete this.controllerLegacy, e;
    }
  }
  onKeyPress(e, r) {
    this.on("keypress", (n) => {
      n.key === e && r(n);
    });
  }
  onKeyUp(e, r) {
    this.on("keyup", (n) => {
      n.key === e && r(n);
    });
  }
  onKeyDown(e, r) {
    this.on("keydown", (n) => {
      n.key === e && r(n);
    });
  }
  onQuit(e) {
    return this.on("quit", e);
  }
  handleKeyDown(e) {
    this.handleInput({ keydown: e });
  }
  handleKeyUp(e) {
    this.handleInput({ keyup: e });
  }
  handleDpad(e) {
    this.handleInput({ dpad: e });
  }
  handleGyro(e) {
    this.handleInput({ gyro: e });
  }
  // handle the input, pass it to subscribers (usually the game logic which will use this to move players in engine)
  handleInput(e, r) {
    let n = !1;
    Object.keys(e).forEach((i) => {
      const o = e[i];
      i === "keydown" && !this.inputState[o] && (this.inputState[o] = !0, this.emit("keydown", { key: o }), this.emit("keypress", { key: o }), n = !0), i === "keyup" && this.inputState[o] && (delete this.inputState[o], this.emit("keyup", { key: o }), n = !0), i === "dpad" && (this.inputState.dpad = e.dpad, n = !0), i === "gyro" && (this.inputState.gyro = e.gyro, n = !0);
    }), n && (Ce("inputEmit", e), this.emit("input", e), r || this.emit("input_broadcast", e));
  }
  isKeyDown(e) {
    return this.inputState[e];
  }
  on(e, r, n) {
    return e === "profile" && r(this.state.profile), e === "webrtc_connected" && this.webrtcConnected && r(), super.on(e, r, n);
  }
  getState(e) {
    return e ? typeof this.state[e] == "object" ? JSON.parse(JSON.stringify(this.state[e])) : this.state[e] : this.state;
  }
  // public method to change state object (used by host only or to change my own state). This is then synced with all clients.
  setState(e, r, n) {
    JSON.stringify(this.state[e]) !== JSON.stringify(r) && (this.setLocalState(e, r), this.iUpdatedStateAt[e] = Date.now(), this.isRenderServerOrHostIfNotCasting() && !n ? this.broadcastUnreliable({
      pstate: this.id,
      d: [e, r],
      o: Date.now() - this.getBootDate()
    }) : this.send(
      {
        pstate: this.id,
        d: [e, r],
        o: Date.now() - this.getBootDate() - this.timeDiffFromServer
      },
      n
    ));
  }
  setFullDefaultLocalState(e) {
    Object.keys(e).forEach((r) => {
      this.setDefaultLocalState(r, e[r]);
    });
  }
  // get default player state
  getDefaultState(e) {
    return e ? typeof this.defaultPlayerState[e] == "object" ? JSON.parse(JSON.stringify(this.defaultPlayerState[e])) : this.defaultPlayerState[e] : this.defaultPlayerState;
  }
  /**
   * store default player states. This will come in handy when we reset the player states,
   * we will replace the states with these default states.
   */
  setDefaultState(e, r) {
    const n = typeof r == "object" ? JSON.parse(JSON.stringify(r)) : r;
    this.setDefaultLocalState(e, n) && this.send(
      {
        default_pstate: this.id,
        d: [e, n],
        o: Date.now() - this.getBootDate() - this.timeDiffFromServer
      },
      !0
    );
  }
  setDefaultLocalState(e, r) {
    if (JSON.stringify(this.defaultPlayerState[e]) !== JSON.stringify(r))
      return this.defaultPlayerState[e] = r, !0;
  }
  getProfile() {
    let e = this.getState("profile") || { color: "#ffffff", name: "" };
    return e && e.color && (e = { ...e, color: db(e.color) }), this.avatarList && this.avatarList.length > 0 && (e.avatarIndex = this.avatarList.indexOf(e.photo)), e.avatarIndex === void 0 && (e.avatarIndex = -1), e;
  }
  setRoundState(e, r, n) {
    this.setState(`round.${e}`, r, n);
  }
  getRoundState(e) {
    if (e)
      return this.getState(`round.${e}`);
    {
      let r = {};
      return Object.keys(this.getState()).forEach((n) => {
        n.startsWith("round.") && (r[n.substring(6)] = this.getState(n));
      }), r;
    }
  }
  resetRoundState() {
    Object.keys(this.getState()).forEach((e) => {
      e.startsWith("round.") && this.setState(e, void 0);
    });
  }
  setFullLocalState(e, r) {
    Object.keys(e).forEach((n) => {
      (!this.iUpdatedStateAt[n] || this.iUpdatedStateAt[n] + this.syncIntervalTime < Date.now()) && this.setLocalState(n, e[n], r);
    }), Object.keys(this.state).forEach((n) => {
      var i;
      (!this.iUpdatedStateAt[n] || this.iUpdatedStateAt[n] + this.syncIntervalTime < Date.now()) && e[n] === void 0 && (Ce("set default states for the playerState", this.state[n]), this.setLocalState(n, (i = this.defaultPlayerState) == null ? void 0 : i[n], r));
    });
  }
  // just change local state without broadcasting
  // updateOrder: since we have two channels the state can come from,
  // we keep order in mind and only update if it's latest from host
  setLocalState(e, r, n) {
    if (n && this.stateKeyUpdateOrder[e] && this.stateKeyUpdateOrder[e] > n)
      return;
    this.stateKeyUpdateOrder[e] = n || 0;
    const i = JSON.stringify(r);
    var o = !1;
    JSON.stringify(this.state[e]) !== i && (o = !0);
    const s = typeof r == "object" ? JSON.parse(i) : r;
    return this.state[e] = s, o && (this.emit("state", e, s), e === "profile" && this.emit("profile", s)), o;
  }
  kick() {
    return new Promise((e, r) => {
      if (!this.isRenderServerOrHostIfNotCasting()) {
        r("Only the host can kick a player.");
        return;
      }
      this._kickPlayerTrigger(this.id, e);
    });
  }
  disconnect(e) {
    Ce("[PlayerState] disconnecting with eventCode:", e), this.detachControllerLegacy(), clearInterval(this.heartbeatInterval), this.isDestroyed = !0, this.peer && this.peer.destroy(), this.emit("quit", this);
  }
  isBot() {
    return this.state.__bot;
  }
  isProxyPlayer() {
    return this.state.__proxyBy;
  }
}
typeof window < "u" && (window.__TEMPSTORAGE__ = {});
function pb(t, e) {
  var r;
  window._USETEMPSTORAGE ? window.__TEMPSTORAGE__[t] = e : (r = window._PLAYROOM_CONFIG) != null && r.sessionStorage ? sessionStorage.setItem(t, e) : localStorage.setItem(t, e);
}
function gb(t) {
  var e;
  return window._USETEMPSTORAGE ? window.__TEMPSTORAGE__[t] : (e = window._PLAYROOM_CONFIG) != null && e.sessionStorage ? sessionStorage.getItem(t) : localStorage.getItem(t);
}
const xt = {
  set: pb,
  get: gb
};
let ja = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((e, r) => (r &= 63, r < 36 ? e += r.toString(36) : r < 62 ? e += (r - 26).toString(36).toUpperCase() : r > 62 ? e += "-" : e += "_", e), "");
function F0() {
  const t = localStorage.getItem("permId") || ja(32);
  return localStorage.setItem("permId", t), t;
}
function mb() {
  const t = xt.get("myId") || ja(12);
  return xt.set("myId", t), t;
}
function Ll(t) {
  return new Promise((e) => setTimeout(e, t));
}
function yb(t, e) {
  return new Promise((r, n) => {
    if (t.getState(e) !== void 0)
      r();
    else {
      const i = t.on(
        "state",
        (o, s) => {
          o === e && (i(), r());
        },
        !0
      );
    }
  });
}
function XS(t, e) {
  const r = Me();
  return new Promise((n, i) => {
    const o = (l) => {
      e && e(l), n(l);
    };
    let s = r.getState(t);
    s && o(s);
    const a = r.on("state", (l, c) => {
      c === t && l[c] && (a(), o(l[c]));
    });
  });
}
function JS(t, e, r) {
  return new Promise((n) => {
    const i = (a) => {
      r && r(a), n(a);
    };
    let o = t.getState(e);
    o && i(o);
    const s = t.on("state", (a, l) => {
      a === e && l && (s(), i(l));
    });
  });
}
var j0 = {}, W0 = {};
Object.defineProperty(W0, "__esModule", { value: !0 });
var U0 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.createArrayPatch = t.createObjectPatch = t.createPatch = void 0;
  const e = (s) => (s instanceof Object && typeof s.toJSON == "function" && (s = s.toJSON()), typeof s == "function" ? s = void 0 : typeof s == "number" && (s !== s || s === 1 / 0 || s === -1 / 0) && (s = null), s), r = (s, a) => (s = e(s), a = e(a), n(s, a));
  t.createPatch = r;
  const n = (s, a) => {
    if (s === void 0 && (s = null), a === void 0 && (a = null), s === a)
      return "none";
    if (typeof s == "object" && s !== null && (typeof a == "object" && a !== null)) {
      const u = Array.isArray(s), f = Array.isArray(a);
      if (u && f)
        return (0, t.createArrayPatch)(s, a);
      if (!u && !f)
        return (0, t.createObjectPatch)(s, a);
    }
    return "reset";
  }, i = (s, a) => {
    const l = [], c = {}, u = {};
    let f = 0, d = 0, h = 0;
    for (const p in s) {
      const y = e(s[p]);
      if (y === void 0)
        continue;
      f += 1;
      const b = e(a[p]);
      if (b === void 0) {
        l.push(p);
        continue;
      }
      const x = n(y, b);
      x === "reset" ? (c[p] = b, d += 1) : x !== "none" && (u[p] = x, h += 1);
    }
    if (f && l.length + d === f)
      return "reset";
    for (const p in a) {
      const y = e(a[p]);
      if (y === void 0)
        continue;
      if (f === 0)
        return "reset";
      e(s[p]) === void 0 && (c[p] = y, d += 1);
    }
    const g = { t: "o" };
    return l.length && (g.r = l), d && (g.s = c), h && (g.p = u), !g.r && !g.s && !g.p ? "none" : g;
  };
  t.createObjectPatch = i;
  const o = (s, a) => {
    const l = s.length, c = a.length;
    let u, f, d, h, g;
    for (h = 0; h < l && h < c; h += 1) {
      const V = e(s[h]), te = e(a[h]);
      if (g = n(V, te), g !== "none")
        break;
    }
    if (h === l)
      return h === c ? "none" : { t: "a", s: [[
        l,
        0,
        ...a.slice(h, c).map(e)
      ]] };
    if (h === c)
      return { t: "a", s: [[h, l - h]] };
    let p = l - 1, y = c - 1, b;
    for (; p >= h && y >= h && (u = e(s[p]), f = e(a[y]), b = n(u, f), b === "none"); )
      p -= 1, y -= 1;
    if (p < h)
      return { t: "a", s: [[
        h,
        0,
        ...a.slice(h, y + 1).map(e)
      ]] };
    if (y < h)
      return { t: "a", s: [[h, p - h + 1]] };
    const x = p - h + 1, S = y - h + 1, O = x * S, _ = x + 1, B = new Array(O);
    B[0] = g, B[O - 1] = b;
    let N, j, W, G, ee, fe;
    N = { 1: 0 };
    e:
      for (j = 0; j < O; j++)
        for (N = Object.create(N), W = -j; W <= j; W += 2) {
          for (W === -j || W !== j && N[W - 1] < N[W + 1] ? G = N[W + 1] : G = N[W - 1] + 1, ee = G - W, d = ee * x + G; d < O && G < x && ee < S && (fe = B[d], fe || (u = e(s[h + G]), f = e(a[h + ee]), fe = B[d] = n(u, f)), fe !== "reset"); )
            G++, ee++, d += _;
          if (N[W] = G, G >= x && ee >= S)
            break e;
        }
    let P = !1;
    const z = {}, U = [];
    if (j === O) {
      if (h === 0 && x === l)
        return "reset";
      U.push([h, x, ...a.slice(h, y + 1)]);
    } else {
      W = x - S;
      let V = [NaN, NaN];
      for (; j-- >= 0; ) {
        const te = N[W - 1] === void 0 || N[W + 1] !== void 0 && N[W - 1] < N[W + 1];
        W = te ? W + 1 : W - 1, G = N[W], ee = G - W;
        const X = h + G;
        for (te ? (ee !== -1 && (V[0] === X ? (f = e(a[h + ee]), V.splice(2, 0, f)) : U.push(V = [X, 0, a[h + ee]])), ee++) : (ee !== -1 && (V[0] === X + 1 ? (V[0] -= 1, V[1] += 1) : U.push(V = [X, 1])), G++), d = ee * x + G; d < O && G < x && ee < S && (fe = B[d], fe !== "reset"); )
          fe !== "none" && (z[h + G] = fe, P = !0), G++, ee++, d += _;
        N = Object.getPrototypeOf(N);
      }
    }
    const I = { t: "a" };
    return P && (I.p = z), U.length && (I.s = U), I;
  };
  t.createArrayPatch = o;
})(U0);
var an = {};
Object.defineProperty(an, "__esModule", { value: !0 });
an.applyArrayPatch = an.applyObjectPatch = an.applyPatch = void 0;
function z0(t = !1) {
  const e = (i, o) => {
    if (o.t === "o")
      return r(i, o);
    if (o.t === "a")
      return n(i, o);
    throw Error("Invalid patch");
  }, r = (i, o) => {
    let s = t ? i : Object.assign({}, i);
    const a = o.r;
    if (a)
      for (const u of a)
        delete s[u];
    const l = o.s;
    if (l)
      for (const u in l)
        s[u] = l[u];
    const c = o.p;
    if (c)
      for (const u in c)
        s[u] = e(s[u], c[u]);
    return s;
  }, n = (i, o) => {
    const s = t ? i : [...i], a = o.p;
    if (a)
      for (const c in a)
        s[c] = e(s[c], a[c]);
    const l = o.s;
    if (l)
      for (let c of l)
        s.splice(...c);
    return s;
  };
  return { applyPatch: e, applyObjectPatch: r, applyArrayPatch: n };
}
const yu = z0(), bu = z0(!0);
an.applyPatch = Object.assign(yu.applyPatch, {
  /**
   * Variant that modifies the target value in-place.
   */
  inPlace: bu.applyPatch
});
an.applyObjectPatch = Object.assign(yu.applyObjectPatch, {
  /**
   * Variant that modifies the target object in-place.
   */
  inPlace: bu.applyObjectPatch
});
an.applyArrayPatch = Object.assign(yu.applyArrayPatch, {
  /**
   * Variant that modifies the target array in-place.
   */
  inPlace: bu.applyArrayPatch
});
(function(t) {
  var e = ds && ds.__createBinding || (Object.create ? function(n, i, o, s) {
    s === void 0 && (s = o);
    var a = Object.getOwnPropertyDescriptor(i, o);
    (!a || ("get" in a ? !i.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(n, s, a);
  } : function(n, i, o, s) {
    s === void 0 && (s = o), n[s] = i[o];
  }), r = ds && ds.__exportStar || function(n, i) {
    for (var o in n)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, n, o);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(W0, t), r(U0, t), r(an, t);
})(j0);
var ln = {
  DEBUG: !1,
  LIB_VERSION: "2.45.0"
}, Dt;
if (typeof window > "u") {
  var id = {
    hostname: ""
  };
  Dt = {
    navigator: { userAgent: "" },
    document: {
      location: id,
      referrer: ""
    },
    screen: { width: 0, height: 0 },
    location: id
  };
} else
  Dt = window;
var Wa = Array.prototype, bb = Function.prototype, V0 = Object.prototype, $r = Wa.slice, Xo = V0.toString, Ua = V0.hasOwnProperty, yt = Dt.console, Br = Dt.navigator, rt = Dt.document, Wi = Dt.opera, aa = Dt.screen, cr = Br.userAgent, Fl = bb.bind, od = Wa.forEach, sd = Wa.indexOf, ad = Wa.map, vb = Array.isArray, Ec = {}, T = {
  trim: function(t) {
    return t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  }
}, et = {
  /** @type {function(...*)} */
  log: function() {
    if (ln.DEBUG && !T.isUndefined(yt) && yt)
      try {
        yt.log.apply(yt, arguments);
      } catch {
        T.each(arguments, function(e) {
          yt.log(e);
        });
      }
  },
  /** @type {function(...*)} */
  warn: function() {
    if (ln.DEBUG && !T.isUndefined(yt) && yt) {
      var t = ["Mixpanel warning:"].concat(T.toArray(arguments));
      try {
        yt.warn.apply(yt, t);
      } catch {
        T.each(t, function(r) {
          yt.warn(r);
        });
      }
    }
  },
  /** @type {function(...*)} */
  error: function() {
    if (ln.DEBUG && !T.isUndefined(yt) && yt) {
      var t = ["Mixpanel error:"].concat(T.toArray(arguments));
      try {
        yt.error.apply(yt, t);
      } catch {
        T.each(t, function(r) {
          yt.error(r);
        });
      }
    }
  },
  /** @type {function(...*)} */
  critical: function() {
    if (!T.isUndefined(yt) && yt) {
      var t = ["Mixpanel error:"].concat(T.toArray(arguments));
      try {
        yt.error.apply(yt, t);
      } catch {
        T.each(t, function(r) {
          yt.error(r);
        });
      }
    }
  }
}, jl = function(t, e) {
  return function() {
    return arguments[0] = "[" + e + "] " + arguments[0], t.apply(et, arguments);
  };
}, vu = function(t) {
  return {
    log: jl(et.log, t),
    error: jl(et.error, t),
    critical: jl(et.critical, t)
  };
};
T.bind = function(t, e) {
  var r, n;
  if (Fl && t.bind === Fl)
    return Fl.apply(t, $r.call(arguments, 1));
  if (!T.isFunction(t))
    throw new TypeError();
  return r = $r.call(arguments, 2), n = function() {
    if (!(this instanceof n))
      return t.apply(e, r.concat($r.call(arguments)));
    var i = {};
    i.prototype = t.prototype;
    var o = new i();
    i.prototype = null;
    var s = t.apply(o, r.concat($r.call(arguments)));
    return Object(s) === s ? s : o;
  }, n;
};
T.each = function(t, e, r) {
  if (t != null) {
    if (od && t.forEach === od)
      t.forEach(e, r);
    else if (t.length === +t.length) {
      for (var n = 0, i = t.length; n < i; n++)
        if (n in t && e.call(r, t[n], n, t) === Ec)
          return;
    } else
      for (var o in t)
        if (Ua.call(t, o) && e.call(r, t[o], o, t) === Ec)
          return;
  }
};
T.extend = function(t) {
  return T.each($r.call(arguments, 1), function(e) {
    for (var r in e)
      e[r] !== void 0 && (t[r] = e[r]);
  }), t;
};
T.isArray = vb || function(t) {
  return Xo.call(t) === "[object Array]";
};
T.isFunction = function(t) {
  try {
    return /^\s*\bfunction\b/.test(t);
  } catch {
    return !1;
  }
};
T.isArguments = function(t) {
  return !!(t && Ua.call(t, "callee"));
};
T.toArray = function(t) {
  return t ? t.toArray ? t.toArray() : T.isArray(t) || T.isArguments(t) ? $r.call(t) : T.values(t) : [];
};
T.map = function(t, e, r) {
  if (ad && t.map === ad)
    return t.map(e, r);
  var n = [];
  return T.each(t, function(i) {
    n.push(e.call(r, i));
  }), n;
};
T.keys = function(t) {
  var e = [];
  return t === null || T.each(t, function(r, n) {
    e[e.length] = n;
  }), e;
};
T.values = function(t) {
  var e = [];
  return t === null || T.each(t, function(r) {
    e[e.length] = r;
  }), e;
};
T.include = function(t, e) {
  var r = !1;
  return t === null ? r : sd && t.indexOf === sd ? t.indexOf(e) != -1 : (T.each(t, function(n) {
    if (r || (r = n === e))
      return Ec;
  }), r);
};
T.includes = function(t, e) {
  return t.indexOf(e) !== -1;
};
T.inherit = function(t, e) {
  return t.prototype = new e(), t.prototype.constructor = t, t.superclass = e.prototype, t;
};
T.isObject = function(t) {
  return t === Object(t) && !T.isArray(t);
};
T.isEmptyObject = function(t) {
  if (T.isObject(t)) {
    for (var e in t)
      if (Ua.call(t, e))
        return !1;
    return !0;
  }
  return !1;
};
T.isUndefined = function(t) {
  return t === void 0;
};
T.isString = function(t) {
  return Xo.call(t) == "[object String]";
};
T.isDate = function(t) {
  return Xo.call(t) == "[object Date]";
};
T.isNumber = function(t) {
  return Xo.call(t) == "[object Number]";
};
T.isElement = function(t) {
  return !!(t && t.nodeType === 1);
};
T.encodeDates = function(t) {
  return T.each(t, function(e, r) {
    T.isDate(e) ? t[r] = T.formatDate(e) : T.isObject(e) && (t[r] = T.encodeDates(e));
  }), t;
};
T.timestamp = function() {
  return Date.now = Date.now || function() {
    return +/* @__PURE__ */ new Date();
  }, Date.now();
};
T.formatDate = function(t) {
  function e(r) {
    return r < 10 ? "0" + r : r;
  }
  return t.getUTCFullYear() + "-" + e(t.getUTCMonth() + 1) + "-" + e(t.getUTCDate()) + "T" + e(t.getUTCHours()) + ":" + e(t.getUTCMinutes()) + ":" + e(t.getUTCSeconds());
};
T.strip_empty_properties = function(t) {
  var e = {};
  return T.each(t, function(r, n) {
    T.isString(r) && r.length > 0 && (e[n] = r);
  }), e;
};
T.truncate = function(t, e) {
  var r;
  return typeof t == "string" ? r = t.slice(0, e) : T.isArray(t) ? (r = [], T.each(t, function(n) {
    r.push(T.truncate(n, e));
  })) : T.isObject(t) ? (r = {}, T.each(t, function(n, i) {
    r[i] = T.truncate(n, e);
  })) : r = t, r;
};
T.JSONEncode = function() {
  return function(t) {
    var e = t, r = function(i) {
      var o = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, s = {
        // table of character substitutions
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      };
      return o.lastIndex = 0, o.test(i) ? '"' + i.replace(o, function(a) {
        var l = s[a];
        return typeof l == "string" ? l : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + i + '"';
    }, n = function(i, o) {
      var s = "", a = "    ", l = 0, c = "", u = "", f = 0, d = s, h = [], g = o[i];
      switch (g && typeof g == "object" && typeof g.toJSON == "function" && (g = g.toJSON(i)), typeof g) {
        case "string":
          return r(g);
        case "number":
          return isFinite(g) ? String(g) : "null";
        case "boolean":
        case "null":
          return String(g);
        case "object":
          if (!g)
            return "null";
          if (s += a, h = [], Xo.apply(g) === "[object Array]") {
            for (f = g.length, l = 0; l < f; l += 1)
              h[l] = n(l, g) || "null";
            return u = h.length === 0 ? "[]" : s ? `[
` + s + h.join(`,
` + s) + `
` + d + "]" : "[" + h.join(",") + "]", s = d, u;
          }
          for (c in g)
            Ua.call(g, c) && (u = n(c, g), u && h.push(r(c) + (s ? ": " : ":") + u));
          return u = h.length === 0 ? "{}" : s ? "{" + h.join(",") + d + "}" : "{" + h.join(",") + "}", s = d, u;
      }
    };
    return n("", {
      "": e
    });
  };
}();
T.JSONDecode = function() {
  var t, e, r = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, n, i = function(h) {
    var g = new SyntaxError(h);
    throw g.at = t, g.text = n, g;
  }, o = function(h) {
    return h && h !== e && i("Expected '" + h + "' instead of '" + e + "'"), e = n.charAt(t), t += 1, e;
  }, s = function() {
    var h, g = "";
    for (e === "-" && (g = "-", o("-")); e >= "0" && e <= "9"; )
      g += e, o();
    if (e === ".")
      for (g += "."; o() && e >= "0" && e <= "9"; )
        g += e;
    if (e === "e" || e === "E")
      for (g += e, o(), (e === "-" || e === "+") && (g += e, o()); e >= "0" && e <= "9"; )
        g += e, o();
    if (h = +g, !isFinite(h))
      i("Bad number");
    else
      return h;
  }, a = function() {
    var h, g, p = "", y;
    if (e === '"')
      for (; o(); ) {
        if (e === '"')
          return o(), p;
        if (e === "\\")
          if (o(), e === "u") {
            for (y = 0, g = 0; g < 4 && (h = parseInt(o(), 16), !!isFinite(h)); g += 1)
              y = y * 16 + h;
            p += String.fromCharCode(y);
          } else if (typeof r[e] == "string")
            p += r[e];
          else
            break;
        else
          p += e;
      }
    i("Bad string");
  }, l = function() {
    for (; e && e <= " "; )
      o();
  }, c = function() {
    switch (e) {
      case "t":
        return o("t"), o("r"), o("u"), o("e"), !0;
      case "f":
        return o("f"), o("a"), o("l"), o("s"), o("e"), !1;
      case "n":
        return o("n"), o("u"), o("l"), o("l"), null;
    }
    i('Unexpected "' + e + '"');
  }, u, f = function() {
    var h = [];
    if (e === "[") {
      if (o("["), l(), e === "]")
        return o("]"), h;
      for (; e; ) {
        if (h.push(u()), l(), e === "]")
          return o("]"), h;
        o(","), l();
      }
    }
    i("Bad array");
  }, d = function() {
    var h, g = {};
    if (e === "{") {
      if (o("{"), l(), e === "}")
        return o("}"), g;
      for (; e; ) {
        if (h = a(), l(), o(":"), Object.hasOwnProperty.call(g, h) && i('Duplicate key "' + h + '"'), g[h] = u(), l(), e === "}")
          return o("}"), g;
        o(","), l();
      }
    }
    i("Bad object");
  };
  return u = function() {
    switch (l(), e) {
      case "{":
        return d();
      case "[":
        return f();
      case '"':
        return a();
      case "-":
        return s();
      default:
        return e >= "0" && e <= "9" ? s() : c();
    }
  }, function(h) {
    var g;
    return n = h, t = 0, e = " ", g = u(), l(), e && i("Syntax error"), g;
  };
}();
T.base64Encode = function(t) {
  var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", r, n, i, o, s, a, l, c, u = 0, f = 0, d = "", h = [];
  if (!t)
    return t;
  t = T.utf8Encode(t);
  do
    r = t.charCodeAt(u++), n = t.charCodeAt(u++), i = t.charCodeAt(u++), c = r << 16 | n << 8 | i, o = c >> 18 & 63, s = c >> 12 & 63, a = c >> 6 & 63, l = c & 63, h[f++] = e.charAt(o) + e.charAt(s) + e.charAt(a) + e.charAt(l);
  while (u < t.length);
  switch (d = h.join(""), t.length % 3) {
    case 1:
      d = d.slice(0, -2) + "==";
      break;
    case 2:
      d = d.slice(0, -1) + "=";
      break;
  }
  return d;
};
T.utf8Encode = function(t) {
  t = (t + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`);
  var e = "", r, n, i = 0, o;
  for (r = n = 0, i = t.length, o = 0; o < i; o++) {
    var s = t.charCodeAt(o), a = null;
    s < 128 ? n++ : s > 127 && s < 2048 ? a = String.fromCharCode(s >> 6 | 192, s & 63 | 128) : a = String.fromCharCode(s >> 12 | 224, s >> 6 & 63 | 128, s & 63 | 128), a !== null && (n > r && (e += t.substring(r, n)), e += a, r = n = o + 1);
  }
  return n > r && (e += t.substring(r, t.length)), e;
};
T.UUID = function() {
  var t = function() {
    for (var n = 1 * /* @__PURE__ */ new Date(), i = 0; n == 1 * /* @__PURE__ */ new Date(); )
      i++;
    return n.toString(16) + i.toString(16);
  }, e = function() {
    return Math.random().toString(16).replace(".", "");
  }, r = function() {
    var n = cr, i, o, s = [], a = 0;
    function l(c, u) {
      var f, d = 0;
      for (f = 0; f < u.length; f++)
        d |= s[f] << f * 8;
      return c ^ d;
    }
    for (i = 0; i < n.length; i++)
      o = n.charCodeAt(i), s.unshift(o & 255), s.length >= 4 && (a = l(a, s), s = []);
    return s.length > 0 && (a = l(a, s)), a.toString(16);
  };
  return function() {
    var n = (aa.height * aa.width).toString(16);
    return t() + "-" + e() + "-" + r() + "-" + n + "-" + t();
  };
}();
var ld = [
  "ahrefsbot",
  "baiduspider",
  "bingbot",
  "bingpreview",
  "facebookexternal",
  "petalbot",
  "pinterest",
  "screaming frog",
  "yahoo! slurp",
  "yandexbot",
  // a whole bunch of goog-specific crawlers
  // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
  "adsbot-google",
  "apis-google",
  "duplexweb-google",
  "feedfetcher-google",
  "google favicon",
  "google web preview",
  "google-read-aloud",
  "googlebot",
  "googleweblight",
  "mediapartners-google",
  "storebot-google"
];
T.isBlockedUA = function(t) {
  var e;
  for (t = t.toLowerCase(), e = 0; e < ld.length; e++)
    if (t.indexOf(ld[e]) !== -1)
      return !0;
  return !1;
};
T.HTTPBuildQuery = function(t, e) {
  var r, n, i = [];
  return T.isUndefined(e) && (e = "&"), T.each(t, function(o, s) {
    r = encodeURIComponent(o.toString()), n = encodeURIComponent(s), i[i.length] = n + "=" + r;
  }), i.join(e);
};
T.getQueryParam = function(t, e) {
  e = e.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var r = "[\\?&]" + e + "=([^&#]*)", n = new RegExp(r), i = n.exec(t);
  if (i === null || i && typeof i[1] != "string" && i[1].length)
    return "";
  var o = i[1];
  try {
    o = decodeURIComponent(o);
  } catch {
    et.error("Skipping decoding for malformed query param: " + o);
  }
  return o.replace(/\+/g, " ");
};
T.cookie = {
  get: function(t) {
    for (var e = t + "=", r = rt.cookie.split(";"), n = 0; n < r.length; n++) {
      for (var i = r[n]; i.charAt(0) == " "; )
        i = i.substring(1, i.length);
      if (i.indexOf(e) === 0)
        return decodeURIComponent(i.substring(e.length, i.length));
    }
    return null;
  },
  parse: function(t) {
    var e;
    try {
      e = T.JSONDecode(T.cookie.get(t)) || {};
    } catch {
    }
    return e;
  },
  set_seconds: function(t, e, r, n, i, o, s) {
    var a = "", l = "", c = "";
    if (s)
      a = "; domain=" + s;
    else if (n) {
      var u = cd(rt.location.hostname);
      a = u ? "; domain=." + u : "";
    }
    if (r) {
      var f = /* @__PURE__ */ new Date();
      f.setTime(f.getTime() + r * 1e3), l = "; expires=" + f.toGMTString();
    }
    o && (i = !0, c = "; SameSite=None"), i && (c += "; secure"), rt.cookie = t + "=" + encodeURIComponent(e) + l + "; path=/" + a + c;
  },
  set: function(t, e, r, n, i, o, s) {
    var a = "", l = "", c = "";
    if (s)
      a = "; domain=" + s;
    else if (n) {
      var u = cd(rt.location.hostname);
      a = u ? "; domain=." + u : "";
    }
    if (r) {
      var f = /* @__PURE__ */ new Date();
      f.setTime(f.getTime() + r * 24 * 60 * 60 * 1e3), l = "; expires=" + f.toGMTString();
    }
    o && (i = !0, c = "; SameSite=None"), i && (c += "; secure");
    var d = t + "=" + encodeURIComponent(e) + l + "; path=/" + a + c;
    return rt.cookie = d, d;
  },
  remove: function(t, e, r) {
    T.cookie.set(t, "", -1, e, !1, !1, r);
  }
};
var Wl = null, la = function(t, e) {
  if (Wl !== null && !e)
    return Wl;
  var r = !0;
  try {
    t = t || window.localStorage;
    var n = "__mplss_" + Au(8), i = "xyz";
    t.setItem(n, i), t.getItem(n) !== i && (r = !1), t.removeItem(n);
  } catch {
    r = !1;
  }
  return Wl = r, r;
};
T.localStorage = {
  is_supported: function(t) {
    var e = la(null, t);
    return e || et.error("localStorage unsupported; falling back to cookie store"), e;
  },
  error: function(t) {
    et.error("localStorage error: " + t);
  },
  get: function(t) {
    try {
      return window.localStorage.getItem(t);
    } catch (e) {
      T.localStorage.error(e);
    }
    return null;
  },
  parse: function(t) {
    try {
      return T.JSONDecode(T.localStorage.get(t)) || {};
    } catch {
    }
    return null;
  },
  set: function(t, e) {
    try {
      window.localStorage.setItem(t, e);
    } catch (r) {
      T.localStorage.error(r);
    }
  },
  remove: function(t) {
    try {
      window.localStorage.removeItem(t);
    } catch (e) {
      T.localStorage.error(e);
    }
  }
};
T.register_event = function() {
  var t = function(n, i, o, s, a) {
    if (!n) {
      et.error("No valid element provided to register_event");
      return;
    }
    if (n.addEventListener && !s)
      n.addEventListener(i, o, !!a);
    else {
      var l = "on" + i, c = n[l];
      n[l] = e(n, o, c);
    }
  };
  function e(n, i, o) {
    var s = function(a) {
      if (a = a || r(window.event), !!a) {
        var l = !0, c, u;
        return T.isFunction(o) && (c = o(a)), u = i.call(n, a), (c === !1 || u === !1) && (l = !1), l;
      }
    };
    return s;
  }
  function r(n) {
    return n && (n.preventDefault = r.preventDefault, n.stopPropagation = r.stopPropagation), n;
  }
  return r.preventDefault = function() {
    this.returnValue = !1;
  }, r.stopPropagation = function() {
    this.cancelBubble = !0;
  }, t;
}();
var Ab = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
T.dom_query = function() {
  function t(i) {
    return i.all ? i.all : i.getElementsByTagName("*");
  }
  var e = /[\t\r\n]/g;
  function r(i, o) {
    var s = " " + o + " ";
    return (" " + i.className + " ").replace(e, " ").indexOf(s) >= 0;
  }
  function n(i) {
    if (!rt.getElementsByTagName)
      return [];
    var o = i.split(" "), s, a, l, c, u, f, d, h, g, p, y = [rt];
    for (f = 0; f < o.length; f++) {
      if (s = o[f].replace(/^\s+/, "").replace(/\s+$/, ""), s.indexOf("#") > -1) {
        a = s.split("#"), l = a[0];
        var b = a[1], x = rt.getElementById(b);
        if (!x || l && x.nodeName.toLowerCase() != l)
          return [];
        y = [x];
        continue;
      }
      if (s.indexOf(".") > -1) {
        a = s.split("."), l = a[0];
        var S = a[1];
        for (l || (l = "*"), c = [], u = 0, d = 0; d < y.length; d++)
          for (l == "*" ? g = t(y[d]) : g = y[d].getElementsByTagName(l), h = 0; h < g.length; h++)
            c[u++] = g[h];
        for (y = [], p = 0, d = 0; d < c.length; d++)
          c[d].className && T.isString(c[d].className) && // some SVG elements have classNames which are not strings
          r(c[d], S) && (y[p++] = c[d]);
        continue;
      }
      var O = s.match(Ab);
      if (O) {
        l = O[1];
        var _ = O[2], B = O[3], N = O[4];
        for (l || (l = "*"), c = [], u = 0, d = 0; d < y.length; d++)
          for (l == "*" ? g = t(y[d]) : g = y[d].getElementsByTagName(l), h = 0; h < g.length; h++)
            c[u++] = g[h];
        y = [], p = 0;
        var j;
        switch (B) {
          case "=":
            j = function(W) {
              return W.getAttribute(_) == N;
            };
            break;
          case "~":
            j = function(W) {
              return W.getAttribute(_).match(new RegExp("\\b" + N + "\\b"));
            };
            break;
          case "|":
            j = function(W) {
              return W.getAttribute(_).match(new RegExp("^" + N + "-?"));
            };
            break;
          case "^":
            j = function(W) {
              return W.getAttribute(_).indexOf(N) === 0;
            };
            break;
          case "$":
            j = function(W) {
              return W.getAttribute(_).lastIndexOf(N) == W.getAttribute(_).length - N.length;
            };
            break;
          case "*":
            j = function(W) {
              return W.getAttribute(_).indexOf(N) > -1;
            };
            break;
          default:
            j = function(W) {
              return W.getAttribute(_);
            };
        }
        for (y = [], p = 0, d = 0; d < c.length; d++)
          j(c[d]) && (y[p++] = c[d]);
        continue;
      }
      for (l = s, c = [], u = 0, d = 0; d < y.length; d++)
        for (g = y[d].getElementsByTagName(l), h = 0; h < g.length; h++)
          c[u++] = g[h];
      y = c;
    }
    return y;
  }
  return function(i) {
    return T.isElement(i) ? [i] : T.isObject(i) && !T.isUndefined(i.length) ? i : n.call(this, i);
  };
}();
T.info = {
  campaignParams: function() {
    var t = "utm_source utm_medium utm_campaign utm_content utm_term".split(" "), e = "", r = {};
    return T.each(t, function(n) {
      e = T.getQueryParam(rt.URL, n), e.length && (r[n] = e);
    }), r;
  },
  searchEngine: function(t) {
    return t.search("https?://(.*)google.([^/?]*)") === 0 ? "google" : t.search("https?://(.*)bing.com") === 0 ? "bing" : t.search("https?://(.*)yahoo.com") === 0 ? "yahoo" : t.search("https?://(.*)duckduckgo.com") === 0 ? "duckduckgo" : null;
  },
  searchInfo: function(t) {
    var e = T.info.searchEngine(t), r = e != "yahoo" ? "q" : "p", n = {};
    if (e !== null) {
      n.$search_engine = e;
      var i = T.getQueryParam(t, r);
      i.length && (n.mp_keyword = i);
    }
    return n;
  },
  /**
   * This function detects which browser is running this script.
   * The order of the checks are important since many user agents
   * include key words used in later checks.
   */
  browser: function(t, e, r) {
    return e = e || "", r || T.includes(t, " OPR/") ? T.includes(t, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(t) ? "BlackBerry" : T.includes(t, "IEMobile") || T.includes(t, "WPDesktop") ? "Internet Explorer Mobile" : T.includes(t, "SamsungBrowser/") ? "Samsung Internet" : T.includes(t, "Edge") || T.includes(t, "Edg/") ? "Microsoft Edge" : T.includes(t, "FBIOS") ? "Facebook Mobile" : T.includes(t, "Chrome") ? "Chrome" : T.includes(t, "CriOS") ? "Chrome iOS" : T.includes(t, "UCWEB") || T.includes(t, "UCBrowser") ? "UC Browser" : T.includes(t, "FxiOS") ? "Firefox iOS" : T.includes(e, "Apple") ? T.includes(t, "Mobile") ? "Mobile Safari" : "Safari" : T.includes(t, "Android") ? "Android Mobile" : T.includes(t, "Konqueror") ? "Konqueror" : T.includes(t, "Firefox") ? "Firefox" : T.includes(t, "MSIE") || T.includes(t, "Trident/") ? "Internet Explorer" : T.includes(t, "Gecko") ? "Mozilla" : "";
  },
  /**
   * This function detects which browser version is running this script,
   * parsing major and minor version (e.g., 42.1). User agent strings from:
   * http://www.useragentstring.com/pages/useragentstring.php
   */
  browserVersion: function(t, e, r) {
    var n = T.info.browser(t, e, r), i = {
      "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
      "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
      Chrome: /Chrome\/(\d+(\.\d+)?)/,
      "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
      "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
      Safari: /Version\/(\d+(\.\d+)?)/,
      "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
      Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
      Firefox: /Firefox\/(\d+(\.\d+)?)/,
      "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
      Konqueror: /Konqueror:(\d+(\.\d+)?)/,
      BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
      "Android Mobile": /android\s(\d+(\.\d+)?)/,
      "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
      "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
      Mozilla: /rv:(\d+(\.\d+)?)/
    }, o = i[n];
    if (o === void 0)
      return null;
    var s = t.match(o);
    return s ? parseFloat(s[s.length - 2]) : null;
  },
  os: function() {
    var t = cr;
    return /Windows/i.test(t) ? /Phone/.test(t) || /WPDesktop/.test(t) ? "Windows Phone" : "Windows" : /(iPhone|iPad|iPod)/.test(t) ? "iOS" : /Android/.test(t) ? "Android" : /(BlackBerry|PlayBook|BB10)/i.test(t) ? "BlackBerry" : /Mac/i.test(t) ? "Mac OS X" : /Linux/.test(t) ? "Linux" : /CrOS/.test(t) ? "Chrome OS" : "";
  },
  device: function(t) {
    return /Windows Phone/i.test(t) || /WPDesktop/.test(t) ? "Windows Phone" : /iPad/.test(t) ? "iPad" : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(t) ? "BlackBerry" : /Android/.test(t) ? "Android" : "";
  },
  referringDomain: function(t) {
    var e = t.split("/");
    return e.length >= 3 ? e[2] : "";
  },
  properties: function() {
    return T.extend(T.strip_empty_properties({
      $os: T.info.os(),
      $browser: T.info.browser(cr, Br.vendor, Wi),
      $referrer: rt.referrer,
      $referring_domain: T.info.referringDomain(rt.referrer),
      $device: T.info.device(cr)
    }), {
      $current_url: Dt.location.href,
      $browser_version: T.info.browserVersion(cr, Br.vendor, Wi),
      $screen_height: aa.height,
      $screen_width: aa.width,
      mp_lib: "web",
      $lib_version: ln.LIB_VERSION,
      $insert_id: Au(),
      time: T.timestamp() / 1e3
      // epoch time in seconds
    });
  },
  people_properties: function() {
    return T.extend(T.strip_empty_properties({
      $os: T.info.os(),
      $browser: T.info.browser(cr, Br.vendor, Wi)
    }), {
      $browser_version: T.info.browserVersion(cr, Br.vendor, Wi)
    });
  },
  pageviewInfo: function(t) {
    return T.strip_empty_properties({
      mp_page: t,
      mp_referrer: rt.referrer,
      mp_browser: T.info.browser(cr, Br.vendor, Wi),
      mp_platform: T.info.os()
    });
  }
};
var Au = function(t) {
  var e = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
  return t ? e.substring(0, t) : e;
}, wb = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, xb = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, cd = function(t) {
  var e = xb, r = t.split("."), n = r[r.length - 1];
  (n.length > 4 || n === "com" || n === "org") && (e = wb);
  var i = t.match(e);
  return i ? i[0] : "";
}, ca = null, ua = null;
typeof JSON < "u" && (ca = JSON.stringify, ua = JSON.parse);
ca = ca || T.JSONEncode;
ua = ua || T.JSONDecode;
T.toArray = T.toArray;
T.isObject = T.isObject;
T.JSONEncode = T.JSONEncode;
T.JSONDecode = T.JSONDecode;
T.isBlockedUA = T.isBlockedUA;
T.isEmptyObject = T.isEmptyObject;
T.info = T.info;
T.info.device = T.info.device;
T.info.browser = T.info.browser;
T.info.browserVersion = T.info.browserVersion;
T.info.properties = T.info.properties;
var Kr = function() {
};
Kr.prototype.create_properties = function() {
};
Kr.prototype.event_handler = function() {
};
Kr.prototype.after_track_handler = function() {
};
Kr.prototype.init = function(t) {
  return this.mp = t, this;
};
Kr.prototype.track = function(t, e, r, n) {
  var i = this, o = T.dom_query(t);
  if (o.length === 0) {
    et.error("The DOM query (" + t + ") returned 0 elements");
    return;
  }
  return T.each(o, function(s) {
    T.register_event(s, this.override_event, function(a) {
      var l = {}, c = i.create_properties(r, this), u = i.mp.get_config("track_links_timeout");
      i.event_handler(a, this, l), window.setTimeout(i.track_callback(n, c, l, !0), u), i.mp.track(e, c, i.track_callback(n, c, l));
    });
  }, this), !0;
};
Kr.prototype.track_callback = function(t, e, r, n) {
  n = n || !1;
  var i = this;
  return function() {
    r.callback_fired || (r.callback_fired = !0, !(t && t(n, e) === !1) && i.after_track_handler(e, r, n));
  };
};
Kr.prototype.create_properties = function(t, e) {
  var r;
  return typeof t == "function" ? r = t(e) : r = T.extend({}, t), r;
};
var wi = function() {
  this.override_event = "click";
};
T.inherit(wi, Kr);
wi.prototype.create_properties = function(t, e) {
  var r = wi.superclass.create_properties.apply(this, arguments);
  return e.href && (r.url = e.href), r;
};
wi.prototype.event_handler = function(t, e, r) {
  r.new_tab = t.which === 2 || t.metaKey || t.ctrlKey || e.target === "_blank", r.href = e.href, r.new_tab || t.preventDefault();
};
wi.prototype.after_track_handler = function(t, e) {
  e.new_tab || setTimeout(function() {
    window.location = e.href;
  }, 0);
};
var za = function() {
  this.override_event = "submit";
};
T.inherit(za, Kr);
za.prototype.event_handler = function(t, e, r) {
  r.element = e, t.preventDefault();
};
za.prototype.after_track_handler = function(t, e) {
  setTimeout(function() {
    e.element.submit();
  }, 0);
};
var _b = vu("lock"), q0 = function(t, e) {
  e = e || {}, this.storageKey = t, this.storage = e.storage || window.localStorage, this.pollIntervalMS = e.pollIntervalMS || 100, this.timeoutMS = e.timeoutMS || 2e3;
};
q0.prototype.withLock = function(t, e, r) {
  !r && typeof e != "function" && (r = e, e = null);
  var n = r || (/* @__PURE__ */ new Date()).getTime() + "|" + Math.random(), i = (/* @__PURE__ */ new Date()).getTime(), o = this.storageKey, s = this.pollIntervalMS, a = this.timeoutMS, l = this.storage, c = o + ":X", u = o + ":Y", f = o + ":Z", d = function(x) {
    e && e(x);
  }, h = function(x) {
    if ((/* @__PURE__ */ new Date()).getTime() - i > a) {
      _b.error("Timeout waiting for mutex on " + o + "; clearing lock. [" + n + "]"), l.removeItem(f), l.removeItem(u), y();
      return;
    }
    setTimeout(function() {
      try {
        x();
      } catch (S) {
        d(S);
      }
    }, s * (Math.random() + 0.1));
  }, g = function(x, S) {
    x() ? S() : h(function() {
      g(x, S);
    });
  }, p = function() {
    var x = l.getItem(u);
    if (x && x !== n)
      return !1;
    if (l.setItem(u, n), l.getItem(u) === n)
      return !0;
    if (!la(l, !0))
      throw new Error("localStorage support dropped while acquiring lock");
    return !1;
  }, y = function() {
    l.setItem(c, n), g(p, function() {
      if (l.getItem(c) === n) {
        b();
        return;
      }
      h(function() {
        if (l.getItem(u) !== n) {
          y();
          return;
        }
        g(function() {
          return !l.getItem(f);
        }, b);
      });
    });
  }, b = function() {
    l.setItem(f, "1");
    try {
      t();
    } finally {
      l.removeItem(f), l.getItem(u) === n && l.removeItem(u), l.getItem(c) === n && l.removeItem(c);
    }
  };
  try {
    if (la(l, !0))
      y();
    else
      throw new Error("localStorage support check failed");
  } catch (x) {
    d(x);
  }
};
var ud = vu("batch"), mn = function(t, e) {
  e = e || {}, this.storageKey = t, this.storage = e.storage || window.localStorage, this.reportError = e.errorReporter || T.bind(ud.error, ud), this.lock = new q0(t, { storage: this.storage }), this.pid = e.pid || null, this.memQueue = [];
};
mn.prototype.enqueue = function(t, e, r) {
  var n = {
    id: Au(),
    flushAfter: (/* @__PURE__ */ new Date()).getTime() + e * 2,
    payload: t
  };
  this.lock.withLock(T.bind(function() {
    var o;
    try {
      var s = this.readFromStorage();
      s.push(n), o = this.saveToStorage(s), o && this.memQueue.push(n);
    } catch {
      this.reportError("Error enqueueing item", t), o = !1;
    }
    r && r(o);
  }, this), T.bind(function(o) {
    this.reportError("Error acquiring storage lock", o), r && r(!1);
  }, this), this.pid);
};
mn.prototype.fillBatch = function(t) {
  var e = this.memQueue.slice(0, t);
  if (e.length < t) {
    var r = this.readFromStorage();
    if (r.length) {
      var n = {};
      T.each(e, function(s) {
        n[s.id] = !0;
      });
      for (var i = 0; i < r.length; i++) {
        var o = r[i];
        if ((/* @__PURE__ */ new Date()).getTime() > o.flushAfter && !n[o.id] && (o.orphaned = !0, e.push(o), e.length >= t))
          break;
      }
    }
  }
  return e;
};
var fd = function(t, e) {
  var r = [];
  return T.each(t, function(n) {
    n.id && !e[n.id] && r.push(n);
  }), r;
};
mn.prototype.removeItemsByID = function(t, e) {
  var r = {};
  T.each(t, function(i) {
    r[i] = !0;
  }), this.memQueue = fd(this.memQueue, r);
  var n = T.bind(function() {
    var i;
    try {
      var o = this.readFromStorage();
      if (o = fd(o, r), i = this.saveToStorage(o), i) {
        o = this.readFromStorage();
        for (var s = 0; s < o.length; s++) {
          var a = o[s];
          if (a.id && r[a.id])
            return this.reportError("Item not removed from storage"), !1;
        }
      }
    } catch {
      this.reportError("Error removing items", t), i = !1;
    }
    return i;
  }, this);
  this.lock.withLock(function() {
    var o = n();
    e && e(o);
  }, T.bind(function(o) {
    var s = !1;
    if (this.reportError("Error acquiring storage lock", o), !la(this.storage, !0) && (s = n(), !s))
      try {
        this.storage.removeItem(this.storageKey);
      } catch (a) {
        this.reportError("Error clearing queue", a);
      }
    e && e(s);
  }, this), this.pid);
};
var dd = function(t, e) {
  var r = [];
  return T.each(t, function(n) {
    var i = n.id;
    if (i in e) {
      var o = e[i];
      o !== null && (n.payload = o, r.push(n));
    } else
      r.push(n);
  }), r;
};
mn.prototype.updatePayloads = function(t, e) {
  this.memQueue = dd(this.memQueue, t), this.lock.withLock(T.bind(function() {
    var n;
    try {
      var i = this.readFromStorage();
      i = dd(i, t), n = this.saveToStorage(i);
    } catch {
      this.reportError("Error updating items", t), n = !1;
    }
    e && e(n);
  }, this), T.bind(function(n) {
    this.reportError("Error acquiring storage lock", n), e && e(!1);
  }, this), this.pid);
};
mn.prototype.readFromStorage = function() {
  var t;
  try {
    t = this.storage.getItem(this.storageKey), t && (t = ua(t), T.isArray(t) || (this.reportError("Invalid storage entry:", t), t = null));
  } catch (e) {
    this.reportError("Error retrieving queue", e), t = null;
  }
  return t || [];
};
mn.prototype.saveToStorage = function(t) {
  try {
    return this.storage.setItem(this.storageKey, ca(t)), !0;
  } catch (e) {
    return this.reportError("Error saving queue", e), !1;
  }
};
mn.prototype.clear = function() {
  this.memQueue = [], this.storage.removeItem(this.storageKey);
};
var Sb = 10 * 60 * 1e3, fo = vu("batch"), Or = function(t, e) {
  this.errorReporter = e.errorReporter, this.queue = new mn(t, {
    errorReporter: T.bind(this.reportError, this),
    storage: e.storage
  }), this.libConfig = e.libConfig, this.sendRequest = e.sendRequestFunc, this.beforeSendHook = e.beforeSendHook, this.stopAllBatching = e.stopAllBatchingFunc, this.batchSize = this.libConfig.batch_size, this.flushInterval = this.libConfig.batch_flush_interval_ms, this.stopped = !this.libConfig.batch_autostart, this.consecutiveRemovalFailures = 0;
};
Or.prototype.enqueue = function(t, e) {
  this.queue.enqueue(t, this.flushInterval, e);
};
Or.prototype.start = function() {
  this.stopped = !1, this.consecutiveRemovalFailures = 0, this.flush();
};
Or.prototype.stop = function() {
  this.stopped = !0, this.timeoutID && (clearTimeout(this.timeoutID), this.timeoutID = null);
};
Or.prototype.clear = function() {
  this.queue.clear();
};
Or.prototype.resetBatchSize = function() {
  this.batchSize = this.libConfig.batch_size;
};
Or.prototype.resetFlush = function() {
  this.scheduleFlush(this.libConfig.batch_flush_interval_ms);
};
Or.prototype.scheduleFlush = function(t) {
  this.flushInterval = t, this.stopped || (this.timeoutID = setTimeout(T.bind(this.flush, this), this.flushInterval));
};
Or.prototype.flush = function(t) {
  try {
    if (this.requestInProgress) {
      fo.log("Flush: Request already in progress");
      return;
    }
    t = t || {};
    var e = this.libConfig.batch_request_timeout_ms, r = (/* @__PURE__ */ new Date()).getTime(), n = this.batchSize, i = this.queue.fillBatch(n), o = [], s = {};
    if (T.each(i, function(c) {
      var u = c.payload;
      this.beforeSendHook && !c.orphaned && (u = this.beforeSendHook(u)), u && o.push(u), s[c.id] = u;
    }, this), o.length < 1) {
      this.resetFlush();
      return;
    }
    this.requestInProgress = !0;
    var a = T.bind(function(c) {
      this.requestInProgress = !1;
      try {
        var u = !1;
        if (t.unloading)
          this.queue.updatePayloads(s);
        else if (T.isObject(c) && c.error === "timeout" && (/* @__PURE__ */ new Date()).getTime() - r >= e)
          this.reportError("Network timeout; retrying"), this.flush();
        else if (T.isObject(c) && c.xhr_req && (c.xhr_req.status >= 500 || c.xhr_req.status === 429 || c.error === "timeout")) {
          var f = this.flushInterval * 2, d = c.xhr_req.responseHeaders;
          if (d) {
            var h = d["Retry-After"];
            h && (f = parseInt(h, 10) * 1e3 || f);
          }
          f = Math.min(Sb, f), this.reportError("Error; retry in " + f + " ms"), this.scheduleFlush(f);
        } else if (T.isObject(c) && c.xhr_req && c.xhr_req.status === 413)
          if (i.length > 1) {
            var g = Math.max(1, Math.floor(n / 2));
            this.batchSize = Math.min(this.batchSize, g, i.length - 1), this.reportError("413 response; reducing batch size to " + this.batchSize), this.resetFlush();
          } else
            this.reportError("Single-event request too large; dropping", i), this.resetBatchSize(), u = !0;
        else
          u = !0;
        u && this.queue.removeItemsByID(
          T.map(i, function(p) {
            return p.id;
          }),
          T.bind(function(p) {
            p ? (this.consecutiveRemovalFailures = 0, this.flush()) : (this.reportError("Failed to remove items from queue"), ++this.consecutiveRemovalFailures > 5 ? (this.reportError("Too many queue failures; disabling batching system."), this.stopAllBatching()) : this.resetFlush());
          }, this)
        );
      } catch (p) {
        this.reportError("Error handling API response", p), this.resetFlush();
      }
    }, this), l = {
      method: "POST",
      verbose: !0,
      ignore_json_errors: !0,
      // eslint-disable-line camelcase
      timeout_ms: e
      // eslint-disable-line camelcase
    };
    t.unloading && (l.transport = "sendBeacon"), fo.log("MIXPANEL REQUEST:", o), this.sendRequest(o, l, a);
  } catch (c) {
    this.reportError("Error flushing request queue", c), this.resetFlush();
  }
};
Or.prototype.reportError = function(t, e) {
  if (fo.error.apply(fo.error, arguments), this.errorReporter)
    try {
      e instanceof Error || (e = new Error(t)), this.errorReporter(t, e);
    } catch (r) {
      fo.error(r);
    }
};
var Eb = "__mp_opt_in_out_";
function kb(t, e) {
  K0(!0, t, e);
}
function Cb(t, e) {
  K0(!1, t, e);
}
function Tb(t, e) {
  return Y0(t, e) === "1";
}
function H0(t, e) {
  if (Ib(e))
    return et.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"'), !0;
  var r = Y0(t, e) === "0";
  return r && et.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data."), r;
}
function Jo(t) {
  return _u(t, function(e) {
    return this.get_config(e);
  });
}
function yn(t) {
  return _u(t, function(e) {
    return this._get_config(e);
  });
}
function Di(t) {
  return _u(t, function(e) {
    return this._get_config(e);
  });
}
function Ob(t, e) {
  e = e || {}, wu(e).remove(
    xu(t, e),
    !!e.crossSubdomainCookie,
    e.cookieDomain
  );
}
function wu(t) {
  return t = t || {}, t.persistenceType === "localStorage" ? T.localStorage : T.cookie;
}
function xu(t, e) {
  return e = e || {}, (e.persistencePrefix || Eb) + t;
}
function Y0(t, e) {
  return wu(e).get(xu(t, e));
}
function Ib(t) {
  if (t && t.ignoreDnt)
    return !1;
  var e = t && t.window || Dt, r = e.navigator || {}, n = !1;
  return T.each([
    r.doNotTrack,
    // standard
    r.msDoNotTrack,
    e.doNotTrack
  ], function(i) {
    T.includes([!0, 1, "1", "yes"], i) && (n = !0);
  }), n;
}
function K0(t, e, r) {
  if (!T.isString(e) || !e.length) {
    et.error("gdpr." + (t ? "optIn" : "optOut") + " called with an invalid token");
    return;
  }
  r = r || {}, wu(r).set(
    xu(e, r),
    t ? 1 : 0,
    T.isNumber(r.cookieExpiration) ? r.cookieExpiration : null,
    !!r.crossSubdomainCookie,
    !!r.secureCookie,
    !!r.crossSiteCookie,
    r.cookieDomain
  ), r.track && t && r.track(r.trackEventName || "$opt_in", r.trackProperties, {
    send_immediately: !0
  });
}
function _u(t, e) {
  return function() {
    var r = !1;
    try {
      var n = e.call(this, "token"), i = e.call(this, "ignore_dnt"), o = e.call(this, "opt_out_tracking_persistence_type"), s = e.call(this, "opt_out_tracking_cookie_prefix"), a = e.call(this, "window");
      n && (r = H0(n, {
        ignoreDnt: i,
        persistenceType: o,
        persistencePrefix: s,
        window: a
      }));
    } catch (c) {
      et.error("Unexpected error when checking tracking opt-out status: " + c);
    }
    if (!r)
      return t.apply(this, arguments);
    var l = arguments[arguments.length - 1];
    typeof l == "function" && l(0);
  };
}
var fn = "$set", xi = "$set_once", ur = "$unset", zn = "$add", Hr = "$append", Vn = "$union", dn = "$remove", Pb = "$delete", X0 = {
  set_action: function(t, e) {
    var r = {}, n = {};
    return T.isObject(t) ? T.each(t, function(i, o) {
      this._is_reserved_property(o) || (n[o] = i);
    }, this) : n[t] = e, r[fn] = n, r;
  },
  unset_action: function(t) {
    var e = {}, r = [];
    return T.isArray(t) || (t = [t]), T.each(t, function(n) {
      this._is_reserved_property(n) || r.push(n);
    }, this), e[ur] = r, e;
  },
  set_once_action: function(t, e) {
    var r = {}, n = {};
    return T.isObject(t) ? T.each(t, function(i, o) {
      this._is_reserved_property(o) || (n[o] = i);
    }, this) : n[t] = e, r[xi] = n, r;
  },
  union_action: function(t, e) {
    var r = {}, n = {};
    return T.isObject(t) ? T.each(t, function(i, o) {
      this._is_reserved_property(o) || (n[o] = T.isArray(i) ? i : [i]);
    }, this) : n[t] = T.isArray(e) ? e : [e], r[Vn] = n, r;
  },
  append_action: function(t, e) {
    var r = {}, n = {};
    return T.isObject(t) ? T.each(t, function(i, o) {
      this._is_reserved_property(o) || (n[o] = i);
    }, this) : n[t] = e, r[Hr] = n, r;
  },
  remove_action: function(t, e) {
    var r = {}, n = {};
    return T.isObject(t) ? T.each(t, function(i, o) {
      this._is_reserved_property(o) || (n[o] = i);
    }, this) : n[t] = e, r[dn] = n, r;
  },
  delete_action: function() {
    var t = {};
    return t[Pb] = "", t;
  }
}, at = function() {
};
T.extend(at.prototype, X0);
at.prototype._init = function(t, e, r) {
  this._mixpanel = t, this._group_key = e, this._group_id = r;
};
at.prototype.set = Di(function(t, e, r) {
  var n = this.set_action(t, e);
  return T.isObject(t) && (r = e), this._send_request(n, r);
});
at.prototype.set_once = Di(function(t, e, r) {
  var n = this.set_once_action(t, e);
  return T.isObject(t) && (r = e), this._send_request(n, r);
});
at.prototype.unset = Di(function(t, e) {
  var r = this.unset_action(t);
  return this._send_request(r, e);
});
at.prototype.union = Di(function(t, e, r) {
  T.isObject(t) && (r = e);
  var n = this.union_action(t, e);
  return this._send_request(n, r);
});
at.prototype.delete = Di(function(t) {
  var e = this.delete_action();
  return this._send_request(e, t);
});
at.prototype.remove = Di(function(t, e, r) {
  var n = this.remove_action(t, e);
  return this._send_request(n, r);
});
at.prototype._send_request = function(t, e) {
  t.$group_key = this._group_key, t.$group_id = this._group_id, t.$token = this._get_config("token");
  var r = T.encodeDates(t);
  return this._mixpanel._track_or_batch({
    type: "groups",
    data: r,
    endpoint: this._get_config("api_host") + "/groups/",
    batcher: this._mixpanel.request_batchers.groups
  }, e);
};
at.prototype._is_reserved_property = function(t) {
  return t === "$group_key" || t === "$group_id";
};
at.prototype._get_config = function(t) {
  return this._mixpanel.get_config(t);
};
at.prototype.toString = function() {
  return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
at.prototype.remove = at.prototype.remove;
at.prototype.set = at.prototype.set;
at.prototype.set_once = at.prototype.set_once;
at.prototype.union = at.prototype.union;
at.prototype.unset = at.prototype.unset;
at.prototype.toString = at.prototype.toString;
var Te = function() {
};
T.extend(Te.prototype, X0);
Te.prototype._init = function(t) {
  this._mixpanel = t;
};
Te.prototype.set = yn(function(t, e, r) {
  var n = this.set_action(t, e);
  return T.isObject(t) && (r = e), this._get_config("save_referrer") && this._mixpanel.persistence.update_referrer_info(document.referrer), n[fn] = T.extend(
    {},
    T.info.people_properties(),
    this._mixpanel.persistence.get_referrer_info(),
    n[fn]
  ), this._send_request(n, r);
});
Te.prototype.set_once = yn(function(t, e, r) {
  var n = this.set_once_action(t, e);
  return T.isObject(t) && (r = e), this._send_request(n, r);
});
Te.prototype.unset = yn(function(t, e) {
  var r = this.unset_action(t);
  return this._send_request(r, e);
});
Te.prototype.increment = yn(function(t, e, r) {
  var n = {}, i = {};
  return T.isObject(t) ? (T.each(t, function(o, s) {
    if (!this._is_reserved_property(s))
      if (isNaN(parseFloat(o))) {
        et.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
        return;
      } else
        i[s] = o;
  }, this), r = e) : (T.isUndefined(e) && (e = 1), i[t] = e), n[zn] = i, this._send_request(n, r);
});
Te.prototype.append = yn(function(t, e, r) {
  T.isObject(t) && (r = e);
  var n = this.append_action(t, e);
  return this._send_request(n, r);
});
Te.prototype.remove = yn(function(t, e, r) {
  T.isObject(t) && (r = e);
  var n = this.remove_action(t, e);
  return this._send_request(n, r);
});
Te.prototype.union = yn(function(t, e, r) {
  T.isObject(t) && (r = e);
  var n = this.union_action(t, e);
  return this._send_request(n, r);
});
Te.prototype.track_charge = yn(function(t, e, r) {
  if (!T.isNumber(t) && (t = parseFloat(t), isNaN(t))) {
    et.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
    return;
  }
  return this.append("$transactions", T.extend({
    $amount: t
  }, e), r);
});
Te.prototype.clear_charges = function(t) {
  return this.set("$transactions", [], t);
};
Te.prototype.delete_user = function() {
  if (!this._identify_called()) {
    et.error("mixpanel.people.delete_user() requires you to call identify() first");
    return;
  }
  var t = { $delete: this._mixpanel.get_distinct_id() };
  return this._send_request(t);
};
Te.prototype.toString = function() {
  return this._mixpanel.toString() + ".people";
};
Te.prototype._send_request = function(t, e) {
  t.$token = this._get_config("token"), t.$distinct_id = this._mixpanel.get_distinct_id();
  var r = this._mixpanel.get_property("$device_id"), n = this._mixpanel.get_property("$user_id"), i = this._mixpanel.get_property("$had_persisted_distinct_id");
  r && (t.$device_id = r), n && (t.$user_id = n), i && (t.$had_persisted_distinct_id = i);
  var o = T.encodeDates(t);
  return this._identify_called() ? this._mixpanel._track_or_batch({
    type: "people",
    data: o,
    endpoint: this._get_config("api_host") + "/engage/",
    batcher: this._mixpanel.request_batchers.people
  }, e) : (this._enqueue(t), T.isUndefined(e) || (this._get_config("verbose") ? e({ status: -1, error: null }) : e(-1)), T.truncate(o, 255));
};
Te.prototype._get_config = function(t) {
  return this._mixpanel.get_config(t);
};
Te.prototype._identify_called = function() {
  return this._mixpanel._flags.identify_called === !0;
};
Te.prototype._enqueue = function(t) {
  fn in t ? this._mixpanel.persistence._add_to_people_queue(fn, t) : xi in t ? this._mixpanel.persistence._add_to_people_queue(xi, t) : ur in t ? this._mixpanel.persistence._add_to_people_queue(ur, t) : zn in t ? this._mixpanel.persistence._add_to_people_queue(zn, t) : Hr in t ? this._mixpanel.persistence._add_to_people_queue(Hr, t) : dn in t ? this._mixpanel.persistence._add_to_people_queue(dn, t) : Vn in t ? this._mixpanel.persistence._add_to_people_queue(Vn, t) : et.error("Invalid call to _enqueue():", t);
};
Te.prototype._flush_one_queue = function(t, e, r, n) {
  var i = this, o = T.extend({}, this._mixpanel.persistence._get_queue(t)), s = o;
  !T.isUndefined(o) && T.isObject(o) && !T.isEmptyObject(o) && (i._mixpanel.persistence._pop_from_people_queue(t, o), n && (s = n(o)), e.call(i, s, function(a, l) {
    a === 0 && i._mixpanel.persistence._add_to_people_queue(t, o), T.isUndefined(r) || r(a, l);
  }));
};
Te.prototype._flush = function(t, e, r, n, i, o, s) {
  var a = this, l = this._mixpanel.persistence._get_queue(Hr), c = this._mixpanel.persistence._get_queue(dn);
  if (this._flush_one_queue(fn, this.set, t), this._flush_one_queue(xi, this.set_once, n), this._flush_one_queue(ur, this.unset, o, function(y) {
    return T.keys(y);
  }), this._flush_one_queue(zn, this.increment, e), this._flush_one_queue(Vn, this.union, i), !T.isUndefined(l) && T.isArray(l) && l.length) {
    for (var u, f = function(y, b) {
      y === 0 && a._mixpanel.persistence._add_to_people_queue(Hr, u), T.isUndefined(r) || r(y, b);
    }, d = l.length - 1; d >= 0; d--)
      u = l.pop(), T.isEmptyObject(u) || a.append(u, f);
    a._mixpanel.persistence.save();
  }
  if (!T.isUndefined(c) && T.isArray(c) && c.length) {
    for (var h, g = function(y, b) {
      y === 0 && a._mixpanel.persistence._add_to_people_queue(dn, h), T.isUndefined(s) || s(y, b);
    }, p = c.length - 1; p >= 0; p--)
      h = c.pop(), T.isEmptyObject(h) || a.remove(h, g);
    a._mixpanel.persistence.save();
  }
};
Te.prototype._is_reserved_property = function(t) {
  return t === "$distinct_id" || t === "$token" || t === "$device_id" || t === "$user_id" || t === "$had_persisted_distinct_id";
};
Te.prototype.set = Te.prototype.set;
Te.prototype.set_once = Te.prototype.set_once;
Te.prototype.unset = Te.prototype.unset;
Te.prototype.increment = Te.prototype.increment;
Te.prototype.append = Te.prototype.append;
Te.prototype.remove = Te.prototype.remove;
Te.prototype.union = Te.prototype.union;
Te.prototype.track_charge = Te.prototype.track_charge;
Te.prototype.clear_charges = Te.prototype.clear_charges;
Te.prototype.delete_user = Te.prototype.delete_user;
Te.prototype.toString = Te.prototype.toString;
var Su = "__mps", Eu = "__mpso", ku = "__mpus", Cu = "__mpa", Tu = "__mpap", Ou = "__mpr", Iu = "__mpu", J0 = "$people_distinct_id", fa = "__alias", Eo = "__timers", Rb = [
  Su,
  Eu,
  ku,
  Cu,
  Tu,
  Ou,
  Iu,
  J0,
  fa,
  Eo
], De = function(t) {
  this.props = {}, this.campaign_params_saved = !1, t.persistence_name ? this.name = "mp_" + t.persistence_name : this.name = "mp_" + t.token + "_mixpanel";
  var e = t.persistence;
  e !== "cookie" && e !== "localStorage" && (et.critical("Unknown persistence type " + e + "; falling back to cookie"), e = t.persistence = "cookie"), e === "localStorage" && T.localStorage.is_supported() ? this.storage = T.localStorage : this.storage = T.cookie, this.load(), this.update_config(t), this.upgrade(t), this.save();
};
De.prototype.properties = function() {
  var t = {};
  return T.each(this.props, function(e, r) {
    T.include(Rb, r) || (t[r] = e);
  }), t;
};
De.prototype.load = function() {
  if (!this.disabled) {
    var t = this.storage.parse(this.name);
    t && (this.props = T.extend({}, t));
  }
};
De.prototype.upgrade = function(t) {
  var e = t.upgrade, r, n;
  e && (r = "mp_super_properties", typeof e == "string" && (r = e), n = this.storage.parse(r), this.storage.remove(r), this.storage.remove(r, !0), n && (this.props = T.extend(
    this.props,
    n.all,
    n.events
  ))), !t.cookie_name && t.name !== "mixpanel" && (r = "mp_" + t.token + "_" + t.name, n = this.storage.parse(r), n && (this.storage.remove(r), this.storage.remove(r, !0), this.register_once(n))), this.storage === T.localStorage && (n = T.cookie.parse(this.name), T.cookie.remove(this.name), T.cookie.remove(this.name, !0), n && this.register_once(n));
};
De.prototype.save = function() {
  this.disabled || this.storage.set(
    this.name,
    T.JSONEncode(this.props),
    this.expire_days,
    this.cross_subdomain,
    this.secure,
    this.cross_site,
    this.cookie_domain
  );
};
De.prototype.remove = function() {
  this.storage.remove(this.name, !1, this.cookie_domain), this.storage.remove(this.name, !0, this.cookie_domain);
};
De.prototype.clear = function() {
  this.remove(), this.props = {};
};
De.prototype.register_once = function(t, e, r) {
  return T.isObject(t) ? (typeof e > "u" && (e = "None"), this.expire_days = typeof r > "u" ? this.default_expiry : r, T.each(t, function(n, i) {
    (!this.props.hasOwnProperty(i) || this.props[i] === e) && (this.props[i] = n);
  }, this), this.save(), !0) : !1;
};
De.prototype.register = function(t, e) {
  return T.isObject(t) ? (this.expire_days = typeof e > "u" ? this.default_expiry : e, T.extend(this.props, t), this.save(), !0) : !1;
};
De.prototype.unregister = function(t) {
  t in this.props && (delete this.props[t], this.save());
};
De.prototype.update_campaign_params = function() {
  this.campaign_params_saved || (this.register_once(T.info.campaignParams()), this.campaign_params_saved = !0);
};
De.prototype.update_search_keyword = function(t) {
  this.register(T.info.searchInfo(t));
};
De.prototype.update_referrer_info = function(t) {
  this.register_once({
    $initial_referrer: t || "$direct",
    $initial_referring_domain: T.info.referringDomain(t) || "$direct"
  }, "");
};
De.prototype.get_referrer_info = function() {
  return T.strip_empty_properties({
    $initial_referrer: this.props.$initial_referrer,
    $initial_referring_domain: this.props.$initial_referring_domain
  });
};
De.prototype.safe_merge = function(t) {
  return T.each(this.props, function(e, r) {
    r in t || (t[r] = e);
  }), t;
};
De.prototype.update_config = function(t) {
  this.default_expiry = this.expire_days = t.cookie_expiration, this.set_disabled(t.disable_persistence), this.set_cookie_domain(t.cookie_domain), this.set_cross_site(t.cross_site_cookie), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie);
};
De.prototype.set_disabled = function(t) {
  this.disabled = t, this.disabled ? this.remove() : this.save();
};
De.prototype.set_cookie_domain = function(t) {
  t !== this.cookie_domain && (this.remove(), this.cookie_domain = t, this.save());
};
De.prototype.set_cross_site = function(t) {
  t !== this.cross_site && (this.cross_site = t, this.remove(), this.save());
};
De.prototype.set_cross_subdomain = function(t) {
  t !== this.cross_subdomain && (this.cross_subdomain = t, this.remove(), this.save());
};
De.prototype.get_cross_subdomain = function() {
  return this.cross_subdomain;
};
De.prototype.set_secure = function(t) {
  t !== this.secure && (this.secure = !!t, this.remove(), this.save());
};
De.prototype._add_to_people_queue = function(t, e) {
  var r = this._get_queue_key(t), n = e[t], i = this._get_or_create_queue(fn), o = this._get_or_create_queue(xi), s = this._get_or_create_queue(ur), a = this._get_or_create_queue(zn), l = this._get_or_create_queue(Vn), c = this._get_or_create_queue(dn, []), u = this._get_or_create_queue(Hr, []);
  r === Su ? (T.extend(i, n), this._pop_from_people_queue(zn, n), this._pop_from_people_queue(Vn, n), this._pop_from_people_queue(ur, n)) : r === Eu ? (T.each(n, function(f, d) {
    d in o || (o[d] = f);
  }), this._pop_from_people_queue(ur, n)) : r === ku ? T.each(n, function(f) {
    T.each([i, o, a, l], function(d) {
      f in d && delete d[f];
    }), T.each(u, function(d) {
      f in d && delete d[f];
    }), s[f] = !0;
  }) : r === Cu ? (T.each(n, function(f, d) {
    d in i ? i[d] += f : (d in a || (a[d] = 0), a[d] += f);
  }, this), this._pop_from_people_queue(ur, n)) : r === Iu ? (T.each(n, function(f, d) {
    T.isArray(f) && (d in l || (l[d] = []), l[d] = l[d].concat(f));
  }), this._pop_from_people_queue(ur, n)) : r === Ou ? (c.push(n), this._pop_from_people_queue(Hr, n)) : r === Tu && (u.push(n), this._pop_from_people_queue(ur, n)), et.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):"), et.log(e), this.save();
};
De.prototype._pop_from_people_queue = function(t, e) {
  var r = this._get_queue(t);
  T.isUndefined(r) || (T.each(e, function(n, i) {
    t === Hr || t === dn ? T.each(r, function(o) {
      o[i] === n && delete o[i];
    }) : delete r[i];
  }, this), this.save());
};
De.prototype._get_queue_key = function(t) {
  if (t === fn)
    return Su;
  if (t === xi)
    return Eu;
  if (t === ur)
    return ku;
  if (t === zn)
    return Cu;
  if (t === Hr)
    return Tu;
  if (t === dn)
    return Ou;
  if (t === Vn)
    return Iu;
  et.error("Invalid queue:", t);
};
De.prototype._get_queue = function(t) {
  return this.props[this._get_queue_key(t)];
};
De.prototype._get_or_create_queue = function(t, e) {
  var r = this._get_queue_key(t);
  return e = T.isUndefined(e) ? {} : e, this.props[r] || (this.props[r] = e);
};
De.prototype.set_event_timer = function(t, e) {
  var r = this.props[Eo] || {};
  r[t] = e, this.props[Eo] = r, this.save();
};
De.prototype.remove_event_timer = function(t) {
  var e = this.props[Eo] || {}, r = e[t];
  return T.isUndefined(r) || (delete this.props[Eo][t], this.save()), r;
};
var Pu, Pt, Q0 = 0, Db = 1, Mb = function(t) {
  return t;
}, ko = function() {
}, nr = "mixpanel", G0 = "base64", Nb = "json", hi = Dt.XMLHttpRequest && "withCredentials" in new XMLHttpRequest(), Z0 = !hi && cr.indexOf("MSIE") === -1 && cr.indexOf("Mozilla") === -1, da = null;
Br.sendBeacon && (da = function() {
  return Br.sendBeacon.apply(Br, arguments);
});
var hd = {
  api_host: "https://api-js.mixpanel.com",
  api_method: "POST",
  api_transport: "XHR",
  api_payload_format: G0,
  app_host: "https://mixpanel.com",
  cdn: "https://cdn.mxpnl.com",
  cross_site_cookie: !1,
  cross_subdomain_cookie: !0,
  error_reporter: ko,
  persistence: "cookie",
  persistence_name: "",
  cookie_domain: "",
  cookie_name: "",
  loaded: ko,
  store_google: !0,
  save_referrer: !0,
  test: !1,
  verbose: !1,
  img: !1,
  debug: !1,
  track_links_timeout: 300,
  cookie_expiration: 365,
  upgrade: !1,
  disable_persistence: !1,
  disable_cookie: !1,
  secure_cookie: !1,
  ip: !0,
  opt_out_tracking_by_default: !1,
  opt_out_persistence_by_default: !1,
  opt_out_tracking_persistence_type: "localStorage",
  opt_out_tracking_cookie_prefix: null,
  property_blacklist: [],
  xhr_headers: {},
  // { header: value, header2: value }
  ignore_dnt: !1,
  batch_requests: !0,
  batch_size: 50,
  batch_flush_interval_ms: 5e3,
  batch_request_timeout_ms: 9e4,
  batch_autostart: !0,
  hooks: {}
}, $0 = !1, ce = function() {
}, kc = function(t, e, r) {
  var n, i = r === nr ? Pt : Pt[r];
  if (i && Pu === Q0)
    n = i;
  else {
    if (i && !T.isArray(i)) {
      et.error("You have already initialized " + r);
      return;
    }
    n = new ce();
  }
  return n._cached_groups = {}, n._init(t, e, r), n.people = new Te(), n.people._init(n), ln.DEBUG = ln.DEBUG || n.get_config("debug"), !T.isUndefined(i) && T.isArray(i) && (n._execute_array.call(n.people, i.people), n._execute_array(i)), n;
};
ce.prototype.init = function(t, e, r) {
  if (T.isUndefined(r)) {
    this.report_error("You must name your new library: init(token, config, name)");
    return;
  }
  if (r === nr) {
    this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
    return;
  }
  var n = kc(t, e, r);
  return Pt[r] = n, n._loaded(), n;
};
ce.prototype._init = function(t, e, r) {
  e = e || {}, this.__loaded = !0, this.config = {};
  var n = {};
  if (!("api_payload_format" in e)) {
    var i = e.api_host || hd.api_host;
    i.match(/\.mixpanel\.com$/) && (n.api_payload_format = Nb);
  }
  if (this.set_config(T.extend({}, hd, n, e, {
    name: r,
    token: t,
    callback_fn: (r === nr ? r : nr + "." + r) + "._jsc"
  })), this._jsc = ko, this.__dom_loaded_queue = [], this.__request_queue = [], this.__disabled_events = [], this._flags = {
    disable_all_events: !1,
    identify_called: !1
  }, this.request_batchers = {}, this._batch_requests = this.get_config("batch_requests"), this._batch_requests) {
    if (!T.localStorage.is_supported(!0) || !hi)
      this._batch_requests = !1, et.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support");
    else if (this.init_batchers(), da && Dt.addEventListener) {
      var o = T.bind(function() {
        this.request_batchers.events.stopped || this.request_batchers.events.flush({ unloading: !0 });
      }, this);
      Dt.addEventListener("pagehide", function(a) {
        a.persisted && o();
      }), Dt.addEventListener("visibilitychange", function() {
        rt.visibilityState === "hidden" && o();
      });
    }
  }
  this.persistence = this.cookie = new De(this.config), this.unpersisted_superprops = {}, this._gdpr_init();
  var s = T.UUID();
  this.get_distinct_id() || this.register_once({
    distinct_id: s,
    $device_id: s
  }, "");
};
ce.prototype._loaded = function() {
  this.get_config("loaded")(this), this._set_default_superprops();
};
ce.prototype._set_default_superprops = function() {
  this.persistence.update_search_keyword(rt.referrer), this.get_config("store_google") && this.persistence.update_campaign_params(), this.get_config("save_referrer") && this.persistence.update_referrer_info(rt.referrer);
};
ce.prototype._dom_loaded = function() {
  T.each(this.__dom_loaded_queue, function(t) {
    this._track_dom.apply(this, t);
  }, this), this.has_opted_out_tracking() || T.each(this.__request_queue, function(t) {
    this._send_request.apply(this, t);
  }, this), delete this.__dom_loaded_queue, delete this.__request_queue;
};
ce.prototype._track_dom = function(t, e) {
  if (this.get_config("img"))
    return this.report_error("You can't use DOM tracking functions with img = true."), !1;
  if (!$0)
    return this.__dom_loaded_queue.push([t, e]), !1;
  var r = new t().init(this);
  return r.track.apply(r, e);
};
ce.prototype._prepare_callback = function(t, e) {
  if (T.isUndefined(t))
    return null;
  if (hi) {
    var r = function(s) {
      t(s, e);
    };
    return r;
  } else {
    var n = this._jsc, i = "" + Math.floor(Math.random() * 1e8), o = this.get_config("callback_fn") + "[" + i + "]";
    return n[i] = function(s) {
      delete n[i], t(s, e);
    }, o;
  }
};
ce.prototype._send_request = function(t, e, r, n) {
  var i = !0;
  if (Z0)
    return this.__request_queue.push(arguments), i;
  var o = {
    method: this.get_config("api_method"),
    transport: this.get_config("api_transport"),
    verbose: this.get_config("verbose")
  }, s = null;
  !n && (T.isFunction(r) || typeof r == "string") && (n = r, r = null), r = T.extend(o, r || {}), hi || (r.method = "GET");
  var a = r.method === "POST", l = da && a && r.transport.toLowerCase() === "sendbeacon", c = r.verbose;
  e.verbose && (c = !0), this.get_config("test") && (e.test = 1), c && (e.verbose = 1), this.get_config("img") && (e.img = 1), hi || (n ? e.callback = n : (c || this.get_config("test")) && (e.callback = "(function(){})")), e.ip = this.get_config("ip") ? 1 : 0, e._ = (/* @__PURE__ */ new Date()).getTime().toString(), a && (s = "data=" + encodeURIComponent(e.data), delete e.data), t += "?" + T.HTTPBuildQuery(e);
  var u = this;
  if ("img" in e) {
    var f = rt.createElement("img");
    f.src = t, rt.body.appendChild(f);
  } else if (l) {
    try {
      i = da(t, s);
    } catch (b) {
      u.report_error(b), i = !1;
    }
    try {
      n && n(i ? 1 : 0);
    } catch (b) {
      u.report_error(b);
    }
  } else if (hi)
    try {
      var d = new XMLHttpRequest();
      d.open(r.method, t, !0);
      var h = this.get_config("xhr_headers");
      if (a && (h["Content-Type"] = "application/x-www-form-urlencoded"), T.each(h, function(b, x) {
        d.setRequestHeader(x, b);
      }), r.timeout_ms && typeof d.timeout < "u") {
        d.timeout = r.timeout_ms;
        var g = (/* @__PURE__ */ new Date()).getTime();
      }
      d.withCredentials = !0, d.onreadystatechange = function() {
        if (d.readyState === 4)
          if (d.status === 200) {
            if (n)
              if (c) {
                var b;
                try {
                  b = T.JSONDecode(d.responseText);
                } catch (S) {
                  if (u.report_error(S), r.ignore_json_errors)
                    b = d.responseText;
                  else
                    return;
                }
                n(b);
              } else
                n(Number(d.responseText));
          } else {
            var x;
            d.timeout && !d.status && (/* @__PURE__ */ new Date()).getTime() - g >= d.timeout ? x = "timeout" : x = "Bad HTTP status: " + d.status + " " + d.statusText, u.report_error(x), n && n(c ? { status: 0, error: x, xhr_req: d } : 0);
          }
      }, d.send(s);
    } catch (b) {
      u.report_error(b), i = !1;
    }
  else {
    var p = rt.createElement("script");
    p.type = "text/javascript", p.async = !0, p.defer = !0, p.src = t;
    var y = rt.getElementsByTagName("script")[0];
    y.parentNode.insertBefore(p, y);
  }
  return i;
};
ce.prototype._execute_array = function(t) {
  var e, r = [], n = [], i = [];
  T.each(t, function(s) {
    s && (e = s[0], T.isArray(e) ? i.push(s) : typeof s == "function" ? s.call(this) : T.isArray(s) && e === "alias" ? r.push(s) : T.isArray(s) && e.indexOf("track") !== -1 && typeof this[e] == "function" ? i.push(s) : n.push(s));
  }, this);
  var o = function(s, a) {
    T.each(s, function(l) {
      if (T.isArray(l[0])) {
        var c = a;
        T.each(l, function(u) {
          c = c[u[0]].apply(c, u.slice(1));
        });
      } else
        this[l[0]].apply(this, l.slice(1));
    }, a);
  };
  o(r, this), o(n, this), o(i, this);
};
ce.prototype.are_batchers_initialized = function() {
  return !!this.request_batchers.events;
};
ce.prototype.init_batchers = function() {
  var t = this.get_config("token");
  if (!this.are_batchers_initialized()) {
    var e = T.bind(function(r) {
      return new Or(
        "__mpq_" + t + r.queue_suffix,
        {
          libConfig: this.config,
          sendRequestFunc: T.bind(function(n, i, o) {
            this._send_request(
              this.get_config("api_host") + r.endpoint,
              this._encode_data_for_request(n),
              i,
              this._prepare_callback(o, n)
            );
          }, this),
          beforeSendHook: T.bind(function(n) {
            return this._run_hook("before_send_" + r.type, n);
          }, this),
          errorReporter: this.get_config("error_reporter"),
          stopAllBatchingFunc: T.bind(this.stop_batch_senders, this)
        }
      );
    }, this);
    this.request_batchers = {
      events: e({ type: "events", endpoint: "/track/", queue_suffix: "_ev" }),
      people: e({ type: "people", endpoint: "/engage/", queue_suffix: "_pp" }),
      groups: e({ type: "groups", endpoint: "/groups/", queue_suffix: "_gr" })
    };
  }
  this.get_config("batch_autostart") && this.start_batch_senders();
};
ce.prototype.start_batch_senders = function() {
  this.are_batchers_initialized() && (this._batch_requests = !0, T.each(this.request_batchers, function(t) {
    t.start();
  }));
};
ce.prototype.stop_batch_senders = function() {
  this._batch_requests = !1, T.each(this.request_batchers, function(t) {
    t.stop(), t.clear();
  });
};
ce.prototype.push = function(t) {
  this._execute_array([t]);
};
ce.prototype.disable = function(t) {
  typeof t > "u" ? this._flags.disable_all_events = !0 : this.__disabled_events = this.__disabled_events.concat(t);
};
ce.prototype._encode_data_for_request = function(t) {
  var e = T.JSONEncode(t);
  return this.get_config("api_payload_format") === G0 && (e = T.base64Encode(e)), { data: e };
};
ce.prototype._track_or_batch = function(t, e) {
  var r = T.truncate(t.data, 255), n = t.endpoint, i = t.batcher, o = t.should_send_immediately, s = t.send_request_options || {};
  e = e || ko;
  var a = !0, l = T.bind(function() {
    return s.skip_hooks || (r = this._run_hook("before_send_" + t.type, r)), r ? (et.log("MIXPANEL REQUEST:"), et.log(r), this._send_request(
      n,
      this._encode_data_for_request(r),
      s,
      this._prepare_callback(e, r)
    )) : null;
  }, this);
  return this._batch_requests && !o ? i.enqueue(r, function(c) {
    c ? e(1, r) : l();
  }) : a = l(), a && r;
};
ce.prototype.track = Jo(function(t, e, r, n) {
  !n && typeof r == "function" && (n = r, r = null), r = r || {};
  var i = r.transport;
  i && (r.transport = i);
  var o = r.send_immediately;
  if (typeof n != "function" && (n = ko), T.isUndefined(t)) {
    this.report_error("No event name provided to mixpanel.track");
    return;
  }
  if (this._event_is_disabled(t)) {
    n(0);
    return;
  }
  e = e || {}, e.token = this.get_config("token");
  var s = this.persistence.remove_event_timer(t);
  if (!T.isUndefined(s)) {
    var a = (/* @__PURE__ */ new Date()).getTime() - s;
    e.$duration = parseFloat((a / 1e3).toFixed(3));
  }
  this._set_default_superprops(), e = T.extend(
    {},
    T.info.properties(),
    this.persistence.properties(),
    this.unpersisted_superprops,
    e
  );
  var l = this.get_config("property_blacklist");
  T.isArray(l) ? T.each(l, function(f) {
    delete e[f];
  }) : this.report_error("Invalid value for property_blacklist config: " + l);
  var c = {
    event: t,
    properties: e
  }, u = this._track_or_batch({
    type: "events",
    data: c,
    endpoint: this.get_config("api_host") + "/track/",
    batcher: this.request_batchers.events,
    should_send_immediately: o,
    send_request_options: r
  }, n);
  return u;
});
ce.prototype.set_group = Jo(function(t, e, r) {
  T.isArray(e) || (e = [e]);
  var n = {};
  return n[t] = e, this.register(n), this.people.set(t, e, r);
});
ce.prototype.add_group = Jo(function(t, e, r) {
  var n = this.get_property(t);
  if (n === void 0) {
    var i = {};
    i[t] = [e], this.register(i);
  } else
    n.indexOf(e) === -1 && (n.push(e), this.register(i));
  return this.people.union(t, e, r);
});
ce.prototype.remove_group = Jo(function(t, e, r) {
  var n = this.get_property(t);
  if (n !== void 0) {
    var i = n.indexOf(e);
    i > -1 && (n.splice(i, 1), this.register({ group_key: n })), n.length === 0 && this.unregister(t);
  }
  return this.people.remove(t, e, r);
});
ce.prototype.track_with_groups = Jo(function(t, e, r, n) {
  var i = T.extend({}, e || {});
  return T.each(r, function(o, s) {
    o != null && (i[s] = o);
  }), this.track(t, i, n);
});
ce.prototype._create_map_key = function(t, e) {
  return t + "_" + JSON.stringify(e);
};
ce.prototype._remove_group_from_cache = function(t, e) {
  delete this._cached_groups[this._create_map_key(t, e)];
};
ce.prototype.get_group = function(t, e) {
  var r = this._create_map_key(t, e), n = this._cached_groups[r];
  return (n === void 0 || n._group_key !== t || n._group_id !== e) && (n = new at(), n._init(this, t, e), this._cached_groups[r] = n), n;
};
ce.prototype.track_pageview = function(t) {
  T.isUndefined(t) && (t = rt.location.href), this.track("mp_page_view", T.info.pageviewInfo(t));
};
ce.prototype.track_links = function() {
  return this._track_dom.call(this, wi, arguments);
};
ce.prototype.track_forms = function() {
  return this._track_dom.call(this, za, arguments);
};
ce.prototype.time_event = function(t) {
  if (T.isUndefined(t)) {
    this.report_error("No event name provided to mixpanel.time_event");
    return;
  }
  this._event_is_disabled(t) || this.persistence.set_event_timer(t, (/* @__PURE__ */ new Date()).getTime());
};
var Bb = {
  persistent: !0
}, Ru = function(t) {
  var e;
  return T.isObject(t) ? e = t : T.isUndefined(t) ? e = {} : e = { days: t }, T.extend({}, Bb, e);
};
ce.prototype.register = function(t, e) {
  var r = Ru(e);
  r.persistent ? this.persistence.register(t, r.days) : T.extend(this.unpersisted_superprops, t);
};
ce.prototype.register_once = function(t, e, r) {
  var n = Ru(r);
  n.persistent ? this.persistence.register_once(t, e, n.days) : (typeof e > "u" && (e = "None"), T.each(t, function(i, o) {
    (!this.unpersisted_superprops.hasOwnProperty(o) || this.unpersisted_superprops[o] === e) && (this.unpersisted_superprops[o] = i);
  }, this));
};
ce.prototype.unregister = function(t, e) {
  e = Ru(e), e.persistent ? this.persistence.unregister(t) : delete this.unpersisted_superprops[t];
};
ce.prototype._register_single = function(t, e) {
  var r = {};
  r[t] = e, this.register(r);
};
ce.prototype.identify = function(t, e, r, n, i, o, s, a) {
  var l = this.get_distinct_id();
  if (this.register({ $user_id: t }), !this.get_property("$device_id")) {
    var c = l;
    this.register_once({
      $had_persisted_distinct_id: !0,
      $device_id: c
    }, "");
  }
  t !== l && t !== this.get_property(fa) && (this.unregister(fa), this.register({ distinct_id: t })), this._flags.identify_called = !0, this.people._flush(e, r, n, i, o, s, a), t !== l && this.track("$identify", {
    distinct_id: t,
    $anon_distinct_id: l
  }, { skip_hooks: !0 });
};
ce.prototype.reset = function() {
  this.persistence.clear(), this._flags.identify_called = !1;
  var t = T.UUID();
  this.register_once({
    distinct_id: t,
    $device_id: t
  }, "");
};
ce.prototype.get_distinct_id = function() {
  return this.get_property("distinct_id");
};
ce.prototype.alias = function(t, e) {
  if (t === this.get_property(J0))
    return this.report_error("Attempting to create alias for existing People user - aborting."), -2;
  var r = this;
  return T.isUndefined(e) && (e = this.get_distinct_id()), t !== e ? (this._register_single(fa, t), this.track("$create_alias", {
    alias: t,
    distinct_id: e
  }, {
    skip_hooks: !0
  }, function() {
    r.identify(t);
  })) : (this.report_error("alias matches current distinct_id - skipping api call."), this.identify(t), -1);
};
ce.prototype.name_tag = function(t) {
  this._register_single("mp_name_tag", t);
};
ce.prototype.set_config = function(t) {
  if (T.isObject(t)) {
    T.extend(this.config, t);
    var e = t.batch_size;
    e && T.each(this.request_batchers, function(r) {
      r.resetBatchSize();
    }), this.get_config("persistence_name") || (this.config.persistence_name = this.config.cookie_name), this.get_config("disable_persistence") || (this.config.disable_persistence = this.config.disable_cookie), this.persistence && this.persistence.update_config(this.config), ln.DEBUG = ln.DEBUG || this.get_config("debug");
  }
};
ce.prototype.get_config = function(t) {
  return this.config[t];
};
ce.prototype._run_hook = function(t) {
  var e = (this.config.hooks[t] || Mb).apply(this, $r.call(arguments, 1));
  return typeof e > "u" && (this.report_error(t + " hook did not return a value"), e = null), e;
};
ce.prototype.get_property = function(t) {
  return this.persistence.props[t];
};
ce.prototype.toString = function() {
  var t = this.get_config("name");
  return t !== nr && (t = nr + "." + t), t;
};
ce.prototype._event_is_disabled = function(t) {
  return T.isBlockedUA(cr) || this._flags.disable_all_events || T.include(this.__disabled_events, t);
};
ce.prototype._gdpr_init = function() {
  var t = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
  t && T.localStorage.is_supported() && (!this.has_opted_in_tracking() && this.has_opted_in_tracking({ persistence_type: "cookie" }) && this.opt_in_tracking({ enable_persistence: !1 }), !this.has_opted_out_tracking() && this.has_opted_out_tracking({ persistence_type: "cookie" }) && this.opt_out_tracking({ clear_persistence: !1 }), this.clear_opt_in_out_tracking({
    persistence_type: "cookie",
    enable_persistence: !1
  })), this.has_opted_out_tracking() ? this._gdpr_update_persistence({ clear_persistence: !0 }) : !this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || T.cookie.get("mp_optout")) && (T.cookie.remove("mp_optout"), this.opt_out_tracking({
    clear_persistence: this.get_config("opt_out_persistence_by_default")
  }));
};
ce.prototype._gdpr_update_persistence = function(t) {
  var e;
  if (t && t.clear_persistence)
    e = !0;
  else if (t && t.enable_persistence)
    e = !1;
  else
    return;
  !this.get_config("disable_persistence") && this.persistence.disabled !== e && this.persistence.set_disabled(e), e && T.each(this.request_batchers, function(r) {
    r.clear();
  });
};
ce.prototype._gdpr_call_func = function(t, e) {
  return e = T.extend({
    track: T.bind(this.track, this),
    persistence_type: this.get_config("opt_out_tracking_persistence_type"),
    cookie_prefix: this.get_config("opt_out_tracking_cookie_prefix"),
    cookie_expiration: this.get_config("cookie_expiration"),
    cross_site_cookie: this.get_config("cross_site_cookie"),
    cross_subdomain_cookie: this.get_config("cross_subdomain_cookie"),
    cookie_domain: this.get_config("cookie_domain"),
    secure_cookie: this.get_config("secure_cookie"),
    ignore_dnt: this.get_config("ignore_dnt")
  }, e), T.localStorage.is_supported() || (e.persistence_type = "cookie"), t(this.get_config("token"), {
    track: e.track,
    trackEventName: e.track_event_name,
    trackProperties: e.track_properties,
    persistenceType: e.persistence_type,
    persistencePrefix: e.cookie_prefix,
    cookieDomain: e.cookie_domain,
    cookieExpiration: e.cookie_expiration,
    crossSiteCookie: e.cross_site_cookie,
    crossSubdomainCookie: e.cross_subdomain_cookie,
    secureCookie: e.secure_cookie,
    ignoreDnt: e.ignore_dnt
  });
};
ce.prototype.opt_in_tracking = function(t) {
  t = T.extend({
    enable_persistence: !0
  }, t), this._gdpr_call_func(kb, t), this._gdpr_update_persistence(t);
};
ce.prototype.opt_out_tracking = function(t) {
  t = T.extend({
    clear_persistence: !0,
    delete_user: !0
  }, t), t.delete_user && this.people && this.people._identify_called() && (this.people.delete_user(), this.people.clear_charges()), this._gdpr_call_func(Cb, t), this._gdpr_update_persistence(t);
};
ce.prototype.has_opted_in_tracking = function(t) {
  return this._gdpr_call_func(Tb, t);
};
ce.prototype.has_opted_out_tracking = function(t) {
  return this._gdpr_call_func(H0, t);
};
ce.prototype.clear_opt_in_out_tracking = function(t) {
  t = T.extend({
    enable_persistence: !0
  }, t), this._gdpr_call_func(Ob, t), this._gdpr_update_persistence(t);
};
ce.prototype.report_error = function(t, e) {
  et.error.apply(et.error, arguments);
  try {
    !e && !(t instanceof Error) && (t = new Error(t)), this.get_config("error_reporter")(t, e);
  } catch (r) {
    et.error(r);
  }
};
ce.prototype.init = ce.prototype.init;
ce.prototype.reset = ce.prototype.reset;
ce.prototype.disable = ce.prototype.disable;
ce.prototype.time_event = ce.prototype.time_event;
ce.prototype.track = ce.prototype.track;
ce.prototype.track_links = ce.prototype.track_links;
ce.prototype.track_forms = ce.prototype.track_forms;
ce.prototype.track_pageview = ce.prototype.track_pageview;
ce.prototype.register = ce.prototype.register;
ce.prototype.register_once = ce.prototype.register_once;
ce.prototype.unregister = ce.prototype.unregister;
ce.prototype.identify = ce.prototype.identify;
ce.prototype.alias = ce.prototype.alias;
ce.prototype.name_tag = ce.prototype.name_tag;
ce.prototype.set_config = ce.prototype.set_config;
ce.prototype.get_config = ce.prototype.get_config;
ce.prototype.get_property = ce.prototype.get_property;
ce.prototype.get_distinct_id = ce.prototype.get_distinct_id;
ce.prototype.toString = ce.prototype.toString;
ce.prototype.opt_out_tracking = ce.prototype.opt_out_tracking;
ce.prototype.opt_in_tracking = ce.prototype.opt_in_tracking;
ce.prototype.has_opted_out_tracking = ce.prototype.has_opted_out_tracking;
ce.prototype.has_opted_in_tracking = ce.prototype.has_opted_in_tracking;
ce.prototype.clear_opt_in_out_tracking = ce.prototype.clear_opt_in_out_tracking;
ce.prototype.get_group = ce.prototype.get_group;
ce.prototype.set_group = ce.prototype.set_group;
ce.prototype.add_group = ce.prototype.add_group;
ce.prototype.remove_group = ce.prototype.remove_group;
ce.prototype.track_with_groups = ce.prototype.track_with_groups;
ce.prototype.start_batch_senders = ce.prototype.start_batch_senders;
ce.prototype.stop_batch_senders = ce.prototype.stop_batch_senders;
De.prototype.properties = De.prototype.properties;
De.prototype.update_search_keyword = De.prototype.update_search_keyword;
De.prototype.update_referrer_info = De.prototype.update_referrer_info;
De.prototype.get_cross_subdomain = De.prototype.get_cross_subdomain;
De.prototype.clear = De.prototype.clear;
var ui = {}, Lb = function() {
  T.each(ui, function(t, e) {
    e !== nr && (Pt[e] = t);
  }), Pt._ = T;
}, Fb = function() {
  Pt.init = function(t, e, r) {
    if (r)
      return Pt[r] || (Pt[r] = ui[r] = kc(t, e, r), Pt[r]._loaded()), Pt[r];
    var n = Pt;
    ui[nr] ? n = ui[nr] : t && (n = kc(t, e, nr), n._loaded(), ui[nr] = n), Pt = n, Pu === Db && (Dt[nr] = Pt), Lb();
  };
}, jb = function() {
  function t() {
    t.done || (t.done = !0, $0 = !0, Z0 = !1, T.each(ui, function(n) {
      n._dom_loaded();
    }));
  }
  function e() {
    try {
      rt.documentElement.doScroll("left");
    } catch {
      setTimeout(e, 1);
      return;
    }
    t();
  }
  if (rt.addEventListener)
    rt.readyState === "complete" ? t() : rt.addEventListener("DOMContentLoaded", t, !1);
  else if (rt.attachEvent) {
    rt.attachEvent("onreadystatechange", t);
    var r = !1;
    try {
      r = Dt.frameElement === null;
    } catch {
    }
    rt.documentElement.doScroll && r && e();
  }
  T.register_event(Dt, "load", t, !0);
};
function Wb() {
  return Pu = Q0, Pt = new ce(), Fb(), Pt.init(), jb(), Pt;
}
var Ub = Wb(), to = Ub;
function Du() {
  return typeof window < "u" ? window.location.host.indexOf("discordsays.com") !== -1 : !1;
}
let pd = !1;
function zb(t) {
  var r;
  if (pd)
    return;
  let e = "https://ws.joinplayroom.com";
  if ((r = process.env) != null && r.REACT_APP_SERVER) {
    const n = process.env.REACT_APP_SERVER.split("://");
    e = `${n[0] === "wss" ? "https" : "http"}://${n[1]}`;
  }
  t && (e = t), to.init("2647310162474a4f7ca66a277c543032", {
    debug: !1,
    api_host: `${e}/__mix`
  }), pd = !0;
}
zb(
  Du() ? `${window.location.protocol}//${window.location.host}/_ws` : null
);
let hs = () => {
  var t;
  return process.env.NODE_ENV === "production" || typeof window < "u" && ((t = window == null ? void 0 : window._PLAYROOM_CONFIG) == null ? void 0 : t.sdkMode);
}, pi = {
  identify: (t) => {
    try {
      hs() && to.identify(t);
    } catch (e) {
      console.log(e);
    }
  },
  alias: (t) => {
    try {
      hs() && to.alias(t);
    } catch (e) {
      console.log(e);
    }
  },
  track: (t, e) => {
    try {
      hs() && to.track(t, e);
    } catch (r) {
      console.log(r);
    }
  },
  people: {
    set: (t) => {
      try {
        hs() && to.people.set(t);
      } catch (e) {
        console.log(e);
      }
    }
  }
};
var Co = {}, Vb = {
  get exports() {
    return Co;
  },
  set exports(t) {
    Co = t;
  }
}, Cc = {}, qb = {
  get exports() {
    return Cc;
  },
  set exports(t) {
    Cc = t;
  }
};
(function() {
  var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = {
    // Bit-wise rotation left
    rotl: function(r, n) {
      return r << n | r >>> 32 - n;
    },
    // Bit-wise rotation right
    rotr: function(r, n) {
      return r << 32 - n | r >>> n;
    },
    // Swap big-endian to little-endian and vice versa
    endian: function(r) {
      if (r.constructor == Number)
        return e.rotl(r, 8) & 16711935 | e.rotl(r, 24) & 4278255360;
      for (var n = 0; n < r.length; n++)
        r[n] = e.endian(r[n]);
      return r;
    },
    // Generate an array of any length of random bytes
    randomBytes: function(r) {
      for (var n = []; r > 0; r--)
        n.push(Math.floor(Math.random() * 256));
      return n;
    },
    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(r) {
      for (var n = [], i = 0, o = 0; i < r.length; i++, o += 8)
        n[o >>> 5] |= r[i] << 24 - o % 32;
      return n;
    },
    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(r) {
      for (var n = [], i = 0; i < r.length * 32; i += 8)
        n.push(r[i >>> 5] >>> 24 - i % 32 & 255);
      return n;
    },
    // Convert a byte array to a hex string
    bytesToHex: function(r) {
      for (var n = [], i = 0; i < r.length; i++)
        n.push((r[i] >>> 4).toString(16)), n.push((r[i] & 15).toString(16));
      return n.join("");
    },
    // Convert a hex string to a byte array
    hexToBytes: function(r) {
      for (var n = [], i = 0; i < r.length; i += 2)
        n.push(parseInt(r.substr(i, 2), 16));
      return n;
    },
    // Convert a byte array to a base-64 string
    bytesToBase64: function(r) {
      for (var n = [], i = 0; i < r.length; i += 3)
        for (var o = r[i] << 16 | r[i + 1] << 8 | r[i + 2], s = 0; s < 4; s++)
          i * 8 + s * 6 <= r.length * 8 ? n.push(t.charAt(o >>> 6 * (3 - s) & 63)) : n.push("=");
      return n.join("");
    },
    // Convert a base-64 string to a byte array
    base64ToBytes: function(r) {
      r = r.replace(/[^A-Z0-9+\/]/ig, "");
      for (var n = [], i = 0, o = 0; i < r.length; o = ++i % 4)
        o != 0 && n.push((t.indexOf(r.charAt(i - 1)) & Math.pow(2, -2 * o + 8) - 1) << o * 2 | t.indexOf(r.charAt(i)) >>> 6 - o * 2);
      return n;
    }
  };
  qb.exports = e;
})();
var Tc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(t) {
      return Tc.bin.stringToBytes(unescape(encodeURIComponent(t)));
    },
    // Convert a byte array to a string
    bytesToString: function(t) {
      return decodeURIComponent(escape(Tc.bin.bytesToString(t)));
    }
  },
  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(t) {
      for (var e = [], r = 0; r < t.length; r++)
        e.push(t.charCodeAt(r) & 255);
      return e;
    },
    // Convert a byte array to a string
    bytesToString: function(t) {
      for (var e = [], r = 0; r < t.length; r++)
        e.push(String.fromCharCode(t[r]));
      return e.join("");
    }
  }
}, gd = Tc;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Hb = function(t) {
  return t != null && (e1(t) || Yb(t) || !!t._isBuffer);
};
function e1(t) {
  return !!t.constructor && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
function Yb(t) {
  return typeof t.readFloatLE == "function" && typeof t.slice == "function" && e1(t.slice(0, 0));
}
(function() {
  var t = Cc, e = gd.utf8, r = Hb, n = gd.bin, i = function(o, s) {
    o.constructor == String ? s && s.encoding === "binary" ? o = n.stringToBytes(o) : o = e.stringToBytes(o) : r(o) ? o = Array.prototype.slice.call(o, 0) : !Array.isArray(o) && o.constructor !== Uint8Array && (o = o.toString());
    for (var a = t.bytesToWords(o), l = o.length * 8, c = 1732584193, u = -271733879, f = -1732584194, d = 271733878, h = 0; h < a.length; h++)
      a[h] = (a[h] << 8 | a[h] >>> 24) & 16711935 | (a[h] << 24 | a[h] >>> 8) & 4278255360;
    a[l >>> 5] |= 128 << l % 32, a[(l + 64 >>> 9 << 4) + 14] = l;
    for (var g = i._ff, p = i._gg, y = i._hh, b = i._ii, h = 0; h < a.length; h += 16) {
      var x = c, S = u, O = f, _ = d;
      c = g(c, u, f, d, a[h + 0], 7, -680876936), d = g(d, c, u, f, a[h + 1], 12, -389564586), f = g(f, d, c, u, a[h + 2], 17, 606105819), u = g(u, f, d, c, a[h + 3], 22, -1044525330), c = g(c, u, f, d, a[h + 4], 7, -176418897), d = g(d, c, u, f, a[h + 5], 12, 1200080426), f = g(f, d, c, u, a[h + 6], 17, -1473231341), u = g(u, f, d, c, a[h + 7], 22, -45705983), c = g(c, u, f, d, a[h + 8], 7, 1770035416), d = g(d, c, u, f, a[h + 9], 12, -1958414417), f = g(f, d, c, u, a[h + 10], 17, -42063), u = g(u, f, d, c, a[h + 11], 22, -1990404162), c = g(c, u, f, d, a[h + 12], 7, 1804603682), d = g(d, c, u, f, a[h + 13], 12, -40341101), f = g(f, d, c, u, a[h + 14], 17, -1502002290), u = g(u, f, d, c, a[h + 15], 22, 1236535329), c = p(c, u, f, d, a[h + 1], 5, -165796510), d = p(d, c, u, f, a[h + 6], 9, -1069501632), f = p(f, d, c, u, a[h + 11], 14, 643717713), u = p(u, f, d, c, a[h + 0], 20, -373897302), c = p(c, u, f, d, a[h + 5], 5, -701558691), d = p(d, c, u, f, a[h + 10], 9, 38016083), f = p(f, d, c, u, a[h + 15], 14, -660478335), u = p(u, f, d, c, a[h + 4], 20, -405537848), c = p(c, u, f, d, a[h + 9], 5, 568446438), d = p(d, c, u, f, a[h + 14], 9, -1019803690), f = p(f, d, c, u, a[h + 3], 14, -187363961), u = p(u, f, d, c, a[h + 8], 20, 1163531501), c = p(c, u, f, d, a[h + 13], 5, -1444681467), d = p(d, c, u, f, a[h + 2], 9, -51403784), f = p(f, d, c, u, a[h + 7], 14, 1735328473), u = p(u, f, d, c, a[h + 12], 20, -1926607734), c = y(c, u, f, d, a[h + 5], 4, -378558), d = y(d, c, u, f, a[h + 8], 11, -2022574463), f = y(f, d, c, u, a[h + 11], 16, 1839030562), u = y(u, f, d, c, a[h + 14], 23, -35309556), c = y(c, u, f, d, a[h + 1], 4, -1530992060), d = y(d, c, u, f, a[h + 4], 11, 1272893353), f = y(f, d, c, u, a[h + 7], 16, -155497632), u = y(u, f, d, c, a[h + 10], 23, -1094730640), c = y(c, u, f, d, a[h + 13], 4, 681279174), d = y(d, c, u, f, a[h + 0], 11, -358537222), f = y(f, d, c, u, a[h + 3], 16, -722521979), u = y(u, f, d, c, a[h + 6], 23, 76029189), c = y(c, u, f, d, a[h + 9], 4, -640364487), d = y(d, c, u, f, a[h + 12], 11, -421815835), f = y(f, d, c, u, a[h + 15], 16, 530742520), u = y(u, f, d, c, a[h + 2], 23, -995338651), c = b(c, u, f, d, a[h + 0], 6, -198630844), d = b(d, c, u, f, a[h + 7], 10, 1126891415), f = b(f, d, c, u, a[h + 14], 15, -1416354905), u = b(u, f, d, c, a[h + 5], 21, -57434055), c = b(c, u, f, d, a[h + 12], 6, 1700485571), d = b(d, c, u, f, a[h + 3], 10, -1894986606), f = b(f, d, c, u, a[h + 10], 15, -1051523), u = b(u, f, d, c, a[h + 1], 21, -2054922799), c = b(c, u, f, d, a[h + 8], 6, 1873313359), d = b(d, c, u, f, a[h + 15], 10, -30611744), f = b(f, d, c, u, a[h + 6], 15, -1560198380), u = b(u, f, d, c, a[h + 13], 21, 1309151649), c = b(c, u, f, d, a[h + 4], 6, -145523070), d = b(d, c, u, f, a[h + 11], 10, -1120210379), f = b(f, d, c, u, a[h + 2], 15, 718787259), u = b(u, f, d, c, a[h + 9], 21, -343485551), c = c + x >>> 0, u = u + S >>> 0, f = f + O >>> 0, d = d + _ >>> 0;
    }
    return t.endian([c, u, f, d]);
  };
  i._ff = function(o, s, a, l, c, u, f) {
    var d = o + (s & a | ~s & l) + (c >>> 0) + f;
    return (d << u | d >>> 32 - u) + s;
  }, i._gg = function(o, s, a, l, c, u, f) {
    var d = o + (s & l | a & ~l) + (c >>> 0) + f;
    return (d << u | d >>> 32 - u) + s;
  }, i._hh = function(o, s, a, l, c, u, f) {
    var d = o + (s ^ a ^ l) + (c >>> 0) + f;
    return (d << u | d >>> 32 - u) + s;
  }, i._ii = function(o, s, a, l, c, u, f) {
    var d = o + (a ^ (s | ~l)) + (c >>> 0) + f;
    return (d << u | d >>> 32 - u) + s;
  }, i._blocksize = 16, i._digestsize = 16, Vb.exports = function(o, s) {
    if (o == null)
      throw new Error("Illegal argument " + o);
    var a = t.wordsToBytes(i(o, s));
    return s && s.asBytes ? a : s && s.asString ? n.bytesToString(a) : t.bytesToHex(a);
  };
})();
const Nn = {
  roomLimitExceed: {
    code: 4444,
    reason: "ROOM_LIMIT_EXCEEDED"
  },
  playerKicked: {
    code: 4999,
    reason: "PLAYER_KICKED"
  },
  unknown: {
    code: 0,
    reason: "UNKNOWN"
  }
};
function Kb(t, e) {
  e || (e = {}), typeof e == "function" && (e = { cmp: e });
  var r = typeof e.cycles == "boolean" ? e.cycles : !1, n = e.cmp && function(o) {
    return function(s) {
      return function(a, l) {
        var c = { key: a, value: s[a] }, u = { key: l, value: s[l] };
        return o(c, u);
      };
    };
  }(e.cmp), i = [];
  return function o(s) {
    if (s && s.toJSON && typeof s.toJSON == "function" && (s = s.toJSON()), s !== void 0) {
      if (typeof s == "number")
        return isFinite(s) ? "" + s : "null";
      if (typeof s != "object")
        return JSON.stringify(s);
      var a, l;
      if (Array.isArray(s)) {
        for (l = "[", a = 0; a < s.length; a++)
          a && (l += ","), l += o(s[a]) || "null";
        return l + "]";
      }
      if (s === null)
        return "null";
      if (i.indexOf(s) !== -1) {
        if (r)
          return JSON.stringify("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      }
      var c = i.push(s) - 1, u = Object.keys(s).sort(n && n(s));
      for (l = "", a = 0; a < u.length; a++) {
        var f = u[a], d = o(s[f]);
        d && (l && (l += ","), l += JSON.stringify(f) + ":" + d);
      }
      return i.splice(c, 1), "{" + l + "}";
    }
  }(t);
}
function t1(t) {
  return Object.keys(t).forEach((e) => {
    t[e] && typeof t[e] == "object" ? t1(t[e]) : (t[e] === void 0 || t[e] === null) && delete t[e];
  }), t;
}
function Xb(t, e) {
  return Object.keys(t).map(function(r) {
    return e + encodeURIComponent(r) + "=" + encodeURIComponent(t[r]);
  }).join("&");
}
function Jb(t) {
  const e = t != null && t.profile ? Xb(t.profile, "profile_") : "", r = t != null && t.reconnectGracePeriod ? `reconnectGracePeriod=${t.reconnectGracePeriod}` : "", n = t != null && t.maxPlayersPerRoom ? `maxPlayersPerRoom=${t.maxPlayersPerRoom}` : "", i = t != null && t.gameId ? `gameId=${t.gameId}` : "";
  return [
    e,
    r,
    n,
    i
  ].filter(Boolean).join("&");
}
function Oc(t, e = !0) {
  let r = "wss://ws.joinplayroom.com";
  return Du() && (r = `wss://${window.location.host}/_ws`), t != null && t.websocketBaseUrl && (r = t == null ? void 0 : t.websocketBaseUrl), {}.VITE_APP_SERVER && (r = {}.VITE_APP_SERVER), e ? r : r.replace("wss://", "https://").replace("ws://", "http://");
}
class Ul extends gu {
  constructor({
    isHost: e,
    roomId: r,
    isSpectator: n,
    letEveryoneWriteState: i = !1,
    enableDeltaCompression: o = !1,
    sdkOptions: s
  }) {
    super(), this.hostname = Oc(s), this.isHost = e, this.isSpectator = n, this.roomId = r, this.roomId && this.roomId.length > 25 && (this.roomId = Co(this.roomId)), this.myId = mb(), this.renderServerId = null, this.lastSeenTimestamp = 0, this.lastUpdateOrderSeen = 0, this.lastUpdateSyncMessageSeen = void 0, this.enableDeltaCompression = o, this.sdkOptions = s, this.playerStates = {}, this.autoAdmitPlayers = !0, this.waitingPlayerStates = {}, this.syncIntervalTime = p0.SyncIntervalTime, this.pendingDeletionPlayerIds = [], this.spectatorStates = {}, this.ignoreNextSync = !1, this.bootDate = Date.now(), this.wsHeartbeatInterval = 0, this.iUpdatedStateAt = {}, this.requestSyncs = !0, this.rpcIdWasCalled = {}, this.rpcCallbacks = {}, this.globalState = JSON.parse(
      JSON.stringify((s == null ? void 0 : s.defaultStates) ?? {})
    ), this.defaultGlobalState = JSON.parse(
      JSON.stringify((s == null ? void 0 : s.defaultStates) ?? {})
    ), this.globalStateReadTime = {}, this.letEveryoneWriteState = i, this.reconnectAttempts = 0, this.joinWebsocket(), pi.identify(F0());
  }
  isRenderServer() {
    return this.myId === this.renderServerId;
  }
  stateHash(e) {
    let r = JSON.stringify(e || this.getAllState());
    const n = ["defaultPlayersStates", "defaultGlobalState"];
    let i = t1(
      JSON.parse(r)
    );
    return n.forEach((o) => {
      delete i[o];
    }), Co(Kb(i));
  }
  getBootDate() {
    return this.bootDate;
  }
  getAllState() {
    var e = {
      ...this.globalState,
      defaultGlobalState: this.defaultGlobalState,
      defaultPlayersStates: {},
      __players: {}
    };
    return Object.keys(this.playerStates).forEach((r) => {
      e.__players[r] = this.playerStates[r].getState(), e.defaultPlayersStates[r] = this.playerStates[r].getDefaultState();
    }), Object.keys(this.waitingPlayerStates).length > 0 ? (e.waitingPlayers = [], Object.keys(this.waitingPlayerStates).forEach((r) => {
      e.waitingPlayers.push(this.waitingPlayerStates[r].id);
    })) : delete e.waitingPlayers, e;
  }
  broadcastGlobalState(e = !1) {
    const r = this.getAllState();
    let n = { sync: r, o: this.stateHash(r) };
    e && (n.force = !0), this.websocketSend(JSON.stringify(n));
  }
  joinWebsocket(e = !1) {
    let r = new WebSocket(
      this.hostname + "/api/room/" + this.roomId + "/websocket/" + (this.myId || "new") + // re-use the id I had previously (if any)
      (this.isHost && !e ? "/host" : "") + // make me host (if isHost is set)
      (this.isSpectator ? "/spectator" : "") + (this.sdkOptions ? "?" + Jb(this.sdkOptions) : "")
    );
    r.addEventListener("open", (n) => {
      this.reconnectAttempts = 0, this.emit("connection_opened"), this.ws = r, this.wsHeartbeatInterval = setInterval(() => {
        if (this.isRenderServerOrHostIfNotCasting)
          this.websocketSend(JSON.stringify({ beat: Date.now() })), this.broadcastGlobalState();
        else if (this.requestSyncs) {
          if (this.ignoreNextSync) {
            this.ignoreNextSync = !1;
            return;
          }
          const i = this.stateHash();
          this.enableDeltaCompression ? this.websocketSend(
            JSON.stringify({
              beat: Date.now(),
              syncO: i
            })
          ) : this.websocketSend(JSON.stringify({ beat: Date.now() }));
        }
      }, this.syncIntervalTime);
    }), r.addEventListener("error", (n) => {
      throw new Error(n.error);
    }), r.onerror = (n) => {
      throw new Error(
        n.message + " " + (this.hostname + "/api/room/" + this.roomId + "/websocket/" + (this.myId || "new") + // re-use the id I had previously (if any)
        (this.isHost ? "/host" : "") + // make me host (if isHost is set)
        (this.isSpectator ? "/spectator" : ""))
      );
    }, r.addEventListener("message", (n) => {
      var s;
      let i = JSON.parse(n.data);
      if (i.error)
        this.emit("error", { type: "websocket", error: i.error });
      else if (i.newId) {
        if (this.myId = i.newId, xt.set("myId", i.newId), !this.playerStates[this.myId] && !this.isSpectator && (this.playerStates[this.myId] = this.createPlayerState(this.myId)), i.profile && !this.isSpectator) {
          var o = this.playerStates[this.myId].getState("profile") || {};
          this.playerStates[this.myId].setState("profile", {
            ...o,
            ...i.profile
          });
        }
        i.bootDate && (this.bootDate = i.bootDate), this.isHost ? (this.emit("before_initial_sync"), this.broadcastGlobalState(), this.once("sync", (a) => {
          this.emit("connected");
        })) : this.emit("connected");
      } else if (i.joined && this.isRenderServerOrHostIfNotCasting)
        if (this.autoAdmitPlayers) {
          if (!this.playerStates[i.joined]) {
            this.playerStates[i.joined] = this.createPlayerState(
              i.joined,
              !1,
              i.proxyBy,
              i.profile
            );
            let a = this.getState("__pOrder") || [];
            a.includes(i.joined) || (a.push(i.joined), this.setState("__pOrder", a));
          }
          this.emitPlayerJoined(this.playerStates[i.joined]);
        } else
          this.pendingDeletionPlayerIds.includes(i.joined) && this.playerStates[i.joined] ? this.playerStates[i.joined].startWebrtc() : this.waitingPlayerStates[i.joined] = this.createPlayerState(
            i.joined
          ), this.pendingDeletionPlayerIds.includes(i.joined) && (this.pendingDeletionPlayerIds = this.pendingDeletionPlayerIds.filter(
            (a) => a !== i.joined
          ));
      else if (i.renderServerUpdate)
        this.renderServerId !== i.renderServerUpdate && (this.renderServerId = i.renderServerUpdate, this.bootDate = i.bootDate, this.isRenderServer() ? (Object.keys(this.playerStates).forEach((a) => {
          this.playerStates[a].startWebrtc();
        }), Object.keys(this.spectatorStates).forEach((a) => {
          this.spectatorStates[a].startWebrtc();
        })) : this.playerStates[this.myId].startWebrtc());
      else if (i.hostUpdate)
        this.isHost = i.hostUpdate === this.myId, this.emit("host_updated", this.isHost), this.isHost && this.isRenderServerOrHostIfNotCasting ? Object.keys(this.playerStates).forEach((a) => {
          this.playerStates[a].startWebrtc();
        }) : this.isSpectator || this.playerStates[this.myId].startWebrtc();
      else if (i.spectator)
        this.spectatorStates[i.spectator] || (this.spectatorStates[i.spectator] = this.createPlayerState(
          i.spectator,
          !0
        ), this.emit("spectator_joined", this.spectatorStates[i.spectator]));
      else if (i.quit)
        this.playerStates[i.quit] && this.isRenderServerOrHostIfNotCasting && this.autoAdmitPlayers && this.playerStates[i.quit].disconnect(), this.playerStates[i.quit] && this.isRenderServerOrHostIfNotCasting && !this.autoAdmitPlayers && this.pendingDeletionPlayerIds.push(i.quit), this.waitingPlayerStates[i.quit] && this.waitingPlayerStates[i.quit].disconnect(), Ce("pquit", i.quit, this.renderServerId), this.renderServerId, i.quit;
      else if (i.signal)
        this.isRenderServerOrHostIfNotCasting && this.myId !== i.id && (this.playerStates[i.id] || this.spectatorStates[i.id]) ? (Ce(
          "signal to host",
          i.signal,
          `from ${this.playerStates[i.id] ? "player" : ""}${this.spectatorStates[i.id] ? "spectator" : ""}`
        ), this.playerStates[i.id] && this.playerStates[i.id].signal(i.signal), this.spectatorStates[i.id] && this.spectatorStates[i.id].signal(i.signal)) : !this.isRenderServerOrHostIfNotCasting && this.myId === i.for && (Ce("signal to client", i.signal), this.playerStates[this.myId] && this.playerStates[this.myId].signal(i.signal), this.spectatorStates[this.myId] && this.spectatorStates[this.myId].signal(i.signal));
      else if (i.pinput && this.isRenderServerOrHostIfNotCasting)
        this.passPlayerInput(i.id, i.pinput);
      else if (i.pong && this.isRenderServer())
        this.playerStates[i.id] && this.playerStates[i.id].handlePingResponse(i);
      else if (i.ping && !this.isRenderServer() && i.for === this.myId)
        this.websocketSend(
          JSON.stringify({
            pong: i.ping
          })
        );
      else if (i.pstate)
        this.setPlayerState(i);
      else if (i.gstate)
        this.setLocalStateFromServerGlobalState(i.gstate[0], i.gstate[1]);
      else if (i.sync) {
        if (this.emit("sync", i.sync), !this.isRenderServerOrHostIfNotCasting) {
          const { defaultGlobalState: a, ...l } = i.sync;
          this.setFullLocalState(l, i.o), this.setFullDefaultLocalState(a, i.o);
        }
        this.emit("post_sync", i.sync);
      } else if (i.dsync) {
        const a = j0.applyObjectPatch(this.getAllState(), i.dsync);
        this.emit("sync", a), this.emit("dsync", a), this.setFullLocalState(a, i.o), this.emit("post_dsync", a);
      } else
        i.kick ? this.myId === i.kick || this.isRenderServerOrHostIfNotCasting && ((s = this.playerStates[i.kick]) != null && s.isProxyPlayer()) && this.removeProxyPlayer(i.kick) : i.rpc ? this.rpcHandle(i, !0) : i.rpcResp ? this.rpcResponseHandle(i, !0) : i.default_gstate ? this.setLocalDefaultState(
          i.default_gstate[0],
          i.default_gstate[1]
        ) : i.default_pstate ? this.setDefaultPlayerState(i) : i.timestamp > this.lastSeenTimestamp && (this.emit("message", { type: "reliable", data: i }), this.lastSeenTimestamp = i.timestamp);
    }), r.addEventListener("close", (n) => {
      const i = Object.values(Nn).map(
        (o) => o.code
      );
      Ce("WebSocket closed, reconnecting:", n.code, n.reason), clearInterval(this.wsHeartbeatInterval), n.code === 4e3 ? (this.emit("permission_error"), this.disconnect(n.code)) : n.code === 4001 || n.code === 4002 ? this.disconnect(n.code) : n.reason === "PLAYER_KICKED" ? this.disconnect(n.code, n.reason) : this.wasDisconnectedManually ? (Ce("Websocket was closed manually, not reconnecting"), clearInterval(this.wsHeartbeatInterval)) : i.indexOf(n.code) === -1 && this.reconnectAttempts < 3 ? (clearInterval(this.wsHeartbeatInterval), this.reconnectAttempts++, setTimeout(
        () => {
          var s;
          const o = JSON.parse(
            JSON.stringify((s = this.playerStates[this.myId]) == null ? void 0 : s.getState())
          ) || {};
          this.joinWebsocket(!0), this.isRenderServerOrHostIfNotCasting || this.once("post_dsync", (a) => {
            Object.keys(o).forEach((l) => {
              var c;
              (c = this.playerStates[this.myId]) == null || c.setState(
                l,
                o[l],
                !0
              );
            });
          });
        },
        this.isHost ? 1e3 : 1500
      )) : this.disconnect(n.code);
    }), r.addEventListener("error", (n) => {
      Ce("WebSocket error, reconnecting:", n, typeof n), clearInterval(this.wsHeartbeatInterval);
    });
  }
  get isRenderServerOrHostIfNotCasting() {
    return !!(this.isRenderServer() || !this.getState("casting") && this.isHost);
  }
  setAutoAdmitPlayers(e) {
    this.isRenderServerOrHostIfNotCasting && this.autoAdmitPlayers !== e && (Ce("setAutoAdmitPlayers", e), !this.autoAdmitPlayers && e && (Object.keys(this.waitingPlayerStates).length > 0 && Object.keys(this.waitingPlayerStates).forEach((r) => {
      this.playerStates[r] = this.waitingPlayerStates[r], this.emitPlayerJoined(this.playerStates[r]);
    }), this.waitingPlayerStates = {}, this.pendingDeletionPlayerIds.forEach((r) => {
      this.playerStates[r] && this.playerStates[r].disconnect();
    }), this.pendingDeletionPlayerIds = []), this.autoAdmitPlayers = e);
  }
  addProxyPlayer() {
    if (this.isRenderServerOrHostIfNotCasting) {
      var e = ja(9);
      return this.broadcast({ joined: e }, !0), this.playerStates[e] = this.createPlayerState(e, !1, !0), this.playerStates[e];
    }
  }
  removeProxyPlayer(e) {
    this.playerStates[e] && this.broadcast({ quit: e }, !0);
  }
  kickPlayer(e, r) {
    this.broadcast({ kick: e }, !0);
    const n = this.on("player_quit", (i) => {
      i === e && (n(), r());
    });
  }
  createPlayerState(e, r, n = !1, i) {
    var a, l, c;
    let o = JSON.parse(
      JSON.stringify(((a = this.sdkOptions) == null ? void 0 : a.defaultPlayerStates) ?? {})
    );
    i && (o.profile = i);
    var s = new hb({
      websocketSend: (u) => this.websocketSend(u),
      id: e,
      myId: this.myId,
      // isHost: this.isHost,
      isRenderServer: () => this.isRenderServer(),
      isRenderServerOrHostIfNotCasting: () => this.isRenderServerOrHostIfNotCasting,
      playerIsSpectator: r,
      playerIsProxy: n,
      broadcastUnreliable: this.broadcastUnreliable.bind(this),
      setPlayerState: this.setPlayerState.bind(this),
      getBootDate: this.getBootDate.bind(this),
      avatarList: (l = this.sdkOptions) == null ? void 0 : l.avatars,
      kickPlayer: this.kickPlayer.bind(this),
      state: o,
      defaultPlayerState: JSON.parse(
        JSON.stringify(((c = this.sdkOptions) == null ? void 0 : c.defaultPlayerStates) ?? {})
      )
    });
    return (this.isRenderServerOrHostIfNotCasting || e === this.myId) && (Ce(
      "startWebrtc::createPlayerState",
      e,
      this.isRenderServerOrHostIfNotCasting
    ), s.startWebrtc()), s.on("quit", () => {
      Ce("pquit", s.id), delete this.playerStates[s.id], this.emit("players", this.playerStates), this.emit("player_quit", s.id), this.waitingPlayerStates[s.id] && delete this.waitingPlayerStates[s.id];
    }), s.on("global_state_unreliable", (u) => {
      this.setLocalState(u[0], u[1], !0);
    }), s.on("rpc_call_unreliable", this.rpcHandle.bind(this)), s;
  }
  emitPlayerJoined(e) {
    yb(e, "profile").then(() => {
      this.emit("joined", e), this.emit("players", this.playerStates);
    });
  }
  broadcastUnreliable(e) {
    Object.keys(this.playerStates).forEach((r) => {
      if (r !== this.myId)
        try {
          Ce("broadcast unreliable", r, e), this.playerStates[r].send(e, !1, !0);
        } catch (n) {
          Ce(n);
        }
    });
  }
  websocketSend(e) {
    try {
      this.ws.send(e);
    } catch (r) {
      Ce(r);
    }
  }
  rpcHandle(e, r) {
    this.rpcIdWasCalled[e.rid] || (this.rpcIdWasCalled[e.rid] = !0, this.emit("rpc", e, r));
  }
  rpcCall(e, r) {
    return this.ws && this.websocketSend(JSON.stringify(e)), new Promise((n, i) => {
      this.rpcCallbacks[e.rid] = {
        resolve: (o) => {
          r && r(o), n(o);
        },
        reject: i
      };
    });
  }
  rpcResponse(e) {
    this.ws && this.websocketSend(JSON.stringify(e));
  }
  rpcResponseHandle(e) {
    this.rpcCallbacks[e.rid] && (this.rpcCallbacks[e.rid].resolve(e.rpcResp), delete this.rpcCallbacks[e.rid]);
  }
  broadcast(e, r) {
    r ? this.ws && this.websocketSend(JSON.stringify(e)) : (Object.keys(this.spectatorStates).forEach((n) => {
      n !== this.myId && this.spectatorStates[n].send(e, r);
    }), Object.keys(this.playerStates).forEach((n) => {
      n !== this.myId && this.playerStates[n].send(e, r);
    }));
  }
  // used by non-hosts, to setState about other players
  setPlayerState(e) {
    var r = !1;
    this.playerStates[e.pstate] && (r = this.playerStates[e.pstate].setLocalState(
      e.d[0],
      e.d[1],
      e.o
    )), this.waitingPlayerStates[e.pstate] && (r = this.waitingPlayerStates[e.pstate].setLocalState(
      e.d[0],
      e.d[1],
      e.o
    )), r && (this.ignoreNextSync = !0);
  }
  // used by host, triggered when user input is sent to us (via network or controller(for local player))
  passPlayerInput(e, r) {
    this.playerStates[e] ? this.playerStates[e].handleInput(r, !0) : this.waitingPlayerStates[e] && this.waitingPlayerStates[e].handleInput(r, !0);
  }
  getState(e) {
    return e ? typeof this.globalState[e] == "object" ? JSON.parse(JSON.stringify(this.globalState[e])) : this.globalState[e] : this.globalState || {};
  }
  // public method to change state object (used by host only). This is then synced with all clients.
  setState(e, r, n = !0) {
    const i = typeof r == "object" ? JSON.parse(JSON.stringify(r)) : r, o = this.setLocalState(e, i);
    (this.isHost || this.isRenderServer() || this.letEveryoneWriteState) && o && (this.iUpdatedStateAt[e] = Date.now(), this.broadcast({ gstate: [e, i] }, n));
  }
  // update local state from the server globalThis state
  setLocalStateFromServerGlobalState(e, r) {
    switch (e) {
      case "round.timer": {
        const n = this.getState("round.timer"), i = r > n ? r : n;
        this.setLocalState(e, i);
        break;
      }
      default: {
        this.setLocalState(e, r);
        break;
      }
    }
  }
  // just change local state without broadcasting
  setLocalState(e, r, n = !1) {
    return JSON.stringify(this.globalState[e]) === JSON.stringify(r) ? !1 : (r === void 0 ? delete this.globalState[e] : this.globalState[e] = r, n && (this.ignoreNextSync = !0), this.emit("state", this.globalState, e), !0);
  }
  // used to change all of local state to what came from server
  setFullLocalState(e, r) {
    this.lastUpdateOrderSeen = r, this.lastUpdateSyncMessageSeen = JSON.parse(JSON.stringify(e)), this.isHost && (e.path = e.path || this.globalState.path);
    var n = e.__players || {};
    delete e.__players, Object.keys(e).forEach((i) => {
      (!this.iUpdatedStateAt[i] || this.iUpdatedStateAt[i] + this.syncIntervalTime < Date.now()) && this.setLocalState(i, e[i]);
    }), Object.keys(this.globalState).forEach((i) => {
      var o;
      (!this.iUpdatedStateAt[i] || this.iUpdatedStateAt[i] + this.syncIntervalTime < Date.now()) && !e[i] && e[i] !== 0 && (Ce("set default states for the globalState"), this.setLocalState(i, (o = this.defaultGlobalState) == null ? void 0 : o[i]));
    }), Object.keys(n).forEach((i) => {
      var o;
      this.playerStates[i] || (this.playerStates[i] = this.createPlayerState(i), this.emitPlayerJoined(this.playerStates[i])), this.playerStates[i].setFullLocalState(
        n[i],
        r
      ), (o = e == null ? void 0 : e.defaultPlayersStates) != null && o[i] && this.playerStates[i].setFullDefaultLocalState(
        e.defaultPlayersStates[i],
        r
      );
    }), Object.keys(this.playerStates).forEach((i) => {
      i !== this.myId && !n[i] && (e.waitingPlayers || []).indexOf(i) === -1 && (Ce("player removed in state, disconnecting them", i), this.playerStates[i].disconnect());
    });
  }
  getDefaultState(e) {
    return e ? typeof this.defaultGlobalState[e] == "object" ? JSON.parse(JSON.stringify(this.defaultGlobalState[e])) : this.defaultGlobalState[e] : this.defaultGlobalState || {};
  }
  /**
   * store default globalThis states. This will come in handy when we reset the states,
   * we will replace the states with these default states.
   */
  setDefaultState(e, r) {
    const n = typeof r == "object" ? JSON.parse(JSON.stringify(r)) : r, i = this.setLocalDefaultState(e, n);
    (this.isHost || this.isRenderServer() || this.letEveryoneWriteState) && i && this.broadcast({ default_gstate: [e, n] }, !0);
  }
  setLocalDefaultState(e, r) {
    return JSON.stringify(this.defaultGlobalState[e]) === JSON.stringify(r) ? !1 : (r == null ? delete this.defaultGlobalState[e] : this.defaultGlobalState[e] = r, !0);
  }
  setFullDefaultLocalState(e) {
    this.defaultGlobalState = {
      ...this.defaultGlobalState,
      ...e
    };
  }
  setDefaultPlayerState(e) {
    this.playerStates[e.default_pstate] && this.playerStates[e.default_pstate].setDefaultLocalState(
      e.d[0],
      e.d[1],
      e.o
    );
  }
  getHostname(e = !0) {
    return Oc(this.sdkOptions, e);
  }
  disconnect(e, r) {
    Ce("disconnecting with eventCode:", e, r), r === "MANUAL_DISCONNECT" && (this.wasDisconnectedManually = !0), this.emit("disconnected", { eventCode: e, reason: r }), Object.keys(this.playerStates).forEach((n) => {
      this.playerStates[n].disconnect({ eventCode: e });
    }), Object.keys(this.waitingPlayerStates).forEach((n) => {
      this.waitingPlayerStates[n].disconnect({ eventCode: e });
    }), this.ws && this.ws.close();
  }
}
function ha(t, e) {
  e || (e = "123456789ABCDEFGHIJKLMNPQRSTUVWXYZ");
  for (var r = "", n = t; n > 0; --n)
    r += e[Math.floor(Math.random() * e.length)];
  return r;
}
const Qb = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], Ui = {
  ROOMSTATE: "ROOMSTATE",
  GAMESTATE: "GAMESTATE",
  USERSTATE: "USERSTATE"
}, Gb = {
  ROOMSTATE: "Room",
  GAMESTATE: "Game",
  USERSTATE: "User"
};
async function Zb(t) {
  var e, r;
  if (t.t = Date.now(), t.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone, t.localTime = (/* @__PURE__ */ new Date()).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: !1
  }), t.weekday = Qb[(/* @__PURE__ */ new Date()).getDay()], typeof window < "u" && ((e = window == null ? void 0 : window._PLAYROOM_CONFIG) != null && e.sdkMode)) {
    if (t.sdkMode = !0, t.sdkVersion = (r = window == null ? void 0 : window._PLAYROOM_CONFIG) == null ? void 0 : r.sdkVersion, process.env.NODE_ENV !== "production")
      return Ce("analytics:", t);
    try {
      pi.track(
        `${Gb[t.type]}: ${t.event || ""}`,
        t
      );
    } catch (n) {
      console.error(n);
    }
  }
}
function md(t, e) {
  return Oc(t, !1) + e;
}
let ho, zr, pa;
async function $b(t, e, r) {
  if (!t.gameId) {
    r("gameId is required for Discord mode");
    return;
  }
  if (!Du()) {
    console.warn(
      "Discord mock mode is active. To see the Discord mode in action, run the game inside Discord."
    );
    let a = {
      ...t,
      skipLobby: !0
    };
    e(a);
    return;
  }
  let n = null, i = typeof t.discord == "object" ? t.discord : {};
  i.scope ? (i.scope.includes("identify") || i.scope.push("identify"), i.scope.includes("guilds.members.read") || i.scope.push("guilds.members.read")) : i.scope = ["identify", "guilds.members.read"], i.prompt || (i.prompt = "none"), i.state || (i.state = "");
  try {
    pa = await r3();
    const { DiscordSDK: a } = pa, l = await fetch(
      `${md(t, "/api/discord/client_id")}?gameId=${t.gameId}`
    ), { client_id: c } = await l.json(), u = new a(c);
    await u.ready();
    const { code: f } = await u.commands.authorize({
      ...i,
      client_id: c,
      response_type: "code"
    }), d = await fetch(
      `${md(t, "/api/discord/auth")}?gameId=${t.gameId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ code: f, redirect_uri: window.location.href })
      }
    ), { access_token: h } = await d.json();
    zr = u, ho = await zr.commands.authenticate({
      access_token: h
    }), n = await e3(), n._discord_id && xt.set("myId", "DCD-" + n._discord_id);
  } catch (a) {
    r("Discord auth failed: " + a.message);
    return;
  }
  let o = "DCRD_" + zr.instanceId;
  t.persistentMode && (o = "PER_" + o);
  let s = {
    ...t,
    skipLobby: !0,
    roomCode: o,
    profile: n
  };
  e(s);
}
function e3() {
  return new Promise((t) => {
    if (ho) {
      const e = ho.user;
      fetch(
        `https://discord.com/api/users/@me/guilds/${zr.guildId}/member`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${ho.access_token}`
          }
        }
      ).then((r) => r.json()).then((r) => {
        let n = "";
        if (r != null && r.avatar)
          n = `https://cdn.discordapp.com/guilds/${zr.guildId}/users/${e.id}/avatars/${r.avatar}.png?size=256`;
        else if (e.avatar)
          n = `https://cdn.discordapp.com/avatars/${e.id}/${e.avatar}.png?size=256`;
        else {
          const o = parseInt(e.discriminator);
          n = `https://cdn.discordapp.com/embed/avatars/${Number.isNaN(o) ? 0 : o % 5}.png`;
        }
        const i = (r == null ? void 0 : r.nick) ?? e.username;
        t({
          name: i,
          photo: n,
          _discord_id: e.id
        });
      });
    }
  });
}
async function QS() {
  if (!zr || !pa)
    throw new Error(
      "Discord not initialized. Call insertCoin() first with 'discord' option set."
    );
  const { PermissionUtils: t, Permissions: e } = pa;
  try {
    const { permissions: r } = await zr.commands.getChannelPermissions();
    if (t.can(e.CREATE_INSTANT_INVITE, r))
      await zr.commands.openInviteDialog();
    else
      throw console.warn("User does not have CREATE_INSTANT_INVITE permissions"), new Error("User does not have CREATE_INSTANT_INVITE permissions");
  } catch {
    throw new Error("Failed to open invite dialog");
  }
}
function t3() {
  return zr;
}
function GS() {
  return ho.access_token;
}
async function r3() {
  return await import("@discord/embedded-app-sdk");
}
class n3 extends gu {
  constructor(e = {}) {
    super(), this.connection = !1, this.currentRoom = !1, this.isConnected = !1, this.singlePlayerMode = !1, this.letEveryoneWriteState = !1, this.sdkOptions = e;
  }
  createRoom(e, r = !1, n = !1) {
    this.letEveryoneWriteState = r, e || (e = this._generateRoomId()), e = e.toUpperCase(), this.connection = new Ul({
      isHost: !0,
      roomId: e,
      letEveryoneWriteState: this.letEveryoneWriteState,
      enableDeltaCompression: n,
      sdkOptions: this.sdkOptions
    }), this.currentRoom = e, this.listenToEvents(), this.emit("connection_initiated");
  }
  isRenderServer() {
    if (this.connection)
      return this.connection.isRenderServer();
  }
  // Abstracted helper functions
  get isMultiplayerCastScreen() {
    return !!(!this.singlePlayerMode && this.isSpectator() && !this.isHost());
  }
  get isHost() {
    return this.connection ? this.connection.isHost : !1;
  }
  get isSpectator() {
    return this.connection ? this.connection.isSpectator : !1;
  }
  get isRenderServerOrHostIfNotCasting() {
    return !!(this.connection && this.connection.isRenderServerOrHostIfNotCasting);
  }
  listenToEvents() {
    this.connection.on("joined", (e) => {
      this.emit("joined", e), this.isRenderServerOrHostIfNotCasting && this.roomLog(Ui.ROOMSTATE, "player_joined", {
        playerId: e.id
      });
    }), this.connection.on("player_quit", (e) => {
      this.isRenderServerOrHostIfNotCasting && this.roomLog(Ui.ROOMSTATE, "player_quit", {
        playerId: e
      });
    }), this.connection.on("state", (e, r) => {
      this.emit("state", e, r);
    }), this.connection.on("host_updated", (e) => {
      e && (this.getState("uid") || (this.setState("uid", ja(7)), this.setState("id", this.currentRoom), this.setState("meta", {
        creatorUserId: this.connection.myId,
        creatorPermId: F0()
      })));
    }), this.connection.on("rpc", (e) => {
      this.emit("rpc", e);
    }), this.connection.on("connected", () => {
      this.isConnected = !0, this.emit("connected"), this.isHost && (this.emit("room_created", { id: this.currentRoom }), this.roomLog(Ui.ROOMSTATE, "room_created", {
        host: this.connection.myId
      }));
    }), this.connection.on("reconnecting", () => {
      this.emit("reconnecting");
    }), this.connection.on("permission_error", () => {
      this.isHost ? this.createRoom() : (this.isConnected = !1, this.emit("permission_error"));
    }), this.connection.on("host_left", () => {
      this.isConnected = !1, this.emit("host_left");
    }), this.connection.on("disconnected", (e) => {
      this.isConnected = !1, this.emit("disconnected", e);
    }), this.connection.on("players", (e) => {
      Object.keys(this.connection.playerStates).length > 0 && (this.singlePlayerMode = !1), this.emit("players", e);
    }), this.connection.on("host_updated", (e) => {
      this.emit("host_updated", e);
    });
  }
  _waitforConnection() {
    return new Promise((e) => {
      this.isConnected ? e() : this.once("connected", e);
    });
  }
  on(e, r, n) {
    return e === "joined" && this._waitforConnection().then(() => {
      const i = this.getState("__pOrder") || [];
      Object.keys(
        this.connection.playerStates
      ).sort((s, a) => {
        const l = i.indexOf(s), c = i.indexOf(a);
        return l === -1 && c === -1 ? 0 : l === -1 ? 1 : c === -1 ? -1 : l - c;
      }).forEach((s) => {
        r(this.connection.playerStates[s]);
      });
    }), e === "players" && this._waitforConnection().then(() => {
      r(this.connection.playerStates);
    }), super.on(e, r, n);
  }
  once(e, r) {
    return e === "connection_initiated" && this.connection && r(), super.once(e, r);
  }
  setDeltaCompression(e) {
    this.connection.enableDeltaCompression = e;
  }
  joinRoom(e, r = !1, n = !1) {
    this.letEveryoneWriteState = r, e || (e = this._generateRoomId()), e = e.toUpperCase(), this.connection = new Ul({
      isHost: !1,
      roomId: e,
      letEveryoneWriteState: this.letEveryoneWriteState,
      enableDeltaCompression: n,
      sdkOptions: this.sdkOptions
    }), this.currentRoom = e, this.listenToEvents(), this.emit("connection_initiated");
  }
  _generateRoomId() {
    var e;
    return (e = this.sdkOptions) != null && e.persistentMode ? `PER_${ha(26)}` : ha(4);
  }
  spectateRoom(e, r, n = !1, i = !1) {
    this.letEveryoneWriteState = n, e || (e = this._generateRoomId()), r && (this.singlePlayerMode = !0), e = e.toUpperCase(), this.connection = new Ul({
      isSpectator: !0,
      roomId: e,
      letEveryoneWriteState: this.letEveryoneWriteState,
      enableDeltaCompression: i,
      sdkOptions: this.sdkOptions
    }), this.currentRoom = e, this.listenToEvents(), this.emit("connection_initiated");
  }
  leaveRoom() {
    this.connection.disconnect(void 0, "MANUAL_DISCONNECT"), this.currentRoom = !1, delete this.connection;
  }
  getState(e) {
    return this.connection ? e ? this.connection.getState(e) : this.connection.getState() : e === void 0 ? {} : void 0;
  }
  // get default globalThis state
  getDefaultState(e) {
    return this.connection ? e ? this.connection.getDefaultState(e) : this.connection.getDefaultState() : e === void 0 ? {} : void 0;
  }
  // host only: public method to change state object. This is then synced with all clients.
  setState(e, r, n = !0) {
    this.connection && (this.isSpectator && !this.isRenderServer() || this.connection.setState(e, r, n));
  }
  /**
   * store default globalThis states. This will come in handy when we reset the states,
   * we will replace the states with these default states.
   */
  setDefaultState(e, r) {
    this.connection && (this.isSpectator && !this.isRenderServer() || this.connection.setDefaultState(e, r));
  }
  setRoundState(e, r, n = !0) {
    this.connection && (this.isSpectator && !this.isRenderServer() || this.connection.setState(`round.${e}`, r, n));
  }
  getRoundState(e) {
    if (!this.connection)
      return {};
    if (e)
      return this.connection.getState(`round.${e}`);
    {
      let r = {};
      return Object.keys(this.connection.getState()).forEach((n) => {
        n.startsWith("round.") && (r[n.substring(6)] = this.connection.getState(n));
      }), r;
    }
  }
  resetRoundState() {
    Object.keys(this.connection.getState()).forEach((e) => {
      e.startsWith("round.") && this.connection.setState(e, void 0);
    }), Object.keys(this.connection.playerStates).forEach((e) => {
      this.connection.playerStates[e].resetRoundState();
    }), Object.keys(this.connection.spectatorStates).forEach((e) => {
      this.connection.spectatorStates[e].resetRoundState();
    });
  }
  // host only: we maintain a running log of winner per game, we use this to calculate leaderboard score
  addToWinLog(e, r) {
    let n = this.getState("winslog") || [];
    const i = Date.now();
    if (Ce("winnerPlayerId in addToWinLog:", r), typeof r == "object") {
      const o = r.map((s, a) => (this.gameLog("winner", { winnerId: s, gameId: e }), [e, s, i]));
      n = n.concat(o);
    } else
      this.gameLog("winner", { winnerId: r, gameId: e }), n.push([e, r, i]);
    Ce("currentLog (to be winslog): ", n), this.setState("winslog", n);
  }
  getMyPlayerState() {
    if (this.connection)
      return this.isSpectator ? this.connection.spectatorStates[this.connection.myId] : this.connection.playerStates[this.connection.myId];
  }
  // RenderServer only: add a stream to all spectator's webrtc
  addRenderStream(e) {
    if (!this.isRenderServer)
      return;
    const r = Object.values(this.connection.spectatorStates).filter(
      (i) => i.id !== this.connection.myId
    );
    return Ce("addRenderStream", r), r.forEach((i) => i.peer.addStream(e)), this.connection.on("spectator_joined", (i) => {
      Ce("spectator_joined", i), i.once("webrtc_connected", () => {
        setTimeout(() => {
          Ce("adding stream"), i.peer.addStream(e);
        }, 5e3);
      });
    });
  }
  // RenderServer only: remove a stream to all spectator's webrtc
  removeRenderStream(e) {
    if (!this.isRenderServer)
      return;
    const r = Object.values(this.connection.spectatorStates).filter(
      (n) => n.id !== this.connection.myId
    );
    Ce("removeRenderStream", r), r.forEach((n) => n.peer.removeStream(e));
  }
  getPlayers() {
    return this.connection ? this.singlePlayerMode ? this.connection.spectatorStates : this.connection.playerStates : {};
  }
  attachController(e) {
    this.detachControllerLegacy();
    var r = this.connection.playerStates[this.connection.myId];
    r && r.attachControllerLegacy(e);
  }
  detachControllerLegacy() {
    var e = this.connection.playerStates[this.connection.myId];
    e && e.detachControllerLegacy();
  }
  navigate(e, r) {
    if (this.connection && (this.isRenderServer() || this.isHost)) {
      var n = { pathname: e };
      r && (n.state = JSON.stringify(r)), this.setState("path", n), this.roomLog(Ui.ROOMSTATE, "navigate", n);
    }
  }
  async roomLog(e, r, n) {
    var i;
    if (this.connection && this.isRenderServerOrHostIfNotCasting) {
      const o = { ...n };
      o.type = e, o.event = r, o.roomId = this.currentRoom, o.roomUid = this.getState("uid"), this.getState("meta") && (n = { ...n, ...this.getState("meta") });
      const s = Object.keys(this.getPlayers());
      o.playersInRoom = s.length, this.getState("playlist") && (o.playlist = this.getState("playlist")), (i = this.sdkOptions) != null && i.gameId && (o.gameId = this.sdkOptions.gameId), await Zb(o);
    }
  }
  async gameLog(e, r) {
    this.connection && this.isRenderServerOrHostIfNotCasting && (r = r || {}, await this.roomLog(Ui.GAMESTATE, e, r, !0));
  }
  shareEditorConfigurationWithAllClients(e, r, n) {
    this.connection && this.connection.setState(e, r, n);
  }
  setSDKOptions(e) {
    this.sdkOptions = e;
  }
  _getPersistentRoomId() {
    var r, n, i;
    if ((r = this.sdkOptions) != null && r.discord) {
      var e = t3();
      return e ? `PER_DCRD_G${(n = this.sdkOptions) == null ? void 0 : n.gameId}_${e.guildId || e.channelId}` : `PER_${(i = this.sdkOptions) == null ? void 0 : i.gameId}_${this.currentRoom}`;
    }
    return this.currentRoom;
  }
  async setPersistentData(e, r) {
    if (!this.connection)
      return;
    const n = this.connection.getHostname(!1) + "/api/room/" + this._getPersistentRoomId() + "/persistence_set", o = await fetch(n, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        key: e,
        value: r
      })
    });
    if (o.status !== 200)
      throw new Error("Failed to set persistent state");
    {
      const s = await o.json();
      return s.data ? s.data[0] : void 0;
    }
  }
  async getPersistentData(e) {
    if (!this.connection)
      return;
    const r = this.connection.getHostname(!1) + "/api/room/" + this._getPersistentRoomId() + "/persistence_get", i = await fetch(r, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        key: e
      })
    });
    if (i.status !== 200)
      throw new Error("Failed to get persistent state");
    {
      const o = await i.json();
      return o.data ? o.data[0] : void 0;
    }
  }
  async insertPersistentData(e, r) {
    if (!this.connection)
      return;
    const n = this.connection.getHostname(!1) + "/api/room/" + this._getPersistentRoomId() + "/persistence_insert", o = await fetch(n, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        key: e,
        value: r
      })
    });
    if (o.status !== 200)
      throw new Error("Failed to insert persistent state");
    return (await o.json()).index;
  }
}
function Me(t) {
  var r, n, i, o;
  let e = window._multiplayer;
  try {
    e = (r = window.parent) == null ? void 0 : r._multiplayer;
  } catch {
  }
  e && !((n = e == null ? void 0 : e.getState) != null && n.call(e, "__launched")) && t && e.setSDKOptions(t);
  try {
    if ((i = window.parent) != null && i._multiplayer && window.location.hash.indexOf("NOPARENT") === -1)
      return (o = window.parent) == null ? void 0 : o._multiplayer;
  } catch {
  }
  return window._multiplayer || (window._multiplayer = new n3(t)), window._multiplayer;
}
function zl(t, e) {
  return Object.keys(t).map((i) => t[i]).sort((i, o) => {
    const s = e.indexOf(i.id), a = e.indexOf(o.id);
    return s === -1 && a === -1 ? 0 : s === -1 ? 1 : a === -1 ? -1 : s - a;
  });
}
function Va(t) {
  const e = Me(), [r, n] = ht(
    zl(e.getPlayers(), e.getState("__pOrder") || [])
  );
  return r1(() => {
    t && n(
      zl(
        e.getPlayers(),
        e.getState("__pOrder") || []
      )
    );
  }), _t(() => e.on(
    "players",
    (o) => {
      n(
        zl(o, e.getState("__pOrder") || [])
      );
    },
    !0
  ), []), r;
}
function i3(t, e) {
  const r = Me(), n = r.getDefaultState(t) ?? e;
  n !== void 0 && r.getState(t) === void 0 && r.setDefaultState(t, n);
  const [i, o] = ht(
    r.getState(t) !== void 0 ? r.getState(t) : n
  );
  return _t(() => (r.getState(t) !== i && o(r.getState(t) ?? n), r.on("state", (a, l) => {
    t && l === t ? a !== a[l] && o(a[l]) : t || o(a);
  })), []), i;
}
function r1(t) {
  const e = Me();
  _t(() => {
    var r = [];
    return r.push(
      e.on(
        "joined",
        (n) => {
          r.push(
            n.on(
              "state",
              (i, o) => {
                t(n.id, i, n.state, n);
              },
              !0
            )
          );
        },
        !0
      )
    ), () => {
      r.forEach((n) => n());
    };
  }, []);
}
function o3(t, e, r) {
  const n = t.getDefaultState(e) ?? r;
  n !== void 0 && t.getState(e) === void 0 && t.setDefaultState(e, n);
  const [i, o] = ht(
    t.getState(e) !== void 0 ? t.getState(e) : n
  );
  return _t(() => {
    const s = t.getState(e) ?? n;
    o(s), t.setState(e, s);
  }, []), _t(() => t.on("state", (a, l) => {
    a === e && o(t.getState(e));
  }), []), i;
}
function s3(t, e, r) {
  const [n, i] = ht(Math.random());
  return _t(() => {
    const o = t.map(
      (s) => s.on(
        "state",
        (a, l) => {
          a === e && i(Math.random());
        },
        !0
      )
    );
    return () => {
      o.forEach((s) => s());
    };
  }, [t, e]), (t == null ? void 0 : t.map((o) => ({
    playerId: o.id,
    state: o.getState(e)
  }))) || r || [];
}
function ZS(t) {
  const e = Va();
  return s3(e, t, void 0).map((n) => ({
    player: e.find((i) => i.id === n.playerId),
    state: n.state
  }));
}
function Mu() {
  const t = Me(), [e, r] = ht(t.isHost);
  return _t(() => (setTimeout(() => {
    r(t.isHost);
  }, 50), t.on("host_updated", () => {
    r(t.isHost);
  })), [t.isHost]), e;
}
function gi(t, e) {
  return [
    i3(t, e),
    (r, n) => Me().setState(t, r, n)
  ];
}
function $S(t, e, r) {
  return [
    o3(t, e, r),
    (n, i) => t.setState(e, n, i)
  ];
}
async function eE(t = []) {
  return new Promise((e, r) => {
    try {
      const n = Me(), i = [
        "id",
        "meta",
        "uid",
        "__launched",
        "casting",
        "__pOrder"
      ], o = n.getState();
      Object.keys(o).forEach((s) => {
        if (!i.includes(s) && !t.includes(s)) {
          const a = n.getDefaultState(s);
          n.setState(s, a);
        }
      }), e(!0);
    } catch (n) {
      r(n);
    }
  });
}
function tE(t = []) {
  return new Promise((e, r) => {
    try {
      const n = Me(), i = [
        "profile",
        "__proxyBy",
        "__gamepad",
        "__bot"
      ], o = n == null ? void 0 : n.getPlayers();
      Object.keys(o).forEach((s) => {
        var l;
        const a = (l = o[s]) == null ? void 0 : l.state;
        a && Object.keys(a).forEach((c) => {
          if (!i.includes(c) && !t.includes(c)) {
            const u = o[s].getDefaultState(c);
            o[s].setState(c, u);
          }
        });
      }), e(!0);
    } catch (n) {
      r(n);
    }
  });
}
function rE(t) {
  return Me().on("joined", t);
}
function nE(t) {
  return Me().on("live:tiktok:msg", t);
}
function iE(t, e, r) {
  Me().setState(t, e, r);
}
function oE(t) {
  return Me().getState(t);
}
function sE() {
  return Me().isHost;
}
function a3() {
  return Me().isSpectator;
}
function n1(t, e) {
  const n = Me().getMyPlayerState();
  e ? n.handleKeyDown(t) : n.handleKeyUp(t);
}
function aE(t) {
  n1(t, !0);
}
function lE(t) {
  n1(t, !1);
}
function To() {
  return Me().getMyPlayerState();
}
function i1(t) {
  return t.replace(
    /https:\/\/play\.joinplayroom\.app\/games\//,
    ""
  ).split("/")[0];
}
function o1(t) {
  const e = /https:\/\/play\.joinplayroom\.app/;
  return new RegExp(e, "g").test(t);
}
function l3(t, e) {
  return o1(t) ? `https://joinplayroom.com/launch/${i1(t)}/R${e ?? ""}` : `${t}R${e ?? ""}`;
}
function c3(t, e) {
  return o1(t) ? `https://joinplayroom.com/app-launcher.html?game=${i1(t)}&room=R${e}` : `${t}R${e ?? ""}`;
}
function cE() {
  return Me().currentRoom;
}
function uE(t) {
  return Me().connection.on("disconnected", (r) => {
    let n;
    Object.values(Nn).forEach((i) => {
      r.eventCode === i.code && (n = i);
    }), t(n || Nn.unknown);
  });
}
const po = {
  ALL: 0,
  OTHERS: 1,
  HOST: 2
};
function u3(t, e) {
  const r = Me();
  return r.on("rpc", async (n) => {
    const [i, o, s, a] = n.rpc, l = n.rid;
    if (o !== t)
      return;
    switch (a) {
      case po.ALL:
        break;
      case po.OTHERS:
        if (i === r.getMyPlayerState().id)
          return;
        break;
      case po.HOST:
        if (!r.isHost)
          return;
        break;
      default:
        return;
    }
    const c = r.getPlayers()[i], u = await e(s, c, a);
    u !== void 0 && r.connection.rpcResponse({ rpcResp: u, rid: l });
  });
}
function f3(t, e, r = po.ALL, n) {
  const i = Me(), o = ha(5);
  return i.connection.rpcCall(
    {
      rpc: [
        i.getMyPlayerState().id,
        // sender
        t,
        // RPC identifier
        e,
        // RPC payload,
        r
        // RPC mode
      ],
      rid: o
    },
    n
  );
}
function d3(t, e) {
  return Me().setPersistentData(t, e);
}
function s1(t) {
  return Me().getPersistentData(t);
}
function h3(t, e) {
  return Me().insertPersistentData(t, e);
}
const fE = {
  Mode: po,
  register: u3,
  call: f3
};
async function dE() {
  const t = Me();
  if (t.isHost)
    return t.setState("__matchmakingqueue", !0), new Promise((e, r) => {
      t.once("matchmaking_room_joined", e);
    });
  throw new Error("Only host can start matchmaking");
}
function zi(t) {
  let e = {};
  return t.type === "pointerdown" || t.type === "pointermove" || t.type === "pointerup" ? e.changedTouches = [
    {
      clientX: t.clientX,
      clientY: t.clientY,
      identifier: t.pointerId
    }
  ] : (t.type === "touchstart" || t.type === "touchmove" || t.type === "touchend") && (e = t), e;
}
function p3(t) {
  var e = Math.PI / 2, r, n;
  t > -e && t < e ? r = "right" : r = "left", t > 0 ? n = "up" : n = "down";
  let i = {};
  return r && (i.x = r), n && (i.y = n), i;
}
function g3(t) {
  var e = Math.PI / 4, r;
  return t > e && t < e * 3 ? r = "up" : t > -e && t <= e ? r = "right" : t > -e * 3 && t <= -e ? r = "down" : r = "left", r;
}
const ps = {
  userSelect: "none",
  position: "fixed",
  transition: "opacity 0.3s 0.1s",
  willChange: "opacity",
  height: "70px",
  width: "95px",
  right: "0px",
  backgroundSize: "25px",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: "15px",
  fontFamily: "sans-serif"
}, gs = {
  position: "absolute",
  top: "calc(50% - 30px)",
  left: "calc(50% - 30px)",
  height: "60px",
  width: "60px",
  border: "2px solid #fff",
  borderRadius: "10px",
  boxSizing: "border-box",
  opacity: "0.25",
  willChange: "opacity"
}, yd = {
  position: "absolute",
  backgroundSize: "25px",
  top: "10px",
  left: "10px",
  width: "calc(100% - 20px)",
  height: "calc(100% - 20px)",
  display: "flex",
  backgroundRepeat: "no-repeat",
  color: "#fff",
  fontSize: "15px",
  fontFamily: "sans-serif"
}, ms = [
  {
    element: { ...ps, bottom: "15px" },
    border: { ...gs }
  },
  {
    element: { ...ps, bottom: "calc(70px + 15px)" },
    border: { ...gs }
  },
  {
    element: { ...ps, bottom: "calc(70px * 2 + 15px)" },
    border: { ...gs }
  },
  {
    element: { ...ps, bottom: "calc(70px * 3 + 15px)" },
    border: { ...gs }
  }
], Ic = {
  type: "angular",
  buttons: [],
  zones: {}
};
function m3(t = {}) {
  if (t.type = t.type || Ic.type, t.zones = t.zones || Ic.zones, t.buttons && t.buttons.length > 0) {
    if (ms.length < t.buttons.length)
      throw new Error(`Only ${ms.length} buttons are supported.`);
    t.buttons = t.buttons.map((e, r) => {
      var i, o;
      let n = {
        ...e,
        css: {
          element: {
            ...ms[r].element,
            ...(i = e.css) == null ? void 0 : i.element
          },
          border: { ...ms[r].border, ...(o = e.css) == null ? void 0 : o.border }
        }
      };
      return e.icon && (n.css.element.backgroundImage = `url(${e.icon})`), n;
    });
  }
  return t;
}
class Pc {
  constructor(e, r = Ic) {
    var n, i;
    this.buttons = {}, this.joystick = {}, this.playerState = e, this.multiplayer = Me(), this.allowGamepads = (i = (n = this.multiplayer) == null ? void 0 : n.sdkOptions) == null ? void 0 : i.allowGamepads, this.requestAnimationFrameId = null, this.allowGamepads && (!r.buttons || r.buttons.length === 0) && (r.buttons = [
      { id: "button1", label: "A" },
      { id: "button2", label: "B" },
      { id: "button3", label: "X" },
      { id: "button4", label: "Y" }
    ]), r = m3(r), this.validateConfig(r), this.config = r, this.multiplayer.sdkOptions && (this.multiplayer.sdkOptions.joystickConfig = this.config), e.id === To().id && this.initControls(r);
  }
  validateConfig(e) {
    if (this.allowGamepads && e.zones && Object.keys(e.zones).length > 0)
      throw new Error(
        "Joystick zones don't work when allowGamepads is enabled"
      );
  }
  isAnyButtonPressed() {
    return (this.config.buttons || []).some((e) => this.isPressed(e.id));
  }
  isPressed(e) {
    return this.playerState.getState("ctr-" + e) || !1;
  }
  isJoystickPressed() {
    return this.isPressed("joystick") || !1;
  }
  angle() {
    return this.playerState.getState("ctr-angle") || 0;
  }
  dpad() {
    return this.playerState.getState("ctr-dpad") || {};
  }
  initControls(e) {
    this.setupJoystick(e.zones), e.buttons && e.buttons.length > 0 && e.buttons.forEach((r) => {
      this.setupButton(r);
    });
  }
  setupJoystick(e) {
    this.joystick.active = !1, this.joystick.$element = document.createElement("div"), this.joystick.$element.style.userSelect = "none", this.joystick.$element.style.position = "fixed", this.joystick.$element.style.bottom = "10px", this.joystick.$element.style.left = "10px", this.joystick.$element.style.width = "170px", this.joystick.$element.style.height = "170px", this.joystick.$element.style.borderRadius = "50%", this.joystick.$element.style.transition = "opacity 0.3s 0.0s", this.joystick.$element.style.willChange = "opacity", document.body.appendChild(this.joystick.$element), this.joystick.$cursor = document.createElement("div"), this.joystick.$cursor.style.position = "absolute", this.joystick.$cursor.style.top = "calc(50% - 30px)", this.joystick.$cursor.style.left = "calc(50% - 30px)", this.joystick.$cursor.style.width = "60px", this.joystick.$cursor.style.height = "60px", this.joystick.$cursor.style.border = "2px solid #ffffff", this.joystick.$cursor.style.borderRadius = "50%", this.joystick.$cursor.style.boxSizing = "border-box", this.joystick.$cursor.style.pointerEvents = "none", this.joystick.$cursor.style.willChange = "transform", this.joystick.$element.appendChild(this.joystick.$cursor), this.joystick.$limit = document.createElement("div"), this.joystick.$limit.style.position = "absolute", this.joystick.$limit.style.top = "calc(50% - 75px)", this.joystick.$limit.style.left = "calc(50% - 75px)", this.joystick.$limit.style.width = "150px", this.joystick.$limit.style.height = "150px", this.joystick.$limit.style.border = "2px solid #ffffff", this.joystick.$limit.style.borderRadius = "50%", this.joystick.$limit.style.opacity = "0.25", this.joystick.$limit.style.pointerEvents = "none", this.joystick.$limit.style.boxSizing = "border-box", this.joystick.$element.appendChild(this.joystick.$limit), Object.keys(e).forEach((r) => {
      const n = e[r], i = document.createElement("div");
      Object.keys(yd).forEach((o) => {
        i.style[o] = yd[o];
      }), n.icon && (i.style.backgroundImage = `url(${n.icon})`), r === "up" && (i.style.backgroundPosition = "center top", i.style.justifyContent = "center", i.style.alignItems = "flex-start"), r === "down" && (i.style.backgroundPosition = "center bottom", i.style.justifyContent = "center", i.style.alignItems = "flex-end"), r === "left" && (i.style.backgroundPosition = "left center", i.style.justifyContent = "flex-start", i.style.alignItems = "center"), r === "right" && (i.style.backgroundPosition = "right center", i.style.justifyContent = "flex-end", i.style.alignItems = "center"), n.label && (i.innerHTML = n.label), this.joystick.$limit.appendChild(i);
    }), this.joystick.angle = {}, this.joystick.angle.offset = Math.PI * 0.5, this.joystick.angle.center = {}, this.joystick.angle.center.x = 0, this.joystick.angle.center.y = 0, this.joystick.angle.current = {}, this.joystick.angle.current.x = 0, this.joystick.angle.current.y = 0, this.joystick.angle.originalValue = 0, this.joystick.angle.value = -Math.PI * 0.5, this.joystick.resize = () => {
      const r = this.joystick.$element.getBoundingClientRect();
      this.joystick.angle.center.x = r.left + r.width * 0.5, this.joystick.angle.center.y = r.top + r.height * 0.5;
    }, window.addEventListener("resize", this.joystick.resize), this.joystick.resize(), this.updateJoystick(), this.joystick.events = {}, this.joystick.touchIdentifier = null, this.joystick.events.touchstart = (r) => {
      r.preventDefault();
      const n = zi(r).changedTouches[0];
      n && (this.joystick.active = !0, this.playerState.setState("ctr-joystick", !0), this.joystick.touchIdentifier = n.identifier, this.joystick.angle.current.x = n.clientX, this.joystick.angle.current.y = n.clientY, this.joystick.$limit.style.opacity = "0.5", document.addEventListener("pointerup", this.joystick.events.touchend), document.addEventListener("touchend", this.joystick.events.touchend), document.addEventListener(
        "pointermove",
        this.joystick.events.touchmove,
        { passive: !1 }
      ), document.addEventListener("touchmove", this.joystick.events.touchmove, {
        passive: !1
      }));
    }, this.joystick.events.touchmove = (r) => {
      r.preventDefault();
      const i = [...zi(r).changedTouches].find(
        (o) => o.identifier === this.joystick.touchIdentifier
      );
      i && (this.joystick.angle.current.x = i.clientX, this.joystick.angle.current.y = i.clientY);
    }, this.joystick.events.touchend = (r) => {
      [...zi(r).changedTouches].find(
        (o) => o.identifier === this.joystick.touchIdentifier
      ) && (this.joystick.active = !1, this.playerState.setState("ctr-joystick", !1), this.config.type === "dpad" && this.playerState.setState("ctr-dpad", void 0), this.config.zones && Object.keys(this.config.zones).forEach((o) => {
        this.playerState.setState(
          `ctr-${this.config.zones[o].id}`,
          !1
        );
      }), this.joystick.$limit.style.opacity = "0.25", this.joystick.$cursor.style.transform = "translateX(0px) translateY(0px)", document.removeEventListener(
        "pointerup",
        this.joystick.events.touchend
      ), document.removeEventListener("touchend", this.joystick.events.touchend));
    }, this.joystick.$element.addEventListener(
      "pointerdown",
      this.joystick.events.touchstart,
      { passive: !1 }
    ), this.joystick.$element.addEventListener(
      "touchstart",
      this.joystick.events.touchstart,
      { passive: !1 }
    );
  }
  setupButton({ id: e, label: r, css: n }) {
    let i = {};
    i.id = e, i.value = !1, i.$element = document.createElement("div"), r && (i.$element.innerHTML = r), Object.keys(n.element).forEach((o) => {
      i.$element.style[o] = n.element[o];
    }), document.body.appendChild(i.$element), i.$border = document.createElement("div"), Object.keys(n.border).forEach((o) => {
      i.$border.style[o] = n.border[o];
    }), i.$element.appendChild(i.$border), i.events = {}, i.touchIdentifier = null, i.events.touchstart = (o) => {
      o.preventDefault();
      const s = zi(o).changedTouches[0];
      s && (i.touchIdentifier = s.identifier, i.value = !0, this.playerState.setState(`ctr-${i.id}`, !0), i.$border.style.opacity = "0.5", document.addEventListener("pointerup", i.events.touchend), document.addEventListener("touchend", i.events.touchend));
    }, i.events.touchend = (o) => {
      [...zi(o).changedTouches].find(
        (l) => l.identifier === i.touchIdentifier
      ) && (i.value = !1, this.playerState.setState(`ctr-${i.id}`, !1), i.$border.style.opacity = "0.25", document.removeEventListener("pointerup", i.events.touchend), document.removeEventListener("touchend", i.events.touchend));
    }, i.$element.addEventListener("pointerdown", i.events.touchstart), i.$element.addEventListener("touchstart", i.events.touchstart), this.buttons[i.id] = i;
  }
  updateJoystick() {
    if (this.joystick.active) {
      if (this.joystick.angle.originalValue = -Math.atan2(
        this.joystick.angle.current.y - this.joystick.angle.center.y,
        this.joystick.angle.current.x - this.joystick.angle.center.x
      ), this.joystick.angle.value = this.joystick.angle.originalValue + this.joystick.angle.offset, this.config.type === "angular" ? this.playerState.setState("ctr-angle", this.joystick.angle.value) : this.config.type === "dpad" && this.playerState.setState(
        "ctr-dpad",
        p3(this.joystick.angle.originalValue)
      ), this.config.zones) {
        let o = g3(
          this.joystick.angle.originalValue
        );
        this.config.zones[o] && this.playerState.setState(
          `ctr-${this.config.zones[o].id}`,
          !0
        ), Object.keys(this.config.zones).forEach((s) => {
          s !== o && this.playerState.setState(
            `ctr-${this.config.zones[s].id}`,
            !1
          );
        });
      }
      const e = Math.hypot(
        this.joystick.angle.current.y - this.joystick.angle.center.y,
        this.joystick.angle.current.x - this.joystick.angle.center.x
      );
      let r = e;
      r > 20 && (r = 20 + Math.log(e - 20) * 5), r > 43 && (r = 43);
      const n = Math.sin(this.joystick.angle.originalValue + Math.PI * 0.5) * r, i = Math.cos(this.joystick.angle.originalValue + Math.PI * 0.5) * r;
      this.joystick.$cursor.style.transform = `translateX(${n}px) translateY(${i}px)`;
    }
    this.requestAnimationFrameId = window.requestAnimationFrame(
      this.updateJoystick.bind(this)
    );
  }
  destroy() {
    this.requestAnimationFrameId && (cancelAnimationFrame(this.requestAnimationFrameId), this.requestAnimationFrameId = null), this.joystick.$element.remove(), Object.values(this.buttons).forEach((e) => {
      e.$element.remove();
    }), this.buttons = {}, this.joystick = {}, this.playerState.setState("ctr-joystick", !1), this.playerState.setState("ctr-dpad", void 0), this.playerState.setState("ctr-angle", 0);
  }
}
function qa(t, e, r) {
  t += "";
  var n = { "00": { A: { env: ["#ff2f2b"], clo: ["#fff", "#000"], head: ["#fff"], mouth: ["#fff", "#000", "#000"], eyes: ["#000", "none", "#00FFFF"], top: ["#fff", "#fff"] }, B: { env: ["#ff1ec1"], clo: ["#000", "#fff"], head: ["#ffc1c1"], mouth: ["#fff", "#000", "#000"], eyes: ["#FF2D00", "#fff", "none"], top: ["#a21d00", "#fff"] }, C: { env: ["#0079b1"], clo: ["#0e00b1", "#d1fffe"], head: ["#f5aa77"], mouth: ["#fff", "#000", "#000"], eyes: ["#0c00de", "#fff", "none"], top: ["#acfffd", "#acfffd"] } }, "01": { A: { env: ["#a50000"], clo: ["#f06", "#8e0039"], head: ["#85492C"], mouth: ["#000"], eyes: ["#000", "#ff9809"], top: ["#ff9809", "#ff9809", "none", "none"] }, B: { env: ["#40E83B"], clo: ["#00650b", "#62ce5a"], head: ["#f7c1a6"], mouth: ["#6e1c1c"], eyes: ["#000", "#ff833b"], top: ["#67FFCC", "none", "none", "#ecff3b"] }, C: { env: ["#ff2c2c"], clo: ["#fff", "#000"], head: ["#ffce8b"], mouth: ["#000"], eyes: ["#000", "#0072ff"], top: ["#ff9809", "none", "#ffc809", "none"] } }, "02": { A: { env: ["#ff7520"], clo: ["#d12823"], head: ["#fee3c5"], mouth: ["#d12823"], eyes: ["#000", "none"], top: ["#000", "none", "none", "#FFCC00", "red"] }, B: { env: ["#ff9700"], clo: ["#000"], head: ["#d2ad6d"], mouth: ["#000"], eyes: ["#000", "#00ffdc"], top: ["#fdff00", "#fdff00", "none", "none", "none"] }, C: { env: ["#26a7ff"], clo: ["#d85cd7"], head: ["#542e02"], mouth: ["#f70014"], eyes: ["#000", "magenta"], top: ["#FFCC00", "#FFCC00", "#FFCC00", "#ff0000", "yellow"] } }, "03": { A: { env: ["#6FC30E"], clo: ["#b4e1fa", "#5b5d6e", "#515262", "#a0d2f0", "#a0d2f0"], head: ["#fae3b9"], mouth: ["#fff", "#000"], eyes: ["#000"], top: ["#8eff45", "#8eff45", "none", "none"] }, B: { env: ["#00a58c"], clo: ["#000", "none", "none", "none", "none"], head: ["#FAD2B9"], mouth: ["#fff", "#000"], eyes: ["#000"], top: ["#FFC600", "none", "#FFC600", "none"] }, C: { env: ["#ff501f"], clo: ["#000", "#ff0000", "#ff0000", "#7d7d7d", "#7d7d7d"], head: ["#fff3dc"], mouth: ["#d2001b", "none"], eyes: ["#000"], top: ["#D2001B", "none", "none", "#D2001B"] } }, "04": { A: { env: ["#fc0"], clo: ["#901e0e", "#ffbe1e", "#ffbe1e", "#c55f54"], head: ["#f8d9ad"], mouth: ["#000", "none", "#000", "none"], eyes: ["#000"], top: ["#583D00", "#AF892E", "#462D00", "#a0a0a0"] }, B: { env: ["#386465"], clo: ["#fff", "#333", "#333", "#333"], head: ["#FFD79D"], mouth: ["#000", "#000", "#000", "#000"], eyes: ["#000"], top: ["#27363C", "#5DCAD4", "#314652", "#333"] }, C: { env: ["#DFFF00"], clo: ["#304267", "#aab0b1", "#aab0b1", "#aab0b1"], head: ["#e6b876"], mouth: ["#50230a", "#50230a", "#50230a", "#50230a"], eyes: ["#000"], top: ["#333", "#afafaf", "#222", "#6d3a1d"] } }, "05": { A: { env: ["#a09300"], clo: ["#c7d4e2", "#435363", "#435363", "#141720", "#141720", "#e7ecf2", "#e7ecf2"], head: ["#f5d4a6"], mouth: ["#000", "#cf9f76"], eyes: ["#000", "#000", "#000", "#000", "#000", "#000", "#fff", "#fff", "#fff", "#fff", "#000", "#000"], top: ["none", "#fdff00"] }, B: { env: ["#b3003e"], clo: ["#000", "#435363", "#435363", "#000", "none", "#e7ecf2", "#e7ecf2"], head: ["#f5d4a6"], mouth: ["#000", "#af9f94"], eyes: ["#9ff3ff;opacity:0.96", "#000", "#9ff3ff;opacity:0.96", "#000", "#2f508a", "#000", "#000", "#000", "none", "none", "none", "none"], top: ["#ff9a00", "#ff9a00"] }, C: { env: ["#884f00"], clo: ["#ff0000", "#fff", "#fff", "#141720", "#141720", "#e7ecf2", "#e7ecf2"], head: ["#c57b14"], mouth: ["#000", "#cf9f76"], eyes: ["none", "#000", "none", "#000", "#5a0000", "#000", "#000", "#000", "none", "none", "none", "none"], top: ["#efefef", "none"] } }, "06": { A: { env: ["#8acf00"], clo: ["#ee2829", "#ff0"], head: ["#ffce73"], mouth: ["#fff", "#000"], eyes: ["#000"], top: ["#000", "#000", "none", "#000", "#ff4e4e", "#000"] }, B: { env: ["#00d2a3"], clo: ["#0D0046", "#ffce73"], head: ["#ffce73"], mouth: ["#000", "none"], eyes: ["#000"], top: ["#000", "#000", "#000", "none", "#ffb358", "#000", "none", "none"] }, C: { env: ["#ff184e"], clo: ["#000", "none"], head: ["#ffce73"], mouth: ["#ff0000", "none"], eyes: ["#000"], top: ["none", "none", "none", "none", "none", "#ffc107", "none", "none"] } }, "07": { A: { env: ["#00deae"], clo: ["#ff0000"], head: ["#ffce94"], mouth: ["#f73b6c", "#000"], eyes: ["#e91e63", "#000", "#e91e63", "#000", "#000", "#000"], top: ["#dd104f", "#dd104f", "#f73b6c", "#dd104f"] }, B: { env: ["#181284"], clo: ["#491f49", "#ff9809", "#491f49"], head: ["#f6ba97"], mouth: ["#ff9809", "#000"], eyes: ["#c4ffe4", "#000", "#c4ffe4", "#000", "#000", "#000"], top: ["none", "none", "#d6f740", "#516303"] }, C: { env: ["#bcf700"], clo: ["#ff14e4", "#000", "#14fffd"], head: ["#7b401e"], mouth: ["#666", "#000"], eyes: ["#00b5b4", "#000", "#00b5b4", "#000", "#000", "#000"], top: ["#14fffd", "#14fffd", "#14fffd", "#0d3a62"] } }, "08": { A: { env: ["#0df"], clo: ["#571e57", "#ff0"], head: ["#f2c280"], eyes: ["#795548", "#000"], mouth: ["#ff0000"], top: ["#de3b00", "none"] }, B: { env: ["#B400C2"], clo: ["#0D204A", "#00ffdf"], head: ["#ca8628"], eyes: ["#cbbdaf", "#000"], mouth: ["#1a1a1a"], top: ["#000", "#000"] }, C: { env: ["#ffe926"], clo: ["#00d6af", "#000"], head: ["#8c5100"], eyes: ["none", "#000"], mouth: ["#7d0000"], top: ["#f7f7f7", "none"] } }, "09": { A: { env: ["#4aff0c"], clo: ["#101010", "#fff", "#fff"], head: ["#dbbc7f"], mouth: ["#000"], eyes: ["#000", "none", "none"], top: ["#531148", "#531148", "#531148", "none"] }, B: { env: ["#FFC107"], clo: ["#033c58", "#fff", "#fff"], head: ["#dbc97f"], mouth: ["#000"], eyes: ["none", "#fff", "#000"], top: ["#FFEB3B", "#FFEB3B", "none", "#FFEB3B"] }, C: { env: ["#FF9800"], clo: ["#b40000", "#fff", "#fff"], head: ["#E2AF6B"], mouth: ["#000"], eyes: ["none", "#fff", "#000"], top: ["#ec0000", "#ec0000", "none", "none"] } }, 10: { A: { env: ["#104c8c"], clo: ["#354B65", "#3D8EBB", "#89D0DA", "#00FFFD"], head: ["#cc9a5c"], mouth: ["#222", "#fff"], eyes: ["#000", "#000"], top: ["#fff", "#fff", "none"] }, B: { env: ["#0DC15C"], clo: ["#212121", "#fff", "#212121", "#fff"], head: ["#dca45f"], mouth: ["#111", "#633b1d"], eyes: ["#000", "#000"], top: ["none", "#792B74", "#792B74"] }, C: { env: ["#ffe500"], clo: ["#1e5e80", "#fff", "#1e5e80", "#fff"], head: ["#e8bc86"], mouth: ["#111", "none"], eyes: ["#000", "#000"], top: ["none", "none", "#633b1d"] } }, 11: { A: { env: ["#4a3f73"], clo: ["#e6e9ee", "#f1543f", "#ff7058", "#fff", "#fff"], head: ["#b27e5b"], mouth: ["#191919", "#191919"], eyes: ["#000", "#000", "#57FFFD"], top: ["#ffc", "#ffc", "#ffc"] }, B: { env: ["#00a08d"], clo: ["#FFBA32", "#484848", "#4e4e4e", "#fff", "#fff"], head: ["#ab5f2c"], mouth: ["#191919", "#191919"], eyes: ["#000", "#ff23fa;opacity:0.39", "#000"], top: ["#ff90f4", "#ff90f4", "#ff90f4"] }, C: { env: ["#22535d"], clo: ["#000", "#ff2500", "#ff2500", "#fff", "#fff"], head: ["#a76c44"], mouth: ["#191919", "#191919"], eyes: ["#000", "none", "#000"], top: ["none", "#00efff", "none"] } }, 12: { A: { env: ["#2668DC"], clo: ["#2385c6", "#b8d0e0", "#b8d0e0"], head: ["#ad8a60"], mouth: ["#000", "#4d4d4d"], eyes: ["#7fb5a2", "#d1eddf", "#301e19"], top: ["#fff510", "#fff510"] }, B: { env: ["#643869"], clo: ["#D67D1B", "#b8d0e0", "#b8d0e0"], head: ["#CC985A", "none0000"], mouth: ["#000", "#ececec"], eyes: ["#1f2644", "#9b97ce", "#301e19"], top: ["#00eaff", "none"] }, C: { env: ["#F599FF"], clo: ["#2823C6", "#b8d0e0", "#b8d0e0"], head: ["#C7873A"], mouth: ["#000", "#4d4d4d"], eyes: ["#581b1b", "#FF8B8B", "#000"], top: ["none", "#9c0092"] } }, 13: { A: { env: ["#d10084"], clo: ["#efedee", "#00a1e0", "#00a1e0", "#efedee", "#ffce1c"], head: ["#b35f49"], mouth: ["#3a484a", "#000"], eyes: ["#000"], top: ["#000", "none", "#000", "none"] }, B: { env: ["#E6C117"], clo: ["#efedee", "#ec0033", "#ec0033", "#efedee", "#f2ff05"], head: ["#ffc016"], mouth: ["#4a3737", "#000"], eyes: ["#000"], top: ["#ffe900", "#ffe900", "none", "#ffe900"] }, C: { env: ["#1d8c00"], clo: ["#e000cb", "#fff", "#fff", "#e000cb", "#ffce1c"], head: ["#b96438"], mouth: ["#000", "#000"], eyes: ["#000"], top: ["#53ffff", "#53ffff", "none", "none"] } }, 14: { A: { env: ["#fc0065"], clo: ["#708913", "#fdea14", "#708913", "#fdea14", "#708913"], head: ["#DEA561"], mouth: ["#444", "#000"], eyes: ["#000"], top: ["#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f", "#32393f"] }, B: { env: ["#81f72e"], clo: ["#ff0000", "#ffc107", "#ff0000", "#ffc107", "#ff0000"], head: ["#ef9831"], mouth: ["#6b0000", "#000"], eyes: ["#000"], top: ["#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "#FFFAAD", "none", "none", "none", "none"] }, C: { env: ["#00D872"], clo: ["#590D00", "#FD1336", "#590D00", "#FD1336", "#590D00"], head: ["#c36c00"], mouth: ["#56442b", "#000"], eyes: ["#000"], top: ["#004E4C", "#004E4C", "#004E4C", "#004E4C", "#004E4C", "#004E4C", "#004E4C", "#004E4C", "#004E4C", "none", "none", "none", "none", "none", "none", "none", "none"] } }, 15: { A: { env: ["#111"], clo: ["#000", "#00FFFF"], head: ["#755227"], mouth: ["#fff", "#000"], eyes: ["black", "#008;opacity:0.67", "aqua"], top: ["#fff", "#fff", "#fff", "#fff", "#fff"] }, B: { env: ["#00D0D4"], clo: ["#000", "#fff"], head: ["#755227"], mouth: ["#fff", "#000"], eyes: ["black", "#1df7ff;opacity:0.64", "#fcff2c"], top: ["#fff539", "none", "#fff539", "none", "#fff539"] }, C: { env: ["#DC75FF"], clo: ["#000", "#FFBDEC"], head: ["#997549"], mouth: ["#fff", "#000"], eyes: ["black", "black", "aqua"], top: ["#00fffd", "none", "none", "none", "none"] } } }, i = [], o = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 231 231">', s = "</svg>", a = '<path d="M33.83,33.83a115.5,115.5,0,1,1,0,163.34,115.49,115.49,0,0,1,0-163.34Z" style="fill:#01;"/>', l = '<path d="m115.5 51.75a63.75 63.75 0 0 0-10.5 126.63v14.09a115.5 115.5 0 0 0-53.729 19.027 115.5 115.5 0 0 0 128.46 0 115.5 115.5 0 0 0-53.729-19.029v-14.084a63.75 63.75 0 0 0 53.25-62.881 63.75 63.75 0 0 0-63.65-63.75 63.75 63.75 0 0 0-0.09961 0z" style="fill:#000;"/>', c = "stroke-linecap:round;stroke-linejoin:round;stroke-width:";
  i["00"] = [], i["00"].env = a, i["00"].clo = '<path d="m141.74 195a114.93 114.93 0 0 1 37.912 16.45l0.07 0.05c-1.17 0.79-2.3601 1.55-3.5601 2.29a115.55 115.55 0 0 1-120.95 0.21q-2.0001-1.23-4.0002-2.54a114.79 114.79 0 0 1 38.002-16.5 116.21 116.21 0 0 1 15.791-2.49v-14.57c1.32 0.22 2.6501 0.39 4.0002 0.51 2.0001 0.19 4.0002 0.28 6.1202 0.29a64.333 64.33 0 0 0 8.8804-0.62c0.67003-0.09 1.3401-0.2 2.0001-0.31v14.69a118 118 0 0 1 15.741 2.54z" style="fill:#fff;"/><path d="m79.292 212a3.4601 3.46 0 0 0 3.8902 5.07 3.3801 3.38 0 0 0 2.1001-1.61 3.4701 3.47 0 0 0-1.2801-4.72 3.4201 3.42 0 0 0-2.6201-0.34 3.5101 3.51 0 0 0-2.0901 1.6zm60.122 0.46a3.4901 3.49 0 0 0 1.21 4.7h0.06a3.4601 3.46 0 0 0 4.7202-1.27l0.07-0.13a3.4601 3.46 0 0 0-1.34-4.6 3.4601 3.46 0 0 0-2.5801-0.32 3.5301 3.53 0 0 0-2.1001 1.61zm9.8004 5.7 5.8602 5.87c-1.39 0.5-2.7901 1-4.2102 1.44l-4.4802-4.47a7.5203 7.52 0 0 1-1.9401 0.81 7.8303 7.83 0 0 1-6.0002-0.79 7.8703 7.87 0 0 1-2.9201-10.69v-0.07a7.8903 7.89 0 0 1 10.77-2.88l0.12 0.07a7.8603 7.86 0 0 1 2.7901 10.62v0.07zm-37.701-2.36-9.5004 9.51v4.9c-1.35-0.16-2.6801-0.33-4.0002-0.54v-6l0.58002-0.58 10.1-10.09a7.8703 7.87 0 1 1 2.8401 2.86zm7.3203-5.91a3.4601 3.46 0 1 0-1.6101 2.1 3.3801 3.38 0 0 0 1.6101-2.1zm-29.741 7.82 3.0901 3.1 0.59002 0.59v7.36c-1.3401-0.26-2.6801-0.55-4.0002-0.87v-4.84l-2.5101-2.51a7.5203 7.52 0 0 1-1.9401 0.81 7.8803 7.88 0 1 1 1.9101-14.43 7.8703 7.87 0 0 1 2.8901 10.75z" style="fill:#1a1a1a;"/>', i["00"].head = l, i["00"].mouth = '<path d="m94.19 136.84h42.632a3.7801 3.78 0 0 1 3.7802 3.78v3.22a15.231 15.23 0 0 1-15.211 15.16h-19.781a15.251 15.25 0 0 1-15.221-15.16v-3.22a3.8002 3.8 0 0 1 3.7802-3.78z" style="fill:#fff;' + c + '3px;stroke:#1a1a1a;"/><path d="m130.96 136.84v21.16m-30.911-21.16v21.16m10.34-21.16v22.16m10.31-22.2v22.2" style="fill:none;' + c + '3px;stroke:#1a1a1a;"/>', i["00"].eyes = '<path d="m83.739 83.92h63.533a19.101 19.1 0 0 1 19.051 19 19.111 19.11 0 0 1-19.051 19h-63.533a19.091 19.09 0 0 1-19.001-19 19.091 19.09 0 0 1 19.001-19z" style="fill:#1a1a1a;"/><path d="m140.23 93.54a9.3804 9.38 0 1 0 9.3804 9.38 9.3804 9.38 0 0 0-9.3804-9.38zm-49.402 0a9.3804 9.38 0 1 0 9.3804 9.38 9.3904 9.39 0 0 0-9.3804-9.38z" style="fill:#e6e7e8;"/><rect x="79.795" y="98.627" width="71.471" height="8.5859" ry="4.2929" style="fill:#b3b3b3;"/>', i["00"].top = '<path d="m32.902 67.662c-0.36295 1.7227-6.2342 30.695 5.6133 52.596 4.5843 8.4743 9.0081 13.239 12.75 15.893a67.7 67.7 0 0 1-3.4688-21.35 67.7 67.7 0 0 1 2.332-17.658c-4.4914-2.4646-10.868-6.9012-13.834-13.52-4.1626-9.285-3.6155-14.673-3.3926-15.961zm165.19 0c0.22292 1.2882 0.77005 6.6759-3.3926 15.961-2.9664 6.6183-9.3426 11.055-13.834 13.52a67.7 67.7 0 0 1 2.332 17.658 67.7 67.7 0 0 1-3.4688 21.35c3.7419-2.6532 8.1657-7.4183 12.75-15.893 11.847-21.9 5.9762-50.873 5.6133-52.596z" style="fill:#fff;"/><path d="m115.73 13.191c-7.3787-0.13351-13.509 5.7888-13.631 13.168-0.10128 5.8827 3.4508 10.518 8.0566 12.52 1.061 0.46115 2.1869 0.78009 3.3418 0.95703v8.4291c0.66778-0.02035 1.3358-0.03077 2.0039-0.03125 0.66547-9e-5 1.3309 0.0097 1.9961 0.0293v-8.4115c2.6002-0.38406 5.1586-1.5484 7.3086-3.625 4.2322-4.0878 4.9991-9.8755 3.1582-14.549-1.8407-4.6726-6.3502-8.3834-12.232-8.4863z" style="fill:#fff;"/>', i["01"] = [], i["01"].env = a, i["01"].clo = '<path d="m141.75 195a114.79 114.79 0 0 1 38 16.5 115.53 115.53 0 0 1-128.46 0 114.79 114.79 0 0 1 38-16.5c0 10.76 11.75 19.48 26.25 19.48s26.25-8.72 26.25-19.48z" style="fill:#1a1a1a;"/><path d="m92.502 194.27v0.70391c0 4.3033 2.4373 8.2583 6.3807 11.183 4.2199 3.1204 10.106 5.0508 16.661 5.0508 6.548 0 12.434-1.9303 16.654-5.0508 3.9434-2.9245 6.388-6.8795 6.388-11.183v-0.67489c1.0768 0.21771 2.1463 0.44994 3.2158 0.69666h-7e-3c1.0695 0.24672 2.1318 0.50798 3.1867 0.791-0.27648 6.103-3.6524 11.553-8.9708 15.493-5.2821 3.9114-12.521 6.328-20.466 6.328-7.9449 0-15.184-2.4165-20.474-6.328-5.333-3.9477-8.7089-9.4194-8.9708-15.544 1.055-0.27577 2.1099-0.53702 3.1722-0.78376 1.0695-0.23947 2.1463-0.46443 3.2304-0.68213z" style="fill:#b3b3b3;"/>', i["01"].head = l, i["01"].mouth = '<path d="m100.35 143.85a7.67 7.67 0 0 0 7.58 7.7v0a7.66 7.66 0 0 0 7.57-7.7 7.66 7.66 0 0 0 7.57 7.7v0a7.67 7.67 0 0 0 7.58-7.7" style="fill:none;' + c + '6.3998px;stroke:#333;"/>', i["01"].eyes = '<path d="m78.73 111a10.9 10.9 0 0 1 15.19 0m43.16 0a10.9 10.9 0 0 1 15.19 0" style="fill:none;' + c + '6.1999px;stroke:#333;"/><path d="m79.804 123.74h7.07m57.273 0h7.05" style="fill:none;' + c + '5.9998px;stroke:#b8b8b8;"/>', i["01"].top = '<path d="m57.534 142.03c-6.9383-31.75-0.57294-52.577 14.174-62.344 22.562-12.283 62.082-12.222 83.484-1.8846 21.348 11.177 22.124 37.396 18.498 63.733 8.1279-14.155 13.164-31.598 14.085-48.902 1.0828-11.795-1.1756-18.866-7.4833-27.972-26.465-37.685-103.45-31.56-129.66-2.8372-7.8504 9.4615-9.6006 17.478-9.275 26.667 1.0024 18.667 6.9688 38.508 16.18 53.54z" style="fill:#b3b3b3;"/><path d="m111.26 3.0423c-6.013 0.1128-12.629 2.6924-15.291 7.9082-1.1676 3.2383-1.6758 6.2069-1.6758 8.8926 0.89228-0.2661 1.8005-0.5164 2.7266-0.7441 3.7502-1.0672 7.4851-1.7135 11.129-1.9981 1.1007-0.086 2.1953-0.1391 3.2773-0.1601h2e-3c5.6969-0.1133 11.09 0.6603 15.904 2.0527 0.0552-3.042-0.70696-5.9824-2.1738-8.5-1.8411-3.1599-4.7033-5.5568-8.4297-6.8262-1.6883-0.4952-3.5163-0.662-5.4688-0.625zm3.0664 17.449c-0.69317-0.01-1.3919-0.01-2.0938 0h-2e-3c-1.1591 0.019-2.3326 0.064-3.5117 0.1386-3.9035 0.246-7.9025 0.8061-11.92 1.7285-15.159 3.0075-26.469 9.9279-22.068 19.682 22.891-8.7773 52.315-10.403 76.023-2.2129 2.1414-9.5529-14.939-19.081-36.428-19.34z" style="fill:#b3b3b3;"/><path d="m165.62 16.981c-0.8575 0-1.9406 0.54389-3.3476 1.3574-7.3382 4.7652-13.452 10.867-19.516 18.363 9.2734 2.1825 17.903 5.6706 25.213 10.604 1.1512-9.1263 1.9137-18.503 0.055-26.996-0.57-2.4184-1.3017-3.3267-2.4043-3.3281zm-104.09 1.6934c-1.1026 0-1.8342 0.91165-2.4043 3.3301-1.8794 8.5869-1.0806 18.078 0.092 27.299 7.0559-4.6638 15.687-8.3667 25.111-10.984-6.043-7.4601-12.139-13.537-19.451-18.285-1.407-0.81353-2.4901-1.3605-3.3477-1.3594z" style="fill:#b3b3b3;"/><path d="m162.45 16.686c-2.3175 2e-3 -4.6276 0.57608-6.8926 1.668-8.4768 6.0155-11.113 13.349-10.133 19.787 10.323 2.7077 19.762 7.0658 27.346 13.279 9.848-4.9363 11.32-17.137 4.6152-25.852-4.7104-6.1222-9.8371-8.8878-14.936-8.8828zm-97.318 4.1387c-2.4569 0.0556-5.1642 0.54474-8.1172 1.5176-13.487 4.4433-19.06 21.215-3.6484 31.84 7.2476-6.0694 16.961-10.896 27.892-14.229 0.2193-3.3241-0.3201-7.0817-1.8691-11.236-2.8049-4.8445-7.2233-7.721-13.221-7.8906-0.3408-0.01-0.6861-0.01-1.0371-2e-3z" style="fill:#b3b3b3;"/>', i["02"] = [], i["02"].env = a, i["02"].clo = '<path d="m141.75 195a114.79 114.79 0 0 1 38 16.5 115.53 115.53 0 0 1-128.46 0 114.79 114.79 0 0 1 38-16.5c0 10.76 11.75 19.48 26.25 19.48s26.25-8.72 26.25-19.48z" style="fill:#5a5a5a;"/>', i["02"].head = l, i["02"].mouth = '<path d="m115.5 161.71c-8.24 0-14.46-4.15-19.19-11.25 3.37-2.44 6.51-4.57 10-6.79a5.25 5.25 0 0 1 5.48-0.17 28.19 28.19 0 0 1 3.68 2.75 28.19 28.19 0 0 1 3.68-2.75 5.25 5.25 0 0 1 5.48 0.17c3.52 2.22 6.66 4.35 10 6.79-4.74 7.1-11 11.25-19.19 11.25z" style="fill:#5a5a5a;"/>', i["02"].eyes = '<path d="m172.7 90.75h-6.54c-0.14-0.1-0.26-0.22-0.4-0.3-4.48-2.76-22.75-2.11-33.71 1.2-1 0.3-1.91 0.61-2.75 0.94-1.8937 0.79244-3.8739 1.3597-5.9 1.69-5.5051 0.79002-10.403 0.79002-15.908 0-2.0261-0.33034-4.0063-0.89756-5.9-1.69-0.84-0.33-1.76-0.64-2.75-0.94-11-3.31-29.23-4-33.71-1.2-0.13832 0.08869-0.2688 0.18906-0.39 0.3h-6.55c-1.1046 0-2 0.89543-2 2v4.66c-0.0013 0.98185 0.49088 1.8986 1.31 2.44l1.9 1.27c0.59238 0.38889 0.93475 1.0622 0.9 1.77-0.14175 5.4854 0.88072 10.939 3 16 3.58 8.38 16 10.9 24.93 10.9 2.6976 0.0771 5.3921-0.2361 8-0.93 4.35-1.43 8.24-7.36 10.45-12.42 1.7607-3.8506 2.7493-8.009 2.91-12.24 7.3e-4 -0.7138 0.38183-1.3731 1-1.73 3.2281-1.951 6.5798-1.951 9.8079 0 0.61817 0.3569 0.99927 1.0162 1 1.73 0.16067 4.231 1.1493 8.3894 2.91 12.24 2.21 5.06 6.1 11 10.45 12.42 2.6079 0.6939 5.3024 1.0071 8 0.93 8.92 0 21.35-2.52 24.93-10.9 2.1193-5.0614 3.1418-10.515 3-16-0.0348-0.70778 0.30762-1.3811 0.9-1.77l1.9-1.27c0.81913-0.54136 1.3113-1.4582 1.31-2.44v-4.6c0.0336-1.1048-0.83521-2.0274-1.94-2.06z" style="fill:#1a1a1a;' + c + '2.5;stroke:#b3b3b3;"/>', i["02"].top = '<path d="m124.22 13.61c-19.783 0-36.945 8.0887-39.695 24.106-15.332 0.23539-31.831 2.7712-41.663 15.782-6.0238 7.9604-7.0402 19.901-6.8476 31.724 0.46007 28.503 10.742 64.228-4.3012 89.714 16.584 5.7777 43.086 10.742 73.59 11.662v-8.6558c-1.851-0.35308-3.6592-0.78105-5.4353-1.2732-30.953-8.4632-50.672-36.635-47.259-68.669 1.5514-10.603 4.6221-19.665 10.025-27.69 5.3818-7.9925 13.267-15.717 23.892-21.41 0.40658 0.72757 1.9901 3.5843 2.4074 4.3012 7.5003 12.775 17.986 23.849 33.157 26.866 12.433 2.4609 23.849 3.4666 36.346 1.1555 4.2584-0.78106 10.667-2.3967 14.851-2.4181 14.861 33.404-1.0806 75.035-40.668 87.457-2.2255 0.70616-4.5258 1.316-6.8904 1.8189 0 2.707-0.0428 5.6493-0.0642 8.5274 23.603-0.72757 48.682-4.0444 72.874-11.234-18.521-32.152 0.81315-89.083-10.036-121.46-9.0731-26.973-38.85-40.315-64.282-40.305z" style="fill:#c5c5c5;"/><path d="m33.147 172.32c-2.6535 5.1143-6.088 9.9504-10.1 12.411 7.8427 10.453 17.387 19.516 28.257 26.781 16.038-10.731 35.629-17.055 54-18.606v-9.0089c-30.065-0.94155-56.108-5.8847-72.157-11.577zm164.06 0.55637c-23.731 7.0723-48.361 10.325-71.525 11.042-0.0321 3.1242-0.0535 6.2377-0.0107 9.0517 19.227 1.7226 37.908 7.8534 53.989 18.542 0.0107 0 0.0107 0 0.0214 0.0107 10.731-7.1686 20.179-16.081 27.958-26.374-4.2798-2.3967-7.832-6.9653-10.432-12.272z" style="fill:#c5c5c5;"/><path d="m50.02 46.5c-2.9297 1.9143-6.1313 3.8826-10.154 7.9805-14.091 14.359-16.145 27.701-6.1406 44.018 4.2049 6.8583 6.1414 13.706-0.24609 20.5-7.7143 8.1957-21.559 4.2912-21.537 16.061 0.0214 8.613 15.063 7.9178 22.531 13.984 3.7662 3.0707 5.0836 8.3992 2.0664 12.508-4.2156 5.7456-16.006 7.3715-22.629 8.9336 5.8811 10.843 13.45 20.638 22.355 29.033l0.0039 0.0234 0.0059-0.0137c2e-3 2e-3 0.0038 4e-3 0.0059 6e-3 0.0034-0.0112 0.0063-0.0219 0.0098-0.0332 14.775-12.218 20.268-20.965 49.461-28.434-17.404-10.258-30.68-27.122-24.143-35.34 4.4123-5.5444 5.6612-7.8633 6.4062-12.078 2.3582-13.339-10.208-22.335-9.2363-32.715 1.9432-8.2346 11.379-11.173 16.947-15.115 5.4577-3.9082 9.8014-8.7695 10.799-16.918-13.558-4.8896-17.609-5.8617-36.506-12.4zm140.87 19.357c-3.4404-0.91243-23.311 122.43 4.4121 133.14 8.9661-8.5809 16.552-18.584 22.404-29.658 0-0.31029-25.133-3.9922-25.979-14.018-0.10699-1.1769 0.11822-1.4855 0.86718-2.502 6.6764-9.2122 30.716-11.416 29.646-23.496-0.27818-3.1563-4.1617-5.2334-6.7402-6.4531-12.155-5.767-32.942-9.6494-15.031-24.543 9.2122-7.3505 10.43-8.4323 0.59766-14.691-9.4583-6.0238-9.394-11.993-9.7578-16.326-0.0767-0.93035-0.22089-1.4003-0.41992-1.4531z" style="fill:#c5c5c5;"/><path d="m133.83 39.909c-11.33 1.393-9.5492 16.204-2e-3 16.643-4.5102 10.717 9.0165 16.181 14.441 8.3125 6.562 8.6765 18.596 0.94751 14.457-8.3125 11.718-1.5381 9.2769-16.099 0-16.643 4.503-10.867-9.4883-16.101-14.457-8.3301-6.8832-9.0411-18.509-0.47321-14.439 8.3301z" style="fill:#333;"/><path d="m153.86 48.222c0-3.0528-2.5184-5.5648-5.5791-5.5648-3.0783 0-5.5793 2.512-5.5793 5.5648 0 3.0703 2.501 5.5648 5.5793 5.5648 3.0606 0 5.5791-2.4946 5.5791-5.5648z" style="fill:#f9f9f9;"/>', i["03"] = [], i["03"].env = a, i["03"].clo = '<path d="m141.75 195c13.563 3.1499 26.439 8.7409 38 16.5-38.873 26.001-89.587 26.001-128.46 0 11.561-7.7591 24.437-13.35 38-16.5 8.4869 8.8011 26.21 25.619 26.21 25.619s17.603-16.972 26.25-25.619z" style="fill:#d6d6d6;"/><path d="m109 230.81 1.6836-14.33h9.6328l1.6836 14.33c-2.16 0.12-4.33 0.19-6.51 0.19s-4.35-0.07-6.51-0.19z" style="fill:#5e5e5e;"/><path d="m124.17 210.6h-17.349v5.53a3.8828 3.29 0 0 0 3.8828 3.29h9.583a3.8828 3.29 0 0 0 3.8828-3.29z" style="fill:#535353;"/><path d="m140.57 190.36-25.066 20.245c5.9686 3.2455 11.597 7.0814 16.8 11.45 1.5989 1.3338 3.9762 1.1189 5.31-0.48 0.21005-0.25749 0.38802-0.53956 0.52999-0.84l10.826-23.805-4-6c-0.90256-1.351-2.7298-1.7137-4.08-0.81-0.11612 0.0786-0.22641 0.16549-0.33 0.26z" style="fill:#c6c6c6;"/><path d="m90.434 190.36 25.066 20.245c-5.9686 3.2455-11.597 7.0814-16.8 11.45-1.5989 1.3338-3.9762 1.1189-5.31-0.48-0.21005-0.25749-0.38802-0.53956-0.52999-0.84l-10.826-23.805 4-6c0.90256-1.351 2.7298-1.7137 4.08-0.81 0.11612 0.0786 0.22641 0.16549 0.33 0.26z" style="fill:#c6c6c6;"/>', i["03"].head = l, i["03"].mouth = '<path d="m136.21 147.09a21.77 21.77 0 0 1-40.13 0z" style="fill:#fff;' + c + '3.4999px;stroke:#000;"/>', i["03"].eyes = '<path d="m145.39 104.7-11.52 11.2h17.26m-65.52-11.2 11.52 11.2h-17.26" style="fill:none;' + c + '5.4998px;stroke:#000;"/>', i["03"].top = '<path d="m43.891 77.836c-5.1124 28.237 2.1347 61.004 24.792 81.332-6.2362-12.503-9.5362-33.948-9.4887-45.458-0.50203-37.473 41.439-46.335 56.149-17.614 18.8-31.2 52.825-16.872 54.062 13.714 0.56018 13.844-0.43568 25.598-7.0962 48.966 18.372-12.47 28.012-53.959 23.545-80.941-47.486-2.2552-94.831-2.5724-141.96 0z" style="fill:#1a1a1a;"/><path d="m111.26 12.782c-18.508 0.0791-32.594 3.6163-32.594 3.6163 24.513 5.6002 32.807 10.504 31.743 19.835-0.87227 9.702-11.092 10.875-20.811 11.554-5.2548 0.36414-10.949 0.71523-16.391 1.7525-11.862 2.2818-19.946 4.3736-24.447 11.956-1.7012 2.8662-3.7945 10.428-4.8689 16.34h141.96c-5.7242-38.563-32.557-65.073-74.595-65.054z" style="fill:#1a1a1a;"/><path d="m73.292 44.77c-11.788 2.2816-18.923 5.5444-23.394 13.126-2.8484 6.7586-4.8454 13.238-6.0072 19.939h141.96c-1.9772-14.576-6.8677-28.248-19.277-32.098-28.834-6.3308-63.774-6.3553-93.285-0.96761z" style="fill:#1a1a1a;"/><path d="m165.95 35.642c-11.178 21.829-91.89 19.36-103.98 2.3011-9.703 12.267-15.605 25.883-18.079 39.892h141.96c-3.0096-17.158-9.7424-32.688-19.902-42.193z" style="fill:#1a1a1a;"/>', i["04"] = [], i["04"].env = a, i["04"].clo = '<path d="m141.75 195a114.79 114.79 0 0 1 38 16.5 115.53 115.53 0 0 1-128.46 0 114.79 114.79 0 0 1 38-16.5l15.71 15.75h21z" style="fill:#949494;"/><path d="m115.45 211.34-10.55 10.54a2.51 2.51 0 0 1-3.5599 0 2 2 0 0 1-0.26999-0.30994l-18.48-25.4 5.8901-5.8899a2.52 2.52 0 0 1 3.5199-0.0791l23.49 21.14z" style="fill:#c0c0c0;"/><path d="m115.45 211.34 10.55 10.54a2.51 2.51 0 0 0 3.5599 0 2 2 0 0 0 0.26999-0.30994l18.48-25.4-5.8901-5.8899a2.52 2.52 0 0 0-3.4699-0.089l-23.49 21.14z" style="fill:#c0c0c0;"/><path d="m158.41 199.58-10.11-3.2401v29.93q5.1601-1.5299 10.11-3.51zm-75.82 26.66v-29.9l-10.1 3.2401v23.14c3.2901 1.3199 6.67 2.4999 10.1 3.5199z" style="fill:#7c7c7c;"/>', i["04"].head = l, i["04"].mouth = '<path d="m118.05 148.38c-1.5064 0.59192-2.595 2.0264-2.6191 3.9863-0.0574 1.3977 0.53421 3.5611 3.6758 5.7949 8.0544 4.9446 21.507 3.6862 21.255-7.1658-4.664 4.8219-10.021 5.6377-14.773 0.73907-1.2328-1.1599-2.3694-2.4032-3.9294-3.1408-1.0946-0.50424-2.2257-0.61071-3.6096-0.21337z" style="fill:#333;"/><path d="m133.61 154.93c3.0731-0.48816 5.5702-2.8457 5.4438-4.5059-0.47801-4.8311-5.7317-3.0917-4.3369-0.31405-2.8103-1.4445-1.8343-3.8862 0.50427-4.7324 2.0509-0.79942 5.0937 0.34314 6.2002 2.6376 2.2229 7.3422-3.4376 11.68-10.384 12.561z" style="fill:#333;"/><path d="m112.81 148.38c1.5064 0.59192 2.595 2.0264 2.6191 3.9863 0.0574 1.3977-0.53421 3.5611-3.6758 5.7949-8.0544 4.9446-21.507 3.6862-21.255-7.1658 4.664 4.8219 10.021 5.6377 14.773 0.73907 1.2328-1.1599 2.3694-2.4032 3.9294-3.1408 1.0946-0.50424 2.2257-0.61071 3.6096-0.21337z" style="fill:#333;"/><path d="m97.252 154.93c-3.0731-0.48816-5.5702-2.8457-5.4438-4.5059 0.47801-4.8311 5.7317-3.0917 4.3369-0.31405 2.8103-1.4445 1.8343-3.8862-0.50427-4.7324-2.0509-0.79942-5.0937 0.34314-6.2002 2.6376-2.2229 7.3422 3.4376 11.68 10.384 12.561z" style="fill:#333;"/>', i["04"].eyes = '<path d="m131.64 114.09 7.5801-7.5801 7.5801 7.5801m-62.6 0 7.5801-7.5801 7.5799 7.5801" style="fill:none;' + c + '6.4998px;stroke:#000;"/>', i["04"].top = '<path d="m137.38 11.148c-12.23 1.9593-18.511 14.606-43.436 9.4915-11.285-3.2054-16.406-3.573-20.389 0.58594-4.1548 4.3384-7.033 12.435-9.8184 21.706-2.1354 7.4136-3.7187 14.381-4.7461 21.646h112.7c-3.4878-24.293-10.822-43.281-25.182-51.061-3.5314-1.623-6.5274-2.2959-9.1289-2.3613z" style="fill:#b3b3b3;"/><path d="m114.37 43.383c-19.445 0.088-38.524 2.0724-52.379 5.6992-1.2766 4.5795-2.4317 10.169-3.2285 16.807h113.11c-0.83731-6.0107-1.9164-11.674-3.3184-16.924-15.229-3.8842-34.873-5.6693-54.18-5.582z" style="fill:#e6e6e6;"/><path d="m115.5 55.773c-58.39 0-105.73 15.476-105.73 34.57h0.0312c0 11.295 16.496 21.319 42.126 27.627-0.10331-7.7704 2.788-21.904 5.2734-31.031 6.0935-1.7168 6.9294-1.8971 13.167-2.9919 14.874-2.8256 29.99-4.2037 45.133-4.1153 15.143-0.0884 30.259 1.2897 45.133 4.1153 6.2372 1.0947 7.2065 1.2751 13.3 2.9919 2.4854 9.1267 5.3768 23.26 5.2734 31.031 25.63-6.3082 41.993-16.332 41.993-27.627h0.0312c0-19.093-47.34-34.57-105.73-34.57z" style="fill:#818181;"/><path d="m72.088 83.533c-6.9765 1.1147-13.357 2.856-18.439 4.3477-1.1861 7.415-2.0038 18.858-1.8926 26.293 4.3278-0.62795 10.155-1.3644 13.295-1.6465-0.40554 0.30198 2.7344-17.827 7.0371-28.994zm86.824 0c4.3028 11.167 7.4426 29.296 7.0371 28.994 3.1396 0.28213 8.9671 1.0185 13.295 1.6465 0.11119-7.4351-0.70652-18.878-1.8926-26.293-5.0822-1.4916-11.463-3.2329-18.439-4.3477z" style="fill:#434343;"/>', i["05"] = [], i["05"].env = a, i["05"].clo = '<path d="m141.75 194.98a114.79 114.78 0 0 1 38 16.498 115.53 115.52 0 0 1-128.46 0 114.79 114.78 0 0 1 38-16.498l15.71 15.748h21z" style="fill:#d2d2d2;"/><path d="m70 200.88v20.77c-2.22-0.95325-4.3999-1.9698-6.5399-3.0496h-0.10088v-14.621c2.17-1.1 4.39-2.1399 6.64-3.0996z" style="fill:#505050;"/><path d="m161 200.88v20.77c1.9-0.80986 3.7702-1.6798 5.6201-2.5898l0.0989-0.0494 0.82005-0.40997h0.10088v-14.621c-2.17-1.1-4.39-2.1399-6.6402-3.0996z" style="fill:#505050;"/><polygon transform="matrix(1 0 0 .99987 4e-5 -3e-5)" points="97.32 201.93 115.5 223.72 133.68 201.93" style="fill:#171717;"/><path d="m111.2 230.88 1.31-16.908c0.32992 1.2798 5.6399 1.2798 5.9999 0l1.3201 16.938c-1.4301 0.0494-2.8601 0.089-4.3 0.089s-2.87 0-4.3-0.089z" style="fill:#171717;"/><path d="m115.49 201.79v0.0692l-7.55 12.678-7.0001 11.809-19.19-26.487c0.60999-0.42995 1.22-0.89985 1.8001-1.3899a52 51.993 0 0 0 10.07-10.619l21.79 13.878z" style="fill:#ebebeb;"/><path d="m149.24 199.86-19.08 26.517-7.0001-11.809-7.57-12.678-0.0593-0.10086 21.94-13.998a52.21 52.203 0 0 0 10.08 10.699c0.58013 0.47009 1.1502 0.92002 1.7301 1.3399z" style="fill:#ebebeb;"/>', i["05"].head = l, i["05"].mouth = '<path d="m122.83 151.88a10.49 10.489 0 0 1-14.66 0" style="fill:none;' + c + '6.1996px;stroke:#333;"/>', i["05"].eyes = '<path d="m70.959 94.985h35.031c2.4086 1e-5 4.3612 1.9523 4.3612 4.3606l-2.5864 17.511c-0.3515 2.3799-1.7218 4.3606-3.8457 4.3606h-30.9c-2.1239-1e-5 -3.8457-1.9523-3.8457-4.3606l-2.5864-17.511c1e-5 -2.4082 1.9526-4.3606 4.3612-4.3606z" style="fill:#1a1a1a;' + c + '3.0045px;stroke:#333;"/><path d="m160.05 94.985h-35.031c-2.4086 1e-5 -4.3612 1.9523-4.3612 4.3606l2.5864 17.511c0.35149 2.3799 1.7218 4.3606 3.8457 4.3606h30.9c2.1239-1e-5 3.8457-1.9523 3.8457-4.3606l2.5864-17.511c-1e-5 -2.4082-1.9526-4.3606-4.3612-4.3606z" style="fill:#1a1a1a;' + c + '3.0045px;stroke:#333;"/><path d="m90.607 102.35a4.6337 4.6332 0 1 0 4.6892 4.6337 4.6337 4.6332 0 0 0-4.6892-4.6337zm49.72 0a4.6337 4.6332 0 1 0 4.6444 4.6337 4.6337 4.6332 0 0 0-4.6444-4.6337z" style="fill:#1a1a1a;"/><path d="m70.66 94.985h-11.775" style="fill:none;' + c + '3.0045px;stroke:#333;"/><path d="m172.13 94.985h-19.484" style="fill:none;' + c + '3.0045px;stroke:#333;"/><path d="m109.32 106.2c4.2045-2.427 9.3036-1.913 12.353-0.0258" style="fill:none;' + c + '3.0045px;stroke:#333;"/><path d="m148.33 109.79-5.7626-8.2324" style="fill:none;' + c + '4;stroke:#fff;"/><path d="m156.27 105-2.403-3.4328" style="fill:none;' + c + '4;stroke:#fff;"/><path d="m82.748 114.34-8.9489-12.784" style="fill:none;' + c + '4;stroke:#fff;"/><path d="m91.408 109.79-5.7626-8.2324" style="fill:none;' + c + '4;stroke:#fff;"/>', i["05"].top = '<path d="m41.835 75.131c-2.8674 12.582 1.2304 27.241 6.0238 39.031 0.25861 0.63658 0.51208 1.3075 0.79989 1.9683 0.71726 1.658 2.1184 3.9751 3.0038 3.9266 0.56895-0.0312 0.71637-1.5512 1.0228-3.1562 2.1988-19.097 8.8981-27.915 15.636-38.107 2.8783-4.0645 3.8616-7.2293 1.0644-9.9325-6.3236-3.5596-14.924-2.8574-21.367-0.67406-3.2312 1.4765-5.2427 3.4773-6.1842 6.9439zm125.65-8.5679c7.65-0.70616 19.714-0.1307 21.694 8.5679 1.455 6.4083 0.26915 17.747-1.0542 24.579-1.1961 5.3203-3.8066 14.231-7.8782 19.75-0.5565 0.44544-0.96888 0.13656-1.4159-1.1606-0.90692-3.0353-1.4298-7.8372-2.2556-10.727-3.4822-12.79-8.2195-21.875-14.429-29.94-5.5782-6.8415-4.2152-9.7207 5.3393-11.069z" style="fill:#4d4d4d;"/><path d="m112.27 73.826c-18.585-7.5217-34.987-14.797-48.939 5.018-4.9752 7.083-3.7876 8.8056-4.9217 0.0749-1.637-12.476-4.7505-34.174 1.9259-45.194 7.6822-12.7 19.323-13.128 31.039-5.3818 10.796 7.7784 24.277 14.647 38.015 12.219 12.732-2.2576 15.835-7.7464 15.707-19.912-0.0215-2.6-0.0963-5.2106-0.2033-7.7999 13.631 3.9267 24.609 14.776 26.513 29.049 0.88804 6.6336 0.26749 12.722-1.9259 19.013-5.9702 17.108-30.119 20.896-45.74 16.841-3.9588-1.0378-7.6822-2.4181-11.47-3.9267z" style="fill:#4d4d4d;"/>', i["06"] = [], i["06"].env = a, i["06"].clo = '<path d="m115.5 231a115 115 0 0 0 64.23-19.5 114.79 114.79 0 0 0-38-16.5l-2.41-9a125.19 125.19 0 0 0-13.32-2.28v8.75q3.52 0.32 7 0.84l-17.5 17.48-17.5-17.48q3.45-0.52 7-0.84v-8.75a125.55 125.55 0 0 0-13.34 2.28l-2.41 9a114.79 114.79 0 0 0-38 16.5 114.94 114.94 0 0 0 64.25 19.5z" style="fill:#646464;"/><path d="m132.98 193.33-36.185 36.155-2.4-0.42 36.108-36.081z" style="fill:#e3e3e3;"/>', i["06"].head = l, i["06"].mouth = '<path d="m127.84 146.73c-2.24 8.93-6.92 15.08-12.34 15.08s-10.1-6.15-12.34-15.08z" style="fill:#fff;' + c + '2.9999px;stroke:#1a1a1a;"/>', i["06"].eyes = '<path d="m129.31 114.14 20-5.37m-47.66 5.37-20-5.37" style="fill:none;' + c + '4.9998px;stroke:#1a1a1a;"/>', i["06"].top = '<path d="m169.65 90.998c3.137 11.94 4.9371 36.484-3.4118 58.213l5.129 3.1164c10.044-15.199 14.959-39.163 13.943-61.33z" style="fill:#1a1a1a;"/><path d="m45.081 90.989c-0.88085 4.9304-0.87534 14.953-0.15027 21.75 2.1318 19.98 16.671 42.505 16.671 42.505l5.7352-4.4331s-13.244-31.348-6.0571-52.751c0.52108-1.5517 0.95592-2.916 1.3462-4.1835z" style="fill:#1a1a1a;"/><path d="m117 3.4883c-8.2136-0.19887-19.13 7.933-18.494 9.3516 1.6214 3.6186 11.176 22.55 11.889 23.963h10.148c2.6022-6.3102 11.32-26.531 11.32-26.531s-4.1382-4.138-12.416-6.4375c-0.77605-0.21556-1.5976-0.32513-2.4473-0.3457z" style="fill:#1a1a1a;"/><path d="m115.95 4.5428c-3.1563 0-6.3123 0.57462-9.2165 1.715-5.8084 2.2817-10.532 6.808-12.779 12.245v-5e-3c-1.8166 4.397-2.0233 9.3441-0.58058 13.857 0.69352 2.1687 1.7693 4.2296 3.1533 6.0968h38.893c0.71032-0.95769 1.3441-1.9641 1.8787-3.0144 2.6811-5.2673 2.9296-11.542 0.67253-16.975-2.257-5.4337-6.9893-9.9522-12.802-12.224-2.9064-1.1335-6.0633-1.6987-9.2196-1.6956z" style="fill:#1a1a1a;"/><path d="m92.512 28.125c0.13387 1.4318 0.41877 2.8511 0.85962 4.2306 1.4429 4.5127 4.5278 8.5654 8.6411 11.353 4.1135 2.7873 9.2311 4.2913 14.336 4.2165 5.1052-0.0764 10.168-1.7333 14.181-4.6419 2.8754-2.0834 5.2132-4.7932 6.7665-7.8447 1.2005-2.3586 1.9085-4.9188 2.127-7.5156-15.037-2.6407-31.421-3.4671-46.912 0.20253z" style="fill:#b3b3b3;"/><path d="m34.426 90.63c14.714 4.0779 22.683 6.4085 45.254 7.4257 2.5318-18.185 4.6689-28.672 10.023-38.352 3.2025 13.403 3.8346 25.22 2.9106 42.253l11.172-0.23161c1.4706-11.886 3.8989-29.213 2.1636-42.021 10.416 12.631 11.373 23.624 13.077 39.726 30.174-0.76004 59.808-4.5121 77.845-10.128-10.76-38.608-41.475-55.66-80.38-56.104-38.182-0.45134-74.543 22.405-82.065 57.432z" style="fill:#1a1a1a;"/>', i["07"] = [], i["07"].env = a, i["07"].clo = '<path d="m88.18 194.11c-4.2079 1.021-8.3545 2.2792-12.42 3.7695v26.072a115.5 115.5 0 0 0 79.48 0v-26.072c-4.0858-1.4904-8.2529-2.7486-12.48-3.7695v8.7051c0 9.3888-7.6112 17-17 17h-20.58c-9.3888 0-17-7.6112-17-17v-8.7051z" style="fill:#efefef;"/>', i["07"].head = l, i["07"].mouth = '<polygon points="121.61 160.74 109.39 160.74 115.5 171.31" style="fill:#797979;"/><path d="m132.64 144.06a34.42 34.42 0 0 1-34.24 0" style="fill:none;' + c + '5.9998px;stroke:#000;"/>', i["07"].eyes = '<path d="m170.25 100c1.69 9.62-4.79 29.23-22.4 29.23-6.81 0-15-3.66-20.23-10-4.34-5.33-7.56-12.87-6.2-19.45 1.63-7.89 7.07-11.45 14.67-12.92a68.16 68.16 0 0 1 12.52-1c10.77 0 19.78 3.61 21.64 14.22z" style="fill:#565656;stroke-width:3.99px;stroke:#000;"/><path d="m60.75 100c-1.69 9.62 4.79 29.23 22.4 29.23 6.81 0 15-3.66 20.23-10 4.34-5.33 7.56-12.87 6.2-19.45-1.63-7.89-7.07-11.45-14.67-12.92a68.16 68.16 0 0 0-12.52-1c-10.77 0-19.78 3.61-21.64 14.22z" style="fill:#565656;stroke-width:3.99px;stroke:#000;"/><line x1="100.2" x2="130.8" y1="87.92" y2="87.92" style="fill:none;' + c + '3.99px;stroke:#000;"/><path d="m109.87 101.73c0-2.59 2.52-4.69 5.63-4.69s5.63 2.1 5.63 4.69" style="fill:none;stroke-width:3.99px;stroke:#000;"/>', i["07"].top = '<path d="m30.622 70.381c2.0971-3.9374 4.6649-7.9604 7.6822-12.037 3.0172-4.0765 6.0987-7.6929 9.2229-10.817l22.897 22.897c-4.4402 4.4403-8.2278 9.5439-11.213 15.14z" style="fill:#999;"/><path d="m160.58 70.423 22.907-22.897c3.1242 3.1242 6.2056 6.7406 9.2229 10.817 3.0065 4.0765 5.5744 8.0994 7.6715 12.037l-28.578 15.182c-2.9851-5.5958-6.7727-10.689-11.224-15.14z" style="fill:#999;"/><path d="m92.411 15.247c3.8197-0.87736 7.6715-1.5407 11.534-1.9794 4.0765-0.46007 7.9282-0.69546 11.555-0.69546 1.53 0 3.1563 0.0428 4.8682 0.1391l1.851 22.255 5.767-21.57c3.1028 0.37449 6.0666 0.86666 8.8912 1.4658l-10.55 49.763c-1.9259-0.41729-3.702-0.70617-5.3176-0.87736-1.423-0.14979-3.2633-0.22468-5.5102-0.22468-2.2362 0-4.237 0.10699-5.981 0.29958-1.9473 0.22469-3.8732 0.55636-5.767 0.99504z" style="fill:#999;"/><path d="m92.411 15.247c1.9152-0.43869 4.023-0.84526 6.3233-1.2304 2.065-0.34238 4.1514-0.62057 6.2698-0.84525l5.1785 50.565c-1.0913 0.10699-2.1827 0.25679-3.2954 0.43868-0.86665 0.14979-1.9152 0.36378-3.1349 0.64196z" style="fill:#4d4d4d;"/>', i["08"] = [], i["08"].env = a, i["08"].clo = '<path d="m141.89 195a114.79 114.79 0 0 1 38 16.5 115.55 115.55 0 0 1-128.47 0 114.79 114.79 0 0 1 38-16.5l15.75 15.75h21z" style="fill:#353535;"/><path d="m146.4 196.14-17.4 17.44-1.17 1.17h-24.34l-1.18-1.17-17.43-17.44c1.49-0.41 3-0.79 4.51-1.14l4.67-1 12.74 12.74h17.69l12.73-12.74 4.67 1c1.52 0.35 3 0.73 4.51 1.14z" style="fill:#919191;"/>', i["08"].head = l, i["08"].mouth = '<path d="m115.68 160.64c7.08 0 13.11-4.93 15.46-11.84a2.14 2.14 0 0 0-1.51-2.6101 2.3 2.3 0 0 0-0.73995-0.0593h-26.42a2.12 2.12 0 0 0-2.31 1.9099 1.85 1.85 0 0 0 0.0593 0.73995c2.3401 6.9301 8.3802 11.86 15.46 11.86z" style="fill:#2f2f2f;"/>', i["08"].eyes = '<path d="m145.38 95.628c-5.1601 2.2597-11.03 2.2597-16.19 0m-47.29 1.75c5.1755-2.2694 11.065-2.2694 16.24 0" style="fill:none;' + c + '5.9998px;stroke:#5e5e5e;"/><path d="m90.016 106.28c-4.4506-0.0105-6.6902 5.3657-3.5508 8.5195 3.1394 3.1539 8.5252 0.93887 8.5352-3.5117 0.0063-2.7522-2.2204-4.9898-4.9727-4.9961l-0.011719-0.01172zm47.281 0c-4.4506-0.0105-6.6902 5.3657-3.5508 8.5195 3.1394 3.1539 8.5252 0.93887 8.5352-3.5117 6e-3 -2.7522-2.2204-4.9898-4.9727-4.9961l-0.01171-0.01172z" style="fill:#1a1a1a;"/>', i["08"].top = '<path d="m108.37 22.019c-6.2698-12.829-17.151-13.396-18.949 1.1769-11.448-9.4583-26.021-4.483-20.361 12.422-12.251-7.9282-24.919 1.7761-17.076 20.853-27.08 2.3646-22.715 24.726-10.111 31.435-9.9002 3.3566-10.701 9.4006-8.464 14.497 2.6574 4.7842 9.0126 6.4737 11.545 9.6519-6.624 0.59419-8.4112 5.6011-5.7404 9.5192 1.6896 2.4787 5.2756 4.2218 8.5971 5.5455 1.0485 0.40658 3.702 1.2732 3.9053 2.4181 0.18744 1.2156-6.7884 3.0055-5.7281 5.2612 0.60648 1.4227 1.7764 2.7151 2.6466 3.7156 1.2807 1.6595 10.755 8.0351 9.4583 4.2049-1.0271-3.7234-2.2148-7.4682-3.1456-11.192-1.1662-5.3069-1.7868-10.721-1.102-16.156 1.4223-5.455 5.069-4.4265 7.7837-8.3588 3.5264-5.7505 2.0296-11.614 2.124-13.575 0.107-1.7868 1.5407-1.1876 3.1884-1.4337 4.3868-0.64196 7.0081-2.1185 8.8377-6.2698 0.77035-1.9259 0.62057-9.7578 0.52426-11.78 0.36378-4.6328 4.1835 0 6.548 0.64196 3.2633 0.88805 6.8797 0.21399 9.0731-2.5037 1.7547-2.3753 2.0864-2.8888 4.6114-0.80245 2.6856 2.2148 4.0979 3.1349 7.6929 3.274 5.5637 0.20329 8.7735-6.2698 11.32-5.6386 3.5201 0.87735 3.6057 5.4567 10.261 4.8682 2.386-0.20329 3.8304-0.86665 5.4032-2.6428 0.88805-0.99505 1.958-2.5037 3.4345-2.6214 1.4658-0.1177 2.3218 2.3646 3.0065 3.4452 1.1926 2.6755 4.0295 3.6513 6.2377 3.3168 1.958-0.17119 3.854-1.4115 5.4268-2.4707 0.99679-0.66102 1.8284-0.81128 1.9256 0.2071 0.29592 2.2271 0.0862 7.7025 0.1596 8.4821 0.10556 8.4609 5.37 10.569 13.223 10.333-0.31871 3.7464 0.0583 11.28 5.4353 14.562 3.9481 2.7604 6.6657 1.2732 6.7299 7.8534 7e-3 6.1914-0.43693 13.061-1.2946 18.189-0.69547 4.0444-1.2412 6.4838-2.5251 10.378-0.64196 1.9152-0.81315 1.9687 1.4123 1.0699 7.1472-3.1456 10.539-11.48 8.3562-18.842-0.43869-2.0436 0.84525-1.7226 2.8781-2.6106 9.5248-4.2363 8.1264-11.335-0.75967-14.273 11.988-3.0926 13.886-8.9002 6.6871-15.375 7.3077-5.9168 3.6378-16.177-2.8032-16.991 12.422-7.0937 5.7349-22.062-5.1036-18.499 4.1728-12.037-5.5637-26.203-21.121-16.894 6.9653-11.373 2.065-22.661-12.101-10.785-3.4559-18.382-15.14-16.584-23.902-5.018 0.09435-20.075-16.001-17.42-18.146-2.5892z" style="fill:#1a1a1a;"/><path d="m5.4353 80.502c7.4468 9.1373 15.632 8.8912 15.632 8.8912s-6.0772 3.7983-6.8369 9.8755c-0.75966 6.088 4.5579 9.6295 8.0994 10.646 3.5522 1.0058 7.0937-2.7925 7.0937-2.7925s-5.8312 10.646-1.5193 15.964c4.3012 5.3176 11.908 3.0386 11.908 3.0386s-5.3283 10.132 1.0057 14.187c5.8312 3.7234 18.542 7.6715 20.511 8.2706-6.0666-9.7472-9.576-21.249-9.576-33.575v-0.0428c0-35.201 28.546-63.747 63.747-63.747 35.212 0 63.758 28.546 63.758 63.747 0 12.476-3.5843 24.116-9.7899 33.949h0.53496s13.931-1.0057 16.21-9.3727c2.279-8.3562 0.75967-9.8756 0.75967-9.8756s10.635 2.0329 13.417-7.5966l2.7926-9.6295s10.132 0 10.892-7.083c0.75963-7.0937-7.0295-12.411-7.0295-12.411s11.459 0.82385 14.498-10.453c1.0164-3.7555 0.83456-8.2171 0.1391-12.497-17.665-41.161-58.569-69.995-106.18-69.995-30.632 0-60.034 12.187-81.679 33.831v0.0107c-13.171 13.171-22.833 29.22-28.386 46.66z" style="fill:#1a1a1a;"/>', i["09"] = [], i["09"].env = a, i["09"].clo = '<path d="m141.75 195a114.79 114.79 0 0 1 38 16.5 115.53 115.53 0 0 1-128.46 0 114.79 114.79 0 0 1 38-16.5l13.85 13.85v-1.2h17.86v3.1h5z" style="fill:#333;"/><polygon points="115.36 207.65 123.37 224.2 148.3 196.86 143.08 189.95" style="fill:#fff;"/><polygon points="115.36 207.65 107.35 224.2 82.42 196.86 87.63 189.95" style="fill:#fff;"/>', i["09"].head = l, i["09"].mouth = '<path d="m126.28 149.82c-6.16 2.43-15.52 2.42-21.56 0" style="fill:none;' + c + '5.9998px;stroke:#1c1c1c;"/>', i["09"].eyes = '<path d="m83.527 103.98v10h10v-10h-10zm53.945 0v10h10v-10h-10z" style="fill:#1a1a1a;"/><path d="m56.621 94.906v11.688h5.3418v6.4922h5.3418v6.1055h5.3223v6.2324h26.846v-6.2324h5.3047v-6.1055h5.1445v-6.0039h11.154v6.0039h5.1446v6.1055h5.3066v6.2324h26.846v-6.2324h5.3203v-6.1055h5.3438v-6.4922h5.3418v-11.688z" style="fill:#1a1a1a;"/><path d="m67.387 100.65v5.9394h5.1992v-5.9394zm5.1992 5.9394v6.4922h5.4238v-6.4922zm5.4238 0h5.1992v-5.9394h-5.1992zm5.1992 0v6.4922h5.4258v-6.4922zm5.4258 6.4922v6.1055h5.1426v-6.1055zm-10.625 0v6.1055h5.1445v-6.1055zm48.281-12.432v5.9394h5.1992v-5.9394zm5.1992 5.9394v6.4922h5.4238v-6.4922zm5.4238 0h5.1992v-5.9394h-5.1992zm5.1992 0v6.4922h5.4258v-6.4922zm5.4258 6.4922v6.1055h5.1426v-6.1055zm-10.625 0v6.1055h5.1445v-6.1055z" style="fill:#fff;"/>', i["09"].top = '<path d="m157.79 67.5a61.31 61.31 0 0 1-42.79 17.43h-55.7c18.16-37.74 68.27-46.85 98.49-17.43z" style="fill:#4d4d4d;"/><path d="m122.93 7.0078c-10.503-0.15729-21.09 1.6448-29.545 5.4316-17.141 7.8999-32.169 23.297-43.973 38.779-5.1703 6.8631-8.7779 13.46-8.1855 18.395 0.93114 12.312 10.372 26.483 11.068 36.9 15.663-72.081 105.99-70.452 124.91-7.0525l4e-3 0.0156c5.616-10.926 8.0682-20.188 8.352-27.653 0.43654-15.607-7.8088-21.149-21.735-28.249 1.7934-3.7704 1.7273-7.5023 2.0625-10.154-0.79964-7.8568-3.6796-13.51-10.43-17.758-5.9434-3.7404-13.06-6.0867-18.463-7.2266-4.5319-0.87895-9.2901-1.3562-14.064-1.4277z" style="fill:#4d4d4d;"/><path d="m42.426 75.338c0.52158 18.689 10.557 74.338-18.115 101.25 12.38 10.603 28.352 19.061 46.025 24.594 11.032-4.6874 22.88-7.4147 34.817-8.5046l0.0633-14.477c-22.49-4.3813-40.766-18.898-48.862-39.967-8.096-21.07-4.7931-44.72 9.2478-62.393zm124.67 2.7207c7.8997 10.886 11.743 24.64 11.787 37.441-0.36632 30.178-22.389 57.576-53.12 62.708l0.0238 14.471c12.282 1.1216 24.518 3.9888 35.825 8.9128 15.488-5.1448 30.007-13.325 42.396-25.043-13.136-22.051-23.282-63.045-18.694-101.55z" style="fill:#4d4d4d;"/><path d="m143.61 46.383c-11.639 0.12482-20.998 1.8906-20.998 1.8906l-9 3.5059c0.63003-0.0191 1.2603-0.0289 1.8906-0.0293h0.0996c35.169 0.055 60.959 27.235 63.283 63.383 7.4e-4 31.157-22.742 57.213-53.106 63.079l-0.0216 14.498c11.567 1.0563 23.154 3.6067 33.887 8.0463 35.952-15.315 55.082-52.303 36.709-68.279-5.018-7.9035-10.44-15.409-9.5544-23.03 5.0545-50.452 0.39626-63.561-43.189-63.064zm-69.966 21.09c-15.286 3.244-17.096 3.73-31.734 6.6953 3.0304 13.081 3.0583 22.274 1.2085 30.012-3.8004 11.361-8.9712 19.787-12.286 28.764-6.8823 22.459-2.9157 31.982 12.093 46.165 8.6595 8.0693 19.861 16.209 30.939 20.647 2.669-1.0316 5.3729-1.9628 8.106-2.792 7.4979-2.275 15.388-3.6535 23.206-4.3673l0.0433-14.393c-23.933-4.5937-44.283-21.98-50.77-45.817-6.3319-23.265 0.51104-48.752 19.195-64.914z" style="fill:#4d4d4d;"/>', i[10] = [], i[10].env = a, i[10].clo = '<path d="m141.75 195a114.79 114.79 0 0 1 38 16.5 115.53 115.53 0 0 1-128.46 0 114.79 114.79 0 0 1 38-16.5l15.71 15.75h21z" style="fill:#666;"/><path d="m89.291 195a114.79 114.79 0 0 0-38.002 16.5 115.53 115.53 0 0 0 38.002 16.482zm52.434 0v32.982a115.53 115.53 0 0 0 38-16.482 114.79 114.79 0 0 0-38-16.5z" style="fill:#999;"/><path d="m157.15 199.75c0.2548 7.4501 1.54 14.855 4.9512 21.432a115.53 115.53 0 0 0 17.619-9.6797 114.79 114.79 0 0 0-22.57-11.752zm-83.295 2e-3a114.79 114.79 0 0 0-22.57 11.75 115.53 115.53 0 0 0 17.621 9.6797c3.411-6.5765 4.6944-13.98 4.9492-21.43z" style="fill:#ccc;"/><path d="m99.197 204.97v2e-3l16.302 16.301 16.301-16.301v-2e-3z" style="fill:#fff;"/>', i[10].head = l, i[10].mouth = '<path d="m100.19 152.09c2.8726 4.0616 9.8095 4.7232 15.119-0.45432 5.0656 4.5134 11.167 5.6898 15.495 0.31458" style="fill:none;' + c + '5.8949;stroke:#333;"/><path d="m109.67 135.53c-0.9758 0.0743-2.05 0.45327-3.1485 0.99414-4.3235 2.1399-7.3862 4.2557-10.639 7.1406-0.6251 0.5715 0.1168 0.77785 1.4238 0.87304 5.6967 0.0536 14.384 0.41404 15.098-0.875 1.9251-2.0788 1.7969-5.3303-0.1816-7.3008-0.701-0.67533-1.5769-0.90632-2.5527-0.83203zm11.656 0c-0.9758-0.0743-1.8517 0.1567-2.5527 0.83203-1.9785 1.9705-2.1067 5.222-0.1817 7.3008 0.7142 1.289 9.401 0.9286 15.098 0.875 1.307-0.0952 2.0489-0.30154 1.4238-0.87304-3.2524-2.8849-6.3151-5.0007-10.639-7.1406-1.0985-0.54087-2.1727-0.91985-3.1485-0.99414z" style="fill:#333;"/>', i[10].eyes = '<path d="m97.56 107.84a10.63 10.63 0 0 1-15 0.13l-0.13-0.13" style="fill:none;' + c + '6.3px;stroke:#000;"/><path d="m148.59 107.84a10.63 10.63 0 0 1-15 0.13l-0.13-0.13" style="fill:none;' + c + '6.3px;stroke:#000;"/>', i[10].top = '<path d="m41.668 87.073c-9.2319-0.0231-11.63 6.5104 2.2676 17.66-14.015 1.1231-4.3662 16.457 4.875 24.66 4.0686 3.0199 6.4647 5.4657 5.5078 1.1348-1.2079-4.9178-1.8184-9.9634-1.8184-15.027 3.26e-4 -7.5692 1.2547-15.016 3.7883-22.183 0.57048-1.7876 1.0689-2.0306-0.37721-2.6839-5.5405-2.4478-10.375-3.5511-14.243-3.5608z" style="fill:#ccc;"/><path d="m185.48 89.513c-2.4418-0.11189-5.4618 0.81187-9.5148 3.2121-1.314 0.81729-0.70075 1.995-0.32301 3.2653 3.194 10.982 3.8215 22.462 1.2538 33.628-0.31613 1.688-0.47649 3.569 2.6953 1.3516 7.7016-5.371 19.17-18.734 16.918-26.105-1.4251-3.9177-11.4-0.35546-11.4-0.35546s4.987-4.2755 5.3437-9.6191c0.20048-3.0057-1.5237-5.2189-4.9726-5.377z" style="fill:#ccc;"/><path d="m91.689 36.108c-3.7298-7.3864-9.5859-10.504-17.578-6.7891-9.5194 4.5907-15.629 18.444-13.416 29.232 0 0-8.5511-4.9878-18.17-3.5625-19.623 8.094-1.4102 29.869 10.817 37.342 2.075 1.297 2.5792 1.7432 3.4291-0.37685 2.6746-6.5374 6.1886-12.722 11.297-17.709 4.1039 8.7427 14.629 4.1809 20.006-0.14062 4.4873 9.6838 10.377 6.3535 15.377 3.4785 4.0764 7.8829 10.756 7.25 17.631 0.0625 4.875 4.5625 14.713 4.1867 15.555-3.426 8.4753 2.6244 14.012 10.437 22.962-1.4764 8.8552 6.8221 14.407 16.853 17.122 27.51 0.34 1.554 1.175 0.85565 2.2212 0.44315 10.255-4.286 22.842-15.749 15.705-23.975-3.5623-3.5623-13.539-2.1387-13.539-2.1387s6.77-7.1233 9.2637-18.168c2.4936-11.043-23.514-4.9883-23.514-4.9883s7.4818-5.6993 12.113-13.537c4.6314-7.8378-2.4943-11.756-11.045-11.043-8.5496 0.71204-17.1 7.4805-17.1 7.4805s3.3946-7.8055-3.5625-12.826c-9.5935-6.9234-23.869 6.4121-23.869 6.4121-4.2562-26.835-24.872-6.386-31.707 8.1953z" style="fill:#ccc;"/>', i[11] = [], i[11].env = a, i[11].clo = '<path d="m116 203.13c-0.12 0-0.25 0.12-0.49 0.12s-0.25-0.12-0.49-0.12zm-27.29-8c0.87-0.25 1.72-0.47 2.56-0.69a32.37 32.37 0 0 0 0.3 8.57 21.5 21.5 0 0 0 7 6.88c6.41-6 16.8-6.64 16.8-6.64s10.5 0.58 17 6.69a21.61 21.61 0 0 0 6.93-6.66 32.34 32.34 0 0 0 0.35-8.84l2.13 0.56a114.79 114.79 0 0 1 38 16.5 115.53 115.53 0 0 1-128.46 0 114.64 114.64 0 0 1 37.38-16.37z" style="fill:#e9e9e9;"/><path d="m126.15 206-3.92 7.83h-13.46l-3.92-7.83a36.59 36.59 0 0 1 10.65-2.7 35.66 35.66 0 0 1 10.65 2.7z" style="fill:#818181;"/><path d="m124.54 230.65-2.18-16.74h-13.47l-2.19 16.76c2.9 0.22 5.84 0.33 8.8 0.33s6.06-0.12 9-0.35z" style="fill:#989898;"/><path d="m134.84 186s0.86 9.8-19.34 17.26c0 0 15.79 0.86 20.57 11.76 0.12 0.49 9.3-23.26-1.23-29z" style="fill:#fff;"/><path d="m96.16 186c-10.41 5.76-1.35 29.39-1.1 29 4.65-10.78 20.56-11.76 20.56-11.76-20.32-7.45-19.46-17.24-19.46-17.24z" style="fill:#fff;"/>', i[11].head = l, i[11].mouth = '<path d="m118.57 165.14a8.66 8.66 0 0 0-2.76-4.23h-0.62a8 8 0 0 0-2.76 4.22c-0.52 1.89 2.07 10.61 2.76 12.53h0.62c0.64-1.76 3.19-10.82 2.76-12.52z" style="fill:#333;"/><path d="m102.81 152.24a2.4921 2.4921 0 1 1 1.19-4.84l0.21 0.06a37.1 37.1 0 0 0 5.43 1.12 44.52 44.52 0 0 0 11.76 0 37.1 37.1 0 0 0 5.43-1.12 2.4903 2.4903 0 0 1 1.59 4.72l-0.21 0.06a43.08 43.08 0 0 1-6.15 1.29 48.55 48.55 0 0 1-13.08 0 42.79 42.79 0 0 1-6.17-1.29z" style="fill:#333;"/>', i[11].eyes = '<path d="m86.851 100.39a4.94 4.94 0 1 0 4.9297 5 5 5 0 0 0-4.9297-5zm57.221 0a4.94 4.94 0 1 0 4.9394 4.9394 4.94 4.94 0 0 0-4.9394-4.9394z" style="fill:#333;"/><path d="m86.207 89.365c-25.504 0-21.503 6.8561-21.035 19.596 0.80177 18.121 17.763 16.514 21.201 16.639 14.758-0.041 20.518-8.227 22.951-22.932 1.8166-10.731-9.251-13.174-23.117-13.303zm58.598 0c-13.866 0.1284-24.936 2.5717-23.119 13.303 2.4332 14.705 8.1936 22.891 22.951 22.932 3.4383-0.125 20.399 1.4828 21.201-16.639 0-18.965-0.47958-19.596-21.033-19.596z" style="fill:#4d4d4d;"/><path d="m169.87 90.255a0.51 0.51 0 0 0-0.43991-0.52 167.64 167.64 0 0 0-22.6-1.6801c-12 0-27.47 3.7601-30.17 3.7601h-2.4c-1.2499 0-5.29-0.80996-10.45-1.6801a124.35 124.35 0 0 0-19.72-2.08 166.18 166.18 0 0 0-19.31 1.24c-1.56 0.17999-2.69 0.35009-3.2899 0.44009a0.51 0.51 0 0 0-0.44007 0.52l-0.091 6.4501a0.57 0.57 0 0 0 0.33012 0.52l0.73994 0.23992c1.08 0.41992 1.0001 19.85 6.78 24.71 3.4401 2.8599 6.51 4.4899 19.42 4.4899 7.4699 0 12.17-1.9999 16.63-8 3.21-4.32 6.0999-14.55 6.0999-14.55 0.82006-4.07 3.7702-4.52 4.43-4.5801h0.12068c0.11078 0 3.66 0.0593 4.57 4.5801 0 0 2.8599 10.22 6.0699 14.54 4.4601 5.9999 9.1601 8 16.63 8 12.91 0 16-1.63 19.42-4.4901 5.7898-4.86 5.6998-24.29 6.78-24.71l0.73994-0.23993a0.57 0.57 0 0 0 0.32996-0.52l-0.12068-6.4501zm-65 23c-1.9101 4.5-6.8 10.29-13.7 10.64-20.7 0.99985-21.65-4.7401-23-9.3201a31.45 31.45 0 0 1-1.2099-13.18c0.53997-4.5799 1.7-7.2699 3.7801-8.6201a9.3 9.3 0 0 1 4.3499-1.51 85.07 85.07 0 0 1 11.4-0.52 59.23 59.23 0 0 1 9.2099 0.69999c7.37 1.2 12.35 3.7001 12.35 6.1601a46.12 46.12 0 0 1-3.23 15.64zm58 1.3201c-1.34 4.5799-2.29 10.36-23 9.3201-6.91-0.3501-11.81-6.1401-13.71-10.64a46.35 46.35 0 0 1-3.22-15.64c0-3.39 9.43-6.8599 21.56-6.8599 12.13 0 14 0.89996 15.75 1.9999 2.08 1.3502 3.2398 4 3.77 8.6201a31.23 31.23 0 0 1-1.1601 13.17z" style="fill:#333;"/>', i[11].top = '<path d="m156.1 15.879c-0.38556 5.3015-1.7049 9.4762-3.6602 12.76-0.41226 23.773-9.2343 35.229-15.154 42.797l15.062-4.6641c-0.66253 2.8135-2.4628 7.156-0.34766 12.137 1.6334-2.3144 7.9395-5.807 13-3.3477-0.43442 3.5532-0.95271 7.094-1.4512 10.639l8.9648 0.85937c0.83453 3.8792 0.51719 9.3449-0.59961 11.736l5.5508 2.0098c0.20764 2.7646 0.10001 5.4906-0.74609 8.875 8.4545-1.7225 14.213-4.3896 19.641-13.188 2.8639-4.7524 4.9018-10.483 4.7305-17.242-4.1612 4.916-9.6484 7.2485-15.26 10.109 6.507-11.065 8.8648-22.768 8.1367-30.58-7.3456 10.251-11.649 13.06-19.918 16.9 1.2386-11.4 5.5249-18.582 12.461-27.27-11.392-1.3025-16.301 1.4749-24.891 6.4395 4.5466-14.036 2.2208-26.679-5.5195-38.971zm-117.76 28.682c9.3378 3.6366 19.581 9.0234 21.129 18.549-7.6182 0.0414-14.897-3.5072-20.242-7.1894-0.15967 8.2309 2.8451 12.252 6.7734 19.08-7.2127 1.6129-12.084 4.8315-17.471 9.4805 7.2948-0.15715 12.299-1.0502 16.891 4.2793-6.0512 5.0164-11.99 10.79-11.99 19.24 9.257-6.1688 12.495-5.9486 21.137-2.2012 1.2906-8.0996 2.3978-14.872 2.7869-16.435 2.4719-0.73247 3.5247-0.94807 5.9221-1.2938-2.1556-7.4281 1.0996-9.5176 2.4141-11.6l7.543 1.5059c-3.9093-6.1699 2.6565-12.483 7.1445-15.51-4.4474-7.2082-5.6649-11.558-7.377-16.797-11.198-8.2947-23.895-6.2742-34.66-1.1094z" style="fill:#f9f9f9;"/><path d="m101.9 7.6408c-10.047 6.2416-12.441 28.646-12.131 33.289-6.9249-5.8258-7.8992-13.75-7.7695-19.203-9.6235 6.0158-10.666 14.421-9 23.943 1.1061 5.1411 2.3972 10.461 7.377 16.797 2e-3 -1e-3 4e-3 -3e-3 6e-3 -4e-3 2.7742 2.8742 5.4644 5.5941 8.3477 8.3574 0.41187-6.971 0.45449-13.622 7.1856-15.824 3.9532 2.8169 7.4123 5.9388 11.084 9.1035l10.559-10.25c5.6447 3.961 5.4531 6.5652 6.5215 14.104 2.153-1.7546 8.719-9.0037 15.844-10.139 0.98706 4.1261-0.99388 10.308-2.6387 13.621 0 0 14.32-11.846 15.195-27.971 0.33968-6.2599 0.2237-11.146-0.041-14.826-3.2125 5.5652-8.7118 8.7799-13.789 10.15-4.2715-9.2486-2.4785-21.435-0.48047-29.309-12.21 3.0195-20.932 18.337-22.172 25.07-9.2678-7.397-13.605-16.146-14.098-26.91z" style="fill:#f9f9f9;"/>', i[12] = [], i[12].env = a, i[12].clo = '<path d="m141.75 195a114.79 114.79 0 0 1 38 16.5 115.53 115.53 0 0 1-128.46 0 114.79 114.79 0 0 1 38-16.5l26.23 13 26.27-13z" style="fill:#131111;"/><polygon points="115.5 208.03 115.5 207.74 82.72 188.91 80.45 198.86 101.46 222.72" style="fill:#cbcbcb;"/><polygon points="115.5 208.03 115.5 207.74 148.28 188.91 150.55 198.86 129.54 222.72" style="fill:#cbcbcb;"/>', i[12].head = l, i[12].mouth = '<path d="m123.07 154.05a10.61 10.61 0 0 1-15 0.14l-0.14-0.14" style="fill:none;' + c + '6.3px;stroke:#000;"/><path d="m120.1 142.22 0.19-0.11c3-1.87 5.45-2.4 7.3-1.46 2.15 1.1 3.12 3.84 4.84 5.5a5.18 5.18 0 0 0 6.68 0.73m-28.21-4.66-0.19-0.11c-3-1.87-5.45-2.4-7.3-1.46-2.15 1.1-3.12 3.84-4.84 5.5a5.18 5.18 0 0 1-6.68 0.73" style="fill:none;' + c + '5.9998px;stroke:#4d4d4d;"/>', i[12].eyes = '<path d="m161.73 86.016h-92.51c-3.37 0-6.0001 2.3998-6.0001 5.2999v28.45c0 3.0002 2.74 5.3001 6.0001 5.3001h32.36c7.0901 0 7.44-19.43 13.82-19.43s6.8801 19.44 13.83 19.44h32.36c3.37 0 5.9999-2.4 5.9999-5.3001v-28.46c0.14043-2.9001-2.6-5.2999-5.9-5.2999z" style="fill:#8f8f8f;"/><path d="m161.73 86.016h-92.51c-3.37 0-6.0001 2.3998-6.0001 5.2999v28.45l104.55-28.45c0-2.9001-2.74-5.2999-5.9999-5.2999z" style="fill:#e3e3e3;"/><path d="m161.73 86.016h-92.51c-3.37 0-6.0001 2.3998-6.0001 5.2999v28.45c0 3.0002 2.74 5.3001 6.0001 5.3001h32.36c7.0901 0 7.44-19.43 13.82-19.43s6.8801 19.44 13.83 19.44h32.36c3.37 0 5.9999-2.4 5.9999-5.3001v-28.46c0.14043-2.9001-2.6-5.2999-5.9-5.2999z" style="fill:none;' + c + '4.0026px;stroke:#232323;"/>', i[12].top = '<path d="m69.834 33.826c-8.2001-0.0626-16.444 2.6753-23.152 7.7038-8.5298 6.9899-12.159 19.61-12.329 32.68-0.2041 15.476 1.6092 34.752 1.7464 51.915 0.10414 13.047 0.53485 25.984-2.9197 33.995-2.4994 5.81-9.0955 9.6006-16.196 12.311 7.9599 2.8301 25.009 2.8094 33.58 1.5393 10.8-1.59 17.238-6.5294 17.159-22.699-0.0911-15.93-1.3894-29.23-1.559-45.83-0.3208-11.983-1.569-24.291 4.9774-33.987 4.2139-6.1265 10.452-10.521 17.116-13.588 3.9292-1.8575 8.0384-3.3083 12.263-4.3297-6.8718-13.574-18.732-19.618-30.687-19.709z" style="fill:#b3b3b3;"/><path d="m90.8 76.246c11.918-17.125 31.996-23.218 49.743-17.488 11.81 3.9496 20.692 13.389 22.313 28.237 0.51051 6.2098 0.63413 12.445 0.37007 18.67-0.23973 11.2-0.72946 23.82-1.0995 34.08-0.82005 22.43 0.0593 35.1 24.589 36.3 8.5635 0.32122 17.137-0.22845 25.59-1.6405h-0.0198c-10.74-3.3799-17.98-15.609-19.3-26.289-1.29-10.41-0.6098-23.43-0.7898-38.091-0.1701-14.96 1.0398-29.819 0.28008-42.089-1.414-22.777-14.947-38.505-34.126-45.152-27.813-7.35-51.083 0.091-61.672 17.343-5.4698 8.9112-7.7413 20.07-5.8788 36.121z" style="fill:#b3b3b3;"/>', i[13] = [], i[13].env = a, i[13].clo = '<path d="M61.11,205.59l3.49,3.69-6.26,6.6A115.45,115.45,0,0,0,72,222.51v-22a115.19,115.19,0,0,0-10.85,5.1Z" style="fill:#eee;"/><path d="M93.24,228.85V199l-4-4A114.43,114.43,0,0,0,72,200.49v22a114.43,114.43,0,0,0,21.28,6.34Z" style="fill:#787878;"/><path d="m159 222.51v-22a114.63 114.63 0 0 0-17.25-5.51l-4 4v29.86a114.16 114.16 0 0 0 21.25-6.35z" style="fill:#787878;"/><path d="m169.89 205.59-3.49 3.69 6.26 6.6a115.45 115.45 0 0 1-13.66 6.63v-22a115.19 115.19 0 0 1 10.85 5.1z" style="fill:#eee;"/><path d="M115.5,219.62A28.5,28.5,0,0,1,87.25,195c2.93-.74,5.92-1.36,8.94-1.87a19.41,19.41,0,0,0,38.62,0c3,.51,6,1.13,8.94,1.87a28.49,28.49,0,0,1-28.25,24.63Z" style="fill:#c9c9c9;"/>', i[13].head = l, i[13].mouth = '<path d="m115.5 153.93a14 14 0 0 1-10.5-4.69 3.4209 3.4209 0 0 1 5-4.67l0.08 0.08 0.08 0.09a7.35 7.35 0 0 0 10.39 0.37l0.37-0.37a3.4206 3.4206 0 1 1 5.23 4.41l-0.08 0.09a14 14 0 0 1-10.53 4.69z" /><path d="m115.27 127.32c-7.6627-0.03-15.251 1.4419-20.646 5.1465-7.62 5.33-9.9053 11.512-14.127 18.109-3.4379 5.2447-9.326 10.024-13.467 6.334 25.425 29.755 71.409 29.786 96.875 0.0664-6.8104 3.9305-11.545-2.47-13.508-6.4004-10.697-17.605-14.115-22.656-35.127-23.256zm-0.26758 8.3984c7.457 0.0802 14.986 1.2966 17.146 5.9522 2.5765 11.319-7.5878 17.454-16.681 17.515-6.09-0.05-12.2-2.3802-15.26-7.7402-6.36-11.16 3.6349-15.607 14.795-15.727z" style="fill:#404040;"/>', i[13].eyes = '<path d="m91.72 97.36v11.4m47.56-11.4v11.4" style="fill:none;' + c + '7.9999px;stroke:#333;"/>', i[13].top = '<path d="m52.107 57.293c-1.3411 14.839-3.8707 52.771 1.3145 72.715-0.67572-43.829 12.389-70.177 62.078-70.187 49.689 0.010061 62.754 26.359 62.078 70.187 5.1852-19.944 2.6556-57.876 1.3145-72.715h-63.393-63.393z" style="fill:#4d4d4d;"/><path d="m52.339 30.629c-1.3825 24.448-2.1216 45.905-1.4497 66.517 9.4643-48.304 112.77-54.916 129.22 0 0.67191-20.612-0.3798-47.256-1.4928-66.517-32.241 14.296-91.346 18.861-126.28 0z" style="fill:#4d4d4d;"/><path d="m115.5 24.92c-22.25 0-44.5 4.2296-56.72 12.69-3.32 2.3-5.0602 6.4392-5.5903 10.269-0.45275 3.23-0.84043 6.7561-1.1785 10.461h126.98c-0.33704-3.7047-0.72492-7.2306-1.1775-10.461-0.53009-3.8301-2.2697-7.9992-5.5897-10.269-12.22-8.4601-34.47-12.69-56.72-12.69z" style="fill:#4d4d4d;"/><path d="m76.521 39.139c21.233 3.3965 33.116-13.392 37.59-31.72 4.3614 17.158 14.175 34.968 36.577 31.584-33.921 20.594-57.646 11.594-74.167 0.1345z" style="fill:#4d4d4d;"/>', i[14] = [], i[14].env = a, i[14].clo = '<path d="m91.92 194.41a101.47 101.47 0 0 1 23.58 17.09 101.47 101.47 0 0 1 23.58-17.09c0.89 0.19 1.78 0.38 2.67 0.59a114.79 114.79 0 0 1 38 16.5 115.53 115.53 0 0 1-128.46 0 114.79 114.79 0 0 1 38-16.5c0.88-0.21 1.78-0.4 2.67-0.59z" style="fill:#757575;"/><path d="m73.65 199.82c16.59 8.23 28.72 18.91 34.27 30.93a114.86 114.86 0 0 1-56.65-19.25 115.06 115.06 0 0 1 22.38-11.68z" style="fill:#d8d8d8;"/><path d="m60.63 205.85c12.35 5.94 21.93 13.44 27.59 21.91a114.7 114.7 0 0 1-36.95-16.26q4.53-3 9.36-5.65z" style="fill:#757575;"/><path d="m157.35 199.82c-16.6 8.23-28.72 18.91-34.27 30.93a114.86 114.86 0 0 0 56.65-19.25 115.06 115.06 0 0 0-22.38-11.68z" style="fill:#d8d8d8;"/><path d="m170.37 205.85c-12.35 5.94-21.93 13.44-27.59 21.91a114.7 114.7 0 0 0 36.95-16.26q-4.53-3-9.36-5.65z" style="fill:#757575;"/>', i[14].head = l, i[14].mouth = '<path d="m115.5 131c-17.71 0.65-27 9.41-29.61 23.69-1 5.62-0.43 7.06 2.76 7.17 22.76 0.76 22.23 18.21 26.85 18.89 4.62-0.68 4.09-18.13 26.85-18.89 3.19-0.11 3.79-1.55 2.76-7.17-2.62-14.28-11.9-23-29.61-23.69zm0 29.31c-10 0-18-5-18-11.17s8.08-11.17 18-11.17 18 5 18 11.17-8.08 11.17-18 11.17z" style="fill:#333;"/><path d="m123.54 148.46a11.53 11.53 0 0 1-16.09 0" style="fill:none;' + c + '6.7998px;stroke:#000;"/>', i[14].eyes = '<path d="m133 108.17h14.17m-63.26 0h14.09m-20.69-8.93a21.31 21.31 0 0 1 27.29 0m21.8 0a21.31 21.31 0 0 1 27.29 0" style="fill:none;' + c + '4.8243px;stroke:#000;"/>', i[14].top = '<path d="m115.5 51.75c-38.702 5.3101-54.215 18.038-59.863 35.101" style="fill:none;' + c + '12;stroke:#333;"/><path d="m115.5 51.75c-7.8393 3.6337-5.5974 16.583-14.341 23.452" style="fill:none;' + c + '12;stroke:#333;"/><path d="m111.35 48.614c-22.634-6.9181-42.457-3.1988-55.733 2.5105" style="fill:none;' + c + '12;stroke:#333;"/><path d="m115.47 54.008c0.1965-6.7774-0.1436-26.309 0.05-38.184" style="fill:none;' + c + '12;stroke:#333;"/><path d="m68.874 28.177c34.115-3.382 41.987 13.321 45.17 19.602" style="fill:none;' + c + '12;stroke:#333;"/><path d="m116.49 48.69c2.8876-6.3019 10.358-21.518 43.469-22.326" style="fill:none;' + c + '12;stroke:#333;"/><path d="m116.92 51.766c1.5094 6.3991 3.4988 15.595 10.088 23.058" style="fill:none;' + c + '12;stroke:#333;"/><path d="m113.81 51.532c22.03-7.8674 46.709-7.3614 59.444-2.0465" style="fill:none;' + c + '12;stroke:#333;"/><path d="m114.53 52.278c36.226 4.8583 52.414 17.092 59.373 33.347" style="fill:none;' + c + '12;stroke:#333;"/><path d="m55.637 86.851c-4.1213 12.452-2.9877 27.213-1.777 43.084" style="fill:none;' + c + '12;stroke:#333;"/><path d="m55.614 51.124c-13.422 5.5019-21.908 16.409-24.712 28.774-1.8322 8.4632-1.9809 18.156-1.6096 28.486" style="fill:none;' + c + '12;stroke:#333;"/><path d="m173.26 49.486c24.917 10.399 26.707 36.537 27.209 59.62" style="fill:none;' + c + '12;stroke:#333;"/><path d="m173.9 85.625c5.4042 12.625 5.2413 27.675 4.5745 43.58" style="fill:none;' + c + '12;stroke:#333;"/><path d="m53.86 129.93c1.293 16.951 2.6738 35.169-2.1664 53.193" style="fill:none;' + c + '12;stroke:#333;"/><path d="m29.292 108.38c0.6173 17.177 2.6722 36.119 0.8158 54.108" style="fill:none;' + c + '12;stroke:#333;"/><path d="m200.47 109.11c0.3586 18.529-1.2751 36.94 1.9231 48.985" style="fill:none;' + c + '12;stroke:#333;"/><path d="m178.48 129.2c-0.7279 17.362-2.0563 35.743 2.6011 53.099" style="fill:none;' + c + '12;stroke:#333;"/>', i[15] = [], i[15].env = a, i[15].clo = '<path d="m141.75 195a114.79 114.79 0 0 1 38 16.5 115.53 115.53 0 0 1-128.46 0 114.79 114.79 0 0 1 38-16.5 115.77 115.77 0 0 1 15.71-2.53v-14.09a63.8 63.8 0 0 0 21 0v14.09a116.6 116.6 0 0 1 15.75 2.53z" style="fill:#1a1a1a;"/><path d="m60.984 205.66 6.2675 2.2051 3.4074-6.819 2.8018-1.1353-3.9911 7.9907 27.222-3.0857 3.2541-11.739 2.1451-0.2692-3.2833 11.819 20.393-1.6011-14.191-15.945v-2.4379l17.606-5.7274 3.3855-0.473v1.47l-19.167 6.2295 14.731 16.542 19.839-7.7432 3.3636 0.8223-21.371 8.34 20.532 13.842 2.6777-21.687 1.9481 0.5604-2.7726 22.378 0.0584 0.0364 8.5075 4.9923-2.4807 0.85145-6.4718-3.7916-1.2987 6.0622-2.1524 0.53125 1.3425-6.2804-17.037 8.8348-5.0271 0.35661 21.59-11.193-20.962-14.133-7.5006 25.457-2.0721-0.0364 7.6392-25.915-21.05 1.652 9.0109 24.052-1.4155-0.0946-0.49615-0.0437-0.073-7e-3 -0.2043-0.0145-8.3688-22.342-10.127 19.242-1.9846-0.52399 10.514-19.962-26.04 2.9547 13.425 16.418-3.4438-1.0625-12.083-14.781-8.1645 5.9675-1.9043-1.077 8.128-5.9385-6.9898-2.4598 2.3348-1.2881zm92.509-7.2556 14.228 20.093-1.8095 0.89514-15.614-22.043z" style="fill:#b2b2b2;"/>', i[15].head = l, i[15].mouth = '<path d="m97.06 144.59a20.15 20.15 0 0 0 36.88 4.53z" style="fill:#fff;' + c + '2.9999px;stroke:#000;"/>', i[15].eyes = '<line x1="85.29" x2="85.29" y1="98.73" y2="109.79" style="fill:none;' + c + '8.7999px;stroke:#000;"/><path d="m108.28 72.16h62.18c9.19 0 13.32 1.21 14.71 8.52 3.61 18.95 2.2 33.49-0.44 43.75a65.07 65.07 0 0 1-5.89 14.78 73.52 73.52 0 0 1-7.06 10.26c-1.8 2.27-5.17 1.21-4.19-1.09 0.14-0.47 0.27-1 0.4-1.48a14.29 14.29 0 0 0 0.52-6.62 12.52 12.52 0 0 0-3.88-6.3c-4.17-3.9-12.81-8.71-32.53-13.66-6.4-1.6-10.69-2.24-11.76-2.79a7.08 7.08 0 0 1-3.85-6.31v-9c0-2.39 0.18-4.55-1.56-6.57s-4.16-2.13-6.65-2.14a6 6 0 0 1-6-6v-9.35a6 6 0 0 1 6-6z" style="fill:#1a1a1a;"/><path d="m135.9 98.73v9.27m15.22-9.29v9.29" style="fill:none;' + c + '7.7998px;stroke:#b2b2b2;"/>', i[15].top = '<path d="m109.99 15.57c-13.46 3.6301-19.789 11.95-24.069 24.08-6.9996-7-8.7307-10.82-7.5606-21.43a41 41 0 0 0-9.2698 24.988c0.0366 7.6776 5.6462 13.939 12.697 15.297-13.315 5.8106-15.258 22.033-14.045 33.524 5.7687-11.861 14.254-20.981 27.258-22.951-0.43017 6.6-2.5099 10.22-7.29 17.66 18.29-2.8601 25.119-7.8199 37.15-18.24 0.46001 0 1.0001 0.089 1.4606 0.12058-0.33023 3.5601-1.0906 6.5598-5.0004 12.46 9.5298-1.32 14.721-5.8006 17.539-11.671 8.8862 0.95314 15.836 6.785 21.26 14.818 1.928-15.211-4.4766-26.6-19.807-34.036 1.4167-2.6974 8.0143-11.925 17.661-15.721-1.424-0.28569-2.8883-0.49486-4.4033-0.61125-5.71-0.41992-13.62-0.99982-24.89 4.1703 2.8501-8.5101 10.21-11 18.05-13.12-15.131-1.2501-28.61-2.5898-40.53 8.1801-1.8997-6.21-0.18055-12.54 3.7889-17.52z" style="fill:#fff;"/><path d="m172.63 69.954c1.2292 14.064 0.93841 29.96 0.34635 45.169 1.7887 6.796 3.0379 13.235 3.8842 18.388l0.13973-0.011c1.0001 6.56 2.3597 13.18 3.2698 19.73 2.0002-6.5699 2.5303-18.25 3.2405-25.43 1.2597-13 1.8296-29.311-0.43017-41.931-0.85041-4.72-2.0007-7.6896-2.0007-8.4796 4.6205 3.5601 8.6606 9.2204 13.001 14.15-0.6751-3.4318-1.347-6.6004-2.0567-9.5273-4.047-5.7183-13.726-12.154-19.393-12.06z" style="fill:#fff;"/><path d="m157.97 34.471c-10.339 2.7579-17.715 13.543-19.132 16.24 15.33 7.4361 20.783 17.96 21.278 33.517 5.9534 8.8179 10.066 20.289 12.857 30.895 0.87636-13.178 1.8186-27.726 0.26566-44.28 2.5698 0.44857 9.1372 1.3934 18.781 11.17-2.1158-8.7321-4.5671-15.31-8.4539-20.283-4.5598-5.8401-10.999-10.431-23.809-13 9.6502-3.34 16.27-0.76993 25.5 2.1301-8.1388-7.4315-16.474-14.219-27.287-16.389z" style="fill:#fff;"/><path d="m61.473 73.354c-7.256-0.77501-13.024 2.3746-16.262 5.3879 0.73789-0.45409 1.3868-0.74208 1.8489-0.74208 0 0-1.5198 10.359-1.6197 11.519-1.56 19.73 0.99957 43.401 6.37 62.471 1.3099 4.6899 1.1895 3.0893 1.8898-0.9107 1.7526-10.061 3.3891-24.703 6.9739-38.864-5.068-17.627-4.2508-32.403 0.79937-38.861z" style="fill:#fff;"/><path d="m69.09 43.21c-0.0253 1.0803-8e-3 2.1612 0.0523 3.2402-3.8402 0-12.46 0.71984-16 2.1598-4.4504 1.8001-8.48 5.4801-11.67 11.83 7.2999-3.94 11.899-3.8502 16.66-1.8102-10.39 3.45-19.52 11.37-20.32 26.9 1.1456-1.5053 4.6079-4.9789 7.1393-6.6285 0.09-0.0587 0.17427-0.10556 0.26167-0.15946 3.7141-2.3211 9.0494-5.1247 15.181-4.9553-5.0501 6.4577-6.6824 20.434 0.28207 38.428 1.7866-7.0567 4.0574-13.994 7.0681-20.184-1e-3 -11.664 2.0764-27.774 15.391-33.585-7.0508-2.1538-12.709-7.991-14.043-15.236z" style="fill:#fff;"/>';
  var u = u || function(S, O) {
    var _ = {}, B = _.lib = {}, N = function() {
    }, j = B.Base = { extend: function(I) {
      N.prototype = this;
      var V = new N();
      return I && V.mixIn(I), V.hasOwnProperty("init") || (V.init = function() {
        V.$super.init.apply(this, arguments);
      }), V.init.prototype = V, V.$super = this, V;
    }, create: function() {
      var I = this.extend();
      return I.init.apply(I, arguments), I;
    }, init: function() {
    }, mixIn: function(I) {
      for (var V in I)
        I.hasOwnProperty(V) && (this[V] = I[V]);
      I.hasOwnProperty("toString") && (this.toString = I.toString);
    }, clone: function() {
      return this.init.prototype.extend(this);
    } }, W = B.WordArray = j.extend({ init: function(I, V) {
      I = this.words = I || [], this.sigBytes = V != O ? V : 4 * I.length;
    }, toString: function(I) {
      return (I || ee).stringify(this);
    }, concat: function(I) {
      var V = this.words, te = I.words, X = this.sigBytes;
      if (I = I.sigBytes, this.clamp(), X % 4)
        for (var H = 0; H < I; H++)
          V[X + H >>> 2] |= (te[H >>> 2] >>> 24 - H % 4 * 8 & 255) << 24 - (X + H) % 4 * 8;
      else if (65535 < te.length)
        for (H = 0; H < I; H += 4)
          V[X + H >>> 2] = te[H >>> 2];
      else
        V.push.apply(V, te);
      return this.sigBytes += I, this;
    }, clamp: function() {
      var I = this.words, V = this.sigBytes;
      I[V >>> 2] &= 4294967295 << 32 - V % 4 * 8, I.length = S.ceil(V / 4);
    }, clone: function() {
      var I = j.clone.call(this);
      return I.words = this.words.slice(0), I;
    }, random: function(I) {
      for (var V = [], te = 0; te < I; te += 4)
        V.push(4294967296 * S.random() | 0);
      return new W.init(V, I);
    } }), G = _.enc = {}, ee = G.Hex = { stringify: function(I) {
      var V = I.words;
      I = I.sigBytes;
      for (var te = [], X = 0; X < I; X++) {
        var H = V[X >>> 2] >>> 24 - X % 4 * 8 & 255;
        te.push((H >>> 4).toString(16)), te.push((15 & H).toString(16));
      }
      return te.join("");
    }, parse: function(I) {
      for (var V = I.length, te = [], X = 0; X < V; X += 2)
        te[X >>> 3] |= parseInt(I.substr(X, 2), 16) << 24 - X % 8 * 4;
      return new W.init(te, V / 2);
    } }, fe = G.Latin1 = { stringify: function(I) {
      var V = I.words;
      I = I.sigBytes;
      for (var te = [], X = 0; X < I; X++)
        te.push(String.fromCharCode(V[X >>> 2] >>> 24 - X % 4 * 8 & 255));
      return te.join("");
    }, parse: function(I) {
      for (var V = I.length, te = [], X = 0; X < V; X++)
        te[X >>> 2] |= (255 & I.charCodeAt(X)) << 24 - X % 4 * 8;
      return new W.init(te, V);
    } }, P = G.Utf8 = { stringify: function(I) {
      try {
        return decodeURIComponent(escape(fe.stringify(I)));
      } catch {
        throw Error("Malformed UTF-8 data");
      }
    }, parse: function(I) {
      return fe.parse(unescape(encodeURIComponent(I)));
    } }, z = B.BufferedBlockAlgorithm = j.extend({ reset: function() {
      this._data = new W.init(), this._nDataBytes = 0;
    }, _append: function(I) {
      typeof I == "string" && (I = P.parse(I)), this._data.concat(I), this._nDataBytes += I.sigBytes;
    }, _process: function(I) {
      var V = this._data, te = V.words, X = V.sigBytes, H = this.blockSize, $ = X / (4 * H), $;
      if (I = ($ = I ? S.ceil($) : S.max((0 | $) - this._minBufferSize, 0)) * H, X = S.min(4 * I, X), I) {
        for (var se = 0; se < I; se += H)
          this._doProcessBlock(te, se);
        se = te.splice(0, I), V.sigBytes -= X;
      }
      return new W.init(se, X);
    }, clone: function() {
      var I = j.clone.call(this);
      return I._data = this._data.clone(), I;
    }, _minBufferSize: 0 });
    B.Hasher = z.extend({ cfg: j.extend(), init: function(I) {
      this.cfg = this.cfg.extend(I), this.reset();
    }, reset: function() {
      z.reset.call(this), this._doReset();
    }, update: function(I) {
      return this._append(I), this._process(), this;
    }, finalize: function(I) {
      return I && this._append(I), this._doFinalize();
    }, blockSize: 16, _createHelper: function(I) {
      return function(V, te) {
        return new I.init(te).finalize(V);
      };
    }, _createHmacHelper: function(I) {
      return function(V, te) {
        return new U.HMAC.init(I, te).finalize(V);
      };
    } });
    var U = _.algo = {};
    return _;
  }(Math);
  (function(S) {
    for (var O = u, I, _ = (I = O.lib).WordArray, B = I.Hasher, I = O.algo, N = [], j = [], W = function(te) {
      return 4294967296 * (te - (0 | te)) | 0;
    }, G = 2, ee = 0; 64 > ee; ) {
      var fe;
      e: {
        fe = G;
        for (var P = S.sqrt(fe), z = 2; z <= P; z++)
          if (!(fe % z)) {
            fe = !1;
            break e;
          }
        fe = !0;
      }
      fe && (8 > ee && (N[ee] = W(S.pow(G, 0.5))), j[ee] = W(S.pow(G, 1 / 3)), ee++), G++;
    }
    var U = [], I = I.SHA256 = B.extend({ _doReset: function() {
      this._hash = new _.init(N.slice(0));
    }, _doProcessBlock: function(V, te) {
      for (var X = this._hash.words, H = X[0], $ = X[1], se = X[2], he = X[3], pe = X[4], me = X[5], L = X[6], q = X[7], Z = 0; 64 > Z; Z++) {
        if (16 > Z)
          U[Z] = 0 | V[te + Z];
        else {
          var oe = U[Z - 15], de = U[Z - 2];
          U[Z] = ((oe << 25 | oe >>> 7) ^ (oe << 14 | oe >>> 18) ^ oe >>> 3) + U[Z - 7] + ((de << 15 | de >>> 17) ^ (de << 13 | de >>> 19) ^ de >>> 10) + U[Z - 16];
        }
        oe = q + ((pe << 26 | pe >>> 6) ^ (pe << 21 | pe >>> 11) ^ (pe << 7 | pe >>> 25)) + (pe & me ^ ~pe & L) + j[Z] + U[Z], de = ((H << 30 | H >>> 2) ^ (H << 19 | H >>> 13) ^ (H << 10 | H >>> 22)) + (H & $ ^ H & se ^ $ & se), q = L, L = me, me = pe, pe = he + oe | 0, he = se, se = $, $ = H, H = oe + de | 0;
      }
      X[0] = X[0] + H | 0, X[1] = X[1] + $ | 0, X[2] = X[2] + se | 0, X[3] = X[3] + he | 0, X[4] = X[4] + pe | 0, X[5] = X[5] + me | 0, X[6] = X[6] + L | 0, X[7] = X[7] + q | 0;
    }, _doFinalize: function() {
      var V = this._data, te = V.words, X = 8 * this._nDataBytes, H = 8 * V.sigBytes;
      return te[H >>> 5] |= 128 << 24 - H % 32, te[14 + (H + 64 >>> 9 << 4)] = S.floor(X / 4294967296), te[15 + (H + 64 >>> 9 << 4)] = X, V.sigBytes = 4 * te.length, this._process(), this._hash;
    }, clone: function() {
      var V = B.clone.call(this);
      return V._hash = this._hash.clone(), V;
    } });
    O.SHA256 = B._createHelper(I), O.HmacSHA256 = B._createHmacHelper(I);
  })(Math);
  var f = "";
  if (t.length == 0)
    return f;
  f = u.SHA256(t).toString().replace(/\D/g, "").substring(0, 12);
  var d = [];
  for (var h in d.env = f[0] + "" + f[1], d.env = Math.round(0.47 * d.env) + "", d.clo = f[2] + "" + f[3], d.clo = Math.round(0.47 * d.clo) + "", d.head = f[4] + "" + f[5], d.head = Math.round(0.47 * d.head) + "", d.mouth = f[6] + "" + f[7], d.mouth = Math.round(0.47 * d.mouth) + "", d.eyes = f[8] + "" + f[9], d.eyes = Math.round(0.47 * d.eyes) + "", d.top = f[10] + "" + f[11], d.top = Math.round(0.47 * d.top) + "", d) {
    var g = d[h];
    g > 31 ? ((g = g - 32 + "").length == 1 && (g = "0" + g), d[h] = g + "C") : g > 15 ? ((g = g - 16 + "").length == 1 && (g = "0" + g), d[h] = g + "B") : d[h] = (g + "").length == 1 ? "0" + g + "A" : g + "A";
  }
  var p = [];
  for (var h in d) {
    var y = d[h].substring(0, 2), b = d[h].substring(2, 3);
    r !== void 0 && (y = r.part, b = r.theme), p[h] = x(h, y, b);
  }
  function x(S, O, _) {
    var B = n[O][_][S], N = i[O][S], j = /#(.*?);/g, W = N.match(j), G = N;
    if (W != null)
      for (var ee = 0; ee < W.length; ee++)
        G = G.replace(W[ee], B[ee] + ";");
    return G;
  }
  return e && (p.env = ""), o + p.env + p.head + p.clo + p.top + p.eyes + p.mouth + s;
}
function Ha(t) {
  return "data:image/svg+xml," + encodeURIComponent(t).replace(/'/g, "%27").replace(/"/g, "%22");
}
var wt = {};
(function(t) {
  function e(P, z) {
    if (!P)
      throw z = z || "Assertion failed", typeof Error < "u" ? new Error(z) : z;
  }
  var r = !1, n = 0, i = function() {
    if (r)
      return r = !1, n;
    var P = 2 * Math.random() - 1, z = 2 * Math.random() - 1, U = P * P + z * z;
    if (U == 0 || U > 1)
      return i();
    var I = Math.sqrt(-2 * Math.log(U) / U);
    return n = z * I, r = !0, P * I;
  }, o = function(P, z) {
    return Math.random() * (z - P) + P;
  }, s = function(P, z) {
    return Math.floor(Math.random() * (z - P) + P);
  }, a = function(P, z) {
    return P + i() * z;
  }, l = function(P) {
    if (typeof P > "u" || isNaN(P))
      return [];
    if (typeof ArrayBuffer > "u") {
      for (var z = new Array(P), U = 0; U < P; U++)
        z[U] = 0;
      return z;
    } else
      return new Float64Array(P);
  }, c = function(P, z) {
    this.n = P, this.d = z, this.w = l(P * z), this.dw = l(P * z);
  };
  c.prototype = {
    get: function(P, z) {
      var U = this.d * P + z;
      return e(U >= 0 && U < this.w.length), this.w[U];
    },
    set: function(P, z, U) {
      var I = this.d * P + z;
      e(I >= 0 && I < this.w.length), this.w[I] = U;
    },
    setFrom: function(P) {
      for (var z = 0, U = P.length; z < U; z++)
        this.w[z] = P[z];
    },
    setColumn: function(P, z) {
      for (var U = 0, I = P.w.length; U < I; U++)
        this.w[this.d * U + z] = P.w[U];
    },
    toJSON: function() {
      var P = {};
      return P.n = this.n, P.d = this.d, P.w = this.w, P;
    },
    fromJSON: function(P) {
      this.n = P.n, this.d = P.d, this.w = l(this.n * this.d), this.dw = l(this.n * this.d);
      for (var z = 0, U = this.n * this.d; z < U; z++)
        this.w[z] = P.w[z];
    }
  };
  var u = function(P) {
    var z = new c(P.n, P.d);
    return z.setFrom(P.w), z;
  }, f = function(P) {
    var z = {};
    for (var U in P)
      P.hasOwnProperty(U) && (z[U] = u(P[U]));
    return z;
  }, d = function(P, z) {
    for (var U = 0, I = P.n * P.d; U < I; U++)
      P.dw[U] !== 0 && (P.w[U] += -z * P.dw[U], P.dw[U] = 0);
  }, h = function(P, z) {
    for (var U in P)
      P.hasOwnProperty(U) && d(P[U], z);
  }, g = function(P) {
    var z = {};
    for (var U in P)
      P.hasOwnProperty(U) && (z[U] = P[U].toJSON());
    return z;
  }, p = function(P) {
    var z = {};
    for (var U in P)
      P.hasOwnProperty(U) && (z[U] = new c(1, 1), z[U].fromJSON(P[U]));
    return z;
  }, y = function(P) {
    for (var z in P)
      if (P.hasOwnProperty(z)) {
        var U = P[z];
        O(U, 0);
      }
  }, b = function(P) {
    var z = 0;
    for (var U in P)
      if (P.hasOwnProperty(U)) {
        var I = P[U];
        z += I.dw.length;
      }
    var V = new c(z, 1), te = 0;
    for (var U in P)
      if (P.hasOwnProperty(U))
        for (var I = P[U], X = 0, H = I.dw.length; X < H; X++)
          V.w[te] = I.dw[X], te++;
    return V;
  }, x = function(P, z, U, I) {
    var V = new c(P, z);
    return S(V, U, I), V;
  }, S = function(P, z, U) {
    for (var I = 0, V = P.w.length; I < V; I++)
      P.w[I] = a(z, U);
  }, O = function(P, z) {
    for (var U = 0, I = P.dw.length; U < I; U++)
      P.dw[U] = z;
  }, _ = function(P) {
    typeof P > "u" && (P = !0), this.needs_backprop = P, this.backprop = [];
  };
  _.prototype = {
    backward: function() {
      for (var P = this.backprop.length - 1; P >= 0; P--)
        this.backprop[P]();
    },
    rowPluck: function(P, z) {
      e(z >= 0 && z < P.n);
      for (var U = P.d, I = new c(U, 1), V = 0, te = U; V < te; V++)
        I.w[V] = P.w[U * z + V];
      if (this.needs_backprop) {
        var X = function() {
          for (var H = 0, $ = U; H < $; H++)
            P.dw[U * z + H] += I.dw[H];
        };
        this.backprop.push(X);
      }
      return I;
    },
    tanh: function(P) {
      for (var z = new c(P.n, P.d), U = P.w.length, I = 0; I < U; I++)
        z.w[I] = Math.tanh(P.w[I]);
      if (this.needs_backprop) {
        var V = function() {
          for (var te = 0; te < U; te++) {
            var X = z.w[te];
            P.dw[te] += (1 - X * X) * z.dw[te];
          }
        };
        this.backprop.push(V);
      }
      return z;
    },
    sigmoid: function(P) {
      for (var z = new c(P.n, P.d), U = P.w.length, I = 0; I < U; I++)
        z.w[I] = G(P.w[I]);
      if (this.needs_backprop) {
        var V = function() {
          for (var te = 0; te < U; te++) {
            var X = z.w[te];
            P.dw[te] += X * (1 - X) * z.dw[te];
          }
        };
        this.backprop.push(V);
      }
      return z;
    },
    relu: function(P) {
      for (var z = new c(P.n, P.d), U = P.w.length, I = 0; I < U; I++)
        z.w[I] = Math.max(0, P.w[I]);
      if (this.needs_backprop) {
        var V = function() {
          for (var te = 0; te < U; te++)
            P.dw[te] += P.w[te] > 0 ? z.dw[te] : 0;
        };
        this.backprop.push(V);
      }
      return z;
    },
    mul: function(P, z) {
      e(P.d === z.n, "matmul dimensions misaligned");
      for (var U = P.n, I = z.d, V = new c(U, I), te = 0; te < P.n; te++)
        for (var X = 0; X < z.d; X++) {
          for (var H = 0, $ = 0; $ < P.d; $++)
            H += P.w[P.d * te + $] * z.w[z.d * $ + X];
          V.w[I * te + X] = H;
        }
      if (this.needs_backprop) {
        var se = function() {
          for (var he = 0; he < P.n; he++)
            for (var pe = 0; pe < z.d; pe++)
              for (var me = 0; me < P.d; me++) {
                var L = V.dw[I * he + pe];
                P.dw[P.d * he + me] += z.w[z.d * me + pe] * L, z.dw[z.d * me + pe] += P.w[P.d * he + me] * L;
              }
        };
        this.backprop.push(se);
      }
      return V;
    },
    add: function(P, z) {
      e(P.w.length === z.w.length);
      for (var U = new c(P.n, P.d), I = 0, V = P.w.length; I < V; I++)
        U.w[I] = P.w[I] + z.w[I];
      if (this.needs_backprop) {
        var te = function() {
          for (var X = 0, H = P.w.length; X < H; X++)
            P.dw[X] += U.dw[X], z.dw[X] += U.dw[X];
        };
        this.backprop.push(te);
      }
      return U;
    },
    dot: function(P, z) {
      e(P.w.length === z.w.length);
      for (var U = new c(1, 1), I = 0, V = 0, te = P.w.length; V < te; V++)
        I += P.w[V] * z.w[V];
      if (U.w[0] = I, this.needs_backprop) {
        var X = function() {
          for (var H = 0, $ = P.w.length; H < $; H++)
            P.dw[H] += z.w[H] * U.dw[0], z.dw[H] += P.w[H] * U.dw[0];
        };
        this.backprop.push(X);
      }
      return U;
    },
    eltmul: function(P, z) {
      e(P.w.length === z.w.length);
      for (var U = new c(P.n, P.d), I = 0, V = P.w.length; I < V; I++)
        U.w[I] = P.w[I] * z.w[I];
      if (this.needs_backprop) {
        var te = function() {
          for (var X = 0, H = P.w.length; X < H; X++)
            P.dw[X] += z.w[X] * U.dw[X], z.dw[X] += P.w[X] * U.dw[X];
        };
        this.backprop.push(te);
      }
      return U;
    }
  };
  var B = function(P) {
    for (var z = new c(P.n, P.d), U = -999999, I = 0, V = P.w.length; I < V; I++)
      P.w[I] > U && (U = P.w[I]);
    for (var te = 0, I = 0, V = P.w.length; I < V; I++)
      z.w[I] = Math.exp(P.w[I] - U), te += z.w[I];
    for (var I = 0, V = P.w.length; I < V; I++)
      z.w[I] /= te;
    return z;
  }, N = function() {
    this.decay_rate = 0.999, this.smooth_eps = 1e-8, this.step_cache = {};
  };
  N.prototype = {
    step: function(P, z, U, I) {
      var V = {}, te = 0, X = 0;
      for (var H in P)
        if (P.hasOwnProperty(H)) {
          var $ = P[H];
          H in this.step_cache || (this.step_cache[H] = new c($.n, $.d));
          for (var se = this.step_cache[H], he = 0, pe = $.w.length; he < pe; he++) {
            var me = $.dw[he];
            se.w[he] = se.w[he] * this.decay_rate + (1 - this.decay_rate) * me * me, me > I && (me = I, te++), me < -I && (me = -I, te++), X++, $.w[he] += -z * me / Math.sqrt(se.w[he] + this.smooth_eps) - U * $.w[he], $.dw[he] = 0;
          }
        }
      return V.ratio_clipped = te * 1 / X, V;
    }
  };
  var j = function(P, z, U) {
    for (var I = {}, V = 0; V < z.length; V++) {
      var te = V === 0 ? P : z[V - 1], X = z[V];
      I["Wix" + V] = new x(X, te, 0, 0.08), I["Wih" + V] = new x(X, X, 0, 0.08), I["bi" + V] = new c(X, 1), I["Wfx" + V] = new x(X, te, 0, 0.08), I["Wfh" + V] = new x(X, X, 0, 0.08), I["bf" + V] = new c(X, 1), I["Wox" + V] = new x(X, te, 0, 0.08), I["Woh" + V] = new x(X, X, 0, 0.08), I["bo" + V] = new c(X, 1), I["Wcx" + V] = new x(X, te, 0, 0.08), I["Wch" + V] = new x(X, X, 0, 0.08), I["bc" + V] = new c(X, 1);
    }
    return I.Whd = new x(U, X, 0, 0.08), I.bd = new c(U, 1), I;
  }, W = function(P, z, U, I, V) {
    if (V == null || typeof V.h > "u")
      for (var te = [], X = [], H = 0; H < U.length; H++)
        te.push(new wt.Mat(U[H], 1)), X.push(new wt.Mat(U[H], 1));
    else
      var te = V.h, X = V.c;
    for (var $ = [], se = [], H = 0; H < U.length; H++) {
      var he = H === 0 ? I : $[H - 1], pe = te[H], me = X[H], L = P.mul(z["Wix" + H], he), q = P.mul(z["Wih" + H], pe), Z = P.sigmoid(P.add(P.add(L, q), z["bi" + H])), oe = P.mul(z["Wfx" + H], he), de = P.mul(z["Wfh" + H], pe), R = P.sigmoid(P.add(P.add(oe, de), z["bf" + H])), k = P.mul(z["Wox" + H], he), re = P.mul(z["Woh" + H], pe), ne = P.sigmoid(P.add(P.add(k, re), z["bo" + H])), Ae = P.mul(z["Wcx" + H], he), C = P.mul(z["Wch" + H], pe), v = P.tanh(P.add(P.add(Ae, C), z["bc" + H])), w = P.eltmul(R, me), D = P.eltmul(Z, v), J = P.add(w, D), ae = P.eltmul(ne, P.tanh(J));
      $.push(ae), se.push(J);
    }
    var ue = P.add(P.mul(z.Whd, $[$.length - 1]), z.bd);
    return { h: $, c: se, o: ue };
  }, G = function(P) {
    return 1 / (1 + Math.exp(-P));
  }, ee = function(P) {
    for (var z = P[0], U = 0, I = 1, V = P.length; I < V; I++) {
      var te = P[I];
      te > z && (U = I, z = te);
    }
    return U;
  }, fe = function(P) {
    for (var z = o(0, 1), U = 0, I = 0; ; ) {
      if (U += P[I], U > z)
        return I;
      I++;
    }
    return P.length - 1;
  };
  t.assert = e, t.zeros = l, t.maxi = ee, t.samplei = fe, t.randi = s, t.randn = a, t.softmax = B, t.Mat = c, t.RandMat = x, t.forwardLSTM = W, t.initLSTM = j, t.updateMat = d, t.updateNet = h, t.copyMat = u, t.copyNet = f, t.netToJSON = g, t.netFromJSON = p, t.netZeroGrads = y, t.netFlattenGrads = b, t.Solver = N, t.Graph = _;
})(wt);
var a1 = {};
(function(t) {
  var e = function(u, f, d) {
    return typeof u > "u" ? d : typeof u[f] < "u" ? u[f] : d;
  }, r = wt.zeros, n = wt.assert, i = wt.randi;
  wt.randf;
  var o = function(u, f) {
    for (var d = 0, h = u.length; d < h; d++)
      u[d] = f;
  }, s = function(u) {
    for (var f = Math.random(), d = 0, h = 0, g = u.length; h < g; h++)
      if (d += u[h], d >= f)
        return h;
    n(!1, "wtf");
  }, a = function(u, f) {
    this.V = null, this.P = null, this.env = u, this.gamma = e(f, "gamma", 0.75), this.reset();
  };
  a.prototype = {
    reset: function() {
      this.ns = this.env.getNumStates(), this.na = this.env.getMaxNumActions(), this.V = r(this.ns), this.P = r(this.ns * this.na);
      for (var u = 0; u < this.ns; u++)
        for (var f = this.env.allowedActions(u), d = 0, h = f.length; d < h; d++)
          this.P[f[d] * this.ns + u] = 1 / f.length;
    },
    act: function(u) {
      for (var f = this.env.allowedActions(u), d = [], h = 0, g = f.length; h < g; h++) {
        var p = f[h], y = this.P[p * this.ns + u];
        d.push(y);
      }
      var b = s(d);
      return f[b];
    },
    learn: function() {
      self.evaluatePolicy(), self.updatePolicy();
    },
    evaluatePolicy: function() {
      for (var u = r(this.ns), f = 0; f < this.ns; f++) {
        for (var d = 0, h = this.env.allowedActions(f), g = 0, p = h.length; g < p; g++) {
          var y = h[g], b = this.P[y * this.ns + f];
          if (b !== 0) {
            var x = this.env.nextStateDistribution(f, y), S = this.env.reward(f, y, x);
            d += b * (S + this.gamma * this.V[x]);
          }
        }
        u[f] = d;
      }
      this.V = u;
    },
    updatePolicy: function() {
      for (var u = 0; u < this.ns; u++) {
        for (var f = this.env.allowedActions(u), d, h, g = [], p = 0, y = f.length; p < y; p++) {
          var b = f[p], x = this.env.nextStateDistribution(u, b), S = this.env.reward(u, b, x), O = S + this.gamma * this.V[x];
          g.push(O), p === 0 || O > d ? (d = O, h = 1) : O === d && (h += 1);
        }
        for (var p = 0, y = f.length; p < y; p++) {
          var b = f[p];
          this.P[b * this.ns + u] = g[p] === d ? 1 / h : 0;
        }
      }
    }
  };
  var l = function(u, f) {
    this.update = e(f, "update", "qlearn"), this.gamma = e(f, "gamma", 0.75), this.epsilon = e(f, "epsilon", 0.1), this.alpha = e(f, "alpha", 0.01), this.smooth_policy_update = e(f, "smooth_policy_update", !1), this.beta = e(f, "beta", 0.01), this.lambda = e(f, "lambda", 0), this.replacing_traces = e(f, "replacing_traces", !0), this.q_init_val = e(f, "q_init_val", 0), this.planN = e(f, "planN", 0), this.Q = null, this.P = null, this.e = null, this.env_model_s = null, this.env_model_r = null, this.env = u, this.reset();
  };
  l.prototype = {
    reset: function() {
      this.ns = this.env.getNumStates(), this.na = this.env.getMaxNumActions(), this.Q = r(this.ns * this.na), this.q_init_val !== 0 && o(this.Q, this.q_init_val), this.P = r(this.ns * this.na), this.e = r(this.ns * this.na), this.env_model_s = r(this.ns * this.na), o(this.env_model_s, -1), this.env_model_r = r(this.ns * this.na), this.sa_seen = [], this.pq = r(this.ns * this.na);
      for (var u = 0; u < this.ns; u++)
        for (var f = this.env.allowedActions(u), d = 0, h = f.length; d < h; d++)
          this.P[f[d] * this.ns + u] = 1 / f.length;
      this.r0 = null, this.s0 = null, this.s1 = null, this.a0 = null, this.a1 = null;
    },
    resetEpisode: function() {
    },
    act: function(u) {
      for (var f = this.env.allowedActions(u), d = [], h = 0, g = f.length; h < g; h++)
        d.push(this.P[f[h] * this.ns + u]);
      if (Math.random() < this.epsilon) {
        var p = f[i(0, f.length)];
        this.explored = !0;
      } else {
        var p = f[s(d)];
        this.explored = !1;
      }
      return this.s0 = this.s1, this.a0 = this.a1, this.s1 = u, this.a1 = p, p;
    },
    learn: function(u) {
      this.r0 != null && (this.learnFromTuple(this.s0, this.a0, this.r0, this.s1, this.a1, this.lambda), this.planN > 0 && (this.updateModel(this.s0, this.a0, this.r0, this.s1), this.plan())), this.r0 = u;
    },
    updateModel: function(u, f, d, h) {
      var g = f * this.ns + u;
      this.env_model_s[g] === -1 && this.sa_seen.push(f * this.ns + u), this.env_model_s[g] = h, this.env_model_r[g] = d;
    },
    plan: function() {
      for (var u = [], f = 0, d = this.sa_seen.length; f < d; f++) {
        var h = this.sa_seen[f], g = this.pq[h];
        g > 1e-5 && u.push({ sa: h, p: g });
      }
      u.sort(function(j, W) {
        return j.p < W.p ? 1 : -1;
      });
      for (var p = Math.min(this.planN, u.length), y = 0; y < p; y++) {
        var b = u[y].sa;
        this.pq[b] = 0;
        var x = b % this.ns, S = Math.floor(b / this.ns), O = this.env_model_r[b], _ = this.env_model_s[b], B = -1;
        if (this.update === "sarsa")
          var N = this.env.allowedActions(_), B = N[i(0, N.length)];
        this.learnFromTuple(x, S, O, _, B, 0);
      }
    },
    learnFromTuple: function(u, f, d, h, g, p) {
      var y = f * this.ns + u;
      if (this.update === "qlearn") {
        for (var b = this.env.allowedActions(h), x = 0, S = 0, O = b.length; S < O; S++) {
          var _ = b[S] * this.ns + h, B = this.Q[_];
          (S === 0 || B > x) && (x = B);
        }
        var N = d + this.gamma * x;
      } else if (this.update === "sarsa")
        var j = g * this.ns + h, N = d + this.gamma * this.Q[j];
      if (p > 0) {
        this.replacing_traces ? this.e[y] = 1 : this.e[y] += 1;
        for (var W = p * this.gamma, G = r(this.ns), ee = 0; ee < this.ns; ee++)
          for (var b = this.env.allowedActions(ee), S = 0; S < b.length; S++) {
            var fe = b[S], P = fe * this.ns + ee, z = this.e[P], U = this.alpha * z * (N - this.Q[P]);
            this.Q[P] += U, this.updatePriority(ee, fe, U), this.e[P] *= W;
            var I = Math.abs(U);
            I > G[ee] && (G[ee] = I);
          }
        for (var ee = 0; ee < this.ns; ee++)
          G[ee] > 1e-5 && this.updatePolicy(ee);
        this.explored && this.update === "qlearn" && (this.e = r(this.ns * this.na));
      } else {
        var U = this.alpha * (N - this.Q[y]);
        this.Q[y] += U, this.updatePriority(u, f, U), this.updatePolicy(u);
      }
    },
    updatePriority: function(u, f, d) {
      if (d = Math.abs(d), !(d < 1e-5) && this.planN !== 0)
        for (var h = 0; h < this.ns; h++)
          for (var g = 0; g < this.na; g++) {
            var p = g * this.ns + h;
            this.env_model_s[p] === u && (this.pq[p] += d);
          }
    },
    updatePolicy: function(u) {
      for (var f = this.env.allowedActions(u), d, h, g = [], p = 0, y = f.length; p < y; p++) {
        var b = f[p], x = this.Q[b * this.ns + u];
        g.push(x), p === 0 || x > d ? (d = x, h = 1) : x === d && (h += 1);
      }
      for (var S = 0, p = 0, y = f.length; p < y; p++) {
        var b = f[p], O = g[p] === d ? 1 / h : 0, _ = b * this.ns + u;
        this.smooth_policy_update ? (this.P[_] += this.beta * (O - this.P[_]), S += this.P[_]) : this.P[_] = O;
      }
      if (this.smooth_policy_update)
        for (var p = 0, y = f.length; p < y; p++) {
          var b = f[p];
          this.P[b * this.ns + u] /= S;
        }
    }
  };
  var c = function(u, f) {
    this.gamma = e(f, "gamma", 0.75), this.epsilon = e(f, "epsilon", 0.1), this.alpha = e(f, "alpha", 0.01), this.experience_add_every = e(f, "experience_add_every", 25), this.experience_size = e(f, "experience_size", 5e3), this.learning_steps_per_iteration = e(f, "learning_steps_per_iteration", 10), this.tderror_clamp = e(f, "tderror_clamp", 1), this.num_hidden_units = e(f, "num_hidden_units", 100), this.env = u, this.reset();
  };
  c.prototype = {
    reset: function() {
      this.nh = this.num_hidden_units, this.ns = this.env.getNumStates(), this.na = this.env.getMaxNumActions(), this.net = {}, this.net.W1 = new wt.RandMat(this.nh, this.ns, 0, 0.01), this.net.b1 = new wt.Mat(this.nh, 1, 0, 0.01), this.net.W2 = new wt.RandMat(this.na, this.nh, 0, 0.01), this.net.b2 = new wt.Mat(this.na, 1, 0, 0.01), this.exp = [], this.expi = 0, this.t = 0, this.r0 = null, this.s0 = null, this.s1 = null, this.a0 = null, this.a1 = null, this.tderror = 0;
    },
    toJSON: function() {
      var u = {};
      return u.nh = this.nh, u.ns = this.ns, u.na = this.na, u.net = wt.netToJSON(this.net), u;
    },
    fromJSON: function(u) {
      this.nh = u.nh, this.ns = u.ns, this.na = u.na, this.net = wt.netFromJSON(u.net);
    },
    forwardQ: function(u, f, d) {
      var h = new wt.Graph(d), g = h.add(h.mul(u.W1, f), u.b1), p = h.tanh(g), y = h.add(h.mul(u.W2, p), u.b2);
      return this.lastG = h, y;
    },
    act: function(u) {
      var f = new wt.Mat(this.ns, 1);
      if (f.setFrom(u), Math.random() < this.epsilon)
        var d = i(0, this.na);
      else
        var h = this.forwardQ(this.net, f, !1), d = wt.maxi(h.w);
      return this.s0 = this.s1, this.a0 = this.a1, this.s1 = f, this.a1 = d, d;
    },
    learn: function(u) {
      if (this.r0 != null && this.alpha > 0) {
        var f = this.learnFromTuple(this.s0, this.a0, this.r0, this.s1, this.a1);
        this.tderror = f, this.t % this.experience_add_every === 0 && (this.exp[this.expi] = [this.s0, this.a0, this.r0, this.s1, this.a1], this.expi += 1, this.expi > this.experience_size && (this.expi = 0)), this.t += 1;
        for (var d = 0; d < this.learning_steps_per_iteration; d++) {
          var h = i(0, this.exp.length), g = this.exp[h];
          this.learnFromTuple(g[0], g[1], g[2], g[3], g[4]);
        }
      }
      this.r0 = u;
    },
    learnFromTuple: function(u, f, d, h, g) {
      var p = this.forwardQ(this.net, h, !1), y = d + this.gamma * p.w[wt.maxi(p.w)], b = this.forwardQ(this.net, u, !0), x = b.w[f] - y, S = this.tderror_clamp;
      return Math.abs(x) > S && (x > S && (x = S), x < -S && (x = -S)), b.dw[f] = x, this.lastG.backward(), wt.updateNet(this.net, this.alpha), x;
    }
  }, t.DPAgent = a, t.TDAgent = l, t.DQNAgent = c;
})(a1);
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function Qo(t) {
  return t + 0.5 | 0;
}
const en = (t, e, r) => Math.max(Math.min(t, r), e);
function ro(t) {
  return en(Qo(t * 2.55), 0, 255);
}
function cn(t) {
  return en(Qo(t * 255), 0, 255);
}
function Mr(t) {
  return en(Qo(t / 2.55) / 100, 0, 1);
}
function bd(t) {
  return en(Qo(t * 100), 0, 100);
}
const $t = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Rc = [..."0123456789ABCDEF"], y3 = (t) => Rc[t & 15], b3 = (t) => Rc[(t & 240) >> 4] + Rc[t & 15], ys = (t) => (t & 240) >> 4 === (t & 15), v3 = (t) => ys(t.r) && ys(t.g) && ys(t.b) && ys(t.a);
function A3(t) {
  var e = t.length, r;
  return t[0] === "#" && (e === 4 || e === 5 ? r = {
    r: 255 & $t[t[1]] * 17,
    g: 255 & $t[t[2]] * 17,
    b: 255 & $t[t[3]] * 17,
    a: e === 5 ? $t[t[4]] * 17 : 255
  } : (e === 7 || e === 9) && (r = {
    r: $t[t[1]] << 4 | $t[t[2]],
    g: $t[t[3]] << 4 | $t[t[4]],
    b: $t[t[5]] << 4 | $t[t[6]],
    a: e === 9 ? $t[t[7]] << 4 | $t[t[8]] : 255
  })), r;
}
const w3 = (t, e) => t < 255 ? e(t) : "";
function x3(t) {
  var e = v3(t) ? y3 : b3;
  return t ? "#" + e(t.r) + e(t.g) + e(t.b) + w3(t.a, e) : void 0;
}
const _3 = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function l1(t, e, r) {
  const n = e * Math.min(r, 1 - r), i = (o, s = (o + t / 30) % 12) => r - n * Math.max(Math.min(s - 3, 9 - s, 1), -1);
  return [i(0), i(8), i(4)];
}
function S3(t, e, r) {
  const n = (i, o = (i + t / 60) % 6) => r - r * e * Math.max(Math.min(o, 4 - o, 1), 0);
  return [n(5), n(3), n(1)];
}
function E3(t, e, r) {
  const n = l1(t, 1, 0.5);
  let i;
  for (e + r > 1 && (i = 1 / (e + r), e *= i, r *= i), i = 0; i < 3; i++)
    n[i] *= 1 - e - r, n[i] += e;
  return n;
}
function k3(t, e, r, n, i) {
  return t === i ? (e - r) / n + (e < r ? 6 : 0) : e === i ? (r - t) / n + 2 : (t - e) / n + 4;
}
function Nu(t) {
  const r = t.r / 255, n = t.g / 255, i = t.b / 255, o = Math.max(r, n, i), s = Math.min(r, n, i), a = (o + s) / 2;
  let l, c, u;
  return o !== s && (u = o - s, c = a > 0.5 ? u / (2 - o - s) : u / (o + s), l = k3(r, n, i, u, o), l = l * 60 + 0.5), [l | 0, c || 0, a];
}
function Bu(t, e, r, n) {
  return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, r, n)).map(cn);
}
function Lu(t, e, r) {
  return Bu(l1, t, e, r);
}
function C3(t, e, r) {
  return Bu(E3, t, e, r);
}
function T3(t, e, r) {
  return Bu(S3, t, e, r);
}
function c1(t) {
  return (t % 360 + 360) % 360;
}
function O3(t) {
  const e = _3.exec(t);
  let r = 255, n;
  if (!e)
    return;
  e[5] !== n && (r = e[6] ? ro(+e[5]) : cn(+e[5]));
  const i = c1(+e[2]), o = +e[3] / 100, s = +e[4] / 100;
  return e[1] === "hwb" ? n = C3(i, o, s) : e[1] === "hsv" ? n = T3(i, o, s) : n = Lu(i, o, s), {
    r: n[0],
    g: n[1],
    b: n[2],
    a: r
  };
}
function I3(t, e) {
  var r = Nu(t);
  r[0] = c1(r[0] + e), r = Lu(r), t.r = r[0], t.g = r[1], t.b = r[2];
}
function P3(t) {
  if (!t)
    return;
  const e = Nu(t), r = e[0], n = bd(e[1]), i = bd(e[2]);
  return t.a < 255 ? `hsla(${r}, ${n}%, ${i}%, ${Mr(t.a)})` : `hsl(${r}, ${n}%, ${i}%)`;
}
const vd = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Ad = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function R3() {
  const t = {}, e = Object.keys(Ad), r = Object.keys(vd);
  let n, i, o, s, a;
  for (n = 0; n < e.length; n++) {
    for (s = a = e[n], i = 0; i < r.length; i++)
      o = r[i], a = a.replace(o, vd[o]);
    o = parseInt(Ad[s], 16), t[a] = [o >> 16 & 255, o >> 8 & 255, o & 255];
  }
  return t;
}
let bs;
function D3(t) {
  bs || (bs = R3(), bs.transparent = [0, 0, 0, 0]);
  const e = bs[t.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const M3 = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function N3(t) {
  const e = M3.exec(t);
  let r = 255, n, i, o;
  if (e) {
    if (e[7] !== n) {
      const s = +e[7];
      r = e[8] ? ro(s) : en(s * 255, 0, 255);
    }
    return n = +e[1], i = +e[3], o = +e[5], n = 255 & (e[2] ? ro(n) : en(n, 0, 255)), i = 255 & (e[4] ? ro(i) : en(i, 0, 255)), o = 255 & (e[6] ? ro(o) : en(o, 0, 255)), {
      r: n,
      g: i,
      b: o,
      a: r
    };
  }
}
function B3(t) {
  return t && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${Mr(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`);
}
const Vl = (t) => t <= 31308e-7 ? t * 12.92 : Math.pow(t, 1 / 2.4) * 1.055 - 0.055, Zn = (t) => t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
function L3(t, e, r) {
  const n = Zn(Mr(t.r)), i = Zn(Mr(t.g)), o = Zn(Mr(t.b));
  return {
    r: cn(Vl(n + r * (Zn(Mr(e.r)) - n))),
    g: cn(Vl(i + r * (Zn(Mr(e.g)) - i))),
    b: cn(Vl(o + r * (Zn(Mr(e.b)) - o))),
    a: t.a + r * (e.a - t.a)
  };
}
function vs(t, e, r) {
  if (t) {
    let n = Nu(t);
    n[e] = Math.max(0, Math.min(n[e] + n[e] * r, e === 0 ? 360 : 1)), n = Lu(n), t.r = n[0], t.g = n[1], t.b = n[2];
  }
}
function u1(t, e) {
  return t && Object.assign(e || {}, t);
}
function wd(t) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(t) ? t.length >= 3 && (e = { r: t[0], g: t[1], b: t[2], a: 255 }, t.length > 3 && (e.a = cn(t[3]))) : (e = u1(t, { r: 0, g: 0, b: 0, a: 1 }), e.a = cn(e.a)), e;
}
function F3(t) {
  return t.charAt(0) === "r" ? N3(t) : O3(t);
}
class Oo {
  constructor(e) {
    if (e instanceof Oo)
      return e;
    const r = typeof e;
    let n;
    r === "object" ? n = wd(e) : r === "string" && (n = A3(e) || D3(e) || F3(e)), this._rgb = n, this._valid = !!n;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = u1(this._rgb);
    return e && (e.a = Mr(e.a)), e;
  }
  set rgb(e) {
    this._rgb = wd(e);
  }
  rgbString() {
    return this._valid ? B3(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? x3(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? P3(this._rgb) : void 0;
  }
  mix(e, r) {
    if (e) {
      const n = this.rgb, i = e.rgb;
      let o;
      const s = r === o ? 0.5 : r, a = 2 * s - 1, l = n.a - i.a, c = ((a * l === -1 ? a : (a + l) / (1 + a * l)) + 1) / 2;
      o = 1 - c, n.r = 255 & c * n.r + o * i.r + 0.5, n.g = 255 & c * n.g + o * i.g + 0.5, n.b = 255 & c * n.b + o * i.b + 0.5, n.a = s * n.a + (1 - s) * i.a, this.rgb = n;
    }
    return this;
  }
  interpolate(e, r) {
    return e && (this._rgb = L3(this._rgb, e._rgb, r)), this;
  }
  clone() {
    return new Oo(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = cn(e), this;
  }
  clearer(e) {
    const r = this._rgb;
    return r.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, r = Qo(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = r, this;
  }
  opaquer(e) {
    const r = this._rgb;
    return r.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return vs(this._rgb, 2, e), this;
  }
  darken(e) {
    return vs(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return vs(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return vs(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return I3(this._rgb, e), this;
  }
}
/*!
 * Chart.js v4.4.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function Ir() {
}
const j3 = (() => {
  let t = 0;
  return () => t++;
})();
function We(t) {
  return t === null || typeof t > "u";
}
function it(t) {
  if (Array.isArray && Array.isArray(t))
    return !0;
  const e = Object.prototype.toString.call(t);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function Be(t) {
  return t !== null && Object.prototype.toString.call(t) === "[object Object]";
}
function pt(t) {
  return (typeof t == "number" || t instanceof Number) && isFinite(+t);
}
function Ht(t, e) {
  return pt(t) ? t : e;
}
function Oe(t, e) {
  return typeof t > "u" ? e : t;
}
const W3 = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 : +t / e, f1 = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 * e : +t;
function nt(t, e, r) {
  if (t && typeof t.call == "function")
    return t.apply(r, e);
}
function $e(t, e, r, n) {
  let i, o, s;
  if (it(t))
    if (o = t.length, n)
      for (i = o - 1; i >= 0; i--)
        e.call(r, t[i], i);
    else
      for (i = 0; i < o; i++)
        e.call(r, t[i], i);
  else if (Be(t))
    for (s = Object.keys(t), o = s.length, i = 0; i < o; i++)
      e.call(r, t[s[i]], s[i]);
}
function ga(t, e) {
  let r, n, i, o;
  if (!t || !e || t.length !== e.length)
    return !1;
  for (r = 0, n = t.length; r < n; ++r)
    if (i = t[r], o = e[r], i.datasetIndex !== o.datasetIndex || i.index !== o.index)
      return !1;
  return !0;
}
function ma(t) {
  if (it(t))
    return t.map(ma);
  if (Be(t)) {
    const e = /* @__PURE__ */ Object.create(null), r = Object.keys(t), n = r.length;
    let i = 0;
    for (; i < n; ++i)
      e[r[i]] = ma(t[r[i]]);
    return e;
  }
  return t;
}
function d1(t) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(t) === -1;
}
function U3(t, e, r, n) {
  if (!d1(t))
    return;
  const i = e[t], o = r[t];
  Be(i) && Be(o) ? Io(i, o, n) : e[t] = ma(o);
}
function Io(t, e, r) {
  const n = it(e) ? e : [
    e
  ], i = n.length;
  if (!Be(t))
    return t;
  r = r || {};
  const o = r.merger || U3;
  let s;
  for (let a = 0; a < i; ++a) {
    if (s = n[a], !Be(s))
      continue;
    const l = Object.keys(s);
    for (let c = 0, u = l.length; c < u; ++c)
      o(l[c], t, s, r);
  }
  return t;
}
function go(t, e) {
  return Io(t, e, {
    merger: z3
  });
}
function z3(t, e, r) {
  if (!d1(t))
    return;
  const n = e[t], i = r[t];
  Be(n) && Be(i) ? go(n, i) : Object.prototype.hasOwnProperty.call(e, t) || (e[t] = ma(i));
}
const xd = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (t) => t,
  // default resolvers
  x: (t) => t.x,
  y: (t) => t.y
};
function V3(t) {
  const e = t.split("."), r = [];
  let n = "";
  for (const i of e)
    n += i, n.endsWith("\\") ? n = n.slice(0, -1) + "." : (r.push(n), n = "");
  return r;
}
function q3(t) {
  const e = V3(t);
  return (r) => {
    for (const n of e) {
      if (n === "")
        break;
      r = r && r[n];
    }
    return r;
  };
}
function hn(t, e) {
  return (xd[e] || (xd[e] = q3(e)))(t);
}
function Fu(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const Po = (t) => typeof t < "u", pn = (t) => typeof t == "function", _d = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const r of t)
    if (!e.has(r))
      return !1;
  return !0;
};
function H3(t) {
  return t.type === "mouseup" || t.type === "click" || t.type === "contextmenu";
}
const st = Math.PI, ot = 2 * st, Y3 = ot + st, ya = Number.POSITIVE_INFINITY, K3 = st / 180, mt = st / 2, Sn = st / 4, Sd = st * 2 / 3, tn = Math.log10, kr = Math.sign;
function mo(t, e, r) {
  return Math.abs(t - e) < r;
}
function Ed(t) {
  const e = Math.round(t);
  t = mo(t, e, t / 1e3) ? e : t;
  const r = Math.pow(10, Math.floor(tn(t))), n = t / r;
  return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * r;
}
function X3(t) {
  const e = [], r = Math.sqrt(t);
  let n;
  for (n = 1; n < r; n++)
    t % n === 0 && (e.push(n), e.push(t / n));
  return r === (r | 0) && e.push(r), e.sort((i, o) => i - o).pop(), e;
}
function _i(t) {
  return !isNaN(parseFloat(t)) && isFinite(t);
}
function J3(t, e) {
  const r = Math.round(t);
  return r - e <= t && r + e >= t;
}
function h1(t, e, r) {
  let n, i, o;
  for (n = 0, i = t.length; n < i; n++)
    o = t[n][r], isNaN(o) || (e.min = Math.min(e.min, o), e.max = Math.max(e.max, o));
}
function pr(t) {
  return t * (st / 180);
}
function ju(t) {
  return t * (180 / st);
}
function kd(t) {
  if (!pt(t))
    return;
  let e = 1, r = 0;
  for (; Math.round(t * e) / e !== t; )
    e *= 10, r++;
  return r;
}
function p1(t, e) {
  const r = e.x - t.x, n = e.y - t.y, i = Math.sqrt(r * r + n * n);
  let o = Math.atan2(n, r);
  return o < -0.5 * st && (o += ot), {
    angle: o,
    distance: i
  };
}
function Dc(t, e) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function Q3(t, e) {
  return (t - e + Y3) % ot - st;
}
function Yt(t) {
  return (t % ot + ot) % ot;
}
function Ro(t, e, r, n) {
  const i = Yt(t), o = Yt(e), s = Yt(r), a = Yt(o - i), l = Yt(s - i), c = Yt(i - o), u = Yt(i - s);
  return i === o || i === s || n && o === s || a > l && c < u;
}
function St(t, e, r) {
  return Math.max(e, Math.min(r, t));
}
function G3(t) {
  return St(t, -32768, 32767);
}
function Fr(t, e, r, n = 1e-6) {
  return t >= Math.min(e, r) - n && t <= Math.max(e, r) + n;
}
function Wu(t, e, r) {
  r = r || ((s) => t[s] < e);
  let n = t.length - 1, i = 0, o;
  for (; n - i > 1; )
    o = i + n >> 1, r(o) ? i = o : n = o;
  return {
    lo: i,
    hi: n
  };
}
const jr = (t, e, r, n) => Wu(t, r, n ? (i) => {
  const o = t[i][e];
  return o < r || o === r && t[i + 1][e] === r;
} : (i) => t[i][e] < r), Z3 = (t, e, r) => Wu(t, r, (n) => t[n][e] >= r);
function $3(t, e, r) {
  let n = 0, i = t.length;
  for (; n < i && t[n] < e; )
    n++;
  for (; i > n && t[i - 1] > r; )
    i--;
  return n > 0 || i < t.length ? t.slice(n, i) : t;
}
const g1 = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function e2(t, e) {
  if (t._chartjs) {
    t._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(t, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), g1.forEach((r) => {
    const n = "_onData" + Fu(r), i = t[r];
    Object.defineProperty(t, r, {
      configurable: !0,
      enumerable: !1,
      value(...o) {
        const s = i.apply(this, o);
        return t._chartjs.listeners.forEach((a) => {
          typeof a[n] == "function" && a[n](...o);
        }), s;
      }
    });
  });
}
function Cd(t, e) {
  const r = t._chartjs;
  if (!r)
    return;
  const n = r.listeners, i = n.indexOf(e);
  i !== -1 && n.splice(i, 1), !(n.length > 0) && (g1.forEach((o) => {
    delete t[o];
  }), delete t._chartjs);
}
function m1(t) {
  const e = new Set(t);
  return e.size === t.length ? t : Array.from(e);
}
const y1 = function() {
  return typeof window > "u" ? function(t) {
    return t();
  } : window.requestAnimationFrame;
}();
function b1(t, e) {
  let r = [], n = !1;
  return function(...i) {
    r = i, n || (n = !0, y1.call(window, () => {
      n = !1, t.apply(e, r);
    }));
  };
}
function t2(t, e) {
  let r;
  return function(...n) {
    return e ? (clearTimeout(r), r = setTimeout(t, e, n)) : t.apply(this, n), e;
  };
}
const Uu = (t) => t === "start" ? "left" : t === "end" ? "right" : "center", It = (t, e, r) => t === "start" ? e : t === "end" ? r : (e + r) / 2, r2 = (t, e, r, n) => t === (n ? "left" : "right") ? r : t === "center" ? (e + r) / 2 : e;
function v1(t, e, r) {
  const n = e.length;
  let i = 0, o = n;
  if (t._sorted) {
    const { iScale: s, _parsed: a } = t, l = s.axis, { min: c, max: u, minDefined: f, maxDefined: d } = s.getUserBounds();
    f && (i = St(Math.min(
      // @ts-expect-error Need to type _parsed
      jr(a, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      r ? n : jr(e, l, s.getPixelForValue(c)).lo
    ), 0, n - 1)), d ? o = St(Math.max(
      // @ts-expect-error Need to type _parsed
      jr(a, s.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      r ? 0 : jr(e, l, s.getPixelForValue(u), !0).hi + 1
    ), i, n) - i : o = n - i;
  }
  return {
    start: i,
    count: o
  };
}
function A1(t) {
  const { xScale: e, yScale: r, _scaleRanges: n } = t, i = {
    xmin: e.min,
    xmax: e.max,
    ymin: r.min,
    ymax: r.max
  };
  if (!n)
    return t._scaleRanges = i, !0;
  const o = n.xmin !== e.min || n.xmax !== e.max || n.ymin !== r.min || n.ymax !== r.max;
  return Object.assign(n, i), o;
}
const As = (t) => t === 0 || t === 1, Td = (t, e, r) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * ot / r)), Od = (t, e, r) => Math.pow(2, -10 * t) * Math.sin((t - e) * ot / r) + 1, yo = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * mt) + 1,
  easeOutSine: (t) => Math.sin(t * mt),
  easeInOutSine: (t) => -0.5 * (Math.cos(st * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => As(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => As(t) ? t : Td(t, 0.075, 0.3),
  easeOutElastic: (t) => As(t) ? t : Od(t, 0.075, 0.3),
  easeInOutElastic(t) {
    return As(t) ? t : t < 0.5 ? 0.5 * Td(t * 2, 0.1125, 0.45) : 0.5 + 0.5 * Od(t * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(t) {
    return t * t * ((1.70158 + 1) * t - 1.70158);
  },
  easeOutBack(t) {
    return (t -= 1) * t * ((1.70158 + 1) * t + 1.70158) + 1;
  },
  easeInOutBack(t) {
    let e = 1.70158;
    return (t /= 0.5) < 1 ? 0.5 * (t * t * (((e *= 1.525) + 1) * t - e)) : 0.5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2);
  },
  easeInBounce: (t) => 1 - yo.easeOutBounce(1 - t),
  easeOutBounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? yo.easeInBounce(t * 2) * 0.5 : yo.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function zu(t) {
  if (t && typeof t == "object") {
    const e = t.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function Id(t) {
  return zu(t) ? t : new Oo(t);
}
function ql(t) {
  return zu(t) ? t : new Oo(t).saturate(0.5).darken(0.1).hexString();
}
const n2 = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], i2 = [
  "color",
  "borderColor",
  "backgroundColor"
];
function o2(t) {
  t.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), t.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), t.set("animations", {
    colors: {
      type: "color",
      properties: i2
    },
    numbers: {
      type: "number",
      properties: n2
    }
  }), t.describe("animations", {
    _fallback: "animation"
  }), t.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function s2(t) {
  t.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Pd = /* @__PURE__ */ new Map();
function a2(t, e) {
  e = e || {};
  const r = t + JSON.stringify(e);
  let n = Pd.get(r);
  return n || (n = new Intl.NumberFormat(t, e), Pd.set(r, n)), n;
}
function Go(t, e, r) {
  return a2(e, r).format(t);
}
const w1 = {
  values(t) {
    return it(t) ? t : "" + t;
  },
  numeric(t, e, r) {
    if (t === 0)
      return "0";
    const n = this.chart.options.locale;
    let i, o = t;
    if (r.length > 1) {
      const c = Math.max(Math.abs(r[0].value), Math.abs(r[r.length - 1].value));
      (c < 1e-4 || c > 1e15) && (i = "scientific"), o = l2(t, r);
    }
    const s = tn(Math.abs(o)), a = isNaN(s) ? 1 : Math.max(Math.min(-1 * Math.floor(s), 20), 0), l = {
      notation: i,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(l, this.options.ticks.format), Go(t, n, l);
  },
  logarithmic(t, e, r) {
    if (t === 0)
      return "0";
    const n = r[e].significand || t / Math.pow(10, Math.floor(tn(t)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(n) || e > 0.8 * r.length ? w1.numeric.call(this, t, e, r) : "";
  }
};
function l2(t, e) {
  let r = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(r) >= 1 && t !== Math.floor(t) && (r = t - Math.floor(t)), r;
}
var Ya = {
  formatters: w1
};
function c2(t) {
  t.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, r) => r.lineWidth,
      tickColor: (e, r) => r.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ya.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), t.route("scale.ticks", "color", "", "color"), t.route("scale.grid", "color", "", "borderColor"), t.route("scale.border", "color", "", "borderColor"), t.route("scale.title", "color", "", "color"), t.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), t.describe("scales", {
    _fallback: "scale"
  }), t.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const qn = /* @__PURE__ */ Object.create(null), Mc = /* @__PURE__ */ Object.create(null);
function bo(t, e) {
  if (!e)
    return t;
  const r = e.split(".");
  for (let n = 0, i = r.length; n < i; ++n) {
    const o = r[n];
    t = t[o] || (t[o] = /* @__PURE__ */ Object.create(null));
  }
  return t;
}
function Hl(t, e, r) {
  return typeof e == "string" ? Io(bo(t, e), r) : Io(bo(t, ""), e);
}
class u2 {
  constructor(e, r) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (n) => n.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (n, i) => ql(i.backgroundColor), this.hoverBorderColor = (n, i) => ql(i.borderColor), this.hoverColor = (n, i) => ql(i.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(r);
  }
  set(e, r) {
    return Hl(this, e, r);
  }
  get(e) {
    return bo(this, e);
  }
  describe(e, r) {
    return Hl(Mc, e, r);
  }
  override(e, r) {
    return Hl(qn, e, r);
  }
  route(e, r, n, i) {
    const o = bo(this, e), s = bo(this, n), a = "_" + r;
    Object.defineProperties(o, {
      [a]: {
        value: o[r],
        writable: !0
      },
      [r]: {
        enumerable: !0,
        get() {
          const l = this[a], c = s[i];
          return Be(l) ? Object.assign({}, c, l) : Oe(l, c);
        },
        set(l) {
          this[a] = l;
        }
      }
    });
  }
  apply(e) {
    e.forEach((r) => r(this));
  }
}
var gt = /* @__PURE__ */ new u2({
  _scriptable: (t) => !t.startsWith("on"),
  _indexable: (t) => t !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  o2,
  s2,
  c2
]);
function f2(t) {
  return !t || We(t.size) || We(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
}
function ba(t, e, r, n, i) {
  let o = e[i];
  return o || (o = e[i] = t.measureText(i).width, r.push(i)), o > n && (n = o), n;
}
function d2(t, e, r, n) {
  n = n || {};
  let i = n.data = n.data || {}, o = n.garbageCollect = n.garbageCollect || [];
  n.font !== e && (i = n.data = {}, o = n.garbageCollect = [], n.font = e), t.save(), t.font = e;
  let s = 0;
  const a = r.length;
  let l, c, u, f, d;
  for (l = 0; l < a; l++)
    if (f = r[l], f != null && !it(f))
      s = ba(t, i, o, s, f);
    else if (it(f))
      for (c = 0, u = f.length; c < u; c++)
        d = f[c], d != null && !it(d) && (s = ba(t, i, o, s, d));
  t.restore();
  const h = o.length / 2;
  if (h > r.length) {
    for (l = 0; l < h; l++)
      delete i[o[l]];
    o.splice(0, h);
  }
  return s;
}
function En(t, e, r) {
  const n = t.currentDevicePixelRatio, i = r !== 0 ? Math.max(r / 2, 0.5) : 0;
  return Math.round((e - i) * n) / n + i;
}
function Rd(t, e) {
  e = e || t.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, t.width, t.height), e.restore();
}
function Nc(t, e, r, n) {
  x1(t, e, r, n, null);
}
function x1(t, e, r, n, i) {
  let o, s, a, l, c, u, f, d;
  const h = e.pointStyle, g = e.rotation, p = e.radius;
  let y = (g || 0) * K3;
  if (h && typeof h == "object" && (o = h.toString(), o === "[object HTMLImageElement]" || o === "[object HTMLCanvasElement]")) {
    t.save(), t.translate(r, n), t.rotate(y), t.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), t.restore();
    return;
  }
  if (!(isNaN(p) || p <= 0)) {
    switch (t.beginPath(), h) {
      default:
        i ? t.ellipse(r, n, i / 2, p, 0, 0, ot) : t.arc(r, n, p, 0, ot), t.closePath();
        break;
      case "triangle":
        u = i ? i / 2 : p, t.moveTo(r + Math.sin(y) * u, n - Math.cos(y) * p), y += Sd, t.lineTo(r + Math.sin(y) * u, n - Math.cos(y) * p), y += Sd, t.lineTo(r + Math.sin(y) * u, n - Math.cos(y) * p), t.closePath();
        break;
      case "rectRounded":
        c = p * 0.516, l = p - c, s = Math.cos(y + Sn) * l, f = Math.cos(y + Sn) * (i ? i / 2 - c : l), a = Math.sin(y + Sn) * l, d = Math.sin(y + Sn) * (i ? i / 2 - c : l), t.arc(r - f, n - a, c, y - st, y - mt), t.arc(r + d, n - s, c, y - mt, y), t.arc(r + f, n + a, c, y, y + mt), t.arc(r - d, n + s, c, y + mt, y + st), t.closePath();
        break;
      case "rect":
        if (!g) {
          l = Math.SQRT1_2 * p, u = i ? i / 2 : l, t.rect(r - u, n - l, 2 * u, 2 * l);
          break;
        }
        y += Sn;
      case "rectRot":
        f = Math.cos(y) * (i ? i / 2 : p), s = Math.cos(y) * p, a = Math.sin(y) * p, d = Math.sin(y) * (i ? i / 2 : p), t.moveTo(r - f, n - a), t.lineTo(r + d, n - s), t.lineTo(r + f, n + a), t.lineTo(r - d, n + s), t.closePath();
        break;
      case "crossRot":
        y += Sn;
      case "cross":
        f = Math.cos(y) * (i ? i / 2 : p), s = Math.cos(y) * p, a = Math.sin(y) * p, d = Math.sin(y) * (i ? i / 2 : p), t.moveTo(r - f, n - a), t.lineTo(r + f, n + a), t.moveTo(r + d, n - s), t.lineTo(r - d, n + s);
        break;
      case "star":
        f = Math.cos(y) * (i ? i / 2 : p), s = Math.cos(y) * p, a = Math.sin(y) * p, d = Math.sin(y) * (i ? i / 2 : p), t.moveTo(r - f, n - a), t.lineTo(r + f, n + a), t.moveTo(r + d, n - s), t.lineTo(r - d, n + s), y += Sn, f = Math.cos(y) * (i ? i / 2 : p), s = Math.cos(y) * p, a = Math.sin(y) * p, d = Math.sin(y) * (i ? i / 2 : p), t.moveTo(r - f, n - a), t.lineTo(r + f, n + a), t.moveTo(r + d, n - s), t.lineTo(r - d, n + s);
        break;
      case "line":
        s = i ? i / 2 : Math.cos(y) * p, a = Math.sin(y) * p, t.moveTo(r - s, n - a), t.lineTo(r + s, n + a);
        break;
      case "dash":
        t.moveTo(r, n), t.lineTo(r + Math.cos(y) * (i ? i / 2 : p), n + Math.sin(y) * p);
        break;
      case !1:
        t.closePath();
        break;
    }
    t.fill(), e.borderWidth > 0 && t.stroke();
  }
}
function Wr(t, e, r) {
  return r = r || 0.5, !e || t && t.x > e.left - r && t.x < e.right + r && t.y > e.top - r && t.y < e.bottom + r;
}
function Ka(t, e) {
  t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip();
}
function Xa(t) {
  t.restore();
}
function h2(t, e, r, n, i) {
  if (!e)
    return t.lineTo(r.x, r.y);
  if (i === "middle") {
    const o = (e.x + r.x) / 2;
    t.lineTo(o, e.y), t.lineTo(o, r.y);
  } else
    i === "after" != !!n ? t.lineTo(e.x, r.y) : t.lineTo(r.x, e.y);
  t.lineTo(r.x, r.y);
}
function p2(t, e, r, n) {
  if (!e)
    return t.lineTo(r.x, r.y);
  t.bezierCurveTo(n ? e.cp1x : e.cp2x, n ? e.cp1y : e.cp2y, n ? r.cp2x : r.cp1x, n ? r.cp2y : r.cp1y, r.x, r.y);
}
function g2(t, e) {
  e.translation && t.translate(e.translation[0], e.translation[1]), We(e.rotation) || t.rotate(e.rotation), e.color && (t.fillStyle = e.color), e.textAlign && (t.textAlign = e.textAlign), e.textBaseline && (t.textBaseline = e.textBaseline);
}
function m2(t, e, r, n, i) {
  if (i.strikethrough || i.underline) {
    const o = t.measureText(n), s = e - o.actualBoundingBoxLeft, a = e + o.actualBoundingBoxRight, l = r - o.actualBoundingBoxAscent, c = r + o.actualBoundingBoxDescent, u = i.strikethrough ? (l + c) / 2 : c;
    t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = i.decorationWidth || 2, t.moveTo(s, u), t.lineTo(a, u), t.stroke();
  }
}
function y2(t, e) {
  const r = t.fillStyle;
  t.fillStyle = e.color, t.fillRect(e.left, e.top, e.width, e.height), t.fillStyle = r;
}
function Hn(t, e, r, n, i, o = {}) {
  const s = it(e) ? e : [
    e
  ], a = o.strokeWidth > 0 && o.strokeColor !== "";
  let l, c;
  for (t.save(), t.font = i.string, g2(t, o), l = 0; l < s.length; ++l)
    c = s[l], o.backdrop && y2(t, o.backdrop), a && (o.strokeColor && (t.strokeStyle = o.strokeColor), We(o.strokeWidth) || (t.lineWidth = o.strokeWidth), t.strokeText(c, r, n, o.maxWidth)), t.fillText(c, r, n, o.maxWidth), m2(t, r, n, c, o), n += Number(i.lineHeight);
  t.restore();
}
function Do(t, e) {
  const { x: r, y: n, w: i, h: o, radius: s } = e;
  t.arc(r + s.topLeft, n + s.topLeft, s.topLeft, 1.5 * st, st, !0), t.lineTo(r, n + o - s.bottomLeft), t.arc(r + s.bottomLeft, n + o - s.bottomLeft, s.bottomLeft, st, mt, !0), t.lineTo(r + i - s.bottomRight, n + o), t.arc(r + i - s.bottomRight, n + o - s.bottomRight, s.bottomRight, mt, 0, !0), t.lineTo(r + i, n + s.topRight), t.arc(r + i - s.topRight, n + s.topRight, s.topRight, 0, -mt, !0), t.lineTo(r + s.topLeft, n);
}
const b2 = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, v2 = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function A2(t, e) {
  const r = ("" + t).match(b2);
  if (!r || r[1] === "normal")
    return e * 1.2;
  switch (t = +r[2], r[3]) {
    case "px":
      return t;
    case "%":
      t /= 100;
      break;
  }
  return e * t;
}
const w2 = (t) => +t || 0;
function Vu(t, e) {
  const r = {}, n = Be(e), i = n ? Object.keys(e) : e, o = Be(t) ? n ? (s) => Oe(t[s], t[e[s]]) : (s) => t[s] : () => t;
  for (const s of i)
    r[s] = w2(o(s));
  return r;
}
function _1(t) {
  return Vu(t, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Ln(t) {
  return Vu(t, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function Mt(t) {
  const e = _1(t);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function vt(t, e) {
  t = t || {}, e = e || gt.font;
  let r = Oe(t.size, e.size);
  typeof r == "string" && (r = parseInt(r, 10));
  let n = Oe(t.style, e.style);
  n && !("" + n).match(v2) && (console.warn('Invalid font style specified: "' + n + '"'), n = void 0);
  const i = {
    family: Oe(t.family, e.family),
    lineHeight: A2(Oe(t.lineHeight, e.lineHeight), r),
    size: r,
    style: n,
    weight: Oe(t.weight, e.weight),
    string: ""
  };
  return i.string = f2(i), i;
}
function no(t, e, r, n) {
  let i = !0, o, s, a;
  for (o = 0, s = t.length; o < s; ++o)
    if (a = t[o], a !== void 0 && (e !== void 0 && typeof a == "function" && (a = a(e), i = !1), r !== void 0 && it(a) && (a = a[r % a.length], i = !1), a !== void 0))
      return n && !i && (n.cacheable = !1), a;
}
function x2(t, e, r) {
  const { min: n, max: i } = t, o = f1(e, (i - n) / 2), s = (a, l) => r && a === 0 ? 0 : a + l;
  return {
    min: s(n, -Math.abs(o)),
    max: s(i, o)
  };
}
function bn(t, e) {
  return Object.assign(Object.create(t), e);
}
function qu(t, e = [
  ""
], r, n, i = () => t[0]) {
  const o = r || t;
  typeof n > "u" && (n = C1("_fallback", t));
  const s = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: t,
    _rootScopes: o,
    _fallback: n,
    _getTarget: i,
    override: (a) => qu([
      a,
      ...t
    ], e, o, n)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, l) {
      return delete a[l], delete a._keys, delete t[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, l) {
      return E1(a, l, () => I2(l, e, t, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, l) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, l) {
      return Md(a).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return Md(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, l, c) {
      const u = a._storage || (a._storage = i());
      return a[l] = u[l] = c, delete a._keys, !0;
    }
  });
}
function Si(t, e, r, n) {
  const i = {
    _cacheable: !1,
    _proxy: t,
    _context: e,
    _subProxy: r,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: S1(t, n),
    setContext: (o) => Si(t, o, r, n),
    override: (o) => Si(t.override(o), e, r, n)
  };
  return new Proxy(i, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, s) {
      return delete o[s], delete t[s], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, s, a) {
      return E1(o, s, () => S2(o, s, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, s) {
      return o._descriptors.allKeys ? Reflect.has(t, s) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(t, s);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t);
    },
    /**
    * A trap for the in operator.
    */
    has(o, s) {
      return Reflect.has(t, s);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(t);
    },
    /**
    * A trap for setting property values.
    */
    set(o, s, a) {
      return t[s] = a, delete o[s], !0;
    }
  });
}
function S1(t, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: r = e.scriptable, _indexable: n = e.indexable, _allKeys: i = e.allKeys } = t;
  return {
    allKeys: i,
    scriptable: r,
    indexable: n,
    isScriptable: pn(r) ? r : () => r,
    isIndexable: pn(n) ? n : () => n
  };
}
const _2 = (t, e) => t ? t + Fu(e) : e, Hu = (t, e) => Be(e) && t !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function E1(t, e, r) {
  if (Object.prototype.hasOwnProperty.call(t, e))
    return t[e];
  const n = r();
  return t[e] = n, n;
}
function S2(t, e, r) {
  const { _proxy: n, _context: i, _subProxy: o, _descriptors: s } = t;
  let a = n[e];
  return pn(a) && s.isScriptable(e) && (a = E2(e, a, t, r)), it(a) && a.length && (a = k2(e, a, t, s.isIndexable)), Hu(e, a) && (a = Si(a, i, o && o[e], s)), a;
}
function E2(t, e, r, n) {
  const { _proxy: i, _context: o, _subProxy: s, _stack: a } = r;
  if (a.has(t))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + t);
  a.add(t);
  let l = e(o, s || n);
  return a.delete(t), Hu(t, l) && (l = Yu(i._scopes, i, t, l)), l;
}
function k2(t, e, r, n) {
  const { _proxy: i, _context: o, _subProxy: s, _descriptors: a } = r;
  if (typeof o.index < "u" && n(t))
    return e[o.index % e.length];
  if (Be(e[0])) {
    const l = e, c = i._scopes.filter((u) => u !== l);
    e = [];
    for (const u of l) {
      const f = Yu(c, i, t, u);
      e.push(Si(f, o, s && s[t], a));
    }
  }
  return e;
}
function k1(t, e, r) {
  return pn(t) ? t(e, r) : t;
}
const C2 = (t, e) => t === !0 ? e : typeof t == "string" ? hn(e, t) : void 0;
function T2(t, e, r, n, i) {
  for (const o of e) {
    const s = C2(r, o);
    if (s) {
      t.add(s);
      const a = k1(s._fallback, r, i);
      if (typeof a < "u" && a !== r && a !== n)
        return a;
    } else if (s === !1 && typeof n < "u" && r !== n)
      return null;
  }
  return !1;
}
function Yu(t, e, r, n) {
  const i = e._rootScopes, o = k1(e._fallback, r, n), s = [
    ...t,
    ...i
  ], a = /* @__PURE__ */ new Set();
  a.add(n);
  let l = Dd(a, s, r, o || r, n);
  return l === null || typeof o < "u" && o !== r && (l = Dd(a, s, o, l, n), l === null) ? !1 : qu(Array.from(a), [
    ""
  ], i, o, () => O2(e, r, n));
}
function Dd(t, e, r, n, i) {
  for (; r; )
    r = T2(t, e, r, n, i);
  return r;
}
function O2(t, e, r) {
  const n = t._getTarget();
  e in n || (n[e] = {});
  const i = n[e];
  return it(i) && Be(r) ? r : i || {};
}
function I2(t, e, r, n) {
  let i;
  for (const o of e)
    if (i = C1(_2(o, t), r), typeof i < "u")
      return Hu(t, i) ? Yu(r, n, t, i) : i;
}
function C1(t, e) {
  for (const r of e) {
    if (!r)
      continue;
    const n = r[t];
    if (typeof n < "u")
      return n;
  }
}
function Md(t) {
  let e = t._keys;
  return e || (e = t._keys = P2(t._scopes)), e;
}
function P2(t) {
  const e = /* @__PURE__ */ new Set();
  for (const r of t)
    for (const n of Object.keys(r).filter((i) => !i.startsWith("_")))
      e.add(n);
  return Array.from(e);
}
function T1(t, e, r, n) {
  const { iScale: i } = t, { key: o = "r" } = this._parsing, s = new Array(n);
  let a, l, c, u;
  for (a = 0, l = n; a < l; ++a)
    c = a + r, u = e[c], s[a] = {
      r: i.parse(hn(u, o), c)
    };
  return s;
}
const R2 = Number.EPSILON || 1e-14, Ei = (t, e) => e < t.length && !t[e].skip && t[e], O1 = (t) => t === "x" ? "y" : "x";
function D2(t, e, r, n) {
  const i = t.skip ? e : t, o = e, s = r.skip ? e : r, a = Dc(o, i), l = Dc(s, o);
  let c = a / (a + l), u = l / (a + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const f = n * c, d = n * u;
  return {
    previous: {
      x: o.x - f * (s.x - i.x),
      y: o.y - f * (s.y - i.y)
    },
    next: {
      x: o.x + d * (s.x - i.x),
      y: o.y + d * (s.y - i.y)
    }
  };
}
function M2(t, e, r) {
  const n = t.length;
  let i, o, s, a, l, c = Ei(t, 0);
  for (let u = 0; u < n - 1; ++u)
    if (l = c, c = Ei(t, u + 1), !(!l || !c)) {
      if (mo(e[u], 0, R2)) {
        r[u] = r[u + 1] = 0;
        continue;
      }
      i = r[u] / e[u], o = r[u + 1] / e[u], a = Math.pow(i, 2) + Math.pow(o, 2), !(a <= 9) && (s = 3 / Math.sqrt(a), r[u] = i * s * e[u], r[u + 1] = o * s * e[u]);
    }
}
function N2(t, e, r = "x") {
  const n = O1(r), i = t.length;
  let o, s, a, l = Ei(t, 0);
  for (let c = 0; c < i; ++c) {
    if (s = a, a = l, l = Ei(t, c + 1), !a)
      continue;
    const u = a[r], f = a[n];
    s && (o = (u - s[r]) / 3, a[`cp1${r}`] = u - o, a[`cp1${n}`] = f - o * e[c]), l && (o = (l[r] - u) / 3, a[`cp2${r}`] = u + o, a[`cp2${n}`] = f + o * e[c]);
  }
}
function B2(t, e = "x") {
  const r = O1(e), n = t.length, i = Array(n).fill(0), o = Array(n);
  let s, a, l, c = Ei(t, 0);
  for (s = 0; s < n; ++s)
    if (a = l, l = c, c = Ei(t, s + 1), !!l) {
      if (c) {
        const u = c[e] - l[e];
        i[s] = u !== 0 ? (c[r] - l[r]) / u : 0;
      }
      o[s] = a ? c ? kr(i[s - 1]) !== kr(i[s]) ? 0 : (i[s - 1] + i[s]) / 2 : i[s - 1] : i[s];
    }
  M2(t, i, o), N2(t, o, e);
}
function ws(t, e, r) {
  return Math.max(Math.min(t, r), e);
}
function L2(t, e) {
  let r, n, i, o, s, a = Wr(t[0], e);
  for (r = 0, n = t.length; r < n; ++r)
    s = o, o = a, a = r < n - 1 && Wr(t[r + 1], e), o && (i = t[r], s && (i.cp1x = ws(i.cp1x, e.left, e.right), i.cp1y = ws(i.cp1y, e.top, e.bottom)), a && (i.cp2x = ws(i.cp2x, e.left, e.right), i.cp2y = ws(i.cp2y, e.top, e.bottom)));
}
function F2(t, e, r, n, i) {
  let o, s, a, l;
  if (e.spanGaps && (t = t.filter((c) => !c.skip)), e.cubicInterpolationMode === "monotone")
    B2(t, i);
  else {
    let c = n ? t[t.length - 1] : t[0];
    for (o = 0, s = t.length; o < s; ++o)
      a = t[o], l = D2(c, a, t[Math.min(o + 1, s - (n ? 0 : 1)) % s], e.tension), a.cp1x = l.previous.x, a.cp1y = l.previous.y, a.cp2x = l.next.x, a.cp2y = l.next.y, c = a;
  }
  e.capBezierPoints && L2(t, r);
}
function I1() {
  return typeof window < "u" && typeof document < "u";
}
function Ku(t) {
  let e = t.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function va(t, e, r) {
  let n;
  return typeof t == "string" ? (n = parseInt(t, 10), t.indexOf("%") !== -1 && (n = n / 100 * e.parentNode[r])) : n = t, n;
}
const Ja = (t) => t.ownerDocument.defaultView.getComputedStyle(t, null);
function j2(t, e) {
  return Ja(t).getPropertyValue(e);
}
const W2 = [
  "top",
  "right",
  "bottom",
  "left"
];
function Fn(t, e, r) {
  const n = {};
  r = r ? "-" + r : "";
  for (let i = 0; i < 4; i++) {
    const o = W2[i];
    n[o] = parseFloat(t[e + "-" + o + r]) || 0;
  }
  return n.width = n.left + n.right, n.height = n.top + n.bottom, n;
}
const U2 = (t, e, r) => (t > 0 || e > 0) && (!r || !r.shadowRoot);
function z2(t, e) {
  const r = t.touches, n = r && r.length ? r[0] : t, { offsetX: i, offsetY: o } = n;
  let s = !1, a, l;
  if (U2(i, o, t.target))
    a = i, l = o;
  else {
    const c = e.getBoundingClientRect();
    a = n.clientX - c.left, l = n.clientY - c.top, s = !0;
  }
  return {
    x: a,
    y: l,
    box: s
  };
}
function In(t, e) {
  if ("native" in t)
    return t;
  const { canvas: r, currentDevicePixelRatio: n } = e, i = Ja(r), o = i.boxSizing === "border-box", s = Fn(i, "padding"), a = Fn(i, "border", "width"), { x: l, y: c, box: u } = z2(t, r), f = s.left + (u && a.left), d = s.top + (u && a.top);
  let { width: h, height: g } = e;
  return o && (h -= s.width + a.width, g -= s.height + a.height), {
    x: Math.round((l - f) / h * r.width / n),
    y: Math.round((c - d) / g * r.height / n)
  };
}
function V2(t, e, r) {
  let n, i;
  if (e === void 0 || r === void 0) {
    const o = Ku(t);
    if (!o)
      e = t.clientWidth, r = t.clientHeight;
    else {
      const s = o.getBoundingClientRect(), a = Ja(o), l = Fn(a, "border", "width"), c = Fn(a, "padding");
      e = s.width - c.width - l.width, r = s.height - c.height - l.height, n = va(a.maxWidth, o, "clientWidth"), i = va(a.maxHeight, o, "clientHeight");
    }
  }
  return {
    width: e,
    height: r,
    maxWidth: n || ya,
    maxHeight: i || ya
  };
}
const xs = (t) => Math.round(t * 10) / 10;
function q2(t, e, r, n) {
  const i = Ja(t), o = Fn(i, "margin"), s = va(i.maxWidth, t, "clientWidth") || ya, a = va(i.maxHeight, t, "clientHeight") || ya, l = V2(t, e, r);
  let { width: c, height: u } = l;
  if (i.boxSizing === "content-box") {
    const d = Fn(i, "border", "width"), h = Fn(i, "padding");
    c -= h.width + d.width, u -= h.height + d.height;
  }
  return c = Math.max(0, c - o.width), u = Math.max(0, n ? c / n : u - o.height), c = xs(Math.min(c, s, l.maxWidth)), u = xs(Math.min(u, a, l.maxHeight)), c && !u && (u = xs(c / 2)), (e !== void 0 || r !== void 0) && n && l.height && u > l.height && (u = l.height, c = xs(Math.floor(u * n))), {
    width: c,
    height: u
  };
}
function Nd(t, e, r) {
  const n = e || 1, i = Math.floor(t.height * n), o = Math.floor(t.width * n);
  t.height = Math.floor(t.height), t.width = Math.floor(t.width);
  const s = t.canvas;
  return s.style && (r || !s.style.height && !s.style.width) && (s.style.height = `${t.height}px`, s.style.width = `${t.width}px`), t.currentDevicePixelRatio !== n || s.height !== i || s.width !== o ? (t.currentDevicePixelRatio = n, s.height = i, s.width = o, t.ctx.setTransform(n, 0, 0, n, 0, 0), !0) : !1;
}
const H2 = function() {
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    };
    window.addEventListener("test", null, e), window.removeEventListener("test", null, e);
  } catch {
  }
  return t;
}();
function Bd(t, e) {
  const r = j2(t, e), n = r && r.match(/^(\d+)(\.\d+)?px$/);
  return n ? +n[1] : void 0;
}
function Pn(t, e, r, n) {
  return {
    x: t.x + r * (e.x - t.x),
    y: t.y + r * (e.y - t.y)
  };
}
function Y2(t, e, r, n) {
  return {
    x: t.x + r * (e.x - t.x),
    y: n === "middle" ? r < 0.5 ? t.y : e.y : n === "after" ? r < 1 ? t.y : e.y : r > 0 ? e.y : t.y
  };
}
function K2(t, e, r, n) {
  const i = {
    x: t.cp2x,
    y: t.cp2y
  }, o = {
    x: e.cp1x,
    y: e.cp1y
  }, s = Pn(t, i, r), a = Pn(i, o, r), l = Pn(o, e, r), c = Pn(s, a, r), u = Pn(a, l, r);
  return Pn(c, u, r);
}
const X2 = function(t, e) {
  return {
    x(r) {
      return t + t + e - r;
    },
    setWidth(r) {
      e = r;
    },
    textAlign(r) {
      return r === "center" ? r : r === "right" ? "left" : "right";
    },
    xPlus(r, n) {
      return r - n;
    },
    leftForLtr(r, n) {
      return r - n;
    }
  };
}, J2 = function() {
  return {
    x(t) {
      return t;
    },
    setWidth(t) {
    },
    textAlign(t) {
      return t;
    },
    xPlus(t, e) {
      return t + e;
    },
    leftForLtr(t, e) {
      return t;
    }
  };
};
function mi(t, e, r) {
  return t ? X2(e, r) : J2();
}
function P1(t, e) {
  let r, n;
  (e === "ltr" || e === "rtl") && (r = t.canvas.style, n = [
    r.getPropertyValue("direction"),
    r.getPropertyPriority("direction")
  ], r.setProperty("direction", e, "important"), t.prevTextDirection = n);
}
function R1(t, e) {
  e !== void 0 && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]));
}
function D1(t) {
  return t === "angle" ? {
    between: Ro,
    compare: Q3,
    normalize: Yt
  } : {
    between: Fr,
    compare: (e, r) => e - r,
    normalize: (e) => e
  };
}
function Ld({ start: t, end: e, count: r, loop: n, style: i }) {
  return {
    start: t % r,
    end: e % r,
    loop: n && (e - t + 1) % r === 0,
    style: i
  };
}
function Q2(t, e, r) {
  const { property: n, start: i, end: o } = r, { between: s, normalize: a } = D1(n), l = e.length;
  let { start: c, end: u, loop: f } = t, d, h;
  if (f) {
    for (c += l, u += l, d = 0, h = l; d < h && s(a(e[c % l][n]), i, o); ++d)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: f,
    style: t.style
  };
}
function M1(t, e, r) {
  if (!r)
    return [
      t
    ];
  const { property: n, start: i, end: o } = r, s = e.length, { compare: a, between: l, normalize: c } = D1(n), { start: u, end: f, loop: d, style: h } = Q2(t, e, r), g = [];
  let p = !1, y = null, b, x, S;
  const O = () => l(i, S, b) && a(i, S) !== 0, _ = () => a(o, b) === 0 || l(o, S, b), B = () => p || O(), N = () => !p || _();
  for (let j = u, W = u; j <= f; ++j)
    x = e[j % s], !x.skip && (b = c(x[n]), b !== S && (p = l(b, i, o), y === null && B() && (y = a(b, i) === 0 ? j : W), y !== null && N() && (g.push(Ld({
      start: y,
      end: j,
      loop: d,
      count: s,
      style: h
    })), y = null), W = j, S = b));
  return y !== null && g.push(Ld({
    start: y,
    end: f,
    loop: d,
    count: s,
    style: h
  })), g;
}
function N1(t, e) {
  const r = [], n = t.segments;
  for (let i = 0; i < n.length; i++) {
    const o = M1(n[i], t.points, e);
    o.length && r.push(...o);
  }
  return r;
}
function G2(t, e, r, n) {
  let i = 0, o = e - 1;
  if (r && !n)
    for (; i < e && !t[i].skip; )
      i++;
  for (; i < e && t[i].skip; )
    i++;
  for (i %= e, r && (o += i); o > i && t[o % e].skip; )
    o--;
  return o %= e, {
    start: i,
    end: o
  };
}
function Z2(t, e, r, n) {
  const i = t.length, o = [];
  let s = e, a = t[e], l;
  for (l = e + 1; l <= r; ++l) {
    const c = t[l % i];
    c.skip || c.stop ? a.skip || (n = !1, o.push({
      start: e % i,
      end: (l - 1) % i,
      loop: n
    }), e = s = c.stop ? l : null) : (s = l, a.skip && (e = l)), a = c;
  }
  return s !== null && o.push({
    start: e % i,
    end: s % i,
    loop: n
  }), o;
}
function $2(t, e) {
  const r = t.points, n = t.options.spanGaps, i = r.length;
  if (!i)
    return [];
  const o = !!t._loop, { start: s, end: a } = G2(r, i, o, n);
  if (n === !0)
    return Fd(t, [
      {
        start: s,
        end: a,
        loop: o
      }
    ], r, e);
  const l = a < s ? a + i : a, c = !!t._fullLoop && s === 0 && a === i - 1;
  return Fd(t, Z2(r, s, l, c), r, e);
}
function Fd(t, e, r, n) {
  return !n || !n.setContext || !r ? e : ev(t, e, r, n);
}
function ev(t, e, r, n) {
  const i = t._chart.getContext(), o = jd(t.options), { _datasetIndex: s, options: { spanGaps: a } } = t, l = r.length, c = [];
  let u = o, f = e[0].start, d = f;
  function h(g, p, y, b) {
    const x = a ? -1 : 1;
    if (g !== p) {
      for (g += l; r[g % l].skip; )
        g -= x;
      for (; r[p % l].skip; )
        p += x;
      g % l !== p % l && (c.push({
        start: g % l,
        end: p % l,
        loop: y,
        style: b
      }), u = b, f = p % l);
    }
  }
  for (const g of e) {
    f = a ? f : g.start;
    let p = r[f % l], y;
    for (d = f + 1; d <= g.end; d++) {
      const b = r[d % l];
      y = jd(n.setContext(bn(i, {
        type: "segment",
        p0: p,
        p1: b,
        p0DataIndex: (d - 1) % l,
        p1DataIndex: d % l,
        datasetIndex: s
      }))), tv(y, u) && h(f, d - 1, g.loop, u), p = b, u = y;
    }
    f < d - 1 && h(f, d - 1, g.loop, u);
  }
  return c;
}
function jd(t) {
  return {
    backgroundColor: t.backgroundColor,
    borderCapStyle: t.borderCapStyle,
    borderDash: t.borderDash,
    borderDashOffset: t.borderDashOffset,
    borderJoinStyle: t.borderJoinStyle,
    borderWidth: t.borderWidth,
    borderColor: t.borderColor
  };
}
function tv(t, e) {
  if (!e)
    return !1;
  const r = [], n = function(i, o) {
    return zu(o) ? (r.includes(o) || r.push(o), r.indexOf(o)) : o;
  };
  return JSON.stringify(t, n) !== JSON.stringify(e, n);
}
/*!
 * Chart.js v4.4.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class rv {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, r, n, i) {
    const o = r.listeners[i], s = r.duration;
    o.forEach((a) => a({
      chart: e,
      initial: r.initial,
      numSteps: s,
      currentStep: Math.min(n - r.start, s)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = y1.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let r = 0;
    this._charts.forEach((n, i) => {
      if (!n.running || !n.items.length)
        return;
      const o = n.items;
      let s = o.length - 1, a = !1, l;
      for (; s >= 0; --s)
        l = o[s], l._active ? (l._total > n.duration && (n.duration = l._total), l.tick(e), a = !0) : (o[s] = o[o.length - 1], o.pop());
      a && (i.draw(), this._notify(i, n, e, "progress")), o.length || (n.running = !1, this._notify(i, n, e, "complete"), n.initial = !1), r += o.length;
    }), this._lastDate = e, r === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const r = this._charts;
    let n = r.get(e);
    return n || (n = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, r.set(e, n)), n;
  }
  listen(e, r, n) {
    this._getAnims(e).listeners[r].push(n);
  }
  add(e, r) {
    !r || !r.length || this._getAnims(e).items.push(...r);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const r = this._charts.get(e);
    r && (r.running = !0, r.start = Date.now(), r.duration = r.items.reduce((n, i) => Math.max(n, i._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const r = this._charts.get(e);
    return !(!r || !r.running || !r.items.length);
  }
  stop(e) {
    const r = this._charts.get(e);
    if (!r || !r.items.length)
      return;
    const n = r.items;
    let i = n.length - 1;
    for (; i >= 0; --i)
      n[i].cancel();
    r.items = [], this._notify(e, r, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var Rr = /* @__PURE__ */ new rv();
const Wd = "transparent", nv = {
  boolean(t, e, r) {
    return r > 0.5 ? e : t;
  },
  color(t, e, r) {
    const n = Id(t || Wd), i = n.valid && Id(e || Wd);
    return i && i.valid ? i.mix(n, r).hexString() : e;
  },
  number(t, e, r) {
    return t + (e - t) * r;
  }
};
class iv {
  constructor(e, r, n, i) {
    const o = r[n];
    i = no([
      e.to,
      i,
      o,
      e.from
    ]);
    const s = no([
      e.from,
      o,
      i
    ]);
    this._active = !0, this._fn = e.fn || nv[e.type || typeof s], this._easing = yo[e.easing] || yo.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = r, this._prop = n, this._from = s, this._to = i, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, r, n) {
    if (this._active) {
      this._notify(!1);
      const i = this._target[this._prop], o = n - this._start, s = this._duration - o;
      this._start = n, this._duration = Math.floor(Math.max(s, e.duration)), this._total += o, this._loop = !!e.loop, this._to = no([
        e.to,
        r,
        i,
        e.from
      ]), this._from = no([
        e.from,
        i,
        r
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const r = e - this._start, n = this._duration, i = this._prop, o = this._from, s = this._loop, a = this._to;
    let l;
    if (this._active = o !== a && (s || r < n), !this._active) {
      this._target[i] = a, this._notify(!0);
      return;
    }
    if (r < 0) {
      this._target[i] = o;
      return;
    }
    l = r / n % 2, l = s && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[i] = this._fn(o, a, l);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((r, n) => {
      e.push({
        res: r,
        rej: n
      });
    });
  }
  _notify(e) {
    const r = e ? "res" : "rej", n = this._promises || [];
    for (let i = 0; i < n.length; i++)
      n[i][r]();
  }
}
class B1 {
  constructor(e, r) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(r);
  }
  configure(e) {
    if (!Be(e))
      return;
    const r = Object.keys(gt.animation), n = this._properties;
    Object.getOwnPropertyNames(e).forEach((i) => {
      const o = e[i];
      if (!Be(o))
        return;
      const s = {};
      for (const a of r)
        s[a] = o[a];
      (it(o.properties) && o.properties || [
        i
      ]).forEach((a) => {
        (a === i || !n.has(a)) && n.set(a, s);
      });
    });
  }
  _animateOptions(e, r) {
    const n = r.options, i = sv(e, n);
    if (!i)
      return [];
    const o = this._createAnimations(i, n);
    return n.$shared && ov(e.options.$animations, n).then(() => {
      e.options = n;
    }, () => {
    }), o;
  }
  _createAnimations(e, r) {
    const n = this._properties, i = [], o = e.$animations || (e.$animations = {}), s = Object.keys(r), a = Date.now();
    let l;
    for (l = s.length - 1; l >= 0; --l) {
      const c = s[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        i.push(...this._animateOptions(e, r));
        continue;
      }
      const u = r[c];
      let f = o[c];
      const d = n.get(c);
      if (f)
        if (d && f.active()) {
          f.update(d, u, a);
          continue;
        } else
          f.cancel();
      if (!d || !d.duration) {
        e[c] = u;
        continue;
      }
      o[c] = f = new iv(d, e, c, u), i.push(f);
    }
    return i;
  }
  update(e, r) {
    if (this._properties.size === 0) {
      Object.assign(e, r);
      return;
    }
    const n = this._createAnimations(e, r);
    if (n.length)
      return Rr.add(this._chart, n), !0;
  }
}
function ov(t, e) {
  const r = [], n = Object.keys(e);
  for (let i = 0; i < n.length; i++) {
    const o = t[n[i]];
    o && o.active() && r.push(o.wait());
  }
  return Promise.all(r);
}
function sv(t, e) {
  if (!e)
    return;
  let r = t.options;
  if (!r) {
    t.options = e;
    return;
  }
  return r.$shared && (t.options = r = Object.assign({}, r, {
    $shared: !1,
    $animations: {}
  })), r;
}
function Ud(t, e) {
  const r = t && t.options || {}, n = r.reverse, i = r.min === void 0 ? e : 0, o = r.max === void 0 ? e : 0;
  return {
    start: n ? o : i,
    end: n ? i : o
  };
}
function av(t, e, r) {
  if (r === !1)
    return !1;
  const n = Ud(t, r), i = Ud(e, r);
  return {
    top: i.end,
    right: n.end,
    bottom: i.start,
    left: n.start
  };
}
function lv(t) {
  let e, r, n, i;
  return Be(t) ? (e = t.top, r = t.right, n = t.bottom, i = t.left) : e = r = n = i = t, {
    top: e,
    right: r,
    bottom: n,
    left: i,
    disabled: t === !1
  };
}
function L1(t, e) {
  const r = [], n = t._getSortedDatasetMetas(e);
  let i, o;
  for (i = 0, o = n.length; i < o; ++i)
    r.push(n[i].index);
  return r;
}
function zd(t, e, r, n = {}) {
  const i = t.keys, o = n.mode === "single";
  let s, a, l, c;
  if (e !== null) {
    for (s = 0, a = i.length; s < a; ++s) {
      if (l = +i[s], l === r) {
        if (n.all)
          continue;
        break;
      }
      c = t.values[l], pt(c) && (o || e === 0 || kr(e) === kr(c)) && (e += c);
    }
    return e;
  }
}
function cv(t) {
  const e = Object.keys(t), r = new Array(e.length);
  let n, i, o;
  for (n = 0, i = e.length; n < i; ++n)
    o = e[n], r[n] = {
      x: o,
      y: t[o]
    };
  return r;
}
function Vd(t, e) {
  const r = t && t.options.stacked;
  return r || r === void 0 && e.stack !== void 0;
}
function uv(t, e, r) {
  return `${t.id}.${e.id}.${r.stack || r.type}`;
}
function fv(t) {
  const { min: e, max: r, minDefined: n, maxDefined: i } = t.getUserBounds();
  return {
    min: n ? e : Number.NEGATIVE_INFINITY,
    max: i ? r : Number.POSITIVE_INFINITY
  };
}
function dv(t, e, r) {
  const n = t[e] || (t[e] = {});
  return n[r] || (n[r] = {});
}
function qd(t, e, r, n) {
  for (const i of e.getMatchingVisibleMetas(n).reverse()) {
    const o = t[i.index];
    if (r && o > 0 || !r && o < 0)
      return i.index;
  }
  return null;
}
function Hd(t, e) {
  const { chart: r, _cachedMeta: n } = t, i = r._stacks || (r._stacks = {}), { iScale: o, vScale: s, index: a } = n, l = o.axis, c = s.axis, u = uv(o, s, n), f = e.length;
  let d;
  for (let h = 0; h < f; ++h) {
    const g = e[h], { [l]: p, [c]: y } = g, b = g._stacks || (g._stacks = {});
    d = b[c] = dv(i, u, p), d[a] = y, d._top = qd(d, s, !0, n.type), d._bottom = qd(d, s, !1, n.type);
    const x = d._visualValues || (d._visualValues = {});
    x[a] = y;
  }
}
function Yl(t, e) {
  const r = t.scales;
  return Object.keys(r).filter((n) => r[n].axis === e).shift();
}
function hv(t, e) {
  return bn(t, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function pv(t, e, r) {
  return bn(t, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: r,
    index: e,
    mode: "default",
    type: "data"
  });
}
function Vi(t, e) {
  const r = t.controller.index, n = t.vScale && t.vScale.axis;
  if (n) {
    e = e || t._parsed;
    for (const i of e) {
      const o = i._stacks;
      if (!o || o[n] === void 0 || o[n][r] === void 0)
        return;
      delete o[n][r], o[n]._visualValues !== void 0 && o[n]._visualValues[r] !== void 0 && delete o[n]._visualValues[r];
    }
  }
}
const Kl = (t) => t === "reset" || t === "none", Yd = (t, e) => e ? t : Object.assign({}, t), gv = (t, e, r) => t && !e.hidden && e._stacked && {
  keys: L1(r, !0),
  values: null
};
class gr {
  constructor(e, r) {
    this.chart = e, this._ctx = e.ctx, this.index = r, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = Vd(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && Vi(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, r = this._cachedMeta, n = this.getDataset(), i = (f, d, h, g) => f === "x" ? d : f === "r" ? g : h, o = r.xAxisID = Oe(n.xAxisID, Yl(e, "x")), s = r.yAxisID = Oe(n.yAxisID, Yl(e, "y")), a = r.rAxisID = Oe(n.rAxisID, Yl(e, "r")), l = r.indexAxis, c = r.iAxisID = i(l, o, s, a), u = r.vAxisID = i(l, s, o, a);
    r.xScale = this.getScaleForId(o), r.yScale = this.getScaleForId(s), r.rScale = this.getScaleForId(a), r.iScale = this.getScaleForId(c), r.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const r = this._cachedMeta;
    return e === r.iScale ? r.vScale : r.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && Cd(this._data, this), e._stacked && Vi(e);
  }
  _dataCheck() {
    const e = this.getDataset(), r = e.data || (e.data = []), n = this._data;
    if (Be(r))
      this._data = cv(r);
    else if (n !== r) {
      if (n) {
        Cd(n, this);
        const i = this._cachedMeta;
        Vi(i), i._parsed = [];
      }
      r && Object.isExtensible(r) && e2(r, this), this._syncList = [], this._data = r;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const r = this._cachedMeta, n = this.getDataset();
    let i = !1;
    this._dataCheck();
    const o = r._stacked;
    r._stacked = Vd(r.vScale, r), r.stack !== n.stack && (i = !0, Vi(r), r.stack = n.stack), this._resyncElements(e), (i || o !== r._stacked) && Hd(this, r._parsed);
  }
  configure() {
    const e = this.chart.config, r = e.datasetScopeKeys(this._type), n = e.getOptionScopes(this.getDataset(), r, !0);
    this.options = e.createResolver(n, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, r) {
    const { _cachedMeta: n, _data: i } = this, { iScale: o, _stacked: s } = n, a = o.axis;
    let l = e === 0 && r === i.length ? !0 : n._sorted, c = e > 0 && n._parsed[e - 1], u, f, d;
    if (this._parsing === !1)
      n._parsed = i, n._sorted = !0, d = i;
    else {
      it(i[e]) ? d = this.parseArrayData(n, i, e, r) : Be(i[e]) ? d = this.parseObjectData(n, i, e, r) : d = this.parsePrimitiveData(n, i, e, r);
      const h = () => f[a] === null || c && f[a] < c[a];
      for (u = 0; u < r; ++u)
        n._parsed[u + e] = f = d[u], l && (h() && (l = !1), c = f);
      n._sorted = l;
    }
    s && Hd(this, d);
  }
  parsePrimitiveData(e, r, n, i) {
    const { iScale: o, vScale: s } = e, a = o.axis, l = s.axis, c = o.getLabels(), u = o === s, f = new Array(i);
    let d, h, g;
    for (d = 0, h = i; d < h; ++d)
      g = d + n, f[d] = {
        [a]: u || o.parse(c[g], g),
        [l]: s.parse(r[g], g)
      };
    return f;
  }
  parseArrayData(e, r, n, i) {
    const { xScale: o, yScale: s } = e, a = new Array(i);
    let l, c, u, f;
    for (l = 0, c = i; l < c; ++l)
      u = l + n, f = r[u], a[l] = {
        x: o.parse(f[0], u),
        y: s.parse(f[1], u)
      };
    return a;
  }
  parseObjectData(e, r, n, i) {
    const { xScale: o, yScale: s } = e, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(i);
    let u, f, d, h;
    for (u = 0, f = i; u < f; ++u)
      d = u + n, h = r[d], c[u] = {
        x: o.parse(hn(h, a), d),
        y: s.parse(hn(h, l), d)
      };
    return c;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, r, n) {
    const i = this.chart, o = this._cachedMeta, s = r[e.axis], a = {
      keys: L1(i, !0),
      values: r._stacks[e.axis]._visualValues
    };
    return zd(a, s, o.index, {
      mode: n
    });
  }
  updateRangeFromParsed(e, r, n, i) {
    const o = n[r.axis];
    let s = o === null ? NaN : o;
    const a = i && n._stacks[r.axis];
    i && a && (i.values = a, s = zd(i, o, this._cachedMeta.index)), e.min = Math.min(e.min, s), e.max = Math.max(e.max, s);
  }
  getMinMax(e, r) {
    const n = this._cachedMeta, i = n._parsed, o = n._sorted && e === n.iScale, s = i.length, a = this._getOtherScale(e), l = gv(r, n, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: f } = fv(a);
    let d, h;
    function g() {
      h = i[d];
      const p = h[a.axis];
      return !pt(h[e.axis]) || u > p || f < p;
    }
    for (d = 0; d < s && !(!g() && (this.updateRangeFromParsed(c, e, h, l), o)); ++d)
      ;
    if (o) {
      for (d = s - 1; d >= 0; --d)
        if (!g()) {
          this.updateRangeFromParsed(c, e, h, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(e) {
    const r = this._cachedMeta._parsed, n = [];
    let i, o, s;
    for (i = 0, o = r.length; i < o; ++i)
      s = r[i][e.axis], pt(s) && n.push(s);
    return n;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const r = this._cachedMeta, n = r.iScale, i = r.vScale, o = this.getParsed(e);
    return {
      label: n ? "" + n.getLabelForValue(o[n.axis]) : "",
      value: i ? "" + i.getLabelForValue(o[i.axis]) : ""
    };
  }
  _update(e) {
    const r = this._cachedMeta;
    this.update(e || "default"), r._clip = lv(Oe(this.options.clip, av(r.xScale, r.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, r = this.chart, n = this._cachedMeta, i = n.data || [], o = r.chartArea, s = [], a = this._drawStart || 0, l = this._drawCount || i.length - a, c = this.options.drawActiveElementsOnTop;
    let u;
    for (n.dataset && n.dataset.draw(e, o, a, l), u = a; u < a + l; ++u) {
      const f = i[u];
      f.hidden || (f.active && c ? s.push(f) : f.draw(e, o));
    }
    for (u = 0; u < s.length; ++u)
      s[u].draw(e, o);
  }
  getStyle(e, r) {
    const n = r ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(n) : this.resolveDataElementOptions(e || 0, n);
  }
  getContext(e, r, n) {
    const i = this.getDataset();
    let o;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const s = this._cachedMeta.data[e];
      o = s.$context || (s.$context = pv(this.getContext(), e, s)), o.parsed = this.getParsed(e), o.raw = i.data[e], o.index = o.dataIndex = e;
    } else
      o = this.$context || (this.$context = hv(this.chart.getContext(), this.index)), o.dataset = i, o.index = o.datasetIndex = this.index;
    return o.active = !!r, o.mode = n, o;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, r) {
    return this._resolveElementOptions(this.dataElementType.id, r, e);
  }
  _resolveElementOptions(e, r = "default", n) {
    const i = r === "active", o = this._cachedDataOpts, s = e + "-" + r, a = o[s], l = this.enableOptionSharing && Po(n);
    if (a)
      return Yd(a, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, e), f = i ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], d = c.getOptionScopes(this.getDataset(), u), h = Object.keys(gt.elements[e]), g = () => this.getContext(n, i, r), p = c.resolveNamedOptions(d, h, g, f);
    return p.$shared && (p.$shared = l, o[s] = Object.freeze(Yd(p, l))), p;
  }
  _resolveAnimations(e, r, n) {
    const i = this.chart, o = this._cachedDataOpts, s = `animation-${r}`, a = o[s];
    if (a)
      return a;
    let l;
    if (i.options.animation !== !1) {
      const u = this.chart.config, f = u.datasetAnimationScopeKeys(this._type, r), d = u.getOptionScopes(this.getDataset(), f);
      l = u.createResolver(d, this.getContext(e, n, r));
    }
    const c = new B1(i, l && l.animations);
    return l && l._cacheable && (o[s] = Object.freeze(c)), c;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, r) {
    return !r || Kl(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, r) {
    const n = this.resolveDataElementOptions(e, r), i = this._sharedOptions, o = this.getSharedOptions(n), s = this.includeOptions(r, o) || o !== i;
    return this.updateSharedOptions(o, r, n), {
      sharedOptions: o,
      includeOptions: s
    };
  }
  updateElement(e, r, n, i) {
    Kl(i) ? Object.assign(e, n) : this._resolveAnimations(r, i).update(e, n);
  }
  updateSharedOptions(e, r, n) {
    e && !Kl(r) && this._resolveAnimations(void 0, r).update(e, n);
  }
  _setStyle(e, r, n, i) {
    e.active = i;
    const o = this.getStyle(r, i);
    this._resolveAnimations(r, n, i).update(e, {
      options: !i && this.getSharedOptions(o) || o
    });
  }
  removeHoverStyle(e, r, n) {
    this._setStyle(e, n, "active", !1);
  }
  setHoverStyle(e, r, n) {
    this._setStyle(e, n, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const r = this._data, n = this._cachedMeta.data;
    for (const [a, l, c] of this._syncList)
      this[a](l, c);
    this._syncList = [];
    const i = n.length, o = r.length, s = Math.min(o, i);
    s && this.parse(0, s), o > i ? this._insertElements(i, o - i, e) : o < i && this._removeElements(o, i - o);
  }
  _insertElements(e, r, n = !0) {
    const i = this._cachedMeta, o = i.data, s = e + r;
    let a;
    const l = (c) => {
      for (c.length += r, a = c.length - 1; a >= s; a--)
        c[a] = c[a - r];
    };
    for (l(o), a = e; a < s; ++a)
      o[a] = new this.dataElementType();
    this._parsing && l(i._parsed), this.parse(e, r), n && this.updateElements(o, e, r, "reset");
  }
  updateElements(e, r, n, i) {
  }
  _removeElements(e, r) {
    const n = this._cachedMeta;
    if (this._parsing) {
      const i = n._parsed.splice(e, r);
      n._stacked && Vi(n, i);
    }
    n.data.splice(e, r);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [r, n, i] = e;
      this[r](n, i);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, r) {
    r && this._sync([
      "_removeElements",
      e,
      r
    ]);
    const n = arguments.length - 2;
    n && this._sync([
      "_insertElements",
      e,
      n
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
ye(gr, "defaults", {}), ye(gr, "datasetElementType", null), ye(gr, "dataElementType", null);
function mv(t, e) {
  if (!t._cache.$bar) {
    const r = t.getMatchingVisibleMetas(e);
    let n = [];
    for (let i = 0, o = r.length; i < o; i++)
      n = n.concat(r[i].controller.getAllParsedValues(t));
    t._cache.$bar = m1(n.sort((i, o) => i - o));
  }
  return t._cache.$bar;
}
function yv(t) {
  const e = t.iScale, r = mv(e, t.type);
  let n = e._length, i, o, s, a;
  const l = () => {
    s === 32767 || s === -32768 || (Po(a) && (n = Math.min(n, Math.abs(s - a) || n)), a = s);
  };
  for (i = 0, o = r.length; i < o; ++i)
    s = e.getPixelForValue(r[i]), l();
  for (a = void 0, i = 0, o = e.ticks.length; i < o; ++i)
    s = e.getPixelForTick(i), l();
  return n;
}
function bv(t, e, r, n) {
  const i = r.barThickness;
  let o, s;
  return We(i) ? (o = e.min * r.categoryPercentage, s = r.barPercentage) : (o = i * n, s = 1), {
    chunk: o / n,
    ratio: s,
    start: e.pixels[t] - o / 2
  };
}
function vv(t, e, r, n) {
  const i = e.pixels, o = i[t];
  let s = t > 0 ? i[t - 1] : null, a = t < i.length - 1 ? i[t + 1] : null;
  const l = r.categoryPercentage;
  s === null && (s = o - (a === null ? e.end - e.start : a - o)), a === null && (a = o + o - s);
  const c = o - (o - Math.min(s, a)) / 2 * l;
  return {
    chunk: Math.abs(a - s) / 2 * l / n,
    ratio: r.barPercentage,
    start: c
  };
}
function Av(t, e, r, n) {
  const i = r.parse(t[0], n), o = r.parse(t[1], n), s = Math.min(i, o), a = Math.max(i, o);
  let l = s, c = a;
  Math.abs(s) > Math.abs(a) && (l = a, c = s), e[r.axis] = c, e._custom = {
    barStart: l,
    barEnd: c,
    start: i,
    end: o,
    min: s,
    max: a
  };
}
function F1(t, e, r, n) {
  return it(t) ? Av(t, e, r, n) : e[r.axis] = r.parse(t, n), e;
}
function Kd(t, e, r, n) {
  const i = t.iScale, o = t.vScale, s = i.getLabels(), a = i === o, l = [];
  let c, u, f, d;
  for (c = r, u = r + n; c < u; ++c)
    d = e[c], f = {}, f[i.axis] = a || i.parse(s[c], c), l.push(F1(d, f, o, c));
  return l;
}
function Xl(t) {
  return t && t.barStart !== void 0 && t.barEnd !== void 0;
}
function wv(t, e, r) {
  return t !== 0 ? kr(t) : (e.isHorizontal() ? 1 : -1) * (e.min >= r ? 1 : -1);
}
function xv(t) {
  let e, r, n, i, o;
  return t.horizontal ? (e = t.base > t.x, r = "left", n = "right") : (e = t.base < t.y, r = "bottom", n = "top"), e ? (i = "end", o = "start") : (i = "start", o = "end"), {
    start: r,
    end: n,
    reverse: e,
    top: i,
    bottom: o
  };
}
function _v(t, e, r, n) {
  let i = e.borderSkipped;
  const o = {};
  if (!i) {
    t.borderSkipped = o;
    return;
  }
  if (i === !0) {
    t.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: s, end: a, reverse: l, top: c, bottom: u } = xv(t);
  i === "middle" && r && (t.enableBorderRadius = !0, (r._top || 0) === n ? i = c : (r._bottom || 0) === n ? i = u : (o[Xd(u, s, a, l)] = !0, i = c)), o[Xd(i, s, a, l)] = !0, t.borderSkipped = o;
}
function Xd(t, e, r, n) {
  return n ? (t = Sv(t, e, r), t = Jd(t, r, e)) : t = Jd(t, e, r), t;
}
function Sv(t, e, r) {
  return t === e ? r : t === r ? e : t;
}
function Jd(t, e, r) {
  return t === "start" ? e : t === "end" ? r : t;
}
function Ev(t, { inflateAmount: e }, r) {
  t.inflateAmount = e === "auto" ? r === 1 ? 0.33 : 0 : e;
}
class Vs extends gr {
  parsePrimitiveData(e, r, n, i) {
    return Kd(e, r, n, i);
  }
  parseArrayData(e, r, n, i) {
    return Kd(e, r, n, i);
  }
  parseObjectData(e, r, n, i) {
    const { iScale: o, vScale: s } = e, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = o.axis === "x" ? a : l, u = s.axis === "x" ? a : l, f = [];
    let d, h, g, p;
    for (d = n, h = n + i; d < h; ++d)
      p = r[d], g = {}, g[o.axis] = o.parse(hn(p, c), d), f.push(F1(hn(p, u), g, s, d));
    return f;
  }
  updateRangeFromParsed(e, r, n, i) {
    super.updateRangeFromParsed(e, r, n, i);
    const o = n._custom;
    o && r === this._cachedMeta.vScale && (e.min = Math.min(e.min, o.min), e.max = Math.max(e.max, o.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(e) {
    const r = this._cachedMeta, { iScale: n, vScale: i } = r, o = this.getParsed(e), s = o._custom, a = Xl(s) ? "[" + s.start + ", " + s.end + "]" : "" + i.getLabelForValue(o[i.axis]);
    return {
      label: "" + n.getLabelForValue(o[n.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const e = this._cachedMeta;
    e.stack = this.getDataset().stack;
  }
  update(e) {
    const r = this._cachedMeta;
    this.updateElements(r.data, 0, r.data.length, e);
  }
  updateElements(e, r, n, i) {
    const o = i === "reset", { index: s, _cachedMeta: { vScale: a } } = this, l = a.getBasePixel(), c = a.isHorizontal(), u = this._getRuler(), { sharedOptions: f, includeOptions: d } = this._getSharedOptions(r, i);
    for (let h = r; h < r + n; h++) {
      const g = this.getParsed(h), p = o || We(g[a.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), y = this._calculateBarIndexPixels(h, u), b = (g._stacks || {})[a.axis], x = {
        horizontal: c,
        base: p.base,
        enableBorderRadius: !b || Xl(g._custom) || s === b._top || s === b._bottom,
        x: c ? p.head : y.center,
        y: c ? y.center : p.head,
        height: c ? y.size : Math.abs(p.size),
        width: c ? Math.abs(p.size) : y.size
      };
      d && (x.options = f || this.resolveDataElementOptions(h, e[h].active ? "active" : i));
      const S = x.options || e[h].options;
      _v(x, S, b, s), Ev(x, S, u.ratio), this.updateElement(e[h], h, x, i);
    }
  }
  _getStacks(e, r) {
    const { iScale: n } = this._cachedMeta, i = n.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), o = n.options.stacked, s = [], a = (l) => {
      const c = l.controller.getParsed(r), u = c && c[l.vScale.axis];
      if (We(u) || isNaN(u))
        return !0;
    };
    for (const l of i)
      if (!(r !== void 0 && a(l)) && ((o === !1 || s.indexOf(l.stack) === -1 || o === void 0 && l.stack === void 0) && s.push(l.stack), l.index === e))
        break;
    return s.length || s.push(void 0), s;
  }
  _getStackCount(e) {
    return this._getStacks(void 0, e).length;
  }
  _getStackIndex(e, r, n) {
    const i = this._getStacks(e, n), o = r !== void 0 ? i.indexOf(r) : -1;
    return o === -1 ? i.length - 1 : o;
  }
  _getRuler() {
    const e = this.options, r = this._cachedMeta, n = r.iScale, i = [];
    let o, s;
    for (o = 0, s = r.data.length; o < s; ++o)
      i.push(n.getPixelForValue(this.getParsed(o)[n.axis], o));
    const a = e.barThickness;
    return {
      min: a || yv(r),
      pixels: i,
      start: n._startPixel,
      end: n._endPixel,
      stackCount: this._getStackCount(),
      scale: n,
      grouped: e.grouped,
      ratio: a ? 1 : e.categoryPercentage * e.barPercentage
    };
  }
  _calculateBarValuePixels(e) {
    const { _cachedMeta: { vScale: r, _stacked: n, index: i }, options: { base: o, minBarLength: s } } = this, a = o || 0, l = this.getParsed(e), c = l._custom, u = Xl(c);
    let f = l[r.axis], d = 0, h = n ? this.applyStack(r, l, n) : f, g, p;
    h !== f && (d = h - f, h = f), u && (f = c.barStart, h = c.barEnd - c.barStart, f !== 0 && kr(f) !== kr(c.barEnd) && (d = 0), d += f);
    const y = !We(o) && !u ? o : d;
    let b = r.getPixelForValue(y);
    if (this.chart.getDataVisibility(e) ? g = r.getPixelForValue(d + h) : g = b, p = g - b, Math.abs(p) < s) {
      p = wv(p, r, a) * s, f === a && (b -= p / 2);
      const x = r.getPixelForDecimal(0), S = r.getPixelForDecimal(1), O = Math.min(x, S), _ = Math.max(x, S);
      b = Math.max(Math.min(b, _), O), g = b + p, n && !u && (l._stacks[r.axis]._visualValues[i] = r.getValueForPixel(g) - r.getValueForPixel(b));
    }
    if (b === r.getPixelForValue(a)) {
      const x = kr(p) * r.getLineWidthForValue(a) / 2;
      b += x, p -= x;
    }
    return {
      size: p,
      base: b,
      head: g,
      center: g + p / 2
    };
  }
  _calculateBarIndexPixels(e, r) {
    const n = r.scale, i = this.options, o = i.skipNull, s = Oe(i.maxBarThickness, 1 / 0);
    let a, l;
    if (r.grouped) {
      const c = o ? this._getStackCount(e) : r.stackCount, u = i.barThickness === "flex" ? vv(e, r, i, c) : bv(e, r, i, c), f = this._getStackIndex(this.index, this._cachedMeta.stack, o ? e : void 0);
      a = u.start + u.chunk * f + u.chunk / 2, l = Math.min(s, u.chunk * u.ratio);
    } else
      a = n.getPixelForValue(this.getParsed(e)[n.axis], e), l = Math.min(s, r.min * r.ratio);
    return {
      base: a - l / 2,
      head: a + l / 2,
      center: a,
      size: l
    };
  }
  draw() {
    const e = this._cachedMeta, r = e.vScale, n = e.data, i = n.length;
    let o = 0;
    for (; o < i; ++o)
      this.getParsed(o)[r.axis] !== null && n[o].draw(this._ctx);
  }
}
ye(Vs, "id", "bar"), ye(Vs, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), ye(Vs, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class qs extends gr {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(e, r, n, i) {
    const o = super.parsePrimitiveData(e, r, n, i);
    for (let s = 0; s < o.length; s++)
      o[s]._custom = this.resolveDataElementOptions(s + n).radius;
    return o;
  }
  parseArrayData(e, r, n, i) {
    const o = super.parseArrayData(e, r, n, i);
    for (let s = 0; s < o.length; s++) {
      const a = r[n + s];
      o[s]._custom = Oe(a[2], this.resolveDataElementOptions(s + n).radius);
    }
    return o;
  }
  parseObjectData(e, r, n, i) {
    const o = super.parseObjectData(e, r, n, i);
    for (let s = 0; s < o.length; s++) {
      const a = r[n + s];
      o[s]._custom = Oe(a && a.r && +a.r, this.resolveDataElementOptions(s + n).radius);
    }
    return o;
  }
  getMaxOverflow() {
    const e = this._cachedMeta.data;
    let r = 0;
    for (let n = e.length - 1; n >= 0; --n)
      r = Math.max(r, e[n].size(this.resolveDataElementOptions(n)) / 2);
    return r > 0 && r;
  }
  getLabelAndValue(e) {
    const r = this._cachedMeta, n = this.chart.data.labels || [], { xScale: i, yScale: o } = r, s = this.getParsed(e), a = i.getLabelForValue(s.x), l = o.getLabelForValue(s.y), c = s._custom;
    return {
      label: n[e] || "",
      value: "(" + a + ", " + l + (c ? ", " + c : "") + ")"
    };
  }
  update(e) {
    const r = this._cachedMeta.data;
    this.updateElements(r, 0, r.length, e);
  }
  updateElements(e, r, n, i) {
    const o = i === "reset", { iScale: s, vScale: a } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(r, i), u = s.axis, f = a.axis;
    for (let d = r; d < r + n; d++) {
      const h = e[d], g = !o && this.getParsed(d), p = {}, y = p[u] = o ? s.getPixelForDecimal(0.5) : s.getPixelForValue(g[u]), b = p[f] = o ? a.getBasePixel() : a.getPixelForValue(g[f]);
      p.skip = isNaN(y) || isNaN(b), c && (p.options = l || this.resolveDataElementOptions(d, h.active ? "active" : i), o && (p.options.radius = 0)), this.updateElement(h, d, p, i);
    }
  }
  resolveDataElementOptions(e, r) {
    const n = this.getParsed(e);
    let i = super.resolveDataElementOptions(e, r);
    i.$shared && (i = Object.assign({}, i, {
      $shared: !1
    }));
    const o = i.radius;
    return r !== "active" && (i.radius = 0), i.radius += Oe(n && n._custom, o), i;
  }
}
ye(qs, "id", "bubble"), ye(qs, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), ye(qs, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function kv(t, e, r) {
  let n = 1, i = 1, o = 0, s = 0;
  if (e < ot) {
    const a = t, l = a + e, c = Math.cos(a), u = Math.sin(a), f = Math.cos(l), d = Math.sin(l), h = (S, O, _) => Ro(S, a, l, !0) ? 1 : Math.max(O, O * r, _, _ * r), g = (S, O, _) => Ro(S, a, l, !0) ? -1 : Math.min(O, O * r, _, _ * r), p = h(0, c, f), y = h(mt, u, d), b = g(st, c, f), x = g(st + mt, u, d);
    n = (p - b) / 2, i = (y - x) / 2, o = -(p + b) / 2, s = -(y + x) / 2;
  }
  return {
    ratioX: n,
    ratioY: i,
    offsetX: o,
    offsetY: s
  };
}
class Bn extends gr {
  constructor(e, r) {
    super(e, r), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(e, r) {
    const n = this.getDataset().data, i = this._cachedMeta;
    if (this._parsing === !1)
      i._parsed = n;
    else {
      let o = (l) => +n[l];
      if (Be(n[e])) {
        const { key: l = "value" } = this._parsing;
        o = (c) => +hn(n[c], l);
      }
      let s, a;
      for (s = e, a = e + r; s < a; ++s)
        i._parsed[s] = o(s);
    }
  }
  _getRotation() {
    return pr(this.options.rotation - 90);
  }
  _getCircumference() {
    return pr(this.options.circumference);
  }
  _getRotationExtents() {
    let e = ot, r = -ot;
    for (let n = 0; n < this.chart.data.datasets.length; ++n)
      if (this.chart.isDatasetVisible(n) && this.chart.getDatasetMeta(n).type === this._type) {
        const i = this.chart.getDatasetMeta(n).controller, o = i._getRotation(), s = i._getCircumference();
        e = Math.min(e, o), r = Math.max(r, o + s);
      }
    return {
      rotation: e,
      circumference: r - e
    };
  }
  update(e) {
    const r = this.chart, { chartArea: n } = r, i = this._cachedMeta, o = i.data, s = this.getMaxBorderWidth() + this.getMaxOffset(o) + this.options.spacing, a = Math.max((Math.min(n.width, n.height) - s) / 2, 0), l = Math.min(W3(this.options.cutout, a), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: f } = this._getRotationExtents(), { ratioX: d, ratioY: h, offsetX: g, offsetY: p } = kv(f, u, l), y = (n.width - s) / d, b = (n.height - s) / h, x = Math.max(Math.min(y, b) / 2, 0), S = f1(this.options.radius, x), O = Math.max(S * l, 0), _ = (S - O) / this._getVisibleDatasetWeightTotal();
    this.offsetX = g * S, this.offsetY = p * S, i.total = this.calculateTotal(), this.outerRadius = S - _ * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - _ * c, 0), this.updateElements(o, 0, o.length, e);
  }
  _circumference(e, r) {
    const n = this.options, i = this._cachedMeta, o = this._getCircumference();
    return r && n.animation.animateRotate || !this.chart.getDataVisibility(e) || i._parsed[e] === null || i.data[e].hidden ? 0 : this.calculateCircumference(i._parsed[e] * o / ot);
  }
  updateElements(e, r, n, i) {
    const o = i === "reset", s = this.chart, a = s.chartArea, c = s.options.animation, u = (a.left + a.right) / 2, f = (a.top + a.bottom) / 2, d = o && c.animateScale, h = d ? 0 : this.innerRadius, g = d ? 0 : this.outerRadius, { sharedOptions: p, includeOptions: y } = this._getSharedOptions(r, i);
    let b = this._getRotation(), x;
    for (x = 0; x < r; ++x)
      b += this._circumference(x, o);
    for (x = r; x < r + n; ++x) {
      const S = this._circumference(x, o), O = e[x], _ = {
        x: u + this.offsetX,
        y: f + this.offsetY,
        startAngle: b,
        endAngle: b + S,
        circumference: S,
        outerRadius: g,
        innerRadius: h
      };
      y && (_.options = p || this.resolveDataElementOptions(x, O.active ? "active" : i)), b += S, this.updateElement(O, x, _, i);
    }
  }
  calculateTotal() {
    const e = this._cachedMeta, r = e.data;
    let n = 0, i;
    for (i = 0; i < r.length; i++) {
      const o = e._parsed[i];
      o !== null && !isNaN(o) && this.chart.getDataVisibility(i) && !r[i].hidden && (n += Math.abs(o));
    }
    return n;
  }
  calculateCircumference(e) {
    const r = this._cachedMeta.total;
    return r > 0 && !isNaN(e) ? ot * (Math.abs(e) / r) : 0;
  }
  getLabelAndValue(e) {
    const r = this._cachedMeta, n = this.chart, i = n.data.labels || [], o = Go(r._parsed[e], n.options.locale);
    return {
      label: i[e] || "",
      value: o
    };
  }
  getMaxBorderWidth(e) {
    let r = 0;
    const n = this.chart;
    let i, o, s, a, l;
    if (!e) {
      for (i = 0, o = n.data.datasets.length; i < o; ++i)
        if (n.isDatasetVisible(i)) {
          s = n.getDatasetMeta(i), e = s.data, a = s.controller;
          break;
        }
    }
    if (!e)
      return 0;
    for (i = 0, o = e.length; i < o; ++i)
      l = a.resolveDataElementOptions(i), l.borderAlign !== "inner" && (r = Math.max(r, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return r;
  }
  getMaxOffset(e) {
    let r = 0;
    for (let n = 0, i = e.length; n < i; ++n) {
      const o = this.resolveDataElementOptions(n);
      r = Math.max(r, o.offset || 0, o.hoverOffset || 0);
    }
    return r;
  }
  _getRingWeightOffset(e) {
    let r = 0;
    for (let n = 0; n < e; ++n)
      this.chart.isDatasetVisible(n) && (r += this._getRingWeight(n));
    return r;
  }
  _getRingWeight(e) {
    return Math.max(Oe(this.chart.data.datasets[e].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
ye(Bn, "id", "doughnut"), ye(Bn, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), ye(Bn, "descriptors", {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing" && !e.startsWith("borderDash") && !e.startsWith("hoverBorderDash")
}), ye(Bn, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const r = e.data;
          if (r.labels.length && r.datasets.length) {
            const { labels: { pointStyle: n, color: i } } = e.legend.options;
            return r.labels.map((o, s) => {
              const l = e.getDatasetMeta(0).controller.getStyle(s);
              return {
                text: o,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: i,
                lineWidth: l.borderWidth,
                pointStyle: n,
                hidden: !e.getDataVisibility(s),
                index: s
              };
            });
          }
          return [];
        }
      },
      onClick(e, r, n) {
        n.chart.toggleDataVisibility(r.index), n.chart.update();
      }
    }
  }
});
class Hs extends gr {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(e) {
    const r = this._cachedMeta, { dataset: n, data: i = [], _dataset: o } = r, s = this.chart._animationsDisabled;
    let { start: a, count: l } = v1(r, i, s);
    this._drawStart = a, this._drawCount = l, A1(r) && (a = 0, l = i.length), n._chart = this.chart, n._datasetIndex = this.index, n._decimated = !!o._decimated, n.points = i;
    const c = this.resolveDatasetElementOptions(e);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(n, void 0, {
      animated: !s,
      options: c
    }, e), this.updateElements(i, a, l, e);
  }
  updateElements(e, r, n, i) {
    const o = i === "reset", { iScale: s, vScale: a, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: f } = this._getSharedOptions(r, i), d = s.axis, h = a.axis, { spanGaps: g, segment: p } = this.options, y = _i(g) ? g : Number.POSITIVE_INFINITY, b = this.chart._animationsDisabled || o || i === "none", x = r + n, S = e.length;
    let O = r > 0 && this.getParsed(r - 1);
    for (let _ = 0; _ < S; ++_) {
      const B = e[_], N = b ? B : {};
      if (_ < r || _ >= x) {
        N.skip = !0;
        continue;
      }
      const j = this.getParsed(_), W = We(j[h]), G = N[d] = s.getPixelForValue(j[d], _), ee = N[h] = o || W ? a.getBasePixel() : a.getPixelForValue(l ? this.applyStack(a, j, l) : j[h], _);
      N.skip = isNaN(G) || isNaN(ee) || W, N.stop = _ > 0 && Math.abs(j[d] - O[d]) > y, p && (N.parsed = j, N.raw = c.data[_]), f && (N.options = u || this.resolveDataElementOptions(_, B.active ? "active" : i)), b || this.updateElement(B, _, N, i), O = j;
    }
  }
  getMaxOverflow() {
    const e = this._cachedMeta, r = e.dataset, n = r.options && r.options.borderWidth || 0, i = e.data || [];
    if (!i.length)
      return n;
    const o = i[0].size(this.resolveDataElementOptions(0)), s = i[i.length - 1].size(this.resolveDataElementOptions(i.length - 1));
    return Math.max(n, o, s) / 2;
  }
  draw() {
    const e = this._cachedMeta;
    e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw();
  }
}
ye(Hs, "id", "line"), ye(Hs, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), ye(Hs, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class vo extends gr {
  constructor(e, r) {
    super(e, r), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(e) {
    const r = this._cachedMeta, n = this.chart, i = n.data.labels || [], o = Go(r._parsed[e].r, n.options.locale);
    return {
      label: i[e] || "",
      value: o
    };
  }
  parseObjectData(e, r, n, i) {
    return T1.bind(this)(e, r, n, i);
  }
  update(e) {
    const r = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(r, 0, r.length, e);
  }
  getMinMax() {
    const e = this._cachedMeta, r = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return e.data.forEach((n, i) => {
      const o = this.getParsed(i).r;
      !isNaN(o) && this.chart.getDataVisibility(i) && (o < r.min && (r.min = o), o > r.max && (r.max = o));
    }), r;
  }
  _updateRadius() {
    const e = this.chart, r = e.chartArea, n = e.options, i = Math.min(r.right - r.left, r.bottom - r.top), o = Math.max(i / 2, 0), s = Math.max(n.cutoutPercentage ? o / 100 * n.cutoutPercentage : 1, 0), a = (o - s) / e.getVisibleDatasetCount();
    this.outerRadius = o - a * this.index, this.innerRadius = this.outerRadius - a;
  }
  updateElements(e, r, n, i) {
    const o = i === "reset", s = this.chart, l = s.options.animation, c = this._cachedMeta.rScale, u = c.xCenter, f = c.yCenter, d = c.getIndexAngle(0) - 0.5 * st;
    let h = d, g;
    const p = 360 / this.countVisibleElements();
    for (g = 0; g < r; ++g)
      h += this._computeAngle(g, i, p);
    for (g = r; g < r + n; g++) {
      const y = e[g];
      let b = h, x = h + this._computeAngle(g, i, p), S = s.getDataVisibility(g) ? c.getDistanceFromCenterForValue(this.getParsed(g).r) : 0;
      h = x, o && (l.animateScale && (S = 0), l.animateRotate && (b = x = d));
      const O = {
        x: u,
        y: f,
        innerRadius: 0,
        outerRadius: S,
        startAngle: b,
        endAngle: x,
        options: this.resolveDataElementOptions(g, y.active ? "active" : i)
      };
      this.updateElement(y, g, O, i);
    }
  }
  countVisibleElements() {
    const e = this._cachedMeta;
    let r = 0;
    return e.data.forEach((n, i) => {
      !isNaN(this.getParsed(i).r) && this.chart.getDataVisibility(i) && r++;
    }), r;
  }
  _computeAngle(e, r, n) {
    return this.chart.getDataVisibility(e) ? pr(this.resolveDataElementOptions(e, r).angle || n) : 0;
  }
}
ye(vo, "id", "polarArea"), ye(vo, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), ye(vo, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const r = e.data;
          if (r.labels.length && r.datasets.length) {
            const { labels: { pointStyle: n, color: i } } = e.legend.options;
            return r.labels.map((o, s) => {
              const l = e.getDatasetMeta(0).controller.getStyle(s);
              return {
                text: o,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: i,
                lineWidth: l.borderWidth,
                pointStyle: n,
                hidden: !e.getDataVisibility(s),
                index: s
              };
            });
          }
          return [];
        }
      },
      onClick(e, r, n) {
        n.chart.toggleDataVisibility(r.index), n.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class Bc extends Bn {
}
ye(Bc, "id", "pie"), ye(Bc, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class Ys extends gr {
  getLabelAndValue(e) {
    const r = this._cachedMeta.vScale, n = this.getParsed(e);
    return {
      label: r.getLabels()[e],
      value: "" + r.getLabelForValue(n[r.axis])
    };
  }
  parseObjectData(e, r, n, i) {
    return T1.bind(this)(e, r, n, i);
  }
  update(e) {
    const r = this._cachedMeta, n = r.dataset, i = r.data || [], o = r.iScale.getLabels();
    if (n.points = i, e !== "resize") {
      const s = this.resolveDatasetElementOptions(e);
      this.options.showLine || (s.borderWidth = 0);
      const a = {
        _loop: !0,
        _fullLoop: o.length === i.length,
        options: s
      };
      this.updateElement(n, void 0, a, e);
    }
    this.updateElements(i, 0, i.length, e);
  }
  updateElements(e, r, n, i) {
    const o = this._cachedMeta.rScale, s = i === "reset";
    for (let a = r; a < r + n; a++) {
      const l = e[a], c = this.resolveDataElementOptions(a, l.active ? "active" : i), u = o.getPointPositionForValue(a, this.getParsed(a).r), f = s ? o.xCenter : u.x, d = s ? o.yCenter : u.y, h = {
        x: f,
        y: d,
        angle: u.angle,
        skip: isNaN(f) || isNaN(d),
        options: c
      };
      this.updateElement(l, a, h, i);
    }
  }
}
ye(Ys, "id", "radar"), ye(Ys, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), ye(Ys, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class Ks extends gr {
  getLabelAndValue(e) {
    const r = this._cachedMeta, n = this.chart.data.labels || [], { xScale: i, yScale: o } = r, s = this.getParsed(e), a = i.getLabelForValue(s.x), l = o.getLabelForValue(s.y);
    return {
      label: n[e] || "",
      value: "(" + a + ", " + l + ")"
    };
  }
  update(e) {
    const r = this._cachedMeta, { data: n = [] } = r, i = this.chart._animationsDisabled;
    let { start: o, count: s } = v1(r, n, i);
    if (this._drawStart = o, this._drawCount = s, A1(r) && (o = 0, s = n.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: a, _dataset: l } = r;
      a._chart = this.chart, a._datasetIndex = this.index, a._decimated = !!l._decimated, a.points = n;
      const c = this.resolveDatasetElementOptions(e);
      c.segment = this.options.segment, this.updateElement(a, void 0, {
        animated: !i,
        options: c
      }, e);
    } else
      this.datasetElementType && (delete r.dataset, this.datasetElementType = !1);
    this.updateElements(n, o, s, e);
  }
  addElements() {
    const { showLine: e } = this.options;
    !this.datasetElementType && e && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(e, r, n, i) {
    const o = i === "reset", { iScale: s, vScale: a, _stacked: l, _dataset: c } = this._cachedMeta, u = this.resolveDataElementOptions(r, i), f = this.getSharedOptions(u), d = this.includeOptions(i, f), h = s.axis, g = a.axis, { spanGaps: p, segment: y } = this.options, b = _i(p) ? p : Number.POSITIVE_INFINITY, x = this.chart._animationsDisabled || o || i === "none";
    let S = r > 0 && this.getParsed(r - 1);
    for (let O = r; O < r + n; ++O) {
      const _ = e[O], B = this.getParsed(O), N = x ? _ : {}, j = We(B[g]), W = N[h] = s.getPixelForValue(B[h], O), G = N[g] = o || j ? a.getBasePixel() : a.getPixelForValue(l ? this.applyStack(a, B, l) : B[g], O);
      N.skip = isNaN(W) || isNaN(G) || j, N.stop = O > 0 && Math.abs(B[h] - S[h]) > b, y && (N.parsed = B, N.raw = c.data[O]), d && (N.options = f || this.resolveDataElementOptions(O, _.active ? "active" : i)), x || this.updateElement(_, O, N, i), S = B;
    }
    this.updateSharedOptions(f, i, u);
  }
  getMaxOverflow() {
    const e = this._cachedMeta, r = e.data || [];
    if (!this.options.showLine) {
      let a = 0;
      for (let l = r.length - 1; l >= 0; --l)
        a = Math.max(a, r[l].size(this.resolveDataElementOptions(l)) / 2);
      return a > 0 && a;
    }
    const n = e.dataset, i = n.options && n.options.borderWidth || 0;
    if (!r.length)
      return i;
    const o = r[0].size(this.resolveDataElementOptions(0)), s = r[r.length - 1].size(this.resolveDataElementOptions(r.length - 1));
    return Math.max(i, o, s) / 2;
  }
}
ye(Ks, "id", "scatter"), ye(Ks, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), ye(Ks, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var Cv = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: Vs,
  BubbleController: qs,
  DoughnutController: Bn,
  LineController: Hs,
  PieController: Bc,
  PolarAreaController: vo,
  RadarController: Ys,
  ScatterController: Ks
});
function kn() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Xu {
  constructor(e) {
    ye(this, "options");
    this.options = e || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(Xu.prototype, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return kn();
  }
  parse() {
    return kn();
  }
  format() {
    return kn();
  }
  add() {
    return kn();
  }
  diff() {
    return kn();
  }
  startOf() {
    return kn();
  }
  endOf() {
    return kn();
  }
}
var Tv = {
  _date: Xu
};
function Ov(t, e, r, n) {
  const { controller: i, data: o, _sorted: s } = t, a = i._cachedMeta.iScale;
  if (a && e === a.axis && e !== "r" && s && o.length) {
    const l = a._reversePixels ? Z3 : jr;
    if (n) {
      if (i._sharedOptions) {
        const c = o[0], u = typeof c.getRange == "function" && c.getRange(e);
        if (u) {
          const f = l(o, e, r - u), d = l(o, e, r + u);
          return {
            lo: f.lo,
            hi: d.hi
          };
        }
      }
    } else
      return l(o, e, r);
  }
  return {
    lo: 0,
    hi: o.length - 1
  };
}
function Zo(t, e, r, n, i) {
  const o = t.getSortedVisibleDatasetMetas(), s = r[e];
  for (let a = 0, l = o.length; a < l; ++a) {
    const { index: c, data: u } = o[a], { lo: f, hi: d } = Ov(o[a], e, s, i);
    for (let h = f; h <= d; ++h) {
      const g = u[h];
      g.skip || n(g, c, h);
    }
  }
}
function Iv(t) {
  const e = t.indexOf("x") !== -1, r = t.indexOf("y") !== -1;
  return function(n, i) {
    const o = e ? Math.abs(n.x - i.x) : 0, s = r ? Math.abs(n.y - i.y) : 0;
    return Math.sqrt(Math.pow(o, 2) + Math.pow(s, 2));
  };
}
function Jl(t, e, r, n, i) {
  const o = [];
  return !i && !t.isPointInArea(e) || Zo(t, r, e, function(a, l, c) {
    !i && !Wr(a, t.chartArea, 0) || a.inRange(e.x, e.y, n) && o.push({
      element: a,
      datasetIndex: l,
      index: c
    });
  }, !0), o;
}
function Pv(t, e, r, n) {
  let i = [];
  function o(s, a, l) {
    const { startAngle: c, endAngle: u } = s.getProps([
      "startAngle",
      "endAngle"
    ], n), { angle: f } = p1(s, {
      x: e.x,
      y: e.y
    });
    Ro(f, c, u) && i.push({
      element: s,
      datasetIndex: a,
      index: l
    });
  }
  return Zo(t, r, e, o), i;
}
function Rv(t, e, r, n, i, o) {
  let s = [];
  const a = Iv(r);
  let l = Number.POSITIVE_INFINITY;
  function c(u, f, d) {
    const h = u.inRange(e.x, e.y, i);
    if (n && !h)
      return;
    const g = u.getCenterPoint(i);
    if (!(!!o || t.isPointInArea(g)) && !h)
      return;
    const y = a(e, g);
    y < l ? (s = [
      {
        element: u,
        datasetIndex: f,
        index: d
      }
    ], l = y) : y === l && s.push({
      element: u,
      datasetIndex: f,
      index: d
    });
  }
  return Zo(t, r, e, c), s;
}
function Ql(t, e, r, n, i, o) {
  return !o && !t.isPointInArea(e) ? [] : r === "r" && !n ? Pv(t, e, r, i) : Rv(t, e, r, n, i, o);
}
function Qd(t, e, r, n, i) {
  const o = [], s = r === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return Zo(t, r, e, (l, c, u) => {
    l[s](e[r], i) && (o.push({
      element: l,
      datasetIndex: c,
      index: u
    }), a = a || l.inRange(e.x, e.y, i));
  }), n && !a ? [] : o;
}
var Dv = {
  evaluateInteractionItems: Zo,
  modes: {
    index(t, e, r, n) {
      const i = In(e, t), o = r.axis || "x", s = r.includeInvisible || !1, a = r.intersect ? Jl(t, i, o, n, s) : Ql(t, i, o, !1, n, s), l = [];
      return a.length ? (t.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = a[0].index, f = c.data[u];
        f && !f.skip && l.push({
          element: f,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(t, e, r, n) {
      const i = In(e, t), o = r.axis || "xy", s = r.includeInvisible || !1;
      let a = r.intersect ? Jl(t, i, o, n, s) : Ql(t, i, o, !1, n, s);
      if (a.length > 0) {
        const l = a[0].datasetIndex, c = t.getDatasetMeta(l).data;
        a = [];
        for (let u = 0; u < c.length; ++u)
          a.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return a;
    },
    point(t, e, r, n) {
      const i = In(e, t), o = r.axis || "xy", s = r.includeInvisible || !1;
      return Jl(t, i, o, n, s);
    },
    nearest(t, e, r, n) {
      const i = In(e, t), o = r.axis || "xy", s = r.includeInvisible || !1;
      return Ql(t, i, o, r.intersect, n, s);
    },
    x(t, e, r, n) {
      const i = In(e, t);
      return Qd(t, i, "x", r.intersect, n);
    },
    y(t, e, r, n) {
      const i = In(e, t);
      return Qd(t, i, "y", r.intersect, n);
    }
  }
};
const j1 = [
  "left",
  "top",
  "right",
  "bottom"
];
function qi(t, e) {
  return t.filter((r) => r.pos === e);
}
function Gd(t, e) {
  return t.filter((r) => j1.indexOf(r.pos) === -1 && r.box.axis === e);
}
function Hi(t, e) {
  return t.sort((r, n) => {
    const i = e ? n : r, o = e ? r : n;
    return i.weight === o.weight ? i.index - o.index : i.weight - o.weight;
  });
}
function Mv(t) {
  const e = [];
  let r, n, i, o, s, a;
  for (r = 0, n = (t || []).length; r < n; ++r)
    i = t[r], { position: o, options: { stack: s, stackWeight: a = 1 } } = i, e.push({
      index: r,
      box: i,
      pos: o,
      horizontal: i.isHorizontal(),
      weight: i.weight,
      stack: s && o + s,
      stackWeight: a
    });
  return e;
}
function Nv(t) {
  const e = {};
  for (const r of t) {
    const { stack: n, pos: i, stackWeight: o } = r;
    if (!n || !j1.includes(i))
      continue;
    const s = e[n] || (e[n] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    s.count++, s.weight += o;
  }
  return e;
}
function Bv(t, e) {
  const r = Nv(t), { vBoxMaxWidth: n, hBoxMaxHeight: i } = e;
  let o, s, a;
  for (o = 0, s = t.length; o < s; ++o) {
    a = t[o];
    const { fullSize: l } = a.box, c = r[a.stack], u = c && a.stackWeight / c.weight;
    a.horizontal ? (a.width = u ? u * n : l && e.availableWidth, a.height = i) : (a.width = n, a.height = u ? u * i : l && e.availableHeight);
  }
  return r;
}
function Lv(t) {
  const e = Mv(t), r = Hi(e.filter((c) => c.box.fullSize), !0), n = Hi(qi(e, "left"), !0), i = Hi(qi(e, "right")), o = Hi(qi(e, "top"), !0), s = Hi(qi(e, "bottom")), a = Gd(e, "x"), l = Gd(e, "y");
  return {
    fullSize: r,
    leftAndTop: n.concat(o),
    rightAndBottom: i.concat(l).concat(s).concat(a),
    chartArea: qi(e, "chartArea"),
    vertical: n.concat(i).concat(l),
    horizontal: o.concat(s).concat(a)
  };
}
function Zd(t, e, r, n) {
  return Math.max(t[r], e[r]) + Math.max(t[n], e[n]);
}
function W1(t, e) {
  t.top = Math.max(t.top, e.top), t.left = Math.max(t.left, e.left), t.bottom = Math.max(t.bottom, e.bottom), t.right = Math.max(t.right, e.right);
}
function Fv(t, e, r, n) {
  const { pos: i, box: o } = r, s = t.maxPadding;
  if (!Be(i)) {
    r.size && (t[i] -= r.size);
    const f = n[r.stack] || {
      size: 0,
      count: 1
    };
    f.size = Math.max(f.size, r.horizontal ? o.height : o.width), r.size = f.size / f.count, t[i] += r.size;
  }
  o.getPadding && W1(s, o.getPadding());
  const a = Math.max(0, e.outerWidth - Zd(s, t, "left", "right")), l = Math.max(0, e.outerHeight - Zd(s, t, "top", "bottom")), c = a !== t.w, u = l !== t.h;
  return t.w = a, t.h = l, r.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function jv(t) {
  const e = t.maxPadding;
  function r(n) {
    const i = Math.max(e[n] - t[n], 0);
    return t[n] += i, i;
  }
  t.y += r("top"), t.x += r("left"), r("right"), r("bottom");
}
function Wv(t, e) {
  const r = e.maxPadding;
  function n(i) {
    const o = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return i.forEach((s) => {
      o[s] = Math.max(e[s], r[s]);
    }), o;
  }
  return n(t ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function io(t, e, r, n) {
  const i = [];
  let o, s, a, l, c, u;
  for (o = 0, s = t.length, c = 0; o < s; ++o) {
    a = t[o], l = a.box, l.update(a.width || e.w, a.height || e.h, Wv(a.horizontal, e));
    const { same: f, other: d } = Fv(e, r, a, n);
    c |= f && i.length, u = u || d, l.fullSize || i.push(a);
  }
  return c && io(i, e, r, n) || u;
}
function _s(t, e, r, n, i) {
  t.top = r, t.left = e, t.right = e + n, t.bottom = r + i, t.width = n, t.height = i;
}
function $d(t, e, r, n) {
  const i = r.padding;
  let { x: o, y: s } = e;
  for (const a of t) {
    const l = a.box, c = n[a.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = a.stackWeight / c.weight || 1;
    if (a.horizontal) {
      const f = e.w * u, d = c.size || l.height;
      Po(c.start) && (s = c.start), l.fullSize ? _s(l, i.left, s, r.outerWidth - i.right - i.left, d) : _s(l, e.left + c.placed, s, f, d), c.start = s, c.placed += f, s = l.bottom;
    } else {
      const f = e.h * u, d = c.size || l.width;
      Po(c.start) && (o = c.start), l.fullSize ? _s(l, o, i.top, d, r.outerHeight - i.bottom - i.top) : _s(l, o, e.top + c.placed, d, f), c.start = o, c.placed += f, o = l.right;
    }
  }
  e.x = o, e.y = s;
}
var Rt = {
  addBox(t, e) {
    t.boxes || (t.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(r) {
            e.draw(r);
          }
        }
      ];
    }, t.boxes.push(e);
  },
  removeBox(t, e) {
    const r = t.boxes ? t.boxes.indexOf(e) : -1;
    r !== -1 && t.boxes.splice(r, 1);
  },
  configure(t, e, r) {
    e.fullSize = r.fullSize, e.position = r.position, e.weight = r.weight;
  },
  update(t, e, r, n) {
    if (!t)
      return;
    const i = Mt(t.options.layout.padding), o = Math.max(e - i.width, 0), s = Math.max(r - i.height, 0), a = Lv(t.boxes), l = a.vertical, c = a.horizontal;
    $e(t.boxes, (p) => {
      typeof p.beforeLayout == "function" && p.beforeLayout();
    });
    const u = l.reduce((p, y) => y.box.options && y.box.options.display === !1 ? p : p + 1, 0) || 1, f = Object.freeze({
      outerWidth: e,
      outerHeight: r,
      padding: i,
      availableWidth: o,
      availableHeight: s,
      vBoxMaxWidth: o / 2 / u,
      hBoxMaxHeight: s / 2
    }), d = Object.assign({}, i);
    W1(d, Mt(n));
    const h = Object.assign({
      maxPadding: d,
      w: o,
      h: s,
      x: i.left,
      y: i.top
    }, i), g = Bv(l.concat(c), f);
    io(a.fullSize, h, f, g), io(l, h, f, g), io(c, h, f, g) && io(l, h, f, g), jv(h), $d(a.leftAndTop, h, f, g), h.x += h.w, h.y += h.h, $d(a.rightAndBottom, h, f, g), t.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, $e(a.chartArea, (p) => {
      const y = p.box;
      Object.assign(y, t.chartArea), y.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class U1 {
  acquireContext(e, r) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, r, n) {
  }
  removeEventListener(e, r, n) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, r, n, i) {
    return r = Math.max(0, r || e.width), n = n || e.height, {
      width: r,
      height: Math.max(0, i ? Math.floor(r / i) : n)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class Uv extends U1 {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const Xs = "$chartjs", zv = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, eh = (t) => t === null || t === "";
function Vv(t, e) {
  const r = t.style, n = t.getAttribute("height"), i = t.getAttribute("width");
  if (t[Xs] = {
    initial: {
      height: n,
      width: i,
      style: {
        display: r.display,
        height: r.height,
        width: r.width
      }
    }
  }, r.display = r.display || "block", r.boxSizing = r.boxSizing || "border-box", eh(i)) {
    const o = Bd(t, "width");
    o !== void 0 && (t.width = o);
  }
  if (eh(n))
    if (t.style.height === "")
      t.height = t.width / (e || 2);
    else {
      const o = Bd(t, "height");
      o !== void 0 && (t.height = o);
    }
  return t;
}
const z1 = H2 ? {
  passive: !0
} : !1;
function qv(t, e, r) {
  t.addEventListener(e, r, z1);
}
function Hv(t, e, r) {
  t.canvas.removeEventListener(e, r, z1);
}
function Yv(t, e) {
  const r = zv[t.type] || t.type, { x: n, y: i } = In(t, e);
  return {
    type: r,
    chart: e,
    native: t,
    x: n !== void 0 ? n : null,
    y: i !== void 0 ? i : null
  };
}
function Aa(t, e) {
  for (const r of t)
    if (r === e || r.contains(e))
      return !0;
}
function Kv(t, e, r) {
  const n = t.canvas, i = new MutationObserver((o) => {
    let s = !1;
    for (const a of o)
      s = s || Aa(a.addedNodes, n), s = s && !Aa(a.removedNodes, n);
    s && r();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
function Xv(t, e, r) {
  const n = t.canvas, i = new MutationObserver((o) => {
    let s = !1;
    for (const a of o)
      s = s || Aa(a.removedNodes, n), s = s && !Aa(a.addedNodes, n);
    s && r();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
const Mo = /* @__PURE__ */ new Map();
let th = 0;
function V1() {
  const t = window.devicePixelRatio;
  t !== th && (th = t, Mo.forEach((e, r) => {
    r.currentDevicePixelRatio !== t && e();
  }));
}
function Jv(t, e) {
  Mo.size || window.addEventListener("resize", V1), Mo.set(t, e);
}
function Qv(t) {
  Mo.delete(t), Mo.size || window.removeEventListener("resize", V1);
}
function Gv(t, e, r) {
  const n = t.canvas, i = n && Ku(n);
  if (!i)
    return;
  const o = b1((a, l) => {
    const c = i.clientWidth;
    r(a, l), c < i.clientWidth && r();
  }, window), s = new ResizeObserver((a) => {
    const l = a[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || o(c, u);
  });
  return s.observe(i), Jv(t, o), s;
}
function Gl(t, e, r) {
  r && r.disconnect(), e === "resize" && Qv(t);
}
function Zv(t, e, r) {
  const n = t.canvas, i = b1((o) => {
    t.ctx !== null && r(Yv(o, t));
  }, t);
  return qv(n, e, i), i;
}
class $v extends U1 {
  acquireContext(e, r) {
    const n = e && e.getContext && e.getContext("2d");
    return n && n.canvas === e ? (Vv(e, r), n) : null;
  }
  releaseContext(e) {
    const r = e.canvas;
    if (!r[Xs])
      return !1;
    const n = r[Xs].initial;
    [
      "height",
      "width"
    ].forEach((o) => {
      const s = n[o];
      We(s) ? r.removeAttribute(o) : r.setAttribute(o, s);
    });
    const i = n.style || {};
    return Object.keys(i).forEach((o) => {
      r.style[o] = i[o];
    }), r.width = r.width, delete r[Xs], !0;
  }
  addEventListener(e, r, n) {
    this.removeEventListener(e, r);
    const i = e.$proxies || (e.$proxies = {}), s = {
      attach: Kv,
      detach: Xv,
      resize: Gv
    }[r] || Zv;
    i[r] = s(e, r, n);
  }
  removeEventListener(e, r) {
    const n = e.$proxies || (e.$proxies = {}), i = n[r];
    if (!i)
      return;
    ({
      attach: Gl,
      detach: Gl,
      resize: Gl
    }[r] || Hv)(e, r, i), n[r] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, r, n, i) {
    return q2(e, r, n, i);
  }
  isAttached(e) {
    const r = Ku(e);
    return !!(r && r.isConnected);
  }
}
function e6(t) {
  return !I1() || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas ? Uv : $v;
}
var Ws;
let Xr = (Ws = class {
  constructor() {
    ye(this, "x");
    ye(this, "y");
    ye(this, "active", !1);
    ye(this, "options");
    ye(this, "$animations");
  }
  tooltipPosition(e) {
    const { x: r, y: n } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: r,
      y: n
    };
  }
  hasValue() {
    return _i(this.x) && _i(this.y);
  }
  getProps(e, r) {
    const n = this.$animations;
    if (!r || !n)
      return this;
    const i = {};
    return e.forEach((o) => {
      i[o] = n[o] && n[o].active() ? n[o]._to : this[o];
    }), i;
  }
}, ye(Ws, "defaults", {}), ye(Ws, "defaultRoutes"), Ws);
function t6(t, e) {
  const r = t.options.ticks, n = r6(t), i = Math.min(r.maxTicksLimit || n, n), o = r.major.enabled ? i6(e) : [], s = o.length, a = o[0], l = o[s - 1], c = [];
  if (s > i)
    return o6(e, c, o, s / i), c;
  const u = n6(o, e, i);
  if (s > 0) {
    let f, d;
    const h = s > 1 ? Math.round((l - a) / (s - 1)) : null;
    for (Ss(e, c, u, We(h) ? 0 : a - h, a), f = 0, d = s - 1; f < d; f++)
      Ss(e, c, u, o[f], o[f + 1]);
    return Ss(e, c, u, l, We(h) ? e.length : l + h), c;
  }
  return Ss(e, c, u), c;
}
function r6(t) {
  const e = t.options.offset, r = t._tickSize(), n = t._length / r + (e ? 0 : 1), i = t._maxLength / r;
  return Math.floor(Math.min(n, i));
}
function n6(t, e, r) {
  const n = s6(t), i = e.length / r;
  if (!n)
    return Math.max(i, 1);
  const o = X3(n);
  for (let s = 0, a = o.length - 1; s < a; s++) {
    const l = o[s];
    if (l > i)
      return l;
  }
  return Math.max(i, 1);
}
function i6(t) {
  const e = [];
  let r, n;
  for (r = 0, n = t.length; r < n; r++)
    t[r].major && e.push(r);
  return e;
}
function o6(t, e, r, n) {
  let i = 0, o = r[0], s;
  for (n = Math.ceil(n), s = 0; s < t.length; s++)
    s === o && (e.push(t[s]), i++, o = r[i * n]);
}
function Ss(t, e, r, n, i) {
  const o = Oe(n, 0), s = Math.min(Oe(i, t.length), t.length);
  let a = 0, l, c, u;
  for (r = Math.ceil(r), i && (l = i - n, r = l / Math.floor(l / r)), u = o; u < 0; )
    a++, u = Math.round(o + a * r);
  for (c = Math.max(o, 0); c < s; c++)
    c === u && (e.push(t[c]), a++, u = Math.round(o + a * r));
}
function s6(t) {
  const e = t.length;
  let r, n;
  if (e < 2)
    return !1;
  for (n = t[0], r = 1; r < e; ++r)
    if (t[r] - t[r - 1] !== n)
      return !1;
  return n;
}
const a6 = (t) => t === "left" ? "right" : t === "right" ? "left" : t, rh = (t, e, r) => e === "top" || e === "left" ? t[e] + r : t[e] - r, nh = (t, e) => Math.min(e || t, t);
function ih(t, e) {
  const r = [], n = t.length / e, i = t.length;
  let o = 0;
  for (; o < i; o += n)
    r.push(t[Math.floor(o)]);
  return r;
}
function l6(t, e, r) {
  const n = t.ticks.length, i = Math.min(e, n - 1), o = t._startPixel, s = t._endPixel, a = 1e-6;
  let l = t.getPixelForTick(i), c;
  if (!(r && (n === 1 ? c = Math.max(l - o, s - l) : e === 0 ? c = (t.getPixelForTick(1) - l) / 2 : c = (l - t.getPixelForTick(i - 1)) / 2, l += i < e ? c : -c, l < o - a || l > s + a)))
    return l;
}
function c6(t, e) {
  $e(t, (r) => {
    const n = r.gc, i = n.length / 2;
    let o;
    if (i > e) {
      for (o = 0; o < i; ++o)
        delete r.data[n[o]];
      n.splice(0, i);
    }
  });
}
function Yi(t) {
  return t.drawTicks ? t.tickLength : 0;
}
function oh(t, e) {
  if (!t.display)
    return 0;
  const r = vt(t.font, e), n = Mt(t.padding);
  return (it(t.text) ? t.text.length : 1) * r.lineHeight + n.height;
}
function u6(t, e) {
  return bn(t, {
    scale: e,
    type: "scale"
  });
}
function f6(t, e, r) {
  return bn(t, {
    tick: r,
    index: e,
    type: "tick"
  });
}
function d6(t, e, r) {
  let n = Uu(t);
  return (r && e !== "right" || !r && e === "right") && (n = a6(n)), n;
}
function h6(t, e, r, n) {
  const { top: i, left: o, bottom: s, right: a, chart: l } = t, { chartArea: c, scales: u } = l;
  let f = 0, d, h, g;
  const p = s - i, y = a - o;
  if (t.isHorizontal()) {
    if (h = It(n, o, a), Be(r)) {
      const b = Object.keys(r)[0], x = r[b];
      g = u[b].getPixelForValue(x) + p - e;
    } else
      r === "center" ? g = (c.bottom + c.top) / 2 + p - e : g = rh(t, r, e);
    d = a - o;
  } else {
    if (Be(r)) {
      const b = Object.keys(r)[0], x = r[b];
      h = u[b].getPixelForValue(x) - y + e;
    } else
      r === "center" ? h = (c.left + c.right) / 2 - y + e : h = rh(t, r, e);
    g = It(n, s, i), f = r === "left" ? -mt : mt;
  }
  return {
    titleX: h,
    titleY: g,
    maxWidth: d,
    rotation: f
  };
}
class Qn extends Xr {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, r) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: r, _suggestedMin: n, _suggestedMax: i } = this;
    return e = Ht(e, Number.POSITIVE_INFINITY), r = Ht(r, Number.NEGATIVE_INFINITY), n = Ht(n, Number.POSITIVE_INFINITY), i = Ht(i, Number.NEGATIVE_INFINITY), {
      min: Ht(e, n),
      max: Ht(r, i),
      minDefined: pt(e),
      maxDefined: pt(r)
    };
  }
  getMinMax(e) {
    let { min: r, max: n, minDefined: i, maxDefined: o } = this.getUserBounds(), s;
    if (i && o)
      return {
        min: r,
        max: n
      };
    const a = this.getMatchingVisibleMetas();
    for (let l = 0, c = a.length; l < c; ++l)
      s = a[l].controller.getMinMax(this, e), i || (r = Math.min(r, s.min)), o || (n = Math.max(n, s.max));
    return r = o && r > n ? n : r, n = i && r > n ? r : n, {
      min: Ht(r, Ht(n, r)),
      max: Ht(n, Ht(r, n))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    nt(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, r, n) {
    const { beginAtZero: i, grace: o, ticks: s } = this.options, a = s.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = r, this._margins = n = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, n), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + n.left + n.right : this.height + n.top + n.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = x2(this, o, i), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = a < this.ticks.length;
    this._convertTicksToLabels(l ? ih(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), s.display && (s.autoSkip || s.source === "auto") && (this.ticks = t6(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, r, n;
    this.isHorizontal() ? (r = this.left, n = this.right) : (r = this.top, n = this.bottom, e = !e), this._startPixel = r, this._endPixel = n, this._reversePixels = e, this._length = n - r, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    nt(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    nt(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    nt(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), nt(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    nt(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const r = this.options.ticks;
    let n, i, o;
    for (n = 0, i = e.length; n < i; n++)
      o = e[n], o.label = nt(r.callback, [
        o.value,
        n,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    nt(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    nt(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, r = e.ticks, n = nh(this.ticks.length, e.ticks.maxTicksLimit), i = r.minRotation || 0, o = r.maxRotation;
    let s = i, a, l, c;
    if (!this._isVisible() || !r.display || i >= o || n <= 1 || !this.isHorizontal()) {
      this.labelRotation = i;
      return;
    }
    const u = this._getLabelSizes(), f = u.widest.width, d = u.highest.height, h = St(this.chart.width - f, 0, this.maxWidth);
    a = e.offset ? this.maxWidth / n : h / (n - 1), f + 6 > a && (a = h / (n - (e.offset ? 0.5 : 1)), l = this.maxHeight - Yi(e.grid) - r.padding - oh(e.title, this.chart.options.font), c = Math.sqrt(f * f + d * d), s = ju(Math.min(Math.asin(St((u.highest.height + 6) / a, -1, 1)), Math.asin(St(l / c, -1, 1)) - Math.asin(St(d / c, -1, 1)))), s = Math.max(i, Math.min(o, s))), this.labelRotation = s;
  }
  afterCalculateLabelRotation() {
    nt(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    nt(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: r, options: { ticks: n, title: i, grid: o } } = this, s = this._isVisible(), a = this.isHorizontal();
    if (s) {
      const l = oh(i, r.options.font);
      if (a ? (e.width = this.maxWidth, e.height = Yi(o) + l) : (e.height = this.maxHeight, e.width = Yi(o) + l), n.display && this.ticks.length) {
        const { first: c, last: u, widest: f, highest: d } = this._getLabelSizes(), h = n.padding * 2, g = pr(this.labelRotation), p = Math.cos(g), y = Math.sin(g);
        if (a) {
          const b = n.mirror ? 0 : y * f.width + p * d.height;
          e.height = Math.min(this.maxHeight, e.height + b + h);
        } else {
          const b = n.mirror ? 0 : p * f.width + y * d.height;
          e.width = Math.min(this.maxWidth, e.width + b + h);
        }
        this._calculatePadding(c, u, y, p);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = r.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = r.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, r, n, i) {
    const { ticks: { align: o, padding: s }, position: a } = this.options, l = this.labelRotation !== 0, c = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, f = this.right - this.getPixelForTick(this.ticks.length - 1);
      let d = 0, h = 0;
      l ? c ? (d = i * e.width, h = n * r.height) : (d = n * e.height, h = i * r.width) : o === "start" ? h = r.width : o === "end" ? d = e.width : o !== "inner" && (d = e.width / 2, h = r.width / 2), this.paddingLeft = Math.max((d - u + s) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - f + s) * this.width / (this.width - f), 0);
    } else {
      let u = r.height / 2, f = e.height / 2;
      o === "start" ? (u = 0, f = e.height) : o === "end" && (u = r.height, f = 0), this.paddingTop = u + s, this.paddingBottom = f + s;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    nt(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: r } = this.options;
    return r === "top" || r === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let r, n;
    for (r = 0, n = e.length; r < n; r++)
      We(e[r].label) && (e.splice(r, 1), n--, r--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const r = this.options.ticks.sampleSize;
      let n = this.ticks;
      r < n.length && (n = ih(n, r)), this._labelSizes = e = this._computeLabelSizes(n, n.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, r, n) {
    const { ctx: i, _longestTextCache: o } = this, s = [], a = [], l = Math.floor(r / nh(r, n));
    let c = 0, u = 0, f, d, h, g, p, y, b, x, S, O, _;
    for (f = 0; f < r; f += l) {
      if (g = e[f].label, p = this._resolveTickFontOptions(f), i.font = y = p.string, b = o[y] = o[y] || {
        data: {},
        gc: []
      }, x = p.lineHeight, S = O = 0, !We(g) && !it(g))
        S = ba(i, b.data, b.gc, S, g), O = x;
      else if (it(g))
        for (d = 0, h = g.length; d < h; ++d)
          _ = g[d], !We(_) && !it(_) && (S = ba(i, b.data, b.gc, S, _), O += x);
      s.push(S), a.push(O), c = Math.max(S, c), u = Math.max(O, u);
    }
    c6(o, r);
    const B = s.indexOf(c), N = a.indexOf(u), j = (W) => ({
      width: s[W] || 0,
      height: a[W] || 0
    });
    return {
      first: j(0),
      last: j(r - 1),
      widest: j(B),
      highest: j(N),
      widths: s,
      heights: a
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, r) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const r = this.ticks;
    return e < 0 || e > r.length - 1 ? null : this.getPixelForValue(r[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const r = this._startPixel + e * this._length;
    return G3(this._alignToPixels ? En(this.chart, r, 0) : r);
  }
  getDecimalForPixel(e) {
    const r = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - r : r;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: r } = this;
    return e < 0 && r < 0 ? r : e > 0 && r > 0 ? e : 0;
  }
  getContext(e) {
    const r = this.ticks || [];
    if (e >= 0 && e < r.length) {
      const n = r[e];
      return n.$context || (n.$context = f6(this.getContext(), e, n));
    }
    return this.$context || (this.$context = u6(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, r = pr(this.labelRotation), n = Math.abs(Math.cos(r)), i = Math.abs(Math.sin(r)), o = this._getLabelSizes(), s = e.autoSkipPadding || 0, a = o ? o.widest.width + s : 0, l = o ? o.highest.height + s : 0;
    return this.isHorizontal() ? l * n > a * i ? a / n : l / i : l * i < a * n ? l / n : a / i;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const r = this.axis, n = this.chart, i = this.options, { grid: o, position: s, border: a } = i, l = o.offset, c = this.isHorizontal(), f = this.ticks.length + (l ? 1 : 0), d = Yi(o), h = [], g = a.setContext(this.getContext()), p = g.display ? g.width : 0, y = p / 2, b = function(I) {
      return En(n, I, p);
    };
    let x, S, O, _, B, N, j, W, G, ee, fe, P;
    if (s === "top")
      x = b(this.bottom), N = this.bottom - d, W = x - y, ee = b(e.top) + y, P = e.bottom;
    else if (s === "bottom")
      x = b(this.top), ee = e.top, P = b(e.bottom) - y, N = x + y, W = this.top + d;
    else if (s === "left")
      x = b(this.right), B = this.right - d, j = x - y, G = b(e.left) + y, fe = e.right;
    else if (s === "right")
      x = b(this.left), G = e.left, fe = b(e.right) - y, B = x + y, j = this.left + d;
    else if (r === "x") {
      if (s === "center")
        x = b((e.top + e.bottom) / 2 + 0.5);
      else if (Be(s)) {
        const I = Object.keys(s)[0], V = s[I];
        x = b(this.chart.scales[I].getPixelForValue(V));
      }
      ee = e.top, P = e.bottom, N = x + y, W = N + d;
    } else if (r === "y") {
      if (s === "center")
        x = b((e.left + e.right) / 2);
      else if (Be(s)) {
        const I = Object.keys(s)[0], V = s[I];
        x = b(this.chart.scales[I].getPixelForValue(V));
      }
      B = x - y, j = B - d, G = e.left, fe = e.right;
    }
    const z = Oe(i.ticks.maxTicksLimit, f), U = Math.max(1, Math.ceil(f / z));
    for (S = 0; S < f; S += U) {
      const I = this.getContext(S), V = o.setContext(I), te = a.setContext(I), X = V.lineWidth, H = V.color, $ = te.dash || [], se = te.dashOffset, he = V.tickWidth, pe = V.tickColor, me = V.tickBorderDash || [], L = V.tickBorderDashOffset;
      O = l6(this, S, l), O !== void 0 && (_ = En(n, O, X), c ? B = j = G = fe = _ : N = W = ee = P = _, h.push({
        tx1: B,
        ty1: N,
        tx2: j,
        ty2: W,
        x1: G,
        y1: ee,
        x2: fe,
        y2: P,
        width: X,
        color: H,
        borderDash: $,
        borderDashOffset: se,
        tickWidth: he,
        tickColor: pe,
        tickBorderDash: me,
        tickBorderDashOffset: L
      }));
    }
    return this._ticksLength = f, this._borderValue = x, h;
  }
  _computeLabelItems(e) {
    const r = this.axis, n = this.options, { position: i, ticks: o } = n, s = this.isHorizontal(), a = this.ticks, { align: l, crossAlign: c, padding: u, mirror: f } = o, d = Yi(n.grid), h = d + u, g = f ? -u : h, p = -pr(this.labelRotation), y = [];
    let b, x, S, O, _, B, N, j, W, G, ee, fe, P = "middle";
    if (i === "top")
      B = this.bottom - g, N = this._getXAxisLabelAlignment();
    else if (i === "bottom")
      B = this.top + g, N = this._getXAxisLabelAlignment();
    else if (i === "left") {
      const U = this._getYAxisLabelAlignment(d);
      N = U.textAlign, _ = U.x;
    } else if (i === "right") {
      const U = this._getYAxisLabelAlignment(d);
      N = U.textAlign, _ = U.x;
    } else if (r === "x") {
      if (i === "center")
        B = (e.top + e.bottom) / 2 + h;
      else if (Be(i)) {
        const U = Object.keys(i)[0], I = i[U];
        B = this.chart.scales[U].getPixelForValue(I) + h;
      }
      N = this._getXAxisLabelAlignment();
    } else if (r === "y") {
      if (i === "center")
        _ = (e.left + e.right) / 2 - h;
      else if (Be(i)) {
        const U = Object.keys(i)[0], I = i[U];
        _ = this.chart.scales[U].getPixelForValue(I);
      }
      N = this._getYAxisLabelAlignment(d).textAlign;
    }
    r === "y" && (l === "start" ? P = "top" : l === "end" && (P = "bottom"));
    const z = this._getLabelSizes();
    for (b = 0, x = a.length; b < x; ++b) {
      S = a[b], O = S.label;
      const U = o.setContext(this.getContext(b));
      j = this.getPixelForTick(b) + o.labelOffset, W = this._resolveTickFontOptions(b), G = W.lineHeight, ee = it(O) ? O.length : 1;
      const I = ee / 2, V = U.color, te = U.textStrokeColor, X = U.textStrokeWidth;
      let H = N;
      s ? (_ = j, N === "inner" && (b === x - 1 ? H = this.options.reverse ? "left" : "right" : b === 0 ? H = this.options.reverse ? "right" : "left" : H = "center"), i === "top" ? c === "near" || p !== 0 ? fe = -ee * G + G / 2 : c === "center" ? fe = -z.highest.height / 2 - I * G + G : fe = -z.highest.height + G / 2 : c === "near" || p !== 0 ? fe = G / 2 : c === "center" ? fe = z.highest.height / 2 - I * G : fe = z.highest.height - ee * G, f && (fe *= -1), p !== 0 && !U.showLabelBackdrop && (_ += G / 2 * Math.sin(p))) : (B = j, fe = (1 - ee) * G / 2);
      let $;
      if (U.showLabelBackdrop) {
        const se = Mt(U.backdropPadding), he = z.heights[b], pe = z.widths[b];
        let me = fe - se.top, L = 0 - se.left;
        switch (P) {
          case "middle":
            me -= he / 2;
            break;
          case "bottom":
            me -= he;
            break;
        }
        switch (N) {
          case "center":
            L -= pe / 2;
            break;
          case "right":
            L -= pe;
            break;
        }
        $ = {
          left: L,
          top: me,
          width: pe + se.width,
          height: he + se.height,
          color: U.backdropColor
        };
      }
      y.push({
        label: O,
        font: W,
        textOffset: fe,
        options: {
          rotation: p,
          color: V,
          strokeColor: te,
          strokeWidth: X,
          textAlign: H,
          textBaseline: P,
          translation: [
            _,
            B
          ],
          backdrop: $
        }
      });
    }
    return y;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: r } = this.options;
    if (-pr(this.labelRotation))
      return e === "top" ? "left" : "right";
    let i = "center";
    return r.align === "start" ? i = "left" : r.align === "end" ? i = "right" : r.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(e) {
    const { position: r, ticks: { crossAlign: n, mirror: i, padding: o } } = this.options, s = this._getLabelSizes(), a = e + o, l = s.widest.width;
    let c, u;
    return r === "left" ? i ? (u = this.right + o, n === "near" ? c = "left" : n === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - a, n === "near" ? c = "right" : n === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : r === "right" ? i ? (u = this.left + o, n === "near" ? c = "right" : n === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + a, n === "near" ? c = "left" : n === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, r = this.options.position;
    if (r === "left" || r === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (r === "top" || r === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: r }, left: n, top: i, width: o, height: s } = this;
    r && (e.save(), e.fillStyle = r, e.fillRect(n, i, o, s), e.restore());
  }
  getLineWidthForValue(e) {
    const r = this.options.grid;
    if (!this._isVisible() || !r.display)
      return 0;
    const i = this.ticks.findIndex((o) => o.value === e);
    return i >= 0 ? r.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(e) {
    const r = this.options.grid, n = this.ctx, i = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let o, s;
    const a = (l, c, u) => {
      !u.width || !u.color || (n.save(), n.lineWidth = u.width, n.strokeStyle = u.color, n.setLineDash(u.borderDash || []), n.lineDashOffset = u.borderDashOffset, n.beginPath(), n.moveTo(l.x, l.y), n.lineTo(c.x, c.y), n.stroke(), n.restore());
    };
    if (r.display)
      for (o = 0, s = i.length; o < s; ++o) {
        const l = i[o];
        r.drawOnChartArea && a({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), r.drawTicks && a({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: r, options: { border: n, grid: i } } = this, o = n.setContext(this.getContext()), s = n.display ? o.width : 0;
    if (!s)
      return;
    const a = i.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, f, d;
    this.isHorizontal() ? (c = En(e, this.left, s) - s / 2, u = En(e, this.right, a) + a / 2, f = d = l) : (f = En(e, this.top, s) - s / 2, d = En(e, this.bottom, a) + a / 2, c = u = l), r.save(), r.lineWidth = o.width, r.strokeStyle = o.color, r.beginPath(), r.moveTo(c, f), r.lineTo(u, d), r.stroke(), r.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const n = this.ctx, i = this._computeLabelArea();
    i && Ka(n, i);
    const o = this.getLabelItems(e);
    for (const s of o) {
      const a = s.options, l = s.font, c = s.label, u = s.textOffset;
      Hn(n, c, 0, u, l, a);
    }
    i && Xa(n);
  }
  drawTitle() {
    const { ctx: e, options: { position: r, title: n, reverse: i } } = this;
    if (!n.display)
      return;
    const o = vt(n.font), s = Mt(n.padding), a = n.align;
    let l = o.lineHeight / 2;
    r === "bottom" || r === "center" || Be(r) ? (l += s.bottom, it(n.text) && (l += o.lineHeight * (n.text.length - 1))) : l += s.top;
    const { titleX: c, titleY: u, maxWidth: f, rotation: d } = h6(this, l, r, a);
    Hn(e, n.text, 0, 0, o, {
      color: n.color,
      maxWidth: f,
      rotation: d,
      textAlign: d6(a, r, i),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, r = e.ticks && e.ticks.z || 0, n = Oe(e.grid && e.grid.z, -1), i = Oe(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== Qn.prototype.draw ? [
      {
        z: r,
        draw: (o) => {
          this.draw(o);
        }
      }
    ] : [
      {
        z: n,
        draw: (o) => {
          this.drawBackground(), this.drawGrid(o), this.drawTitle();
        }
      },
      {
        z: i,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: r,
        draw: (o) => {
          this.drawLabels(o);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const r = this.chart.getSortedVisibleDatasetMetas(), n = this.axis + "AxisID", i = [];
    let o, s;
    for (o = 0, s = r.length; o < s; ++o) {
      const a = r[o];
      a[n] === this.id && (!e || a.type === e) && i.push(a);
    }
    return i;
  }
  _resolveTickFontOptions(e) {
    const r = this.options.ticks.setContext(this.getContext(e));
    return vt(r.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class Es {
  constructor(e, r, n) {
    this.type = e, this.scope = r, this.override = n, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const r = Object.getPrototypeOf(e);
    let n;
    m6(r) && (n = this.register(r));
    const i = this.items, o = e.id, s = this.scope + "." + o;
    if (!o)
      throw new Error("class does not have id: " + e);
    return o in i || (i[o] = e, p6(e, s, n), this.override && gt.override(e.id, e.overrides)), s;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const r = this.items, n = e.id, i = this.scope;
    n in r && delete r[n], i && n in gt[i] && (delete gt[i][n], this.override && delete qn[n]);
  }
}
function p6(t, e, r) {
  const n = Io(/* @__PURE__ */ Object.create(null), [
    r ? gt.get(r) : {},
    gt.get(e),
    t.defaults
  ]);
  gt.set(e, n), t.defaultRoutes && g6(e, t.defaultRoutes), t.descriptors && gt.describe(e, t.descriptors);
}
function g6(t, e) {
  Object.keys(e).forEach((r) => {
    const n = r.split("."), i = n.pop(), o = [
      t
    ].concat(n).join("."), s = e[r].split("."), a = s.pop(), l = s.join(".");
    gt.route(o, i, l, a);
  });
}
function m6(t) {
  return "id" in t && "defaults" in t;
}
class y6 {
  constructor() {
    this.controllers = new Es(gr, "datasets", !0), this.elements = new Es(Xr, "elements"), this.plugins = new Es(Object, "plugins"), this.scales = new Es(Qn, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...e) {
    this._each("register", e);
  }
  remove(...e) {
    this._each("unregister", e);
  }
  addControllers(...e) {
    this._each("register", e, this.controllers);
  }
  addElements(...e) {
    this._each("register", e, this.elements);
  }
  addPlugins(...e) {
    this._each("register", e, this.plugins);
  }
  addScales(...e) {
    this._each("register", e, this.scales);
  }
  getController(e) {
    return this._get(e, this.controllers, "controller");
  }
  getElement(e) {
    return this._get(e, this.elements, "element");
  }
  getPlugin(e) {
    return this._get(e, this.plugins, "plugin");
  }
  getScale(e) {
    return this._get(e, this.scales, "scale");
  }
  removeControllers(...e) {
    this._each("unregister", e, this.controllers);
  }
  removeElements(...e) {
    this._each("unregister", e, this.elements);
  }
  removePlugins(...e) {
    this._each("unregister", e, this.plugins);
  }
  removeScales(...e) {
    this._each("unregister", e, this.scales);
  }
  _each(e, r, n) {
    [
      ...r
    ].forEach((i) => {
      const o = n || this._getRegistryForType(i);
      n || o.isForType(i) || o === this.plugins && i.id ? this._exec(e, o, i) : $e(i, (s) => {
        const a = n || this._getRegistryForType(s);
        this._exec(e, a, s);
      });
    });
  }
  _exec(e, r, n) {
    const i = Fu(e);
    nt(n["before" + i], [], n), r[e](n), nt(n["after" + i], [], n);
  }
  _getRegistryForType(e) {
    for (let r = 0; r < this._typedRegistries.length; r++) {
      const n = this._typedRegistries[r];
      if (n.isForType(e))
        return n;
    }
    return this.plugins;
  }
  _get(e, r, n) {
    const i = r.get(e);
    if (i === void 0)
      throw new Error('"' + e + '" is not a registered ' + n + ".");
    return i;
  }
}
var vr = /* @__PURE__ */ new y6();
class b6 {
  constructor() {
    this._init = [];
  }
  notify(e, r, n, i) {
    r === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install"));
    const o = i ? this._descriptors(e).filter(i) : this._descriptors(e), s = this._notify(o, e, r, n);
    return r === "afterDestroy" && (this._notify(o, e, "stop"), this._notify(this._init, e, "uninstall")), s;
  }
  _notify(e, r, n, i) {
    i = i || {};
    for (const o of e) {
      const s = o.plugin, a = s[n], l = [
        r,
        i,
        o.options
      ];
      if (nt(a, l, s) === !1 && i.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    We(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const r = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), r;
  }
  _createDescriptors(e, r) {
    const n = e && e.config, i = Oe(n.options && n.options.plugins, {}), o = v6(n);
    return i === !1 && !r ? [] : w6(e, o, i, r);
  }
  _notifyStateChanges(e) {
    const r = this._oldCache || [], n = this._cache, i = (o, s) => o.filter((a) => !s.some((l) => a.plugin.id === l.plugin.id));
    this._notify(i(r, n), e, "stop"), this._notify(i(n, r), e, "start");
  }
}
function v6(t) {
  const e = {}, r = [], n = Object.keys(vr.plugins.items);
  for (let o = 0; o < n.length; o++)
    r.push(vr.getPlugin(n[o]));
  const i = t.plugins || [];
  for (let o = 0; o < i.length; o++) {
    const s = i[o];
    r.indexOf(s) === -1 && (r.push(s), e[s.id] = !0);
  }
  return {
    plugins: r,
    localIds: e
  };
}
function A6(t, e) {
  return !e && t === !1 ? null : t === !0 ? {} : t;
}
function w6(t, { plugins: e, localIds: r }, n, i) {
  const o = [], s = t.getContext();
  for (const a of e) {
    const l = a.id, c = A6(n[l], i);
    c !== null && o.push({
      plugin: a,
      options: x6(t.config, {
        plugin: a,
        local: r[l]
      }, c, s)
    });
  }
  return o;
}
function x6(t, { plugin: e, local: r }, n, i) {
  const o = t.pluginScopeKeys(e), s = t.getOptionScopes(n, o);
  return r && e.defaults && s.push(e.defaults), t.createResolver(s, i, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function Lc(t, e) {
  const r = gt.datasets[t] || {};
  return ((e.datasets || {})[t] || {}).indexAxis || e.indexAxis || r.indexAxis || "x";
}
function _6(t, e) {
  let r = t;
  return t === "_index_" ? r = e : t === "_value_" && (r = e === "x" ? "y" : "x"), r;
}
function S6(t, e) {
  return t === e ? "_index_" : "_value_";
}
function sh(t) {
  if (t === "x" || t === "y" || t === "r")
    return t;
}
function E6(t) {
  if (t === "top" || t === "bottom")
    return "x";
  if (t === "left" || t === "right")
    return "y";
}
function Fc(t, ...e) {
  if (sh(t))
    return t;
  for (const r of e) {
    const n = r.axis || E6(r.position) || t.length > 1 && sh(t[0].toLowerCase());
    if (n)
      return n;
  }
  throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`);
}
function ah(t, e, r) {
  if (r[e + "AxisID"] === t)
    return {
      axis: e
    };
}
function k6(t, e) {
  if (e.data && e.data.datasets) {
    const r = e.data.datasets.filter((n) => n.xAxisID === t || n.yAxisID === t);
    if (r.length)
      return ah(t, "x", r[0]) || ah(t, "y", r[0]);
  }
  return {};
}
function C6(t, e) {
  const r = qn[t.type] || {
    scales: {}
  }, n = e.scales || {}, i = Lc(t.type, e), o = /* @__PURE__ */ Object.create(null);
  return Object.keys(n).forEach((s) => {
    const a = n[s];
    if (!Be(a))
      return console.error(`Invalid scale configuration for scale: ${s}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${s}`);
    const l = Fc(s, a, k6(s, t), gt.scales[a.type]), c = S6(l, i), u = r.scales || {};
    o[s] = go(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      a,
      u[l],
      u[c]
    ]);
  }), t.data.datasets.forEach((s) => {
    const a = s.type || t.type, l = s.indexAxis || Lc(a, e), u = (qn[a] || {}).scales || {};
    Object.keys(u).forEach((f) => {
      const d = _6(f, l), h = s[d + "AxisID"] || d;
      o[h] = o[h] || /* @__PURE__ */ Object.create(null), go(o[h], [
        {
          axis: d
        },
        n[h],
        u[f]
      ]);
    });
  }), Object.keys(o).forEach((s) => {
    const a = o[s];
    go(a, [
      gt.scales[a.type],
      gt.scale
    ]);
  }), o;
}
function q1(t) {
  const e = t.options || (t.options = {});
  e.plugins = Oe(e.plugins, {}), e.scales = C6(t, e);
}
function H1(t) {
  return t = t || {}, t.datasets = t.datasets || [], t.labels = t.labels || [], t;
}
function T6(t) {
  return t = t || {}, t.data = H1(t.data), q1(t), t;
}
const lh = /* @__PURE__ */ new Map(), Y1 = /* @__PURE__ */ new Set();
function ks(t, e) {
  let r = lh.get(t);
  return r || (r = e(), lh.set(t, r), Y1.add(r)), r;
}
const Ki = (t, e, r) => {
  const n = hn(e, r);
  n !== void 0 && t.add(n);
};
class O6 {
  constructor(e) {
    this._config = T6(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = H1(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), q1(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return ks(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, r) {
    return ks(`${e}.transition.${r}`, () => [
      [
        `datasets.${e}.transitions.${r}`,
        `transitions.${r}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, r) {
    return ks(`${e}-${r}`, () => [
      [
        `datasets.${e}.elements.${r}`,
        `datasets.${e}`,
        `elements.${r}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const r = e.id, n = this.type;
    return ks(`${n}-plugin-${r}`, () => [
      [
        `plugins.${r}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, r) {
    const n = this._scopeCache;
    let i = n.get(e);
    return (!i || r) && (i = /* @__PURE__ */ new Map(), n.set(e, i)), i;
  }
  getOptionScopes(e, r, n) {
    const { options: i, type: o } = this, s = this._cachedScopes(e, n), a = s.get(r);
    if (a)
      return a;
    const l = /* @__PURE__ */ new Set();
    r.forEach((u) => {
      e && (l.add(e), u.forEach((f) => Ki(l, e, f))), u.forEach((f) => Ki(l, i, f)), u.forEach((f) => Ki(l, qn[o] || {}, f)), u.forEach((f) => Ki(l, gt, f)), u.forEach((f) => Ki(l, Mc, f));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), Y1.has(r) && s.set(r, c), c;
  }
  chartOptionScopes() {
    const { options: e, type: r } = this;
    return [
      e,
      qn[r] || {},
      gt.datasets[r] || {},
      {
        type: r
      },
      gt,
      Mc
    ];
  }
  resolveNamedOptions(e, r, n, i = [
    ""
  ]) {
    const o = {
      $shared: !0
    }, { resolver: s, subPrefixes: a } = ch(this._resolverCache, e, i);
    let l = s;
    if (P6(s, r)) {
      o.$shared = !1, n = pn(n) ? n() : n;
      const c = this.createResolver(e, n, a);
      l = Si(s, n, c);
    }
    for (const c of r)
      o[c] = l[c];
    return o;
  }
  createResolver(e, r, n = [
    ""
  ], i) {
    const { resolver: o } = ch(this._resolverCache, e, n);
    return Be(r) ? Si(o, r, void 0, i) : o;
  }
}
function ch(t, e, r) {
  let n = t.get(e);
  n || (n = /* @__PURE__ */ new Map(), t.set(e, n));
  const i = r.join();
  let o = n.get(i);
  return o || (o = {
    resolver: qu(e, r),
    subPrefixes: r.filter((a) => !a.toLowerCase().includes("hover"))
  }, n.set(i, o)), o;
}
const I6 = (t) => Be(t) && Object.getOwnPropertyNames(t).reduce((e, r) => e || pn(t[r]), !1);
function P6(t, e) {
  const { isScriptable: r, isIndexable: n } = S1(t);
  for (const i of e) {
    const o = r(i), s = n(i), a = (s || o) && t[i];
    if (o && (pn(a) || I6(a)) || s && it(a))
      return !0;
  }
  return !1;
}
var R6 = "4.4.0";
const D6 = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function uh(t, e) {
  return t === "top" || t === "bottom" || D6.indexOf(t) === -1 && e === "x";
}
function fh(t, e) {
  return function(r, n) {
    return r[t] === n[t] ? r[e] - n[e] : r[t] - n[t];
  };
}
function dh(t) {
  const e = t.chart, r = e.options.animation;
  e.notifyPlugins("afterRender"), nt(r && r.onComplete, [
    t
  ], e);
}
function M6(t) {
  const e = t.chart, r = e.options.animation;
  nt(r && r.onProgress, [
    t
  ], e);
}
function K1(t) {
  return I1() && typeof t == "string" ? t = document.getElementById(t) : t && t.length && (t = t[0]), t && t.canvas && (t = t.canvas), t;
}
const Js = {}, hh = (t) => {
  const e = K1(t);
  return Object.values(Js).filter((r) => r.canvas === e).pop();
};
function N6(t, e, r) {
  const n = Object.keys(t);
  for (const i of n) {
    const o = +i;
    if (o >= e) {
      const s = t[i];
      delete t[i], (r > 0 || o > e) && (t[o + r] = s);
    }
  }
}
function B6(t, e, r, n) {
  return !r || t.type === "mouseout" ? null : n ? e : t;
}
function Cs(t, e, r) {
  return t.options.clip ? t[r] : e[r];
}
function L6(t, e) {
  const { xScale: r, yScale: n } = t;
  return r && n ? {
    left: Cs(r, e, "left"),
    right: Cs(r, e, "right"),
    top: Cs(n, e, "top"),
    bottom: Cs(n, e, "bottom")
  } : e;
}
class Nr {
  static register(...e) {
    vr.add(...e), ph();
  }
  static unregister(...e) {
    vr.remove(...e), ph();
  }
  constructor(e, r) {
    const n = this.config = new O6(r), i = K1(e), o = hh(i);
    if (o)
      throw new Error("Canvas is already in use. Chart with ID '" + o.id + "' must be destroyed before the canvas with ID '" + o.canvas.id + "' can be reused.");
    const s = n.createResolver(n.chartOptionScopes(), this.getContext());
    this.platform = new (n.platform || e6(i))(), this.platform.updateConfig(n);
    const a = this.platform.acquireContext(i, s.aspectRatio), l = a && a.canvas, c = l && l.height, u = l && l.width;
    if (this.id = j3(), this.ctx = a, this.canvas = l, this.width = u, this.height = c, this._options = s, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new b6(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = t2((f) => this.update(f), s.resizeDelay || 0), this._dataChanges = [], Js[this.id] = this, !a || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Rr.listen(this, "complete", dh), Rr.listen(this, "progress", M6), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: r }, width: n, height: i, _aspectRatio: o } = this;
    return We(e) ? r && o ? o : i ? n / i : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return vr;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Nd(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Rd(this.canvas, this.ctx), this;
  }
  stop() {
    return Rr.stop(this), this;
  }
  resize(e, r) {
    Rr.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: r
    } : this._resize(e, r);
  }
  _resize(e, r) {
    const n = this.options, i = this.canvas, o = n.maintainAspectRatio && this.aspectRatio, s = this.platform.getMaximumSize(i, e, r, o), a = n.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = s.width, this.height = s.height, this._aspectRatio = this.aspectRatio, Nd(this, a, !0) && (this.notifyPlugins("resize", {
      size: s
    }), nt(n.onResize, [
      this,
      s
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const r = this.options.scales || {};
    $e(r, (n, i) => {
      n.id = i;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, r = e.scales, n = this.scales, i = Object.keys(n).reduce((s, a) => (s[a] = !1, s), {});
    let o = [];
    r && (o = o.concat(Object.keys(r).map((s) => {
      const a = r[s], l = Fc(s, a), c = l === "r", u = l === "x";
      return {
        options: a,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), $e(o, (s) => {
      const a = s.options, l = a.id, c = Fc(l, a), u = Oe(a.type, s.dtype);
      (a.position === void 0 || uh(a.position, c) !== uh(s.dposition)) && (a.position = s.dposition), i[l] = !0;
      let f = null;
      if (l in n && n[l].type === u)
        f = n[l];
      else {
        const d = vr.getScale(u);
        f = new d({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), n[f.id] = f;
      }
      f.init(a, e);
    }), $e(i, (s, a) => {
      s || delete n[a];
    }), $e(n, (s) => {
      Rt.configure(this, s, s.options), Rt.addBox(this, s);
    });
  }
  _updateMetasets() {
    const e = this._metasets, r = this.data.datasets.length, n = e.length;
    if (e.sort((i, o) => i.index - o.index), n > r) {
      for (let i = r; i < n; ++i)
        this._destroyDatasetMeta(i);
      e.splice(r, n - r);
    }
    this._sortedMetasets = e.slice(0).sort(fh("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: r } } = this;
    e.length > r.length && delete this._stacks, e.forEach((n, i) => {
      r.filter((o) => o === n._dataset).length === 0 && this._destroyDatasetMeta(i);
    });
  }
  buildOrUpdateControllers() {
    const e = [], r = this.data.datasets;
    let n, i;
    for (this._removeUnreferencedMetasets(), n = 0, i = r.length; n < i; n++) {
      const o = r[n];
      let s = this.getDatasetMeta(n);
      const a = o.type || this.config.type;
      if (s.type && s.type !== a && (this._destroyDatasetMeta(n), s = this.getDatasetMeta(n)), s.type = a, s.indexAxis = o.indexAxis || Lc(a, this.options), s.order = o.order || 0, s.index = n, s.label = "" + o.label, s.visible = this.isDatasetVisible(n), s.controller)
        s.controller.updateIndex(n), s.controller.linkScales();
      else {
        const l = vr.getController(a), { datasetElementType: c, dataElementType: u } = gt.datasets[a];
        Object.assign(l, {
          dataElementType: vr.getElement(u),
          datasetElementType: c && vr.getElement(c)
        }), s.controller = new l(this, n), e.push(s.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    $e(this.data.datasets, (e, r) => {
      this.getDatasetMeta(r).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const r = this.config;
    r.update();
    const n = this._options = r.createResolver(r.chartOptionScopes(), this.getContext()), i = this._animationsDisabled = !n.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const o = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let s = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: f } = this.getDatasetMeta(c), d = !i && o.indexOf(f) === -1;
      f.buildOrUpdateElements(d), s = Math.max(+f.getMaxOverflow(), s);
    }
    s = this._minPadding = n.layout.autoPadding ? s : 0, this._updateLayout(s), i || $e(o, (c) => {
      c.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(fh("z", "_idx"));
    const { _active: a, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    $e(this.scales, (e) => {
      Rt.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, r = new Set(Object.keys(this._listeners)), n = new Set(e.events);
    (!_d(r, n) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, r = this._getUniformDataChanges() || [];
    for (const { method: n, start: i, count: o } of r) {
      const s = n === "_removeElements" ? -o : o;
      N6(e, i, s);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const r = this.data.datasets.length, n = (o) => new Set(e.filter((s) => s[0] === o).map((s, a) => a + "," + s.splice(1).join(","))), i = n(0);
    for (let o = 1; o < r; o++)
      if (!_d(i, n(o)))
        return;
    return Array.from(i).map((o) => o.split(",")).map((o) => ({
      method: o[1],
      start: +o[2],
      count: +o[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Rt.update(this, this.width, this.height, e);
    const r = this.chartArea, n = r.width <= 0 || r.height <= 0;
    this._layers = [], $e(this.boxes, (i) => {
      n && i.position === "chartArea" || (i.configure && i.configure(), this._layers.push(...i._layers()));
    }, this), this._layers.forEach((i, o) => {
      i._idx = o;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let r = 0, n = this.data.datasets.length; r < n; ++r)
        this.getDatasetMeta(r).controller.configure();
      for (let r = 0, n = this.data.datasets.length; r < n; ++r)
        this._updateDataset(r, pn(e) ? e({
          datasetIndex: r
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, r) {
    const n = this.getDatasetMeta(e), i = {
      meta: n,
      index: e,
      mode: r,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", i) !== !1 && (n.controller._update(r), i.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", i));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (Rr.has(this) ? this.attached && !Rr.running(this) && Rr.start(this) : (this.draw(), dh({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: n, height: i } = this._resizeBeforeDraw;
      this._resize(n, i), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const r = this._layers;
    for (e = 0; e < r.length && r[e].z <= 0; ++e)
      r[e].draw(this.chartArea);
    for (this._drawDatasets(); e < r.length; ++e)
      r[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const r = this._sortedMetasets, n = [];
    let i, o;
    for (i = 0, o = r.length; i < o; ++i) {
      const s = r[i];
      (!e || s.visible) && n.push(s);
    }
    return n;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let r = e.length - 1; r >= 0; --r)
      this._drawDataset(e[r]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const r = this.ctx, n = e._clip, i = !n.disabled, o = L6(e, this.chartArea), s = {
      meta: e,
      index: e.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", s) !== !1 && (i && Ka(r, {
      left: n.left === !1 ? 0 : o.left - n.left,
      right: n.right === !1 ? this.width : o.right + n.right,
      top: n.top === !1 ? 0 : o.top - n.top,
      bottom: n.bottom === !1 ? this.height : o.bottom + n.bottom
    }), e.controller.draw(), i && Xa(r), s.cancelable = !1, this.notifyPlugins("afterDatasetDraw", s));
  }
  isPointInArea(e) {
    return Wr(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, r, n, i) {
    const o = Dv.modes[r];
    return typeof o == "function" ? o(this, e, n, i) : [];
  }
  getDatasetMeta(e) {
    const r = this.data.datasets[e], n = this._metasets;
    let i = n.filter((o) => o && o._dataset === r).pop();
    return i || (i = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: r && r.order || 0,
      index: e,
      _dataset: r,
      _parsed: [],
      _sorted: !1
    }, n.push(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = bn(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const r = this.data.datasets[e];
    if (!r)
      return !1;
    const n = this.getDatasetMeta(e);
    return typeof n.hidden == "boolean" ? !n.hidden : !r.hidden;
  }
  setDatasetVisibility(e, r) {
    const n = this.getDatasetMeta(e);
    n.hidden = !r;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, r, n) {
    const i = n ? "show" : "hide", o = this.getDatasetMeta(e), s = o.controller._resolveAnimations(void 0, i);
    Po(r) ? (o.data[r].hidden = !n, this.update()) : (this.setDatasetVisibility(e, n), s.update(o, {
      visible: n
    }), this.update((a) => a.datasetIndex === e ? i : void 0));
  }
  hide(e, r) {
    this._updateVisibility(e, r, !1);
  }
  show(e, r) {
    this._updateVisibility(e, r, !0);
  }
  _destroyDatasetMeta(e) {
    const r = this._metasets[e];
    r && r.controller && r.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, r;
    for (this.stop(), Rr.remove(this), e = 0, r = this.data.datasets.length; e < r; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: r } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), Rd(e, r), this.platform.releaseContext(r), this.canvas = null, this.ctx = null), delete Js[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, r = this.platform, n = (o, s) => {
      r.addEventListener(this, o, s), e[o] = s;
    }, i = (o, s, a) => {
      o.offsetX = s, o.offsetY = a, this._eventHandler(o);
    };
    $e(this.options.events, (o) => n(o, i));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, r = this.platform, n = (l, c) => {
      r.addEventListener(this, l, c), e[l] = c;
    }, i = (l, c) => {
      e[l] && (r.removeEventListener(this, l, c), delete e[l]);
    }, o = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let s;
    const a = () => {
      i("attach", a), this.attached = !0, this.resize(), n("resize", o), n("detach", s);
    };
    s = () => {
      this.attached = !1, i("resize", o), this._stop(), this._resize(0, 0), n("attach", a);
    }, r.isAttached(this.canvas) ? a() : s();
  }
  unbindEvents() {
    $e(this._listeners, (e, r) => {
      this.platform.removeEventListener(this, r, e);
    }), this._listeners = {}, $e(this._responsiveListeners, (e, r) => {
      this.platform.removeEventListener(this, r, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, r, n) {
    const i = n ? "set" : "remove";
    let o, s, a, l;
    for (r === "dataset" && (o = this.getDatasetMeta(e[0].datasetIndex), o.controller["_" + i + "DatasetHoverStyle"]()), a = 0, l = e.length; a < l; ++a) {
      s = e[a];
      const c = s && this.getDatasetMeta(s.datasetIndex).controller;
      c && c[i + "HoverStyle"](s.element, s.datasetIndex, s.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const r = this._active || [], n = e.map(({ datasetIndex: o, index: s }) => {
      const a = this.getDatasetMeta(o);
      if (!a)
        throw new Error("No dataset found at index " + o);
      return {
        datasetIndex: o,
        element: a.data[s],
        index: s
      };
    });
    !ga(n, r) && (this._active = n, this._lastEvent = null, this._updateHoverStyles(n, r));
  }
  notifyPlugins(e, r, n) {
    return this._plugins.notify(this, e, r, n);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((r) => r.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, r, n) {
    const i = this.options.hover, o = (l, c) => l.filter((u) => !c.some((f) => u.datasetIndex === f.datasetIndex && u.index === f.index)), s = o(r, e), a = n ? e : o(e, r);
    s.length && this.updateHoverStyle(s, i.mode, !1), a.length && i.mode && this.updateHoverStyle(a, i.mode, !0);
  }
  _eventHandler(e, r) {
    const n = {
      event: e,
      replay: r,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, i = (s) => (s.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", n, i) === !1)
      return;
    const o = this._handleEvent(e, r, n.inChartArea);
    return n.cancelable = !1, this.notifyPlugins("afterEvent", n, i), (o || n.changed) && this.render(), this;
  }
  _handleEvent(e, r, n) {
    const { _active: i = [], options: o } = this, s = r, a = this._getActiveElements(e, i, n, s), l = H3(e), c = B6(e, this._lastEvent, n, l);
    n && (this._lastEvent = null, nt(o.onHover, [
      e,
      a,
      this
    ], this), l && nt(o.onClick, [
      e,
      a,
      this
    ], this));
    const u = !ga(a, i);
    return (u || r) && (this._active = a, this._updateHoverStyles(a, i, r)), this._lastEvent = c, u;
  }
  _getActiveElements(e, r, n, i) {
    if (e.type === "mouseout")
      return [];
    if (!n)
      return r;
    const o = this.options.hover;
    return this.getElementsAtEventForMode(e, o.mode, o, i);
  }
}
ye(Nr, "defaults", gt), ye(Nr, "instances", Js), ye(Nr, "overrides", qn), ye(Nr, "registry", vr), ye(Nr, "version", R6), ye(Nr, "getChart", hh);
function ph() {
  return $e(Nr.instances, (t) => t._plugins.invalidate());
}
function F6(t, e, r) {
  const { startAngle: n, pixelMargin: i, x: o, y: s, outerRadius: a, innerRadius: l } = e;
  let c = i / a;
  t.beginPath(), t.arc(o, s, a, n - c, r + c), l > i ? (c = i / l, t.arc(o, s, l, r + c, n - c, !0)) : t.arc(o, s, i, r + mt, n - mt), t.closePath(), t.clip();
}
function j6(t) {
  return Vu(t, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function W6(t, e, r, n) {
  const i = j6(t.options.borderRadius), o = (r - e) / 2, s = Math.min(o, n * e / 2), a = (l) => {
    const c = (r - Math.min(o, l)) * n / 2;
    return St(l, 0, Math.min(o, c));
  };
  return {
    outerStart: a(i.outerStart),
    outerEnd: a(i.outerEnd),
    innerStart: St(i.innerStart, 0, s),
    innerEnd: St(i.innerEnd, 0, s)
  };
}
function $n(t, e, r, n) {
  return {
    x: r + t * Math.cos(e),
    y: n + t * Math.sin(e)
  };
}
function wa(t, e, r, n, i, o) {
  const { x: s, y: a, startAngle: l, pixelMargin: c, innerRadius: u } = e, f = Math.max(e.outerRadius + n + r - c, 0), d = u > 0 ? u + n + r + c : 0;
  let h = 0;
  const g = i - l;
  if (n) {
    const U = u > 0 ? u - n : 0, I = f > 0 ? f - n : 0, V = (U + I) / 2, te = V !== 0 ? g * V / (V + n) : g;
    h = (g - te) / 2;
  }
  const p = Math.max(1e-3, g * f - r / st) / f, y = (g - p) / 2, b = l + y + h, x = i - y - h, { outerStart: S, outerEnd: O, innerStart: _, innerEnd: B } = W6(e, d, f, x - b), N = f - S, j = f - O, W = b + S / N, G = x - O / j, ee = d + _, fe = d + B, P = b + _ / ee, z = x - B / fe;
  if (t.beginPath(), o) {
    const U = (W + G) / 2;
    if (t.arc(s, a, f, W, U), t.arc(s, a, f, U, G), O > 0) {
      const X = $n(j, G, s, a);
      t.arc(X.x, X.y, O, G, x + mt);
    }
    const I = $n(fe, x, s, a);
    if (t.lineTo(I.x, I.y), B > 0) {
      const X = $n(fe, z, s, a);
      t.arc(X.x, X.y, B, x + mt, z + Math.PI);
    }
    const V = (x - B / d + (b + _ / d)) / 2;
    if (t.arc(s, a, d, x - B / d, V, !0), t.arc(s, a, d, V, b + _ / d, !0), _ > 0) {
      const X = $n(ee, P, s, a);
      t.arc(X.x, X.y, _, P + Math.PI, b - mt);
    }
    const te = $n(N, b, s, a);
    if (t.lineTo(te.x, te.y), S > 0) {
      const X = $n(N, W, s, a);
      t.arc(X.x, X.y, S, b - mt, W);
    }
  } else {
    t.moveTo(s, a);
    const U = Math.cos(W) * f + s, I = Math.sin(W) * f + a;
    t.lineTo(U, I);
    const V = Math.cos(G) * f + s, te = Math.sin(G) * f + a;
    t.lineTo(V, te);
  }
  t.closePath();
}
function U6(t, e, r, n, i) {
  const { fullCircles: o, startAngle: s, circumference: a } = e;
  let l = e.endAngle;
  if (o) {
    wa(t, e, r, n, l, i);
    for (let c = 0; c < o; ++c)
      t.fill();
    isNaN(a) || (l = s + (a % ot || ot));
  }
  return wa(t, e, r, n, l, i), t.fill(), l;
}
function z6(t, e, r, n, i) {
  const { fullCircles: o, startAngle: s, circumference: a, options: l } = e, { borderWidth: c, borderJoinStyle: u, borderDash: f, borderDashOffset: d } = l, h = l.borderAlign === "inner";
  if (!c)
    return;
  t.setLineDash(f || []), t.lineDashOffset = d, h ? (t.lineWidth = c * 2, t.lineJoin = u || "round") : (t.lineWidth = c, t.lineJoin = u || "bevel");
  let g = e.endAngle;
  if (o) {
    wa(t, e, r, n, g, i);
    for (let p = 0; p < o; ++p)
      t.stroke();
    isNaN(a) || (g = s + (a % ot || ot));
  }
  h && F6(t, e, g), o || (wa(t, e, r, n, g, i), t.stroke());
}
class oo extends Xr {
  constructor(r) {
    super();
    ye(this, "circumference");
    ye(this, "endAngle");
    ye(this, "fullCircles");
    ye(this, "innerRadius");
    ye(this, "outerRadius");
    ye(this, "pixelMargin");
    ye(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, r && Object.assign(this, r);
  }
  inRange(r, n, i) {
    const o = this.getProps([
      "x",
      "y"
    ], i), { angle: s, distance: a } = p1(o, {
      x: r,
      y: n
    }), { startAngle: l, endAngle: c, innerRadius: u, outerRadius: f, circumference: d } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], i), h = (this.options.spacing + this.options.borderWidth) / 2, p = Oe(d, c - l) >= ot || Ro(s, l, c), y = Fr(a, u + h, f + h);
    return p && y;
  }
  getCenterPoint(r) {
    const { x: n, y: i, startAngle: o, endAngle: s, innerRadius: a, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], r), { offset: c, spacing: u } = this.options, f = (o + s) / 2, d = (a + l + u + c) / 2;
    return {
      x: n + Math.cos(f) * d,
      y: i + Math.sin(f) * d
    };
  }
  tooltipPosition(r) {
    return this.getCenterPoint(r);
  }
  draw(r) {
    const { options: n, circumference: i } = this, o = (n.offset || 0) / 4, s = (n.spacing || 0) / 2, a = n.circular;
    if (this.pixelMargin = n.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = i > ot ? Math.floor(i / ot) : 0, i === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    r.save();
    const l = (this.startAngle + this.endAngle) / 2;
    r.translate(Math.cos(l) * o, Math.sin(l) * o);
    const c = 1 - Math.sin(Math.min(st, i || 0)), u = o * c;
    r.fillStyle = n.backgroundColor, r.strokeStyle = n.borderColor, U6(r, this, u, s, a), z6(r, this, u, s, a), r.restore();
  }
}
ye(oo, "id", "arc"), ye(oo, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), ye(oo, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), ye(oo, "descriptors", {
  _scriptable: !0,
  _indexable: (r) => r !== "borderDash"
});
function X1(t, e, r = e) {
  t.lineCap = Oe(r.borderCapStyle, e.borderCapStyle), t.setLineDash(Oe(r.borderDash, e.borderDash)), t.lineDashOffset = Oe(r.borderDashOffset, e.borderDashOffset), t.lineJoin = Oe(r.borderJoinStyle, e.borderJoinStyle), t.lineWidth = Oe(r.borderWidth, e.borderWidth), t.strokeStyle = Oe(r.borderColor, e.borderColor);
}
function V6(t, e, r) {
  t.lineTo(r.x, r.y);
}
function q6(t) {
  return t.stepped ? h2 : t.tension || t.cubicInterpolationMode === "monotone" ? p2 : V6;
}
function J1(t, e, r = {}) {
  const n = t.length, { start: i = 0, end: o = n - 1 } = r, { start: s, end: a } = e, l = Math.max(i, s), c = Math.min(o, a), u = i < s && o < s || i > a && o > a;
  return {
    count: n,
    start: l,
    loop: e.loop,
    ilen: c < l && !u ? n + c - l : c - l
  };
}
function H6(t, e, r, n) {
  const { points: i, options: o } = e, { count: s, start: a, loop: l, ilen: c } = J1(i, r, n), u = q6(o);
  let { move: f = !0, reverse: d } = n || {}, h, g, p;
  for (h = 0; h <= c; ++h)
    g = i[(a + (d ? c - h : h)) % s], !g.skip && (f ? (t.moveTo(g.x, g.y), f = !1) : u(t, p, g, d, o.stepped), p = g);
  return l && (g = i[(a + (d ? c : 0)) % s], u(t, p, g, d, o.stepped)), !!l;
}
function Y6(t, e, r, n) {
  const i = e.points, { count: o, start: s, ilen: a } = J1(i, r, n), { move: l = !0, reverse: c } = n || {};
  let u = 0, f = 0, d, h, g, p, y, b;
  const x = (O) => (s + (c ? a - O : O)) % o, S = () => {
    p !== y && (t.lineTo(u, y), t.lineTo(u, p), t.lineTo(u, b));
  };
  for (l && (h = i[x(0)], t.moveTo(h.x, h.y)), d = 0; d <= a; ++d) {
    if (h = i[x(d)], h.skip)
      continue;
    const O = h.x, _ = h.y, B = O | 0;
    B === g ? (_ < p ? p = _ : _ > y && (y = _), u = (f * u + O) / ++f) : (S(), t.lineTo(O, _), g = B, f = 0, p = y = _), b = _;
  }
  S();
}
function jc(t) {
  const e = t.options, r = e.borderDash && e.borderDash.length;
  return !t._decimated && !t._loop && !e.tension && e.cubicInterpolationMode !== "monotone" && !e.stepped && !r ? Y6 : H6;
}
function K6(t) {
  return t.stepped ? Y2 : t.tension || t.cubicInterpolationMode === "monotone" ? K2 : Pn;
}
function X6(t, e, r, n) {
  let i = e._path;
  i || (i = e._path = new Path2D(), e.path(i, r, n) && i.closePath()), X1(t, e.options), t.stroke(i);
}
function J6(t, e, r, n) {
  const { segments: i, options: o } = e, s = jc(e);
  for (const a of i)
    X1(t, o, a.style), t.beginPath(), s(t, e, a, {
      start: r,
      end: r + n - 1
    }) && t.closePath(), t.stroke();
}
const Q6 = typeof Path2D == "function";
function G6(t, e, r, n) {
  Q6 && !e.options.segment ? X6(t, e, r, n) : J6(t, e, r, n);
}
class rn extends Xr {
  constructor(e) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e);
  }
  updateControlPoints(e, r) {
    const n = this.options;
    if ((n.tension || n.cubicInterpolationMode === "monotone") && !n.stepped && !this._pointsUpdated) {
      const i = n.spanGaps ? this._loop : this._fullLoop;
      F2(this._points, n, e, i, r), this._pointsUpdated = !0;
    }
  }
  set points(e) {
    this._points = e, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = $2(this, this.options.segment));
  }
  first() {
    const e = this.segments, r = this.points;
    return e.length && r[e[0].start];
  }
  last() {
    const e = this.segments, r = this.points, n = e.length;
    return n && r[e[n - 1].end];
  }
  interpolate(e, r) {
    const n = this.options, i = e[r], o = this.points, s = N1(this, {
      property: r,
      start: i,
      end: i
    });
    if (!s.length)
      return;
    const a = [], l = K6(n);
    let c, u;
    for (c = 0, u = s.length; c < u; ++c) {
      const { start: f, end: d } = s[c], h = o[f], g = o[d];
      if (h === g) {
        a.push(h);
        continue;
      }
      const p = Math.abs((i - h[r]) / (g[r] - h[r])), y = l(h, g, p, n.stepped);
      y[r] = e[r], a.push(y);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(e, r, n) {
    return jc(this)(e, this, r, n);
  }
  path(e, r, n) {
    const i = this.segments, o = jc(this);
    let s = this._loop;
    r = r || 0, n = n || this.points.length - r;
    for (const a of i)
      s &= o(e, this, a, {
        start: r,
        end: r + n - 1
      });
    return !!s;
  }
  draw(e, r, n, i) {
    const o = this.options || {};
    (this.points || []).length && o.borderWidth && (e.save(), G6(e, this, n, i), e.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
ye(rn, "id", "line"), ye(rn, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), ye(rn, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), ye(rn, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
});
function gh(t, e, r, n) {
  const i = t.options, { [r]: o } = t.getProps([
    r
  ], n);
  return Math.abs(e - o) < i.radius + i.hitRadius;
}
class Qs extends Xr {
  constructor(r) {
    super();
    ye(this, "parsed");
    ye(this, "skip");
    ye(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, r && Object.assign(this, r);
  }
  inRange(r, n, i) {
    const o = this.options, { x: s, y: a } = this.getProps([
      "x",
      "y"
    ], i);
    return Math.pow(r - s, 2) + Math.pow(n - a, 2) < Math.pow(o.hitRadius + o.radius, 2);
  }
  inXRange(r, n) {
    return gh(this, r, "x", n);
  }
  inYRange(r, n) {
    return gh(this, r, "y", n);
  }
  getCenterPoint(r) {
    const { x: n, y: i } = this.getProps([
      "x",
      "y"
    ], r);
    return {
      x: n,
      y: i
    };
  }
  size(r) {
    r = r || this.options || {};
    let n = r.radius || 0;
    n = Math.max(n, n && r.hoverRadius || 0);
    const i = n && r.borderWidth || 0;
    return (n + i) * 2;
  }
  draw(r, n) {
    const i = this.options;
    this.skip || i.radius < 0.1 || !Wr(this, n, this.size(i) / 2) || (r.strokeStyle = i.borderColor, r.lineWidth = i.borderWidth, r.fillStyle = i.backgroundColor, Nc(r, i, this.x, this.y));
  }
  getRange() {
    const r = this.options || {};
    return r.radius + r.hitRadius;
  }
}
ye(Qs, "id", "point"), /**
* @type {any}
*/
ye(Qs, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
ye(Qs, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Q1(t, e) {
  const { x: r, y: n, base: i, width: o, height: s } = t.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], e);
  let a, l, c, u, f;
  return t.horizontal ? (f = s / 2, a = Math.min(r, i), l = Math.max(r, i), c = n - f, u = n + f) : (f = o / 2, a = r - f, l = r + f, c = Math.min(n, i), u = Math.max(n, i)), {
    left: a,
    top: c,
    right: l,
    bottom: u
  };
}
function nn(t, e, r, n) {
  return t ? 0 : St(e, r, n);
}
function Z6(t, e, r) {
  const n = t.options.borderWidth, i = t.borderSkipped, o = _1(n);
  return {
    t: nn(i.top, o.top, 0, r),
    r: nn(i.right, o.right, 0, e),
    b: nn(i.bottom, o.bottom, 0, r),
    l: nn(i.left, o.left, 0, e)
  };
}
function $6(t, e, r) {
  const { enableBorderRadius: n } = t.getProps([
    "enableBorderRadius"
  ]), i = t.options.borderRadius, o = Ln(i), s = Math.min(e, r), a = t.borderSkipped, l = n || Be(i);
  return {
    topLeft: nn(!l || a.top || a.left, o.topLeft, 0, s),
    topRight: nn(!l || a.top || a.right, o.topRight, 0, s),
    bottomLeft: nn(!l || a.bottom || a.left, o.bottomLeft, 0, s),
    bottomRight: nn(!l || a.bottom || a.right, o.bottomRight, 0, s)
  };
}
function eA(t) {
  const e = Q1(t), r = e.right - e.left, n = e.bottom - e.top, i = Z6(t, r / 2, n / 2), o = $6(t, r / 2, n / 2);
  return {
    outer: {
      x: e.left,
      y: e.top,
      w: r,
      h: n,
      radius: o
    },
    inner: {
      x: e.left + i.l,
      y: e.top + i.t,
      w: r - i.l - i.r,
      h: n - i.t - i.b,
      radius: {
        topLeft: Math.max(0, o.topLeft - Math.max(i.t, i.l)),
        topRight: Math.max(0, o.topRight - Math.max(i.t, i.r)),
        bottomLeft: Math.max(0, o.bottomLeft - Math.max(i.b, i.l)),
        bottomRight: Math.max(0, o.bottomRight - Math.max(i.b, i.r))
      }
    }
  };
}
function Zl(t, e, r, n) {
  const i = e === null, o = r === null, a = t && !(i && o) && Q1(t, n);
  return a && (i || Fr(e, a.left, a.right)) && (o || Fr(r, a.top, a.bottom));
}
function tA(t) {
  return t.topLeft || t.topRight || t.bottomLeft || t.bottomRight;
}
function rA(t, e) {
  t.rect(e.x, e.y, e.w, e.h);
}
function $l(t, e, r = {}) {
  const n = t.x !== r.x ? -e : 0, i = t.y !== r.y ? -e : 0, o = (t.x + t.w !== r.x + r.w ? e : 0) - n, s = (t.y + t.h !== r.y + r.h ? e : 0) - i;
  return {
    x: t.x + n,
    y: t.y + i,
    w: t.w + o,
    h: t.h + s,
    radius: t.radius
  };
}
class Gs extends Xr {
  constructor(e) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, e && Object.assign(this, e);
  }
  draw(e) {
    const { inflateAmount: r, options: { borderColor: n, backgroundColor: i } } = this, { inner: o, outer: s } = eA(this), a = tA(s.radius) ? Do : rA;
    e.save(), (s.w !== o.w || s.h !== o.h) && (e.beginPath(), a(e, $l(s, r, o)), e.clip(), a(e, $l(o, -r, s)), e.fillStyle = n, e.fill("evenodd")), e.beginPath(), a(e, $l(o, r)), e.fillStyle = i, e.fill(), e.restore();
  }
  inRange(e, r, n) {
    return Zl(this, e, r, n);
  }
  inXRange(e, r) {
    return Zl(this, e, null, r);
  }
  inYRange(e, r) {
    return Zl(this, null, e, r);
  }
  getCenterPoint(e) {
    const { x: r, y: n, base: i, horizontal: o } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], e);
    return {
      x: o ? (r + i) / 2 : r,
      y: o ? n : (n + i) / 2
    };
  }
  getRange(e) {
    return e === "x" ? this.width / 2 : this.height / 2;
  }
}
ye(Gs, "id", "bar"), ye(Gs, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), ye(Gs, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var nA = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: oo,
  BarElement: Gs,
  LineElement: rn,
  PointElement: Qs
});
const Wc = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], mh = /* @__PURE__ */ Wc.map((t) => t.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function G1(t) {
  return Wc[t % Wc.length];
}
function Z1(t) {
  return mh[t % mh.length];
}
function iA(t, e) {
  return t.borderColor = G1(e), t.backgroundColor = Z1(e), ++e;
}
function oA(t, e) {
  return t.backgroundColor = t.data.map(() => G1(e++)), e;
}
function sA(t, e) {
  return t.backgroundColor = t.data.map(() => Z1(e++)), e;
}
function aA(t) {
  let e = 0;
  return (r, n) => {
    const i = t.getDatasetMeta(n).controller;
    i instanceof Bn ? e = oA(r, e) : i instanceof vo ? e = sA(r, e) : i && (e = iA(r, e));
  };
}
function yh(t) {
  let e;
  for (e in t)
    if (t[e].borderColor || t[e].backgroundColor)
      return !0;
  return !1;
}
function lA(t) {
  return t && (t.borderColor || t.backgroundColor);
}
var cA = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(t, e, r) {
    if (!r.enabled)
      return;
    const { data: { datasets: n }, options: i } = t.config, { elements: o } = i;
    if (!r.forceOverride && (yh(n) || lA(i) || o && yh(o)))
      return;
    const s = aA(t);
    n.forEach(s);
  }
};
function uA(t, e, r, n, i) {
  const o = i.samples || n;
  if (o >= r)
    return t.slice(e, e + r);
  const s = [], a = (r - 2) / (o - 2);
  let l = 0;
  const c = e + r - 1;
  let u = e, f, d, h, g, p;
  for (s[l++] = t[u], f = 0; f < o - 2; f++) {
    let y = 0, b = 0, x;
    const S = Math.floor((f + 1) * a) + 1 + e, O = Math.min(Math.floor((f + 2) * a) + 1, r) + e, _ = O - S;
    for (x = S; x < O; x++)
      y += t[x].x, b += t[x].y;
    y /= _, b /= _;
    const B = Math.floor(f * a) + 1 + e, N = Math.min(Math.floor((f + 1) * a) + 1, r) + e, { x: j, y: W } = t[u];
    for (h = g = -1, x = B; x < N; x++)
      g = 0.5 * Math.abs((j - y) * (t[x].y - W) - (j - t[x].x) * (b - W)), g > h && (h = g, d = t[x], p = x);
    s[l++] = d, u = p;
  }
  return s[l++] = t[c], s;
}
function fA(t, e, r, n) {
  let i = 0, o = 0, s, a, l, c, u, f, d, h, g, p;
  const y = [], b = e + r - 1, x = t[e].x, O = t[b].x - x;
  for (s = e; s < e + r; ++s) {
    a = t[s], l = (a.x - x) / O * n, c = a.y;
    const _ = l | 0;
    if (_ === u)
      c < g ? (g = c, f = s) : c > p && (p = c, d = s), i = (o * i + a.x) / ++o;
    else {
      const B = s - 1;
      if (!We(f) && !We(d)) {
        const N = Math.min(f, d), j = Math.max(f, d);
        N !== h && N !== B && y.push({
          ...t[N],
          x: i
        }), j !== h && j !== B && y.push({
          ...t[j],
          x: i
        });
      }
      s > 0 && B !== h && y.push(t[B]), y.push(a), u = _, o = 0, g = p = c, f = d = h = s;
    }
  }
  return y;
}
function $1(t) {
  if (t._decimated) {
    const e = t._data;
    delete t._decimated, delete t._data, Object.defineProperty(t, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: e
    });
  }
}
function bh(t) {
  t.data.datasets.forEach((e) => {
    $1(e);
  });
}
function dA(t, e) {
  const r = e.length;
  let n = 0, i;
  const { iScale: o } = t, { min: s, max: a, minDefined: l, maxDefined: c } = o.getUserBounds();
  return l && (n = St(jr(e, o.axis, s).lo, 0, r - 1)), c ? i = St(jr(e, o.axis, a).hi + 1, n, r) - n : i = r - n, {
    start: n,
    count: i
  };
}
var hA = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (t, e, r) => {
    if (!r.enabled) {
      bh(t);
      return;
    }
    const n = t.width;
    t.data.datasets.forEach((i, o) => {
      const { _data: s, indexAxis: a } = i, l = t.getDatasetMeta(o), c = s || i.data;
      if (no([
        a,
        t.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const u = t.scales[l.xAxisID];
      if (u.type !== "linear" && u.type !== "time" || t.options.parsing)
        return;
      let { start: f, count: d } = dA(l, c);
      const h = r.threshold || 4 * n;
      if (d <= h) {
        $1(i);
        return;
      }
      We(s) && (i._data = c, delete i.data, Object.defineProperty(i, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(p) {
          this._data = p;
        }
      }));
      let g;
      switch (r.algorithm) {
        case "lttb":
          g = uA(c, f, d, n, r);
          break;
        case "min-max":
          g = fA(c, f, d, n);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${r.algorithm}'`);
      }
      i._decimated = g;
    });
  },
  destroy(t) {
    bh(t);
  }
};
function pA(t, e, r) {
  const n = t.segments, i = t.points, o = e.points, s = [];
  for (const a of n) {
    let { start: l, end: c } = a;
    c = Ju(l, c, i);
    const u = Uc(r, i[l], i[c], a.loop);
    if (!e.segments) {
      s.push({
        source: a,
        target: u,
        start: i[l],
        end: i[c]
      });
      continue;
    }
    const f = N1(e, u);
    for (const d of f) {
      const h = Uc(r, o[d.start], o[d.end], d.loop), g = M1(a, i, h);
      for (const p of g)
        s.push({
          source: p,
          target: d,
          start: {
            [r]: vh(u, h, "start", Math.max)
          },
          end: {
            [r]: vh(u, h, "end", Math.min)
          }
        });
    }
  }
  return s;
}
function Uc(t, e, r, n) {
  if (n)
    return;
  let i = e[t], o = r[t];
  return t === "angle" && (i = Yt(i), o = Yt(o)), {
    property: t,
    start: i,
    end: o
  };
}
function gA(t, e) {
  const { x: r = null, y: n = null } = t || {}, i = e.points, o = [];
  return e.segments.forEach(({ start: s, end: a }) => {
    a = Ju(s, a, i);
    const l = i[s], c = i[a];
    n !== null ? (o.push({
      x: l.x,
      y: n
    }), o.push({
      x: c.x,
      y: n
    })) : r !== null && (o.push({
      x: r,
      y: l.y
    }), o.push({
      x: r,
      y: c.y
    }));
  }), o;
}
function Ju(t, e, r) {
  for (; e > t; e--) {
    const n = r[e];
    if (!isNaN(n.x) && !isNaN(n.y))
      break;
  }
  return e;
}
function vh(t, e, r, n) {
  return t && e ? n(t[r], e[r]) : t ? t[r] : e ? e[r] : 0;
}
function eg(t, e) {
  let r = [], n = !1;
  return it(t) ? (n = !0, r = t) : r = gA(t, e), r.length ? new rn({
    points: r,
    options: {
      tension: 0
    },
    _loop: n,
    _fullLoop: n
  }) : null;
}
function Ah(t) {
  return t && t.fill !== !1;
}
function mA(t, e, r) {
  let i = t[e].fill;
  const o = [
    e
  ];
  let s;
  if (!r)
    return i;
  for (; i !== !1 && o.indexOf(i) === -1; ) {
    if (!pt(i))
      return i;
    if (s = t[i], !s)
      return !1;
    if (s.visible)
      return i;
    o.push(i), i = s.fill;
  }
  return !1;
}
function yA(t, e, r) {
  const n = wA(t);
  if (Be(n))
    return isNaN(n.value) ? !1 : n;
  let i = parseFloat(n);
  return pt(i) && Math.floor(i) === i ? bA(n[0], e, i, r) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(n) >= 0 && n;
}
function bA(t, e, r, n) {
  return (t === "-" || t === "+") && (r = e + r), r === e || r < 0 || r >= n ? !1 : r;
}
function vA(t, e) {
  let r = null;
  return t === "start" ? r = e.bottom : t === "end" ? r = e.top : Be(t) ? r = e.getPixelForValue(t.value) : e.getBasePixel && (r = e.getBasePixel()), r;
}
function AA(t, e, r) {
  let n;
  return t === "start" ? n = r : t === "end" ? n = e.options.reverse ? e.min : e.max : Be(t) ? n = t.value : n = e.getBaseValue(), n;
}
function wA(t) {
  const e = t.options, r = e.fill;
  let n = Oe(r && r.target, r);
  return n === void 0 && (n = !!e.backgroundColor), n === !1 || n === null ? !1 : n === !0 ? "origin" : n;
}
function xA(t) {
  const { scale: e, index: r, line: n } = t, i = [], o = n.segments, s = n.points, a = _A(e, r);
  a.push(eg({
    x: null,
    y: e.bottom
  }, n));
  for (let l = 0; l < o.length; l++) {
    const c = o[l];
    for (let u = c.start; u <= c.end; u++)
      SA(i, s[u], a);
  }
  return new rn({
    points: i,
    options: {}
  });
}
function _A(t, e) {
  const r = [], n = t.getMatchingVisibleMetas("line");
  for (let i = 0; i < n.length; i++) {
    const o = n[i];
    if (o.index === e)
      break;
    o.hidden || r.unshift(o.dataset);
  }
  return r;
}
function SA(t, e, r) {
  const n = [];
  for (let i = 0; i < r.length; i++) {
    const o = r[i], { first: s, last: a, point: l } = EA(o, e, "x");
    if (!(!l || s && a)) {
      if (s)
        n.unshift(l);
      else if (t.push(l), !a)
        break;
    }
  }
  t.push(...n);
}
function EA(t, e, r) {
  const n = t.interpolate(e, r);
  if (!n)
    return {};
  const i = n[r], o = t.segments, s = t.points;
  let a = !1, l = !1;
  for (let c = 0; c < o.length; c++) {
    const u = o[c], f = s[u.start][r], d = s[u.end][r];
    if (Fr(i, f, d)) {
      a = i === f, l = i === d;
      break;
    }
  }
  return {
    first: a,
    last: l,
    point: n
  };
}
class tg {
  constructor(e) {
    this.x = e.x, this.y = e.y, this.radius = e.radius;
  }
  pathSegment(e, r, n) {
    const { x: i, y: o, radius: s } = this;
    return r = r || {
      start: 0,
      end: ot
    }, e.arc(i, o, s, r.end, r.start, !0), !n.bounds;
  }
  interpolate(e) {
    const { x: r, y: n, radius: i } = this, o = e.angle;
    return {
      x: r + Math.cos(o) * i,
      y: n + Math.sin(o) * i,
      angle: o
    };
  }
}
function kA(t) {
  const { chart: e, fill: r, line: n } = t;
  if (pt(r))
    return CA(e, r);
  if (r === "stack")
    return xA(t);
  if (r === "shape")
    return !0;
  const i = TA(t);
  return i instanceof tg ? i : eg(i, n);
}
function CA(t, e) {
  const r = t.getDatasetMeta(e);
  return r && t.isDatasetVisible(e) ? r.dataset : null;
}
function TA(t) {
  return (t.scale || {}).getPointPositionForValue ? IA(t) : OA(t);
}
function OA(t) {
  const { scale: e = {}, fill: r } = t, n = vA(r, e);
  if (pt(n)) {
    const i = e.isHorizontal();
    return {
      x: i ? n : null,
      y: i ? null : n
    };
  }
  return null;
}
function IA(t) {
  const { scale: e, fill: r } = t, n = e.options, i = e.getLabels().length, o = n.reverse ? e.max : e.min, s = AA(r, e, o), a = [];
  if (n.grid.circular) {
    const l = e.getPointPositionForValue(0, o);
    return new tg({
      x: l.x,
      y: l.y,
      radius: e.getDistanceFromCenterForValue(s)
    });
  }
  for (let l = 0; l < i; ++l)
    a.push(e.getPointPositionForValue(l, s));
  return a;
}
function ec(t, e, r) {
  const n = kA(e), { line: i, scale: o, axis: s } = e, a = i.options, l = a.fill, c = a.backgroundColor, { above: u = c, below: f = c } = l || {};
  n && i.points.length && (Ka(t, r), PA(t, {
    line: i,
    target: n,
    above: u,
    below: f,
    area: r,
    scale: o,
    axis: s
  }), Xa(t));
}
function PA(t, e) {
  const { line: r, target: n, above: i, below: o, area: s, scale: a } = e, l = r._loop ? "angle" : e.axis;
  t.save(), l === "x" && o !== i && (wh(t, n, s.top), xh(t, {
    line: r,
    target: n,
    color: i,
    scale: a,
    property: l
  }), t.restore(), t.save(), wh(t, n, s.bottom)), xh(t, {
    line: r,
    target: n,
    color: o,
    scale: a,
    property: l
  }), t.restore();
}
function wh(t, e, r) {
  const { segments: n, points: i } = e;
  let o = !0, s = !1;
  t.beginPath();
  for (const a of n) {
    const { start: l, end: c } = a, u = i[l], f = i[Ju(l, c, i)];
    o ? (t.moveTo(u.x, u.y), o = !1) : (t.lineTo(u.x, r), t.lineTo(u.x, u.y)), s = !!e.pathSegment(t, a, {
      move: s
    }), s ? t.closePath() : t.lineTo(f.x, r);
  }
  t.lineTo(e.first().x, r), t.closePath(), t.clip();
}
function xh(t, e) {
  const { line: r, target: n, property: i, color: o, scale: s } = e, a = pA(r, n, i);
  for (const { source: l, target: c, start: u, end: f } of a) {
    const { style: { backgroundColor: d = o } = {} } = l, h = n !== !0;
    t.save(), t.fillStyle = d, RA(t, s, h && Uc(i, u, f)), t.beginPath();
    const g = !!r.pathSegment(t, l);
    let p;
    if (h) {
      g ? t.closePath() : _h(t, n, f, i);
      const y = !!n.pathSegment(t, c, {
        move: g,
        reverse: !0
      });
      p = g && y, p || _h(t, n, u, i);
    }
    t.closePath(), t.fill(p ? "evenodd" : "nonzero"), t.restore();
  }
}
function RA(t, e, r) {
  const { top: n, bottom: i } = e.chart.chartArea, { property: o, start: s, end: a } = r || {};
  o === "x" && (t.beginPath(), t.rect(s, n, a - s, i - n), t.clip());
}
function _h(t, e, r, n) {
  const i = e.interpolate(r, n);
  i && t.lineTo(i.x, i.y);
}
var DA = {
  id: "filler",
  afterDatasetsUpdate(t, e, r) {
    const n = (t.data.datasets || []).length, i = [];
    let o, s, a, l;
    for (s = 0; s < n; ++s)
      o = t.getDatasetMeta(s), a = o.dataset, l = null, a && a.options && a instanceof rn && (l = {
        visible: t.isDatasetVisible(s),
        index: s,
        fill: yA(a, s, n),
        chart: t,
        axis: o.controller.options.indexAxis,
        scale: o.vScale,
        line: a
      }), o.$filler = l, i.push(l);
    for (s = 0; s < n; ++s)
      l = i[s], !(!l || l.fill === !1) && (l.fill = mA(i, s, r.propagate));
  },
  beforeDraw(t, e, r) {
    const n = r.drawTime === "beforeDraw", i = t.getSortedVisibleDatasetMetas(), o = t.chartArea;
    for (let s = i.length - 1; s >= 0; --s) {
      const a = i[s].$filler;
      a && (a.line.updateControlPoints(o, a.axis), n && a.fill && ec(t.ctx, a, o));
    }
  },
  beforeDatasetsDraw(t, e, r) {
    if (r.drawTime !== "beforeDatasetsDraw")
      return;
    const n = t.getSortedVisibleDatasetMetas();
    for (let i = n.length - 1; i >= 0; --i) {
      const o = n[i].$filler;
      Ah(o) && ec(t.ctx, o, t.chartArea);
    }
  },
  beforeDatasetDraw(t, e, r) {
    const n = e.meta.$filler;
    !Ah(n) || r.drawTime !== "beforeDatasetDraw" || ec(t.ctx, n, t.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const Sh = (t, e) => {
  let { boxHeight: r = e, boxWidth: n = e } = t;
  return t.usePointStyle && (r = Math.min(r, e), n = t.pointStyleWidth || Math.min(n, e)), {
    boxWidth: n,
    boxHeight: r,
    itemHeight: Math.max(e, r)
  };
}, MA = (t, e) => t !== null && e !== null && t.datasetIndex === e.datasetIndex && t.index === e.index;
class Eh extends Xr {
  constructor(e) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, r, n) {
    this.maxWidth = e, this.maxHeight = r, this._margins = n, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const e = this.options.labels || {};
    let r = nt(e.generateLabels, [
      this.chart
    ], this) || [];
    e.filter && (r = r.filter((n) => e.filter(n, this.chart.data))), e.sort && (r = r.sort((n, i) => e.sort(n, i, this.chart.data))), this.options.reverse && r.reverse(), this.legendItems = r;
  }
  fit() {
    const { options: e, ctx: r } = this;
    if (!e.display) {
      this.width = this.height = 0;
      return;
    }
    const n = e.labels, i = vt(n.font), o = i.size, s = this._computeTitleHeight(), { boxWidth: a, itemHeight: l } = Sh(n, o);
    let c, u;
    r.font = i.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(s, o, a, l) + 10) : (u = this.maxHeight, c = this._fitCols(s, i, a, l) + 10), this.width = Math.min(c, e.maxWidth || this.maxWidth), this.height = Math.min(u, e.maxHeight || this.maxHeight);
  }
  _fitRows(e, r, n, i) {
    const { ctx: o, maxWidth: s, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], u = i + a;
    let f = e;
    o.textAlign = "left", o.textBaseline = "middle";
    let d = -1, h = -u;
    return this.legendItems.forEach((g, p) => {
      const y = n + r / 2 + o.measureText(g.text).width;
      (p === 0 || c[c.length - 1] + y + 2 * a > s) && (f += u, c[c.length - (p > 0 ? 0 : 1)] = 0, h += u, d++), l[p] = {
        left: 0,
        top: h,
        row: d,
        width: y,
        height: i
      }, c[c.length - 1] += y + a;
    }), f;
  }
  _fitCols(e, r, n, i) {
    const { ctx: o, maxHeight: s, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = s - e;
    let f = a, d = 0, h = 0, g = 0, p = 0;
    return this.legendItems.forEach((y, b) => {
      const { itemWidth: x, itemHeight: S } = NA(n, r, o, y, i);
      b > 0 && h + S + 2 * a > u && (f += d + a, c.push({
        width: d,
        height: h
      }), g += d + a, p++, d = h = 0), l[b] = {
        left: g,
        top: h,
        col: p,
        width: x,
        height: S
      }, d = Math.max(d, x), h += S + a;
    }), f += d, c.push({
      width: d,
      height: h
    }), f;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const e = this._computeTitleHeight(), { legendHitBoxes: r, options: { align: n, labels: { padding: i }, rtl: o } } = this, s = mi(o, this.left, this.width);
    if (this.isHorizontal()) {
      let a = 0, l = It(n, this.left + i, this.right - this.lineWidths[a]);
      for (const c of r)
        a !== c.row && (a = c.row, l = It(n, this.left + i, this.right - this.lineWidths[a])), c.top += this.top + e + i, c.left = s.leftForLtr(s.x(l), c.width), l += c.width + i;
    } else {
      let a = 0, l = It(n, this.top + e + i, this.bottom - this.columnSizes[a].height);
      for (const c of r)
        c.col !== a && (a = c.col, l = It(n, this.top + e + i, this.bottom - this.columnSizes[a].height)), c.top = l, c.left += this.left + i, c.left = s.leftForLtr(s.x(c.left), c.width), l += c.height + i;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const e = this.ctx;
      Ka(e, this), this._draw(), Xa(e);
    }
  }
  _draw() {
    const { options: e, columnSizes: r, lineWidths: n, ctx: i } = this, { align: o, labels: s } = e, a = gt.color, l = mi(e.rtl, this.left, this.width), c = vt(s.font), { padding: u } = s, f = c.size, d = f / 2;
    let h;
    this.drawTitle(), i.textAlign = l.textAlign("left"), i.textBaseline = "middle", i.lineWidth = 0.5, i.font = c.string;
    const { boxWidth: g, boxHeight: p, itemHeight: y } = Sh(s, f), b = function(B, N, j) {
      if (isNaN(g) || g <= 0 || isNaN(p) || p < 0)
        return;
      i.save();
      const W = Oe(j.lineWidth, 1);
      if (i.fillStyle = Oe(j.fillStyle, a), i.lineCap = Oe(j.lineCap, "butt"), i.lineDashOffset = Oe(j.lineDashOffset, 0), i.lineJoin = Oe(j.lineJoin, "miter"), i.lineWidth = W, i.strokeStyle = Oe(j.strokeStyle, a), i.setLineDash(Oe(j.lineDash, [])), s.usePointStyle) {
        const G = {
          radius: p * Math.SQRT2 / 2,
          pointStyle: j.pointStyle,
          rotation: j.rotation,
          borderWidth: W
        }, ee = l.xPlus(B, g / 2), fe = N + d;
        x1(i, G, ee, fe, s.pointStyleWidth && g);
      } else {
        const G = N + Math.max((f - p) / 2, 0), ee = l.leftForLtr(B, g), fe = Ln(j.borderRadius);
        i.beginPath(), Object.values(fe).some((P) => P !== 0) ? Do(i, {
          x: ee,
          y: G,
          w: g,
          h: p,
          radius: fe
        }) : i.rect(ee, G, g, p), i.fill(), W !== 0 && i.stroke();
      }
      i.restore();
    }, x = function(B, N, j) {
      Hn(i, j.text, B, N + y / 2, c, {
        strikethrough: j.hidden,
        textAlign: l.textAlign(j.textAlign)
      });
    }, S = this.isHorizontal(), O = this._computeTitleHeight();
    S ? h = {
      x: It(o, this.left + u, this.right - n[0]),
      y: this.top + u + O,
      line: 0
    } : h = {
      x: this.left + u,
      y: It(o, this.top + O + u, this.bottom - r[0].height),
      line: 0
    }, P1(this.ctx, e.textDirection);
    const _ = y + u;
    this.legendItems.forEach((B, N) => {
      i.strokeStyle = B.fontColor, i.fillStyle = B.fontColor;
      const j = i.measureText(B.text).width, W = l.textAlign(B.textAlign || (B.textAlign = s.textAlign)), G = g + d + j;
      let ee = h.x, fe = h.y;
      l.setWidth(this.width), S ? N > 0 && ee + G + u > this.right && (fe = h.y += _, h.line++, ee = h.x = It(o, this.left + u, this.right - n[h.line])) : N > 0 && fe + _ > this.bottom && (ee = h.x = ee + r[h.line].width + u, h.line++, fe = h.y = It(o, this.top + O + u, this.bottom - r[h.line].height));
      const P = l.x(ee);
      if (b(P, fe, B), ee = r2(W, ee + g + d, S ? ee + G : this.right, e.rtl), x(l.x(ee), fe, B), S)
        h.x += G + u;
      else if (typeof B.text != "string") {
        const z = c.lineHeight;
        h.y += rg(B, z) + u;
      } else
        h.y += _;
    }), R1(this.ctx, e.textDirection);
  }
  drawTitle() {
    const e = this.options, r = e.title, n = vt(r.font), i = Mt(r.padding);
    if (!r.display)
      return;
    const o = mi(e.rtl, this.left, this.width), s = this.ctx, a = r.position, l = n.size / 2, c = i.top + l;
    let u, f = this.left, d = this.width;
    if (this.isHorizontal())
      d = Math.max(...this.lineWidths), u = this.top + c, f = It(e.align, f, this.right - d);
    else {
      const g = this.columnSizes.reduce((p, y) => Math.max(p, y.height), 0);
      u = c + It(e.align, this.top, this.bottom - g - e.labels.padding - this._computeTitleHeight());
    }
    const h = It(a, f, f + d);
    s.textAlign = o.textAlign(Uu(a)), s.textBaseline = "middle", s.strokeStyle = r.color, s.fillStyle = r.color, s.font = n.string, Hn(s, r.text, h, u, n);
  }
  _computeTitleHeight() {
    const e = this.options.title, r = vt(e.font), n = Mt(e.padding);
    return e.display ? r.lineHeight + n.height : 0;
  }
  _getLegendItemAt(e, r) {
    let n, i, o;
    if (Fr(e, this.left, this.right) && Fr(r, this.top, this.bottom)) {
      for (o = this.legendHitBoxes, n = 0; n < o.length; ++n)
        if (i = o[n], Fr(e, i.left, i.left + i.width) && Fr(r, i.top, i.top + i.height))
          return this.legendItems[n];
    }
    return null;
  }
  handleEvent(e) {
    const r = this.options;
    if (!FA(e.type, r))
      return;
    const n = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const i = this._hoveredItem, o = MA(i, n);
      i && !o && nt(r.onLeave, [
        e,
        i,
        this
      ], this), this._hoveredItem = n, n && !o && nt(r.onHover, [
        e,
        n,
        this
      ], this);
    } else
      n && nt(r.onClick, [
        e,
        n,
        this
      ], this);
  }
}
function NA(t, e, r, n, i) {
  const o = BA(n, t, e, r), s = LA(i, n, e.lineHeight);
  return {
    itemWidth: o,
    itemHeight: s
  };
}
function BA(t, e, r, n) {
  let i = t.text;
  return i && typeof i != "string" && (i = i.reduce((o, s) => o.length > s.length ? o : s)), e + r.size / 2 + n.measureText(i).width;
}
function LA(t, e, r) {
  let n = t;
  return typeof e.text != "string" && (n = rg(e, r)), n;
}
function rg(t, e) {
  const r = t.text ? t.text.length : 0;
  return e * r;
}
function FA(t, e) {
  return !!((t === "mousemove" || t === "mouseout") && (e.onHover || e.onLeave) || e.onClick && (t === "click" || t === "mouseup"));
}
var jA = {
  id: "legend",
  _element: Eh,
  start(t, e, r) {
    const n = t.legend = new Eh({
      ctx: t.ctx,
      options: r,
      chart: t
    });
    Rt.configure(t, n, r), Rt.addBox(t, n);
  },
  stop(t) {
    Rt.removeBox(t, t.legend), delete t.legend;
  },
  beforeUpdate(t, e, r) {
    const n = t.legend;
    Rt.configure(t, n, r), n.options = r;
  },
  afterUpdate(t) {
    const e = t.legend;
    e.buildLabels(), e.adjustHitBoxes();
  },
  afterEvent(t, e) {
    e.replay || t.legend.handleEvent(e.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(t, e, r) {
      const n = e.datasetIndex, i = r.chart;
      i.isDatasetVisible(n) ? (i.hide(n), e.hidden = !0) : (i.show(n), e.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (t) => t.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(t) {
        const e = t.data.datasets, { labels: { usePointStyle: r, pointStyle: n, textAlign: i, color: o, useBorderRadius: s, borderRadius: a } } = t.legend.options;
        return t._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(r ? 0 : void 0), u = Mt(c.borderWidth);
          return {
            text: e[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: o,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: n || c.pointStyle,
            rotation: c.rotation,
            textAlign: i || c.textAlign,
            borderRadius: s && (a || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (t) => t.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (t) => !t.startsWith("on"),
    labels: {
      _scriptable: (t) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(t)
    }
  }
};
class Qu extends Xr {
  constructor(e) {
    super(), this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, r) {
    const n = this.options;
    if (this.left = 0, this.top = 0, !n.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = e, this.height = this.bottom = r;
    const i = it(n.text) ? n.text.length : 1;
    this._padding = Mt(n.padding);
    const o = i * vt(n.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = o : this.width = o;
  }
  isHorizontal() {
    const e = this.options.position;
    return e === "top" || e === "bottom";
  }
  _drawArgs(e) {
    const { top: r, left: n, bottom: i, right: o, options: s } = this, a = s.align;
    let l = 0, c, u, f;
    return this.isHorizontal() ? (u = It(a, n, o), f = r + e, c = o - n) : (s.position === "left" ? (u = n + e, f = It(a, i, r), l = st * -0.5) : (u = o - e, f = It(a, r, i), l = st * 0.5), c = i - r), {
      titleX: u,
      titleY: f,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const e = this.ctx, r = this.options;
    if (!r.display)
      return;
    const n = vt(r.font), o = n.lineHeight / 2 + this._padding.top, { titleX: s, titleY: a, maxWidth: l, rotation: c } = this._drawArgs(o);
    Hn(e, r.text, 0, 0, n, {
      color: r.color,
      maxWidth: l,
      rotation: c,
      textAlign: Uu(r.align),
      textBaseline: "middle",
      translation: [
        s,
        a
      ]
    });
  }
}
function WA(t, e) {
  const r = new Qu({
    ctx: t.ctx,
    options: e,
    chart: t
  });
  Rt.configure(t, r, e), Rt.addBox(t, r), t.titleBlock = r;
}
var UA = {
  id: "title",
  _element: Qu,
  start(t, e, r) {
    WA(t, r);
  },
  stop(t) {
    const e = t.titleBlock;
    Rt.removeBox(t, e), delete t.titleBlock;
  },
  beforeUpdate(t, e, r) {
    const n = t.titleBlock;
    Rt.configure(t, n, r), n.options = r;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Ts = /* @__PURE__ */ new WeakMap();
var zA = {
  id: "subtitle",
  start(t, e, r) {
    const n = new Qu({
      ctx: t.ctx,
      options: r,
      chart: t
    });
    Rt.configure(t, n, r), Rt.addBox(t, n), Ts.set(t, n);
  },
  stop(t) {
    Rt.removeBox(t, Ts.get(t)), Ts.delete(t);
  },
  beforeUpdate(t, e, r) {
    const n = Ts.get(t);
    Rt.configure(t, n, r), n.options = r;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const so = {
  average(t) {
    if (!t.length)
      return !1;
    let e, r, n = 0, i = 0, o = 0;
    for (e = 0, r = t.length; e < r; ++e) {
      const s = t[e].element;
      if (s && s.hasValue()) {
        const a = s.tooltipPosition();
        n += a.x, i += a.y, ++o;
      }
    }
    return {
      x: n / o,
      y: i / o
    };
  },
  nearest(t, e) {
    if (!t.length)
      return !1;
    let r = e.x, n = e.y, i = Number.POSITIVE_INFINITY, o, s, a;
    for (o = 0, s = t.length; o < s; ++o) {
      const l = t[o].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = Dc(e, c);
        u < i && (i = u, a = l);
      }
    }
    if (a) {
      const l = a.tooltipPosition();
      r = l.x, n = l.y;
    }
    return {
      x: r,
      y: n
    };
  }
};
function br(t, e) {
  return e && (it(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t;
}
function Dr(t) {
  return (typeof t == "string" || t instanceof String) && t.indexOf(`
`) > -1 ? t.split(`
`) : t;
}
function VA(t, e) {
  const { element: r, datasetIndex: n, index: i } = e, o = t.getDatasetMeta(n).controller, { label: s, value: a } = o.getLabelAndValue(i);
  return {
    chart: t,
    label: s,
    parsed: o.getParsed(i),
    raw: t.data.datasets[n].data[i],
    formattedValue: a,
    dataset: o.getDataset(),
    dataIndex: i,
    datasetIndex: n,
    element: r
  };
}
function kh(t, e) {
  const r = t.chart.ctx, { body: n, footer: i, title: o } = t, { boxWidth: s, boxHeight: a } = e, l = vt(e.bodyFont), c = vt(e.titleFont), u = vt(e.footerFont), f = o.length, d = i.length, h = n.length, g = Mt(e.padding);
  let p = g.height, y = 0, b = n.reduce((O, _) => O + _.before.length + _.lines.length + _.after.length, 0);
  if (b += t.beforeBody.length + t.afterBody.length, f && (p += f * c.lineHeight + (f - 1) * e.titleSpacing + e.titleMarginBottom), b) {
    const O = e.displayColors ? Math.max(a, l.lineHeight) : l.lineHeight;
    p += h * O + (b - h) * l.lineHeight + (b - 1) * e.bodySpacing;
  }
  d && (p += e.footerMarginTop + d * u.lineHeight + (d - 1) * e.footerSpacing);
  let x = 0;
  const S = function(O) {
    y = Math.max(y, r.measureText(O).width + x);
  };
  return r.save(), r.font = c.string, $e(t.title, S), r.font = l.string, $e(t.beforeBody.concat(t.afterBody), S), x = e.displayColors ? s + 2 + e.boxPadding : 0, $e(n, (O) => {
    $e(O.before, S), $e(O.lines, S), $e(O.after, S);
  }), x = 0, r.font = u.string, $e(t.footer, S), r.restore(), y += g.width, {
    width: y,
    height: p
  };
}
function qA(t, e) {
  const { y: r, height: n } = e;
  return r < n / 2 ? "top" : r > t.height - n / 2 ? "bottom" : "center";
}
function HA(t, e, r, n) {
  const { x: i, width: o } = n, s = r.caretSize + r.caretPadding;
  if (t === "left" && i + o + s > e.width || t === "right" && i - o - s < 0)
    return !0;
}
function YA(t, e, r, n) {
  const { x: i, width: o } = r, { width: s, chartArea: { left: a, right: l } } = t;
  let c = "center";
  return n === "center" ? c = i <= (a + l) / 2 ? "left" : "right" : i <= o / 2 ? c = "left" : i >= s - o / 2 && (c = "right"), HA(c, t, e, r) && (c = "center"), c;
}
function Ch(t, e, r) {
  const n = r.yAlign || e.yAlign || qA(t, r);
  return {
    xAlign: r.xAlign || e.xAlign || YA(t, e, r, n),
    yAlign: n
  };
}
function KA(t, e) {
  let { x: r, width: n } = t;
  return e === "right" ? r -= n : e === "center" && (r -= n / 2), r;
}
function XA(t, e, r) {
  let { y: n, height: i } = t;
  return e === "top" ? n += r : e === "bottom" ? n -= i + r : n -= i / 2, n;
}
function Th(t, e, r, n) {
  const { caretSize: i, caretPadding: o, cornerRadius: s } = t, { xAlign: a, yAlign: l } = r, c = i + o, { topLeft: u, topRight: f, bottomLeft: d, bottomRight: h } = Ln(s);
  let g = KA(e, a);
  const p = XA(e, l, c);
  return l === "center" ? a === "left" ? g += c : a === "right" && (g -= c) : a === "left" ? g -= Math.max(u, d) + i : a === "right" && (g += Math.max(f, h) + i), {
    x: St(g, 0, n.width - e.width),
    y: St(p, 0, n.height - e.height)
  };
}
function Os(t, e, r) {
  const n = Mt(r.padding);
  return e === "center" ? t.x + t.width / 2 : e === "right" ? t.x + t.width - n.right : t.x + n.left;
}
function Oh(t) {
  return br([], Dr(t));
}
function JA(t, e, r) {
  return bn(t, {
    tooltip: e,
    tooltipItems: r,
    type: "tooltip"
  });
}
function Ih(t, e) {
  const r = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return r ? t.override(r) : t;
}
const ng = {
  beforeTitle: Ir,
  title(t) {
    if (t.length > 0) {
      const e = t[0], r = e.chart.data.labels, n = r ? r.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (n > 0 && e.dataIndex < n)
        return r[e.dataIndex];
    }
    return "";
  },
  afterTitle: Ir,
  beforeBody: Ir,
  beforeLabel: Ir,
  label(t) {
    if (this && this.options && this.options.mode === "dataset")
      return t.label + ": " + t.formattedValue || t.formattedValue;
    let e = t.dataset.label || "";
    e && (e += ": ");
    const r = t.formattedValue;
    return We(r) || (e += r), e;
  },
  labelColor(t) {
    const r = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      borderColor: r.borderColor,
      backgroundColor: r.backgroundColor,
      borderWidth: r.borderWidth,
      borderDash: r.borderDash,
      borderDashOffset: r.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(t) {
    const r = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      pointStyle: r.pointStyle,
      rotation: r.rotation
    };
  },
  afterLabel: Ir,
  afterBody: Ir,
  beforeFooter: Ir,
  footer: Ir,
  afterFooter: Ir
};
function Lt(t, e, r, n) {
  const i = t[e].call(r, n);
  return typeof i > "u" ? ng[e].call(r, n) : i;
}
var xc;
let Ph = (xc = class extends Xr {
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const r = this.chart, n = this.options.setContext(this.getContext()), i = n.enabled && r.options.animation && n.animations, o = new B1(this.chart, i);
    return i._cacheable && (this._cachedAnimations = Object.freeze(o)), o;
  }
  getContext() {
    return this.$context || (this.$context = JA(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, r) {
    const { callbacks: n } = r, i = Lt(n, "beforeTitle", this, e), o = Lt(n, "title", this, e), s = Lt(n, "afterTitle", this, e);
    let a = [];
    return a = br(a, Dr(i)), a = br(a, Dr(o)), a = br(a, Dr(s)), a;
  }
  getBeforeBody(e, r) {
    return Oh(Lt(r.callbacks, "beforeBody", this, e));
  }
  getBody(e, r) {
    const { callbacks: n } = r, i = [];
    return $e(e, (o) => {
      const s = {
        before: [],
        lines: [],
        after: []
      }, a = Ih(n, o);
      br(s.before, Dr(Lt(a, "beforeLabel", this, o))), br(s.lines, Lt(a, "label", this, o)), br(s.after, Dr(Lt(a, "afterLabel", this, o))), i.push(s);
    }), i;
  }
  getAfterBody(e, r) {
    return Oh(Lt(r.callbacks, "afterBody", this, e));
  }
  getFooter(e, r) {
    const { callbacks: n } = r, i = Lt(n, "beforeFooter", this, e), o = Lt(n, "footer", this, e), s = Lt(n, "afterFooter", this, e);
    let a = [];
    return a = br(a, Dr(i)), a = br(a, Dr(o)), a = br(a, Dr(s)), a;
  }
  _createItems(e) {
    const r = this._active, n = this.chart.data, i = [], o = [], s = [];
    let a = [], l, c;
    for (l = 0, c = r.length; l < c; ++l)
      a.push(VA(this.chart, r[l]));
    return e.filter && (a = a.filter((u, f, d) => e.filter(u, f, d, n))), e.itemSort && (a = a.sort((u, f) => e.itemSort(u, f, n))), $e(a, (u) => {
      const f = Ih(e.callbacks, u);
      i.push(Lt(f, "labelColor", this, u)), o.push(Lt(f, "labelPointStyle", this, u)), s.push(Lt(f, "labelTextColor", this, u));
    }), this.labelColors = i, this.labelPointStyles = o, this.labelTextColors = s, this.dataPoints = a, a;
  }
  update(e, r) {
    const n = this.options.setContext(this.getContext()), i = this._active;
    let o, s = [];
    if (!i.length)
      this.opacity !== 0 && (o = {
        opacity: 0
      });
    else {
      const a = so[n.position].call(this, i, this._eventPosition);
      s = this._createItems(n), this.title = this.getTitle(s, n), this.beforeBody = this.getBeforeBody(s, n), this.body = this.getBody(s, n), this.afterBody = this.getAfterBody(s, n), this.footer = this.getFooter(s, n);
      const l = this._size = kh(this, n), c = Object.assign({}, a, l), u = Ch(this.chart, n, c), f = Th(n, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, o = {
        opacity: 1,
        x: f.x,
        y: f.y,
        width: l.width,
        height: l.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = s, this.$context = void 0, o && this._resolveAnimations().update(this, o), e && n.external && n.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: r
    });
  }
  drawCaret(e, r, n, i) {
    const o = this.getCaretPosition(e, n, i);
    r.lineTo(o.x1, o.y1), r.lineTo(o.x2, o.y2), r.lineTo(o.x3, o.y3);
  }
  getCaretPosition(e, r, n) {
    const { xAlign: i, yAlign: o } = this, { caretSize: s, cornerRadius: a } = n, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: f } = Ln(a), { x: d, y: h } = e, { width: g, height: p } = r;
    let y, b, x, S, O, _;
    return o === "center" ? (O = h + p / 2, i === "left" ? (y = d, b = y - s, S = O + s, _ = O - s) : (y = d + g, b = y + s, S = O - s, _ = O + s), x = y) : (i === "left" ? b = d + Math.max(l, u) + s : i === "right" ? b = d + g - Math.max(c, f) - s : b = this.caretX, o === "top" ? (S = h, O = S - s, y = b - s, x = b + s) : (S = h + p, O = S + s, y = b + s, x = b - s), _ = S), {
      x1: y,
      x2: b,
      x3: x,
      y1: S,
      y2: O,
      y3: _
    };
  }
  drawTitle(e, r, n) {
    const i = this.title, o = i.length;
    let s, a, l;
    if (o) {
      const c = mi(n.rtl, this.x, this.width);
      for (e.x = Os(this, n.titleAlign, n), r.textAlign = c.textAlign(n.titleAlign), r.textBaseline = "middle", s = vt(n.titleFont), a = n.titleSpacing, r.fillStyle = n.titleColor, r.font = s.string, l = 0; l < o; ++l)
        r.fillText(i[l], c.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + a, l + 1 === o && (e.y += n.titleMarginBottom - a);
    }
  }
  _drawColorBox(e, r, n, i, o) {
    const s = this.labelColors[n], a = this.labelPointStyles[n], { boxHeight: l, boxWidth: c } = o, u = vt(o.bodyFont), f = Os(this, "left", o), d = i.x(f), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, g = r.y + h;
    if (o.usePointStyle) {
      const p = {
        radius: Math.min(c, l) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, y = i.leftForLtr(d, c) + c / 2, b = g + l / 2;
      e.strokeStyle = o.multiKeyBackground, e.fillStyle = o.multiKeyBackground, Nc(e, p, y, b), e.strokeStyle = s.borderColor, e.fillStyle = s.backgroundColor, Nc(e, p, y, b);
    } else {
      e.lineWidth = Be(s.borderWidth) ? Math.max(...Object.values(s.borderWidth)) : s.borderWidth || 1, e.strokeStyle = s.borderColor, e.setLineDash(s.borderDash || []), e.lineDashOffset = s.borderDashOffset || 0;
      const p = i.leftForLtr(d, c), y = i.leftForLtr(i.xPlus(d, 1), c - 2), b = Ln(s.borderRadius);
      Object.values(b).some((x) => x !== 0) ? (e.beginPath(), e.fillStyle = o.multiKeyBackground, Do(e, {
        x: p,
        y: g,
        w: c,
        h: l,
        radius: b
      }), e.fill(), e.stroke(), e.fillStyle = s.backgroundColor, e.beginPath(), Do(e, {
        x: y,
        y: g + 1,
        w: c - 2,
        h: l - 2,
        radius: b
      }), e.fill()) : (e.fillStyle = o.multiKeyBackground, e.fillRect(p, g, c, l), e.strokeRect(p, g, c, l), e.fillStyle = s.backgroundColor, e.fillRect(y, g + 1, c - 2, l - 2));
    }
    e.fillStyle = this.labelTextColors[n];
  }
  drawBody(e, r, n) {
    const { body: i } = this, { bodySpacing: o, bodyAlign: s, displayColors: a, boxHeight: l, boxWidth: c, boxPadding: u } = n, f = vt(n.bodyFont);
    let d = f.lineHeight, h = 0;
    const g = mi(n.rtl, this.x, this.width), p = function(j) {
      r.fillText(j, g.x(e.x + h), e.y + d / 2), e.y += d + o;
    }, y = g.textAlign(s);
    let b, x, S, O, _, B, N;
    for (r.textAlign = s, r.textBaseline = "middle", r.font = f.string, e.x = Os(this, y, n), r.fillStyle = n.bodyColor, $e(this.beforeBody, p), h = a && y !== "right" ? s === "center" ? c / 2 + u : c + 2 + u : 0, O = 0, B = i.length; O < B; ++O) {
      for (b = i[O], x = this.labelTextColors[O], r.fillStyle = x, $e(b.before, p), S = b.lines, a && S.length && (this._drawColorBox(r, e, O, g, n), d = Math.max(f.lineHeight, l)), _ = 0, N = S.length; _ < N; ++_)
        p(S[_]), d = f.lineHeight;
      $e(b.after, p);
    }
    h = 0, d = f.lineHeight, $e(this.afterBody, p), e.y -= o;
  }
  drawFooter(e, r, n) {
    const i = this.footer, o = i.length;
    let s, a;
    if (o) {
      const l = mi(n.rtl, this.x, this.width);
      for (e.x = Os(this, n.footerAlign, n), e.y += n.footerMarginTop, r.textAlign = l.textAlign(n.footerAlign), r.textBaseline = "middle", s = vt(n.footerFont), r.fillStyle = n.footerColor, r.font = s.string, a = 0; a < o; ++a)
        r.fillText(i[a], l.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + n.footerSpacing;
    }
  }
  drawBackground(e, r, n, i) {
    const { xAlign: o, yAlign: s } = this, { x: a, y: l } = e, { width: c, height: u } = n, { topLeft: f, topRight: d, bottomLeft: h, bottomRight: g } = Ln(i.cornerRadius);
    r.fillStyle = i.backgroundColor, r.strokeStyle = i.borderColor, r.lineWidth = i.borderWidth, r.beginPath(), r.moveTo(a + f, l), s === "top" && this.drawCaret(e, r, n, i), r.lineTo(a + c - d, l), r.quadraticCurveTo(a + c, l, a + c, l + d), s === "center" && o === "right" && this.drawCaret(e, r, n, i), r.lineTo(a + c, l + u - g), r.quadraticCurveTo(a + c, l + u, a + c - g, l + u), s === "bottom" && this.drawCaret(e, r, n, i), r.lineTo(a + h, l + u), r.quadraticCurveTo(a, l + u, a, l + u - h), s === "center" && o === "left" && this.drawCaret(e, r, n, i), r.lineTo(a, l + f), r.quadraticCurveTo(a, l, a + f, l), r.closePath(), r.fill(), i.borderWidth > 0 && r.stroke();
  }
  _updateAnimationTarget(e) {
    const r = this.chart, n = this.$animations, i = n && n.x, o = n && n.y;
    if (i || o) {
      const s = so[e.position].call(this, this._active, this._eventPosition);
      if (!s)
        return;
      const a = this._size = kh(this, e), l = Object.assign({}, s, this._size), c = Ch(r, e, l), u = Th(e, l, c, r);
      (i._to !== u.x || o._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = a.width, this.height = a.height, this.caretX = s.x, this.caretY = s.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const r = this.options.setContext(this.getContext());
    let n = this.opacity;
    if (!n)
      return;
    this._updateAnimationTarget(r);
    const i = {
      width: this.width,
      height: this.height
    }, o = {
      x: this.x,
      y: this.y
    };
    n = Math.abs(n) < 1e-3 ? 0 : n;
    const s = Mt(r.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    r.enabled && a && (e.save(), e.globalAlpha = n, this.drawBackground(o, e, i, r), P1(e, r.textDirection), o.y += s.top, this.drawTitle(o, e, r), this.drawBody(o, e, r), this.drawFooter(o, e, r), R1(e, r.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, r) {
    const n = this._active, i = e.map(({ datasetIndex: a, index: l }) => {
      const c = this.chart.getDatasetMeta(a);
      if (!c)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: c.data[l],
        index: l
      };
    }), o = !ga(n, i), s = this._positionChanged(i, r);
    (o || s) && (this._active = i, this._eventPosition = r, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, r, n = !0) {
    if (r && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const i = this.options, o = this._active || [], s = this._getActiveElements(e, o, r, n), a = this._positionChanged(s, e), l = r || !ga(s, o) || a;
    return l && (this._active = s, (i.enabled || i.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, r))), l;
  }
  _getActiveElements(e, r, n, i) {
    const o = this.options;
    if (e.type === "mouseout")
      return [];
    if (!i)
      return r;
    const s = this.chart.getElementsAtEventForMode(e, o.mode, o, n);
    return o.reverse && s.reverse(), s;
  }
  _positionChanged(e, r) {
    const { caretX: n, caretY: i, options: o } = this, s = so[o.position].call(this, e, r);
    return s !== !1 && (n !== s.x || i !== s.y);
  }
}, ye(xc, "positioners", so), xc);
var QA = {
  id: "tooltip",
  _element: Ph,
  positioners: so,
  afterInit(t, e, r) {
    r && (t.tooltip = new Ph({
      chart: t,
      options: r
    }));
  },
  beforeUpdate(t, e, r) {
    t.tooltip && t.tooltip.initialize(r);
  },
  reset(t, e, r) {
    t.tooltip && t.tooltip.initialize(r);
  },
  afterDraw(t) {
    const e = t.tooltip;
    if (e && e._willRender()) {
      const r = {
        tooltip: e
      };
      if (t.notifyPlugins("beforeTooltipDraw", {
        ...r,
        cancelable: !0
      }) === !1)
        return;
      e.draw(t.ctx), t.notifyPlugins("afterTooltipDraw", r);
    }
  },
  afterEvent(t, e) {
    if (t.tooltip) {
      const r = e.replay;
      t.tooltip.handleEvent(e.event, r, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (t, e) => e.bodyFont.size,
    boxWidth: (t, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: ng
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (t) => t !== "filter" && t !== "itemSort" && t !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, GA = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: cA,
  Decimation: hA,
  Filler: DA,
  Legend: jA,
  SubTitle: zA,
  Title: UA,
  Tooltip: QA
});
const ZA = (t, e, r, n) => (typeof e == "string" ? (r = t.push(e) - 1, n.unshift({
  index: r,
  label: e
})) : isNaN(e) && (r = null), r);
function $A(t, e, r, n) {
  const i = t.indexOf(e);
  if (i === -1)
    return ZA(t, e, r, n);
  const o = t.lastIndexOf(e);
  return i !== o ? r : i;
}
const e5 = (t, e) => t === null ? null : St(Math.round(t), 0, e);
function Rh(t) {
  const e = this.getLabels();
  return t >= 0 && t < e.length ? e[t] : t;
}
class zc extends Qn {
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const r = this._addedLabels;
    if (r.length) {
      const n = this.getLabels();
      for (const { index: i, label: o } of r)
        n[i] === o && n.splice(i, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, r) {
    if (We(e))
      return null;
    const n = this.getLabels();
    return r = isFinite(r) && n[r] === e ? r : $A(n, e, Oe(r, e), this._addedLabels), e5(r, n.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: r } = this.getUserBounds();
    let { min: n, max: i } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (n = 0), r || (i = this.getLabels().length - 1)), this.min = n, this.max = i;
  }
  buildTicks() {
    const e = this.min, r = this.max, n = this.options.offset, i = [];
    let o = this.getLabels();
    o = e === 0 && r === o.length - 1 ? o : o.slice(e, r + 1), this._valueRange = Math.max(o.length - (n ? 0 : 1), 1), this._startValue = this.min - (n ? 0.5 : 0);
    for (let s = e; s <= r; s++)
      i.push({
        value: s
      });
    return i;
  }
  getLabelForValue(e) {
    return Rh.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const r = this.ticks;
    return e < 0 || e > r.length - 1 ? null : this.getPixelForValue(r[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
ye(zc, "id", "category"), ye(zc, "defaults", {
  ticks: {
    callback: Rh
  }
});
function t5(t, e) {
  const r = [], { bounds: i, step: o, min: s, max: a, precision: l, count: c, maxTicks: u, maxDigits: f, includeBounds: d } = t, h = o || 1, g = u - 1, { min: p, max: y } = e, b = !We(s), x = !We(a), S = !We(c), O = (y - p) / (f + 1);
  let _ = Ed((y - p) / g / h) * h, B, N, j, W;
  if (_ < 1e-14 && !b && !x)
    return [
      {
        value: p
      },
      {
        value: y
      }
    ];
  W = Math.ceil(y / _) - Math.floor(p / _), W > g && (_ = Ed(W * _ / g / h) * h), We(l) || (B = Math.pow(10, l), _ = Math.ceil(_ * B) / B), i === "ticks" ? (N = Math.floor(p / _) * _, j = Math.ceil(y / _) * _) : (N = p, j = y), b && x && o && J3((a - s) / o, _ / 1e3) ? (W = Math.round(Math.min((a - s) / _, u)), _ = (a - s) / W, N = s, j = a) : S ? (N = b ? s : N, j = x ? a : j, W = c - 1, _ = (j - N) / W) : (W = (j - N) / _, mo(W, Math.round(W), _ / 1e3) ? W = Math.round(W) : W = Math.ceil(W));
  const G = Math.max(kd(_), kd(N));
  B = Math.pow(10, We(l) ? G : l), N = Math.round(N * B) / B, j = Math.round(j * B) / B;
  let ee = 0;
  for (b && (d && N !== s ? (r.push({
    value: s
  }), N < s && ee++, mo(Math.round((N + ee * _) * B) / B, s, Dh(s, O, t)) && ee++) : N < s && ee++); ee < W; ++ee) {
    const fe = Math.round((N + ee * _) * B) / B;
    if (x && fe > a)
      break;
    r.push({
      value: fe
    });
  }
  return x && d && j !== a ? r.length && mo(r[r.length - 1].value, a, Dh(a, O, t)) ? r[r.length - 1].value = a : r.push({
    value: a
  }) : (!x || j === a) && r.push({
    value: j
  }), r;
}
function Dh(t, e, { horizontal: r, minRotation: n }) {
  const i = pr(n), o = (r ? Math.sin(i) : Math.cos(i)) || 1e-3, s = 0.75 * e * ("" + t).length;
  return Math.min(e / o, s);
}
class xa extends Qn {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, r) {
    return We(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: r, maxDefined: n } = this.getUserBounds();
    let { min: i, max: o } = this;
    const s = (l) => i = r ? i : l, a = (l) => o = n ? o : l;
    if (e) {
      const l = kr(i), c = kr(o);
      l < 0 && c < 0 ? a(0) : l > 0 && c > 0 && s(0);
    }
    if (i === o) {
      let l = o === 0 ? 1 : Math.abs(o * 0.05);
      a(o + l), e || s(i - l);
    }
    this.min = i, this.max = o;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: r, stepSize: n } = e, i;
    return n ? (i = Math.ceil(this.max / n) - Math.floor(this.min / n) + 1, i > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${n} would result generating up to ${i} ticks. Limiting to 1000.`), i = 1e3)) : (i = this.computeTickLimit(), r = r || 11), r && (i = Math.min(r, i)), i;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, r = e.ticks;
    let n = this.getTickLimit();
    n = Math.max(2, n);
    const i = {
      maxTicks: n,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: r.precision,
      step: r.stepSize,
      count: r.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: r.minRotation || 0,
      includeBounds: r.includeBounds !== !1
    }, o = this._range || this, s = t5(i, o);
    return e.bounds === "ticks" && h1(s, this, "value"), e.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  configure() {
    const e = this.ticks;
    let r = this.min, n = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const i = (n - r) / Math.max(e.length - 1, 1) / 2;
      r -= i, n += i;
    }
    this._startValue = r, this._endValue = n, this._valueRange = n - r;
  }
  getLabelForValue(e) {
    return Go(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class Vc extends xa {
  determineDataLimits() {
    const { min: e, max: r } = this.getMinMax(!0);
    this.min = pt(e) ? e : 0, this.max = pt(r) ? r : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), r = e ? this.width : this.height, n = pr(this.options.ticks.minRotation), i = (e ? Math.sin(n) : Math.cos(n)) || 1e-3, o = this._resolveTickFontOptions(0);
    return Math.ceil(r / Math.min(40, o.lineHeight / i));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
ye(Vc, "id", "linear"), ye(Vc, "defaults", {
  ticks: {
    callback: Ya.formatters.numeric
  }
});
const No = (t) => Math.floor(tn(t)), Cn = (t, e) => Math.pow(10, No(t) + e);
function Mh(t) {
  return t / Math.pow(10, No(t)) === 1;
}
function Nh(t, e, r) {
  const n = Math.pow(10, r), i = Math.floor(t / n);
  return Math.ceil(e / n) - i;
}
function r5(t, e) {
  const r = e - t;
  let n = No(r);
  for (; Nh(t, e, n) > 10; )
    n++;
  for (; Nh(t, e, n) < 10; )
    n--;
  return Math.min(n, No(t));
}
function n5(t, { min: e, max: r }) {
  e = Ht(t.min, e);
  const n = [], i = No(e);
  let o = r5(e, r), s = o < 0 ? Math.pow(10, Math.abs(o)) : 1;
  const a = Math.pow(10, o), l = i > o ? Math.pow(10, i) : 0, c = Math.round((e - l) * s) / s, u = Math.floor((e - l) / a / 10) * a * 10;
  let f = Math.floor((c - u) / Math.pow(10, o)), d = Ht(t.min, Math.round((l + u + f * Math.pow(10, o)) * s) / s);
  for (; d < r; )
    n.push({
      value: d,
      major: Mh(d),
      significand: f
    }), f >= 10 ? f = f < 15 ? 15 : 20 : f++, f >= 20 && (o++, f = 2, s = o >= 0 ? 1 : s), d = Math.round((l + u + f * Math.pow(10, o)) * s) / s;
  const h = Ht(t.max, d);
  return n.push({
    value: h,
    major: Mh(h),
    significand: f
  }), n;
}
class qc extends Qn {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(e, r) {
    const n = xa.prototype.parse.apply(this, [
      e,
      r
    ]);
    if (n === 0) {
      this._zero = !0;
      return;
    }
    return pt(n) && n > 0 ? n : null;
  }
  determineDataLimits() {
    const { min: e, max: r } = this.getMinMax(!0);
    this.min = pt(e) ? Math.max(0, e) : null, this.max = pt(r) ? Math.max(0, r) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !pt(this._userMin) && (this.min = e === Cn(this.min, 0) ? Cn(this.min, -1) : Cn(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: e, maxDefined: r } = this.getUserBounds();
    let n = this.min, i = this.max;
    const o = (a) => n = e ? n : a, s = (a) => i = r ? i : a;
    n === i && (n <= 0 ? (o(1), s(10)) : (o(Cn(n, -1)), s(Cn(i, 1)))), n <= 0 && o(Cn(i, -1)), i <= 0 && s(Cn(n, 1)), this.min = n, this.max = i;
  }
  buildTicks() {
    const e = this.options, r = {
      min: this._userMin,
      max: this._userMax
    }, n = n5(r, this);
    return e.bounds === "ticks" && h1(n, this, "value"), e.reverse ? (n.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), n;
  }
  getLabelForValue(e) {
    return e === void 0 ? "0" : Go(e, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const e = this.min;
    super.configure(), this._startValue = tn(e), this._valueRange = tn(this.max) - tn(e);
  }
  getPixelForValue(e) {
    return (e === void 0 || e === 0) && (e = this.min), e === null || isNaN(e) ? NaN : this.getPixelForDecimal(e === this.min ? 0 : (tn(e) - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    const r = this.getDecimalForPixel(e);
    return Math.pow(10, this._startValue + r * this._valueRange);
  }
}
ye(qc, "id", "logarithmic"), ye(qc, "defaults", {
  ticks: {
    callback: Ya.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Hc(t) {
  const e = t.ticks;
  if (e.display && t.display) {
    const r = Mt(e.backdropPadding);
    return Oe(e.font && e.font.size, gt.font.size) + r.height;
  }
  return 0;
}
function i5(t, e, r) {
  return r = it(r) ? r : [
    r
  ], {
    w: d2(t, e.string, r),
    h: r.length * e.lineHeight
  };
}
function Bh(t, e, r, n, i) {
  return t === n || t === i ? {
    start: e - r / 2,
    end: e + r / 2
  } : t < n || t > i ? {
    start: e - r,
    end: e
  } : {
    start: e,
    end: e + r
  };
}
function o5(t) {
  const e = {
    l: t.left + t._padding.left,
    r: t.right - t._padding.right,
    t: t.top + t._padding.top,
    b: t.bottom - t._padding.bottom
  }, r = Object.assign({}, e), n = [], i = [], o = t._pointLabels.length, s = t.options.pointLabels, a = s.centerPointLabels ? st / o : 0;
  for (let l = 0; l < o; l++) {
    const c = s.setContext(t.getPointLabelContext(l));
    i[l] = c.padding;
    const u = t.getPointPosition(l, t.drawingArea + i[l], a), f = vt(c.font), d = i5(t.ctx, f, t._pointLabels[l]);
    n[l] = d;
    const h = Yt(t.getIndexAngle(l) + a), g = Math.round(ju(h)), p = Bh(g, u.x, d.w, 0, 180), y = Bh(g, u.y, d.h, 90, 270);
    s5(r, e, h, p, y);
  }
  t.setCenterPoint(e.l - r.l, r.r - e.r, e.t - r.t, r.b - e.b), t._pointLabelItems = c5(t, n, i);
}
function s5(t, e, r, n, i) {
  const o = Math.abs(Math.sin(r)), s = Math.abs(Math.cos(r));
  let a = 0, l = 0;
  n.start < e.l ? (a = (e.l - n.start) / o, t.l = Math.min(t.l, e.l - a)) : n.end > e.r && (a = (n.end - e.r) / o, t.r = Math.max(t.r, e.r + a)), i.start < e.t ? (l = (e.t - i.start) / s, t.t = Math.min(t.t, e.t - l)) : i.end > e.b && (l = (i.end - e.b) / s, t.b = Math.max(t.b, e.b + l));
}
function a5(t, e, r) {
  const n = t.drawingArea, { extra: i, additionalAngle: o, padding: s, size: a } = r, l = t.getPointPosition(e, n + i + s, o), c = Math.round(ju(Yt(l.angle + mt))), u = d5(l.y, a.h, c), f = u5(c), d = f5(l.x, a.w, f);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: f,
    left: d,
    top: u,
    right: d + a.w,
    bottom: u + a.h
  };
}
function l5(t, e) {
  if (!e)
    return !0;
  const { left: r, top: n, right: i, bottom: o } = t;
  return !(Wr({
    x: r,
    y: n
  }, e) || Wr({
    x: r,
    y: o
  }, e) || Wr({
    x: i,
    y: n
  }, e) || Wr({
    x: i,
    y: o
  }, e));
}
function c5(t, e, r) {
  const n = [], i = t._pointLabels.length, o = t.options, { centerPointLabels: s, display: a } = o.pointLabels, l = {
    extra: Hc(o) / 2,
    additionalAngle: s ? st / i : 0
  };
  let c;
  for (let u = 0; u < i; u++) {
    l.padding = r[u], l.size = e[u];
    const f = a5(t, u, l);
    n.push(f), a === "auto" && (f.visible = l5(f, c), f.visible && (c = f));
  }
  return n;
}
function u5(t) {
  return t === 0 || t === 180 ? "center" : t < 180 ? "left" : "right";
}
function f5(t, e, r) {
  return r === "right" ? t -= e : r === "center" && (t -= e / 2), t;
}
function d5(t, e, r) {
  return r === 90 || r === 270 ? t -= e / 2 : (r > 270 || r < 90) && (t -= e), t;
}
function h5(t, e, r) {
  const { left: n, top: i, right: o, bottom: s } = r, { backdropColor: a } = e;
  if (!We(a)) {
    const l = Ln(e.borderRadius), c = Mt(e.backdropPadding);
    t.fillStyle = a;
    const u = n - c.left, f = i - c.top, d = o - n + c.width, h = s - i + c.height;
    Object.values(l).some((g) => g !== 0) ? (t.beginPath(), Do(t, {
      x: u,
      y: f,
      w: d,
      h,
      radius: l
    }), t.fill()) : t.fillRect(u, f, d, h);
  }
}
function p5(t, e) {
  const { ctx: r, options: { pointLabels: n } } = t;
  for (let i = e - 1; i >= 0; i--) {
    const o = t._pointLabelItems[i];
    if (!o.visible)
      continue;
    const s = n.setContext(t.getPointLabelContext(i));
    h5(r, s, o);
    const a = vt(s.font), { x: l, y: c, textAlign: u } = o;
    Hn(r, t._pointLabels[i], l, c + a.lineHeight / 2, a, {
      color: s.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function ig(t, e, r, n) {
  const { ctx: i } = t;
  if (r)
    i.arc(t.xCenter, t.yCenter, e, 0, ot);
  else {
    let o = t.getPointPosition(0, e);
    i.moveTo(o.x, o.y);
    for (let s = 1; s < n; s++)
      o = t.getPointPosition(s, e), i.lineTo(o.x, o.y);
  }
}
function g5(t, e, r, n, i) {
  const o = t.ctx, s = e.circular, { color: a, lineWidth: l } = e;
  !s && !n || !a || !l || r < 0 || (o.save(), o.strokeStyle = a, o.lineWidth = l, o.setLineDash(i.dash), o.lineDashOffset = i.dashOffset, o.beginPath(), ig(t, r, s, n), o.closePath(), o.stroke(), o.restore());
}
function m5(t, e, r) {
  return bn(t, {
    label: r,
    index: e,
    type: "pointLabel"
  });
}
class ao extends xa {
  constructor(e) {
    super(e), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const e = this._padding = Mt(Hc(this.options) / 2), r = this.width = this.maxWidth - e.width, n = this.height = this.maxHeight - e.height;
    this.xCenter = Math.floor(this.left + r / 2 + e.left), this.yCenter = Math.floor(this.top + n / 2 + e.top), this.drawingArea = Math.floor(Math.min(r, n) / 2);
  }
  determineDataLimits() {
    const { min: e, max: r } = this.getMinMax(!1);
    this.min = pt(e) && !isNaN(e) ? e : 0, this.max = pt(r) && !isNaN(r) ? r : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Hc(this.options));
  }
  generateTickLabels(e) {
    xa.prototype.generateTickLabels.call(this, e), this._pointLabels = this.getLabels().map((r, n) => {
      const i = nt(this.options.pointLabels.callback, [
        r,
        n
      ], this);
      return i || i === 0 ? i : "";
    }).filter((r, n) => this.chart.getDataVisibility(n));
  }
  fit() {
    const e = this.options;
    e.display && e.pointLabels.display ? o5(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(e, r, n, i) {
    this.xCenter += Math.floor((e - r) / 2), this.yCenter += Math.floor((n - i) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(e, r, n, i));
  }
  getIndexAngle(e) {
    const r = ot / (this._pointLabels.length || 1), n = this.options.startAngle || 0;
    return Yt(e * r + pr(n));
  }
  getDistanceFromCenterForValue(e) {
    if (We(e))
      return NaN;
    const r = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - e) * r : (e - this.min) * r;
  }
  getValueForDistanceFromCenter(e) {
    if (We(e))
      return NaN;
    const r = e / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - r : this.min + r;
  }
  getPointLabelContext(e) {
    const r = this._pointLabels || [];
    if (e >= 0 && e < r.length) {
      const n = r[e];
      return m5(this.getContext(), e, n);
    }
  }
  getPointPosition(e, r, n = 0) {
    const i = this.getIndexAngle(e) - mt + n;
    return {
      x: Math.cos(i) * r + this.xCenter,
      y: Math.sin(i) * r + this.yCenter,
      angle: i
    };
  }
  getPointPositionForValue(e, r) {
    return this.getPointPosition(e, this.getDistanceFromCenterForValue(r));
  }
  getBasePosition(e) {
    return this.getPointPositionForValue(e || 0, this.getBaseValue());
  }
  getPointLabelPosition(e) {
    const { left: r, top: n, right: i, bottom: o } = this._pointLabelItems[e];
    return {
      left: r,
      top: n,
      right: i,
      bottom: o
    };
  }
  drawBackground() {
    const { backgroundColor: e, grid: { circular: r } } = this.options;
    if (e) {
      const n = this.ctx;
      n.save(), n.beginPath(), ig(this, this.getDistanceFromCenterForValue(this._endValue), r, this._pointLabels.length), n.closePath(), n.fillStyle = e, n.fill(), n.restore();
    }
  }
  drawGrid() {
    const e = this.ctx, r = this.options, { angleLines: n, grid: i, border: o } = r, s = this._pointLabels.length;
    let a, l, c;
    if (r.pointLabels.display && p5(this, s), i.display && this.ticks.forEach((u, f) => {
      if (f !== 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const d = this.getContext(f), h = i.setContext(d), g = o.setContext(d);
        g5(this, h, l, s, g);
      }
    }), n.display) {
      for (e.save(), a = s - 1; a >= 0; a--) {
        const u = n.setContext(this.getPointLabelContext(a)), { color: f, lineWidth: d } = u;
        !d || !f || (e.lineWidth = d, e.strokeStyle = f, e.setLineDash(u.borderDash), e.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(r.ticks.reverse ? this.min : this.max), c = this.getPointPosition(a, l), e.beginPath(), e.moveTo(this.xCenter, this.yCenter), e.lineTo(c.x, c.y), e.stroke());
      }
      e.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const e = this.ctx, r = this.options, n = r.ticks;
    if (!n.display)
      return;
    const i = this.getIndexAngle(0);
    let o, s;
    e.save(), e.translate(this.xCenter, this.yCenter), e.rotate(i), e.textAlign = "center", e.textBaseline = "middle", this.ticks.forEach((a, l) => {
      if (l === 0 && !r.reverse)
        return;
      const c = n.setContext(this.getContext(l)), u = vt(c.font);
      if (o = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        e.font = u.string, s = e.measureText(a.label).width, e.fillStyle = c.backdropColor;
        const f = Mt(c.backdropPadding);
        e.fillRect(-s / 2 - f.left, -o - u.size / 2 - f.top, s + f.width, u.size + f.height);
      }
      Hn(e, a.label, 0, -o, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), e.restore();
  }
  drawTitle() {
  }
}
ye(ao, "id", "radialLinear"), ye(ao, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Ya.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), ye(ao, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), ye(ao, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Qa = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, jt = /* @__PURE__ */ Object.keys(Qa);
function Lh(t, e) {
  return t - e;
}
function Fh(t, e) {
  if (We(e))
    return null;
  const r = t._adapter, { parser: n, round: i, isoWeekday: o } = t._parseOpts;
  let s = e;
  return typeof n == "function" && (s = n(s)), pt(s) || (s = typeof n == "string" ? r.parse(s, n) : r.parse(s)), s === null ? null : (i && (s = i === "week" && (_i(o) || o === !0) ? r.startOf(s, "isoWeek", o) : r.startOf(s, i)), +s);
}
function jh(t, e, r, n) {
  const i = jt.length;
  for (let o = jt.indexOf(t); o < i - 1; ++o) {
    const s = Qa[jt[o]], a = s.steps ? s.steps : Number.MAX_SAFE_INTEGER;
    if (s.common && Math.ceil((r - e) / (a * s.size)) <= n)
      return jt[o];
  }
  return jt[i - 1];
}
function y5(t, e, r, n, i) {
  for (let o = jt.length - 1; o >= jt.indexOf(r); o--) {
    const s = jt[o];
    if (Qa[s].common && t._adapter.diff(i, n, s) >= e - 1)
      return s;
  }
  return jt[r ? jt.indexOf(r) : 0];
}
function b5(t) {
  for (let e = jt.indexOf(t) + 1, r = jt.length; e < r; ++e)
    if (Qa[jt[e]].common)
      return jt[e];
}
function Wh(t, e, r) {
  if (!r)
    t[e] = !0;
  else if (r.length) {
    const { lo: n, hi: i } = Wu(r, e), o = r[n] >= e ? r[n] : r[i];
    t[o] = !0;
  }
}
function v5(t, e, r, n) {
  const i = t._adapter, o = +i.startOf(e[0].value, n), s = e[e.length - 1].value;
  let a, l;
  for (a = o; a <= s; a = +i.add(a, 1, n))
    l = r[a], l >= 0 && (e[l].major = !0);
  return e;
}
function Uh(t, e, r) {
  const n = [], i = {}, o = e.length;
  let s, a;
  for (s = 0; s < o; ++s)
    a = e[s], i[a] = s, n.push({
      value: a,
      major: !1
    });
  return o === 0 || !r ? n : v5(t, n, i, r);
}
class Bo extends Qn {
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, r = {}) {
    const n = e.time || (e.time = {}), i = this._adapter = new Tv._date(e.adapters.date);
    i.init(r), go(n.displayFormats, i.formats()), this._parseOpts = {
      parser: n.parser,
      round: n.round,
      isoWeekday: n.isoWeekday
    }, super.init(e), this._normalized = r.normalized;
  }
  parse(e, r) {
    return e === void 0 ? null : Fh(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, r = this._adapter, n = e.time.unit || "day";
    let { min: i, max: o, minDefined: s, maxDefined: a } = this.getUserBounds();
    function l(c) {
      !s && !isNaN(c.min) && (i = Math.min(i, c.min)), !a && !isNaN(c.max) && (o = Math.max(o, c.max));
    }
    (!s || !a) && (l(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && l(this.getMinMax(!1))), i = pt(i) && !isNaN(i) ? i : +r.startOf(Date.now(), n), o = pt(o) && !isNaN(o) ? o : +r.endOf(Date.now(), n) + 1, this.min = Math.min(i, o - 1), this.max = Math.max(i + 1, o);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let r = Number.POSITIVE_INFINITY, n = Number.NEGATIVE_INFINITY;
    return e.length && (r = e[0], n = e[e.length - 1]), {
      min: r,
      max: n
    };
  }
  buildTicks() {
    const e = this.options, r = e.time, n = e.ticks, i = n.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && i.length && (this.min = this._userMin || i[0], this.max = this._userMax || i[i.length - 1]);
    const o = this.min, s = this.max, a = $3(i, o, s);
    return this._unit = r.unit || (n.autoSkip ? jh(r.minUnit, this.min, this.max, this._getLabelCapacity(o)) : y5(this, a.length, r.minUnit, this.min, this.max)), this._majorUnit = !n.major.enabled || this._unit === "year" ? void 0 : b5(this._unit), this.initOffsets(i), e.reverse && a.reverse(), Uh(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let r = 0, n = 0, i, o;
    this.options.offset && e.length && (i = this.getDecimalForValue(e[0]), e.length === 1 ? r = 1 - i : r = (this.getDecimalForValue(e[1]) - i) / 2, o = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? n = o : n = (o - this.getDecimalForValue(e[e.length - 2])) / 2);
    const s = e.length < 3 ? 0.5 : 0.25;
    r = St(r, 0, s), n = St(n, 0, s), this._offsets = {
      start: r,
      end: n,
      factor: 1 / (r + 1 + n)
    };
  }
  _generate() {
    const e = this._adapter, r = this.min, n = this.max, i = this.options, o = i.time, s = o.unit || jh(o.minUnit, r, n, this._getLabelCapacity(r)), a = Oe(i.ticks.stepSize, 1), l = s === "week" ? o.isoWeekday : !1, c = _i(l) || l === !0, u = {};
    let f = r, d, h;
    if (c && (f = +e.startOf(f, "isoWeek", l)), f = +e.startOf(f, c ? "day" : s), e.diff(n, r, s) > 1e5 * a)
      throw new Error(r + " and " + n + " are too far apart with stepSize of " + a + " " + s);
    const g = i.ticks.source === "data" && this.getDataTimestamps();
    for (d = f, h = 0; d < n; d = +e.add(d, a, s), h++)
      Wh(u, d, g);
    return (d === n || i.bounds === "ticks" || h === 1) && Wh(u, d, g), Object.keys(u).sort(Lh).map((p) => +p);
  }
  getLabelForValue(e) {
    const r = this._adapter, n = this.options.time;
    return n.tooltipFormat ? r.format(e, n.tooltipFormat) : r.format(e, n.displayFormats.datetime);
  }
  format(e, r) {
    const i = this.options.time.displayFormats, o = this._unit, s = r || i[o];
    return this._adapter.format(e, s);
  }
  _tickFormatFunction(e, r, n, i) {
    const o = this.options, s = o.ticks.callback;
    if (s)
      return nt(s, [
        e,
        r,
        n
      ], this);
    const a = o.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && a[l], f = c && a[c], d = n[r], h = c && f && d && d.major;
    return this._adapter.format(e, i || (h ? f : u));
  }
  generateTickLabels(e) {
    let r, n, i;
    for (r = 0, n = e.length; r < n; ++r)
      i = e[r], i.label = this._tickFormatFunction(i.value, r, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const r = this._offsets, n = this.getDecimalForValue(e);
    return this.getPixelForDecimal((r.start + n) * r.factor);
  }
  getValueForPixel(e) {
    const r = this._offsets, n = this.getDecimalForPixel(e) / r.factor - r.end;
    return this.min + n * (this.max - this.min);
  }
  _getLabelSize(e) {
    const r = this.options.ticks, n = this.ctx.measureText(e).width, i = pr(this.isHorizontal() ? r.maxRotation : r.minRotation), o = Math.cos(i), s = Math.sin(i), a = this._resolveTickFontOptions(0).size;
    return {
      w: n * o + a * s,
      h: n * s + a * o
    };
  }
  _getLabelCapacity(e) {
    const r = this.options.time, n = r.displayFormats, i = n[r.unit] || n.millisecond, o = this._tickFormatFunction(e, 0, Uh(this, [
      e
    ], this._majorUnit), i), s = this._getLabelSize(o), a = Math.floor(this.isHorizontal() ? this.width / s.w : this.height / s.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], r, n;
    if (e.length)
      return e;
    const i = this.getMatchingVisibleMetas();
    if (this._normalized && i.length)
      return this._cache.data = i[0].controller.getAllParsedValues(this);
    for (r = 0, n = i.length; r < n; ++r)
      e = e.concat(i[r].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let r, n;
    if (e.length)
      return e;
    const i = this.getLabels();
    for (r = 0, n = i.length; r < n; ++r)
      e.push(Fh(this, i[r]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return m1(e.sort(Lh));
  }
}
ye(Bo, "id", "time"), ye(Bo, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Is(t, e, r) {
  let n = 0, i = t.length - 1, o, s, a, l;
  r ? (e >= t[n].pos && e <= t[i].pos && ({ lo: n, hi: i } = jr(t, "pos", e)), { pos: o, time: a } = t[n], { pos: s, time: l } = t[i]) : (e >= t[n].time && e <= t[i].time && ({ lo: n, hi: i } = jr(t, "time", e)), { time: o, pos: a } = t[n], { time: s, pos: l } = t[i]);
  const c = s - o;
  return c ? a + (l - a) * (e - o) / c : a;
}
class Yc extends Bo {
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), r = this._table = this.buildLookupTable(e);
    this._minPos = Is(r, this.min), this._tableRange = Is(r, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: r, max: n } = this, i = [], o = [];
    let s, a, l, c, u;
    for (s = 0, a = e.length; s < a; ++s)
      c = e[s], c >= r && c <= n && i.push(c);
    if (i.length < 2)
      return [
        {
          time: r,
          pos: 0
        },
        {
          time: n,
          pos: 1
        }
      ];
    for (s = 0, a = i.length; s < a; ++s)
      u = i[s + 1], l = i[s - 1], c = i[s], Math.round((u + l) / 2) !== c && o.push({
        time: c,
        pos: s / (a - 1)
      });
    return o;
  }
  _generate() {
    const e = this.min, r = this.max;
    let n = super.getDataTimestamps();
    return (!n.includes(e) || !n.length) && n.splice(0, 0, e), (!n.includes(r) || n.length === 1) && n.push(r), n.sort((i, o) => i - o);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const r = this.getDataTimestamps(), n = this.getLabelTimestamps();
    return r.length && n.length ? e = this.normalize(r.concat(n)) : e = r.length ? r : n, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (Is(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const r = this._offsets, n = this.getDecimalForPixel(e) / r.factor - r.end;
    return Is(this._table, n * this._tableRange + this._minPos, !0);
  }
}
ye(Yc, "id", "timeseries"), ye(Yc, "defaults", Bo.defaults);
var A5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: zc,
  LinearScale: Vc,
  LogarithmicScale: qc,
  RadialLinearScale: ao,
  TimeScale: Bo,
  TimeSeriesScale: Yc
});
const w5 = [
  Cv,
  nA,
  GA,
  A5
];
Nr.register(...w5);
class x5 {
  constructor(e, r, n) {
    ye(this, "getConfiguration");
    this.myChart = void 0, this.getConfiguration = r, this.resetBot = n, this.startTime = e, this.elapsedTimeDiv = null;
  }
  createOverlay() {
    const e = document.createElement("div");
    e.style.display = "flex", e.style.position = "fixed", e.style.top = "0%", e.style.right = "0%", e.style.width = "450px", e.style.height = "150px", e.style.zIndex = "1000", e.style.backgroundColor = "rgba(0,0,0,0.7)";
    const r = document.createElement("div");
    r.id = "overlay", r.style.top = "0%", r.style.right = "0%", r.style.width = "75%", r.style.height = "150px", r.style.backgroundColor = "rgba(0,0,0,0.7)";
    const n = document.createElement("div");
    n.style.display = "flex", n.style.flexDirection = "column", n.style.width = "25%", n.style.height = "150px", n.style.justifyContent = "strech", n.style.alignItems = "strech", n.style.backgroundColor = "rgba(0,0,0,0.7)";
    const i = document.createElement("canvas");
    i.id = "overlayChart", i.width = "100%", i.height = "100%", this.elapsedTimeDiv = document.createElement("div"), this.elapsedTimeDiv.style.position = "absolute", this.elapsedTimeDiv.style.bottom = "5px", this.elapsedTimeDiv.style.left = "26%", this.elapsedTimeDiv.style.color = "gray", this.elapsedTimeDiv.style.fontSize = "12px", this.elapsedTimeDiv.innerText = "Elapsed Time: 0s";
    const o = document.createElement("button");
    o.innerText = "Reset", o.style.width = "100%", o.style.height = "50%", o.style.color = "gray", o.style.backgroundColor = "rgba(0,0,0,0.7)", n.appendChild(o), o.addEventListener("click", this.resetBot.bind(this));
    const s = document.createElement("button");
    return s.innerText = "Download", s.style.width = "100%", s.style.height = "50%", s.addEventListener("click", this.downloadConfiguration.bind(this)), s.style.backgroundColor = "rgba(0,0,0,0.7)", s.style.color = "gray", n.appendChild(s), e.appendChild(n), e.appendChild(r), r.appendChild(i), r.appendChild(this.elapsedTimeDiv), document.body.appendChild(e), { overlay: r, chartCanvas: i };
  }
  setConfigurationForBot(e) {
    this.getConfiguration = e, console.log("CONFIGURATION SET", this.getConfiguration());
  }
  downloadConfiguration() {
    console.log("DOWNLOADING CONF", this.getConfiguration());
    const e = this.getConfiguration();
    console.log("CONFIGURATIOn", e);
    const r = JSON.stringify(e, null, 2);
    console.log("jsonStr", r);
    const n = new Blob([r], { type: "application/json" }), i = URL.createObjectURL(n), o = document.createElement("a");
    o.href = i, o.download = "chartConfiguration.json", document.body.appendChild(o), o.click(), document.body.removeChild(o);
  }
  showOverlayChart() {
    const { overlay: e, chartCanvas: r } = this.createOverlay();
    setInterval(this.updateElapsedTime.bind(this), 1e3);
    const n = r.getContext("2d");
    this.myChart = new Nr(n, {
      type: "line",
      data: {
        labels: [],
        // Empty array, we will populate it dynamically
        datasets: [
          {
            label: "Average Rewards",
            data: [],
            // Empty array, we will populate it dynamically
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 0.6,
            fill: !1,
            pointRadius: 0,
            // This will remove the points
            pointHitRadius: 0
            // This will remove the points
          },
          {
            label: "Individual Rewards",
            data: [],
            // Empty array for individual data points
            borderColor: "rgba(255, 24, 12, 1)",
            // borderWidth: 2,
            fill: !0,
            pointRadius: 0.1,
            // Add points
            // pointHitRadius: 1,
            showLine: !1,
            animation: {
              // Disable animation for this dataset
              duration: 0
            }
          }
        ]
      },
      options: {
        scales: {
          x: {
            type: "linear",
            // To handle numerical data on x-axis
            position: "bottom",
            title: {
              display: !0,
              text: "Number of Iterations"
            }
          },
          y: {
            title: {
              display: !0,
              text: "Total Reward"
            }
          }
        }
      }
    });
  }
  updateChart(e, r, n) {
    this.myChart.data.labels.push(e), this.myChart.data.datasets[0].data.push(n / e), r !== 0 && this.myChart.data.datasets[1].data.push(r), this.myChart.update();
  }
  reset() {
    this.startTime = (/* @__PURE__ */ new Date()).getTime(), this.myChart.data.labels = [], this.myChart.data.datasets[0].data = [], this.myChart.update();
  }
  updateElapsedTime() {
    const r = (/* @__PURE__ */ new Date()).getTime() - this.startTime, n = Math.floor(r / 1e3), i = Math.floor(n / 3600), o = Math.floor(n % 3600 / 60), s = n % 60, a = String(i).padStart(2, "0"), l = String(o).padStart(2, "0"), c = String(s).padStart(2, "0"), u = `${a}:${l}:${c}`;
    this.elapsedTimeDiv.innerText = `Elapsed Time: ${u}`;
  }
}
function zh(t) {
  try {
    var e = window[t], r = "__storage_test__";
    return e.setItem(r, r), e.removeItem(r), !0;
  } catch {
    return !1;
  }
}
class og {
  constructor(e) {
    if (!e || !e.player)
      throw new Error(
        "botParams is undefined, did you forget to pass botParams to base Bot class like: super(params);"
      );
    this._player = e.player, this._player.setState("__bot", !0), this._player.bot = this, this._id = void 0;
  }
  get id() {
    return this._player.id;
  }
  get player() {
    return this._player;
  }
  getProfile() {
    return this.player.getProfile();
  }
  getState(e) {
    return this.player.getState(e);
  }
  setState(e, r, n) {
    this.player.setState(e, r, n);
  }
  onQuit(e) {
    return this.player.onQuit(e);
  }
  kick() {
    return this.player.kick();
  }
}
class _5 extends og {
  constructor(r) {
    super(r);
    ye(this, "agent");
    ye(this, "totalIteration", 0);
    ye(this, "totalReward", 0);
    ye(this, "numberOfStates", 0);
    ye(this, "numberOfActions", 0);
    ye(this, "showChart", !1);
    ye(this, "overlayChart");
    ye(this, "startTime", (/* @__PURE__ */ new Date()).getTime());
    if (!r.numberOfActions)
      throw new Error("Please Define Number of Actions for DQN Bot");
    if (!r.numberOfStates)
      throw new Error("Please Define Number of States for DQN Bot");
    this.numberOfActions = r.numberOfActions, this.numberOfStates = r.numberOfStates;
    const n = {
      getNumStates: () => this.numberOfStates,
      getMaxNumActions: () => this.numberOfActions
    };
    this.agent = new a1.DQNAgent(n, r.specifications), (!r.hasOwnProperty("retrieveFromLocalStorage") || r.retrieveFromLocalStorage) && (window.addEventListener("beforeunload", () => {
      this.saveModelToLocalStorage();
    }), this.loadModelFromLocalStorage()), r.weights && r.weights.modelWeights && this.setWeights(r.weights), this.overlayChart = new x5(
      this.startTime,
      this.getDownloadableConfiguration.bind(this),
      this.resetBot.bind(this)
    );
  }
  resetBot() {
    this.agent.reset(), this.totalIteration = 0, this.totalReward = 0, this.startTime = (/* @__PURE__ */ new Date()).getTime(), this.overlayChart.reset();
  }
  act(r) {
    if (r.length !== this.numberOfStates)
      throw new Error(
        `State provided for action ${r.length} does not match the number of states ${this.numberOfStates} provided while initialization`
      );
    const n = this.getValidStates(r);
    return this.agent.act(n);
  }
  getValidStates(r) {
    const n = [];
    for (let i = 0; i < r.length; i++) {
      const o = r[i];
      if (typeof o == "boolean")
        n.push(o ? 1 : 0);
      else if (typeof o == "number" && !isNaN(o))
        n.push(o);
      else
        throw new Error(
          `Invalid element at index ${i}: ${o}. Bot only expects Number/Boolean`
        );
    }
    return n;
  }
  learn(r) {
    this.totalIteration += 1, this.totalReward += r, this.showChart && this.overlayChart.updateChart(
      this.totalIteration,
      r,
      this.totalReward
    ), this.agent.learn(r);
  }
  getCurrentModelStateAsJSON() {
    const r = this.agent.toJSON();
    return JSON.stringify(r);
  }
  setCurrentModelState(r) {
    const n = JSON.parse(r);
    this.agent.fromJSON(n);
  }
  saveModelToLocalStorage() {
    try {
      if (zh("localStorage")) {
        const r = this.getCurrentModelStateAsJSON();
        localStorage.setItem(
          this.numberOfStates + "_" + this.numberOfActions,
          r
        );
      }
    } catch (r) {
      console.error(r);
    }
  }
  loadModelFromLocalStorage() {
    try {
      if (zh("localStorage")) {
        const r = localStorage.getItem(
          this.numberOfStates + "_" + this.numberOfActions
        );
        r && this.setCurrentModelState(r);
      }
    } catch (r) {
      console.error(r);
    }
  }
  getDownloadableConfiguration() {
    return {
      numberOfActions: this.numberOfActions,
      numberOfStates: this.numberOfStates,
      modelWeights: this.getCurrentModelStateAsJSON(),
      type: "dqn",
      iterations: this.totalIteration,
      reward: this.totalReward,
      startTime: this.startTime
    };
  }
  setWeights(r) {
    if (!r)
      throw new Error("Weights not given");
    this.setCurrentModelState(r.modelWeights), this.totalIteration = r.iterations ? r.iterations : 0, this.totalReward = r.reward ? r.reward : 0, this.startTime = r.startTime ? r.startTime : (/* @__PURE__ */ new Date()).getTime();
  }
  displayChart() {
    this.overlayChart.showOverlayChart(), this.showChart = !0;
  }
}
const tc = 20;
class gE extends _5 {
  constructor(r) {
    var n = 0;
    let i = r.joystickOptions;
    i.type === "dpad" ? n += 4 : i.type === "angular" && (n += Math.floor(360 / tc)), i.buttons && (n += i.buttons.length), r.numberOfActions = n;
    super(r);
    ye(this, "joystick");
    this.joystick = i, this.numberOfActions = n;
  }
  getAction(r) {
    var n = this.act(r);
    let i = {};
    if (this.joystick.type === "dpad") {
      var o = void 0, s = void 0;
      n === 0 && (o = "left"), n === 1 && (o = "right"), n === 2 && (s = "up"), n === 3 && (s = "down"), o && (i.x = o), s && (i.y = s);
    }
    this.joystick.type === "angular" && (i = n * tc * (Math.PI / 180));
    var a = this.joystick.type === "dpad" ? 4 : Math.floor(360 / tc), l = {};
    const c = this.joystick.buttons;
    if (c.length > 0)
      for (let u = 0; u < c.length; u++)
        u === n - a ? l[c[u].id] = !0 : l[c[u].id] = !1;
    return {
      joystickType: this.joystick.type,
      finalDirection: i,
      buttonSelection: l
    };
  }
  setDQNBotState(r) {
    var { joystickType: n, finalDirection: i, buttonSelection: o } = this.getAction(r);
    this.player.setState("ctr-joystick", !1), n === "angular" && !isNaN(i) && (this.player.setState("ctr-angle", i), this.player.setState("ctr-joystick", !0)), n === "dpad" && Object.keys(i).length !== 0 && (this.player.setState("ctr-dpad", i), this.player.setState("ctr-joystick", !0));
    for (var s in o)
      this.player.setState("ctr-" + s, !1), this.player.setState("ctr-" + s, o[s]);
  }
  setDQNBotReward(r) {
    this.learn(r);
  }
}
const Vh = [
  "#59BF82",
  "#FFF27A",
  "#F14EEB",
  "#FF7F56",
  "#6BDCFF",
  "#3905F5",
  "#FF3666"
];
function S5() {
  return new Promise((t, e) => {
    Me().connection.once("sync", () => {
      setTimeout(() => {
        t();
      }, 1e3);
    });
  });
}
let Xi = [], qh = !1, dr, Ar;
async function E5() {
  var t;
  if (!qh) {
    if (Ar = Me(), dr = (t = Ar.sdkOptions) == null ? void 0 : t.botOptions, !dr)
      throw new Error("Please Define Bot Options");
    if (!dr.botClass)
      throw new Error("Please Define Bot Instance");
    await S5(), qh = !0, Ar.on("joined", (e) => {
      !Ar.isHost && e.isBot() && sg(e);
    });
  }
}
function sg(t) {
  return dr.botParams = dr.botParams || {}, dr.botParams.player = t, new dr.botClass(dr.botParams);
}
function k5(t) {
  let e = "";
  const r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length;
  for (let i = 0; i < t; ++i)
    e += r.charAt(Math.floor(Math.random() * n));
  return e;
}
function C5(t) {
  return t && t.length > 0 ? t[Math.floor(Math.random() * t.length)] : Ha(qa(k5(10)));
}
async function T5() {
  if (!Ar || !Ar.isConnected)
    throw new Error("Create or join a room before adding bots");
  const t = Ar.sdkOptions || {}, e = Object.keys(Ar.getPlayers()).length;
  if (t.maxPlayersPerRoom && e >= t.maxPlayersPerRoom)
    throw new Error("Room's players limit has reached.");
  const r = Ar.connection.addProxyPlayer();
  r.setState("profile", {
    name: "Bot " + (Xi.length + 1),
    photo: C5(t.avatars),
    color: Vh[Xi.length % Vh.length]
  });
  let n = sg(r);
  if (!(n instanceof og))
    throw Ar.connection.removeProxyPlayer(r.id), new Error("Bot Class Should Be Instance of Bot");
  dr.trainingMode && n.displayChart();
  let i;
  return dr.botParams.joystickOptions ? i = new Pc(r, dr.botParams.joystickOptions) : i = new Pc(r), Xi.push({ player: r, joystick: i, bot: n }), r.on("quit", () => {
    const o = Xi.findIndex((s) => r.id == s.player.id);
    Xi.splice(o, 1);
  }), n;
}
const O5 = "playroomkit", I5 = "0.0.77", P5 = "https://joinplayroom.com", R5 = "./multiplayer.mjs", D5 = "./types.d.ts", M5 = [
  "multiplayer.umd.js",
  "multiplayer.full.umd.js",
  "multiplayer.mjs",
  "style.css",
  "types.d.ts",
  "api.md"
], N5 = {}, B5 = {
  react: ">=17.0.2 <= 18",
  "react-dom": ">=17.0.2 <= 18"
}, L5 = {
  "@discord/embedded-app-sdk": ">=1.0.0"
}, Gu = {
  name: O5,
  version: I5,
  homepage: P5,
  main: R5,
  types: D5,
  files: M5,
  dependencies: N5,
  peerDependencies: B5,
  optionalDependencies: L5
};
async function mE(t) {
  const e = ha(10);
  return await h3("_turns", {
    id: e,
    player: {
      id: To().id,
      profile: To().getProfile()
    },
    data: t
  }), e;
}
async function yE() {
  return await s1("_turns") || [];
}
async function bE() {
  await d3("_turns", void 0);
}
async function vE() {
  const t = await s1("_turns"), e = (t == null ? void 0 : t.filter((n) => n.player === To().id)) || [];
  return e[e.length - 1] || void 0;
}
const ag = `/*!
 * Bootstrap Grid Only (grid and responsive utilities extracted from Bootstrap 4.1.3)
 * GitHub: https://github.com/dmhendricks/bootstrap-grid-css
 * Bootstrap License: MIT (https://github.com/twbs/bootstrap/blob/v4-dev/LICENSE)
 * Credits: Twitter, Inc. & The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
 */@-ms-viewport{width:device-width}html{-webkit-box-sizing:border-box;box-sizing:border-box;-ms-overflow-style:scrollbar}*,*:before,*:after{-webkit-box-sizing:inherit;box-sizing:inherit}.bootstrap-wrapper .clearfix:after{display:block;clear:both;content:""}.bootstrap-wrapper .visible{visibility:visible!important}.bootstrap-wrapper .invisible{visibility:hidden!important}.bootstrap-wrapper .hidden-xs-up{display:none!important}@media (max-width: 575.98px){.bootstrap-wrapper .hidden-xs-down{display:none!important}}@media (min-width: 576px){.bootstrap-wrapper .hidden-sm-up{display:none!important}}@media (max-width: 767.98px){.bootstrap-wrapper .hidden-sm-down{display:none!important}}@media (min-width: 768px){.bootstrap-wrapper .hidden-md-up{display:none!important}}@media (max-width: 991.98px){.bootstrap-wrapper .hidden-md-down{display:none!important}}@media (min-width: 992px){.bootstrap-wrapper .hidden-lg-up{display:none!important}}@media (max-width: 1199.98px){.bootstrap-wrapper .hidden-lg-down{display:none!important}}@media (min-width: 1200px){.bootstrap-wrapper .hidden-xl-up{display:none!important}}.bootstrap-wrapper .hidden-xl-down,.bootstrap-wrapper .visible-print-block{display:none!important}@media print{.bootstrap-wrapper .visible-print-block{display:block!important}}.bootstrap-wrapper .visible-print-inline{display:none!important}@media print{.bootstrap-wrapper .visible-print-inline{display:inline!important}}.bootstrap-wrapper .visible-print-inline-block{display:none!important}@media print{.bootstrap-wrapper .visible-print-inline-block{display:inline-block!important}}@media print{.bootstrap-wrapper .hidden-print{display:none!important}}.bootstrap-wrapper .container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width: 576px){.bootstrap-wrapper .container{max-width:540px}}@media (min-width: 768px){.bootstrap-wrapper .container{max-width:720px}}@media (min-width: 992px){.bootstrap-wrapper .container{max-width:960px}}@media (min-width: 1200px){.bootstrap-wrapper .container{max-width:1140px}}.bootstrap-wrapper .container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.bootstrap-wrapper .row{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.bootstrap-wrapper .no-gutters{margin-right:0;margin-left:0}.bootstrap-wrapper .no-gutters>.col,.bootstrap-wrapper .no-gutters>[class*=col-]{padding-right:0;padding-left:0}.bootstrap-wrapper .col-1,.bootstrap-wrapper .col-2,.bootstrap-wrapper .col-3,.bootstrap-wrapper .col-4,.bootstrap-wrapper .col-5,.bootstrap-wrapper .col-6,.bootstrap-wrapper .col-7,.bootstrap-wrapper .col-8,.bootstrap-wrapper .col-9,.bootstrap-wrapper .col-10,.bootstrap-wrapper .col-11,.bootstrap-wrapper .col-12,.bootstrap-wrapper .col,.bootstrap-wrapper .col-auto,.bootstrap-wrapper .col-sm-1,.bootstrap-wrapper .col-sm-2,.bootstrap-wrapper .col-sm-3,.bootstrap-wrapper .col-sm-4,.bootstrap-wrapper .col-sm-5,.bootstrap-wrapper .col-sm-6,.bootstrap-wrapper .col-sm-7,.bootstrap-wrapper .col-sm-8,.bootstrap-wrapper .col-sm-9,.bootstrap-wrapper .col-sm-10,.bootstrap-wrapper .col-sm-11,.bootstrap-wrapper .col-sm-12,.bootstrap-wrapper .col-sm,.bootstrap-wrapper .col-sm-auto,.bootstrap-wrapper .col-md-1,.bootstrap-wrapper .col-md-2,.bootstrap-wrapper .col-md-3,.bootstrap-wrapper .col-md-4,.bootstrap-wrapper .col-md-5,.bootstrap-wrapper .col-md-6,.bootstrap-wrapper .col-md-7,.bootstrap-wrapper .col-md-8,.bootstrap-wrapper .col-md-9,.bootstrap-wrapper .col-md-10,.bootstrap-wrapper .col-md-11,.bootstrap-wrapper .col-md-12,.bootstrap-wrapper .col-md,.bootstrap-wrapper .col-md-auto,.bootstrap-wrapper .col-lg-1,.bootstrap-wrapper .col-lg-2,.bootstrap-wrapper .col-lg-3,.bootstrap-wrapper .col-lg-4,.bootstrap-wrapper .col-lg-5,.bootstrap-wrapper .col-lg-6,.bootstrap-wrapper .col-lg-7,.bootstrap-wrapper .col-lg-8,.bootstrap-wrapper .col-lg-9,.bootstrap-wrapper .col-lg-10,.bootstrap-wrapper .col-lg-11,.bootstrap-wrapper .col-lg-12,.bootstrap-wrapper .col-lg,.bootstrap-wrapper .col-lg-auto,.bootstrap-wrapper .col-xl-1,.bootstrap-wrapper .col-xl-2,.bootstrap-wrapper .col-xl-3,.bootstrap-wrapper .col-xl-4,.bootstrap-wrapper .col-xl-5,.bootstrap-wrapper .col-xl-6,.bootstrap-wrapper .col-xl-7,.bootstrap-wrapper .col-xl-8,.bootstrap-wrapper .col-xl-9,.bootstrap-wrapper .col-xl-10,.bootstrap-wrapper .col-xl-11,.bootstrap-wrapper .col-xl-12,.bootstrap-wrapper .col-xl,.bootstrap-wrapper .col-xl-auto{position:relative;width:100%;padding-right:15px;padding-left:15px}.bootstrap-wrapper .col{-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-wrapper .col-auto{-webkit-box-flex:0;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-wrapper .col-1{-webkit-box-flex:0;-webkit-flex:0 0 8.3333333333%;-ms-flex:0 0 8.3333333333%;flex:0 0 8.3333333333%;max-width:8.3333333333%}.bootstrap-wrapper .col-2{-webkit-box-flex:0;-webkit-flex:0 0 16.6666666667%;-ms-flex:0 0 16.6666666667%;flex:0 0 16.6666666667%;max-width:16.6666666667%}.bootstrap-wrapper .col-3{-webkit-box-flex:0;-webkit-flex:0 0 25%;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-wrapper .col-4{-webkit-box-flex:0;-webkit-flex:0 0 33.3333333333%;-ms-flex:0 0 33.3333333333%;flex:0 0 33.3333333333%;max-width:33.3333333333%}.bootstrap-wrapper .col-5{-webkit-box-flex:0;-webkit-flex:0 0 41.6666666667%;-ms-flex:0 0 41.6666666667%;flex:0 0 41.6666666667%;max-width:41.6666666667%}.bootstrap-wrapper .col-6{-webkit-box-flex:0;-webkit-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-wrapper .col-7{-webkit-box-flex:0;-webkit-flex:0 0 58.3333333333%;-ms-flex:0 0 58.3333333333%;flex:0 0 58.3333333333%;max-width:58.3333333333%}.bootstrap-wrapper .col-8{-webkit-box-flex:0;-webkit-flex:0 0 66.6666666667%;-ms-flex:0 0 66.6666666667%;flex:0 0 66.6666666667%;max-width:66.6666666667%}.bootstrap-wrapper .col-9{-webkit-box-flex:0;-webkit-flex:0 0 75%;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-wrapper .col-10{-webkit-box-flex:0;-webkit-flex:0 0 83.3333333333%;-ms-flex:0 0 83.3333333333%;flex:0 0 83.3333333333%;max-width:83.3333333333%}.bootstrap-wrapper .col-11{-webkit-box-flex:0;-webkit-flex:0 0 91.6666666667%;-ms-flex:0 0 91.6666666667%;flex:0 0 91.6666666667%;max-width:91.6666666667%}.bootstrap-wrapper .col-12{-webkit-box-flex:0;-webkit-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-wrapper .order-first{-webkit-box-ordinal-group:0;-webkit-order:-1;-ms-flex-order:-1;order:-1}.bootstrap-wrapper .order-last{-webkit-box-ordinal-group:14;-webkit-order:13;-ms-flex-order:13;order:13}.bootstrap-wrapper .order-0{-webkit-box-ordinal-group:1;-webkit-order:0;-ms-flex-order:0;order:0}.bootstrap-wrapper .order-1{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}.bootstrap-wrapper .order-2{-webkit-box-ordinal-group:3;-webkit-order:2;-ms-flex-order:2;order:2}.bootstrap-wrapper .order-3{-webkit-box-ordinal-group:4;-webkit-order:3;-ms-flex-order:3;order:3}.bootstrap-wrapper .order-4{-webkit-box-ordinal-group:5;-webkit-order:4;-ms-flex-order:4;order:4}.bootstrap-wrapper .order-5{-webkit-box-ordinal-group:6;-webkit-order:5;-ms-flex-order:5;order:5}.bootstrap-wrapper .order-6{-webkit-box-ordinal-group:7;-webkit-order:6;-ms-flex-order:6;order:6}.bootstrap-wrapper .order-7{-webkit-box-ordinal-group:8;-webkit-order:7;-ms-flex-order:7;order:7}.bootstrap-wrapper .order-8{-webkit-box-ordinal-group:9;-webkit-order:8;-ms-flex-order:8;order:8}.bootstrap-wrapper .order-9{-webkit-box-ordinal-group:10;-webkit-order:9;-ms-flex-order:9;order:9}.bootstrap-wrapper .order-10{-webkit-box-ordinal-group:11;-webkit-order:10;-ms-flex-order:10;order:10}.bootstrap-wrapper .order-11{-webkit-box-ordinal-group:12;-webkit-order:11;-ms-flex-order:11;order:11}.bootstrap-wrapper .order-12{-webkit-box-ordinal-group:13;-webkit-order:12;-ms-flex-order:12;order:12}.bootstrap-wrapper .offset-1{margin-left:8.3333333333%}.bootstrap-wrapper .offset-2{margin-left:16.6666666667%}.bootstrap-wrapper .offset-3{margin-left:25%}.bootstrap-wrapper .offset-4{margin-left:33.3333333333%}.bootstrap-wrapper .offset-5{margin-left:41.6666666667%}.bootstrap-wrapper .offset-6{margin-left:50%}.bootstrap-wrapper .offset-7{margin-left:58.3333333333%}.bootstrap-wrapper .offset-8{margin-left:66.6666666667%}.bootstrap-wrapper .offset-9{margin-left:75%}.bootstrap-wrapper .offset-10{margin-left:83.3333333333%}.bootstrap-wrapper .offset-11{margin-left:91.6666666667%}@media (min-width: 576px){.bootstrap-wrapper .col-sm{-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-wrapper .col-sm-auto{-webkit-box-flex:0;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-wrapper .col-sm-1{-webkit-box-flex:0;-webkit-flex:0 0 8.3333333333%;-ms-flex:0 0 8.3333333333%;flex:0 0 8.3333333333%;max-width:8.3333333333%}.bootstrap-wrapper .col-sm-2{-webkit-box-flex:0;-webkit-flex:0 0 16.6666666667%;-ms-flex:0 0 16.6666666667%;flex:0 0 16.6666666667%;max-width:16.6666666667%}.bootstrap-wrapper .col-sm-3{-webkit-box-flex:0;-webkit-flex:0 0 25%;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-wrapper .col-sm-4{-webkit-box-flex:0;-webkit-flex:0 0 33.3333333333%;-ms-flex:0 0 33.3333333333%;flex:0 0 33.3333333333%;max-width:33.3333333333%}.bootstrap-wrapper .col-sm-5{-webkit-box-flex:0;-webkit-flex:0 0 41.6666666667%;-ms-flex:0 0 41.6666666667%;flex:0 0 41.6666666667%;max-width:41.6666666667%}.bootstrap-wrapper .col-sm-6{-webkit-box-flex:0;-webkit-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-wrapper .col-sm-7{-webkit-box-flex:0;-webkit-flex:0 0 58.3333333333%;-ms-flex:0 0 58.3333333333%;flex:0 0 58.3333333333%;max-width:58.3333333333%}.bootstrap-wrapper .col-sm-8{-webkit-box-flex:0;-webkit-flex:0 0 66.6666666667%;-ms-flex:0 0 66.6666666667%;flex:0 0 66.6666666667%;max-width:66.6666666667%}.bootstrap-wrapper .col-sm-9{-webkit-box-flex:0;-webkit-flex:0 0 75%;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-wrapper .col-sm-10{-webkit-box-flex:0;-webkit-flex:0 0 83.3333333333%;-ms-flex:0 0 83.3333333333%;flex:0 0 83.3333333333%;max-width:83.3333333333%}.bootstrap-wrapper .col-sm-11{-webkit-box-flex:0;-webkit-flex:0 0 91.6666666667%;-ms-flex:0 0 91.6666666667%;flex:0 0 91.6666666667%;max-width:91.6666666667%}.bootstrap-wrapper .col-sm-12{-webkit-box-flex:0;-webkit-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-wrapper .order-sm-first{-webkit-box-ordinal-group:0;-webkit-order:-1;-ms-flex-order:-1;order:-1}.bootstrap-wrapper .order-sm-last{-webkit-box-ordinal-group:14;-webkit-order:13;-ms-flex-order:13;order:13}.bootstrap-wrapper .order-sm-0{-webkit-box-ordinal-group:1;-webkit-order:0;-ms-flex-order:0;order:0}.bootstrap-wrapper .order-sm-1{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}.bootstrap-wrapper .order-sm-2{-webkit-box-ordinal-group:3;-webkit-order:2;-ms-flex-order:2;order:2}.bootstrap-wrapper .order-sm-3{-webkit-box-ordinal-group:4;-webkit-order:3;-ms-flex-order:3;order:3}.bootstrap-wrapper .order-sm-4{-webkit-box-ordinal-group:5;-webkit-order:4;-ms-flex-order:4;order:4}.bootstrap-wrapper .order-sm-5{-webkit-box-ordinal-group:6;-webkit-order:5;-ms-flex-order:5;order:5}.bootstrap-wrapper .order-sm-6{-webkit-box-ordinal-group:7;-webkit-order:6;-ms-flex-order:6;order:6}.bootstrap-wrapper .order-sm-7{-webkit-box-ordinal-group:8;-webkit-order:7;-ms-flex-order:7;order:7}.bootstrap-wrapper .order-sm-8{-webkit-box-ordinal-group:9;-webkit-order:8;-ms-flex-order:8;order:8}.bootstrap-wrapper .order-sm-9{-webkit-box-ordinal-group:10;-webkit-order:9;-ms-flex-order:9;order:9}.bootstrap-wrapper .order-sm-10{-webkit-box-ordinal-group:11;-webkit-order:10;-ms-flex-order:10;order:10}.bootstrap-wrapper .order-sm-11{-webkit-box-ordinal-group:12;-webkit-order:11;-ms-flex-order:11;order:11}.bootstrap-wrapper .order-sm-12{-webkit-box-ordinal-group:13;-webkit-order:12;-ms-flex-order:12;order:12}.bootstrap-wrapper .offset-sm-0{margin-left:0}.bootstrap-wrapper .offset-sm-1{margin-left:8.3333333333%}.bootstrap-wrapper .offset-sm-2{margin-left:16.6666666667%}.bootstrap-wrapper .offset-sm-3{margin-left:25%}.bootstrap-wrapper .offset-sm-4{margin-left:33.3333333333%}.bootstrap-wrapper .offset-sm-5{margin-left:41.6666666667%}.bootstrap-wrapper .offset-sm-6{margin-left:50%}.bootstrap-wrapper .offset-sm-7{margin-left:58.3333333333%}.bootstrap-wrapper .offset-sm-8{margin-left:66.6666666667%}.bootstrap-wrapper .offset-sm-9{margin-left:75%}.bootstrap-wrapper .offset-sm-10{margin-left:83.3333333333%}.bootstrap-wrapper .offset-sm-11{margin-left:91.6666666667%}}@media (min-width: 768px){.bootstrap-wrapper .col-md{-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-wrapper .col-md-auto{-webkit-box-flex:0;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-wrapper .col-md-1{-webkit-box-flex:0;-webkit-flex:0 0 8.3333333333%;-ms-flex:0 0 8.3333333333%;flex:0 0 8.3333333333%;max-width:8.3333333333%}.bootstrap-wrapper .col-md-2{-webkit-box-flex:0;-webkit-flex:0 0 16.6666666667%;-ms-flex:0 0 16.6666666667%;flex:0 0 16.6666666667%;max-width:16.6666666667%}.bootstrap-wrapper .col-md-3{-webkit-box-flex:0;-webkit-flex:0 0 25%;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-wrapper .col-md-4{-webkit-box-flex:0;-webkit-flex:0 0 33.3333333333%;-ms-flex:0 0 33.3333333333%;flex:0 0 33.3333333333%;max-width:33.3333333333%}.bootstrap-wrapper .col-md-5{-webkit-box-flex:0;-webkit-flex:0 0 41.6666666667%;-ms-flex:0 0 41.6666666667%;flex:0 0 41.6666666667%;max-width:41.6666666667%}.bootstrap-wrapper .col-md-6{-webkit-box-flex:0;-webkit-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-wrapper .col-md-7{-webkit-box-flex:0;-webkit-flex:0 0 58.3333333333%;-ms-flex:0 0 58.3333333333%;flex:0 0 58.3333333333%;max-width:58.3333333333%}.bootstrap-wrapper .col-md-8{-webkit-box-flex:0;-webkit-flex:0 0 66.6666666667%;-ms-flex:0 0 66.6666666667%;flex:0 0 66.6666666667%;max-width:66.6666666667%}.bootstrap-wrapper .col-md-9{-webkit-box-flex:0;-webkit-flex:0 0 75%;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-wrapper .col-md-10{-webkit-box-flex:0;-webkit-flex:0 0 83.3333333333%;-ms-flex:0 0 83.3333333333%;flex:0 0 83.3333333333%;max-width:83.3333333333%}.bootstrap-wrapper .col-md-11{-webkit-box-flex:0;-webkit-flex:0 0 91.6666666667%;-ms-flex:0 0 91.6666666667%;flex:0 0 91.6666666667%;max-width:91.6666666667%}.bootstrap-wrapper .col-md-12{-webkit-box-flex:0;-webkit-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-wrapper .order-md-first{-webkit-box-ordinal-group:0;-webkit-order:-1;-ms-flex-order:-1;order:-1}.bootstrap-wrapper .order-md-last{-webkit-box-ordinal-group:14;-webkit-order:13;-ms-flex-order:13;order:13}.bootstrap-wrapper .order-md-0{-webkit-box-ordinal-group:1;-webkit-order:0;-ms-flex-order:0;order:0}.bootstrap-wrapper .order-md-1{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}.bootstrap-wrapper .order-md-2{-webkit-box-ordinal-group:3;-webkit-order:2;-ms-flex-order:2;order:2}.bootstrap-wrapper .order-md-3{-webkit-box-ordinal-group:4;-webkit-order:3;-ms-flex-order:3;order:3}.bootstrap-wrapper .order-md-4{-webkit-box-ordinal-group:5;-webkit-order:4;-ms-flex-order:4;order:4}.bootstrap-wrapper .order-md-5{-webkit-box-ordinal-group:6;-webkit-order:5;-ms-flex-order:5;order:5}.bootstrap-wrapper .order-md-6{-webkit-box-ordinal-group:7;-webkit-order:6;-ms-flex-order:6;order:6}.bootstrap-wrapper .order-md-7{-webkit-box-ordinal-group:8;-webkit-order:7;-ms-flex-order:7;order:7}.bootstrap-wrapper .order-md-8{-webkit-box-ordinal-group:9;-webkit-order:8;-ms-flex-order:8;order:8}.bootstrap-wrapper .order-md-9{-webkit-box-ordinal-group:10;-webkit-order:9;-ms-flex-order:9;order:9}.bootstrap-wrapper .order-md-10{-webkit-box-ordinal-group:11;-webkit-order:10;-ms-flex-order:10;order:10}.bootstrap-wrapper .order-md-11{-webkit-box-ordinal-group:12;-webkit-order:11;-ms-flex-order:11;order:11}.bootstrap-wrapper .order-md-12{-webkit-box-ordinal-group:13;-webkit-order:12;-ms-flex-order:12;order:12}.bootstrap-wrapper .offset-md-0{margin-left:0}.bootstrap-wrapper .offset-md-1{margin-left:8.3333333333%}.bootstrap-wrapper .offset-md-2{margin-left:16.6666666667%}.bootstrap-wrapper .offset-md-3{margin-left:25%}.bootstrap-wrapper .offset-md-4{margin-left:33.3333333333%}.bootstrap-wrapper .offset-md-5{margin-left:41.6666666667%}.bootstrap-wrapper .offset-md-6{margin-left:50%}.bootstrap-wrapper .offset-md-7{margin-left:58.3333333333%}.bootstrap-wrapper .offset-md-8{margin-left:66.6666666667%}.bootstrap-wrapper .offset-md-9{margin-left:75%}.bootstrap-wrapper .offset-md-10{margin-left:83.3333333333%}.bootstrap-wrapper .offset-md-11{margin-left:91.6666666667%}}@media (min-width: 992px){.bootstrap-wrapper .col-lg{-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-wrapper .col-lg-auto{-webkit-box-flex:0;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-wrapper .col-lg-1{-webkit-box-flex:0;-webkit-flex:0 0 8.3333333333%;-ms-flex:0 0 8.3333333333%;flex:0 0 8.3333333333%;max-width:8.3333333333%}.bootstrap-wrapper .col-lg-2{-webkit-box-flex:0;-webkit-flex:0 0 16.6666666667%;-ms-flex:0 0 16.6666666667%;flex:0 0 16.6666666667%;max-width:16.6666666667%}.bootstrap-wrapper .col-lg-3{-webkit-box-flex:0;-webkit-flex:0 0 25%;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-wrapper .col-lg-4{-webkit-box-flex:0;-webkit-flex:0 0 33.3333333333%;-ms-flex:0 0 33.3333333333%;flex:0 0 33.3333333333%;max-width:33.3333333333%}.bootstrap-wrapper .col-lg-5{-webkit-box-flex:0;-webkit-flex:0 0 41.6666666667%;-ms-flex:0 0 41.6666666667%;flex:0 0 41.6666666667%;max-width:41.6666666667%}.bootstrap-wrapper .col-lg-6{-webkit-box-flex:0;-webkit-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-wrapper .col-lg-7{-webkit-box-flex:0;-webkit-flex:0 0 58.3333333333%;-ms-flex:0 0 58.3333333333%;flex:0 0 58.3333333333%;max-width:58.3333333333%}.bootstrap-wrapper .col-lg-8{-webkit-box-flex:0;-webkit-flex:0 0 66.6666666667%;-ms-flex:0 0 66.6666666667%;flex:0 0 66.6666666667%;max-width:66.6666666667%}.bootstrap-wrapper .col-lg-9{-webkit-box-flex:0;-webkit-flex:0 0 75%;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-wrapper .col-lg-10{-webkit-box-flex:0;-webkit-flex:0 0 83.3333333333%;-ms-flex:0 0 83.3333333333%;flex:0 0 83.3333333333%;max-width:83.3333333333%}.bootstrap-wrapper .col-lg-11{-webkit-box-flex:0;-webkit-flex:0 0 91.6666666667%;-ms-flex:0 0 91.6666666667%;flex:0 0 91.6666666667%;max-width:91.6666666667%}.bootstrap-wrapper .col-lg-12{-webkit-box-flex:0;-webkit-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-wrapper .order-lg-first{-webkit-box-ordinal-group:0;-webkit-order:-1;-ms-flex-order:-1;order:-1}.bootstrap-wrapper .order-lg-last{-webkit-box-ordinal-group:14;-webkit-order:13;-ms-flex-order:13;order:13}.bootstrap-wrapper .order-lg-0{-webkit-box-ordinal-group:1;-webkit-order:0;-ms-flex-order:0;order:0}.bootstrap-wrapper .order-lg-1{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}.bootstrap-wrapper .order-lg-2{-webkit-box-ordinal-group:3;-webkit-order:2;-ms-flex-order:2;order:2}.bootstrap-wrapper .order-lg-3{-webkit-box-ordinal-group:4;-webkit-order:3;-ms-flex-order:3;order:3}.bootstrap-wrapper .order-lg-4{-webkit-box-ordinal-group:5;-webkit-order:4;-ms-flex-order:4;order:4}.bootstrap-wrapper .order-lg-5{-webkit-box-ordinal-group:6;-webkit-order:5;-ms-flex-order:5;order:5}.bootstrap-wrapper .order-lg-6{-webkit-box-ordinal-group:7;-webkit-order:6;-ms-flex-order:6;order:6}.bootstrap-wrapper .order-lg-7{-webkit-box-ordinal-group:8;-webkit-order:7;-ms-flex-order:7;order:7}.bootstrap-wrapper .order-lg-8{-webkit-box-ordinal-group:9;-webkit-order:8;-ms-flex-order:8;order:8}.bootstrap-wrapper .order-lg-9{-webkit-box-ordinal-group:10;-webkit-order:9;-ms-flex-order:9;order:9}.bootstrap-wrapper .order-lg-10{-webkit-box-ordinal-group:11;-webkit-order:10;-ms-flex-order:10;order:10}.bootstrap-wrapper .order-lg-11{-webkit-box-ordinal-group:12;-webkit-order:11;-ms-flex-order:11;order:11}.bootstrap-wrapper .order-lg-12{-webkit-box-ordinal-group:13;-webkit-order:12;-ms-flex-order:12;order:12}.bootstrap-wrapper .offset-lg-0{margin-left:0}.bootstrap-wrapper .offset-lg-1{margin-left:8.3333333333%}.bootstrap-wrapper .offset-lg-2{margin-left:16.6666666667%}.bootstrap-wrapper .offset-lg-3{margin-left:25%}.bootstrap-wrapper .offset-lg-4{margin-left:33.3333333333%}.bootstrap-wrapper .offset-lg-5{margin-left:41.6666666667%}.bootstrap-wrapper .offset-lg-6{margin-left:50%}.bootstrap-wrapper .offset-lg-7{margin-left:58.3333333333%}.bootstrap-wrapper .offset-lg-8{margin-left:66.6666666667%}.bootstrap-wrapper .offset-lg-9{margin-left:75%}.bootstrap-wrapper .offset-lg-10{margin-left:83.3333333333%}.bootstrap-wrapper .offset-lg-11{margin-left:91.6666666667%}}@media (min-width: 1200px){.bootstrap-wrapper .col-xl{-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-wrapper .col-xl-auto{-webkit-box-flex:0;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-wrapper .col-xl-1{-webkit-box-flex:0;-webkit-flex:0 0 8.3333333333%;-ms-flex:0 0 8.3333333333%;flex:0 0 8.3333333333%;max-width:8.3333333333%}.bootstrap-wrapper .col-xl-2{-webkit-box-flex:0;-webkit-flex:0 0 16.6666666667%;-ms-flex:0 0 16.6666666667%;flex:0 0 16.6666666667%;max-width:16.6666666667%}.bootstrap-wrapper .col-xl-3{-webkit-box-flex:0;-webkit-flex:0 0 25%;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-wrapper .col-xl-4{-webkit-box-flex:0;-webkit-flex:0 0 33.3333333333%;-ms-flex:0 0 33.3333333333%;flex:0 0 33.3333333333%;max-width:33.3333333333%}.bootstrap-wrapper .col-xl-5{-webkit-box-flex:0;-webkit-flex:0 0 41.6666666667%;-ms-flex:0 0 41.6666666667%;flex:0 0 41.6666666667%;max-width:41.6666666667%}.bootstrap-wrapper .col-xl-6{-webkit-box-flex:0;-webkit-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-wrapper .col-xl-7{-webkit-box-flex:0;-webkit-flex:0 0 58.3333333333%;-ms-flex:0 0 58.3333333333%;flex:0 0 58.3333333333%;max-width:58.3333333333%}.bootstrap-wrapper .col-xl-8{-webkit-box-flex:0;-webkit-flex:0 0 66.6666666667%;-ms-flex:0 0 66.6666666667%;flex:0 0 66.6666666667%;max-width:66.6666666667%}.bootstrap-wrapper .col-xl-9{-webkit-box-flex:0;-webkit-flex:0 0 75%;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-wrapper .col-xl-10{-webkit-box-flex:0;-webkit-flex:0 0 83.3333333333%;-ms-flex:0 0 83.3333333333%;flex:0 0 83.3333333333%;max-width:83.3333333333%}.bootstrap-wrapper .col-xl-11{-webkit-box-flex:0;-webkit-flex:0 0 91.6666666667%;-ms-flex:0 0 91.6666666667%;flex:0 0 91.6666666667%;max-width:91.6666666667%}.bootstrap-wrapper .col-xl-12{-webkit-box-flex:0;-webkit-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-wrapper .order-xl-first{-webkit-box-ordinal-group:0;-webkit-order:-1;-ms-flex-order:-1;order:-1}.bootstrap-wrapper .order-xl-last{-webkit-box-ordinal-group:14;-webkit-order:13;-ms-flex-order:13;order:13}.bootstrap-wrapper .order-xl-0{-webkit-box-ordinal-group:1;-webkit-order:0;-ms-flex-order:0;order:0}.bootstrap-wrapper .order-xl-1{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}.bootstrap-wrapper .order-xl-2{-webkit-box-ordinal-group:3;-webkit-order:2;-ms-flex-order:2;order:2}.bootstrap-wrapper .order-xl-3{-webkit-box-ordinal-group:4;-webkit-order:3;-ms-flex-order:3;order:3}.bootstrap-wrapper .order-xl-4{-webkit-box-ordinal-group:5;-webkit-order:4;-ms-flex-order:4;order:4}.bootstrap-wrapper .order-xl-5{-webkit-box-ordinal-group:6;-webkit-order:5;-ms-flex-order:5;order:5}.bootstrap-wrapper .order-xl-6{-webkit-box-ordinal-group:7;-webkit-order:6;-ms-flex-order:6;order:6}.bootstrap-wrapper .order-xl-7{-webkit-box-ordinal-group:8;-webkit-order:7;-ms-flex-order:7;order:7}.bootstrap-wrapper .order-xl-8{-webkit-box-ordinal-group:9;-webkit-order:8;-ms-flex-order:8;order:8}.bootstrap-wrapper .order-xl-9{-webkit-box-ordinal-group:10;-webkit-order:9;-ms-flex-order:9;order:9}.bootstrap-wrapper .order-xl-10{-webkit-box-ordinal-group:11;-webkit-order:10;-ms-flex-order:10;order:10}.bootstrap-wrapper .order-xl-11{-webkit-box-ordinal-group:12;-webkit-order:11;-ms-flex-order:11;order:11}.bootstrap-wrapper .order-xl-12{-webkit-box-ordinal-group:13;-webkit-order:12;-ms-flex-order:12;order:12}.bootstrap-wrapper .offset-xl-0{margin-left:0}.bootstrap-wrapper .offset-xl-1{margin-left:8.3333333333%}.bootstrap-wrapper .offset-xl-2{margin-left:16.6666666667%}.bootstrap-wrapper .offset-xl-3{margin-left:25%}.bootstrap-wrapper .offset-xl-4{margin-left:33.3333333333%}.bootstrap-wrapper .offset-xl-5{margin-left:41.6666666667%}.bootstrap-wrapper .offset-xl-6{margin-left:50%}.bootstrap-wrapper .offset-xl-7{margin-left:58.3333333333%}.bootstrap-wrapper .offset-xl-8{margin-left:66.6666666667%}.bootstrap-wrapper .offset-xl-9{margin-left:75%}.bootstrap-wrapper .offset-xl-10{margin-left:83.3333333333%}.bootstrap-wrapper .offset-xl-11{margin-left:91.6666666667%}}.bootstrap-wrapper .img-fluid{max-width:100%;height:auto}
`, lg = `:root{--bg-surface-base: #121316;--bg-surface-light2: #272729}.bootstrap-wrapper{font-family:Russo One,sans-serif}.modal-container{position:absolute;top:0;left:0;right:0;bottom:0;z-index:100}.modal-container.fullscreen #popup{background-image:linear-gradient(to bottom,var(--bg-surface-light2) 25%,var(--bg-surface-base) 75%)!important;border-radius:0;height:100vh;width:100vw;padding-top:1rem}.modal-container .popupcontent>span{font-size:1.3rem;margin-bottom:40px;display:block;text-align:center;padding:0px 6rem;max-width:50rem}.modal-container .popupcontent>span.error{color:#bf0000}.modal-container.fullscreen #overlay.show{opacity:1!important;border-radius:0}.modal-container .react-code-input input:first-child{border-color:#ffb0cc;color:#ffb0cc}.modal-container .react-code-input input:nth-child(2){border-color:#fff27a;color:#fff27a}.modal-container .react-code-input input:nth-child(3){border-color:#6bdcff;color:#6bdcff}.modal-container .react-code-input input:nth-child(4){border-color:#ff7f56;color:#ff7f56}.modal-container.fullscreen .popupcontent{width:100%;height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;row-gap:1rem}.full-room-container{background-image:linear-gradient(to bottom,var(--bg-surface-light2) 25%,var(--bg-surface-base) 75%);position:absolute;top:0;left:0;right:0;bottom:0;z-index:101}.button-bot{position:relative;top:60px;width:70px;min-width:70px;height:50px;border:none;border-radius:14px;border:2px solid #000;padding:0rem;font-size:1.5rem;font-weight:400;font-family:Russo One,sans-serif;background:#fff;background-color:#fff;cursor:pointer;color:#000;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);box-shadow:0 7px #00000040}.button-black{cursor:pointer;font-weight:bolder;border:none;color:#000;min-width:80px;height:65px;font-size:1.2rem;background:#fff;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border:2px solid #000;box-shadow:0 7px #00000040;border-radius:20px}.button-black.disabled{color:#fff;background:transparent;border:1px solid #fff;cursor:not-allowed;width:100%}.button-black.btn-icon{background-repeat:no-repeat;background-position-y:center;background-position-x:1rem;background-size:1.75rem}.btn-invite{min-width:200px}.airplay-btn{margin-right:.5rem}.launch-btn{width:100%}.close-btn{width:100%;background:#000;cursor:pointer;font-weight:bolder;border:none;color:#fff;min-width:80px;height:60px;font-size:1rem;border-radius:14px}.close-btn.white{background:#fff;color:#000}.airplay-icon{width:30px;height:30px;object-fit:contain;margin-top:8px}.player-avatar-strip{display:flex}.player-avatar-strip:not(.mobile){margin-bottom:2.2rem;flex-wrap:wrap;row-gap:.5rem}.player-avatar-strip.mobile{overflow-x:auto;max-width:100%;padding-bottom:.4rem}.player-avatar-strip.mobile>div:first-child{margin-left:auto}.player-avatar-strip.mobile>div:last-child{margin-right:auto}.player-avatar-strip .player-score-container{display:flex;flex-direction:row;align-items:center;margin:0rem .3rem;border-radius:2rem;padding:.2rem;position:relative}.player-avatar-strip .player-score-container .player-remove{position:absolute;top:-.1rem;right:-1rem;width:1.5rem;height:1.5rem;border-radius:50%;color:#fff;display:flex;align-items:center;justify-content:center;font-size:1.2rem;cursor:pointer}.player-avatar-strip .player-score-container>span{color:#fff;font-family:Lilita One;font-style:normal;font-weight:400;font-size:2rem;margin:0rem 1rem}.player-avatar-strip .avatar-holder{background-color:#fffc;background-size:23px;background-position:center;background-repeat:no-repeat;width:3.5rem;height:3.5rem;border-radius:50%;margin:.1rem;border:.15rem solid transparent}.player-avatar-strip .avatar-holder.empty{background-color:#0003!important}.player-avatar-strip.mobile .avatar-holder{width:2.5rem;height:2.5rem}.player-avatar-strip.mobile .player-score-container>span{font-size:1.5rem;margin:0rem .7rem}.room-code-sticker{font-family:Russo One,sans-serif;position:absolute;top:calc(20px + env(safe-area-inset-top));right:0;background-color:#fff;color:#000;padding:1.45rem 1.513rem;border-radius:1.1rem;z-index:4;display:flex;flex-direction:column;align-items:center;margin:0rem 3rem;width:11.1rem;text-align:center}.room-code-sticker .qr-code{height:auto;margin:0 auto;width:100%}.room-code-sticker .room-code{margin-top:.62rem;font-size:.89rem;display:flex;flex-direction:column;align-items:center}.room-code-sticker .room-code b{font-size:1.5rem;margin:0;font-weight:400;display:block;white-space:nowrap}.room-code-sticker{width:15.8rem!important;border-radius:2.2rem!important}.room-code-sticker .room-code b{font-size:2.8rem!important;line-height:normal;font-weight:700}.room-code-sticker .room-code span{font-size:1.6rem!important;line-height:normal;display:none}.player-avatar-strip .player-score-container{padding:.1rem!important}.player-avatar-strip .avatar-holder{border-width:0px;width:3rem!important;height:3rem!important;position:relative}.player-avatar-strip .avatar-holder .badge-gamepad{display:block;background-color:#703eff;width:2rem;background-repeat:no-repeat;background-position:center;background-size:70%;border-radius:100%;position:absolute;height:1.7rem;top:1.7rem;right:-.7rem}@-webkit-keyframes playroom-anim-dash{0%{transform:translate(-100%)}to{transform:translate(100%)}}@keyframes playroom-anim-dash{0%{transform:translate(-100%)}to{transform:translate(100%)}}.bootstrap-wrapper .playroom .steps-container{display:flex;height:10px;width:100%;gap:14px}.bootstrap-wrapper .playroom .step-item{flex:1 1 0;width:0;background:#dfdfdf;border-radius:15px}.bootstrap-wrapper .playroom .step-item.active{background:#00bc8b}.bootstrap-wrapper .playroom .step-item.loading{position:relative;overflow:hidden;z-index:0}.bootstrap-wrapper .playroom .step-item.loading:before,.bootstrap-wrapper .playroom .step-item.loading:after,.bootstrap-wrapper .playroom .step-item.loading span{display:flex;position:absolute;transform:translate(-100%);height:100%;width:100%;border-radius:15px}.bootstrap-wrapper .playroom .step-item.loading span{-webkit-animation:playroom-anim-dash 1.618s infinite cubic-bezier(.4,0,1,1);animation:playroom-anim-dash 1.618s infinite cubic-bezier(.4,0,1,1);background-color:#00bc8b;z-index:2}.bootstrap-wrapper .playroom .step-item.loading span:before{content:"";display:inline-block;position:absolute;left:0;width:10px;height:10px;border-radius:50%;background-color:#dfdfdf}.bootstrap-wrapper .playroom .step-item.loading:before{content:"";-webkit-animation:playroom-anim-dash 1.618s infinite cubic-bezier(.2,0,1,1);animation:playroom-anim-dash 1.618s infinite cubic-bezier(.2,0,1,1);background-color:#9eddcc;z-index:1}.bootstrap-wrapper .playroom .step-item.loading:after{content:"";-webkit-animation:playroom-anim-dash 1.618s infinite linear;animation:playroom-anim-dash 1.618s infinite linear;background-color:#cbf4e9;z-index:0}
`, cg = `@import"https://fonts.googleapis.com/css2?family=Russo+One&display=swap";.platform{position:fixed;top:50%;max-width:500px;right:0;z-index:3;transform:translate(-50%,-50%);background-size:contain;width:90vw;left:50%;background-position:50% 55%;display:flex;flex-direction:column;align-items:center;justify-content:center}.back-dark-gradient{background:#5f33ff;background-repeat:no-repeat;background-attachment:fixed}.platform .avatar-container{width:100%;height:100%;display:block;background-size:contain;background-repeat:no-repeat;position:absolute;top:0}.full-avatar-container{width:80px;height:100px;display:block;background-size:contain;background-repeat:no-repeat;position:relative;z-index:2}.player-shadow{display:block;position:absolute;bottom:-45%;left:0;width:100%;height:100%;background-size:100%;background-repeat:no-repeat;background-position:center}.platform .avatar-photo{width:14rem;height:14rem;display:block;background-size:contain;background-repeat:no-repeat;position:relative;border-radius:50%;border:4px solid red;background-color:#0006;backdrop-filter:blur(20px)}.platform .avatar-photo.no-photo{background-size:25%;background-position:center}.platform .color-tray{z-index:3;display:block}.platform .color-tray .color{width:1.8rem;height:1.8rem;display:inline-block;border-radius:50%;margin:3.5px;vertical-align:middle}.platform .input-name{background:#fff;border:4px solid #fff;border-radius:1.8rem;padding:14px 0;font-size:1.2rem;margin:-30px 20px 20px;text-align:center;color:#000;font-weight:700;z-index:1;position:relative;width:14rem}.platform .profilecontainer{text-align:center;padding:40px 20px;background:linear-gradient(0deg,#18191b,#18191b),linear-gradient(0deg,#38393c,#38393c);border:1px solid #38393c;box-shadow:0 2px #ffffff40 inset;border-radius:20.75px;width:100%}.platform .party-hr{font-family:Russo One,sans-serif;font-weight:700;font-size:.85rem;display:flex;align-items:center;text-align:center;color:#fff;margin:2rem 0}.platform .party-hr:before,.platform .party-hr:after{content:"";flex:1;border-bottom:1px solid #38393c}.platform .party-hr:not(:empty):before{margin-right:1.25em}.platform .party-hr:not(:empty):after{margin-left:1.25em}.platform .input-name:focus{outline:none}.platform .color-tray .color.active{width:2.6rem;height:2.6rem}.platform #btn-launchjoin{margin-top:2rem}.button-crop{background-color:#fff;color:#000;width:auto;margin-top:20px}.platform .refresh-button{position:absolute;top:10px;right:10px;color:#000;cursor:pointer;background:#18191b;padding:10px;z-index:1;border-radius:50%;line-height:0;border:1px solid rgba(255,255,255,.3)}.room-code-sticker{width:16.8rem!important;margin:1.1rem 0px}.toast-container{animation:fadeIn .2s,slideIn .2s cubic-bezier(.4,-.05,0,1);transform:translate(-50%) scale(.9)}.sdk-version{margin-top:2rem;color:#fff;font-size:1rem}@keyframes slideIn{0%{transform:translate(-50%) translateY(400px) scale(.9);animation-timing-function:ease-out}to{transform:translate(-50%) translateY(0) scale(.9);animation-timing-function:ease-in}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.airplay-instruction-modal{position:absolute;top:0;left:0;bottom:0;right:0;z-index:101}.airplay-instruction-toast{max-width:500px;width:100%;position:absolute;bottom:.7rem;left:50%;transform:translate(-50%) scale(.9);display:flex;flex-direction:column;align-items:center;justify-content:center;border-radius:4.5rem}.airplay-instruction-container{font-family:Russo One,sans-serif;display:flex;flex-direction:column;align-items:center;margin:1rem 0rem;background:#fff;border:2px solid #000000;box-shadow:0 12px #00000040;border-radius:20px;width:95%;padding:1rem}.airplay-instruction-container .close-icon{background-color:#ff3666;height:4rem;width:4rem;transform:scale(.7);border-radius:50%;position:absolute;top:1.5rem;right:1rem;padding:1rem;cursor:pointer;text-align:center;flex-direction:column;align-items:center;justify-content:center}.airplay-instruction-container .airplay-icon{width:4rem;height:4rem;object-fit:contain}.airplay-instruction-container .airplay-instruction-title{font-weight:bolder;font-size:1.6rem;line-height:normal;margin:0rem;font-family:Open Sans,sans-serif}
`;
function Rn(t) {
  var e = Zu();
  return e[t];
}
function Zu() {
  var t = window.location.hash;
  t && (t = t.split("#")[1]);
  var e = t.split("&"), r = {};
  return e.forEach(function(n, i) {
    n = n.split("="), n[0] !== "" && (r[n[0]] = n[1]);
  }), r;
}
function ug(t) {
  var e = Object.keys(t), r = Object.values(t), n = [];
  e.forEach(function(o, s) {
    o !== "" && n.push(e[s] + "=" + r[s]);
  });
  var i = n.join("&");
  window.location.hash = i;
}
function Kc(t, e) {
  var r = Zu();
  r[t] = e, e === void 0 && delete r[t], ug(r);
}
const Xc = {
  getUrlHashParameter: Rn,
  getUrlHashParameters: Zu,
  setUrlHashParameter: Kc,
  setUrlHashParameters: ug
};
function F5() {
  return Xc.getUrlHashParameter("preview") === "phone";
}
function j5() {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.NativeMethods)
    return !0;
}
function W5() {
  return !!(j5() || F5() || localStorage && xt.get("DEV"));
}
function U5() {
  return !!(W5() || z5 || V5);
}
var z5 = typeof window < "u" && /(android)/i.test(navigator.userAgent), V5 = function() {
  if (typeof window > "u")
    return !1;
  var t = function() {
    var i = new Audio();
    return i.volume = 0.5, i.volume === 1;
  }, e = /iPhone|iPod/.test(navigator.userAgent), r = navigator.userAgent.includes("Macintosh"), n = navigator.maxTouchPoints >= 1;
  return e || r && (n || t());
}(), Jc = {}, q5 = {
  get exports() {
    return Jc;
  },
  set exports(t) {
    Jc = t;
  }
}, rc = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hh;
function H5() {
  if (Hh)
    return rc;
  Hh = 1;
  var t = K;
  function e(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, i = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
  function a(f, d) {
    var h = d(), g = n({ inst: { value: h, getSnapshot: d } }), p = g[0].inst, y = g[1];
    return o(function() {
      p.value = h, p.getSnapshot = d, l(p) && y({ inst: p });
    }, [f, h, d]), i(function() {
      return l(p) && y({ inst: p }), f(function() {
        l(p) && y({ inst: p });
      });
    }, [f]), s(h), h;
  }
  function l(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var h = d();
      return !r(f, h);
    } catch {
      return !0;
    }
  }
  function c(f, d) {
    return d();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return rc.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, rc;
}
var nc = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yh;
function Y5() {
  return Yh || (Yh = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = K, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(S) {
      {
        for (var O = arguments.length, _ = new Array(O > 1 ? O - 1 : 0), B = 1; B < O; B++)
          _[B - 1] = arguments[B];
        n("error", S, _);
      }
    }
    function n(S, O, _) {
      {
        var B = e.ReactDebugCurrentFrame, N = B.getStackAddendum();
        N !== "" && (O += "%s", _ = _.concat([N]));
        var j = _.map(function(W) {
          return String(W);
        });
        j.unshift("Warning: " + O), Function.prototype.apply.call(console[S], console, j);
      }
    }
    function i(S, O) {
      return S === O && (S !== 0 || 1 / S === 1 / O) || S !== S && O !== O;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = t.useState, a = t.useEffect, l = t.useLayoutEffect, c = t.useDebugValue, u = !1, f = !1;
    function d(S, O, _) {
      u || t.startTransition !== void 0 && (u = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var B = O();
      if (!f) {
        var N = O();
        o(B, N) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var j = s({
        inst: {
          value: B,
          getSnapshot: O
        }
      }), W = j[0].inst, G = j[1];
      return l(function() {
        W.value = B, W.getSnapshot = O, h(W) && G({
          inst: W
        });
      }, [S, B, O]), a(function() {
        h(W) && G({
          inst: W
        });
        var ee = function() {
          h(W) && G({
            inst: W
          });
        };
        return S(ee);
      }, [S]), c(B), B;
    }
    function h(S) {
      var O = S.getSnapshot, _ = S.value;
      try {
        var B = O();
        return !o(_, B);
      } catch {
        return !0;
      }
    }
    function g(S, O, _) {
      return O();
    }
    var p = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", y = !p, b = y ? g : d, x = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : b;
    nc.useSyncExternalStore = x, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), nc;
}
(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = H5() : t.exports = Y5();
})(q5);
const on = () => {
}, Ft = (
  /*#__NOINLINE__*/
  on()
), ic = Object, ze = (t) => t === Ft, Ur = (t) => typeof t == "function", gn = (t, e) => ({
  ...t,
  ...e
}), K5 = (t) => Ur(t.then), Ps = /* @__PURE__ */ new WeakMap();
let X5 = 0;
const Lo = (t) => {
  const e = typeof t, r = t && t.constructor, n = r == Date;
  let i, o;
  if (ic(t) === t && !n && r != RegExp) {
    if (i = Ps.get(t), i)
      return i;
    if (i = ++X5 + "~", Ps.set(t, i), r == Array) {
      for (i = "@", o = 0; o < t.length; o++)
        i += Lo(t[o]) + ",";
      Ps.set(t, i);
    }
    if (r == ic) {
      i = "#";
      const s = ic.keys(t).sort();
      for (; !ze(o = s.pop()); )
        ze(t[o]) || (i += o + ":" + Lo(t[o]) + ",");
      Ps.set(t, i);
    }
  } else
    i = n ? t.toJSON() : e == "symbol" ? t.toString() : e == "string" ? JSON.stringify(t) : "" + t;
  return i;
}, Lr = /* @__PURE__ */ new WeakMap(), oc = {}, Rs = {}, $u = "undefined", Ga = typeof window != $u, Qc = typeof document != $u, J5 = () => Ga && typeof window.requestAnimationFrame != $u, fg = (t, e) => {
  const r = Lr.get(t);
  return [
    // Getter
    () => !ze(e) && t.get(e) || oc,
    // Setter
    (n) => {
      if (!ze(e)) {
        const i = t.get(e);
        e in Rs || (Rs[e] = i), r[5](e, gn(i, n), i || oc);
      }
    },
    // Subscriber
    r[6],
    // Get server cache snapshot
    () => !ze(e) && e in Rs ? Rs[e] : !ze(e) && t.get(e) || oc
  ];
};
let Gc = !0;
const Q5 = () => Gc, [Zc, $c] = Ga && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  on,
  on
], G5 = () => {
  const t = Qc && document.visibilityState;
  return ze(t) || t !== "hidden";
}, Z5 = (t) => (Qc && document.addEventListener("visibilitychange", t), Zc("focus", t), () => {
  Qc && document.removeEventListener("visibilitychange", t), $c("focus", t);
}), $5 = (t) => {
  const e = () => {
    Gc = !0, t();
  }, r = () => {
    Gc = !1;
  };
  return Zc("online", e), Zc("offline", r), () => {
    $c("online", e), $c("offline", r);
  };
}, ew = {
  isOnline: Q5,
  isVisible: G5
}, tw = {
  initFocus: Z5,
  initReconnect: $5
}, Kh = !K.useId, Fo = !Ga || "Deno" in window, rw = (t) => J5() ? window.requestAnimationFrame(t) : setTimeout(t, 1), sc = Fo ? _t : qm, ac = typeof navigator < "u" && navigator.connection, Xh = !Fo && ac && ([
  "slow-2g",
  "2g"
].includes(ac.effectiveType) || ac.saveData), ef = (t) => {
  if (Ur(t))
    try {
      t = t();
    } catch {
      t = "";
    }
  const e = t;
  return t = typeof t == "string" ? t : (Array.isArray(t) ? t.length : t) ? Lo(t) : "", [
    t,
    e
  ];
};
let nw = 0;
const eu = () => ++nw, dg = 0, hg = 1, pg = 2, iw = 3;
var Ji = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: iw,
  FOCUS_EVENT: dg,
  MUTATE_EVENT: pg,
  RECONNECT_EVENT: hg
};
async function gg(...t) {
  const [e, r, n, i] = t, o = gn({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let s = o.populateCache;
  const a = o.rollbackOnError;
  let l = o.optimisticData;
  const c = o.revalidate !== !1, u = (h) => typeof a == "function" ? a(h) : a !== !1, f = o.throwOnError;
  if (Ur(r)) {
    const h = r, g = [], p = e.keys();
    for (const y of p)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(y) && h(e.get(y)._k) && g.push(y);
    return Promise.all(g.map(d));
  }
  return d(r);
  async function d(h) {
    const [g] = ef(h);
    if (!g)
      return;
    const [p, y] = fg(e, g), [b, x, S, O] = Lr.get(e), _ = () => {
      const z = b[g];
      return c && (delete S[g], delete O[g], z && z[0]) ? z[0](pg).then(() => p().data) : p().data;
    };
    if (t.length < 3)
      return _();
    let B = n, N;
    const j = eu();
    x[g] = [
      j,
      0
    ];
    const W = !ze(l), G = p(), ee = G.data, fe = G._c, P = ze(fe) ? ee : fe;
    if (W && (l = Ur(l) ? l(P, ee) : l, y({
      data: l,
      _c: P
    })), Ur(B))
      try {
        B = B(P);
      } catch (z) {
        N = z;
      }
    if (B && K5(B))
      if (B = await B.catch((z) => {
        N = z;
      }), j !== x[g][0]) {
        if (N)
          throw N;
        return B;
      } else
        N && W && u(N) && (s = !0, y({
          data: P,
          _c: Ft
        }));
    if (s && !N)
      if (Ur(s)) {
        const z = s(B, P);
        y({
          data: z,
          error: Ft,
          _c: Ft
        });
      } else
        y({
          data: B,
          error: Ft,
          _c: Ft
        });
    if (x[g][1] = eu(), Promise.resolve(_()).then(() => {
      y({
        _c: Ft
      });
    }), N) {
      if (f)
        throw N;
      return;
    }
    return B;
  }
}
const Jh = (t, e) => {
  for (const r in t)
    t[r][0] && t[r][0](e);
}, ow = (t, e) => {
  if (!Lr.has(t)) {
    const r = gn(tw, e), n = {}, i = gg.bind(Ft, t);
    let o = on;
    const s = {}, a = (u, f) => {
      const d = s[u] || [];
      return s[u] = d, d.push(f), () => d.splice(d.indexOf(f), 1);
    }, l = (u, f, d) => {
      t.set(u, f);
      const h = s[u];
      if (h)
        for (const g of h)
          g(f, d);
    }, c = () => {
      if (!Lr.has(t) && (Lr.set(t, [
        n,
        {},
        {},
        {},
        i,
        l,
        a
      ]), !Fo)) {
        const u = r.initFocus(setTimeout.bind(Ft, Jh.bind(Ft, n, dg))), f = r.initReconnect(setTimeout.bind(Ft, Jh.bind(Ft, n, hg)));
        o = () => {
          u && u(), f && f(), Lr.delete(t);
        };
      }
    };
    return c(), [
      t,
      i,
      c,
      o
    ];
  }
  return [
    t,
    Lr.get(t)[4]
  ];
}, sw = (t, e, r, n, i) => {
  const o = r.errorRetryCount, s = i.retryCount, a = ~~((Math.random() + 0.5) * (1 << (s < 8 ? s : 8))) * r.errorRetryInterval;
  !ze(o) && s > o || setTimeout(n, a, i);
}, aw = (t, e) => Lo(t) == Lo(e), [mg, lw] = ow(/* @__PURE__ */ new Map()), cw = gn(
  {
    // events
    onLoadingSlow: on,
    onSuccess: on,
    onError: on,
    onErrorRetry: sw,
    onDiscarded: on,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: Xh ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: Xh ? 5e3 : 3e3,
    // providers
    compare: aw,
    isPaused: () => !1,
    cache: mg,
    mutate: lw,
    fallback: {}
  },
  // use web preset by default
  ew
), uw = (t, e) => {
  const r = gn(t, e);
  if (e) {
    const { use: n, fallback: i } = t, { use: o, fallback: s } = e;
    n && o && (r.use = n.concat(o)), i && s && (r.fallback = gn(i, s));
  }
  return r;
}, fw = pu({}), dw = "$inf$", yg = Ga && window.__SWR_DEVTOOLS_USE__, hw = yg ? window.__SWR_DEVTOOLS_USE__ : [], pw = () => {
  yg && (window.__SWR_DEVTOOLS_REACT__ = K);
}, gw = (t) => Ur(t[1]) ? [
  t[0],
  t[1],
  t[2] || {}
] : [
  t[0],
  null,
  (t[1] === null ? t[2] : t[1]) || {}
], mw = () => gn(cw, Ma(fw)), yw = (t) => (e, r, n) => t(e, r && ((...o) => {
  const [s] = ef(e), [, , , a] = Lr.get(mg);
  if (s.startsWith(dw))
    return r(...o);
  const l = a[s];
  return ze(l) ? r(...o) : (delete a[s], l);
}), n), bw = hw.concat(yw), vw = (t) => function(...r) {
  const n = mw(), [i, o, s] = gw(r), a = uw(n, s);
  let l = t;
  const { use: c } = a, u = (c || []).concat(bw);
  for (let f = u.length; f--; )
    l = u[f](l);
  return l(i, o || a.fetcher || null, a);
}, Aw = (t, e, r) => {
  const n = e[t] || (e[t] = []);
  return n.push(r), () => {
    const i = n.indexOf(r);
    i >= 0 && (n[i] = n[n.length - 1], n.pop());
  };
};
pw();
const Qh = K.use || ((t) => {
  if (t.status === "pending")
    throw t;
  if (t.status === "fulfilled")
    return t.value;
  throw t.status === "rejected" ? t.reason : (t.status = "pending", t.then((e) => {
    t.status = "fulfilled", t.value = e;
  }, (e) => {
    t.status = "rejected", t.reason = e;
  }), t);
}), lc = {
  dedupe: !0
}, ww = (t, e, r) => {
  const { cache: n, compare: i, suspense: o, fallbackData: s, revalidateOnMount: a, revalidateIfStale: l, refreshInterval: c, refreshWhenHidden: u, refreshWhenOffline: f, keepPreviousData: d } = r, [h, g, p, y] = Lr.get(n), [b, x] = ef(t), S = _n(!1), O = _n(!1), _ = _n(b), B = _n(e), N = _n(r), j = () => N.current, W = () => j().isVisible() && j().isOnline(), [G, ee, fe, P] = fg(n, b), z = _n({}).current, U = ze(s) ? r.fallback[b] : s, I = (k, re) => {
    for (const ne in z) {
      const Ae = ne;
      if (Ae === "data") {
        if (!i(k[Ae], re[Ae]) && (!ze(k[Ae]) || !i(me, re[Ae])))
          return !1;
      } else if (re[Ae] !== k[Ae])
        return !1;
    }
    return !0;
  }, V = Hm(() => {
    const k = (() => !b || !e ? !1 : ze(a) ? j().isPaused() || o ? !1 : ze(l) ? !0 : l : a)(), re = (D) => {
      const J = gn(D);
      return delete J._k, k ? {
        isValidating: !0,
        isLoading: !0,
        ...J
      } : J;
    }, ne = G(), Ae = P(), C = re(ne), v = ne === Ae ? C : re(Ae);
    let w = C;
    return [
      () => {
        const D = re(G());
        return I(D, w) ? (w.data = D.data, w.isLoading = D.isLoading, w.isValidating = D.isValidating, w.error = D.error, w) : (w = D, D);
      },
      () => v
    ];
  }, [
    n,
    b
  ]), te = Jc.useSyncExternalStore(xl(
    (k) => fe(b, (re, ne) => {
      I(ne, re) || k();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      n,
      b
    ]
  ), V[0], V[1]), X = !S.current, H = h[b] && h[b].length > 0, $ = te.data, se = ze($) ? U : $, he = te.error, pe = _n(se), me = d ? ze($) ? pe.current : $ : se, L = (() => H && !ze(he) ? !1 : X && !ze(a) ? a : j().isPaused() ? !1 : o ? ze(se) ? !1 : l : ze(se) || l)(), q = !!(b && e && X && L), Z = ze(te.isValidating) ? q : te.isValidating, oe = ze(te.isLoading) ? q : te.isLoading, de = xl(
    async (k) => {
      const re = B.current;
      if (!b || !re || O.current || j().isPaused())
        return !1;
      let ne, Ae, C = !0;
      const v = k || {}, w = !p[b] || !v.dedupe, D = () => Kh ? !O.current && b === _.current && S.current : b === _.current, J = {
        isValidating: !1,
        isLoading: !1
      }, ae = () => {
        ee(J);
      }, ue = () => {
        const _e = p[b];
        _e && _e[1] === Ae && delete p[b];
      }, Se = {
        isValidating: !0
      };
      ze(G().data) && (Se.isLoading = !0);
      try {
        if (w && (ee(Se), r.loadingTimeout && ze(G().data) && setTimeout(() => {
          C && D() && j().onLoadingSlow(b, r);
        }, r.loadingTimeout), p[b] = [
          re(x),
          eu()
        ]), [ne, Ae] = p[b], ne = await ne, w && setTimeout(ue, r.dedupingInterval), !p[b] || p[b][1] !== Ae)
          return w && D() && j().onDiscarded(b), !1;
        J.error = Ft;
        const _e = g[b];
        if (!ze(_e) && // case 1
        (Ae <= _e[0] || // case 2
        Ae <= _e[1] || // case 3
        _e[1] === 0))
          return ae(), w && D() && j().onDiscarded(b), !1;
        const we = G().data;
        J.data = i(we, ne) ? we : ne, w && D() && j().onSuccess(ne, b, r);
      } catch (_e) {
        ue();
        const we = j(), { shouldRetryOnError: Ne } = we;
        we.isPaused() || (J.error = _e, w && D() && (we.onError(_e, b, we), (Ne === !0 || Ur(Ne) && Ne(_e)) && W() && we.onErrorRetry(_e, b, we, (E) => {
          const m = h[b];
          m && m[0] && m[0](Ji.ERROR_REVALIDATE_EVENT, E);
        }, {
          retryCount: (v.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return C = !1, ae(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      b,
      n
    ]
  ), R = xl(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...k) => gg(n, _.current, ...k),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (sc(() => {
    B.current = e, N.current = r, ze($) || (pe.current = $);
  }), sc(() => {
    if (!b)
      return;
    const k = de.bind(Ft, lc);
    let re = 0;
    const Ae = Aw(b, h, (C, v = {}) => {
      if (C == Ji.FOCUS_EVENT) {
        const w = Date.now();
        j().revalidateOnFocus && w > re && W() && (re = w + j().focusThrottleInterval, k());
      } else if (C == Ji.RECONNECT_EVENT)
        j().revalidateOnReconnect && W() && k();
      else {
        if (C == Ji.MUTATE_EVENT)
          return de();
        if (C == Ji.ERROR_REVALIDATE_EVENT)
          return de(v);
      }
    });
    return O.current = !1, _.current = b, S.current = !0, ee({
      _k: x
    }), L && (ze(se) || Fo ? k() : rw(k)), () => {
      O.current = !0, Ae();
    };
  }, [
    b
  ]), sc(() => {
    let k;
    function re() {
      const Ae = Ur(c) ? c(G().data) : c;
      Ae && k !== -1 && (k = setTimeout(ne, Ae));
    }
    function ne() {
      !G().error && (u || j().isVisible()) && (f || j().isOnline()) ? de(lc).then(re) : re();
    }
    return re(), () => {
      k && (clearTimeout(k), k = -1);
    };
  }, [
    c,
    u,
    f,
    b
  ]), Ym(me), o && ze(se) && b) {
    if (!Kh && Fo)
      throw new Error("Fallback data is required when using suspense in SSR.");
    B.current = e, N.current = r, O.current = !1;
    const k = y[b];
    if (!ze(k)) {
      const re = R(k);
      Qh(re);
    }
    if (ze(he)) {
      const re = de(lc);
      ze(me) || (re.status = "fulfilled", re.value = !0), Qh(re);
    } else
      throw he;
  }
  return {
    mutate: R,
    get data() {
      return z.data = !0, me;
    },
    get error() {
      return z.error = !0, he;
    },
    get isValidating() {
      return z.isValidating = !0, Z;
    },
    get isLoading() {
      return z.isLoading = !0, oe;
    }
  };
}, xw = vw(ww);
function Mi({
  middle: t,
  center: e,
  bottom: r,
  right: n,
  visible: i,
  children: o,
  flag: s,
  style: a,
  containerClassName: l
}) {
  return i ? /* @__PURE__ */ K.createElement(
    "div",
    {
      style: a,
      className: [
        "toast-container",
        r ? "bottom" : "",
        n ? "right" : "",
        s ? " with-flag" : "",
        l || ""
      ].join(" ")
    },
    o
  ) : null;
}
var F = {}, Gh = {
  get exports() {
    return F;
  },
  set exports(t) {
    F = t;
  }
}, _a = {}, _w = {
  get exports() {
    return _a;
  },
  set exports(t) {
    _a = t;
  }
}, Ye = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zh;
function Sw() {
  if (Zh)
    return Ye;
  Zh = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, d = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, g = t ? Symbol.for("react.lazy") : 60116, p = t ? Symbol.for("react.block") : 60121, y = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, x = t ? Symbol.for("react.scope") : 60119;
  function S(_) {
    if (typeof _ == "object" && _ !== null) {
      var B = _.$$typeof;
      switch (B) {
        case e:
          switch (_ = _.type, _) {
            case l:
            case c:
            case n:
            case o:
            case i:
            case f:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case a:
                case u:
                case g:
                case h:
                case s:
                  return _;
                default:
                  return B;
              }
          }
        case r:
          return B;
      }
    }
  }
  function O(_) {
    return S(_) === c;
  }
  return Ye.AsyncMode = l, Ye.ConcurrentMode = c, Ye.ContextConsumer = a, Ye.ContextProvider = s, Ye.Element = e, Ye.ForwardRef = u, Ye.Fragment = n, Ye.Lazy = g, Ye.Memo = h, Ye.Portal = r, Ye.Profiler = o, Ye.StrictMode = i, Ye.Suspense = f, Ye.isAsyncMode = function(_) {
    return O(_) || S(_) === l;
  }, Ye.isConcurrentMode = O, Ye.isContextConsumer = function(_) {
    return S(_) === a;
  }, Ye.isContextProvider = function(_) {
    return S(_) === s;
  }, Ye.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === e;
  }, Ye.isForwardRef = function(_) {
    return S(_) === u;
  }, Ye.isFragment = function(_) {
    return S(_) === n;
  }, Ye.isLazy = function(_) {
    return S(_) === g;
  }, Ye.isMemo = function(_) {
    return S(_) === h;
  }, Ye.isPortal = function(_) {
    return S(_) === r;
  }, Ye.isProfiler = function(_) {
    return S(_) === o;
  }, Ye.isStrictMode = function(_) {
    return S(_) === i;
  }, Ye.isSuspense = function(_) {
    return S(_) === f;
  }, Ye.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === n || _ === c || _ === o || _ === i || _ === f || _ === d || typeof _ == "object" && _ !== null && (_.$$typeof === g || _.$$typeof === h || _.$$typeof === s || _.$$typeof === a || _.$$typeof === u || _.$$typeof === y || _.$$typeof === b || _.$$typeof === x || _.$$typeof === p);
  }, Ye.typeOf = S, Ye;
}
var Ke = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $h;
function Ew() {
  return $h || ($h = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, d = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, g = t ? Symbol.for("react.lazy") : 60116, p = t ? Symbol.for("react.block") : 60121, y = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, x = t ? Symbol.for("react.scope") : 60119;
    function S(k) {
      return typeof k == "string" || typeof k == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      k === n || k === c || k === o || k === i || k === f || k === d || typeof k == "object" && k !== null && (k.$$typeof === g || k.$$typeof === h || k.$$typeof === s || k.$$typeof === a || k.$$typeof === u || k.$$typeof === y || k.$$typeof === b || k.$$typeof === x || k.$$typeof === p);
    }
    function O(k) {
      if (typeof k == "object" && k !== null) {
        var re = k.$$typeof;
        switch (re) {
          case e:
            var ne = k.type;
            switch (ne) {
              case l:
              case c:
              case n:
              case o:
              case i:
              case f:
                return ne;
              default:
                var Ae = ne && ne.$$typeof;
                switch (Ae) {
                  case a:
                  case u:
                  case g:
                  case h:
                  case s:
                    return Ae;
                  default:
                    return re;
                }
            }
          case r:
            return re;
        }
      }
    }
    var _ = l, B = c, N = a, j = s, W = e, G = u, ee = n, fe = g, P = h, z = r, U = o, I = i, V = f, te = !1;
    function X(k) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(k) || O(k) === l;
    }
    function H(k) {
      return O(k) === c;
    }
    function $(k) {
      return O(k) === a;
    }
    function se(k) {
      return O(k) === s;
    }
    function he(k) {
      return typeof k == "object" && k !== null && k.$$typeof === e;
    }
    function pe(k) {
      return O(k) === u;
    }
    function me(k) {
      return O(k) === n;
    }
    function L(k) {
      return O(k) === g;
    }
    function q(k) {
      return O(k) === h;
    }
    function Z(k) {
      return O(k) === r;
    }
    function oe(k) {
      return O(k) === o;
    }
    function de(k) {
      return O(k) === i;
    }
    function R(k) {
      return O(k) === f;
    }
    Ke.AsyncMode = _, Ke.ConcurrentMode = B, Ke.ContextConsumer = N, Ke.ContextProvider = j, Ke.Element = W, Ke.ForwardRef = G, Ke.Fragment = ee, Ke.Lazy = fe, Ke.Memo = P, Ke.Portal = z, Ke.Profiler = U, Ke.StrictMode = I, Ke.Suspense = V, Ke.isAsyncMode = X, Ke.isConcurrentMode = H, Ke.isContextConsumer = $, Ke.isContextProvider = se, Ke.isElement = he, Ke.isForwardRef = pe, Ke.isFragment = me, Ke.isLazy = L, Ke.isMemo = q, Ke.isPortal = Z, Ke.isProfiler = oe, Ke.isStrictMode = de, Ke.isSuspense = R, Ke.isValidElementType = S, Ke.typeOf = O;
  }()), Ke;
}
var ep;
function bg() {
  return ep || (ep = 1, function(t) {
    process.env.NODE_ENV === "production" ? t.exports = Sw() : t.exports = Ew();
  }(_w)), _a;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var cc, tp;
function tf() {
  if (tp)
    return cc;
  tp = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return cc = i() ? Object.assign : function(o, s) {
    for (var a, l = n(o), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var f in a)
        e.call(a, f) && (l[f] = a[f]);
      if (t) {
        c = t(a);
        for (var d = 0; d < c.length; d++)
          r.call(a, c[d]) && (l[c[d]] = a[c[d]]);
      }
    }
    return l;
  }, cc;
}
var uc, rp;
function rf() {
  if (rp)
    return uc;
  rp = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return uc = t, uc;
}
var fc, np;
function vg() {
  return np || (np = 1, fc = Function.call.bind(Object.prototype.hasOwnProperty)), fc;
}
var dc, ip;
function kw() {
  if (ip)
    return dc;
  ip = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = rf(), r = {}, n = vg();
    t = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (n(o, u)) {
          var f;
          try {
            if (typeof o[u] != "function") {
              var d = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[u](s, u, l, a, null, e);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var h = c ? c() : "";
            t(
              "Failed " + a + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, dc = i, dc;
}
var hc, op;
function Cw() {
  if (op)
    return hc;
  op = 1;
  var t = bg(), e = tf(), r = rf(), n = vg(), i = kw(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return hc = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(H) {
      var $ = H && (c && H[c] || H[u]);
      if (typeof $ == "function")
        return $;
    }
    var d = "<<anonymous>>", h = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: x(),
      arrayOf: S,
      element: O(),
      elementType: _(),
      instanceOf: B,
      node: G(),
      objectOf: j,
      oneOf: N,
      oneOfType: W,
      shape: fe,
      exact: P
    };
    function g(H, $) {
      return H === $ ? H !== 0 || 1 / H === 1 / $ : H !== H && $ !== $;
    }
    function p(H, $) {
      this.message = H, this.data = $ && typeof $ == "object" ? $ : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function y(H) {
      if (process.env.NODE_ENV !== "production")
        var $ = {}, se = 0;
      function he(me, L, q, Z, oe, de, R) {
        if (Z = Z || d, de = de || q, R !== r) {
          if (l) {
            var k = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw k.name = "Invariant Violation", k;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var re = Z + ":" + q;
            !$[re] && // Avoid spamming the console because they are often not actionable except for lib authors
            se < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + de + "` prop on `" + Z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), $[re] = !0, se++);
          }
        }
        return L[q] == null ? me ? L[q] === null ? new p("The " + oe + " `" + de + "` is marked as required " + ("in `" + Z + "`, but its value is `null`.")) : new p("The " + oe + " `" + de + "` is marked as required in " + ("`" + Z + "`, but its value is `undefined`.")) : null : H(L, q, Z, oe, de);
      }
      var pe = he.bind(null, !1);
      return pe.isRequired = he.bind(null, !0), pe;
    }
    function b(H) {
      function $(se, he, pe, me, L, q) {
        var Z = se[he], oe = I(Z);
        if (oe !== H) {
          var de = V(Z);
          return new p(
            "Invalid " + me + " `" + L + "` of type " + ("`" + de + "` supplied to `" + pe + "`, expected ") + ("`" + H + "`."),
            { expectedType: H }
          );
        }
        return null;
      }
      return y($);
    }
    function x() {
      return y(s);
    }
    function S(H) {
      function $(se, he, pe, me, L) {
        if (typeof H != "function")
          return new p("Property `" + L + "` of component `" + pe + "` has invalid PropType notation inside arrayOf.");
        var q = se[he];
        if (!Array.isArray(q)) {
          var Z = I(q);
          return new p("Invalid " + me + " `" + L + "` of type " + ("`" + Z + "` supplied to `" + pe + "`, expected an array."));
        }
        for (var oe = 0; oe < q.length; oe++) {
          var de = H(q, oe, pe, me, L + "[" + oe + "]", r);
          if (de instanceof Error)
            return de;
        }
        return null;
      }
      return y($);
    }
    function O() {
      function H($, se, he, pe, me) {
        var L = $[se];
        if (!a(L)) {
          var q = I(L);
          return new p("Invalid " + pe + " `" + me + "` of type " + ("`" + q + "` supplied to `" + he + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(H);
    }
    function _() {
      function H($, se, he, pe, me) {
        var L = $[se];
        if (!t.isValidElementType(L)) {
          var q = I(L);
          return new p("Invalid " + pe + " `" + me + "` of type " + ("`" + q + "` supplied to `" + he + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(H);
    }
    function B(H) {
      function $(se, he, pe, me, L) {
        if (!(se[he] instanceof H)) {
          var q = H.name || d, Z = X(se[he]);
          return new p("Invalid " + me + " `" + L + "` of type " + ("`" + Z + "` supplied to `" + pe + "`, expected ") + ("instance of `" + q + "`."));
        }
        return null;
      }
      return y($);
    }
    function N(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function $(se, he, pe, me, L) {
        for (var q = se[he], Z = 0; Z < H.length; Z++)
          if (g(q, H[Z]))
            return null;
        var oe = JSON.stringify(H, function(R, k) {
          var re = V(k);
          return re === "symbol" ? String(k) : k;
        });
        return new p("Invalid " + me + " `" + L + "` of value `" + String(q) + "` " + ("supplied to `" + pe + "`, expected one of " + oe + "."));
      }
      return y($);
    }
    function j(H) {
      function $(se, he, pe, me, L) {
        if (typeof H != "function")
          return new p("Property `" + L + "` of component `" + pe + "` has invalid PropType notation inside objectOf.");
        var q = se[he], Z = I(q);
        if (Z !== "object")
          return new p("Invalid " + me + " `" + L + "` of type " + ("`" + Z + "` supplied to `" + pe + "`, expected an object."));
        for (var oe in q)
          if (n(q, oe)) {
            var de = H(q, oe, pe, me, L + "." + oe, r);
            if (de instanceof Error)
              return de;
          }
        return null;
      }
      return y($);
    }
    function W(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var $ = 0; $ < H.length; $++) {
        var se = H[$];
        if (typeof se != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + te(se) + " at index " + $ + "."
          ), s;
      }
      function he(pe, me, L, q, Z) {
        for (var oe = [], de = 0; de < H.length; de++) {
          var R = H[de], k = R(pe, me, L, q, Z, r);
          if (k == null)
            return null;
          k.data && n(k.data, "expectedType") && oe.push(k.data.expectedType);
        }
        var re = oe.length > 0 ? ", expected one of type [" + oe.join(", ") + "]" : "";
        return new p("Invalid " + q + " `" + Z + "` supplied to " + ("`" + L + "`" + re + "."));
      }
      return y(he);
    }
    function G() {
      function H($, se, he, pe, me) {
        return z($[se]) ? null : new p("Invalid " + pe + " `" + me + "` supplied to " + ("`" + he + "`, expected a ReactNode."));
      }
      return y(H);
    }
    function ee(H, $, se, he, pe) {
      return new p(
        (H || "React class") + ": " + $ + " type `" + se + "." + he + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + pe + "`."
      );
    }
    function fe(H) {
      function $(se, he, pe, me, L) {
        var q = se[he], Z = I(q);
        if (Z !== "object")
          return new p("Invalid " + me + " `" + L + "` of type `" + Z + "` " + ("supplied to `" + pe + "`, expected `object`."));
        for (var oe in H) {
          var de = H[oe];
          if (typeof de != "function")
            return ee(pe, me, L, oe, V(de));
          var R = de(q, oe, pe, me, L + "." + oe, r);
          if (R)
            return R;
        }
        return null;
      }
      return y($);
    }
    function P(H) {
      function $(se, he, pe, me, L) {
        var q = se[he], Z = I(q);
        if (Z !== "object")
          return new p("Invalid " + me + " `" + L + "` of type `" + Z + "` " + ("supplied to `" + pe + "`, expected `object`."));
        var oe = e({}, se[he], H);
        for (var de in oe) {
          var R = H[de];
          if (n(H, de) && typeof R != "function")
            return ee(pe, me, L, de, V(R));
          if (!R)
            return new p(
              "Invalid " + me + " `" + L + "` key `" + de + "` supplied to `" + pe + "`.\nBad object: " + JSON.stringify(se[he], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(H), null, "  ")
            );
          var k = R(q, de, pe, me, L + "." + de, r);
          if (k)
            return k;
        }
        return null;
      }
      return y($);
    }
    function z(H) {
      switch (typeof H) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !H;
        case "object":
          if (Array.isArray(H))
            return H.every(z);
          if (H === null || a(H))
            return !0;
          var $ = f(H);
          if ($) {
            var se = $.call(H), he;
            if ($ !== H.entries) {
              for (; !(he = se.next()).done; )
                if (!z(he.value))
                  return !1;
            } else
              for (; !(he = se.next()).done; ) {
                var pe = he.value;
                if (pe && !z(pe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function U(H, $) {
      return H === "symbol" ? !0 : $ ? $["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && $ instanceof Symbol : !1;
    }
    function I(H) {
      var $ = typeof H;
      return Array.isArray(H) ? "array" : H instanceof RegExp ? "object" : U($, H) ? "symbol" : $;
    }
    function V(H) {
      if (typeof H > "u" || H === null)
        return "" + H;
      var $ = I(H);
      if ($ === "object") {
        if (H instanceof Date)
          return "date";
        if (H instanceof RegExp)
          return "regexp";
      }
      return $;
    }
    function te(H) {
      var $ = V(H);
      switch ($) {
        case "array":
        case "object":
          return "an " + $;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + $;
        default:
          return $;
      }
    }
    function X(H) {
      return !H.constructor || !H.constructor.name ? d : H.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, hc;
}
var pc, sp;
function Tw() {
  if (sp)
    return pc;
  sp = 1;
  var t = rf();
  function e() {
  }
  function r() {
  }
  return r.resetWarningCache = e, pc = function() {
    function n(s, a, l, c, u, f) {
      if (f !== t) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, pc;
}
if (process.env.NODE_ENV !== "production") {
  var Ow = bg(), Iw = !0;
  Gh.exports = Cw()(Ow.isElement, Iw);
} else
  Gh.exports = Tw()();
var Pw = !!(typeof window < "u" && window.document && window.document.createElement), Rw = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var i = r[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function Dw(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Mw(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Nw(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Ag = function(t) {
  Nw(e, t);
  function e() {
    return Dw(this, e), Mw(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }
  return Rw(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function() {
      return Pw ? (!this.props.node && !this.defaultNode && (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode)), Wt.createPortal(this.props.children, this.props.node || this.defaultNode)) : null;
    }
  }]), e;
}(K.Component);
Ag.propTypes = {
  children: F.node.isRequired,
  node: F.any
};
const Bw = Ag;
var Lw = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var i = r[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function Fw(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function jw(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Ww(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var wg = function(t) {
  Ww(e, t);
  function e() {
    return Fw(this, e), jw(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }
  return Lw(e, [{
    key: "componentDidMount",
    value: function() {
      this.renderPortal();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      this.renderPortal();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      Wt.unmountComponentAtNode(this.defaultNode || this.props.node), this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null, this.portal = null;
    }
  }, {
    key: "renderPortal",
    value: function(n) {
      !this.props.node && !this.defaultNode && (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode));
      var i = this.props.children;
      typeof this.props.children.type == "function" && (i = K.cloneElement(this.props.children)), this.portal = Wt.unstable_renderSubtreeIntoContainer(this, i, this.props.node || this.defaultNode);
    }
  }, {
    key: "render",
    value: function() {
      return null;
    }
  }]), e;
}(K.Component);
const Uw = wg;
wg.propTypes = {
  children: F.node.isRequired,
  node: F.any
};
var tu = void 0;
Wt.createPortal ? tu = Bw : tu = Uw;
const xg = tu, _g = "data:image/png;base64,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", Sg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE3SURBVHgB7ZdtbcMwEIbfDEEhBEIhbAwGwUOyMCiFQhiDlUHHwINQBtez+qFWipvz6w+1kh/p5B/JvXlkKckZ6HQ6r8GwdIOIrHUJ9T8Mww4ZaNZKl0+tg2b9IAcN28g9XmsEgfZ9l8oKYU7mSQ6dEbtmgUEbfyWOtwo+ELuwRioLciZBg1jgHalo02QI9jFBo1joXyGV0KS1Nz5gJMQCDiyMYBMxUnAjNhxKkSDYVqywoEMtMgUdakMKOrTiLOiNYhNaIvbPhUjOD76yWDtBUqy+YKZYPcEEMW+8Z0QJEsTCcEoPC1XFbnrqC0p8TI+KEYJ7MMjyJDwrRghGx/Q38Hzp8W4bu6jXDrp8aP3hMdQkPDE7NpOztIP0mO5zxAyCE1i0eZTTi7HT2gpzUrrPK5bV6XSeiSNPs80hxEV9awAAAABJRU5ErkJggg==", zw = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAdCAYAAAD7En+mAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAK1SURBVHgB1ZmBddowEIbPLFA2qEagE2AmKBuETBA6AWwQOgHNBE0mgE4AnUDuBPUGf3WWnMqOZJ8wJPC9dxgL3UknS6ezyEgIgNxcvhrhqzIypo/jaKQw8mJkn2VZQUMxDq6M/MV1szWi6BSM4sSIxm2xSnXyAbfLAYGnmwWc5FFZ021TGPli1m5ZFzQchQ04O5LBAYEN5fQ+lK5N5aQPDlKzN6X8uCFbk9qfGgl6Q1i3+roW6i1Djj4KlRcB3QUuh6YAkA0u7xbVNjiqn4q5LEnGMVC2p8vxO1L+i/phJyu/Rq4gJzklvS+fI+VTkvHAH7Wjd3S98H7e2B/dvZKp09jUzzOniEglfnpP1Jyuz37Ydvo8ReZ+58imi4rS2ZNN7djmnWeDywt3n3v9++6u01YffL7VGVAwCODUtIpeo3Fq6rgO2NDS/pn7TaTutto7oz8OpKPhGCpgYxmpuwzUHUfq7kYd/fxDw0kKXJG3kFJqu72kfEYdhqRRrYskG7CZmdTGVKj/+uO4Yyqt4DbcxA6zTWkC4qONTBJsrHwnEV/PmzrqcvahOvpeeN9n7SkGu7b8HFnRMOpZNvbav6f/UXdLzTZK6j4IuK8+kRY0VNsKbHS8JCrQXkpEV3Uweqbr5aU9g9z9nmRURy0jp7hPUFTCshBF5jDfZ0KdT5Fyaex4atwhvp+2eWxbgj2zkTBv6e0EOjxFVUtPulQOQdchX6tb2IGZQ+7kJtCedK1p2FdBbnMJ+SuaijnKIf2A86MR2aZwuXfZ7tdOnP/EQKMnZ4b8xEDKmiTAPtkfGM5PCBMO2GWgMQyernNKBXZaaaTDDS4oEdjZdOoA86AqGoJzeCdojOtwsBj0d4XnsEb/gHIAzftsZpSAc2DipHaG06+C7MZ89mMW2NxXuTZrCiNH095RaucfEDTBOCTCWakAAAAASUVORK5CYII=";
function Vw({
  playerState: t,
  key: e,
  style: r,
  noDefault: n,
  defaultImage: i
}) {
  var o = t ? t.getState("profile") : !1, s = t ? t.getState("__gamepad") : !1;
  return r = r || {}, o && (r.borderColor = o.color), o && o.photo ? (r.backgroundImage = `url(${o.photo})`, r.backgroundSize = "contain") : n || (i === "color" && o ? r.background = o.color : r.backgroundImage = `url(${i || _g})`, r.backgroundSize = i ? "cover" : "contain"), /* @__PURE__ */ K.createElement(
    "div",
    {
      key: e || (t ? t.id : ""),
      className: "avatar-holder",
      style: r
    },
    s && /* @__PURE__ */ K.createElement(
      "div",
      {
        className: "badge-gamepad",
        style: { backgroundImage: `url(${zw})` }
      }
    )
  );
}
function Eg({
  centered: t,
  bottom: e,
  showNames: r,
  showScores: n,
  onPlayerKick: i,
  showEmptySlots: o = 0,
  mobileMode: s,
  initialScore: a = 0,
  style: l = {}
}) {
  const c = Va(!0), u = Mu(), f = o - c.length;
  return /* @__PURE__ */ K.createElement(
    "div",
    {
      className: "player-avatar-strip" + (s ? " mobile" : ""),
      style: l
    },
    c.map((d) => {
      var p, y, b, x;
      const h = a3() ? !1 : d.id === To().id, g = ((p = d.getState("profile")) == null ? void 0 : p.points) || ((y = d.getState("profile")) == null ? void 0 : y.score) || 0;
      return /* @__PURE__ */ K.createElement(
        "div",
        {
          key: d.id,
          className: "player-score-container",
          style: { backgroundColor: (b = d.getState("profile")) == null ? void 0 : b.color }
        },
        /* @__PURE__ */ K.createElement(Vw, { playerState: d }),
        s && !h && u && /* @__PURE__ */ K.createElement(
          "span",
          {
            className: "player-remove",
            onClick: () => i(d)
          },
          /* @__PURE__ */ K.createElement(
            "svg",
            {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            },
            /* @__PURE__ */ K.createElement("circle", { cx: "10.2441", cy: "9.75", r: "9.75", fill: "white" }),
            /* @__PURE__ */ K.createElement(
              "rect",
              {
                x: "15.2549",
                y: "7.75",
                width: "4",
                height: "10",
                rx: "2",
                transform: "rotate(90 15.2549 7.75)",
                fill: "black"
              }
            )
          )
        ),
        r && /* @__PURE__ */ K.createElement("span", null, (x = d.getState("profile")) == null ? void 0 : x.name),
        n && /* @__PURE__ */ K.createElement("span", null, a + g)
      );
    }),
    f > 0 && [...Array(f)].map((d, h) => /* @__PURE__ */ K.createElement(
      "div",
      {
        key: "empty" + h,
        className: "player-score-container",
        style: { backgroundColor: "#000000" }
      },
      /* @__PURE__ */ K.createElement("div", { className: "avatar-holder empty" })
    ))
  );
}
function vn(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
function ke() {
  return ke = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ke.apply(this, arguments);
}
function kg(t) {
  var e, r, n = "";
  if (typeof t == "string" || typeof t == "number")
    n += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (r = kg(t[e])) && (n && (n += " "), n += r);
    else
      for (e in t)
        t[e] && (n && (n += " "), n += e);
  return n;
}
function lo() {
  for (var t, e, r = 0, n = ""; r < arguments.length; )
    (t = arguments[r++]) && (e = kg(t)) && (n && (n += " "), n += e);
  return n;
}
function nf(t, e) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return t(...n) || e(...n);
  };
}
function un() {
  return un = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, un.apply(this, arguments);
}
function li(t) {
  return t !== null && typeof t == "object" && t.constructor === Object;
}
function Cg(t) {
  if (!li(t))
    return t;
  const e = {};
  return Object.keys(t).forEach((r) => {
    e[r] = Cg(t[r]);
  }), e;
}
function Vr(t, e, r = {
  clone: !0
}) {
  const n = r.clone ? un({}, t) : t;
  return li(t) && li(e) && Object.keys(e).forEach((i) => {
    i !== "__proto__" && (li(e[i]) && i in t && li(t[i]) ? n[i] = Vr(t[i], e[i], r) : r.clone ? n[i] = li(e[i]) ? Cg(e[i]) : e[i] : n[i] = e[i]);
  }), n;
}
function qw(t) {
  const {
    prototype: e = {}
  } = t;
  return !!e.isReactComponent;
}
function Tg(t, e, r, n, i) {
  const o = t[e], s = i || e;
  if (o == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let a;
  const l = o.type;
  return typeof l == "function" && !qw(l) && (a = "Did you accidentally use a plain function component for an element instead?"), a !== void 0 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an element that can hold a ref. ${a} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Og = nf(F.element, Tg);
Og.isRequired = nf(F.element.isRequired, Tg);
const Ig = Og, Hw = "exact-prop: ​";
function Yw(t) {
  return process.env.NODE_ENV === "production" ? t : un({}, t, {
    [Hw]: (e) => {
      const r = Object.keys(e).filter((n) => !t.hasOwnProperty(n));
      return r.length > 0 ? new Error(`The following props are not supported: ${r.map((n) => `\`${n}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function ki(t) {
  let e = "https://mui.com/production-error/?code=" + t;
  for (let r = 1; r < arguments.length; r += 1)
    e += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified MUI error #" + t + "; visit " + e + " for the full message.";
}
var Sa = {}, Kw = {
  get exports() {
    return Sa;
  },
  set exports(t) {
    Sa = t;
  }
}, Xe = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ap;
function Xw() {
  if (ap)
    return Xe;
  ap = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function p(y) {
    if (typeof y == "object" && y !== null) {
      var b = y.$$typeof;
      switch (b) {
        case t:
          switch (y = y.type, y) {
            case r:
            case i:
            case n:
            case c:
            case u:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case s:
                case l:
                case d:
                case f:
                case o:
                  return y;
                default:
                  return b;
              }
          }
        case e:
          return b;
      }
    }
  }
  return Xe.ContextConsumer = s, Xe.ContextProvider = o, Xe.Element = t, Xe.ForwardRef = l, Xe.Fragment = r, Xe.Lazy = d, Xe.Memo = f, Xe.Portal = e, Xe.Profiler = i, Xe.StrictMode = n, Xe.Suspense = c, Xe.SuspenseList = u, Xe.isAsyncMode = function() {
    return !1;
  }, Xe.isConcurrentMode = function() {
    return !1;
  }, Xe.isContextConsumer = function(y) {
    return p(y) === s;
  }, Xe.isContextProvider = function(y) {
    return p(y) === o;
  }, Xe.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, Xe.isForwardRef = function(y) {
    return p(y) === l;
  }, Xe.isFragment = function(y) {
    return p(y) === r;
  }, Xe.isLazy = function(y) {
    return p(y) === d;
  }, Xe.isMemo = function(y) {
    return p(y) === f;
  }, Xe.isPortal = function(y) {
    return p(y) === e;
  }, Xe.isProfiler = function(y) {
    return p(y) === i;
  }, Xe.isStrictMode = function(y) {
    return p(y) === n;
  }, Xe.isSuspense = function(y) {
    return p(y) === c;
  }, Xe.isSuspenseList = function(y) {
    return p(y) === u;
  }, Xe.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === i || y === n || y === c || y === u || y === h || typeof y == "object" && y !== null && (y.$$typeof === d || y.$$typeof === f || y.$$typeof === o || y.$$typeof === s || y.$$typeof === l || y.$$typeof === g || y.getModuleId !== void 0);
  }, Xe.typeOf = p, Xe;
}
var Je = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lp;
function Jw() {
  return lp || (lp = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g = !1, p = !1, y = !1, b = !1, x = !1, S;
    S = Symbol.for("react.module.reference");
    function O(ne) {
      return !!(typeof ne == "string" || typeof ne == "function" || ne === r || ne === i || x || ne === n || ne === c || ne === u || b || ne === h || g || p || y || typeof ne == "object" && ne !== null && (ne.$$typeof === d || ne.$$typeof === f || ne.$$typeof === o || ne.$$typeof === s || ne.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ne.$$typeof === S || ne.getModuleId !== void 0));
    }
    function _(ne) {
      if (typeof ne == "object" && ne !== null) {
        var Ae = ne.$$typeof;
        switch (Ae) {
          case t:
            var C = ne.type;
            switch (C) {
              case r:
              case i:
              case n:
              case c:
              case u:
                return C;
              default:
                var v = C && C.$$typeof;
                switch (v) {
                  case a:
                  case s:
                  case l:
                  case d:
                  case f:
                  case o:
                    return v;
                  default:
                    return Ae;
                }
            }
          case e:
            return Ae;
        }
      }
    }
    var B = s, N = o, j = t, W = l, G = r, ee = d, fe = f, P = e, z = i, U = n, I = c, V = u, te = !1, X = !1;
    function H(ne) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function $(ne) {
      return X || (X = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function se(ne) {
      return _(ne) === s;
    }
    function he(ne) {
      return _(ne) === o;
    }
    function pe(ne) {
      return typeof ne == "object" && ne !== null && ne.$$typeof === t;
    }
    function me(ne) {
      return _(ne) === l;
    }
    function L(ne) {
      return _(ne) === r;
    }
    function q(ne) {
      return _(ne) === d;
    }
    function Z(ne) {
      return _(ne) === f;
    }
    function oe(ne) {
      return _(ne) === e;
    }
    function de(ne) {
      return _(ne) === i;
    }
    function R(ne) {
      return _(ne) === n;
    }
    function k(ne) {
      return _(ne) === c;
    }
    function re(ne) {
      return _(ne) === u;
    }
    Je.ContextConsumer = B, Je.ContextProvider = N, Je.Element = j, Je.ForwardRef = W, Je.Fragment = G, Je.Lazy = ee, Je.Memo = fe, Je.Portal = P, Je.Profiler = z, Je.StrictMode = U, Je.Suspense = I, Je.SuspenseList = V, Je.isAsyncMode = H, Je.isConcurrentMode = $, Je.isContextConsumer = se, Je.isContextProvider = he, Je.isElement = pe, Je.isForwardRef = me, Je.isFragment = L, Je.isLazy = q, Je.isMemo = Z, Je.isPortal = oe, Je.isProfiler = de, Je.isStrictMode = R, Je.isSuspense = k, Je.isSuspenseList = re, Je.isValidElementType = O, Je.typeOf = _;
  }()), Je;
}
(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = Xw() : t.exports = Jw();
})(Kw);
const Qw = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function Gw(t) {
  const e = `${t}`.match(Qw);
  return e && e[1] || "";
}
function Pg(t, e = "") {
  return t.displayName || t.name || Gw(t) || e;
}
function cp(t, e, r) {
  const n = Pg(e);
  return t.displayName || (n !== "" ? `${r}(${n})` : r);
}
function Zw(t) {
  if (t != null) {
    if (typeof t == "string")
      return t;
    if (typeof t == "function")
      return Pg(t, "Component");
    if (typeof t == "object")
      switch (t.$$typeof) {
        case Sa.ForwardRef:
          return cp(t, t.render, "ForwardRef");
        case Sa.Memo:
          return cp(t, t.type, "memo");
        default:
          return;
      }
  }
}
function jo(t, e, r, n, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const o = t[e], s = i || e;
  return o == null ? null : o && o.nodeType !== 1 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an HTMLElement.`) : null;
}
const $w = F.oneOfType([F.func, F.object]), Rg = $w;
function ir(t) {
  if (typeof t != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : ki(7));
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function e4(...t) {
  return t.reduce((e, r) => r == null ? e : function(...i) {
    e.apply(this, i), r.apply(this, i);
  }, () => {
  });
}
function t4(t, e = 166) {
  let r;
  function n(...i) {
    const o = () => {
      t.apply(this, i);
    };
    clearTimeout(r), r = setTimeout(o, e);
  }
  return n.clear = () => {
    clearTimeout(r);
  }, n;
}
function r4(t, e) {
  return process.env.NODE_ENV === "production" ? () => null : (r, n, i, o, s) => {
    const a = i || "<<anonymous>>", l = s || n;
    return typeof r[n] < "u" ? new Error(`The ${o} \`${l}\` of \`${a}\` is deprecated. ${e}`) : null;
  };
}
function n4(t, e) {
  return /* @__PURE__ */ ve.isValidElement(t) && e.indexOf(t.type.muiName) !== -1;
}
function Ea(t) {
  return t && t.ownerDocument || document;
}
function i4(t) {
  return Ea(t).defaultView || window;
}
function o4(t, e) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const r = e ? un({}, e.propTypes) : null;
  return (i) => (o, s, a, l, c, ...u) => {
    const f = c || s, d = r == null ? void 0 : r[f];
    if (d) {
      const h = d(o, s, a, l, c, ...u);
      if (h)
        return h;
    }
    return typeof o[s] < "u" && !o[i] ? new Error(`The prop \`${f}\` of \`${t}\` can only be used together with the \`${i}\` prop.`) : null;
  };
}
function ka(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
const s4 = typeof window < "u" ? ve.useLayoutEffect : ve.useEffect, Ci = s4;
let up = 0;
function a4(t) {
  const [e, r] = ve.useState(t), n = t || e;
  return ve.useEffect(() => {
    e == null && (up += 1, r(`mui-${up}`));
  }, [e]), n;
}
const fp = ve["useId"];
function Dg(t) {
  if (fp !== void 0) {
    const e = fp();
    return t ?? e;
  }
  return a4(t);
}
function l4(t, e, r, n, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const o = i || e;
  return typeof t[e] < "u" ? new Error(`The prop \`${o}\` is not supported. Please remove it.`) : null;
}
function Mg({
  controlled: t,
  default: e,
  name: r,
  state: n = "value"
}) {
  const {
    current: i
  } = ve.useRef(t !== void 0), [o, s] = ve.useState(e), a = i ? t : o;
  if (process.env.NODE_ENV !== "production") {
    ve.useEffect(() => {
      i !== (t !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${n} state of ${r} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${r} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [n, r, t]);
    const {
      current: c
    } = ve.useRef(e);
    ve.useEffect(() => {
      !i && c !== e && console.error([`MUI: A component is changing the default ${n} state of an uncontrolled ${r} after being initialized. To suppress this warning opt to use a controlled ${r}.`].join(`
`));
    }, [JSON.stringify(e)]);
  }
  const l = ve.useCallback((c) => {
    i || s(c);
  }, []);
  return [a, l];
}
function Ng(t) {
  const e = ve.useRef(t);
  return Ci(() => {
    e.current = t;
  }), ve.useCallback((...r) => (
    // @ts-expect-error hide `this`
    // tslint:disable-next-line:ban-comma-operator
    (0, e.current)(...r)
  ), []);
}
function Yn(...t) {
  return ve.useMemo(() => t.every((e) => e == null) ? null : (e) => {
    t.forEach((r) => {
      ka(r, e);
    });
  }, t);
}
let Za = !0, ru = !1, dp;
const c4 = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function u4(t) {
  const {
    type: e,
    tagName: r
  } = t;
  return !!(r === "INPUT" && c4[e] && !t.readOnly || r === "TEXTAREA" && !t.readOnly || t.isContentEditable);
}
function f4(t) {
  t.metaKey || t.altKey || t.ctrlKey || (Za = !0);
}
function gc() {
  Za = !1;
}
function d4() {
  this.visibilityState === "hidden" && ru && (Za = !0);
}
function h4(t) {
  t.addEventListener("keydown", f4, !0), t.addEventListener("mousedown", gc, !0), t.addEventListener("pointerdown", gc, !0), t.addEventListener("touchstart", gc, !0), t.addEventListener("visibilitychange", d4, !0);
}
function p4(t) {
  const {
    target: e
  } = t;
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return Za || u4(e);
}
function Bg() {
  const t = ve.useCallback((i) => {
    i != null && h4(i.ownerDocument);
  }, []), e = ve.useRef(!1);
  function r() {
    return e.current ? (ru = !0, window.clearTimeout(dp), dp = window.setTimeout(() => {
      ru = !1;
    }, 100), e.current = !1, !0) : !1;
  }
  function n(i) {
    return p4(i) ? (e.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: e,
    onFocus: n,
    onBlur: r,
    ref: t
  };
}
function Lg(t, e) {
  const r = un({}, e);
  return Object.keys(t).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      r[n] = un({}, t[n], r[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const i = t[n] || {}, o = e[n];
      r[n] = {}, !o || !Object.keys(o) ? r[n] = i : !i || !Object.keys(i) ? r[n] = o : (r[n] = un({}, o), Object.keys(i).forEach((s) => {
        r[n][s] = Lg(i[s], o[s]);
      }));
    } else
      r[n] === void 0 && (r[n] = t[n]);
  }), r;
}
function of(t, e, r = void 0) {
  const n = {};
  return Object.keys(t).forEach(
    // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (i) => {
      n[i] = t[i].reduce((o, s) => {
        if (s) {
          const a = e(s);
          a !== "" && o.push(a), r && r[s] && o.push(r[s]);
        }
        return o;
      }, []).join(" ");
    }
  ), n;
}
const hp = (t) => t, g4 = () => {
  let t = hp;
  return {
    configure(e) {
      t = e;
    },
    generate(e) {
      return t(e);
    },
    reset() {
      t = hp;
    }
  };
}, m4 = g4(), Fg = m4, y4 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  readOnly: "readOnly",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  required: "required",
  selected: "selected"
};
function $o(t, e, r = "Mui") {
  const n = y4[e];
  return n ? `${r}-${n}` : `${Fg.generate(t)}-${e}`;
}
function sf(t, e, r = "Mui") {
  const n = {};
  return e.forEach((i) => {
    n[i] = $o(t, i, r);
  }), n;
}
function Nt() {
  return Nt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Nt.apply(this, arguments);
}
function b4(t) {
  return typeof t == "string";
}
function co(t, e, r) {
  return t === void 0 || b4(t) ? e : Nt({}, e, {
    ownerState: Nt({}, e.ownerState, r)
  });
}
var Ca = {}, v4 = {
  get exports() {
    return Ca;
  },
  set exports(t) {
    Ca = t;
  }
}, ei = {};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pp;
function A4() {
  if (pp)
    return ei;
  pp = 1, tf();
  var t = K, e = 60103;
  if (ei.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    e = r("react.element"), ei.Fragment = r("react.fragment");
  }
  var n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, c) {
    var u, f = {}, d = null, h = null;
    c !== void 0 && (d = "" + c), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      i.call(l, u) && !o.hasOwnProperty(u) && (f[u] = l[u]);
    if (a && a.defaultProps)
      for (u in l = a.defaultProps, l)
        f[u] === void 0 && (f[u] = l[u]);
    return { $$typeof: e, type: a, key: d, ref: h, props: f, _owner: n.current };
  }
  return ei.jsx = s, ei.jsxs = s, ei;
}
var mc = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gp;
function w4() {
  return gp || (gp = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = K, r = tf(), n = 60103, i = 60106;
      t.Fragment = 60107;
      var o = 60108, s = 60114, a = 60109, l = 60110, c = 60112, u = 60113, f = 60120, d = 60115, h = 60116, g = 60121, p = 60122, y = 60117, b = 60129, x = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var S = Symbol.for;
        n = S("react.element"), i = S("react.portal"), t.Fragment = S("react.fragment"), o = S("react.strict_mode"), s = S("react.profiler"), a = S("react.provider"), l = S("react.context"), c = S("react.forward_ref"), u = S("react.suspense"), f = S("react.suspense_list"), d = S("react.memo"), h = S("react.lazy"), g = S("react.block"), p = S("react.server.block"), y = S("react.fundamental"), S("react.scope"), S("react.opaque.id"), b = S("react.debug_trace_mode"), S("react.offscreen"), x = S("react.legacy_hidden");
      }
      var O = typeof Symbol == "function" && Symbol.iterator, _ = "@@iterator";
      function B(Y) {
        if (Y === null || typeof Y != "object")
          return null;
        var ge = O && Y[O] || Y[_];
        return typeof ge == "function" ? ge : null;
      }
      var N = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function j(Y) {
        {
          for (var ge = arguments.length, be = new Array(ge > 1 ? ge - 1 : 0), xe = 1; xe < ge; xe++)
            be[xe - 1] = arguments[xe];
          W("error", Y, be);
        }
      }
      function W(Y, ge, be) {
        {
          var xe = N.ReactDebugCurrentFrame, je = xe.getStackAddendum();
          je !== "" && (ge += "%s", be = be.concat([je]));
          var Ze = be.map(function(Ie) {
            return "" + Ie;
          });
          Ze.unshift("Warning: " + ge), Function.prototype.apply.call(console[Y], console, Ze);
        }
      }
      var G = !1;
      function ee(Y) {
        return !!(typeof Y == "string" || typeof Y == "function" || Y === t.Fragment || Y === s || Y === b || Y === o || Y === u || Y === f || Y === x || G || typeof Y == "object" && Y !== null && (Y.$$typeof === h || Y.$$typeof === d || Y.$$typeof === a || Y.$$typeof === l || Y.$$typeof === c || Y.$$typeof === y || Y.$$typeof === g || Y[0] === p));
      }
      function fe(Y, ge, be) {
        var xe = ge.displayName || ge.name || "";
        return Y.displayName || (xe !== "" ? be + "(" + xe + ")" : be);
      }
      function P(Y) {
        return Y.displayName || "Context";
      }
      function z(Y) {
        if (Y == null)
          return null;
        if (typeof Y.tag == "number" && j("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof Y == "function")
          return Y.displayName || Y.name || null;
        if (typeof Y == "string")
          return Y;
        switch (Y) {
          case t.Fragment:
            return "Fragment";
          case i:
            return "Portal";
          case s:
            return "Profiler";
          case o:
            return "StrictMode";
          case u:
            return "Suspense";
          case f:
            return "SuspenseList";
        }
        if (typeof Y == "object")
          switch (Y.$$typeof) {
            case l:
              var ge = Y;
              return P(ge) + ".Consumer";
            case a:
              var be = Y;
              return P(be._context) + ".Provider";
            case c:
              return fe(Y, Y.render, "ForwardRef");
            case d:
              return z(Y.type);
            case g:
              return z(Y._render);
            case h: {
              var xe = Y, je = xe._payload, Ze = xe._init;
              try {
                return z(Ze(je));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var U = 0, I, V, te, X, H, $, se;
      function he() {
      }
      he.__reactDisabledLog = !0;
      function pe() {
        {
          if (U === 0) {
            I = console.log, V = console.info, te = console.warn, X = console.error, H = console.group, $ = console.groupCollapsed, se = console.groupEnd;
            var Y = {
              configurable: !0,
              enumerable: !0,
              value: he,
              writable: !0
            };
            Object.defineProperties(console, {
              info: Y,
              log: Y,
              warn: Y,
              error: Y,
              group: Y,
              groupCollapsed: Y,
              groupEnd: Y
            });
          }
          U++;
        }
      }
      function me() {
        {
          if (U--, U === 0) {
            var Y = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, Y, {
                value: I
              }),
              info: r({}, Y, {
                value: V
              }),
              warn: r({}, Y, {
                value: te
              }),
              error: r({}, Y, {
                value: X
              }),
              group: r({}, Y, {
                value: H
              }),
              groupCollapsed: r({}, Y, {
                value: $
              }),
              groupEnd: r({}, Y, {
                value: se
              })
            });
          }
          U < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var L = N.ReactCurrentDispatcher, q;
      function Z(Y, ge, be) {
        {
          if (q === void 0)
            try {
              throw Error();
            } catch (je) {
              var xe = je.stack.trim().match(/\n( *(at )?)/);
              q = xe && xe[1] || "";
            }
          return `
` + q + Y;
        }
      }
      var oe = !1, de;
      {
        var R = typeof WeakMap == "function" ? WeakMap : Map;
        de = new R();
      }
      function k(Y, ge) {
        if (!Y || oe)
          return "";
        {
          var be = de.get(Y);
          if (be !== void 0)
            return be;
        }
        var xe;
        oe = !0;
        var je = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Ze;
        Ze = L.current, L.current = null, pe();
        try {
          if (ge) {
            var Ie = function() {
              throw Error();
            };
            if (Object.defineProperty(Ie.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Ie, []);
              } catch (lr) {
                xe = lr;
              }
              Reflect.construct(Y, [], Ie);
            } else {
              try {
                Ie.call();
              } catch (lr) {
                xe = lr;
              }
              Y.call(Ie.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (lr) {
              xe = lr;
            }
            Y();
          }
        } catch (lr) {
          if (lr && xe && typeof lr.stack == "string") {
            for (var Pe = lr.stack.split(`
`), At = xe.stack.split(`
`), lt = Pe.length - 1, ut = At.length - 1; lt >= 1 && ut >= 0 && Pe[lt] !== At[ut]; )
              ut--;
            for (; lt >= 1 && ut >= 0; lt--, ut--)
              if (Pe[lt] !== At[ut]) {
                if (lt !== 1 || ut !== 1)
                  do
                    if (lt--, ut--, ut < 0 || Pe[lt] !== At[ut]) {
                      var Zt = `
` + Pe[lt].replace(" at new ", " at ");
                      return typeof Y == "function" && de.set(Y, Zt), Zt;
                    }
                  while (lt >= 1 && ut >= 0);
                break;
              }
          }
        } finally {
          oe = !1, L.current = Ze, me(), Error.prepareStackTrace = je;
        }
        var Qr = Y ? Y.displayName || Y.name : "", fs = Qr ? Z(Qr) : "";
        return typeof Y == "function" && de.set(Y, fs), fs;
      }
      function re(Y, ge, be) {
        return k(Y, !1);
      }
      function ne(Y) {
        var ge = Y.prototype;
        return !!(ge && ge.isReactComponent);
      }
      function Ae(Y, ge, be) {
        if (Y == null)
          return "";
        if (typeof Y == "function")
          return k(Y, ne(Y));
        if (typeof Y == "string")
          return Z(Y);
        switch (Y) {
          case u:
            return Z("Suspense");
          case f:
            return Z("SuspenseList");
        }
        if (typeof Y == "object")
          switch (Y.$$typeof) {
            case c:
              return re(Y.render);
            case d:
              return Ae(Y.type, ge, be);
            case g:
              return re(Y._render);
            case h: {
              var xe = Y, je = xe._payload, Ze = xe._init;
              try {
                return Ae(Ze(je), ge, be);
              } catch {
              }
            }
          }
        return "";
      }
      var C = {}, v = N.ReactDebugCurrentFrame;
      function w(Y) {
        if (Y) {
          var ge = Y._owner, be = Ae(Y.type, Y._source, ge ? ge.type : null);
          v.setExtraStackFrame(be);
        } else
          v.setExtraStackFrame(null);
      }
      function D(Y, ge, be, xe, je) {
        {
          var Ze = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Ie in Y)
            if (Ze(Y, Ie)) {
              var Pe = void 0;
              try {
                if (typeof Y[Ie] != "function") {
                  var At = Error((xe || "React class") + ": " + be + " type `" + Ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Y[Ie] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw At.name = "Invariant Violation", At;
                }
                Pe = Y[Ie](ge, Ie, xe, be, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (lt) {
                Pe = lt;
              }
              Pe && !(Pe instanceof Error) && (w(je), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", xe || "React class", be, Ie, typeof Pe), w(null)), Pe instanceof Error && !(Pe.message in C) && (C[Pe.message] = !0, w(je), j("Failed %s type: %s", be, Pe.message), w(null));
            }
        }
      }
      var J = N.ReactCurrentOwner, ae = Object.prototype.hasOwnProperty, ue = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Se, _e, we;
      we = {};
      function Ne(Y) {
        if (ae.call(Y, "ref")) {
          var ge = Object.getOwnPropertyDescriptor(Y, "ref").get;
          if (ge && ge.isReactWarning)
            return !1;
        }
        return Y.ref !== void 0;
      }
      function E(Y) {
        if (ae.call(Y, "key")) {
          var ge = Object.getOwnPropertyDescriptor(Y, "key").get;
          if (ge && ge.isReactWarning)
            return !1;
        }
        return Y.key !== void 0;
      }
      function m(Y, ge) {
        if (typeof Y.ref == "string" && J.current && ge && J.current.stateNode !== ge) {
          var be = z(J.current.type);
          we[be] || (j('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(J.current.type), Y.ref), we[be] = !0);
        }
      }
      function A(Y, ge) {
        {
          var be = function() {
            Se || (Se = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ge));
          };
          be.isReactWarning = !0, Object.defineProperty(Y, "key", {
            get: be,
            configurable: !0
          });
        }
      }
      function M(Y, ge) {
        {
          var be = function() {
            _e || (_e = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ge));
          };
          be.isReactWarning = !0, Object.defineProperty(Y, "ref", {
            get: be,
            configurable: !0
          });
        }
      }
      var Q = function(Y, ge, be, xe, je, Ze, Ie) {
        var Pe = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: Y,
          key: ge,
          ref: be,
          props: Ie,
          // Record the component responsible for creating this element.
          _owner: Ze
        };
        return Pe._store = {}, Object.defineProperty(Pe._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Pe, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: xe
        }), Object.defineProperty(Pe, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: je
        }), Object.freeze && (Object.freeze(Pe.props), Object.freeze(Pe)), Pe;
      };
      function ie(Y, ge, be, xe, je) {
        {
          var Ze, Ie = {}, Pe = null, At = null;
          be !== void 0 && (Pe = "" + be), E(ge) && (Pe = "" + ge.key), Ne(ge) && (At = ge.ref, m(ge, je));
          for (Ze in ge)
            ae.call(ge, Ze) && !ue.hasOwnProperty(Ze) && (Ie[Ze] = ge[Ze]);
          if (Y && Y.defaultProps) {
            var lt = Y.defaultProps;
            for (Ze in lt)
              Ie[Ze] === void 0 && (Ie[Ze] = lt[Ze]);
          }
          if (Pe || At) {
            var ut = typeof Y == "function" ? Y.displayName || Y.name || "Unknown" : Y;
            Pe && A(Ie, ut), At && M(Ie, ut);
          }
          return Q(Y, Pe, At, je, xe, J.current, Ie);
        }
      }
      var le = N.ReactCurrentOwner, Ee = N.ReactDebugCurrentFrame;
      function Fe(Y) {
        if (Y) {
          var ge = Y._owner, be = Ae(Y.type, Y._source, ge ? ge.type : null);
          Ee.setExtraStackFrame(be);
        } else
          Ee.setExtraStackFrame(null);
      }
      var Ve;
      Ve = !1;
      function Ge(Y) {
        return typeof Y == "object" && Y !== null && Y.$$typeof === n;
      }
      function Ue() {
        {
          if (le.current) {
            var Y = z(le.current.type);
            if (Y)
              return `

Check the render method of \`` + Y + "`.";
          }
          return "";
        }
      }
      function bl(Y) {
        {
          if (Y !== void 0) {
            var ge = Y.fileName.replace(/^.*[\\\/]/, ""), be = Y.lineNumber;
            return `

Check your code at ` + ge + ":" + be + ".";
          }
          return "";
        }
      }
      var as = {};
      function ls(Y) {
        {
          var ge = Ue();
          if (!ge) {
            var be = typeof Y == "string" ? Y : Y.displayName || Y.name;
            be && (ge = `

Check the top-level render call using <` + be + ">.");
          }
          return ge;
        }
      }
      function Bi(Y, ge) {
        {
          if (!Y._store || Y._store.validated || Y.key != null)
            return;
          Y._store.validated = !0;
          var be = ls(ge);
          if (as[be])
            return;
          as[be] = !0;
          var xe = "";
          Y && Y._owner && Y._owner !== le.current && (xe = " It was passed a child from " + z(Y._owner.type) + "."), Fe(Y), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', be, xe), Fe(null);
        }
      }
      function Li(Y, ge) {
        {
          if (typeof Y != "object")
            return;
          if (Array.isArray(Y))
            for (var be = 0; be < Y.length; be++) {
              var xe = Y[be];
              Ge(xe) && Bi(xe, ge);
            }
          else if (Ge(Y))
            Y._store && (Y._store.validated = !0);
          else if (Y) {
            var je = B(Y);
            if (typeof je == "function" && je !== Y.entries)
              for (var Ze = je.call(Y), Ie; !(Ie = Ze.next()).done; )
                Ge(Ie.value) && Bi(Ie.value, ge);
          }
        }
      }
      function cs(Y) {
        {
          var ge = Y.type;
          if (ge == null || typeof ge == "string")
            return;
          var be;
          if (typeof ge == "function")
            be = ge.propTypes;
          else if (typeof ge == "object" && (ge.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          ge.$$typeof === d))
            be = ge.propTypes;
          else
            return;
          if (be) {
            var xe = z(ge);
            D(be, Y.props, "prop", xe, Y);
          } else if (ge.PropTypes !== void 0 && !Ve) {
            Ve = !0;
            var je = z(ge);
            j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", je || "Unknown");
          }
          typeof ge.getDefaultProps == "function" && !ge.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function us(Y) {
        {
          for (var ge = Object.keys(Y.props), be = 0; be < ge.length; be++) {
            var xe = ge[be];
            if (xe !== "children" && xe !== "key") {
              Fe(Y), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", xe), Fe(null);
              break;
            }
          }
          Y.ref !== null && (Fe(Y), j("Invalid attribute `ref` supplied to `React.Fragment`."), Fe(null));
        }
      }
      function Fi(Y, ge, be, xe, je, Ze) {
        {
          var Ie = ee(Y);
          if (!Ie) {
            var Pe = "";
            (Y === void 0 || typeof Y == "object" && Y !== null && Object.keys(Y).length === 0) && (Pe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var At = bl(je);
            At ? Pe += At : Pe += Ue();
            var lt;
            Y === null ? lt = "null" : Array.isArray(Y) ? lt = "array" : Y !== void 0 && Y.$$typeof === n ? (lt = "<" + (z(Y.type) || "Unknown") + " />", Pe = " Did you accidentally export a JSX literal instead of a component?") : lt = typeof Y, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", lt, Pe);
          }
          var ut = ie(Y, ge, be, je, Ze);
          if (ut == null)
            return ut;
          if (Ie) {
            var Zt = ge.children;
            if (Zt !== void 0)
              if (xe)
                if (Array.isArray(Zt)) {
                  for (var Qr = 0; Qr < Zt.length; Qr++)
                    Li(Zt[Qr], Y);
                  Object.freeze && Object.freeze(Zt);
                } else
                  j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Li(Zt, Y);
          }
          return Y === t.Fragment ? us(ut) : cs(ut), ut;
        }
      }
      function vl(Y, ge, be) {
        return Fi(Y, ge, be, !0);
      }
      function Al(Y, ge, be) {
        return Fi(Y, ge, be, !1);
      }
      var wl = Al, ji = vl;
      t.jsx = wl, t.jsxs = ji;
    }();
  }(mc)), mc;
}
var mp;
function jg() {
  return mp || (mp = 1, function(t) {
    process.env.NODE_ENV === "production" ? t.exports = A4() : t.exports = w4();
  }(v4)), Ca;
}
var Bt = jg();
const x4 = {
  disableDefaultClasses: !1
}, _4 = /* @__PURE__ */ ve.createContext(x4);
function S4(t) {
  const {
    disableDefaultClasses: e
  } = ve.useContext(_4);
  return (r) => e ? "" : t(r);
}
function E4(t, e = []) {
  if (t === void 0)
    return {};
  const r = {};
  return Object.keys(t).filter((n) => n.match(/^on[A-Z]/) && typeof t[n] == "function" && !e.includes(n)).forEach((n) => {
    r[n] = t[n];
  }), r;
}
function k4(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function af(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
function Wg(t) {
  var e, r, n = "";
  if (typeof t == "string" || typeof t == "number")
    n += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (r = Wg(t[e])) && (n && (n += " "), n += r);
    else
      for (e in t)
        t[e] && (n && (n += " "), n += e);
  return n;
}
function yp() {
  for (var t, e, r = 0, n = ""; r < arguments.length; )
    (t = arguments[r++]) && (e = Wg(t)) && (n && (n += " "), n += e);
  return n;
}
function bp(t) {
  if (t === void 0)
    return {};
  const e = {};
  return Object.keys(t).filter((r) => !(r.match(/^on[A-Z]/) && typeof t[r] == "function")).forEach((r) => {
    e[r] = t[r];
  }), e;
}
function C4(t) {
  const {
    getSlotProps: e,
    additionalProps: r,
    externalSlotProps: n,
    externalForwardedProps: i,
    className: o
  } = t;
  if (!e) {
    const h = yp(i == null ? void 0 : i.className, n == null ? void 0 : n.className, o, r == null ? void 0 : r.className), g = Nt({}, r == null ? void 0 : r.style, i == null ? void 0 : i.style, n == null ? void 0 : n.style), p = Nt({}, r, i, n);
    return h.length > 0 && (p.className = h), Object.keys(g).length > 0 && (p.style = g), {
      props: p,
      internalRef: void 0
    };
  }
  const s = E4(Nt({}, i, n)), a = bp(n), l = bp(i), c = e(s), u = yp(c == null ? void 0 : c.className, r == null ? void 0 : r.className, o, i == null ? void 0 : i.className, n == null ? void 0 : n.className), f = Nt({}, c == null ? void 0 : c.style, r == null ? void 0 : r.style, i == null ? void 0 : i.style, n == null ? void 0 : n.style), d = Nt({}, c, r, l, a);
  return u.length > 0 && (d.className = u), Object.keys(f).length > 0 && (d.style = f), {
    props: d,
    internalRef: c.ref
  };
}
const T4 = ["elementType", "externalSlotProps", "ownerState"];
function O4(t) {
  var e;
  const {
    elementType: r,
    externalSlotProps: n,
    ownerState: i
  } = t, o = af(t, T4), s = k4(n, i), {
    props: a,
    internalRef: l
  } = C4(Nt({}, o, {
    externalSlotProps: s
  })), c = Yn(l, s == null ? void 0 : s.ref, (e = t.additionalProps) == null ? void 0 : e.ref);
  return co(r, Nt({}, a, {
    ref: c
  }), i);
}
var Ut = "top", or = "bottom", sr = "right", zt = "left", $a = "auto", es = [Ut, or, sr, zt], Ti = "start", Wo = "end", I4 = "clippingParents", Ug = "viewport", Qi = "popper", P4 = "reference", vp = /* @__PURE__ */ es.reduce(function(t, e) {
  return t.concat([e + "-" + Ti, e + "-" + Wo]);
}, []), zg = /* @__PURE__ */ [].concat(es, [$a]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Ti, e + "-" + Wo]);
}, []), R4 = "beforeRead", D4 = "read", M4 = "afterRead", N4 = "beforeMain", B4 = "main", L4 = "afterMain", F4 = "beforeWrite", j4 = "write", W4 = "afterWrite", nu = [R4, D4, M4, N4, B4, L4, F4, j4, W4];
function Tr(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Qt(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Kn(t) {
  var e = Qt(t).Element;
  return t instanceof e || t instanceof Element;
}
function Xt(t) {
  var e = Qt(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function lf(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Qt(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function U4(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var n = e.styles[r] || {}, i = e.attributes[r] || {}, o = e.elements[r];
    !Xt(o) || !Tr(o) || (Object.assign(o.style, n), Object.keys(i).forEach(function(s) {
      var a = i[s];
      a === !1 ? o.removeAttribute(s) : o.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function z4(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(n) {
      var i = e.elements[n], o = e.attributes[n] || {}, s = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : r[n]), a = s.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Xt(i) || !Tr(i) || (Object.assign(i.style, a), Object.keys(o).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const V4 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: U4,
  effect: z4,
  requires: ["computeStyles"]
};
function mr(t) {
  return t.split("-")[0];
}
var jn = Math.max, Ta = Math.min, Oi = Math.round;
function iu() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Vg() {
  return !/^((?!chrome|android).)*safari/i.test(iu());
}
function Ii(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  var n = t.getBoundingClientRect(), i = 1, o = 1;
  e && Xt(t) && (i = t.offsetWidth > 0 && Oi(n.width) / t.offsetWidth || 1, o = t.offsetHeight > 0 && Oi(n.height) / t.offsetHeight || 1);
  var s = Kn(t) ? Qt(t) : window, a = s.visualViewport, l = !Vg() && r, c = (n.left + (l && a ? a.offsetLeft : 0)) / i, u = (n.top + (l && a ? a.offsetTop : 0)) / o, f = n.width / i, d = n.height / o;
  return {
    width: f,
    height: d,
    top: u,
    right: c + f,
    bottom: u + d,
    left: c,
    x: c,
    y: u
  };
}
function cf(t) {
  var e = Ii(t), r = t.offsetWidth, n = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: n
  };
}
function qg(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && lf(r)) {
    var n = e;
    do {
      if (n && t.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function yr(t) {
  return Qt(t).getComputedStyle(t);
}
function q4(t) {
  return ["table", "td", "th"].indexOf(Tr(t)) >= 0;
}
function An(t) {
  return ((Kn(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function el(t) {
  return Tr(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (lf(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    An(t)
  );
}
function Ap(t) {
  return !Xt(t) || // https://github.com/popperjs/popper-core/issues/837
  yr(t).position === "fixed" ? null : t.offsetParent;
}
function H4(t) {
  var e = /firefox/i.test(iu()), r = /Trident/i.test(iu());
  if (r && Xt(t)) {
    var n = yr(t);
    if (n.position === "fixed")
      return null;
  }
  var i = el(t);
  for (lf(i) && (i = i.host); Xt(i) && ["html", "body"].indexOf(Tr(i)) < 0; ) {
    var o = yr(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function ts(t) {
  for (var e = Qt(t), r = Ap(t); r && q4(r) && yr(r).position === "static"; )
    r = Ap(r);
  return r && (Tr(r) === "html" || Tr(r) === "body" && yr(r).position === "static") ? e : r || H4(t) || e;
}
function uf(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Ao(t, e, r) {
  return jn(t, Ta(e, r));
}
function Y4(t, e, r) {
  var n = Ao(t, e, r);
  return n > r ? r : n;
}
function Hg() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Yg(t) {
  return Object.assign({}, Hg(), t);
}
function Kg(t, e) {
  return e.reduce(function(r, n) {
    return r[n] = t, r;
  }, {});
}
var K4 = function(e, r) {
  return e = typeof e == "function" ? e(Object.assign({}, r.rects, {
    placement: r.placement
  })) : e, Yg(typeof e != "number" ? e : Kg(e, es));
};
function X4(t) {
  var e, r = t.state, n = t.name, i = t.options, o = r.elements.arrow, s = r.modifiersData.popperOffsets, a = mr(r.placement), l = uf(a), c = [zt, sr].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!o || !s)) {
    var f = K4(i.padding, r), d = cf(o), h = l === "y" ? Ut : zt, g = l === "y" ? or : sr, p = r.rects.reference[u] + r.rects.reference[l] - s[l] - r.rects.popper[u], y = s[l] - r.rects.reference[l], b = ts(o), x = b ? l === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, S = p / 2 - y / 2, O = f[h], _ = x - d[u] - f[g], B = x / 2 - d[u] / 2 + S, N = Ao(O, B, _), j = l;
    r.modifiersData[n] = (e = {}, e[j] = N, e.centerOffset = N - B, e);
  }
}
function J4(t) {
  var e = t.state, r = t.options, n = r.element, i = n === void 0 ? "[data-popper-arrow]" : n;
  if (i != null && !(typeof i == "string" && (i = e.elements.popper.querySelector(i), !i))) {
    if (process.env.NODE_ENV !== "production" && (Xt(i) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !qg(e.elements.popper, i)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    e.elements.arrow = i;
  }
}
const Q4 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: X4,
  effect: J4,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Pi(t) {
  return t.split("-")[1];
}
var G4 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Z4(t, e) {
  var r = t.x, n = t.y, i = e.devicePixelRatio || 1;
  return {
    x: Oi(r * i) / i || 0,
    y: Oi(n * i) / i || 0
  };
}
function wp(t) {
  var e, r = t.popper, n = t.popperRect, i = t.placement, o = t.variation, s = t.offsets, a = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, f = t.isFixed, d = s.x, h = d === void 0 ? 0 : d, g = s.y, p = g === void 0 ? 0 : g, y = typeof u == "function" ? u({
    x: h,
    y: p
  }) : {
    x: h,
    y: p
  };
  h = y.x, p = y.y;
  var b = s.hasOwnProperty("x"), x = s.hasOwnProperty("y"), S = zt, O = Ut, _ = window;
  if (c) {
    var B = ts(r), N = "clientHeight", j = "clientWidth";
    if (B === Qt(r) && (B = An(r), yr(B).position !== "static" && a === "absolute" && (N = "scrollHeight", j = "scrollWidth")), B = B, i === Ut || (i === zt || i === sr) && o === Wo) {
      O = or;
      var W = f && B === _ && _.visualViewport ? _.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        B[N]
      );
      p -= W - n.height, p *= l ? 1 : -1;
    }
    if (i === zt || (i === Ut || i === or) && o === Wo) {
      S = sr;
      var G = f && B === _ && _.visualViewport ? _.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        B[j]
      );
      h -= G - n.width, h *= l ? 1 : -1;
    }
  }
  var ee = Object.assign({
    position: a
  }, c && G4), fe = u === !0 ? Z4({
    x: h,
    y: p
  }, Qt(r)) : {
    x: h,
    y: p
  };
  if (h = fe.x, p = fe.y, l) {
    var P;
    return Object.assign({}, ee, (P = {}, P[O] = x ? "0" : "", P[S] = b ? "0" : "", P.transform = (_.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + p + "px)" : "translate3d(" + h + "px, " + p + "px, 0)", P));
  }
  return Object.assign({}, ee, (e = {}, e[O] = x ? p + "px" : "", e[S] = b ? h + "px" : "", e.transform = "", e));
}
function $4(t) {
  var e = t.state, r = t.options, n = r.gpuAcceleration, i = n === void 0 ? !0 : n, o = r.adaptive, s = o === void 0 ? !0 : o, a = r.roundOffsets, l = a === void 0 ? !0 : a;
  if (process.env.NODE_ENV !== "production") {
    var c = yr(e.elements.popper).transitionProperty || "";
    s && ["transform", "top", "right", "bottom", "left"].some(function(f) {
      return c.indexOf(f) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var u = {
    placement: mr(e.placement),
    variation: Pi(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: i,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, wp(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, wp(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const ex = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: $4,
  data: {}
};
var Ds = {
  passive: !0
};
function tx(t) {
  var e = t.state, r = t.instance, n = t.options, i = n.scroll, o = i === void 0 ? !0 : i, s = n.resize, a = s === void 0 ? !0 : s, l = Qt(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return o && c.forEach(function(u) {
    u.addEventListener("scroll", r.update, Ds);
  }), a && l.addEventListener("resize", r.update, Ds), function() {
    o && c.forEach(function(u) {
      u.removeEventListener("scroll", r.update, Ds);
    }), a && l.removeEventListener("resize", r.update, Ds);
  };
}
const rx = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: tx,
  data: {}
};
var nx = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Zs(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return nx[e];
  });
}
var ix = {
  start: "end",
  end: "start"
};
function xp(t) {
  return t.replace(/start|end/g, function(e) {
    return ix[e];
  });
}
function ff(t) {
  var e = Qt(t), r = e.pageXOffset, n = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function df(t) {
  return Ii(An(t)).left + ff(t).scrollLeft;
}
function ox(t, e) {
  var r = Qt(t), n = An(t), i = r.visualViewport, o = n.clientWidth, s = n.clientHeight, a = 0, l = 0;
  if (i) {
    o = i.width, s = i.height;
    var c = Vg();
    (c || !c && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a + df(t),
    y: l
  };
}
function sx(t) {
  var e, r = An(t), n = ff(t), i = (e = t.ownerDocument) == null ? void 0 : e.body, o = jn(r.scrollWidth, r.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = jn(r.scrollHeight, r.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -n.scrollLeft + df(t), l = -n.scrollTop;
  return yr(i || r).direction === "rtl" && (a += jn(r.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: a,
    y: l
  };
}
function hf(t) {
  var e = yr(t), r = e.overflow, n = e.overflowX, i = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + i + n);
}
function Xg(t) {
  return ["html", "body", "#document"].indexOf(Tr(t)) >= 0 ? t.ownerDocument.body : Xt(t) && hf(t) ? t : Xg(el(t));
}
function wo(t, e) {
  var r;
  e === void 0 && (e = []);
  var n = Xg(t), i = n === ((r = t.ownerDocument) == null ? void 0 : r.body), o = Qt(n), s = i ? [o].concat(o.visualViewport || [], hf(n) ? n : []) : n, a = e.concat(s);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(wo(el(s)))
  );
}
function ou(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function ax(t, e) {
  var r = Ii(t, !1, e === "fixed");
  return r.top = r.top + t.clientTop, r.left = r.left + t.clientLeft, r.bottom = r.top + t.clientHeight, r.right = r.left + t.clientWidth, r.width = t.clientWidth, r.height = t.clientHeight, r.x = r.left, r.y = r.top, r;
}
function _p(t, e, r) {
  return e === Ug ? ou(ox(t, r)) : Kn(e) ? ax(e, r) : ou(sx(An(t)));
}
function lx(t) {
  var e = wo(el(t)), r = ["absolute", "fixed"].indexOf(yr(t).position) >= 0, n = r && Xt(t) ? ts(t) : t;
  return Kn(n) ? e.filter(function(i) {
    return Kn(i) && qg(i, n) && Tr(i) !== "body";
  }) : [];
}
function cx(t, e, r, n) {
  var i = e === "clippingParents" ? lx(t) : [].concat(e), o = [].concat(i, [r]), s = o[0], a = o.reduce(function(l, c) {
    var u = _p(t, c, n);
    return l.top = jn(u.top, l.top), l.right = Ta(u.right, l.right), l.bottom = Ta(u.bottom, l.bottom), l.left = jn(u.left, l.left), l;
  }, _p(t, s, n));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Jg(t) {
  var e = t.reference, r = t.element, n = t.placement, i = n ? mr(n) : null, o = n ? Pi(n) : null, s = e.x + e.width / 2 - r.width / 2, a = e.y + e.height / 2 - r.height / 2, l;
  switch (i) {
    case Ut:
      l = {
        x: s,
        y: e.y - r.height
      };
      break;
    case or:
      l = {
        x: s,
        y: e.y + e.height
      };
      break;
    case sr:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case zt:
      l = {
        x: e.x - r.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = i ? uf(i) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (o) {
      case Ti:
        l[c] = l[c] - (e[u] / 2 - r[u] / 2);
        break;
      case Wo:
        l[c] = l[c] + (e[u] / 2 - r[u] / 2);
        break;
    }
  }
  return l;
}
function Uo(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, i = n === void 0 ? t.placement : n, o = r.strategy, s = o === void 0 ? t.strategy : o, a = r.boundary, l = a === void 0 ? I4 : a, c = r.rootBoundary, u = c === void 0 ? Ug : c, f = r.elementContext, d = f === void 0 ? Qi : f, h = r.altBoundary, g = h === void 0 ? !1 : h, p = r.padding, y = p === void 0 ? 0 : p, b = Yg(typeof y != "number" ? y : Kg(y, es)), x = d === Qi ? P4 : Qi, S = t.rects.popper, O = t.elements[g ? x : d], _ = cx(Kn(O) ? O : O.contextElement || An(t.elements.popper), l, u, s), B = Ii(t.elements.reference), N = Jg({
    reference: B,
    element: S,
    strategy: "absolute",
    placement: i
  }), j = ou(Object.assign({}, S, N)), W = d === Qi ? j : B, G = {
    top: _.top - W.top + b.top,
    bottom: W.bottom - _.bottom + b.bottom,
    left: _.left - W.left + b.left,
    right: W.right - _.right + b.right
  }, ee = t.modifiersData.offset;
  if (d === Qi && ee) {
    var fe = ee[i];
    Object.keys(G).forEach(function(P) {
      var z = [sr, or].indexOf(P) >= 0 ? 1 : -1, U = [Ut, or].indexOf(P) >= 0 ? "y" : "x";
      G[P] += fe[U] * z;
    });
  }
  return G;
}
function ux(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, i = r.boundary, o = r.rootBoundary, s = r.padding, a = r.flipVariations, l = r.allowedAutoPlacements, c = l === void 0 ? zg : l, u = Pi(n), f = u ? a ? vp : vp.filter(function(g) {
    return Pi(g) === u;
  }) : es, d = f.filter(function(g) {
    return c.indexOf(g) >= 0;
  });
  d.length === 0 && (d = f, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var h = d.reduce(function(g, p) {
    return g[p] = Uo(t, {
      placement: p,
      boundary: i,
      rootBoundary: o,
      padding: s
    })[mr(p)], g;
  }, {});
  return Object.keys(h).sort(function(g, p) {
    return h[g] - h[p];
  });
}
function fx(t) {
  if (mr(t) === $a)
    return [];
  var e = Zs(t);
  return [xp(t), e, xp(e)];
}
function dx(t) {
  var e = t.state, r = t.options, n = t.name;
  if (!e.modifiersData[n]._skip) {
    for (var i = r.mainAxis, o = i === void 0 ? !0 : i, s = r.altAxis, a = s === void 0 ? !0 : s, l = r.fallbackPlacements, c = r.padding, u = r.boundary, f = r.rootBoundary, d = r.altBoundary, h = r.flipVariations, g = h === void 0 ? !0 : h, p = r.allowedAutoPlacements, y = e.options.placement, b = mr(y), x = b === y, S = l || (x || !g ? [Zs(y)] : fx(y)), O = [y].concat(S).reduce(function(pe, me) {
      return pe.concat(mr(me) === $a ? ux(e, {
        placement: me,
        boundary: u,
        rootBoundary: f,
        padding: c,
        flipVariations: g,
        allowedAutoPlacements: p
      }) : me);
    }, []), _ = e.rects.reference, B = e.rects.popper, N = /* @__PURE__ */ new Map(), j = !0, W = O[0], G = 0; G < O.length; G++) {
      var ee = O[G], fe = mr(ee), P = Pi(ee) === Ti, z = [Ut, or].indexOf(fe) >= 0, U = z ? "width" : "height", I = Uo(e, {
        placement: ee,
        boundary: u,
        rootBoundary: f,
        altBoundary: d,
        padding: c
      }), V = z ? P ? sr : zt : P ? or : Ut;
      _[U] > B[U] && (V = Zs(V));
      var te = Zs(V), X = [];
      if (o && X.push(I[fe] <= 0), a && X.push(I[V] <= 0, I[te] <= 0), X.every(function(pe) {
        return pe;
      })) {
        W = ee, j = !1;
        break;
      }
      N.set(ee, X);
    }
    if (j)
      for (var H = g ? 3 : 1, $ = function(me) {
        var L = O.find(function(q) {
          var Z = N.get(q);
          if (Z)
            return Z.slice(0, me).every(function(oe) {
              return oe;
            });
        });
        if (L)
          return W = L, "break";
      }, se = H; se > 0; se--) {
        var he = $(se);
        if (he === "break")
          break;
      }
    e.placement !== W && (e.modifiersData[n]._skip = !0, e.placement = W, e.reset = !0);
  }
}
const hx = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: dx,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Sp(t, e, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - r.y,
    right: t.right - e.width + r.x,
    bottom: t.bottom - e.height + r.y,
    left: t.left - e.width - r.x
  };
}
function Ep(t) {
  return [Ut, sr, or, zt].some(function(e) {
    return t[e] >= 0;
  });
}
function px(t) {
  var e = t.state, r = t.name, n = e.rects.reference, i = e.rects.popper, o = e.modifiersData.preventOverflow, s = Uo(e, {
    elementContext: "reference"
  }), a = Uo(e, {
    altBoundary: !0
  }), l = Sp(s, n), c = Sp(a, i, o), u = Ep(l), f = Ep(c);
  e.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const gx = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: px
};
function mx(t, e, r) {
  var n = mr(t), i = [zt, Ut].indexOf(n) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, s = o[0], a = o[1];
  return s = s || 0, a = (a || 0) * i, [zt, sr].indexOf(n) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function yx(t) {
  var e = t.state, r = t.options, n = t.name, i = r.offset, o = i === void 0 ? [0, 0] : i, s = zg.reduce(function(u, f) {
    return u[f] = mx(f, e.rects, o), u;
  }, {}), a = s[e.placement], l = a.x, c = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[n] = s;
}
const bx = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: yx
};
function vx(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = Jg({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const Ax = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: vx,
  data: {}
};
function wx(t) {
  return t === "x" ? "y" : "x";
}
function xx(t) {
  var e = t.state, r = t.options, n = t.name, i = r.mainAxis, o = i === void 0 ? !0 : i, s = r.altAxis, a = s === void 0 ? !1 : s, l = r.boundary, c = r.rootBoundary, u = r.altBoundary, f = r.padding, d = r.tether, h = d === void 0 ? !0 : d, g = r.tetherOffset, p = g === void 0 ? 0 : g, y = Uo(e, {
    boundary: l,
    rootBoundary: c,
    padding: f,
    altBoundary: u
  }), b = mr(e.placement), x = Pi(e.placement), S = !x, O = uf(b), _ = wx(O), B = e.modifiersData.popperOffsets, N = e.rects.reference, j = e.rects.popper, W = typeof p == "function" ? p(Object.assign({}, e.rects, {
    placement: e.placement
  })) : p, G = typeof W == "number" ? {
    mainAxis: W,
    altAxis: W
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, W), ee = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, fe = {
    x: 0,
    y: 0
  };
  if (B) {
    if (o) {
      var P, z = O === "y" ? Ut : zt, U = O === "y" ? or : sr, I = O === "y" ? "height" : "width", V = B[O], te = V + y[z], X = V - y[U], H = h ? -j[I] / 2 : 0, $ = x === Ti ? N[I] : j[I], se = x === Ti ? -j[I] : -N[I], he = e.elements.arrow, pe = h && he ? cf(he) : {
        width: 0,
        height: 0
      }, me = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Hg(), L = me[z], q = me[U], Z = Ao(0, N[I], pe[I]), oe = S ? N[I] / 2 - H - Z - L - G.mainAxis : $ - Z - L - G.mainAxis, de = S ? -N[I] / 2 + H + Z + q + G.mainAxis : se + Z + q + G.mainAxis, R = e.elements.arrow && ts(e.elements.arrow), k = R ? O === "y" ? R.clientTop || 0 : R.clientLeft || 0 : 0, re = (P = ee == null ? void 0 : ee[O]) != null ? P : 0, ne = V + oe - re - k, Ae = V + de - re, C = Ao(h ? Ta(te, ne) : te, V, h ? jn(X, Ae) : X);
      B[O] = C, fe[O] = C - V;
    }
    if (a) {
      var v, w = O === "x" ? Ut : zt, D = O === "x" ? or : sr, J = B[_], ae = _ === "y" ? "height" : "width", ue = J + y[w], Se = J - y[D], _e = [Ut, zt].indexOf(b) !== -1, we = (v = ee == null ? void 0 : ee[_]) != null ? v : 0, Ne = _e ? ue : J - N[ae] - j[ae] - we + G.altAxis, E = _e ? J + N[ae] + j[ae] - we - G.altAxis : Se, m = h && _e ? Y4(Ne, J, E) : Ao(h ? Ne : ue, J, h ? E : Se);
      B[_] = m, fe[_] = m - J;
    }
    e.modifiersData[n] = fe;
  }
}
const _x = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: xx,
  requiresIfExists: ["offset"]
};
function Sx(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Ex(t) {
  return t === Qt(t) || !Xt(t) ? ff(t) : Sx(t);
}
function kx(t) {
  var e = t.getBoundingClientRect(), r = Oi(e.width) / t.offsetWidth || 1, n = Oi(e.height) / t.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Cx(t, e, r) {
  r === void 0 && (r = !1);
  var n = Xt(e), i = Xt(e) && kx(e), o = An(e), s = Ii(t, i, r), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Tr(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  hf(o)) && (a = Ex(e)), Xt(e) ? (l = Ii(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : o && (l.x = df(o))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function Tx(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  t.forEach(function(o) {
    e.set(o.name, o);
  });
  function i(o) {
    r.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(a) {
      if (!r.has(a)) {
        var l = e.get(a);
        l && i(l);
      }
    }), n.push(o);
  }
  return t.forEach(function(o) {
    r.has(o.name) || i(o);
  }), n;
}
function Ox(t) {
  var e = Tx(t);
  return nu.reduce(function(r, n) {
    return r.concat(e.filter(function(i) {
      return i.phase === n;
    }));
  }, []);
}
function Ix(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function Gr(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    r[n - 1] = arguments[n];
  return [].concat(r).reduce(function(i, o) {
    return i.replace(/%s/, o);
  }, t);
}
var Tn = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', Px = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', kp = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function Rx(t) {
  t.forEach(function(e) {
    [].concat(Object.keys(e), kp).filter(function(r, n, i) {
      return i.indexOf(r) === n;
    }).forEach(function(r) {
      switch (r) {
        case "name":
          typeof e.name != "string" && console.error(Gr(Tn, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
          break;
        case "enabled":
          typeof e.enabled != "boolean" && console.error(Gr(Tn, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));
          break;
        case "phase":
          nu.indexOf(e.phase) < 0 && console.error(Gr(Tn, e.name, '"phase"', "either " + nu.join(", "), '"' + String(e.phase) + '"'));
          break;
        case "fn":
          typeof e.fn != "function" && console.error(Gr(Tn, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "effect":
          e.effect != null && typeof e.effect != "function" && console.error(Gr(Tn, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "requires":
          e.requires != null && !Array.isArray(e.requires) && console.error(Gr(Tn, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(e.requiresIfExists) || console.error(Gr(Tn, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + kp.map(function(n) {
            return '"' + n + '"';
          }).join(", ") + '; but "' + r + '" was provided.');
      }
      e.requires && e.requires.forEach(function(n) {
        t.find(function(i) {
          return i.name === n;
        }) == null && console.error(Gr(Px, String(e.name), n, n));
      });
    });
  });
}
function Dx(t, e) {
  var r = /* @__PURE__ */ new Set();
  return t.filter(function(n) {
    var i = e(n);
    if (!r.has(i))
      return r.add(i), !0;
  });
}
function Mx(t) {
  var e = t.reduce(function(r, n) {
    var i = r[n.name];
    return r[n.name] = i ? Object.assign({}, i, n, {
      options: Object.assign({}, i.options, n.options),
      data: Object.assign({}, i.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
var Cp = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", Nx = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", Tp = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Op() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Bx(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, n = r === void 0 ? [] : r, i = e.defaultOptions, o = i === void 0 ? Tp : i;
  return function(a, l, c) {
    c === void 0 && (c = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Tp, o),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], d = !1, h = {
      state: u,
      setOptions: function(b) {
        var x = typeof b == "function" ? b(u.options) : b;
        p(), u.options = Object.assign({}, o, u.options, x), u.scrollParents = {
          reference: Kn(a) ? wo(a) : a.contextElement ? wo(a.contextElement) : [],
          popper: wo(l)
        };
        var S = Ox(Mx([].concat(n, u.options.modifiers)));
        if (u.orderedModifiers = S.filter(function(ee) {
          return ee.enabled;
        }), process.env.NODE_ENV !== "production") {
          var O = Dx([].concat(S, u.options.modifiers), function(ee) {
            var fe = ee.name;
            return fe;
          });
          if (Rx(O), mr(u.options.placement) === $a) {
            var _ = u.orderedModifiers.find(function(ee) {
              var fe = ee.name;
              return fe === "flip";
            });
            _ || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var B = yr(l), N = B.marginTop, j = B.marginRight, W = B.marginBottom, G = B.marginLeft;
          [N, j, W, G].some(function(ee) {
            return parseFloat(ee);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return g(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var b = u.elements, x = b.reference, S = b.popper;
          if (!Op(x, S)) {
            process.env.NODE_ENV !== "production" && console.error(Cp);
            return;
          }
          u.rects = {
            reference: Cx(x, ts(S), u.options.strategy === "fixed"),
            popper: cf(S)
          }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(ee) {
            return u.modifiersData[ee.name] = Object.assign({}, ee.data);
          });
          for (var O = 0, _ = 0; _ < u.orderedModifiers.length; _++) {
            if (process.env.NODE_ENV !== "production" && (O += 1, O > 100)) {
              console.error(Nx);
              break;
            }
            if (u.reset === !0) {
              u.reset = !1, _ = -1;
              continue;
            }
            var B = u.orderedModifiers[_], N = B.fn, j = B.options, W = j === void 0 ? {} : j, G = B.name;
            typeof N == "function" && (u = N({
              state: u,
              options: W,
              name: G,
              instance: h
            }) || u);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Ix(function() {
        return new Promise(function(y) {
          h.forceUpdate(), y(u);
        });
      }),
      destroy: function() {
        p(), d = !0;
      }
    };
    if (!Op(a, l))
      return process.env.NODE_ENV !== "production" && console.error(Cp), h;
    h.setOptions(c).then(function(y) {
      !d && c.onFirstUpdate && c.onFirstUpdate(y);
    });
    function g() {
      u.orderedModifiers.forEach(function(y) {
        var b = y.name, x = y.options, S = x === void 0 ? {} : x, O = y.effect;
        if (typeof O == "function") {
          var _ = O({
            state: u,
            name: b,
            instance: h,
            options: S
          }), B = function() {
          };
          f.push(_ || B);
        }
      });
    }
    function p() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return h;
  };
}
var Lx = [rx, Ax, ex, V4, bx, hx, _x, Q4, gx], Fx = /* @__PURE__ */ Bx({
  defaultModifiers: Lx
});
function jx(t) {
  return typeof t == "function" ? t() : t;
}
const Oa = /* @__PURE__ */ ve.forwardRef(function(e, r) {
  const {
    children: n,
    container: i,
    disablePortal: o = !1
  } = e, [s, a] = ve.useState(null), l = Yn(/* @__PURE__ */ ve.isValidElement(n) ? n.ref : null, r);
  if (Ci(() => {
    o || a(jx(i) || document.body);
  }, [i, o]), Ci(() => {
    if (s && !o)
      return ka(r, s), () => {
        ka(r, null);
      };
  }, [r, s, o]), o) {
    if (/* @__PURE__ */ ve.isValidElement(n)) {
      const c = {
        ref: l
      };
      return /* @__PURE__ */ ve.cloneElement(n, c);
    }
    return /* @__PURE__ */ Bt.jsx(ve.Fragment, {
      children: n
    });
  }
  return /* @__PURE__ */ Bt.jsx(ve.Fragment, {
    children: s && /* @__PURE__ */ Xm.createPortal(n, s)
  });
});
process.env.NODE_ENV !== "production" && (Oa.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The children to render into the `container`.
   */
  children: F.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: F.oneOfType([jo, F.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: F.bool
});
process.env.NODE_ENV !== "production" && (Oa["propTypes"] = Yw(Oa.propTypes));
const Wx = Oa;
function Ux(t) {
  return $o("MuiPopper", t);
}
sf("MuiPopper", ["root"]);
const zx = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], Vx = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function qx(t, e) {
  if (e === "ltr")
    return t;
  switch (t) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return t;
  }
}
function Ia(t) {
  return typeof t == "function" ? t() : t;
}
function tl(t) {
  return t.nodeType !== void 0;
}
function Hx(t) {
  return !tl(t);
}
const Yx = () => of({
  root: ["root"]
}, S4(Ux)), Kx = {}, Xx = /* @__PURE__ */ ve.forwardRef(function(e, r) {
  var n;
  const {
    anchorEl: i,
    children: o,
    direction: s,
    disablePortal: a,
    modifiers: l,
    open: c,
    placement: u,
    popperOptions: f,
    popperRef: d,
    slotProps: h = {},
    slots: g = {},
    TransitionProps: p
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = e, y = af(e, zx), b = ve.useRef(null), x = Yn(b, r), S = ve.useRef(null), O = Yn(S, d), _ = ve.useRef(O);
  Ci(() => {
    _.current = O;
  }, [O]), ve.useImperativeHandle(d, () => S.current, []);
  const B = qx(u, s), [N, j] = ve.useState(B), [W, G] = ve.useState(Ia(i));
  ve.useEffect(() => {
    S.current && S.current.forceUpdate();
  }), ve.useEffect(() => {
    i && G(Ia(i));
  }, [i]), Ci(() => {
    if (!W || !c)
      return;
    const U = (te) => {
      j(te.placement);
    };
    if (process.env.NODE_ENV !== "production" && W && tl(W) && W.nodeType === 1) {
      const te = W.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && te.top === 0 && te.left === 0 && te.right === 0 && te.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let I = [{
      name: "preventOverflow",
      options: {
        altBoundary: a
      }
    }, {
      name: "flip",
      options: {
        altBoundary: a
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: te
      }) => {
        U(te);
      }
    }];
    l != null && (I = I.concat(l)), f && f.modifiers != null && (I = I.concat(f.modifiers));
    const V = Fx(W, b.current, Nt({
      placement: B
    }, f, {
      modifiers: I
    }));
    return _.current(V), () => {
      V.destroy(), _.current(null);
    };
  }, [W, a, l, c, f, B]);
  const ee = {
    placement: N
  };
  p !== null && (ee.TransitionProps = p);
  const fe = Yx(), P = (n = g.root) != null ? n : "div", z = O4({
    elementType: P,
    externalSlotProps: h.root,
    externalForwardedProps: y,
    additionalProps: {
      role: "tooltip",
      ref: x
    },
    ownerState: e,
    className: fe.root
  });
  return /* @__PURE__ */ Bt.jsx(P, Nt({}, z, {
    children: typeof o == "function" ? o(ee) : o
  }));
}), Qg = /* @__PURE__ */ ve.forwardRef(function(e, r) {
  const {
    anchorEl: n,
    children: i,
    container: o,
    direction: s = "ltr",
    disablePortal: a = !1,
    keepMounted: l = !1,
    modifiers: c,
    open: u,
    placement: f = "bottom",
    popperOptions: d = Kx,
    popperRef: h,
    style: g,
    transition: p = !1,
    slotProps: y = {},
    slots: b = {}
  } = e, x = af(e, Vx), [S, O] = ve.useState(!0), _ = () => {
    O(!1);
  }, B = () => {
    O(!0);
  };
  if (!l && !u && (!p || S))
    return null;
  let N;
  if (o)
    N = o;
  else if (n) {
    const G = Ia(n);
    N = G && tl(G) ? Ea(G).body : Ea(null).body;
  }
  const j = !u && l && (!p || S) ? "none" : void 0, W = p ? {
    in: u,
    onEnter: _,
    onExited: B
  } : void 0;
  return /* @__PURE__ */ Bt.jsx(Wx, {
    disablePortal: a,
    container: N,
    children: /* @__PURE__ */ Bt.jsx(Xx, Nt({
      anchorEl: n,
      direction: s,
      disablePortal: a,
      modifiers: c,
      ref: r,
      open: p ? !S : u,
      placement: f,
      popperOptions: d,
      popperRef: h,
      slotProps: y,
      slots: b
    }, x, {
      style: Nt({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: j
      }, g),
      TransitionProps: W,
      children: i
    }))
  });
});
process.env.NODE_ENV !== "production" && (Qg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: nf(F.oneOfType([jo, F.object, F.func]), (t) => {
    if (t.open) {
      const e = Ia(t.anchorEl);
      if (e && tl(e) && e.nodeType === 1) {
        const r = e.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!e || typeof e.getBoundingClientRect != "function" || Hx(e) && e.contextElement != null && e.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: F.oneOfType([F.node, F.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: F.oneOfType([jo, F.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: F.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: F.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: F.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: F.arrayOf(F.shape({
    data: F.object,
    effect: F.func,
    enabled: F.bool,
    fn: F.func,
    name: F.any,
    options: F.object,
    phase: F.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: F.arrayOf(F.string),
    requiresIfExists: F.arrayOf(F.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: F.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: F.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: F.shape({
    modifiers: F.array,
    onFirstUpdate: F.func,
    placement: F.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: F.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Rg,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: F.shape({
    root: F.oneOfType([F.func, F.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: F.shape({
    root: F.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: F.bool
});
const Jx = Qg;
function su() {
  return su = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, su.apply(this, arguments);
}
function Qx(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return e[r] === void 0 && (e[r] = t(r)), e[r];
  };
}
var Gx = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Zx = /* @__PURE__ */ Qx(
  function(t) {
    return Gx.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function $x(t) {
  if (t.sheet)
    return t.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === t)
      return document.styleSheets[e];
}
function e_(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var t_ = /* @__PURE__ */ function() {
  function t(r) {
    var n = this;
    this._insertTag = function(i) {
      var o;
      n.tags.length === 0 ? n.insertionPoint ? o = n.insertionPoint.nextSibling : n.prepend ? o = n.container.firstChild : o = n.before : o = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(i, o), n.tags.push(i);
    }, this.isSpeedy = r.speedy === void 0 ? process.env.NODE_ENV === "production" : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, e.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(e_(this));
    var i = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var o = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      o && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !o;
    }
    if (this.isSpeedy) {
      var s = $x(i);
      try {
        s.insertRule(n, s.cssRules.length);
      } catch (a) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', a);
      }
    } else
      i.appendChild(document.createTextNode(n));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, t;
}(), Ot = "-ms-", Pa = "-moz-", qe = "-webkit-", pf = "comm", gf = "rule", mf = "decl", r_ = "@import", Gg = "@keyframes", n_ = "@layer", i_ = Math.abs, rl = String.fromCharCode, o_ = Object.assign;
function s_(t, e) {
  return Ct(t, 0) ^ 45 ? (((e << 2 ^ Ct(t, 0)) << 2 ^ Ct(t, 1)) << 2 ^ Ct(t, 2)) << 2 ^ Ct(t, 3) : 0;
}
function Zg(t) {
  return t.trim();
}
function a_(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function He(t, e, r) {
  return t.replace(e, r);
}
function au(t, e) {
  return t.indexOf(e);
}
function Ct(t, e) {
  return t.charCodeAt(e) | 0;
}
function zo(t, e, r) {
  return t.slice(e, r);
}
function wr(t) {
  return t.length;
}
function yf(t) {
  return t.length;
}
function Ms(t, e) {
  return e.push(t), t;
}
function l_(t, e) {
  return t.map(e).join("");
}
var nl = 1, Ri = 1, $g = 0, Vt = 0, bt = 0, Ni = "";
function il(t, e, r, n, i, o, s) {
  return { value: t, root: e, parent: r, type: n, props: i, children: o, line: nl, column: Ri, length: s, return: "" };
}
function Gi(t, e) {
  return o_(il("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function c_() {
  return bt;
}
function u_() {
  return bt = Vt > 0 ? Ct(Ni, --Vt) : 0, Ri--, bt === 10 && (Ri = 1, nl--), bt;
}
function Jt() {
  return bt = Vt < $g ? Ct(Ni, Vt++) : 0, Ri++, bt === 10 && (Ri = 1, nl++), bt;
}
function Cr() {
  return Ct(Ni, Vt);
}
function $s() {
  return Vt;
}
function rs(t, e) {
  return zo(Ni, t, e);
}
function Vo(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function em(t) {
  return nl = Ri = 1, $g = wr(Ni = t), Vt = 0, [];
}
function tm(t) {
  return Ni = "", t;
}
function ea(t) {
  return Zg(rs(Vt - 1, lu(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function f_(t) {
  for (; (bt = Cr()) && bt < 33; )
    Jt();
  return Vo(t) > 2 || Vo(bt) > 3 ? "" : " ";
}
function d_(t, e) {
  for (; --e && Jt() && !(bt < 48 || bt > 102 || bt > 57 && bt < 65 || bt > 70 && bt < 97); )
    ;
  return rs(t, $s() + (e < 6 && Cr() == 32 && Jt() == 32));
}
function lu(t) {
  for (; Jt(); )
    switch (bt) {
      case t:
        return Vt;
      case 34:
      case 39:
        t !== 34 && t !== 39 && lu(bt);
        break;
      case 40:
        t === 41 && lu(t);
        break;
      case 92:
        Jt();
        break;
    }
  return Vt;
}
function h_(t, e) {
  for (; Jt() && t + bt !== 47 + 10; )
    if (t + bt === 42 + 42 && Cr() === 47)
      break;
  return "/*" + rs(e, Vt - 1) + "*" + rl(t === 47 ? t : Jt());
}
function p_(t) {
  for (; !Vo(Cr()); )
    Jt();
  return rs(t, Vt);
}
function g_(t) {
  return tm(ta("", null, null, null, [""], t = em(t), 0, [0], t));
}
function ta(t, e, r, n, i, o, s, a, l) {
  for (var c = 0, u = 0, f = s, d = 0, h = 0, g = 0, p = 1, y = 1, b = 1, x = 0, S = "", O = i, _ = o, B = n, N = S; y; )
    switch (g = x, x = Jt()) {
      case 40:
        if (g != 108 && Ct(N, f - 1) == 58) {
          au(N += He(ea(x), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        N += ea(x);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        N += f_(g);
        break;
      case 92:
        N += d_($s() - 1, 7);
        continue;
      case 47:
        switch (Cr()) {
          case 42:
          case 47:
            Ms(m_(h_(Jt(), $s()), e, r), l);
            break;
          default:
            N += "/";
        }
        break;
      case 123 * p:
        a[c++] = wr(N) * b;
      case 125 * p:
      case 59:
      case 0:
        switch (x) {
          case 0:
          case 125:
            y = 0;
          case 59 + u:
            b == -1 && (N = He(N, /\f/g, "")), h > 0 && wr(N) - f && Ms(h > 32 ? Pp(N + ";", n, r, f - 1) : Pp(He(N, " ", "") + ";", n, r, f - 2), l);
            break;
          case 59:
            N += ";";
          default:
            if (Ms(B = Ip(N, e, r, c, u, i, a, S, O = [], _ = [], f), o), x === 123)
              if (u === 0)
                ta(N, e, B, B, O, o, f, a, _);
              else
                switch (d === 99 && Ct(N, 3) === 110 ? 100 : d) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    ta(t, B, B, n && Ms(Ip(t, B, B, 0, 0, i, a, S, i, O = [], f), _), i, _, f, a, n ? O : _);
                    break;
                  default:
                    ta(N, B, B, B, [""], _, 0, a, _);
                }
        }
        c = u = h = 0, p = b = 1, S = N = "", f = s;
        break;
      case 58:
        f = 1 + wr(N), h = g;
      default:
        if (p < 1) {
          if (x == 123)
            --p;
          else if (x == 125 && p++ == 0 && u_() == 125)
            continue;
        }
        switch (N += rl(x), x * p) {
          case 38:
            b = u > 0 ? 1 : (N += "\f", -1);
            break;
          case 44:
            a[c++] = (wr(N) - 1) * b, b = 1;
            break;
          case 64:
            Cr() === 45 && (N += ea(Jt())), d = Cr(), u = f = wr(S = N += p_($s())), x++;
            break;
          case 45:
            g === 45 && wr(N) == 2 && (p = 0);
        }
    }
  return o;
}
function Ip(t, e, r, n, i, o, s, a, l, c, u) {
  for (var f = i - 1, d = i === 0 ? o : [""], h = yf(d), g = 0, p = 0, y = 0; g < n; ++g)
    for (var b = 0, x = zo(t, f + 1, f = i_(p = s[g])), S = t; b < h; ++b)
      (S = Zg(p > 0 ? d[b] + " " + x : He(x, /&\f/g, d[b]))) && (l[y++] = S);
  return il(t, e, r, i === 0 ? gf : a, l, c, u);
}
function m_(t, e, r) {
  return il(t, e, r, pf, rl(c_()), zo(t, 2, -2), 0);
}
function Pp(t, e, r, n) {
  return il(t, e, r, mf, zo(t, 0, n), zo(t, n + 1, -1), n);
}
function yi(t, e) {
  for (var r = "", n = yf(t), i = 0; i < n; i++)
    r += e(t[i], i, t, e) || "";
  return r;
}
function y_(t, e, r, n) {
  switch (t.type) {
    case n_:
      if (t.children.length)
        break;
    case r_:
    case mf:
      return t.return = t.return || t.value;
    case pf:
      return "";
    case Gg:
      return t.return = t.value + "{" + yi(t.children, n) + "}";
    case gf:
      t.value = t.props.join(",");
  }
  return wr(r = yi(t.children, n)) ? t.return = t.value + "{" + r + "}" : "";
}
function b_(t) {
  var e = yf(t);
  return function(r, n, i, o) {
    for (var s = "", a = 0; a < e; a++)
      s += t[a](r, n, i, o) || "";
    return s;
  };
}
function v_(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
var A_ = function(e, r, n) {
  for (var i = 0, o = 0; i = o, o = Cr(), i === 38 && o === 12 && (r[n] = 1), !Vo(o); )
    Jt();
  return rs(e, Vt);
}, w_ = function(e, r) {
  var n = -1, i = 44;
  do
    switch (Vo(i)) {
      case 0:
        i === 38 && Cr() === 12 && (r[n] = 1), e[n] += A_(Vt - 1, r, n);
        break;
      case 2:
        e[n] += ea(i);
        break;
      case 4:
        if (i === 44) {
          e[++n] = Cr() === 58 ? "&\f" : "", r[n] = e[n].length;
          break;
        }
      default:
        e[n] += rl(i);
    }
  while (i = Jt());
  return e;
}, x_ = function(e, r) {
  return tm(w_(em(e), r));
}, Rp = /* @__PURE__ */ new WeakMap(), __ = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var r = e.value, n = e.parent, i = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(e.props.length === 1 && r.charCodeAt(0) !== 58 && !Rp.get(n)) && !i) {
      Rp.set(e, !0);
      for (var o = [], s = x_(r, o), a = n.props, l = 0, c = 0; l < s.length; l++)
        for (var u = 0; u < a.length; u++, c++)
          e.props[c] = o[l] ? s[l].replace(/&\f/g, a[u]) : a[u] + " " + s[l];
    }
  }
}, S_ = function(e) {
  if (e.type === "decl") {
    var r = e.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, E_ = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", k_ = function(e) {
  return e.type === "comm" && e.children.indexOf(E_) > -1;
}, C_ = function(e) {
  return function(r, n, i) {
    if (!(r.type !== "rule" || e.compat)) {
      var o = r.value.match(/(:first|:nth|:nth-last)-child/g);
      if (o) {
        for (var s = !!r.parent, a = s ? r.parent.children : (
          // globalThis rule at the root level
          i
        ), l = a.length - 1; l >= 0; l--) {
          var c = a[l];
          if (c.line < r.line)
            break;
          if (c.column < r.column) {
            if (k_(c))
              return;
            break;
          }
        }
        o.forEach(function(u) {
          console.error('The pseudo class "' + u + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + u.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, rm = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, T_ = function(e, r) {
  for (var n = e - 1; n >= 0; n--)
    if (!rm(r[n]))
      return !0;
  return !1;
}, Dp = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, O_ = function(e, r, n) {
  rm(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within globalThis styles."), Dp(e)) : T_(r, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Dp(e)));
};
function nm(t, e) {
  switch (s_(t, e)) {
    case 5103:
      return qe + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return qe + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return qe + t + Pa + t + Ot + t + t;
    case 6828:
    case 4268:
      return qe + t + Ot + t + t;
    case 6165:
      return qe + t + Ot + "flex-" + t + t;
    case 5187:
      return qe + t + He(t, /(\w+).+(:[^]+)/, qe + "box-$1$2" + Ot + "flex-$1$2") + t;
    case 5443:
      return qe + t + Ot + "flex-item-" + He(t, /flex-|-self/, "") + t;
    case 4675:
      return qe + t + Ot + "flex-line-pack" + He(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return qe + t + Ot + He(t, "shrink", "negative") + t;
    case 5292:
      return qe + t + Ot + He(t, "basis", "preferred-size") + t;
    case 6060:
      return qe + "box-" + He(t, "-grow", "") + qe + t + Ot + He(t, "grow", "positive") + t;
    case 4554:
      return qe + He(t, /([^-])(transform)/g, "$1" + qe + "$2") + t;
    case 6187:
      return He(He(He(t, /(zoom-|grab)/, qe + "$1"), /(image-set)/, qe + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return He(t, /(image-set\([^]*)/, qe + "$1$`$1");
    case 4968:
      return He(He(t, /(.+:)(flex-)?(.*)/, qe + "box-pack:$3" + Ot + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + qe + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return He(t, /(.+)-inline(.+)/, qe + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (wr(t) - 1 - e > 6)
        switch (Ct(t, e + 1)) {
          case 109:
            if (Ct(t, e + 4) !== 45)
              break;
          case 102:
            return He(t, /(.+:)(.+)-([^]+)/, "$1" + qe + "$2-$3$1" + Pa + (Ct(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~au(t, "stretch") ? nm(He(t, "stretch", "fill-available"), e) + t : t;
        }
      break;
    case 4949:
      if (Ct(t, e + 1) !== 115)
        break;
    case 6444:
      switch (Ct(t, wr(t) - 3 - (~au(t, "!important") && 10))) {
        case 107:
          return He(t, ":", ":" + qe) + t;
        case 101:
          return He(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + qe + (Ct(t, 14) === 45 ? "inline-" : "") + "box$3$1" + qe + "$2$3$1" + Ot + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (Ct(t, e + 11)) {
        case 114:
          return qe + t + Ot + He(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return qe + t + Ot + He(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return qe + t + Ot + He(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return qe + t + Ot + t + t;
  }
  return t;
}
var I_ = function(e, r, n, i) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case mf:
        e.return = nm(e.value, e.length);
        break;
      case Gg:
        return yi([Gi(e, {
          value: He(e.value, "@", "@" + qe)
        })], i);
      case gf:
        if (e.length)
          return l_(e.props, function(o) {
            switch (a_(o, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return yi([Gi(e, {
                  props: [He(o, /:(read-\w+)/, ":" + Pa + "$1")]
                })], i);
              case "::placeholder":
                return yi([Gi(e, {
                  props: [He(o, /:(plac\w+)/, ":" + qe + "input-$1")]
                }), Gi(e, {
                  props: [He(o, /:(plac\w+)/, ":" + Pa + "$1")]
                }), Gi(e, {
                  props: [He(o, /:(plac\w+)/, Ot + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, P_ = [I_], R_ = function(e) {
  var r = e.key;
  if (process.env.NODE_ENV !== "production" && !r)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(p) {
      var y = p.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(p), p.setAttribute("data-s", ""));
    });
  }
  var i = e.stylisPlugins || P_;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(r))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + r + '" was passed');
  var o = {}, s, a = [];
  s = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(p) {
      for (var y = p.getAttribute("data-emotion").split(" "), b = 1; b < y.length; b++)
        o[y[b]] = !0;
      a.push(p);
    }
  );
  var l, c = [__, S_];
  process.env.NODE_ENV !== "production" && c.push(C_({
    get compat() {
      return g.compat;
    }
  }), O_);
  {
    var u, f = [y_, process.env.NODE_ENV !== "production" ? function(p) {
      p.root || (p.return ? u.insert(p.return) : p.value && p.type !== pf && u.insert(p.value + "{}"));
    } : v_(function(p) {
      u.insert(p);
    })], d = b_(c.concat(i, f)), h = function(y) {
      return yi(g_(y), d);
    };
    l = function(y, b, x, S) {
      u = x, process.env.NODE_ENV !== "production" && b.map !== void 0 && (u = {
        insert: function(_) {
          x.insert(_ + b.map);
        }
      }), h(y ? y + "{" + b.styles + "}" : b.styles), S && (g.inserted[b.name] = !0);
    };
  }
  var g = {
    key: r,
    sheet: new t_({
      key: r,
      container: s,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: o,
    registered: {},
    insert: l
  };
  return g.sheet.hydrate(a), g;
}, D_ = !0;
function im(t, e, r) {
  var n = "";
  return r.split(" ").forEach(function(i) {
    t[i] !== void 0 ? e.push(t[i] + ";") : n += i + " ";
  }), n;
}
var bf = function(e, r, n) {
  var i = e.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is globalThis or not
  // also, note that this check will be dead code eliminated in the browser
  D_ === !1) && e.registered[i] === void 0 && (e.registered[i] = r.styles);
}, om = function(e, r, n) {
  bf(e, r, n);
  var i = e.key + "-" + r.name;
  if (e.inserted[r.name] === void 0) {
    var o = r;
    do
      e.insert(r === o ? "." + i : "", o, e.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function M_(t) {
  for (var e = 0, r, n = 0, i = t.length; i >= 4; ++n, i -= 4)
    r = t.charCodeAt(n) & 255 | (t.charCodeAt(++n) & 255) << 8 | (t.charCodeAt(++n) & 255) << 16 | (t.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, e = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      e ^= (t.charCodeAt(n + 2) & 255) << 16;
    case 2:
      e ^= (t.charCodeAt(n + 1) & 255) << 8;
    case 1:
      e ^= t.charCodeAt(n) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var N_ = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function B_(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return e[r] === void 0 && (e[r] = t(r)), e[r];
  };
}
var Mp = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, L_ = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", F_ = /[A-Z]|^ms/g, sm = /_EMO_([^_]+?)_([^]*?)_EMO_/g, vf = function(e) {
  return e.charCodeAt(1) === 45;
}, Np = function(e) {
  return e != null && typeof e != "boolean";
}, yc = /* @__PURE__ */ B_(function(t) {
  return vf(t) ? t : t.replace(F_, "-$&").toLowerCase();
}), Ra = function(e, r) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(sm, function(n, i, o) {
          return fr = {
            name: i,
            styles: o,
            next: fr
          }, i;
        });
  }
  return N_[e] !== 1 && !vf(e) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
if (process.env.NODE_ENV !== "production") {
  var j_ = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, W_ = ["normal", "none", "initial", "inherit", "unset"], U_ = Ra, z_ = /^-ms-/, V_ = /-(.)/g, Bp = {};
  Ra = function(e, r) {
    if (e === "content" && (typeof r != "string" || W_.indexOf(r) === -1 && !j_.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || r.charAt(0) !== '"' && r.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + r + "\"'`");
    var n = U_(e, r);
    return n !== "" && !vf(e) && e.indexOf("-") !== -1 && Bp[e] === void 0 && (Bp[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(z_, "ms-").replace(V_, function(i, o) {
      return o.toUpperCase();
    }) + "?")), n;
  };
}
var am = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function qo(t, e, r) {
  if (r == null)
    return "";
  if (r.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && r.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(am);
    return r;
  }
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      if (r.anim === 1)
        return fr = {
          name: r.name,
          styles: r.styles,
          next: fr
        }, r.name;
      if (r.styles !== void 0) {
        var n = r.next;
        if (n !== void 0)
          for (; n !== void 0; )
            fr = {
              name: n.name,
              styles: n.styles,
              next: fr
            }, n = n.next;
        var i = r.styles + ";";
        return process.env.NODE_ENV !== "production" && r.map !== void 0 && (i += r.map), i;
      }
      return q_(t, e, r);
    }
    case "function": {
      if (t !== void 0) {
        var o = fr, s = r(t);
        return fr = o, qo(t, e, s);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var a = [], l = r.replace(sm, function(u, f, d) {
          var h = "animation" + a.length;
          return a.push("const " + h + " = keyframes`" + d.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + h + "}";
        });
        a.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(a, ["`" + l + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + l + "`"));
      }
      break;
  }
  if (e == null)
    return r;
  var c = e[r];
  return c !== void 0 ? c : r;
}
function q_(t, e, r) {
  var n = "";
  if (Array.isArray(r))
    for (var i = 0; i < r.length; i++)
      n += qo(t, e, r[i]) + ";";
  else
    for (var o in r) {
      var s = r[o];
      if (typeof s != "object")
        e != null && e[s] !== void 0 ? n += o + "{" + e[s] + "}" : Np(s) && (n += yc(o) + ":" + Ra(o, s) + ";");
      else {
        if (o === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(am);
        if (Array.isArray(s) && typeof s[0] == "string" && (e == null || e[s[0]] === void 0))
          for (var a = 0; a < s.length; a++)
            Np(s[a]) && (n += yc(o) + ":" + Ra(o, s[a]) + ";");
        else {
          var l = qo(t, e, s);
          switch (o) {
            case "animation":
            case "animationName": {
              n += yc(o) + ":" + l + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && o === "undefined" && console.error(L_), n += o + "{" + l + "}";
          }
        }
      }
    }
  return n;
}
var Lp = /label:\s*([^\s;\n{]+)\s*(;|$)/g, lm;
process.env.NODE_ENV !== "production" && (lm = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var fr, cu = function(e, r, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var i = !0, o = "";
  fr = void 0;
  var s = e[0];
  s == null || s.raw === void 0 ? (i = !1, o += qo(n, r, s)) : (process.env.NODE_ENV !== "production" && s[0] === void 0 && console.error(Mp), o += s[0]);
  for (var a = 1; a < e.length; a++)
    o += qo(n, r, e[a]), i && (process.env.NODE_ENV !== "production" && s[a] === void 0 && console.error(Mp), o += s[a]);
  var l;
  process.env.NODE_ENV !== "production" && (o = o.replace(lm, function(d) {
    return l = d, "";
  })), Lp.lastIndex = 0;
  for (var c = "", u; (u = Lp.exec(o)) !== null; )
    c += "-" + // $FlowFixMe we know it's not null
    u[1];
  var f = M_(o) + c;
  return process.env.NODE_ENV !== "production" ? {
    name: f,
    styles: o,
    map: l,
    next: fr,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: f,
    styles: o,
    next: fr
  };
}, H_ = function(e) {
  return e();
}, Y_ = ve["useInsertionEffect"] ? ve["useInsertionEffect"] : !1, cm = Y_ || H_, K_ = {}.hasOwnProperty, Af = /* @__PURE__ */ pu(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ R_({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Af.displayName = "EmotionCacheContext");
Af.Provider;
var um = function(e) {
  return /* @__PURE__ */ Km(function(r, n) {
    var i = Ma(Af);
    return e(r, i, n);
  });
}, ol = /* @__PURE__ */ pu({});
process.env.NODE_ENV !== "production" && (ol.displayName = "EmotionThemeContext");
var Fp = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", jp = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", X_ = function(e) {
  var r = e.cache, n = e.serialized, i = e.isStringTag;
  return bf(r, n, i), cm(function() {
    return om(r, n, i);
  }), null;
}, J_ = /* @__PURE__ */ um(function(t, e, r) {
  var n = t.css;
  typeof n == "string" && e.registered[n] !== void 0 && (n = e.registered[n]);
  var i = t[Fp], o = [n], s = "";
  typeof t.className == "string" ? s = im(e.registered, o, t.className) : t.className != null && (s = t.className + " ");
  var a = cu(o, void 0, Ma(ol));
  if (process.env.NODE_ENV !== "production" && a.name.indexOf("-") === -1) {
    var l = t[jp];
    l && (a = cu([a, "label:" + l + ";"]));
  }
  s += e.key + "-" + a.name;
  var c = {};
  for (var u in t)
    K_.call(t, u) && u !== "css" && u !== Fp && (process.env.NODE_ENV === "production" || u !== jp) && (c[u] = t[u]);
  return c.ref = r, c.className = s, /* @__PURE__ */ fi(h0, null, /* @__PURE__ */ fi(X_, {
    cache: e,
    serialized: a,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ fi(i, c));
});
process.env.NODE_ENV !== "production" && (J_.displayName = "EmotionCssPropInternal");
var Q_ = Zx, G_ = function(e) {
  return e !== "theme";
}, Wp = function(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96 ? Q_ : G_;
}, Up = function(e, r, n) {
  var i;
  if (r) {
    var o = r.shouldForwardProp;
    i = e.__emotion_forwardProp && o ? function(s) {
      return e.__emotion_forwardProp(s) && o(s);
    } : o;
  }
  return typeof i != "function" && n && (i = e.__emotion_forwardProp), i;
}, zp = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Z_ = function(e) {
  var r = e.cache, n = e.serialized, i = e.isStringTag;
  return bf(r, n, i), cm(function() {
    return om(r, n, i);
  }), null;
}, $_ = function t(e, r) {
  if (process.env.NODE_ENV !== "production" && e === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var n = e.__emotion_real === e, i = n && e.__emotion_base || e, o, s;
  r !== void 0 && (o = r.label, s = r.target);
  var a = Up(e, r, n), l = a || Wp(i), c = !l("as");
  return function() {
    var u = arguments, f = n && e.__emotion_styles !== void 0 ? e.__emotion_styles.slice(0) : [];
    if (o !== void 0 && f.push("label:" + o + ";"), u[0] == null || u[0].raw === void 0)
      f.push.apply(f, u);
    else {
      process.env.NODE_ENV !== "production" && u[0][0] === void 0 && console.error(zp), f.push(u[0][0]);
      for (var d = u.length, h = 1; h < d; h++)
        process.env.NODE_ENV !== "production" && u[0][h] === void 0 && console.error(zp), f.push(u[h], u[0][h]);
    }
    var g = um(function(p, y, b) {
      var x = c && p.as || i, S = "", O = [], _ = p;
      if (p.theme == null) {
        _ = {};
        for (var B in p)
          _[B] = p[B];
        _.theme = Ma(ol);
      }
      typeof p.className == "string" ? S = im(y.registered, O, p.className) : p.className != null && (S = p.className + " ");
      var N = cu(f.concat(O), y.registered, _);
      S += y.key + "-" + N.name, s !== void 0 && (S += " " + s);
      var j = c && a === void 0 ? Wp(x) : l, W = {};
      for (var G in p)
        c && G === "as" || // $FlowFixMe
        j(G) && (W[G] = p[G]);
      return W.className = S, W.ref = b, /* @__PURE__ */ fi(h0, null, /* @__PURE__ */ fi(Z_, {
        cache: y,
        serialized: N,
        isStringTag: typeof x == "string"
      }), /* @__PURE__ */ fi(x, W));
    });
    return g.displayName = o !== void 0 ? o : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", g.defaultProps = e.defaultProps, g.__emotion_real = g, g.__emotion_base = i, g.__emotion_styles = f, g.__emotion_forwardProp = a, Object.defineProperty(g, "toString", {
      value: function() {
        return s === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + s;
      }
    }), g.withComponent = function(p, y) {
      return t(p, su({}, r, y, {
        shouldForwardProp: Up(g, y, !0)
      })).apply(void 0, f);
    }, g;
  };
};
const e9 = $_;
var t9 = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], uu = e9.bind();
t9.forEach(function(t) {
  uu[t] = uu(t);
});
const r9 = uu;
/**
 * @mui/styled-engine v5.12.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function n9(t, e) {
  const r = r9(t, e);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const i = typeof t == "string" ? `"${t}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${i})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((o) => o === void 0) && console.error(`MUI: the styled(${i})(...args) API requires all its args to be defined.`), r(...n);
  } : r;
}
const i9 = (t, e) => {
  Array.isArray(t.__emotion_styles) && (t.__emotion_styles = e(t.__emotion_styles));
};
function kt() {
  return kt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, kt.apply(this, arguments);
}
function sl(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
const o9 = ["values", "unit", "step"], s9 = (t) => {
  const e = Object.keys(t).map((r) => ({
    key: r,
    val: t[r]
  })) || [];
  return e.sort((r, n) => r.val - n.val), e.reduce((r, n) => kt({}, r, {
    [n.key]: n.val
  }), {});
};
function a9(t) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: e = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: r = "px",
    step: n = 5
  } = t, i = sl(t, o9), o = s9(e), s = Object.keys(o);
  function a(d) {
    return `@media (min-width:${typeof e[d] == "number" ? e[d] : d}${r})`;
  }
  function l(d) {
    return `@media (max-width:${(typeof e[d] == "number" ? e[d] : d) - n / 100}${r})`;
  }
  function c(d, h) {
    const g = s.indexOf(h);
    return `@media (min-width:${typeof e[d] == "number" ? e[d] : d}${r}) and (max-width:${(g !== -1 && typeof e[s[g]] == "number" ? e[s[g]] : h) - n / 100}${r})`;
  }
  function u(d) {
    return s.indexOf(d) + 1 < s.length ? c(d, s[s.indexOf(d) + 1]) : a(d);
  }
  function f(d) {
    const h = s.indexOf(d);
    return h === 0 ? a(s[1]) : h === s.length - 1 ? l(s[h]) : c(d, s[s.indexOf(d) + 1]).replace("@media", "@media not all and");
  }
  return kt({
    keys: s,
    values: o,
    up: a,
    down: l,
    between: c,
    only: u,
    not: f,
    unit: r
  }, i);
}
const l9 = {
  borderRadius: 4
}, c9 = l9, u9 = process.env.NODE_ENV !== "production" ? F.oneOfType([F.number, F.string, F.object, F.array]) : {}, wn = u9;
function xo(t, e) {
  return e ? Vr(t, e, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : t;
}
const wf = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Vp = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (t) => `@media (min-width:${wf[t]}px)`
};
function Yr(t, e, r) {
  const n = t.theme || {};
  if (Array.isArray(e)) {
    const o = n.breakpoints || Vp;
    return e.reduce((s, a, l) => (s[o.up(o.keys[l])] = r(e[l]), s), {});
  }
  if (typeof e == "object") {
    const o = n.breakpoints || Vp;
    return Object.keys(e).reduce((s, a) => {
      if (Object.keys(o.values || wf).indexOf(a) !== -1) {
        const l = o.up(a);
        s[l] = r(e[a], a);
      } else {
        const l = a;
        s[l] = e[l];
      }
      return s;
    }, {});
  }
  return r(e);
}
function f9(t = {}) {
  var e;
  return ((e = t.keys) == null ? void 0 : e.reduce((n, i) => {
    const o = t.up(i);
    return n[o] = {}, n;
  }, {})) || {};
}
function d9(t, e) {
  return t.reduce((r, n) => {
    const i = r[n];
    return (!i || Object.keys(i).length === 0) && delete r[n], r;
  }, e);
}
function al(t, e, r = !0) {
  if (!e || typeof e != "string")
    return null;
  if (t && t.vars && r) {
    const n = `vars.${e}`.split(".").reduce((i, o) => i && i[o] ? i[o] : null, t);
    if (n != null)
      return n;
  }
  return e.split(".").reduce((n, i) => n && n[i] != null ? n[i] : null, t);
}
function Da(t, e, r, n = r) {
  let i;
  return typeof t == "function" ? i = t(r) : Array.isArray(t) ? i = t[r] || n : i = al(t, r) || n, e && (i = e(i, n, t)), i;
}
function Qe(t) {
  const {
    prop: e,
    cssProperty: r = t.prop,
    themeKey: n,
    transform: i
  } = t, o = (s) => {
    if (s[e] == null)
      return null;
    const a = s[e], l = s.theme, c = al(l, n) || {};
    return Yr(s, a, (f) => {
      let d = Da(c, i, f);
      return f === d && typeof f == "string" && (d = Da(c, i, `${e}${f === "default" ? "" : ir(f)}`, f)), r === !1 ? d : {
        [r]: d
      };
    });
  };
  return o.propTypes = process.env.NODE_ENV !== "production" ? {
    [e]: wn
  } : {}, o.filterProps = [e], o;
}
function h9(t) {
  const e = {};
  return (r) => (e[r] === void 0 && (e[r] = t(r)), e[r]);
}
const p9 = {
  m: "margin",
  p: "padding"
}, g9 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, qp = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, m9 = h9((t) => {
  if (t.length > 2)
    if (qp[t])
      t = qp[t];
    else
      return [t];
  const [e, r] = t.split(""), n = p9[e], i = g9[r] || "";
  return Array.isArray(i) ? i.map((o) => n + o) : [n + i];
}), ll = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], cl = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], y9 = [...ll, ...cl];
function ns(t, e, r, n) {
  var i;
  const o = (i = al(t, e, !1)) != null ? i : r;
  return typeof o == "number" ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && typeof s != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${s}.`), o * s) : Array.isArray(o) ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && (Number.isInteger(s) ? s > o.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${s} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${e}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${e}\` as a number.`].join(`
`))), o[s]) : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${e}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function fm(t) {
  return ns(t, "spacing", 8, "spacing");
}
function is(t, e) {
  if (typeof e == "string" || e == null)
    return e;
  const r = Math.abs(e), n = t(r);
  return e >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function b9(t, e) {
  return (r) => t.reduce((n, i) => (n[i] = is(e, r), n), {});
}
function v9(t, e, r, n) {
  if (e.indexOf(r) === -1)
    return null;
  const i = m9(r), o = b9(i, n), s = t[r];
  return Yr(t, s, o);
}
function dm(t, e) {
  const r = fm(t.theme);
  return Object.keys(t).map((n) => v9(t, e, n, r)).reduce(xo, {});
}
function ft(t) {
  return dm(t, ll);
}
ft.propTypes = process.env.NODE_ENV !== "production" ? ll.reduce((t, e) => (t[e] = wn, t), {}) : {};
ft.filterProps = ll;
function dt(t) {
  return dm(t, cl);
}
dt.propTypes = process.env.NODE_ENV !== "production" ? cl.reduce((t, e) => (t[e] = wn, t), {}) : {};
dt.filterProps = cl;
process.env.NODE_ENV !== "production" && y9.reduce((t, e) => (t[e] = wn, t), {});
function A9(t = 8) {
  if (t.mui)
    return t;
  const e = fm({
    spacing: t
  }), r = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((o) => {
    const s = e(o);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return r.mui = !0, r;
}
function ul(...t) {
  const e = t.reduce((n, i) => (i.filterProps.forEach((o) => {
    n[o] = i;
  }), n), {}), r = (n) => Object.keys(n).reduce((i, o) => e[o] ? xo(i, e[o](n)) : i, {});
  return r.propTypes = process.env.NODE_ENV !== "production" ? t.reduce((n, i) => Object.assign(n, i.propTypes), {}) : {}, r.filterProps = t.reduce((n, i) => n.concat(i.filterProps), []), r;
}
function _r(t) {
  return typeof t != "number" ? t : `${t}px solid`;
}
const w9 = Qe({
  prop: "border",
  themeKey: "borders",
  transform: _r
}), x9 = Qe({
  prop: "borderTop",
  themeKey: "borders",
  transform: _r
}), _9 = Qe({
  prop: "borderRight",
  themeKey: "borders",
  transform: _r
}), S9 = Qe({
  prop: "borderBottom",
  themeKey: "borders",
  transform: _r
}), E9 = Qe({
  prop: "borderLeft",
  themeKey: "borders",
  transform: _r
}), k9 = Qe({
  prop: "borderColor",
  themeKey: "palette"
}), C9 = Qe({
  prop: "borderTopColor",
  themeKey: "palette"
}), T9 = Qe({
  prop: "borderRightColor",
  themeKey: "palette"
}), O9 = Qe({
  prop: "borderBottomColor",
  themeKey: "palette"
}), I9 = Qe({
  prop: "borderLeftColor",
  themeKey: "palette"
}), fl = (t) => {
  if (t.borderRadius !== void 0 && t.borderRadius !== null) {
    const e = ns(t.theme, "shape.borderRadius", 4, "borderRadius"), r = (n) => ({
      borderRadius: is(e, n)
    });
    return Yr(t, t.borderRadius, r);
  }
  return null;
};
fl.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: wn
} : {};
fl.filterProps = ["borderRadius"];
ul(w9, x9, _9, S9, E9, k9, C9, T9, O9, I9, fl);
const dl = (t) => {
  if (t.gap !== void 0 && t.gap !== null) {
    const e = ns(t.theme, "spacing", 8, "gap"), r = (n) => ({
      gap: is(e, n)
    });
    return Yr(t, t.gap, r);
  }
  return null;
};
dl.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: wn
} : {};
dl.filterProps = ["gap"];
const hl = (t) => {
  if (t.columnGap !== void 0 && t.columnGap !== null) {
    const e = ns(t.theme, "spacing", 8, "columnGap"), r = (n) => ({
      columnGap: is(e, n)
    });
    return Yr(t, t.columnGap, r);
  }
  return null;
};
hl.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: wn
} : {};
hl.filterProps = ["columnGap"];
const pl = (t) => {
  if (t.rowGap !== void 0 && t.rowGap !== null) {
    const e = ns(t.theme, "spacing", 8, "rowGap"), r = (n) => ({
      rowGap: is(e, n)
    });
    return Yr(t, t.rowGap, r);
  }
  return null;
};
pl.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: wn
} : {};
pl.filterProps = ["rowGap"];
const P9 = Qe({
  prop: "gridColumn"
}), R9 = Qe({
  prop: "gridRow"
}), D9 = Qe({
  prop: "gridAutoFlow"
}), M9 = Qe({
  prop: "gridAutoColumns"
}), N9 = Qe({
  prop: "gridAutoRows"
}), B9 = Qe({
  prop: "gridTemplateColumns"
}), L9 = Qe({
  prop: "gridTemplateRows"
}), F9 = Qe({
  prop: "gridTemplateAreas"
}), j9 = Qe({
  prop: "gridArea"
});
ul(dl, hl, pl, P9, R9, D9, M9, N9, B9, L9, F9, j9);
function bi(t, e) {
  return e === "grey" ? e : t;
}
const W9 = Qe({
  prop: "color",
  themeKey: "palette",
  transform: bi
}), U9 = Qe({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: bi
}), z9 = Qe({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: bi
});
ul(W9, U9, z9);
function Kt(t) {
  return t <= 1 && t !== 0 ? `${t * 100}%` : t;
}
const V9 = Qe({
  prop: "width",
  transform: Kt
}), xf = (t) => {
  if (t.maxWidth !== void 0 && t.maxWidth !== null) {
    const e = (r) => {
      var n, i, o;
      return {
        maxWidth: ((n = t.theme) == null || (i = n.breakpoints) == null || (o = i.values) == null ? void 0 : o[r]) || wf[r] || Kt(r)
      };
    };
    return Yr(t, t.maxWidth, e);
  }
  return null;
};
xf.filterProps = ["maxWidth"];
const q9 = Qe({
  prop: "minWidth",
  transform: Kt
}), H9 = Qe({
  prop: "height",
  transform: Kt
}), Y9 = Qe({
  prop: "maxHeight",
  transform: Kt
}), K9 = Qe({
  prop: "minHeight",
  transform: Kt
});
Qe({
  prop: "size",
  cssProperty: "width",
  transform: Kt
});
Qe({
  prop: "size",
  cssProperty: "height",
  transform: Kt
});
const X9 = Qe({
  prop: "boxSizing"
});
ul(V9, xf, q9, H9, Y9, K9, X9);
const J9 = {
  // borders
  border: {
    themeKey: "borders",
    transform: _r
  },
  borderTop: {
    themeKey: "borders",
    transform: _r
  },
  borderRight: {
    themeKey: "borders",
    transform: _r
  },
  borderBottom: {
    themeKey: "borders",
    transform: _r
  },
  borderLeft: {
    themeKey: "borders",
    transform: _r
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: fl
  },
  // palette
  color: {
    themeKey: "palette",
    transform: bi
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: bi
  },
  backgroundColor: {
    themeKey: "palette",
    transform: bi
  },
  // spacing
  p: {
    style: dt
  },
  pt: {
    style: dt
  },
  pr: {
    style: dt
  },
  pb: {
    style: dt
  },
  pl: {
    style: dt
  },
  px: {
    style: dt
  },
  py: {
    style: dt
  },
  padding: {
    style: dt
  },
  paddingTop: {
    style: dt
  },
  paddingRight: {
    style: dt
  },
  paddingBottom: {
    style: dt
  },
  paddingLeft: {
    style: dt
  },
  paddingX: {
    style: dt
  },
  paddingY: {
    style: dt
  },
  paddingInline: {
    style: dt
  },
  paddingInlineStart: {
    style: dt
  },
  paddingInlineEnd: {
    style: dt
  },
  paddingBlock: {
    style: dt
  },
  paddingBlockStart: {
    style: dt
  },
  paddingBlockEnd: {
    style: dt
  },
  m: {
    style: ft
  },
  mt: {
    style: ft
  },
  mr: {
    style: ft
  },
  mb: {
    style: ft
  },
  ml: {
    style: ft
  },
  mx: {
    style: ft
  },
  my: {
    style: ft
  },
  margin: {
    style: ft
  },
  marginTop: {
    style: ft
  },
  marginRight: {
    style: ft
  },
  marginBottom: {
    style: ft
  },
  marginLeft: {
    style: ft
  },
  marginX: {
    style: ft
  },
  marginY: {
    style: ft
  },
  marginInline: {
    style: ft
  },
  marginInlineStart: {
    style: ft
  },
  marginInlineEnd: {
    style: ft
  },
  marginBlock: {
    style: ft
  },
  marginBlockStart: {
    style: ft
  },
  marginBlockEnd: {
    style: ft
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (t) => ({
      "@media print": {
        display: t
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: dl
  },
  rowGap: {
    style: pl
  },
  columnGap: {
    style: hl
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Kt
  },
  maxWidth: {
    style: xf
  },
  minWidth: {
    transform: Kt
  },
  height: {
    transform: Kt
  },
  maxHeight: {
    transform: Kt
  },
  minHeight: {
    transform: Kt
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, _f = J9;
function Q9(...t) {
  const e = t.reduce((n, i) => n.concat(Object.keys(i)), []), r = new Set(e);
  return t.every((n) => r.size === Object.keys(n).length);
}
function G9(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Z9() {
  function t(r, n, i, o) {
    const s = {
      [r]: n,
      theme: i
    }, a = o[r];
    if (!a)
      return {
        [r]: n
      };
    const {
      cssProperty: l = r,
      themeKey: c,
      transform: u,
      style: f
    } = a;
    if (n == null)
      return null;
    if (c === "typography" && n === "inherit")
      return {
        [r]: n
      };
    const d = al(i, c) || {};
    return f ? f(s) : Yr(s, n, (g) => {
      let p = Da(d, u, g);
      return g === p && typeof g == "string" && (p = Da(d, u, `${r}${g === "default" ? "" : ir(g)}`, g)), l === !1 ? p : {
        [l]: p
      };
    });
  }
  function e(r) {
    var n;
    const {
      sx: i,
      theme: o = {}
    } = r || {};
    if (!i)
      return null;
    const s = (n = o.unstable_sxConfig) != null ? n : _f;
    function a(l) {
      let c = l;
      if (typeof l == "function")
        c = l(o);
      else if (typeof l != "object")
        return l;
      if (!c)
        return null;
      const u = f9(o.breakpoints), f = Object.keys(u);
      let d = u;
      return Object.keys(c).forEach((h) => {
        const g = G9(c[h], o);
        if (g != null)
          if (typeof g == "object")
            if (s[h])
              d = xo(d, t(h, g, o, s));
            else {
              const p = Yr({
                theme: o
              }, g, (y) => ({
                [h]: y
              }));
              Q9(p, g) ? d[h] = e({
                sx: g,
                theme: o
              }) : d = xo(d, p);
            }
          else
            d = xo(d, t(h, g, o, s));
      }), d9(f, d);
    }
    return Array.isArray(i) ? i.map(a) : a(i);
  }
  return e;
}
const hm = Z9();
hm.filterProps = ["sx"];
const Sf = hm, $9 = ["breakpoints", "palette", "spacing", "shape"];
function Ef(t = {}, ...e) {
  const {
    breakpoints: r = {},
    palette: n = {},
    spacing: i,
    shape: o = {}
  } = t, s = sl(t, $9), a = a9(r), l = A9(i);
  let c = Vr({
    breakpoints: a,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: kt({
      mode: "light"
    }, n),
    spacing: l,
    shape: kt({}, c9, o)
  }, s);
  return c = e.reduce((u, f) => Vr(u, f), c), c.unstable_sxConfig = kt({}, _f, s == null ? void 0 : s.unstable_sxConfig), c.unstable_sx = function(f) {
    return Sf({
      sx: f,
      theme: this
    });
  }, c;
}
function e8(t) {
  return Object.keys(t).length === 0;
}
function pm(t = null) {
  const e = ve.useContext(ol);
  return !e || e8(e) ? t : e;
}
const t8 = Ef();
function gm(t = t8) {
  return pm(t);
}
const r8 = ["variant"];
function Hp(t) {
  return t.length === 0;
}
function mm(t) {
  const {
    variant: e
  } = t, r = sl(t, r8);
  let n = e || "";
  return Object.keys(r).sort().forEach((i) => {
    i === "color" ? n += Hp(n) ? t[i] : ir(t[i]) : n += `${Hp(n) ? i : ir(i)}${ir(t[i].toString())}`;
  }), n;
}
const n8 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function i8(t) {
  return Object.keys(t).length === 0;
}
function o8(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96;
}
const s8 = (t, e) => e.components && e.components[t] && e.components[t].styleOverrides ? e.components[t].styleOverrides : null, a8 = (t, e) => {
  let r = [];
  e && e.components && e.components[t] && e.components[t].variants && (r = e.components[t].variants);
  const n = {};
  return r.forEach((i) => {
    const o = mm(i.props);
    n[o] = i.style;
  }), n;
}, l8 = (t, e, r, n) => {
  var i, o;
  const {
    ownerState: s = {}
  } = t, a = [], l = r == null || (i = r.components) == null || (o = i[n]) == null ? void 0 : o.variants;
  return l && l.forEach((c) => {
    let u = !0;
    Object.keys(c.props).forEach((f) => {
      s[f] !== c.props[f] && t[f] !== c.props[f] && (u = !1);
    }), u && a.push(e[mm(c.props)]);
  }), a;
};
function ra(t) {
  return t !== "ownerState" && t !== "theme" && t !== "sx" && t !== "as";
}
const c8 = Ef(), u8 = (t) => t.charAt(0).toLowerCase() + t.slice(1);
function Zi({
  defaultTheme: t,
  theme: e,
  themeId: r
}) {
  return i8(e) ? t : e[r] || e;
}
function f8(t = {}) {
  const {
    themeId: e,
    defaultTheme: r = c8,
    rootShouldForwardProp: n = ra,
    slotShouldForwardProp: i = ra
  } = t, o = (s) => Sf(kt({}, s, {
    theme: Zi(kt({}, s, {
      defaultTheme: r,
      themeId: e
    }))
  }));
  return o.__mui_systemSx = !0, (s, a = {}) => {
    i9(s, (O) => O.filter((_) => !(_ != null && _.__mui_systemSx)));
    const {
      name: l,
      slot: c,
      skipVariantsResolver: u,
      skipSx: f,
      overridesResolver: d
    } = a, h = sl(a, n8), g = u !== void 0 ? u : c && c !== "Root" || !1, p = f || !1;
    let y;
    process.env.NODE_ENV !== "production" && l && (y = `${l}-${u8(c || "Root")}`);
    let b = ra;
    c === "Root" ? b = n : c ? b = i : o8(s) && (b = void 0);
    const x = n9(s, kt({
      shouldForwardProp: b,
      label: y
    }, h)), S = (O, ..._) => {
      const B = _ ? _.map((G) => typeof G == "function" && G.__emotion_real !== G ? (ee) => G(kt({}, ee, {
        theme: Zi(kt({}, ee, {
          defaultTheme: r,
          themeId: e
        }))
      })) : G) : [];
      let N = O;
      l && d && B.push((G) => {
        const ee = Zi(kt({}, G, {
          defaultTheme: r,
          themeId: e
        })), fe = s8(l, ee);
        if (fe) {
          const P = {};
          return Object.entries(fe).forEach(([z, U]) => {
            P[z] = typeof U == "function" ? U(kt({}, G, {
              theme: ee
            })) : U;
          }), d(G, P);
        }
        return null;
      }), l && !g && B.push((G) => {
        const ee = Zi(kt({}, G, {
          defaultTheme: r,
          themeId: e
        }));
        return l8(G, a8(l, ee), ee, l);
      }), p || B.push(o);
      const j = B.length - _.length;
      if (Array.isArray(O) && j > 0) {
        const G = new Array(j).fill("");
        N = [...O, ...G], N.raw = [...O.raw, ...G];
      } else
        typeof O == "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        O.__emotion_real !== O && (N = (G) => O(kt({}, G, {
          theme: Zi(kt({}, G, {
            defaultTheme: r,
            themeId: e
          }))
        })));
      const W = x(N, ...B);
      if (process.env.NODE_ENV !== "production") {
        let G;
        l && (G = `${l}${c || ""}`), G === void 0 && (G = `Styled(${Zw(s)})`), W.displayName = G;
      }
      return s.muiName && (W.muiName = s.muiName), W;
    };
    return x.withConfig && (S.withConfig = x.withConfig), S;
  };
}
function d8(t) {
  const {
    theme: e,
    name: r,
    props: n
  } = t;
  return !e || !e.components || !e.components[r] || !e.components[r].defaultProps ? n : Lg(e.components[r].defaultProps, n);
}
function h8({
  props: t,
  name: e,
  defaultTheme: r,
  themeId: n
}) {
  let i = gm(r);
  return n && (i = i[n] || i), d8({
    theme: i,
    name: e,
    props: t
  });
}
function kf(t, e = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (t < e || t > r) && console.error(`MUI: The value provided ${t} is out of range [${e}, ${r}].`), Math.min(Math.max(e, t), r);
}
function p8(t) {
  t = t.slice(1);
  const e = new RegExp(`.{1,${t.length >= 6 ? 2 : 1}}`, "g");
  let r = t.match(e);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, i) => i < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Xn(t) {
  if (t.type)
    return t;
  if (t.charAt(0) === "#")
    return Xn(p8(t));
  const e = t.indexOf("("), r = t.substring(0, e);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${t}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : ki(9, t));
  let n = t.substring(e + 1, t.length - 1), i;
  if (r === "color") {
    if (n = n.split(" "), i = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(i) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${i}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : ki(10, i));
  } else
    n = n.split(",");
  return n = n.map((o) => parseFloat(o)), {
    type: r,
    values: n,
    colorSpace: i
  };
}
function gl(t) {
  const {
    type: e,
    colorSpace: r
  } = t;
  let {
    values: n
  } = t;
  return e.indexOf("rgb") !== -1 ? n = n.map((i, o) => o < 3 ? parseInt(i, 10) : i) : e.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), e.indexOf("color") !== -1 ? n = `${r} ${n.join(" ")}` : n = `${n.join(", ")}`, `${e}(${n})`;
}
function g8(t) {
  t = Xn(t);
  const {
    values: e
  } = t, r = e[0], n = e[1] / 100, i = e[2] / 100, o = n * Math.min(i, 1 - i), s = (c, u = (c + r / 30) % 12) => i - o * Math.max(Math.min(u - 3, 9 - u, 1), -1);
  let a = "rgb";
  const l = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return t.type === "hsla" && (a += "a", l.push(e[3])), gl({
    type: a,
    values: l
  });
}
function Yp(t) {
  t = Xn(t);
  let e = t.type === "hsl" || t.type === "hsla" ? Xn(g8(t)).values : t.values;
  return e = e.map((r) => (t.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2]).toFixed(3));
}
function Kp(t, e) {
  const r = Yp(t), n = Yp(e);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function ym(t, e) {
  return t = Xn(t), e = kf(e), (t.type === "rgb" || t.type === "hsl") && (t.type += "a"), t.type === "color" ? t.values[3] = `/${e}` : t.values[3] = e, gl(t);
}
function m8(t, e) {
  if (t = Xn(t), e = kf(e), t.type.indexOf("hsl") !== -1)
    t.values[2] *= 1 - e;
  else if (t.type.indexOf("rgb") !== -1 || t.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      t.values[r] *= 1 - e;
  return gl(t);
}
function y8(t, e) {
  if (t = Xn(t), e = kf(e), t.type.indexOf("hsl") !== -1)
    t.values[2] += (100 - t.values[2]) * e;
  else if (t.type.indexOf("rgb") !== -1)
    for (let r = 0; r < 3; r += 1)
      t.values[r] += (255 - t.values[r]) * e;
  else if (t.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      t.values[r] += (1 - t.values[r]) * e;
  return gl(t);
}
function b8(t, e) {
  return ke({
    toolbar: {
      minHeight: 56,
      [t.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [t.up("sm")]: {
        minHeight: 64
      }
    }
  }, e);
}
const v8 = {
  black: "#000",
  white: "#fff"
}, Ho = v8, A8 = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, w8 = A8, x8 = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, ti = x8, _8 = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, ri = _8, S8 = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, $i = S8, E8 = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, ni = E8, k8 = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, ii = k8, C8 = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, oi = C8, T8 = ["mode", "contrastThreshold", "tonalOffset"], Xp = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: Ho.white,
    default: Ho.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, bc = {
  text: {
    primary: Ho.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: Ho.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Jp(t, e, r, n) {
  const i = n.light || n, o = n.dark || n * 1.5;
  t[e] || (t.hasOwnProperty(r) ? t[e] = t[r] : e === "light" ? t.light = y8(t.main, i) : e === "dark" && (t.dark = m8(t.main, o)));
}
function O8(t = "light") {
  return t === "dark" ? {
    main: ni[200],
    light: ni[50],
    dark: ni[400]
  } : {
    main: ni[700],
    light: ni[400],
    dark: ni[800]
  };
}
function I8(t = "light") {
  return t === "dark" ? {
    main: ti[200],
    light: ti[50],
    dark: ti[400]
  } : {
    main: ti[500],
    light: ti[300],
    dark: ti[700]
  };
}
function P8(t = "light") {
  return t === "dark" ? {
    main: ri[500],
    light: ri[300],
    dark: ri[700]
  } : {
    main: ri[700],
    light: ri[400],
    dark: ri[800]
  };
}
function R8(t = "light") {
  return t === "dark" ? {
    main: ii[400],
    light: ii[300],
    dark: ii[700]
  } : {
    main: ii[700],
    light: ii[500],
    dark: ii[900]
  };
}
function D8(t = "light") {
  return t === "dark" ? {
    main: oi[400],
    light: oi[300],
    dark: oi[700]
  } : {
    main: oi[800],
    light: oi[500],
    dark: oi[900]
  };
}
function M8(t = "light") {
  return t === "dark" ? {
    main: $i[400],
    light: $i[300],
    dark: $i[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: $i[500],
    dark: $i[900]
  };
}
function N8(t) {
  const {
    mode: e = "light",
    contrastThreshold: r = 3,
    tonalOffset: n = 0.2
  } = t, i = vn(t, T8), o = t.primary || O8(e), s = t.secondary || I8(e), a = t.error || P8(e), l = t.info || R8(e), c = t.success || D8(e), u = t.warning || M8(e);
  function f(p) {
    const y = Kp(p, bc.text.primary) >= r ? bc.text.primary : Xp.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const b = Kp(p, y);
      b < 3 && console.error([`MUI: The contrast ratio of ${b}:1 for ${y} on ${p}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return y;
  }
  const d = ({
    color: p,
    name: y,
    mainShade: b = 500,
    lightShade: x = 300,
    darkShade: S = 700
  }) => {
    if (p = ke({}, p), !p.main && p[b] && (p.main = p[b]), !p.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${y ? ` (${y})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${b}\` property.` : ki(11, y ? ` (${y})` : "", b));
    if (typeof p.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${y ? ` (${y})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(p.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : ki(12, y ? ` (${y})` : "", JSON.stringify(p.main)));
    return Jp(p, "light", x, n), Jp(p, "dark", S, n), p.contrastText || (p.contrastText = f(p.main)), p;
  }, h = {
    dark: bc,
    light: Xp
  };
  return process.env.NODE_ENV !== "production" && (h[e] || console.error(`MUI: The palette mode \`${e}\` is not supported.`)), Vr(ke({
    // A collection of common colors.
    common: ke({}, Ho),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: e,
    // The colors used to represent primary interface elements for a user.
    primary: d({
      color: o,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: d({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: d({
      color: a,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: d({
      color: u,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: d({
      color: l,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: d({
      color: c,
      name: "success"
    }),
    // The grey colors.
    grey: w8,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: d,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, h[e]), i);
}
const B8 = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function L8(t) {
  return Math.round(t * 1e5) / 1e5;
}
const Qp = {
  textTransform: "uppercase"
}, Gp = '"Roboto", "Helvetica", "Arial", sans-serif';
function F8(t, e) {
  const r = typeof e == "function" ? e(t) : e, {
    fontFamily: n = Gp,
    // The default font size of the Material Specification.
    fontSize: i = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: s = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: f
  } = r, d = vn(r, B8);
  process.env.NODE_ENV !== "production" && (typeof i != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof c != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const h = i / 14, g = f || ((b) => `${b / c * h}rem`), p = (b, x, S, O, _) => ke({
    fontFamily: n,
    fontWeight: b,
    fontSize: g(x),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: S
  }, n === Gp ? {
    letterSpacing: `${L8(O / x)}em`
  } : {}, _, u), y = {
    h1: p(o, 96, 1.167, -1.5),
    h2: p(o, 60, 1.2, -0.5),
    h3: p(s, 48, 1.167, 0),
    h4: p(s, 34, 1.235, 0.25),
    h5: p(s, 24, 1.334, 0),
    h6: p(a, 20, 1.6, 0.15),
    subtitle1: p(s, 16, 1.75, 0.15),
    subtitle2: p(a, 14, 1.57, 0.1),
    body1: p(s, 16, 1.5, 0.15),
    body2: p(s, 14, 1.43, 0.15),
    button: p(a, 14, 1.75, 0.4, Qp),
    caption: p(s, 12, 1.66, 0.4),
    overline: p(s, 12, 2.66, 1, Qp),
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Vr(ke({
    htmlFontSize: c,
    pxToRem: g,
    fontFamily: n,
    fontSize: i,
    fontWeightLight: o,
    fontWeightRegular: s,
    fontWeightMedium: a,
    fontWeightBold: l
  }, y), d, {
    clone: !1
    // No need to clone deep
  });
}
const j8 = 0.2, W8 = 0.14, U8 = 0.12;
function ct(...t) {
  return [`${t[0]}px ${t[1]}px ${t[2]}px ${t[3]}px rgba(0,0,0,${j8})`, `${t[4]}px ${t[5]}px ${t[6]}px ${t[7]}px rgba(0,0,0,${W8})`, `${t[8]}px ${t[9]}px ${t[10]}px ${t[11]}px rgba(0,0,0,${U8})`].join(",");
}
const z8 = ["none", ct(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ct(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ct(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ct(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ct(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ct(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ct(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ct(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ct(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ct(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ct(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ct(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ct(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ct(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ct(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ct(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ct(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ct(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ct(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ct(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ct(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ct(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ct(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ct(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], V8 = z8, q8 = ["duration", "easing", "delay"], H8 = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Y8 = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Zp(t) {
  return `${Math.round(t)}ms`;
}
function K8(t) {
  if (!t)
    return 0;
  const e = t / 36;
  return Math.round((4 + 15 * e ** 0.25 + e / 5) * 10);
}
function X8(t) {
  const e = ke({}, H8, t.easing), r = ke({}, Y8, t.duration);
  return ke({
    getAutoHeightDuration: K8,
    create: (i = ["all"], o = {}) => {
      const {
        duration: s = r.standard,
        easing: a = e.easeInOut,
        delay: l = 0
      } = o, c = vn(o, q8);
      if (process.env.NODE_ENV !== "production") {
        const u = (d) => typeof d == "string", f = (d) => !isNaN(parseFloat(d));
        !u(i) && !Array.isArray(i) && console.error('MUI: Argument "props" must be a string or Array.'), !f(s) && !u(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), u(a) || console.error('MUI: Argument "easing" must be a string.'), !f(l) && !u(l) && console.error('MUI: Argument "delay" must be a number or a string.'), Object.keys(c).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(c).join(",")}].`);
      }
      return (Array.isArray(i) ? i : [i]).map((u) => `${u} ${typeof s == "string" ? s : Zp(s)} ${a} ${typeof l == "string" ? l : Zp(l)}`).join(",");
    }
  }, t, {
    easing: e,
    duration: r
  });
}
const J8 = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Q8 = J8, G8 = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Z8(t = {}, ...e) {
  const {
    mixins: r = {},
    palette: n = {},
    transitions: i = {},
    typography: o = {}
  } = t, s = vn(t, G8);
  if (t.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : ki(18));
  const a = N8(n), l = Ef(t);
  let c = Vr(l, {
    mixins: b8(l.breakpoints, r),
    palette: a,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: V8.slice(),
    typography: F8(a, o),
    transitions: X8(i),
    zIndex: ke({}, Q8)
  });
  if (c = Vr(c, s), c = e.reduce((u, f) => Vr(u, f), c), process.env.NODE_ENV !== "production") {
    const u = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], f = (d, h) => {
      let g;
      for (g in d) {
        const p = d[g];
        if (u.indexOf(g) !== -1 && Object.keys(p).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const y = $o("", g);
            console.error([`MUI: The \`${h}\` component increases the CSS specificity of the \`${g}\` internal state.`, "You can not override it like this: ", JSON.stringify(d, null, 2), "", `Instead, you need to use the '&.${y}' syntax:`, JSON.stringify({
              root: {
                [`&.${y}`]: p
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          d[g] = {};
        }
      }
    };
    Object.keys(c.components).forEach((d) => {
      const h = c.components[d].styleOverrides;
      h && d.indexOf("Mui") === 0 && f(h, d);
    });
  }
  return c.unstable_sxConfig = ke({}, _f, s == null ? void 0 : s.unstable_sxConfig), c.unstable_sx = function(f) {
    return Sf({
      sx: f,
      theme: this
    });
  }, c;
}
const $8 = Z8(), Cf = $8, Tf = "$$material", e7 = (t) => ra(t) && t !== "classes", t7 = f8({
  themeId: Tf,
  defaultTheme: Cf,
  rootShouldForwardProp: e7
}), os = t7;
function Of({
  props: t,
  name: e
}) {
  return h8({
    props: t,
    name: e,
    defaultTheme: Cf,
    themeId: Tf
  });
}
function r7(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
function n7(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
const $p = {
  disabled: !1
};
var i7 = process.env.NODE_ENV !== "production" ? F.oneOfType([F.number, F.shape({
  enter: F.number,
  exit: F.number,
  appear: F.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && F.oneOfType([F.string, F.shape({
  enter: F.string,
  exit: F.string,
  active: F.string
}), F.shape({
  enter: F.string,
  enterDone: F.string,
  enterActive: F.string,
  exit: F.string,
  exitDone: F.string,
  exitActive: F.string
})]);
const bm = K.createContext(null);
var o7 = function(e) {
  return e.scrollTop;
}, uo = "unmounted", Dn = "exited", Mn = "entering", ci = "entered", fu = "exiting", Jr = /* @__PURE__ */ function(t) {
  n7(e, t);
  function e(n, i) {
    var o;
    o = t.call(this, n, i) || this;
    var s = i, a = s && !s.isMounting ? n.enter : n.appear, l;
    return o.appearStatus = null, n.in ? a ? (l = Dn, o.appearStatus = Mn) : l = ci : n.unmountOnExit || n.mountOnEnter ? l = uo : l = Dn, o.state = {
      status: l
    }, o.nextCallback = null, o;
  }
  e.getDerivedStateFromProps = function(i, o) {
    var s = i.in;
    return s && o.status === uo ? {
      status: Dn
    } : null;
  };
  var r = e.prototype;
  return r.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, r.componentDidUpdate = function(i) {
    var o = null;
    if (i !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== Mn && s !== ci && (o = Mn) : (s === Mn || s === ci) && (o = fu);
    }
    this.updateStatus(!1, o);
  }, r.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, r.getTimeouts = function() {
    var i = this.props.timeout, o, s, a;
    return o = s = a = i, i != null && typeof i != "number" && (o = i.exit, s = i.enter, a = i.appear !== void 0 ? i.appear : s), {
      exit: o,
      enter: s,
      appear: a
    };
  }, r.updateStatus = function(i, o) {
    if (i === void 0 && (i = !1), o !== null)
      if (this.cancelNextCallback(), o === Mn) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : Wt.findDOMNode(this);
          s && o7(s);
        }
        this.performEnter(i);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === Dn && this.setState({
        status: uo
      });
  }, r.performEnter = function(i) {
    var o = this, s = this.props.enter, a = this.context ? this.context.isMounting : i, l = this.props.nodeRef ? [a] : [Wt.findDOMNode(this), a], c = l[0], u = l[1], f = this.getTimeouts(), d = a ? f.appear : f.enter;
    if (!i && !s || $p.disabled) {
      this.safeSetState({
        status: ci
      }, function() {
        o.props.onEntered(c);
      });
      return;
    }
    this.props.onEnter(c, u), this.safeSetState({
      status: Mn
    }, function() {
      o.props.onEntering(c, u), o.onTransitionEnd(d, function() {
        o.safeSetState({
          status: ci
        }, function() {
          o.props.onEntered(c, u);
        });
      });
    });
  }, r.performExit = function() {
    var i = this, o = this.props.exit, s = this.getTimeouts(), a = this.props.nodeRef ? void 0 : Wt.findDOMNode(this);
    if (!o || $p.disabled) {
      this.safeSetState({
        status: Dn
      }, function() {
        i.props.onExited(a);
      });
      return;
    }
    this.props.onExit(a), this.safeSetState({
      status: fu
    }, function() {
      i.props.onExiting(a), i.onTransitionEnd(s.exit, function() {
        i.safeSetState({
          status: Dn
        }, function() {
          i.props.onExited(a);
        });
      });
    });
  }, r.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, r.safeSetState = function(i, o) {
    o = this.setNextCallback(o), this.setState(i, o);
  }, r.setNextCallback = function(i) {
    var o = this, s = !0;
    return this.nextCallback = function(a) {
      s && (s = !1, o.nextCallback = null, i(a));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, r.onTransitionEnd = function(i, o) {
    this.setNextCallback(o);
    var s = this.props.nodeRef ? this.props.nodeRef.current : Wt.findDOMNode(this), a = i == null && !this.props.addEndListener;
    if (!s || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var l = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], c = l[0], u = l[1];
      this.props.addEndListener(c, u);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, r.render = function() {
    var i = this.state.status;
    if (i === uo)
      return null;
    var o = this.props, s = o.children;
    o.in, o.mountOnEnter, o.unmountOnExit, o.appear, o.enter, o.exit, o.timeout, o.addEndListener, o.onEnter, o.onEntering, o.onEntered, o.onExit, o.onExiting, o.onExited, o.nodeRef;
    var a = r7(o, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ K.createElement(bm.Provider, {
        value: null
      }, typeof s == "function" ? s(i, a) : K.cloneElement(K.Children.only(s), a))
    );
  }, e;
}(K.Component);
Jr.contextType = bm;
Jr.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: F.shape({
    current: typeof Element > "u" ? F.any : function(t, e, r, n, i, o) {
      var s = t[e];
      return F.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(t, e, r, n, i, o);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: F.oneOfType([F.func.isRequired, F.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: F.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: F.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: F.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: F.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: F.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: F.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(e) {
    var r = i7;
    e.addEndListener || (r = r.isRequired);
    for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      i[o - 1] = arguments[o];
    return r.apply(void 0, [e].concat(i));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: F.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: F.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: F.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: F.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: F.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: F.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: F.func
} : {};
function si() {
}
Jr.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: si,
  onEntering: si,
  onEntered: si,
  onExit: si,
  onExiting: si,
  onExited: si
};
Jr.UNMOUNTED = uo;
Jr.EXITED = Dn;
Jr.ENTERING = Mn;
Jr.ENTERED = ci;
Jr.EXITING = fu;
const s7 = Jr;
function vm() {
  const t = gm(Cf);
  return process.env.NODE_ENV !== "production" && ve.useDebugValue(t), t[Tf] || t;
}
const a7 = (t) => t.scrollTop;
function e0(t, e) {
  var r, n;
  const {
    timeout: i,
    easing: o,
    style: s = {}
  } = t;
  return {
    duration: (r = s.transitionDuration) != null ? r : typeof i == "number" ? i : i[e.mode] || 0,
    easing: (n = s.transitionTimingFunction) != null ? n : typeof o == "object" ? o[e.mode] : o,
    delay: s.transitionDelay
  };
}
const l7 = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function du(t) {
  return `scale(${t}, ${t ** 2})`;
}
const c7 = {
  entering: {
    opacity: 1,
    transform: du(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, vc = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), If = /* @__PURE__ */ ve.forwardRef(function(e, r) {
  const {
    addEndListener: n,
    appear: i = !0,
    children: o,
    easing: s,
    in: a,
    onEnter: l,
    onEntered: c,
    onEntering: u,
    onExit: f,
    onExited: d,
    onExiting: h,
    style: g,
    timeout: p = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: y = s7
  } = e, b = vn(e, l7), x = ve.useRef(), S = ve.useRef(), O = vm(), _ = ve.useRef(null), B = Yn(_, o.ref, r), N = (U) => (I) => {
    if (U) {
      const V = _.current;
      I === void 0 ? U(V) : U(V, I);
    }
  }, j = N(u), W = N((U, I) => {
    a7(U);
    const {
      duration: V,
      delay: te,
      easing: X
    } = e0({
      style: g,
      timeout: p,
      easing: s
    }, {
      mode: "enter"
    });
    let H;
    p === "auto" ? (H = O.transitions.getAutoHeightDuration(U.clientHeight), S.current = H) : H = V, U.style.transition = [O.transitions.create("opacity", {
      duration: H,
      delay: te
    }), O.transitions.create("transform", {
      duration: vc ? H : H * 0.666,
      delay: te,
      easing: X
    })].join(","), l && l(U, I);
  }), G = N(c), ee = N(h), fe = N((U) => {
    const {
      duration: I,
      delay: V,
      easing: te
    } = e0({
      style: g,
      timeout: p,
      easing: s
    }, {
      mode: "exit"
    });
    let X;
    p === "auto" ? (X = O.transitions.getAutoHeightDuration(U.clientHeight), S.current = X) : X = I, U.style.transition = [O.transitions.create("opacity", {
      duration: X,
      delay: V
    }), O.transitions.create("transform", {
      duration: vc ? X : X * 0.666,
      delay: vc ? V : V || X * 0.333,
      easing: te
    })].join(","), U.style.opacity = 0, U.style.transform = du(0.75), f && f(U);
  }), P = N(d), z = (U) => {
    p === "auto" && (x.current = setTimeout(U, S.current || 0)), n && n(_.current, U);
  };
  return ve.useEffect(() => () => {
    clearTimeout(x.current);
  }, []), /* @__PURE__ */ Bt.jsx(y, ke({
    appear: i,
    in: a,
    nodeRef: _,
    onEnter: W,
    onEntered: G,
    onEntering: j,
    onExit: fe,
    onExited: P,
    onExiting: ee,
    addEndListener: z,
    timeout: p === "auto" ? null : p
  }, b, {
    children: (U, I) => /* @__PURE__ */ ve.cloneElement(o, ke({
      style: ke({
        opacity: 0,
        transform: du(0.75),
        visibility: U === "exited" && !a ? "hidden" : void 0
      }, c7[U], g, o.props.style),
      ref: B
    }, I))
  }));
});
process.env.NODE_ENV !== "production" && (If.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: F.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: F.bool,
  /**
   * A single child content element.
   */
  children: Ig.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: F.oneOfType([F.shape({
    enter: F.string,
    exit: F.string
  }), F.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: F.bool,
  /**
   * @ignore
   */
  onEnter: F.func,
  /**
   * @ignore
   */
  onEntered: F.func,
  /**
   * @ignore
   */
  onEntering: F.func,
  /**
   * @ignore
   */
  onExit: F.func,
  /**
   * @ignore
   */
  onExited: F.func,
  /**
   * @ignore
   */
  onExiting: F.func,
  /**
   * @ignore
   */
  style: F.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: F.oneOfType([F.oneOf(["auto"]), F.number, F.shape({
    appear: F.number,
    enter: F.number,
    exit: F.number
  })])
});
If.muiSupportAuto = !0;
const t0 = If, u7 = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], f7 = os(Jx, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (t, e) => e.root
})({}), Am = /* @__PURE__ */ ve.forwardRef(function(e, r) {
  var n;
  const i = pm(), o = Of({
    props: e,
    name: "MuiPopper"
  }), {
    anchorEl: s,
    component: a,
    components: l,
    componentsProps: c,
    container: u,
    disablePortal: f,
    keepMounted: d,
    modifiers: h,
    open: g,
    placement: p,
    popperOptions: y,
    popperRef: b,
    transition: x,
    slots: S,
    slotProps: O
  } = o, _ = vn(o, u7), B = (n = S == null ? void 0 : S.root) != null ? n : l == null ? void 0 : l.Root, N = ke({
    anchorEl: s,
    container: u,
    disablePortal: f,
    keepMounted: d,
    modifiers: h,
    open: g,
    placement: p,
    popperOptions: y,
    popperRef: b,
    transition: x
  }, _);
  return /* @__PURE__ */ Bt.jsx(f7, ke({
    as: a,
    direction: i == null ? void 0 : i.direction,
    slots: {
      root: B
    },
    slotProps: O ?? c
  }, N, {
    ref: r
  }));
});
process.env.NODE_ENV !== "production" && (Am.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: F.oneOfType([jo, F.object, F.func]),
  /**
   * Popper render function or node.
   */
  children: F.oneOfType([F.node, F.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: F.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: F.shape({
    Root: F.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: F.shape({
    root: F.oneOfType([F.func, F.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: F.oneOfType([jo, F.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: F.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: F.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: F.arrayOf(F.shape({
    data: F.object,
    effect: F.func,
    enabled: F.bool,
    fn: F.func,
    name: F.any,
    options: F.object,
    phase: F.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: F.arrayOf(F.string),
    requiresIfExists: F.arrayOf(F.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: F.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: F.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: F.shape({
    modifiers: F.array,
    onFirstUpdate: F.func,
    placement: F.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: F.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Rg,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: F.shape({
    root: F.oneOfType([F.func, F.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: F.shape({
    root: F.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: F.oneOfType([F.arrayOf(F.oneOfType([F.func, F.object, F.bool])), F.func, F.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: F.bool
});
const wm = Am;
function d7(t) {
  return $o("MuiTooltip", t);
}
const h7 = sf("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), sn = h7, p7 = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function g7(t) {
  return Math.round(t * 1e5) / 1e5;
}
const m7 = (t) => {
  const {
    classes: e,
    disableInteractive: r,
    arrow: n,
    touch: i,
    placement: o
  } = t, s = {
    popper: ["popper", !r && "popperInteractive", n && "popperArrow"],
    tooltip: ["tooltip", n && "tooltipArrow", i && "touch", `tooltipPlacement${ir(o.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return of(s, d7, e);
}, y7 = os(wm, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (t, e) => {
    const {
      ownerState: r
    } = t;
    return [e.popper, !r.disableInteractive && e.popperInteractive, r.arrow && e.popperArrow, !r.open && e.popperClose];
  }
})(({
  theme: t,
  ownerState: e,
  open: r
}) => ke({
  zIndex: (t.vars || t).zIndex.tooltip,
  pointerEvents: "none"
}, !e.disableInteractive && {
  pointerEvents: "auto"
}, !r && {
  pointerEvents: "none"
}, e.arrow && {
  [`&[data-popper-placement*="bottom"] .${sn.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${sn.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${sn.arrow}`]: ke({}, e.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${sn.arrow}`]: ke({}, e.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), b7 = os("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (t, e) => {
    const {
      ownerState: r
    } = t;
    return [e.tooltip, r.touch && e.touch, r.arrow && e.tooltipArrow, e[`tooltipPlacement${ir(r.placement.split("-")[0])}`]];
  }
})(({
  theme: t,
  ownerState: e
}) => ke({
  backgroundColor: t.vars ? t.vars.palette.Tooltip.bg : ym(t.palette.grey[700], 0.92),
  borderRadius: (t.vars || t).shape.borderRadius,
  color: (t.vars || t).palette.common.white,
  fontFamily: t.typography.fontFamily,
  padding: "4px 8px",
  fontSize: t.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: t.typography.fontWeightMedium
}, e.arrow && {
  position: "relative",
  margin: 0
}, e.touch && {
  padding: "8px 16px",
  fontSize: t.typography.pxToRem(14),
  lineHeight: `${g7(16 / 14)}em`,
  fontWeight: t.typography.fontWeightRegular
}, {
  [`.${sn.popper}[data-popper-placement*="left"] &`]: ke({
    transformOrigin: "right center"
  }, e.isRtl ? ke({
    marginLeft: "14px"
  }, e.touch && {
    marginLeft: "24px"
  }) : ke({
    marginRight: "14px"
  }, e.touch && {
    marginRight: "24px"
  })),
  [`.${sn.popper}[data-popper-placement*="right"] &`]: ke({
    transformOrigin: "left center"
  }, e.isRtl ? ke({
    marginRight: "14px"
  }, e.touch && {
    marginRight: "24px"
  }) : ke({
    marginLeft: "14px"
  }, e.touch && {
    marginLeft: "24px"
  })),
  [`.${sn.popper}[data-popper-placement*="top"] &`]: ke({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, e.touch && {
    marginBottom: "24px"
  }),
  [`.${sn.popper}[data-popper-placement*="bottom"] &`]: ke({
    transformOrigin: "center top",
    marginTop: "14px"
  }, e.touch && {
    marginTop: "24px"
  })
})), v7 = os("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (t, e) => e.arrow
})(({
  theme: t
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: t.vars ? t.vars.palette.Tooltip.bg : ym(t.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let Ns = !1, Ac = null, eo = {
  x: 0,
  y: 0
};
function Bs(t, e) {
  return (r) => {
    e && e(r), t(r);
  };
}
const xm = /* @__PURE__ */ ve.forwardRef(function(e, r) {
  var n, i, o, s, a, l, c, u, f, d, h, g, p, y, b, x, S, O, _;
  const B = Of({
    props: e,
    name: "MuiTooltip"
  }), {
    arrow: N = !1,
    children: j,
    components: W = {},
    componentsProps: G = {},
    describeChild: ee = !1,
    disableFocusListener: fe = !1,
    disableHoverListener: P = !1,
    disableInteractive: z = !1,
    disableTouchListener: U = !1,
    enterDelay: I = 100,
    enterNextDelay: V = 0,
    enterTouchDelay: te = 700,
    followCursor: X = !1,
    id: H,
    leaveDelay: $ = 0,
    leaveTouchDelay: se = 1500,
    onClose: he,
    onOpen: pe,
    open: me,
    placement: L = "bottom",
    PopperComponent: q,
    PopperProps: Z = {},
    slotProps: oe = {},
    slots: de = {},
    title: R,
    TransitionComponent: k = t0,
    TransitionProps: re
  } = B, ne = vn(B, p7), Ae = vm(), C = Ae.direction === "rtl", [v, w] = ve.useState(), [D, J] = ve.useState(null), ae = ve.useRef(!1), ue = z || X, Se = ve.useRef(), _e = ve.useRef(), we = ve.useRef(), Ne = ve.useRef(), [E, m] = Mg({
    controlled: me,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let A = E;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: Re
    } = ve.useRef(me !== void 0);
    ve.useEffect(() => {
      v && v.disabled && !Re && R !== "" && v.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [R, v, Re]);
  }
  const M = Dg(H), Q = ve.useRef(), ie = ve.useCallback(() => {
    Q.current !== void 0 && (document.body.style.WebkitUserSelect = Q.current, Q.current = void 0), clearTimeout(Ne.current);
  }, []);
  ve.useEffect(() => () => {
    clearTimeout(Se.current), clearTimeout(_e.current), clearTimeout(we.current), ie();
  }, [ie]);
  const le = (Re) => {
    clearTimeout(Ac), Ns = !0, m(!0), pe && !A && pe(Re);
  }, Ee = Ng(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Re) => {
      clearTimeout(Ac), Ac = setTimeout(() => {
        Ns = !1;
      }, 800 + $), m(!1), he && A && he(Re), clearTimeout(Se.current), Se.current = setTimeout(() => {
        ae.current = !1;
      }, Ae.transitions.duration.shortest);
    }
  ), Fe = (Re) => {
    ae.current && Re.type !== "touchstart" || (v && v.removeAttribute("title"), clearTimeout(_e.current), clearTimeout(we.current), I || Ns && V ? _e.current = setTimeout(() => {
      le(Re);
    }, Ns ? V : I) : le(Re));
  }, Ve = (Re) => {
    clearTimeout(_e.current), clearTimeout(we.current), we.current = setTimeout(() => {
      Ee(Re);
    }, $);
  }, {
    isFocusVisibleRef: Ge,
    onBlur: Ue,
    onFocus: bl,
    ref: as
  } = Bg(), [, ls] = ve.useState(!1), Bi = (Re) => {
    Ue(Re), Ge.current === !1 && (ls(!1), Ve(Re));
  }, Li = (Re) => {
    v || w(Re.currentTarget), bl(Re), Ge.current === !0 && (ls(!0), Fe(Re));
  }, cs = (Re) => {
    ae.current = !0;
    const qt = j.props;
    qt.onTouchStart && qt.onTouchStart(Re);
  }, us = Fe, Fi = Ve, vl = (Re) => {
    cs(Re), clearTimeout(we.current), clearTimeout(Se.current), ie(), Q.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Ne.current = setTimeout(() => {
      document.body.style.WebkitUserSelect = Q.current, Fe(Re);
    }, te);
  }, Al = (Re) => {
    j.props.onTouchEnd && j.props.onTouchEnd(Re), ie(), clearTimeout(we.current), we.current = setTimeout(() => {
      Ee(Re);
    }, se);
  };
  ve.useEffect(() => {
    if (!A)
      return;
    function Re(qt) {
      (qt.key === "Escape" || qt.key === "Esc") && Ee(qt);
    }
    return document.addEventListener("keydown", Re), () => {
      document.removeEventListener("keydown", Re);
    };
  }, [Ee, A]);
  const wl = Yn(j.ref, as, w, r);
  !R && R !== 0 && (A = !1);
  const ji = ve.useRef(), Y = (Re) => {
    const qt = j.props;
    qt.onMouseMove && qt.onMouseMove(Re), eo = {
      x: Re.clientX,
      y: Re.clientY
    }, ji.current && ji.current.update();
  }, ge = {}, be = typeof R == "string";
  ee ? (ge.title = !A && be && !P ? R : null, ge["aria-describedby"] = A ? M : null) : (ge["aria-label"] = be ? R : null, ge["aria-labelledby"] = A && !be ? M : null);
  const xe = ke({}, ge, ne, j.props, {
    className: lo(ne.className, j.props.className),
    onTouchStart: cs,
    ref: wl
  }, X ? {
    onMouseMove: Y
  } : {});
  process.env.NODE_ENV !== "production" && (xe["data-mui-internal-clone-element"] = !0, ve.useEffect(() => {
    v && !v.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [v]));
  const je = {};
  U || (xe.onTouchStart = vl, xe.onTouchEnd = Al), P || (xe.onMouseOver = Bs(us, xe.onMouseOver), xe.onMouseLeave = Bs(Fi, xe.onMouseLeave), ue || (je.onMouseOver = us, je.onMouseLeave = Fi)), fe || (xe.onFocus = Bs(Li, xe.onFocus), xe.onBlur = Bs(Bi, xe.onBlur), ue || (je.onFocus = Li, je.onBlur = Bi)), process.env.NODE_ENV !== "production" && j.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${j.props.title}\` or the Tooltip component.`].join(`
`));
  const Ze = ve.useMemo(() => {
    var Re;
    let qt = [{
      name: "arrow",
      enabled: !!D,
      options: {
        element: D,
        padding: 4
      }
    }];
    return (Re = Z.popperOptions) != null && Re.modifiers && (qt = qt.concat(Z.popperOptions.modifiers)), ke({}, Z.popperOptions, {
      modifiers: qt
    });
  }, [D, Z]), Ie = ke({}, B, {
    isRtl: C,
    arrow: N,
    disableInteractive: ue,
    placement: L,
    PopperComponentProp: q,
    touch: ae.current
  }), Pe = m7(Ie), At = (n = (i = de.popper) != null ? i : W.Popper) != null ? n : y7, lt = (o = (s = (a = de.transition) != null ? a : W.Transition) != null ? s : k) != null ? o : t0, ut = (l = (c = de.tooltip) != null ? c : W.Tooltip) != null ? l : b7, Zt = (u = (f = de.arrow) != null ? f : W.Arrow) != null ? u : v7, Qr = co(At, ke({}, Z, (d = oe.popper) != null ? d : G.popper, {
    className: lo(Pe.popper, Z == null ? void 0 : Z.className, (h = (g = oe.popper) != null ? g : G.popper) == null ? void 0 : h.className)
  }), Ie), fs = co(lt, ke({}, re, (p = oe.transition) != null ? p : G.transition), Ie), lr = co(ut, ke({}, (y = oe.tooltip) != null ? y : G.tooltip, {
    className: lo(Pe.tooltip, (b = (x = oe.tooltip) != null ? x : G.tooltip) == null ? void 0 : b.className)
  }), Ie), Um = co(Zt, ke({}, (S = oe.arrow) != null ? S : G.arrow, {
    className: lo(Pe.arrow, (O = (_ = oe.arrow) != null ? _ : G.arrow) == null ? void 0 : O.className)
  }), Ie);
  return /* @__PURE__ */ Bt.jsxs(ve.Fragment, {
    children: [/* @__PURE__ */ ve.cloneElement(j, xe), /* @__PURE__ */ Bt.jsx(At, ke({
      as: q ?? wm,
      placement: L,
      anchorEl: X ? {
        getBoundingClientRect: () => ({
          top: eo.y,
          left: eo.x,
          right: eo.x,
          bottom: eo.y,
          width: 0,
          height: 0
        })
      } : v,
      popperRef: ji,
      open: v ? A : !1,
      id: M,
      transition: !0
    }, je, Qr, {
      popperOptions: Ze,
      children: ({
        TransitionProps: Re
      }) => /* @__PURE__ */ Bt.jsx(lt, ke({
        timeout: Ae.transitions.duration.shorter
      }, Re, fs, {
        children: /* @__PURE__ */ Bt.jsxs(ut, ke({}, lr, {
          children: [R, N ? /* @__PURE__ */ Bt.jsx(Zt, ke({}, Um, {
            ref: J
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (xm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: F.bool,
  /**
   * Tooltip reference element.
   */
  children: Ig.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: F.object,
  /**
   * @ignore
   */
  className: F.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: F.shape({
    Arrow: F.elementType,
    Popper: F.elementType,
    Tooltip: F.elementType,
    Transition: F.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: F.shape({
    arrow: F.object,
    popper: F.object,
    tooltip: F.object,
    transition: F.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: F.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: F.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: F.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: F.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: F.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: F.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: F.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: F.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: F.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: F.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: F.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: F.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: F.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: F.func,
  /**
   * If `true`, the component is shown.
   */
  open: F.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: F.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: F.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: F.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: F.shape({
    arrow: F.object,
    popper: F.object,
    tooltip: F.object,
    transition: F.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: F.shape({
    arrow: F.elementType,
    popper: F.elementType,
    tooltip: F.elementType,
    transition: F.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: F.oneOfType([F.arrayOf(F.oneOfType([F.func, F.object, F.bool])), F.func, F.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: F.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: F.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: F.object
});
const A7 = xm;
var hu = {}, w7 = {
  get exports() {
    return hu;
  },
  set exports(t) {
    hu = t;
  }
};
(function(t) {
  function e(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(w7);
var wc = {};
function x7(t) {
  return $o("MuiSvgIcon", t);
}
sf("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const _7 = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], S7 = (t) => {
  const {
    color: e,
    fontSize: r,
    classes: n
  } = t, i = {
    root: ["root", e !== "inherit" && `color${ir(e)}`, `fontSize${ir(r)}`]
  };
  return of(i, x7, n);
}, E7 = os("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (t, e) => {
    const {
      ownerState: r
    } = t;
    return [e.root, r.color !== "inherit" && e[`color${ir(r.color)}`], e[`fontSize${ir(r.fontSize)}`]];
  }
})(({
  theme: t,
  ownerState: e
}) => {
  var r, n, i, o, s, a, l, c, u, f, d, h, g, p, y, b, x;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    fill: "currentColor",
    flexShrink: 0,
    transition: (r = t.transitions) == null || (n = r.create) == null ? void 0 : n.call(r, "fill", {
      duration: (i = t.transitions) == null || (o = i.duration) == null ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((s = t.typography) == null || (a = s.pxToRem) == null ? void 0 : a.call(s, 20)) || "1.25rem",
      medium: ((l = t.typography) == null || (c = l.pxToRem) == null ? void 0 : c.call(l, 24)) || "1.5rem",
      large: ((u = t.typography) == null || (f = u.pxToRem) == null ? void 0 : f.call(u, 35)) || "2.1875rem"
    }[e.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (d = (h = (t.vars || t).palette) == null || (g = h[e.color]) == null ? void 0 : g.main) != null ? d : {
      action: (p = (t.vars || t).palette) == null || (y = p.action) == null ? void 0 : y.active,
      disabled: (b = (t.vars || t).palette) == null || (x = b.action) == null ? void 0 : x.disabled,
      inherit: void 0
    }[e.color]
  };
}), Pf = /* @__PURE__ */ ve.forwardRef(function(e, r) {
  const n = Of({
    props: e,
    name: "MuiSvgIcon"
  }), {
    children: i,
    className: o,
    color: s = "inherit",
    component: a = "svg",
    fontSize: l = "medium",
    htmlColor: c,
    inheritViewBox: u = !1,
    titleAccess: f,
    viewBox: d = "0 0 24 24"
  } = n, h = vn(n, _7), g = ke({}, n, {
    color: s,
    component: a,
    fontSize: l,
    instanceFontSize: e.fontSize,
    inheritViewBox: u,
    viewBox: d
  }), p = {};
  u || (p.viewBox = d);
  const y = S7(g);
  return /* @__PURE__ */ Bt.jsxs(E7, ke({
    as: a,
    className: lo(y.root, o),
    focusable: "false",
    color: c,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: r
  }, p, h, {
    ownerState: g,
    children: [i, f ? /* @__PURE__ */ Bt.jsx("title", {
      children: f
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Pf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: F.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: F.object,
  /**
   * @ignore
   */
  className: F.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: F.oneOfType([F.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), F.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: F.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: F.oneOfType([F.oneOf(["inherit", "large", "medium", "small"]), F.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: F.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: F.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: F.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: F.oneOfType([F.arrayOf(F.oneOfType([F.func, F.object, F.bool])), F.func, F.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: F.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: F.string
});
Pf.muiName = "SvgIcon";
const r0 = Pf;
function k7(t, e) {
  function r(n, i) {
    return /* @__PURE__ */ Bt.jsx(r0, ke({
      "data-testid": `${e}Icon`,
      ref: i
    }, n, {
      children: t
    }));
  }
  return process.env.NODE_ENV !== "production" && (r.displayName = `${e}Icon`), r.muiName = r0.muiName, /* @__PURE__ */ ve.memo(/* @__PURE__ */ ve.forwardRef(r));
}
const C7 = {
  configure: (t) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), Fg.configure(t);
  }
}, T7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: ir,
  createChainedFunction: e4,
  createSvgIcon: k7,
  debounce: t4,
  deprecatedPropType: r4,
  isMuiElement: n4,
  ownerDocument: Ea,
  ownerWindow: i4,
  requirePropFactory: o4,
  setRef: ka,
  unstable_ClassNameGenerator: C7,
  unstable_useEnhancedEffect: Ci,
  unstable_useId: Dg,
  unsupportedProp: l4,
  useControlled: Mg,
  useEventCallback: Ng,
  useForkRef: Yn,
  useIsFocusVisible: Bg
}, Symbol.toStringTag, { value: "Module" })), O7 = /* @__PURE__ */ g0(T7);
var n0;
function I7() {
  return n0 || (n0 = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e.createSvgIcon;
      }
    });
    var e = O7;
  }(wc)), wc;
}
const P7 = ({ text: t, displayText: e }) => {
  const [r, n] = ht(!1);
  return /* @__PURE__ */ K.createElement(A7, { title: r ? "Copied link!" : "Copy link to clipboard" }, /* @__PURE__ */ K.createElement(
    "button",
    {
      id: "btn-invite",
      className: "button-black btn-invite",
      onClick: () => {
        const i = { url: t, title: "Join my room" };
        navigator.share ? navigator.share(i).then(
          () => console.log("Hooray! Your content was shared to tha world")
        ).catch((o) => {
          console.log(
            `Oops! I couldn't share to the world because: ${o}`
          ), prompt("Copy the link below", t);
        }) : (n(!0), navigator.clipboard.writeText(t).catch((o) => {
          console.log(
            `Oops! I couldn't share to the world because: ${o}`
          ), prompt("Copy the link below", t);
        }), setTimeout(() => n(!1), 1e3));
      }
    },
    r ? "Copied!" : "Share link"
  ));
};
var Rf = {}, R7 = hu;
Object.defineProperty(Rf, "__esModule", {
  value: !0
});
var _m = Rf.default = void 0, D7 = R7(I7()), M7 = jg(), N7 = (0, D7.default)(/* @__PURE__ */ (0, M7.jsx)("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
}), "Refresh");
_m = Rf.default = N7;
const Sm = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAzMSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjQ4OTEzNiA1LjI1MzE3QzAuNDg5MTM2IDIuNDkxNzUgMi43Mjc3MSAwLjI1MzE3NCA1LjQ4OTE0IDAuMjUzMTc0SDI1LjQ4OTFDMjguMjUwNiAwLjI1MzE3NCAzMC40ODkxIDIuNDkxNzUgMzAuNDg5MSA1LjI1MzE3VjE3LjI1MzJDMzAuNDg5MSAyMC4wMTQ2IDI4LjI1MDYgMjIuMjUzMiAyNS40ODkxIDIyLjI1MzJIMjIuNzM5MVYyMC4yNTMySDI1LjQ4OTFDMjcuMTQ2IDIwLjI1MzIgMjguNDg5MSAxOC45MSAyOC40ODkxIDE3LjI1MzJWNS4yNTMxN0MyOC40ODkxIDMuNTk2MzIgMjcuMTQ2IDIuMjUzMTcgMjUuNDg5MSAyLjI1MzE3SDUuNDg5MTRDMy44MzIyOCAyLjI1MzE3IDIuNDg5MTQgMy41OTYzMiAyLjQ4OTE0IDUuMjUzMTdWMTcuMjUzMkMyLjQ4OTE0IDE4LjkxIDMuODMyMjggMjAuMjUzMiA1LjQ4OTE0IDIwLjI1MzJINy40ODkxNFYyMi4yNTMySDUuNDg5MTRDMi43Mjc3MSAyMi4yNTMyIDAuNDg5MTM2IDIwLjAxNDYgMC40ODkxMzYgMTcuMjUzMlY1LjI1MzE3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0Ljk4OTEgMTUuMjUzMkwyMi4zNTA0IDI1Ljc1MzJINy42Mjc5MkwxNC45ODkxIDE1LjI1MzJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
var Em = {}, km = {
  MODE_NUMBER: 1 << 0,
  MODE_ALPHA_NUM: 1 << 1,
  MODE_8BIT_BYTE: 1 << 2,
  MODE_KANJI: 1 << 3
}, B7 = km;
function Cm(t) {
  this.mode = B7.MODE_8BIT_BYTE, this.data = t;
}
Cm.prototype = {
  getLength: function(t) {
    return this.data.length;
  },
  write: function(t) {
    for (var e = 0; e < this.data.length; e++)
      t.put(this.data.charCodeAt(e), 8);
  }
};
var L7 = Cm, Tm = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
}, Ls = Tm;
function Sr(t, e) {
  this.totalCount = t, this.dataCount = e;
}
Sr.RS_BLOCK_TABLE = [
  // L
  // M
  // Q
  // H
  // 1
  [1, 26, 19],
  [1, 26, 16],
  [1, 26, 13],
  [1, 26, 9],
  // 2
  [1, 44, 34],
  [1, 44, 28],
  [1, 44, 22],
  [1, 44, 16],
  // 3
  [1, 70, 55],
  [1, 70, 44],
  [2, 35, 17],
  [2, 35, 13],
  // 4		
  [1, 100, 80],
  [2, 50, 32],
  [2, 50, 24],
  [4, 25, 9],
  // 5
  [1, 134, 108],
  [2, 67, 43],
  [2, 33, 15, 2, 34, 16],
  [2, 33, 11, 2, 34, 12],
  // 6
  [2, 86, 68],
  [4, 43, 27],
  [4, 43, 19],
  [4, 43, 15],
  // 7		
  [2, 98, 78],
  [4, 49, 31],
  [2, 32, 14, 4, 33, 15],
  [4, 39, 13, 1, 40, 14],
  // 8
  [2, 121, 97],
  [2, 60, 38, 2, 61, 39],
  [4, 40, 18, 2, 41, 19],
  [4, 40, 14, 2, 41, 15],
  // 9
  [2, 146, 116],
  [3, 58, 36, 2, 59, 37],
  [4, 36, 16, 4, 37, 17],
  [4, 36, 12, 4, 37, 13],
  // 10		
  [2, 86, 68, 2, 87, 69],
  [4, 69, 43, 1, 70, 44],
  [6, 43, 19, 2, 44, 20],
  [6, 43, 15, 2, 44, 16],
  // 11
  [4, 101, 81],
  [1, 80, 50, 4, 81, 51],
  [4, 50, 22, 4, 51, 23],
  [3, 36, 12, 8, 37, 13],
  // 12
  [2, 116, 92, 2, 117, 93],
  [6, 58, 36, 2, 59, 37],
  [4, 46, 20, 6, 47, 21],
  [7, 42, 14, 4, 43, 15],
  // 13
  [4, 133, 107],
  [8, 59, 37, 1, 60, 38],
  [8, 44, 20, 4, 45, 21],
  [12, 33, 11, 4, 34, 12],
  // 14
  [3, 145, 115, 1, 146, 116],
  [4, 64, 40, 5, 65, 41],
  [11, 36, 16, 5, 37, 17],
  [11, 36, 12, 5, 37, 13],
  // 15
  [5, 109, 87, 1, 110, 88],
  [5, 65, 41, 5, 66, 42],
  [5, 54, 24, 7, 55, 25],
  [11, 36, 12],
  // 16
  [5, 122, 98, 1, 123, 99],
  [7, 73, 45, 3, 74, 46],
  [15, 43, 19, 2, 44, 20],
  [3, 45, 15, 13, 46, 16],
  // 17
  [1, 135, 107, 5, 136, 108],
  [10, 74, 46, 1, 75, 47],
  [1, 50, 22, 15, 51, 23],
  [2, 42, 14, 17, 43, 15],
  // 18
  [5, 150, 120, 1, 151, 121],
  [9, 69, 43, 4, 70, 44],
  [17, 50, 22, 1, 51, 23],
  [2, 42, 14, 19, 43, 15],
  // 19
  [3, 141, 113, 4, 142, 114],
  [3, 70, 44, 11, 71, 45],
  [17, 47, 21, 4, 48, 22],
  [9, 39, 13, 16, 40, 14],
  // 20
  [3, 135, 107, 5, 136, 108],
  [3, 67, 41, 13, 68, 42],
  [15, 54, 24, 5, 55, 25],
  [15, 43, 15, 10, 44, 16],
  // 21
  [4, 144, 116, 4, 145, 117],
  [17, 68, 42],
  [17, 50, 22, 6, 51, 23],
  [19, 46, 16, 6, 47, 17],
  // 22
  [2, 139, 111, 7, 140, 112],
  [17, 74, 46],
  [7, 54, 24, 16, 55, 25],
  [34, 37, 13],
  // 23
  [4, 151, 121, 5, 152, 122],
  [4, 75, 47, 14, 76, 48],
  [11, 54, 24, 14, 55, 25],
  [16, 45, 15, 14, 46, 16],
  // 24
  [6, 147, 117, 4, 148, 118],
  [6, 73, 45, 14, 74, 46],
  [11, 54, 24, 16, 55, 25],
  [30, 46, 16, 2, 47, 17],
  // 25
  [8, 132, 106, 4, 133, 107],
  [8, 75, 47, 13, 76, 48],
  [7, 54, 24, 22, 55, 25],
  [22, 45, 15, 13, 46, 16],
  // 26
  [10, 142, 114, 2, 143, 115],
  [19, 74, 46, 4, 75, 47],
  [28, 50, 22, 6, 51, 23],
  [33, 46, 16, 4, 47, 17],
  // 27
  [8, 152, 122, 4, 153, 123],
  [22, 73, 45, 3, 74, 46],
  [8, 53, 23, 26, 54, 24],
  [12, 45, 15, 28, 46, 16],
  // 28
  [3, 147, 117, 10, 148, 118],
  [3, 73, 45, 23, 74, 46],
  [4, 54, 24, 31, 55, 25],
  [11, 45, 15, 31, 46, 16],
  // 29
  [7, 146, 116, 7, 147, 117],
  [21, 73, 45, 7, 74, 46],
  [1, 53, 23, 37, 54, 24],
  [19, 45, 15, 26, 46, 16],
  // 30
  [5, 145, 115, 10, 146, 116],
  [19, 75, 47, 10, 76, 48],
  [15, 54, 24, 25, 55, 25],
  [23, 45, 15, 25, 46, 16],
  // 31
  [13, 145, 115, 3, 146, 116],
  [2, 74, 46, 29, 75, 47],
  [42, 54, 24, 1, 55, 25],
  [23, 45, 15, 28, 46, 16],
  // 32
  [17, 145, 115],
  [10, 74, 46, 23, 75, 47],
  [10, 54, 24, 35, 55, 25],
  [19, 45, 15, 35, 46, 16],
  // 33
  [17, 145, 115, 1, 146, 116],
  [14, 74, 46, 21, 75, 47],
  [29, 54, 24, 19, 55, 25],
  [11, 45, 15, 46, 46, 16],
  // 34
  [13, 145, 115, 6, 146, 116],
  [14, 74, 46, 23, 75, 47],
  [44, 54, 24, 7, 55, 25],
  [59, 46, 16, 1, 47, 17],
  // 35
  [12, 151, 121, 7, 152, 122],
  [12, 75, 47, 26, 76, 48],
  [39, 54, 24, 14, 55, 25],
  [22, 45, 15, 41, 46, 16],
  // 36
  [6, 151, 121, 14, 152, 122],
  [6, 75, 47, 34, 76, 48],
  [46, 54, 24, 10, 55, 25],
  [2, 45, 15, 64, 46, 16],
  // 37
  [17, 152, 122, 4, 153, 123],
  [29, 74, 46, 14, 75, 47],
  [49, 54, 24, 10, 55, 25],
  [24, 45, 15, 46, 46, 16],
  // 38
  [4, 152, 122, 18, 153, 123],
  [13, 74, 46, 32, 75, 47],
  [48, 54, 24, 14, 55, 25],
  [42, 45, 15, 32, 46, 16],
  // 39
  [20, 147, 117, 4, 148, 118],
  [40, 75, 47, 7, 76, 48],
  [43, 54, 24, 22, 55, 25],
  [10, 45, 15, 67, 46, 16],
  // 40
  [19, 148, 118, 6, 149, 119],
  [18, 75, 47, 31, 76, 48],
  [34, 54, 24, 34, 55, 25],
  [20, 45, 15, 61, 46, 16]
];
Sr.getRSBlocks = function(t, e) {
  var r = Sr.getRsBlockTable(t, e);
  if (r == null)
    throw new Error("bad rs block @ typeNumber:" + t + "/errorCorrectLevel:" + e);
  for (var n = r.length / 3, i = new Array(), o = 0; o < n; o++)
    for (var s = r[o * 3 + 0], a = r[o * 3 + 1], l = r[o * 3 + 2], c = 0; c < s; c++)
      i.push(new Sr(a, l));
  return i;
};
Sr.getRsBlockTable = function(t, e) {
  switch (e) {
    case Ls.L:
      return Sr.RS_BLOCK_TABLE[(t - 1) * 4 + 0];
    case Ls.M:
      return Sr.RS_BLOCK_TABLE[(t - 1) * 4 + 1];
    case Ls.Q:
      return Sr.RS_BLOCK_TABLE[(t - 1) * 4 + 2];
    case Ls.H:
      return Sr.RS_BLOCK_TABLE[(t - 1) * 4 + 3];
    default:
      return;
  }
};
var F7 = Sr;
function Om() {
  this.buffer = new Array(), this.length = 0;
}
Om.prototype = {
  get: function(t) {
    var e = Math.floor(t / 8);
    return (this.buffer[e] >>> 7 - t % 8 & 1) == 1;
  },
  put: function(t, e) {
    for (var r = 0; r < e; r++)
      this.putBit((t >>> e - r - 1 & 1) == 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(t) {
    var e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
};
var j7 = Om, hr = {
  glog: function(t) {
    if (t < 1)
      throw new Error("glog(" + t + ")");
    return hr.LOG_TABLE[t];
  },
  gexp: function(t) {
    for (; t < 0; )
      t += 255;
    for (; t >= 256; )
      t -= 255;
    return hr.EXP_TABLE[t];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};
for (var Tt = 0; Tt < 8; Tt++)
  hr.EXP_TABLE[Tt] = 1 << Tt;
for (var Tt = 8; Tt < 256; Tt++)
  hr.EXP_TABLE[Tt] = hr.EXP_TABLE[Tt - 4] ^ hr.EXP_TABLE[Tt - 5] ^ hr.EXP_TABLE[Tt - 6] ^ hr.EXP_TABLE[Tt - 8];
for (var Tt = 0; Tt < 255; Tt++)
  hr.LOG_TABLE[hr.EXP_TABLE[Tt]] = Tt;
var Im = hr, On = Im;
function na(t, e) {
  if (t.length == null)
    throw new Error(t.length + "/" + e);
  for (var r = 0; r < t.length && t[r] == 0; )
    r++;
  this.num = new Array(t.length - r + e);
  for (var n = 0; n < t.length - r; n++)
    this.num[n] = t[n + r];
}
na.prototype = {
  get: function(t) {
    return this.num[t];
  },
  getLength: function() {
    return this.num.length;
  },
  multiply: function(t) {
    for (var e = new Array(this.getLength() + t.getLength() - 1), r = 0; r < this.getLength(); r++)
      for (var n = 0; n < t.getLength(); n++)
        e[r + n] ^= On.gexp(On.glog(this.get(r)) + On.glog(t.get(n)));
    return new na(e, 0);
  },
  mod: function(t) {
    if (this.getLength() - t.getLength() < 0)
      return this;
    for (var e = On.glog(this.get(0)) - On.glog(t.get(0)), r = new Array(this.getLength()), n = 0; n < this.getLength(); n++)
      r[n] = this.get(n);
    for (var n = 0; n < t.getLength(); n++)
      r[n] ^= On.gexp(On.glog(t.get(n)) + e);
    return new na(r, 0).mod(t);
  }
};
var Pm = na, er = km, i0 = Pm, W7 = Im, Zr = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}, Et = {
  PATTERN_POSITION_TABLE: [
    [],
    [6, 18],
    [6, 22],
    [6, 26],
    [6, 30],
    [6, 34],
    [6, 22, 38],
    [6, 24, 42],
    [6, 26, 46],
    [6, 28, 50],
    [6, 30, 54],
    [6, 32, 58],
    [6, 34, 62],
    [6, 26, 46, 66],
    [6, 26, 48, 70],
    [6, 26, 50, 74],
    [6, 30, 54, 78],
    [6, 30, 56, 82],
    [6, 30, 58, 86],
    [6, 34, 62, 90],
    [6, 28, 50, 72, 94],
    [6, 26, 50, 74, 98],
    [6, 30, 54, 78, 102],
    [6, 28, 54, 80, 106],
    [6, 32, 58, 84, 110],
    [6, 30, 58, 86, 114],
    [6, 34, 62, 90, 118],
    [6, 26, 50, 74, 98, 122],
    [6, 30, 54, 78, 102, 126],
    [6, 26, 52, 78, 104, 130],
    [6, 30, 56, 82, 108, 134],
    [6, 34, 60, 86, 112, 138],
    [6, 30, 58, 86, 114, 142],
    [6, 34, 62, 90, 118, 146],
    [6, 30, 54, 78, 102, 126, 150],
    [6, 24, 50, 76, 102, 128, 154],
    [6, 28, 54, 80, 106, 132, 158],
    [6, 32, 58, 84, 110, 136, 162],
    [6, 26, 54, 82, 110, 138, 166],
    [6, 30, 58, 86, 114, 142, 170]
  ],
  G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0,
  G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0,
  G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1,
  getBCHTypeInfo: function(t) {
    for (var e = t << 10; Et.getBCHDigit(e) - Et.getBCHDigit(Et.G15) >= 0; )
      e ^= Et.G15 << Et.getBCHDigit(e) - Et.getBCHDigit(Et.G15);
    return (t << 10 | e) ^ Et.G15_MASK;
  },
  getBCHTypeNumber: function(t) {
    for (var e = t << 12; Et.getBCHDigit(e) - Et.getBCHDigit(Et.G18) >= 0; )
      e ^= Et.G18 << Et.getBCHDigit(e) - Et.getBCHDigit(Et.G18);
    return t << 12 | e;
  },
  getBCHDigit: function(t) {
    for (var e = 0; t != 0; )
      e++, t >>>= 1;
    return e;
  },
  getPatternPosition: function(t) {
    return Et.PATTERN_POSITION_TABLE[t - 1];
  },
  getMask: function(t, e, r) {
    switch (t) {
      case Zr.PATTERN000:
        return (e + r) % 2 == 0;
      case Zr.PATTERN001:
        return e % 2 == 0;
      case Zr.PATTERN010:
        return r % 3 == 0;
      case Zr.PATTERN011:
        return (e + r) % 3 == 0;
      case Zr.PATTERN100:
        return (Math.floor(e / 2) + Math.floor(r / 3)) % 2 == 0;
      case Zr.PATTERN101:
        return e * r % 2 + e * r % 3 == 0;
      case Zr.PATTERN110:
        return (e * r % 2 + e * r % 3) % 2 == 0;
      case Zr.PATTERN111:
        return (e * r % 3 + (e + r) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + t);
    }
  },
  getErrorCorrectPolynomial: function(t) {
    for (var e = new i0([1], 0), r = 0; r < t; r++)
      e = e.multiply(new i0([1, W7.gexp(r)], 0));
    return e;
  },
  getLengthInBits: function(t, e) {
    if (1 <= e && e < 10)
      switch (t) {
        case er.MODE_NUMBER:
          return 10;
        case er.MODE_ALPHA_NUM:
          return 9;
        case er.MODE_8BIT_BYTE:
          return 8;
        case er.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + t);
      }
    else if (e < 27)
      switch (t) {
        case er.MODE_NUMBER:
          return 12;
        case er.MODE_ALPHA_NUM:
          return 11;
        case er.MODE_8BIT_BYTE:
          return 16;
        case er.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + t);
      }
    else if (e < 41)
      switch (t) {
        case er.MODE_NUMBER:
          return 14;
        case er.MODE_ALPHA_NUM:
          return 13;
        case er.MODE_8BIT_BYTE:
          return 16;
        case er.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + t);
      }
    else
      throw new Error("type:" + e);
  },
  getLostPoint: function(t) {
    for (var e = t.getModuleCount(), r = 0, n = 0; n < e; n++)
      for (var i = 0; i < e; i++) {
        for (var o = 0, s = t.isDark(n, i), a = -1; a <= 1; a++)
          if (!(n + a < 0 || e <= n + a))
            for (var l = -1; l <= 1; l++)
              i + l < 0 || e <= i + l || a == 0 && l == 0 || s == t.isDark(n + a, i + l) && o++;
        o > 5 && (r += 3 + o - 5);
      }
    for (var n = 0; n < e - 1; n++)
      for (var i = 0; i < e - 1; i++) {
        var c = 0;
        t.isDark(n, i) && c++, t.isDark(n + 1, i) && c++, t.isDark(n, i + 1) && c++, t.isDark(n + 1, i + 1) && c++, (c == 0 || c == 4) && (r += 3);
      }
    for (var n = 0; n < e; n++)
      for (var i = 0; i < e - 6; i++)
        t.isDark(n, i) && !t.isDark(n, i + 1) && t.isDark(n, i + 2) && t.isDark(n, i + 3) && t.isDark(n, i + 4) && !t.isDark(n, i + 5) && t.isDark(n, i + 6) && (r += 40);
    for (var i = 0; i < e; i++)
      for (var n = 0; n < e - 6; n++)
        t.isDark(n, i) && !t.isDark(n + 1, i) && t.isDark(n + 2, i) && t.isDark(n + 3, i) && t.isDark(n + 4, i) && !t.isDark(n + 5, i) && t.isDark(n + 6, i) && (r += 40);
    for (var u = 0, i = 0; i < e; i++)
      for (var n = 0; n < e; n++)
        t.isDark(n, i) && u++;
    var f = Math.abs(100 * u / e / e - 50) / 5;
    return r += f * 10, r;
  }
}, U7 = Et, z7 = L7, Rm = F7, Dm = j7, xn = U7, V7 = Pm;
function Er(t, e) {
  this.typeNumber = t, this.errorCorrectLevel = e, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
}
var Gt = Er.prototype;
Gt.addData = function(t) {
  var e = new z7(t);
  this.dataList.push(e), this.dataCache = null;
};
Gt.isDark = function(t, e) {
  if (t < 0 || this.moduleCount <= t || e < 0 || this.moduleCount <= e)
    throw new Error(t + "," + e);
  return this.modules[t][e];
};
Gt.getModuleCount = function() {
  return this.moduleCount;
};
Gt.make = function() {
  if (this.typeNumber < 1) {
    var t = 1;
    for (t = 1; t < 40; t++) {
      for (var e = Rm.getRSBlocks(t, this.errorCorrectLevel), r = new Dm(), n = 0, i = 0; i < e.length; i++)
        n += e[i].dataCount;
      for (var i = 0; i < this.dataList.length; i++) {
        var o = this.dataList[i];
        r.put(o.mode, 4), r.put(o.getLength(), xn.getLengthInBits(o.mode, t)), o.write(r);
      }
      if (r.getLengthInBits() <= n * 8)
        break;
    }
    this.typeNumber = t;
  }
  this.makeImpl(!1, this.getBestMaskPattern());
};
Gt.makeImpl = function(t, e) {
  this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
  for (var r = 0; r < this.moduleCount; r++) {
    this.modules[r] = new Array(this.moduleCount);
    for (var n = 0; n < this.moduleCount; n++)
      this.modules[r][n] = null;
  }
  this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(t, e), this.typeNumber >= 7 && this.setupTypeNumber(t), this.dataCache == null && (this.dataCache = Er.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, e);
};
Gt.setupPositionProbePattern = function(t, e) {
  for (var r = -1; r <= 7; r++)
    if (!(t + r <= -1 || this.moduleCount <= t + r))
      for (var n = -1; n <= 7; n++)
        e + n <= -1 || this.moduleCount <= e + n || (0 <= r && r <= 6 && (n == 0 || n == 6) || 0 <= n && n <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= n && n <= 4 ? this.modules[t + r][e + n] = !0 : this.modules[t + r][e + n] = !1);
};
Gt.getBestMaskPattern = function() {
  for (var t = 0, e = 0, r = 0; r < 8; r++) {
    this.makeImpl(!0, r);
    var n = xn.getLostPoint(this);
    (r == 0 || t > n) && (t = n, e = r);
  }
  return e;
};
Gt.createMovieClip = function(t, e, r) {
  var n = t.createEmptyMovieClip(e, r), i = 1;
  this.make();
  for (var o = 0; o < this.modules.length; o++)
    for (var s = o * i, a = 0; a < this.modules[o].length; a++) {
      var l = a * i, c = this.modules[o][a];
      c && (n.beginFill(0, 100), n.moveTo(l, s), n.lineTo(l + i, s), n.lineTo(l + i, s + i), n.lineTo(l, s + i), n.endFill());
    }
  return n;
};
Gt.setupTimingPattern = function() {
  for (var t = 8; t < this.moduleCount - 8; t++)
    this.modules[t][6] == null && (this.modules[t][6] = t % 2 == 0);
  for (var e = 8; e < this.moduleCount - 8; e++)
    this.modules[6][e] == null && (this.modules[6][e] = e % 2 == 0);
};
Gt.setupPositionAdjustPattern = function() {
  for (var t = xn.getPatternPosition(this.typeNumber), e = 0; e < t.length; e++)
    for (var r = 0; r < t.length; r++) {
      var n = t[e], i = t[r];
      if (this.modules[n][i] == null)
        for (var o = -2; o <= 2; o++)
          for (var s = -2; s <= 2; s++)
            o == -2 || o == 2 || s == -2 || s == 2 || o == 0 && s == 0 ? this.modules[n + o][i + s] = !0 : this.modules[n + o][i + s] = !1;
    }
};
Gt.setupTypeNumber = function(t) {
  for (var e = xn.getBCHTypeNumber(this.typeNumber), r = 0; r < 18; r++) {
    var n = !t && (e >> r & 1) == 1;
    this.modules[Math.floor(r / 3)][r % 3 + this.moduleCount - 8 - 3] = n;
  }
  for (var r = 0; r < 18; r++) {
    var n = !t && (e >> r & 1) == 1;
    this.modules[r % 3 + this.moduleCount - 8 - 3][Math.floor(r / 3)] = n;
  }
};
Gt.setupTypeInfo = function(t, e) {
  for (var r = this.errorCorrectLevel << 3 | e, n = xn.getBCHTypeInfo(r), i = 0; i < 15; i++) {
    var o = !t && (n >> i & 1) == 1;
    i < 6 ? this.modules[i][8] = o : i < 8 ? this.modules[i + 1][8] = o : this.modules[this.moduleCount - 15 + i][8] = o;
  }
  for (var i = 0; i < 15; i++) {
    var o = !t && (n >> i & 1) == 1;
    i < 8 ? this.modules[8][this.moduleCount - i - 1] = o : i < 9 ? this.modules[8][15 - i - 1 + 1] = o : this.modules[8][15 - i - 1] = o;
  }
  this.modules[this.moduleCount - 8][8] = !t;
};
Gt.mapData = function(t, e) {
  for (var r = -1, n = this.moduleCount - 1, i = 7, o = 0, s = this.moduleCount - 1; s > 0; s -= 2)
    for (s == 6 && s--; ; ) {
      for (var a = 0; a < 2; a++)
        if (this.modules[n][s - a] == null) {
          var l = !1;
          o < t.length && (l = (t[o] >>> i & 1) == 1);
          var c = xn.getMask(e, n, s - a);
          c && (l = !l), this.modules[n][s - a] = l, i--, i == -1 && (o++, i = 7);
        }
      if (n += r, n < 0 || this.moduleCount <= n) {
        n -= r, r = -r;
        break;
      }
    }
};
Er.PAD0 = 236;
Er.PAD1 = 17;
Er.createData = function(t, e, r) {
  for (var n = Rm.getRSBlocks(t, e), i = new Dm(), o = 0; o < r.length; o++) {
    var s = r[o];
    i.put(s.mode, 4), i.put(s.getLength(), xn.getLengthInBits(s.mode, t)), s.write(i);
  }
  for (var a = 0, o = 0; o < n.length; o++)
    a += n[o].dataCount;
  if (i.getLengthInBits() > a * 8)
    throw new Error("code length overflow. (" + i.getLengthInBits() + ">" + a * 8 + ")");
  for (i.getLengthInBits() + 4 <= a * 8 && i.put(0, 4); i.getLengthInBits() % 8 != 0; )
    i.putBit(!1);
  for (; !(i.getLengthInBits() >= a * 8 || (i.put(Er.PAD0, 8), i.getLengthInBits() >= a * 8)); )
    i.put(Er.PAD1, 8);
  return Er.createBytes(i, n);
};
Er.createBytes = function(t, e) {
  for (var r = 0, n = 0, i = 0, o = new Array(e.length), s = new Array(e.length), a = 0; a < e.length; a++) {
    var l = e[a].dataCount, c = e[a].totalCount - l;
    n = Math.max(n, l), i = Math.max(i, c), o[a] = new Array(l);
    for (var u = 0; u < o[a].length; u++)
      o[a][u] = 255 & t.buffer[u + r];
    r += l;
    var f = xn.getErrorCorrectPolynomial(c), d = new V7(o[a], f.getLength() - 1), h = d.mod(f);
    s[a] = new Array(f.getLength() - 1);
    for (var u = 0; u < s[a].length; u++) {
      var g = u + h.getLength() - s[a].length;
      s[a][u] = g >= 0 ? h.get(g) : 0;
    }
  }
  for (var p = 0, u = 0; u < e.length; u++)
    p += e[u].totalCount;
  for (var y = new Array(p), b = 0, u = 0; u < n; u++)
    for (var a = 0; a < e.length; a++)
      u < o[a].length && (y[b++] = o[a][u]);
  for (var u = 0; u < i; u++)
    for (var a = 0; a < e.length; a++)
      u < s[a].length && (y[b++] = s[a][u]);
  return y;
};
var q7 = Er, Df = {};
Object.defineProperty(Df, "__esModule", {
  value: !0
});
var H7 = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, Y7 = F, tr = Nm(Y7), Mm = K, Fs = Nm(Mm);
function Nm(t) {
  return t && t.__esModule ? t : { default: t };
}
function K7(t, e) {
  var r = {};
  for (var n in t)
    e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
  return r;
}
var X7 = {
  bgColor: tr.default.oneOfType([tr.default.object, tr.default.string]).isRequired,
  bgD: tr.default.string.isRequired,
  fgColor: tr.default.oneOfType([tr.default.object, tr.default.string]).isRequired,
  fgD: tr.default.string.isRequired,
  size: tr.default.number.isRequired,
  title: tr.default.string,
  viewBoxSize: tr.default.number.isRequired,
  xmlns: tr.default.string
}, J7 = {
  title: void 0,
  xmlns: "http://www.w3.org/2000/svg"
}, ml = (0, Mm.forwardRef)(function(t, e) {
  var r = t.bgColor, n = t.bgD, i = t.fgD, o = t.fgColor, s = t.size, a = t.title, l = t.viewBoxSize, c = K7(t, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize"]);
  return Fs.default.createElement(
    "svg",
    H7({}, c, { height: s, ref: e, viewBox: "0 0 " + l + " " + l, width: s }),
    a ? Fs.default.createElement(
      "title",
      null,
      a
    ) : null,
    Fs.default.createElement("path", { d: n, fill: r }),
    Fs.default.createElement("path", { d: i, fill: o })
  );
});
ml.displayName = "QRCodeSvg";
ml.propTypes = X7;
ml.defaultProps = J7;
Df.default = ml;
Object.defineProperty(Em, "__esModule", {
  value: !0
});
var Q7 = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, G7 = q7, Z7 = ss(G7), $7 = Tm, eS = ss($7), tS = F, Pr = ss(tS), Bm = K, rS = ss(Bm), nS = Df, iS = ss(nS);
function ss(t) {
  return t && t.__esModule ? t : { default: t };
}
function oS(t, e) {
  var r = {};
  for (var n in t)
    e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
  return r;
}
var sS = {
  bgColor: Pr.default.oneOfType([Pr.default.object, Pr.default.string]),
  fgColor: Pr.default.oneOfType([Pr.default.object, Pr.default.string]),
  level: Pr.default.string,
  size: Pr.default.number,
  value: Pr.default.string.isRequired
}, aS = {
  bgColor: "#FFFFFF",
  fgColor: "#000000",
  level: "L",
  size: 256
}, yl = (0, Bm.forwardRef)(function(t, e) {
  var r = t.bgColor, n = t.fgColor, i = t.level, o = t.size, s = t.value, a = oS(t, ["bgColor", "fgColor", "level", "size", "value"]), l = new Z7.default(-1, eS.default[i]);
  l.addData(s), l.make();
  var c = l.modules;
  return rS.default.createElement(iS.default, Q7({}, a, {
    bgColor: r,
    bgD: c.map(function(u, f) {
      return u.map(function(d, h) {
        return d ? "" : "M " + h + " " + f + " l 1 0 0 1 -1 0 Z";
      }).join(" ");
    }).join(" "),
    fgColor: n,
    fgD: c.map(function(u, f) {
      return u.map(function(d, h) {
        return d ? "M " + h + " " + f + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref: e,
    size: o,
    viewBoxSize: c.length
  }));
});
yl.displayName = "QRCode";
yl.propTypes = sS;
yl.defaultProps = aS;
var Lm = Em.default = yl;
function lS({
  zIndex: t,
  demoMode: e,
  noAbsolute: r,
  noText: n,
  size: i = 256,
  containerStyles: o = {},
  baseUrl: s = "https://joinplayroom.com/"
}) {
  const l = Me().currentRoom, c = c3(s, l);
  return /* @__PURE__ */ K.createElement(
    "div",
    {
      className: "room-code-sticker",
      style: {
        zIndex: t || "initial",
        position: r ? "initial" : "absolute",
        ...o
      }
    },
    /* @__PURE__ */ K.createElement("div", { className: "qr-code" }, /* @__PURE__ */ K.createElement(
      Lm,
      {
        id: "QRCodeScaled",
        size: i,
        style: { height: "auto", maxWidth: "100%", width: "100%" },
        value: c,
        viewBox: `0 0 ${i} ${i}`
      }
    )),
    !n && l && /* @__PURE__ */ K.createElement("div", { className: "room-code" }, /* @__PURE__ */ K.createElement("b", null, l), /* @__PURE__ */ K.createElement("span", null, "Scan QR code to join the room")),
    !n && !l && /* @__PURE__ */ K.createElement("div", { className: "room-code" }, /* @__PURE__ */ K.createElement("b", null, "Scan to start"), /* @__PURE__ */ K.createElement("span", null, "Download the game from the Appstore"))
  );
}
const cS = "data:image/svg+xml;base64,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", uS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNS43ODI0NyIgY3k9IjQuMjk2NjMiIHI9IjIuNDY5NTgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi4yIi8+CjxjaXJjbGUgY3g9IjE0LjM4NDYiIGN5PSI0LjI5NjYzIiByPSIyLjQ2OTU4IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuMiIvPgo8cmVjdCB4PSIxLjYiIHk9IjkuNzE4NDEiIHdpZHRoPSI4LjM2NDk5IiBoZWlnaHQ9IjcuNDIxNTgiIHJ4PSIxLjkiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi4yIi8+CjxyZWN0IHg9IjEwLjIwMjEiIHk9IjkuNzE4NDEiIHdpZHRoPSI4LjM2NDk5IiBoZWlnaHQ9IjcuNDIxNTgiIHJ4PSIxLjkiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi4yIi8+Cjwvc3ZnPgo=";
const fS = [
  // 10.0.0.0 - 10.255.255.255
  /^(:{2}f{4}:)?10(?:\.\d{1,3}){3}$/,
  // 127.0.0.0 - 127.255.255.255
  /^(:{2}f{4}:)?127(?:\.\d{1,3}){3}$/,
  // 169.254.1.0 - 169.254.254.255
  /^(::f{4}:)?169\.254\.([1-9]|1?\d\d|2[0-4]\d|25[0-4])\.\d{1,3}$/,
  // 172.16.0.0 - 172.31.255.255
  /^(:{2}f{4}:)?(172\.1[6-9]|172\.2\d|172\.3[01])(?:\.\d{1,3}){2}$/,
  // 192.168.0.0 - 192.168.255.255
  /^(:{2}f{4}:)?192\.168(?:\.\d{1,3}){2}$/,
  // fc00::/7
  /^f[cd][\da-f]{2}(::1$|:[\da-f]{1,4}){1,7}$/,
  // fe80::/10
  /^fe[89ab][\da-f](::1$|:[\da-f]{1,4}){1,7}$/
], dS = new RegExp(
  `^(${fS.map((t) => t.source).join("|")})$`
), hS = (
  // eslint-disable-next-line regexp/no-dupe-disjunctions
  new RegExp("(?![\\w-]{64})((^(?=[-\\w.]{1,253}\\.?$)((\\w{1,63}|(\\w[-\\w]{0,61}\\w))\\.?)+$)(?<!\\.{2}))")
);
function pS(t) {
  return typeof t != "string" ? !1 : dS.test(t) || t === "localhost" ? !0 : (hS.test(t), !1);
}
function Fm() {
  const t = location.hostname;
  return pS(t) ? "LOCAL" : Co(location.hostname + location.pathname).slice(0, 9);
}
function o0(t, e) {
  return Math.floor(Math.random() * (e - t + 1)) + t;
}
function gS(t) {
  let e = "";
  const r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length;
  for (let i = 0; i < t; ++i)
    e += r.charAt(Math.floor(Math.random() * n));
  return e;
}
const ai = [
  "#59BF82",
  "#FFF27A",
  "#F14EEB",
  "#FF7F56",
  "#6BDCFF",
  "#3905F5",
  "#FF3666"
], js = [
  "Eclipse",
  "Crankshaft",
  "Firetruck",
  "President",
  "Bat",
  "Avocado",
  "Holiday",
  "Salad",
  "Boom",
  "Cornflakes"
];
function s0(t) {
  return t && t.length > 0 ? t[Math.floor(Math.random() * t.length)] : Ha(qa(gS(10)));
}
function mS({ hide: t, playerState: e }) {
  var r;
  return /* @__PURE__ */ K.createElement(
    "div",
    {
      "data-testid": "full-room-popup",
      id: "full-room-popup",
      className: "full-room-container"
    },
    /* @__PURE__ */ K.createElement(
      Mi,
      {
        visible: !0,
        center: !0,
        style: {
          color: "#000",
          maxWidth: "500px",
          top: "50%",
          position: "absolute",
          width: "100%",
          left: "50%",
          transform: "translateX(-50%) translateY(-50%) scale(0.9)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "4.5rem"
        }
      },
      /* @__PURE__ */ K.createElement(
        "div",
        {
          className: "create-room-modal",
          style: {
            fontFamily: '"Russo One", sans-serif',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "center",
            margin: "1rem 0rem",
            background: "#fff",
            border: "2px solid #000000",
            boxShadow: "0px 12px 0px rgba(0, 0, 0, 0.25)",
            borderRadius: "20px",
            width: "100%",
            maxWidth: "360px",
            aspectRatio: "1/1",
            padding: "2.5rem 2rem 2.5rem 2rem"
          }
        },
        /* @__PURE__ */ K.createElement("span", { style: { fontSize: "40px" } }, "☠️"),
        /* @__PURE__ */ K.createElement("div", null, /* @__PURE__ */ K.createElement("h1", { style: { marginBottom: "1rem", marginTop: "0rem" } }, "Kick Player"), /* @__PURE__ */ K.createElement(
          "h3",
          {
            style: {
              fontWeight: "bold",
              fontSize: "1rem",
              lineHeight: "normal",
              margin: "0rem",
              marginBottom: "2rem",
              fontFamily: "'Open Sans', sans-serif"
            }
          },
          "Remove ",
          ((r = e.getState("profile")) == null ? void 0 : r.name) || "this player",
          " ",
          "from the party?"
        )),
        /* @__PURE__ */ K.createElement(
          "button",
          {
            id: "btn-invite",
            className: "close-btn",
            onClick: () => {
              e.kick(), t();
            }
          },
          "Kick"
        ),
        /* @__PURE__ */ K.createElement("button", { id: "btn-invite", className: "close-btn white", onClick: t }, "Cancel")
      )
    )
  );
}
function yS({
  baseUrl: t,
  avatarsOverride: e,
  lockedNameField: r,
  lockedPhotoField: n,
  matchmakingOptions: i,
  onTurnbasedLaunch: o
}) {
  var $, se, he, pe, me;
  const s = Me(), a = Mu(), l = i && a, c = Va(), u = (L) => {
    if (!l)
      return { data: null, error: null, isLoading: !1 };
    const q = Fm(), Z = s.connection.getHostname(!1) + "/api/game/" + q + "/matchmaking_total_players";
    return fetch(Z).then((oe) => oe.json());
  }, { data: f } = xw(
    "dummy",
    u,
    {
      refreshInterval: 1e4
    }
  ), d = (f == null ? void 0 : f.totalPlayers) || 0, [h, g] = ht(null), [p, y] = gi("__matchmakingqueue"), [b, x] = gi(
    "__matchmakingChosenRoom"
  ), [S, O] = ht(
    !!window.isRunningOnNative
  ), [_, B] = ht(!1), [N, j] = ht(ai), W = s.getMyPlayerState() ? s.getMyPlayerState().getState("profile") : {
    name: js[Math.floor(Math.random() * js.length)] + o0(10, 99),
    color: ai[Math.floor(Math.random() * ai.length)]
  }, [G, ee] = ht({
    color: (W == null ? void 0 : W.color) || fe()[0],
    name: xt.get("playerName") || (W == null ? void 0 : W.name) || js[Math.floor(Math.random() * js.length)] + o0(10, 99),
    photo: (W == null ? void 0 : W.photo) || (xt.get("playerPhoto") && xt.get("playerPhoto") !== "false" ? xt.get("playerPhoto") : s0(e))
  });
  r1((L, q, Z, oe) => {
    const de = fe();
    j(de);
  });
  function fe() {
    const L = s.getPlayers();
    if (!L)
      return ai;
    const q = Object.keys(L).filter((oe) => oe !== s.connection.myId).map((oe) => {
      var de;
      return (de = L[oe].state.profile) == null ? void 0 : de.color;
    });
    return ai.filter(
      (oe) => !q.includes(oe)
    );
  }
  function P(L) {
    var Z;
    xt.set("playerName", L.name), L.photo && xt.set("playerPhoto", L.photo), xt.set("playerColor", L.color), s.getMyPlayerState().setState("profile", L, !0), (Z = window._PLAYROOM_CONFIG) != null && Z.skipProfile && (L != null && L.photo) && s.setState("__launched", !0);
  }
  const [z, U] = ht(!1);
  _t(() => {
    function L(Z) {
      var oe;
      (oe = Z.data) != null && oe.isRunningOnNative && (window.isRunningOnNative = Z.data.isRunningOnNative, O(Z.data.isRunningOnNative), B(!0));
    }
    var q = { ...s == null ? void 0 : s.sdkOptions };
    return delete q.botOptions, window.parent.postMessage(
      {
        joinRoomURL: `${window.location.href}&streaming=true`,
        sdkOptions: q ?? {}
      },
      // "http://10.10.10.32:5175"
      "*"
    ), window.addEventListener("message", L, !1), () => window.removeEventListener("message", L);
  }, [s]);
  const I = S && (($ = s == null ? void 0 : s.sdkOptions) == null ? void 0 : $.streamMode);
  if (h)
    return /* @__PURE__ */ K.createElement(
      mS,
      {
        playerState: h,
        hide: () => g(null)
      }
    );
  const V = (c == null ? void 0 : c.length) || 0, te = a && ((se = s.sdkOptions) == null ? void 0 : se.enableBots) && (!((he = s.sdkOptions) != null && he.maxPlayersPerRoom) || V < ((pe = s.sdkOptions) == null ? void 0 : pe.maxPlayersPerRoom)), X = (me = s.sdkOptions) == null ? void 0 : me.turnBased, H = () => l ? /* @__PURE__ */ K.createElement(
    "span",
    {
      style: {
        opacity: d > 0 ? 1 : 0,
        color: "#00df59",
        marginTop: "1rem"
      }
    },
    /* @__PURE__ */ K.createElement(
      "span",
      {
        style: {
          backgroundColor: "#00df59",
          width: "0.5rem",
          height: "0.5rem",
          borderRadius: "50%",
          display: "inline-block",
          verticalAlign: "middle",
          marginBottom: "0.3rem",
          marginRight: "0.4rem"
        }
      }
    ),
    d,
    " ",
    d === 1 ? "player" : "players",
    " online"
  ) : null;
  return /* @__PURE__ */ K.createElement("div", { className: "main-menu" }, /* @__PURE__ */ K.createElement("div", { className: "platform" }, /* @__PURE__ */ K.createElement("div", { className: "profilecontainer" }, /* @__PURE__ */ K.createElement(
    "div",
    {
      style: { position: "relative", zIndex: 1, display: "inline-block" },
      onClick: () => {
        if (n)
          return;
        const L = s0(e);
        ee({ ...G, photo: L }), P({ ...G, photo: L });
      }
    },
    !n && /* @__PURE__ */ K.createElement("a", { className: "refresh-button" }, /* @__PURE__ */ K.createElement(_m, { style: { color: "white" } })),
    /* @__PURE__ */ K.createElement(
      "div",
      {
        className: "avatar-photo ",
        style: {
          backgroundImage: `url(${G && G.photo || _g})`,
          borderColor: G.color
          // boxShadow: `0 0 70px 50px ${profile.color}44`,
        }
      }
    )
  ), /* @__PURE__ */ K.createElement(
    "input",
    {
      type: "text",
      value: G.name,
      disabled: r,
      onChange: (L) => {
        ee({ ...G, name: L.target.value }), L.target.value && P({ ...G, name: L.target.value });
      },
      style: { borderColor: G.color },
      className: "input-name",
      maxLength: 10
    }
  ), /* @__PURE__ */ K.createElement("div", { className: "color-tray" }, ai.map((L) => {
    const q = N.includes(L);
    return /* @__PURE__ */ K.createElement(
      "span",
      {
        key: L,
        className: "color" + (L === G.color ? " active" : ""),
        style: {
          backgroundColor: L,
          opacity: q ? 1 : 0.5
        },
        onClick: q ? () => {
          ee({ ...G, color: L }), P({ ...G, color: L });
        } : () => {
        }
      }
    );
  })), !X && /* @__PURE__ */ K.createElement(K.Fragment, null, /* @__PURE__ */ K.createElement("div", { className: "party-hr" }, /* @__PURE__ */ K.createElement("span", null, "Party")), /* @__PURE__ */ K.createElement(
    Eg,
    {
      mobileMode: !0,
      showEmptySlots: 4,
      onPlayerKick: (L) => {
        g(L);
      }
    }
  )), /* @__PURE__ */ K.createElement("div", null, te && /* @__PURE__ */ K.createElement(
    "button",
    {
      id: "btn-addbot",
      className: "button-bot",
      onClick: () => {
        T5();
      }
    },
    "🤖 +"
  ))), p ? /* @__PURE__ */ K.createElement(K.Fragment, null, /* @__PURE__ */ K.createElement(H, null), /* @__PURE__ */ K.createElement(
    "button",
    {
      id: "btn-matchmaking",
      style: {
        cursor: "pointer",
        marginTop: "1rem",
        marginBottom: "6rem"
      },
      className: "button-black launch-btn btn-icon disabled",
      onClick: () => {
        a && y(!1);
      }
    },
    b ? "Joining..." : "Connecting...",
    a && /* @__PURE__ */ K.createElement(
      "small",
      {
        style: {
          float: "right",
          padding: "0 1rem",
          fontSize: "0.8rem",
          marginTop: "0.2rem"
        }
      },
      "Cancel"
    )
  )) : /* @__PURE__ */ K.createElement(K.Fragment, null, /* @__PURE__ */ K.createElement(H, null), l && /* @__PURE__ */ K.createElement(
    "button",
    {
      id: "btn-matchmaking",
      style: {
        backgroundImage: `url(${cS})`,
        marginTop: "1rem"
      },
      className: "button-black launch-btn btn-icon",
      onClick: async () => {
        y(!0);
      }
    },
    "Play Online"
  ), /* @__PURE__ */ K.createElement(
    "section",
    {
      style: {
        width: "100%",
        display: "flex",
        marginBottom: "1rem",
        gap: "1rem"
      }
    },
    I && /* @__PURE__ */ K.createElement(
      "button",
      {
        id: "btn-launchjoin",
        className: "button-black airplay-btn",
        onClick: () => B(!0)
      },
      /* @__PURE__ */ K.createElement(
        "img",
        {
          src: Sm,
          alt: "airplay-icon",
          className: "airplay-icon"
        }
      )
    ),
    /* @__PURE__ */ K.createElement(
      "section",
      {
        style: { width: "100rem", display: "flex", gap: "1rem" }
      },
      /* @__PURE__ */ K.createElement(
        "button",
        {
          id: "btn-launchjoin",
          style: l ? {
            marginTop: "1rem",
            backgroundImage: `url(${uS})`
          } : void 0,
          className: "button-black" + (a || X ? " launch-btn" : " disabled") + (l ? " btn-icon" : ""),
          onClick: () => {
            a && !X && s.setState("__launched", !0), X && o();
          }
        },
        a || X ? l ? "Start Private" : "Launch" : "Waiting for host to start"
      ),
      l && /* @__PURE__ */ K.createElement(
        "button",
        {
          id: "btn-invite",
          style: {
            marginTop: "1rem",
            padding: "0rem 3rem 0rem 2rem"
          },
          className: "button-black",
          onClick: () => {
            U(!0);
          }
        },
        "Invite"
      )
    )
  ), !l && (!X || a && X) && /* @__PURE__ */ K.createElement(
    "button",
    {
      id: "btn-invite",
      className: "button-black launch-btn",
      onClick: () => {
        U(!0);
      }
    },
    "Invite"
  )), /* @__PURE__ */ K.createElement("p", { className: "sdk-version" }, "Multiplayer by Playroom v.", Gu.version), /* @__PURE__ */ K.createElement(
    bS,
    {
      show: z,
      onClose: () => {
        U(!1);
      },
      baseUrl: t
    }
  ), /* @__PURE__ */ K.createElement(
    vS,
    {
      show: _,
      onClose: () => {
        B(!1);
      }
    }
  )));
}
function bS({ show: t, onClose: e, baseUrl: r }) {
  const n = Me(), i = (r || window.location.href.split("#")[0]) + "#r=", o = n.currentRoom, s = l3(i, o);
  return t ? /* @__PURE__ */ K.createElement(xg, null, /* @__PURE__ */ K.createElement(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 101
        // "-webkit-backdrop-filter": "blur(0.3rem)",
        // backdropFilter: "blur(0.3rem)",
      }
    },
    /* @__PURE__ */ K.createElement(
      Mi,
      {
        visible: !0,
        center: !0,
        style: {
          color: "#000",
          // width: "70rem",
          maxWidth: "500px",
          // height: "99rem",
          // maxHeight: "160vh",
          bottom: "0.7rem",
          position: "absolute",
          width: "100%",
          left: "50%",
          transform: "translateX(-50%) translateY(-10%) scale(0.9)",
          display: "flex",
          // height: "100%",
          // transform: "translate(-50%, -50%) scale(0.5)",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "4.5rem"
        }
      },
      /* @__PURE__ */ K.createElement(
        "div",
        {
          className: "create-room-modal",
          style: {
            fontFamily: '"Russo One", sans-serif',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // padding: "2rem",
            // gap: "2rem",
            textAlign: "center",
            margin: "1rem 0rem",
            background: "#fff",
            border: "2px solid #000000",
            boxShadow: "0px 12px 0px rgba(0, 0, 0, 0.25)",
            borderRadius: "20px",
            width: "95%",
            padding: "1rem"
          }
        },
        /* @__PURE__ */ K.createElement("h1", { style: { marginBottom: "0.1rem", marginTop: "0rem" } }, "Party maker"),
        /* @__PURE__ */ K.createElement(
          "h3",
          {
            style: {
              fontWeight: "bold",
              fontSize: "1rem",
              lineHeight: "normal",
              margin: "0rem",
              fontFamily: "'Open Sans', sans-serif"
            }
          },
          "Invite friends to play together"
        ),
        /* @__PURE__ */ K.createElement(
          "div",
          {
            style: {
              backgroundColor: "#ff3666",
              height: "4rem",
              width: "4rem",
              transform: "scale(0.7)",
              borderRadius: "50%",
              position: "absolute",
              top: "1.5rem",
              right: "1rem",
              padding: "1rem",
              cursor: "pointer",
              textAlign: "center",
              display: e ? "flex" : "none",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            },
            onClick: e
          },
          /* @__PURE__ */ K.createElement("img", { src: Sg })
        ),
        /* @__PURE__ */ K.createElement(
          lS,
          {
            noAbsolute: !0,
            baseUrl: i,
            size: 128,
            noText: !0,
            containerStyles: {
              // transform: "scale(2.5)",
            }
          }
        ),
        /* @__PURE__ */ K.createElement(P7, { text: s })
      )
    )
  )) : null;
}
function vS({ show: t, onClose: e }) {
  return t ? /* @__PURE__ */ K.createElement(xg, null, /* @__PURE__ */ K.createElement("div", { className: "airplay-instruction-modal" }, /* @__PURE__ */ K.createElement(
    Mi,
    {
      visible: !0,
      center: !0,
      style: {
        color: "#000",
        maxWidth: "500px",
        bottom: "0.7rem",
        position: "absolute",
        width: "100%",
        left: "50%",
        transform: "translateX(-50%) scale(0.9)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4.5rem"
      }
    },
    /* @__PURE__ */ K.createElement("div", { className: "airplay-instruction-container" }, /* @__PURE__ */ K.createElement(
      "div",
      {
        style: {
          display: e ? "flex" : "none"
        },
        onClick: e,
        className: "close-icon"
      },
      /* @__PURE__ */ K.createElement("img", { src: Sg, alt: "close-icon" })
    ), /* @__PURE__ */ K.createElement(
      "img",
      {
        src: Sm,
        alt: "airplay-icon",
        className: "airplay-icon"
      }
    ), /* @__PURE__ */ K.createElement("h1", { className: "airplay-instruction-title" }, "Airplay on TV"), /* @__PURE__ */ K.createElement("ol", null, /* @__PURE__ */ K.createElement("li", null, "Connect your iPhone, iPad, or iPod touch to the same Wi-Fi network as your Apple TV."), /* @__PURE__ */ K.createElement("li", null, "Swipe down from the upper-right corner of the screen to open Control Center on this phone."), /* @__PURE__ */ K.createElement("li", null, "Tap Screen Mirroring ", /* @__PURE__ */ K.createElement("span", { className: "icon-screenmirror" }), "."), /* @__PURE__ */ K.createElement("li", null, "Select your Apple TV or any AirPlay compatible device."), /* @__PURE__ */ K.createElement("li", null, "If an AirPlay passcode appears on your TV screen, enter the passcode on your iOS or iPadOS device."), /* @__PURE__ */ K.createElement("li", null, "Return to this app to continue.")))
  ))) : null;
}
const AS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAxNyAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC42NDIxODgiIHk9IjAuNjQyMTg4IiB3aWR0aD0iMTQuNzcwMyIgaGVpZ2h0PSIyNi4zMjk3IiByeD0iMS45MjY1NiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjI4NDM4Ii8+CjxyZWN0IHg9IjYuMTAwODMiIHk9IjIuMjQ3NjkiIHdpZHRoPSIzLjg1MzEzIiBoZWlnaHQ9IjEuMjg0MzgiIHJ4PSIwLjY0MjE4OCIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", wS = "data:image/svg+xml;base64,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";
function xS({
  zIndex: t,
  demoMode: e,
  noAbsolute: r,
  noText: n,
  size: i = 256,
  containerStyles: o = {},
  baseUrl: s = "https://joinplayroom.com/"
}) {
  const l = Me().currentRoom;
  return _t(() => {
  }, []), /* @__PURE__ */ K.createElement(
    "div",
    {
      className: "room-code-sticker",
      style: {
        zIndex: t || "initial",
        position: r ? "initial" : "absolute",
        ...o
      }
    },
    /* @__PURE__ */ K.createElement("div", { className: "qr-code" }, /* @__PURE__ */ K.createElement(
      Lm,
      {
        id: "QRCodeScaled",
        size: i,
        style: { height: "auto", maxWidth: "100%", width: "100%" },
        value: e ? "https://joinplayroom.com/demohost" : `${s}R${l || ""}`,
        viewBox: `0 0 ${i} ${i}`
      }
    )),
    !n && l && /* @__PURE__ */ K.createElement("div", { className: "room-code" }, /* @__PURE__ */ K.createElement("b", null, l), /* @__PURE__ */ K.createElement("span", null, "Scan QR code to join the room")),
    !n && !l && /* @__PURE__ */ K.createElement("div", { className: "room-code" }, /* @__PURE__ */ K.createElement("b", null, "Scan to start"), /* @__PURE__ */ K.createElement("span", null, "Download the game from the Appstore"))
  );
}
function a0() {
  const { innerWidth: t, innerHeight: e } = window;
  return {
    width: t,
    height: e
  };
}
function _S() {
  let t = document.querySelector('meta[name="viewport"]');
  t || (t = document.createElement("meta"), t.name = "viewport", t.content = "width=device-width, initial-scale=1.0", document.head.appendChild(t));
}
function jm() {
  const [t, e] = ht(
    a0()
  );
  return _t(() => {
    function r() {
      e(a0());
    }
    return _S(), window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, []), t;
}
class Wm {
  /**
   * Constructor
   */
  constructor(e) {
    this.start = Date.now(), this.current = this.start, this.elapsed = 0, this.delta = 16, this.onTick = e, this.tick = this.tick.bind(this), this.tick();
  }
  /**
   * Tick
   */
  tick() {
    this.ticker = window.requestAnimationFrame(this.tick);
    const e = Date.now();
    this.delta = e - this.current, this.elapsed = e - this.start, this.current = e, this.delta > 60 && (this.delta = 60), this.onTick(this.delta, this.elapsed);
  }
  /**
   * Stop
   */
  stop() {
    window.cancelAnimationFrame(this.ticker);
  }
}
const l0 = [
  "#59BF82",
  "#FFF27A",
  "#F14EEB",
  "#FF7F56",
  "#6BDCFF",
  "#3905F5",
  "#FF3666"
];
function SS(t) {
  var e = Math.PI / 2, r, n;
  t > -e && t < e ? r = "right" : r = "left", t > 0 ? n = "up" : n = "down";
  let i = {};
  return r && (i.x = r), n && (i.y = n), i;
}
function ES(t, e) {
  return t === 0 && e === 0 ? NaN : -Math.atan2(e, t);
}
function kS() {
  return new Promise((t, e) => {
    Me().connection.once("sync", () => {
      t();
    });
  });
}
async function CS() {
  const t = Me();
  await kS(), Object.values(t.getPlayers()).filter(
    (o) => o.getState("__proxyBy")
  ).forEach((o) => {
    t.connection.removeProxyPlayer(o.id);
  });
  let r = [];
  function n(o, s) {
    const a = r.find(
      (c) => c.joystick.id == o.id && c.joystick.index == o.index
    );
    if (a)
      return a.player;
    if (!s)
      return;
    const l = t.connection.addProxyPlayer();
    return l.setState("profile", {
      name: "Gamepad " + (r.length + 1),
      // TODO: check and use avatars override here if provided.
      photo: Ha(qa(l.id)),
      color: l0[r.length % l0.length]
    }), l.setState("__gamepad", !0), r.push({ player: l, joystick: o }), l.on("quit", () => {
      const c = r.findIndex((u) => u.player.id == l.id);
      r.splice(c, 1);
    }), l;
  }
  const i = new Wm(() => {
    var l;
    const o = (l = navigator.getGamepads()) == null ? void 0 : l.map((c, u) => [c, u]).filter(([c, u]) => c && c.connected), s = t.sdkOptions, a = (s == null ? void 0 : s.joystickConfig) || !1;
    o.forEach(([c]) => {
      let u = n(c);
      const f = c.buttons.slice(0, 4).map((p) => p.pressed);
      if (!u) {
        if (!f.some((b) => b))
          return;
        const y = Object.keys(t.getPlayers()).length;
        if (s.maxPlayersPerRoom && y >= s.maxPlayersPerRoom)
          return;
        u = n(c, !0);
      }
      f.forEach((p, y) => {
        var x, S;
        let b = `ctr-button${y + 1}`;
        a && a.buttons && (u.getState(b) && u.setState(b, void 0), b = (x = a.buttons[y]) != null && x.id ? `ctr-${(S = a.buttons[y]) == null ? void 0 : S.id}` : b), u.setState(b, p);
      });
      let d = c.axes;
      Math.abs(d[0]) < 0.1 && Math.abs(d[1]) < 0.1 && (d = [0, 0]);
      const h = ES(d[0], d[1]), g = Math.PI * 0.5;
      isNaN(h) ? (u.setState("ctr-joystick", !1), u.setState("ctr-angle", 0), u.setState("ctr-dpad", null)) : (u.setState("ctr-joystick", !0), u.setState("ctr-angle", h + g), u.setState("ctr-dpad", SS(h)));
    });
  });
  return () => {
    i.stop();
  };
}
function TS(t, e) {
  return Math.floor(Math.random() * (e - t + 1)) + t;
}
function OS(t) {
  let e = "";
  const r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length;
  for (let i = 0; i < t; ++i)
    e += r.charAt(Math.floor(Math.random() * n));
  return e;
}
const c0 = [
  "#59BF82",
  "#FFF27A",
  "#F14EEB",
  "#FF7F56",
  "#6BDCFF",
  "#3905F5",
  "#FF3666"
], u0 = [
  "Eclipse",
  "Crankshaft",
  "Firetruck",
  "President",
  "Bat",
  "Avocado",
  "Holiday",
  "Salad",
  "Boom",
  "Cornflakes",
  "Pancake",
  "Penguin",
  "Pirate",
  "Pumpkin",
  "Rainbow",
  "Squirrel"
];
function IS(t) {
  return t && t.length > 0 ? t[Math.floor(Math.random() * t.length)] : Ha(qa(OS(10)));
}
function PS(t) {
  const e = {
    color: c0[Math.floor(Math.random() * c0.length)],
    name: xt.get("playerName") || u0[Math.floor(Math.random() * u0.length)] + TS(10, 99),
    photo: xt.get("playerPhoto") && xt.get("playerPhoto") !== "false" ? xt.get("playerPhoto") : IS(t)
  };
  return xt.set("playerName", e.name), xt.set("playerPhoto", e.photo), e;
}
function RS({ options: t = {}, onStart: e, onReject: r }) {
  const { height: n } = jm(), i = Mu(), [o, s] = ht(!1), [a, l] = ht(!1), [c, u] = ht(!1), [f, d] = gi("__matchmakingqueue"), [h, g] = gi(
    "__matchmakingChosenRoom"
  ), p = Xc.getUrlHashParameter("streaming"), y = Rn("player_name") ? decodeURIComponent(Rn("player_name")) : void 0, b = Rn("player_photo") ? decodeURIComponent(Rn("player_photo")) : void 0, x = Xc.getUrlHashParameter("skipLobby");
  let S = {
    ...t
  };
  const O = PS(S.avatars);
  S.profile = S.profile || {
    name: O.name,
    photo: O.photo
  }, y && (S.profile = {
    ...S.profile,
    name: y
  }), b && (S.profile = {
    ...S.profile,
    photo: b
  });
  const _ = Me(S), B = t.streamMode || !1, N = p || B && !U5(), [j] = gi("__launched"), [W, G] = ht(!1), ee = t.skipLobby || x;
  _t(() => {
    o && (t.skipLobby || x) && !t.matchmaking && _.setState("__launched", !0);
  }, [o]), _t(() => {
    (j || W) && e();
  }, [j, W]), _t(() => {
    var V, te;
    const U = document.createElement("style");
    U.innerHTML = [ag, lg, cg].join(`
`), document.head.appendChild(U);
    let I = Rn("r") ? Rn("r").slice(1) : t.roomCode;
    I ? N ? _.spectateRoom(I, !1, !0, !0) : _.joinRoom(I, !0, !0) : N ? _.spectateRoom(void 0, !0, !0) : _.createRoom(void 0, !0, !0), _.once("connection_initiated", () => {
      _.connection.once("connected", () => {
        Kc("r", "R" + _.currentRoom), s(!0), pi.track("SDK: Connected", { gameId: t.gameId }), t.matchmaking && ee && d(!0);
      }), _.connection.once("disconnected", (X) => {
        Nn.roomLimitExceed.code === X.eventCode ? fe() : Nn.playerKicked.code === X.eventCode ? P() : X.reason === "MANUAL_DISCONNECT" ? s(!1) : window.location.reload();
      });
    }), pi.track("SDK: Insert Coin", {
      ...t,
      isStreamScreen: N
    }), (V = Me().sdkOptions) != null && V.allowGamepads && N && CS(), (te = Me().sdkOptions) != null && te.enableBots && E5();
  }, []), _t(() => {
    (async () => {
      var H;
      if (!f || !i)
        return;
      const I = Math.max(
        1,
        parseInt(
          (((H = t.matchmaking) == null ? void 0 : H.waitBeforeCreatingNewRoom) || 5e3) / 1e3
        )
      ), V = Fm(), te = Object.keys(_.getPlayers()).length, X = _.connection.getHostname(!1) + "/api/game/" + V + "/matchmaking_find?forPlayers=" + te;
      pi.track("SDK: Matchmaking", { gameId: t.gameId });
      for (let $ = 0; $ < I; $++) {
        if (await Ll(1e3), !_.getState("__matchmakingqueue"))
          return;
        const se = await fetch(X, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        });
        if (se.ok) {
          const he = await se.json(), pe = $ === I - 1;
          he.room && (he.new && pe || !he.new) && g(he.room);
        }
      }
    })();
  }, [f, i]), _t(() => {
    (async () => {
      if (h) {
        await Ll(1e3);
        const I = JSON.parse(
          JSON.stringify(_.getMyPlayerState().getState())
        );
        _.leaveRoom(), Kc("r", void 0), await Ll(100), _.joinRoom(h, !0, !0), _.once("connected", () => {
          Object.keys(I || {}).forEach((V) => {
            _.getMyPlayerState().setState(V, I[V]);
          }), _.setState("__launched", !0), _.emit("matchmaking_room_joined");
        });
      }
    })();
  }, [h]);
  const fe = () => {
    !(S != null && S.skipLobby) && !x && l(!0), r({ message: Nn.roomLimitExceed.reason });
  }, P = () => {
    !(S != null && S.skipLobby) && !x && u(!0), r({ message: Nn.playerKicked.reason });
  }, z = () => {
    l(!1);
  };
  return a ? /* @__PURE__ */ K.createElement(NS, { hide: z }) : c ? /* @__PURE__ */ K.createElement(BS, { hide: () => u(!1) }) : !o || j || ee || W ? null : /* @__PURE__ */ K.createElement("div", { className: "bootstrap-wrapper" }, /* @__PURE__ */ K.createElement("div", { className: "playroom" }, /* @__PURE__ */ K.createElement("div", { className: "modal-container fullscreen " }, /* @__PURE__ */ K.createElement("div", { "data-pop": "slide-up", id: "popup", className: "show" }, /* @__PURE__ */ K.createElement("div", { className: "popupcontrols" }), /* @__PURE__ */ K.createElement(
    "div",
    {
      className: "popupcontent",
      style: { transform: `scale(${Math.min(1, n / 880)})` }
    },
    !N && o && /* @__PURE__ */ K.createElement(
      yS,
      {
        baseUrl: t.baseUrl,
        avatarsOverride: t.avatars,
        lockedNameField: !!y,
        lockedPhotoField: !!b,
        matchmakingOptions: t.matchmaking,
        onTurnbasedLaunch: () => G(!0)
      }
    ),
    N && /* @__PURE__ */ K.createElement(DS, { baseUrl: t.baseUrl, show: !0 })
  )), /* @__PURE__ */ K.createElement("div", { id: "overlay", className: "show" }))));
}
function DS({ show: t, baseUrl: e }) {
  var u, f, d;
  const r = Me(), n = (e || window.location.href.split("#")[0]) + "#r=", i = (u = r.sdkOptions) == null ? void 0 : u.allowGamepads, o = Va(!0), [s] = gi("__gamepadPressedTime"), a = o.every((h) => h.getState("__gamepad")) && o.length > 0, l = (o == null ? void 0 : o.length) || 0, c = !((f = r.sdkOptions) != null && f.maxPlayersPerRoom) || l < ((d = r.sdkOptions) == null ? void 0 : d.maxPlayersPerRoom);
  return _t(() => {
    let h = {};
    if (a) {
      let g = function() {
        const y = Object.values(r.getPlayers()).map(
          (S) => new Pc(S)
        );
        let b = {};
        y.forEach((S) => {
          S.isAnyButtonPressed() ? (h[S.playerState.id] || (h[S.playerState.id] = (/* @__PURE__ */ new Date()).getTime()), b[S.playerState.id] = (/* @__PURE__ */ new Date()).getTime() - h[S.playerState.id], b[S.playerState.id] > 2e3 && r.setState("__launched", !0)) : (h[S.playerState.id] = void 0, b[S.playerState.id] = void 0);
        });
        let x = 0;
        Object.values(b).forEach((S) => {
          S > x && (x = S);
        }), r.setState("__gamepadPressedTime", x);
      };
      const p = new Wm(g);
      return () => {
        p.stop(), r.setState("__gamepadPressedTime", void 0);
      };
    }
  }, [a]), t ? /* @__PURE__ */ K.createElement(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 101
        // "-webkit-backdrop-filter": "blur(0.3rem)",
        // backdropFilter: "blur(0.3rem)",
      }
    },
    /* @__PURE__ */ K.createElement(
      Mi,
      {
        visible: !0,
        center: !0,
        style: {
          color: "#000",
          // width: "70rem",
          maxWidth: "500px",
          // height: "99rem",
          // maxHeight: "160vh",
          top: "50%",
          position: "absolute",
          width: "100%",
          left: "50%",
          transform: "translateX(-50%) translateY(-50%) scale(0.9)",
          display: "flex",
          // height: "100%",
          // transform: "translate(-50%, -50%) scale(0.5)",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "4.5rem"
        }
      },
      /* @__PURE__ */ K.createElement(
        "div",
        {
          className: "create-room-modal",
          style: {
            fontFamily: '"Russo One", sans-serif',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // padding: "2rem",
            // gap: "2rem",
            textAlign: "center",
            margin: "1rem 0rem",
            background: "#fff",
            border: "2px solid #000000",
            boxShadow: "0px 12px 0px rgba(0, 0, 0, 0.25)",
            borderRadius: "20px",
            width: "95%",
            padding: "1rem"
          }
        },
        /* @__PURE__ */ K.createElement("h1", { style: { marginBottom: "0.1rem", marginTop: "0rem" } }, "Party maker"),
        /* @__PURE__ */ K.createElement(
          "h3",
          {
            style: {
              fontWeight: "bold",
              fontSize: "1rem",
              lineHeight: "normal",
              margin: "0rem",
              fontFamily: "'Open Sans', sans-serif"
            }
          },
          "Invite friends to play together"
        ),
        /* @__PURE__ */ K.createElement(
          xS,
          {
            noAbsolute: !0,
            baseUrl: n,
            size: 128,
            noText: !0,
            containerStyles: {
              // transform: "scale(2.5)",
            }
          }
        ),
        i ? /* @__PURE__ */ K.createElement("div", { style: { marginBottom: "2rem" } }, /* @__PURE__ */ K.createElement(f0, { expanded: !0 }), /* @__PURE__ */ K.createElement("hr", null), /* @__PURE__ */ K.createElement(
          MS,
          {
            allGamepads: a,
            holdProgress: s,
            playerLimitHasReached: !c
          }
        )) : /* @__PURE__ */ K.createElement(f0, null),
        /* @__PURE__ */ K.createElement(Eg, { showEmptySlots: 4 })
      )
    )
  ) : null;
}
function MS({ allGamepads: t, holdProgress: e, playerLimitHasReached: r }) {
  return /* @__PURE__ */ K.createElement(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "row",
        padding: "1rem 2rem",
        transform: "scale(0.8)",
        marginTop: "2rem",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ K.createElement(
      "img",
      {
        src: wS,
        style: {
          objectFit: "contain",
          height: "105%",
          width: "3rem",
          marginRight: "1rem",
          animation: "1s wiggle 3s ease-in-out infinite"
        }
      }
    ),
    /* @__PURE__ */ K.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          lineHeight: "normal",
          textAlign: "left",
          justifyContent: "center"
        }
      },
      /* @__PURE__ */ K.createElement(
        "h2",
        {
          style: {
            padding: "0",
            margin: "0",
            lineHeight: "normal"
          }
        },
        r ? "Room is full" : "Press button on game pad",
        t && /* @__PURE__ */ K.createElement(K.Fragment, null, /* @__PURE__ */ K.createElement("br", null), /* @__PURE__ */ K.createElement(
          "div",
          {
            style: {
              backgroundImage: "linear-gradient(to right, rgb(141 107 237), rgb(141 107 237))",
              backgroundRepeat: "no-repeat",
              backgroundPositionY: "bottom",
              paddingBottom: "0.5rem",
              backgroundSize: `${e ? e / 2e3 * 100 : 0}% 20%`
            }
          },
          "Press & hold to launch"
        ))
      )
    )
  );
}
function f0({ expanded: t }) {
  return /* @__PURE__ */ K.createElement(
    "div",
    {
      style: {
        // background: "#000000",
        // color: "#ffffff",
        transform: "scale(0.8)",
        display: "flex",
        flexDirection: "row",
        borderRadius: "1rem",
        padding: "1rem 2rem",
        marginTop: "-3rem",
        marginBottom: "2rem"
      }
    },
    /* @__PURE__ */ K.createElement(
      "img",
      {
        src: AS,
        style: {
          objectFit: "contain",
          height: "105%",
          width: "2rem",
          marginRight: t ? "2rem" : "1rem",
          animation: "1s wiggle 3s ease-in-out infinite"
        }
      }
    ),
    /* @__PURE__ */ K.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          lineHeight: "normal",
          textAlign: "left",
          justifyContent: "center"
        }
      },
      /* @__PURE__ */ K.createElement(
        "h2",
        {
          style: {
            padding: "0",
            margin: "0",
            lineHeight: "normal"
          }
        },
        "Scan the code ",
        t ? " from phone" : ""
      )
    )
  );
}
function NS({ hide: t }) {
  return /* @__PURE__ */ K.createElement(
    "div",
    {
      "data-testid": "full-room-popup",
      id: "full-room-popup",
      className: "full-room-container"
    },
    /* @__PURE__ */ K.createElement(
      Mi,
      {
        visible: !0,
        center: !0,
        style: {
          color: "#000",
          maxWidth: "500px",
          top: "50%",
          position: "absolute",
          width: "100%",
          left: "50%",
          transform: "translateX(-50%) translateY(-50%) scale(0.9)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "4.5rem"
        }
      },
      /* @__PURE__ */ K.createElement(
        "div",
        {
          className: "create-room-modal",
          style: {
            fontFamily: '"Russo One", sans-serif',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "center",
            margin: "1rem 0rem",
            background: "#fff",
            border: "2px solid #000000",
            boxShadow: "0px 12px 0px rgba(0, 0, 0, 0.25)",
            borderRadius: "20px",
            width: "100%",
            maxWidth: "360px",
            aspectRatio: "1/1",
            padding: "2.5rem 2rem 2.5rem 2rem"
          }
        },
        /* @__PURE__ */ K.createElement("span", { style: { fontSize: "40px" } }, "🔒"),
        /* @__PURE__ */ K.createElement("div", null, /* @__PURE__ */ K.createElement("h1", { style: { marginBottom: "0.1rem", marginTop: "0rem" } }, "Room is full"), /* @__PURE__ */ K.createElement(
          "h3",
          {
            style: {
              fontWeight: "bold",
              fontSize: "1rem",
              lineHeight: "normal",
              margin: "0rem",
              fontFamily: "'Open Sans', sans-serif"
            }
          },
          "Looks like the game is in progress"
        )),
        /* @__PURE__ */ K.createElement("button", { id: "btn-invite", className: "close-btn", onClick: t }, "Close")
      )
    )
  );
}
function BS({ hide: t }) {
  return /* @__PURE__ */ K.createElement(
    "div",
    {
      "data-testid": "full-room-popup",
      id: "full-room-popup",
      className: "full-room-container"
    },
    /* @__PURE__ */ K.createElement(
      Mi,
      {
        visible: !0,
        center: !0,
        style: {
          color: "#000",
          maxWidth: "500px",
          top: "50%",
          position: "absolute",
          width: "100%",
          left: "50%",
          transform: "translateX(-50%) translateY(-50%) scale(0.9)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "4.5rem"
        }
      },
      /* @__PURE__ */ K.createElement(
        "div",
        {
          className: "create-room-modal",
          style: {
            fontFamily: '"Russo One", sans-serif',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "center",
            margin: "1rem 0rem",
            background: "#fff",
            border: "2px solid #000000",
            boxShadow: "0px 12px 0px rgba(0, 0, 0, 0.25)",
            borderRadius: "20px",
            width: "100%",
            maxWidth: "360px",
            aspectRatio: "1/1",
            padding: "2.5rem 2rem 2.5rem 2rem"
          }
        },
        /* @__PURE__ */ K.createElement("span", { style: { fontSize: "40px" } }, "☠️"),
        /* @__PURE__ */ K.createElement("div", null, /* @__PURE__ */ K.createElement("h1", { style: { marginBottom: "0.1rem", marginTop: "0rem" } }, "Disconnected"), /* @__PURE__ */ K.createElement(
          "h3",
          {
            style: {
              fontWeight: "bold",
              fontSize: "1rem",
              lineHeight: "normal",
              margin: "0rem",
              fontFamily: "'Open Sans', sans-serif"
            }
          },
          "You were removed from the party"
        )),
        /* @__PURE__ */ K.createElement("button", { id: "btn-invite", className: "close-btn", onClick: t }, "Close")
      )
    )
  );
}
function d0(t = {}, e, r) {
  if (window.__playroomjs_mounted)
    return;
  var n = document.createElement("div");
  document.body.appendChild(n), window.__playroomjs_mounted = !0;
  const i = (o) => {
    delete window.__playroomjs_mounted, delete window._multiplayer, r(o);
  };
  LS(
    /* @__PURE__ */ K.createElement(RS, { options: t, onStart: e, onReject: i }),
    n
  );
}
function LS(t, e) {
  Wt.createRoot ? Wt.createRoot(e).render(t) : Wt.render(t, e);
}
const FS = "data:image/png;base64,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";
function jS(t, e, r) {
  let n = !1;
  return new Promise((i, o) => {
    let s;
    const l = `wss://live-api.joinplayroom.com/?service=tiktok&username=${t}`;
    s = new WebSocket(l), s.onmessage = function(c) {
      if (n)
        e(c.data ? JSON.parse(c.data) : null);
      else
        try {
          JSON.parse(c.data).type === "streamStart" && (n = !0, i(s));
        } catch {
        }
    }, s.onopen = function(c) {
    }, s.onerror = function(c) {
      o();
    }, s.onclose = function(c) {
      n ? r() : o();
    };
  });
}
function WS({ options: t = {}, onStart: e }) {
  const { width: r, height: n } = jm(), [i, o] = ht(!1), s = Me();
  return _t(() => {
    const a = document.createElement("style");
    a.innerHTML = [ag, lg, cg].join(`
`), document.head.appendChild(a), s.createRoom(null, !0, !0);
  }, []), i ? null : /* @__PURE__ */ K.createElement("div", { className: "bootstrap-wrapper" }, /* @__PURE__ */ K.createElement("div", { className: "playroom" }, /* @__PURE__ */ K.createElement("div", { className: "modal-container fullscreen " }, /* @__PURE__ */ K.createElement("div", { "data-pop": "slide-up", id: "popup", className: "show" }, /* @__PURE__ */ K.createElement("div", { className: "popupcontrols" }), /* @__PURE__ */ K.createElement(
    "div",
    {
      className: "popupcontent",
      style: { transform: `scale(${Math.min(1, n / 844)})` }
    },
    /* @__PURE__ */ K.createElement(
      US,
      {
        options: t,
        onStart: () => {
          o(!0), s.setState("__launched", !0), e();
        },
        onMessage: (a) => {
          s.emit("live:tiktok:msg", a);
        }
      }
    )
  )), /* @__PURE__ */ K.createElement("div", { id: "overlay", className: "show" }))));
}
function US({ options: t = {}, onStart: e, onMessage: r }) {
  const [n, i] = ht(!1), [o, s] = ht(""), [a, l] = ht(null), [c, u] = ht(null);
  async function f() {
    try {
      const d = await jS(
        o,
        (h) => {
          r(h);
        },
        () => {
          i(!1);
        }
      );
      u(d), e(d);
    } catch (d) {
      console.log(d), l(setTimeout(f, 5e3));
    }
  }
  return /* @__PURE__ */ K.createElement("div", { className: "main-menu" }, /* @__PURE__ */ K.createElement("div", { className: "platform" }, /* @__PURE__ */ K.createElement("div", { className: "profilecontainer" }, /* @__PURE__ */ K.createElement("div", { className: "steps-container" }, /* @__PURE__ */ K.createElement("div", { className: "step-item active" }), /* @__PURE__ */ K.createElement("div", { className: "step-item " + (n ? " loading" : "") }, /* @__PURE__ */ K.createElement("span", null))), !n && /* @__PURE__ */ K.createElement(K.Fragment, null, /* @__PURE__ */ K.createElement(
    "div",
    {
      style: {
        textAlign: "left",
        color: "#fff",
        padding: "1rem 0rem"
      }
    },
    /* @__PURE__ */ K.createElement("b", { className: "title" }, "Connect to TikTok"),
    /* @__PURE__ */ K.createElement("p", { className: "subtitle" }, "Enter your TikTok username which you will live stream from.")
  ), /* @__PURE__ */ K.createElement(
    "div",
    {
      style: {
        position: "relative",
        zIndex: 1,
        display: "inline-block"
      }
    },
    /* @__PURE__ */ K.createElement(
      "div",
      {
        className: "avatar-photo ",
        style: {
          border: "none",
          // tiktok style double shadow
          boxShadow: "2px 2px 0px 0px rgba(254,40,84,1), -2px -2px 0px -0px rgba(36,246,250,1)",
          backgroundImage: `url(${FS})`
        }
      }
    )
  ), /* @__PURE__ */ K.createElement(
    "input",
    {
      type: "text",
      placeholder: "username",
      value: o,
      onChange: (d) => {
        s(d.target.value);
      },
      autoCapitalize: "none",
      autoCorrect: "off",
      className: "input-name"
    }
  )), n && /* @__PURE__ */ K.createElement(K.Fragment, null, /* @__PURE__ */ K.createElement(
    "div",
    {
      style: {
        textAlign: "left",
        color: "#fff",
        padding: "1rem 0rem"
      }
    },
    /* @__PURE__ */ K.createElement("b", { className: "title" }, "Waiting for stream..."),
    /* @__PURE__ */ K.createElement("p", { className: "subtitle" }, "Open TikTok and go live from ", /* @__PURE__ */ K.createElement("b", null, "@", o), ' in "Mobile gaming" mode.')
  ))), /* @__PURE__ */ K.createElement(
    "section",
    {
      style: { width: "100%", display: "flex", marginBottom: "1rem" }
    },
    /* @__PURE__ */ K.createElement(
      "button",
      {
        id: "btn-launchjoin",
        className: "button-black launch-btn",
        disabled: !o,
        onClick: async () => {
          if (n) {
            i(!1), a && clearTimeout(a), l(null), c && c.close();
            return;
          }
          i(!0), f();
        }
      },
      n ? "Cancel" : "Launch"
    )
  ), /* @__PURE__ */ K.createElement("p", { className: "sdk-version" }, "Multiplayer by Playroom v.", Gu.version)));
}
function zS(t = {}, e) {
  if (!window.__playroomjs_mounted) {
    var r = document.createElement("div");
    document.body.appendChild(r), window.__playroomjs_mounted = !0, VS(/* @__PURE__ */ K.createElement(WS, { options: t, onStart: e }), r);
  }
}
function VS(t, e) {
  Wt.createRoot ? Wt.createRoot(e).render(t) : Wt.render(t, e);
}
typeof window < "u" && (window._PLAYROOM_CONFIG = {
  ...window._PLAYROOM_CONFIG || {},
  sessionStorage: !0,
  sdkMode: !0,
  sdkVersion: Gu.version
}, pi.track("SDK: Loaded", {
  cdn: !!window.Playroom
}));
function AE(t = {
  streamMode: !1,
  baseUrl: "",
  allowGamepads: !1,
  enableBots: !1,
  botOptions: {},
  avatars: [],
  roomCode: void 0,
  skipLobby: !1,
  liveMode: void 0,
  maxPlayersPerRoom: void 0,
  defaultStates: {},
  defaultPlayerStates: {},
  matchmaking: void 0,
  gameId: "",
  persistentMode: void 0,
  turnBased: void 0,
  discord: void 0
}, e = void 0, r = void 0) {
  if (typeof t != "object")
    throw new Error("options must be an object");
  if (!t.streamMode && t.allowGamepads)
    throw new Error("allowGamepads only works in stream mode");
  return t.matchmaking && (typeof t.matchmaking != "object" ? t.matchmaking = { waitBeforeCreatingNewRoom: 5e3 } : t.matchmaking = {
    waitBeforeCreatingNewRoom: 5e3,
    ...t.matchmaking
  }), t.turnBased && (t.persistentMode = !0), t.turnBased && t.turnBased.challengeId && (t.roomCode = t.turnBased.challengeId), new Promise((n, i) => {
    const o = () => {
      e && e(), n();
    }, s = (a) => {
      r && r(a), i(a);
    };
    t.liveMode ? zS(t, o) : t.discord ? $b(
      t,
      (a) => {
        d0(a, o, s);
      },
      s
    ) : d0(t, o, s);
  });
}
export {
  pi as Analytics,
  og as Bot,
  _5 as DQNBaseBot,
  gE as DQNBotJoystick,
  Pc as Joystick,
  Me as Multiplayer,
  fE as RPC,
  T5 as addBot,
  bE as clearTurns,
  yE as getAllTurns,
  cE as getChallengeId,
  GS as getDiscordAccessToken,
  t3 as getDiscordClient,
  r3 as getDiscordSDK,
  s1 as getDiscordServerData,
  vE as getMyTurnData,
  s1 as getPersistentData,
  cE as getRoomCode,
  oE as getState,
  aE as handlePlayerKeyDown,
  lE as handlePlayerKeyRelease,
  AE as insertCoin,
  h3 as insertDiscordServerData,
  h3 as insertPersistentData,
  sE as isHost,
  a3 as isStreamScreen,
  To as me,
  To as myPlayer,
  uE as onDisconnect,
  rE as onPlayerJoin,
  nE as onTikTokLiveEvent,
  QS as openDiscordInviteDialog,
  tE as resetPlayersStates,
  eE as resetStates,
  mE as saveMyTurnData,
  d3 as setDiscordServerData,
  d3 as setPersistentData,
  iE as setState,
  dE as startMatchmaking,
  Mu as useIsHost,
  gi as useMultiplayerState,
  $S as usePlayerState,
  Va as usePlayersList,
  ZS as usePlayersState,
  JS as waitForPlayerState,
  XS as waitForState
};
